webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var olyCommonModuleName = 'oly.common';

angular.module(olyCommonModuleName, []);

// ------------------------------------------
// Components
// ------------------------------------------
__webpack_require__(571);
__webpack_require__(573);
__webpack_require__(576);
__webpack_require__(580);
__webpack_require__(582);
__webpack_require__(585);
__webpack_require__(587);
__webpack_require__(589);
__webpack_require__(592);
__webpack_require__(595);
__webpack_require__(598);
__webpack_require__(600);
__webpack_require__(609);
__webpack_require__(611);
__webpack_require__(613);
__webpack_require__(615);
__webpack_require__(619);
__webpack_require__(621);
__webpack_require__(626);
__webpack_require__(628);
__webpack_require__(631);
__webpack_require__(633);
__webpack_require__(637);
__webpack_require__(641);
__webpack_require__(643);
__webpack_require__(645);
__webpack_require__(647);
__webpack_require__(649);
__webpack_require__(652);
__webpack_require__(654);
__webpack_require__(656);
__webpack_require__(658);
__webpack_require__(660);
__webpack_require__(662);
__webpack_require__(664);
__webpack_require__(666);
__webpack_require__(669);
__webpack_require__(671);
__webpack_require__(672);
__webpack_require__(675);
__webpack_require__(677);

module.exports = olyCommonModuleName;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

/**
 * Restful Resources service for AngularJS apps
 * @version v1.5.2 - 2016-02-08 * @link https://github.com/mgonto/restangular
 * @author Martin Gontovnikas <martin@gon.to>
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */!function(){var a=angular.module("restangular",[]);a.provider("Restangular",function(){var a={};a.init=function(a,b){function c(a,b,c,d){var e={};return _.each(_.keys(d),function(f){var g=d[f];g.params=_.extend({},g.params,a.defaultRequestParams[g.method.toLowerCase()]),_.isEmpty(g.params)&&delete g.params,a.isSafe(g.method)?e[f]=function(){return b(_.extend(g,{url:c}))}:e[f]=function(a){return b(_.extend(g,{url:c,data:a}))}}),e}a.configuration=b;var d=["get","head","options","trace","getlist"];b.isSafe=function(a){return _.includes(d,a.toLowerCase())};var e=/^https?:\/\//i;b.isAbsoluteUrl=function(a){return _.isUndefined(b.absoluteUrl)||_.isNull(b.absoluteUrl)?a&&e.test(a):b.absoluteUrl},b.absoluteUrl=_.isUndefined(b.absoluteUrl)?!0:b.absoluteUrl,a.setSelfLinkAbsoluteUrl=function(a){b.absoluteUrl=a},b.baseUrl=_.isUndefined(b.baseUrl)?"":b.baseUrl,a.setBaseUrl=function(a){return b.baseUrl=/\/$/.test(a)?a.substring(0,a.length-1):a,this},b.extraFields=b.extraFields||[],a.setExtraFields=function(a){return b.extraFields=a,this},b.defaultHttpFields=b.defaultHttpFields||{},a.setDefaultHttpFields=function(a){return b.defaultHttpFields=a,this},b.withHttpValues=function(a,c){return _.defaults(c,a,b.defaultHttpFields)},b.encodeIds=_.isUndefined(b.encodeIds)?!0:b.encodeIds,a.setEncodeIds=function(a){b.encodeIds=a},b.defaultRequestParams=b.defaultRequestParams||{get:{},post:{},put:{},remove:{},common:{}},a.setDefaultRequestParams=function(a,c){var d=[],e=c||a;return _.isUndefined(c)?d.push("common"):_.isArray(a)?d=a:d.push(a),_.each(d,function(a){b.defaultRequestParams[a]=e}),this},a.requestParams=b.defaultRequestParams,b.defaultHeaders=b.defaultHeaders||{},a.setDefaultHeaders=function(c){return b.defaultHeaders=c,a.defaultHeaders=b.defaultHeaders,this},a.defaultHeaders=b.defaultHeaders,b.methodOverriders=b.methodOverriders||[],a.setMethodOverriders=function(a){var c=_.extend([],a);return b.isOverridenMethod("delete",c)&&c.push("remove"),b.methodOverriders=c,this},b.jsonp=_.isUndefined(b.jsonp)?!1:b.jsonp,a.setJsonp=function(a){b.jsonp=a},b.isOverridenMethod=function(a,c){var d=c||b.methodOverriders;return!_.isUndefined(_.find(d,function(b){return b.toLowerCase()===a.toLowerCase()}))},b.urlCreator=b.urlCreator||"path",a.setUrlCreator=function(a){if(!_.has(b.urlCreatorFactory,a))throw new Error("URL Path selected isn't valid");return b.urlCreator=a,this},b.restangularFields=b.restangularFields||{id:"id",route:"route",parentResource:"parentResource",restangularCollection:"restangularCollection",cannonicalId:"__cannonicalId",etag:"restangularEtag",selfLink:"href",get:"get",getList:"getList",put:"put",post:"post",remove:"remove",head:"head",trace:"trace",options:"options",patch:"patch",getRestangularUrl:"getRestangularUrl",getRequestedUrl:"getRequestedUrl",putElement:"putElement",addRestangularMethod:"addRestangularMethod",getParentList:"getParentList",clone:"clone",ids:"ids",httpConfig:"_$httpConfig",reqParams:"reqParams",one:"one",all:"all",several:"several",oneUrl:"oneUrl",allUrl:"allUrl",customPUT:"customPUT",customPOST:"customPOST",customDELETE:"customDELETE",customGET:"customGET",customGETLIST:"customGETLIST",customOperation:"customOperation",doPUT:"doPUT",doPOST:"doPOST",doDELETE:"doDELETE",doGET:"doGET",doGETLIST:"doGETLIST",fromServer:"fromServer",withConfig:"withConfig",withHttpConfig:"withHttpConfig",singleOne:"singleOne",plain:"plain",save:"save",restangularized:"restangularized"},a.setRestangularFields=function(a){return b.restangularFields=_.extend(b.restangularFields,a),this},b.isRestangularized=function(a){return!!a[b.restangularFields.restangularized]},b.setFieldToElem=function(a,b,c){var d=a.split("."),e=b;return _.each(_.initial(d),function(a){e[a]={},e=e[a]}),e[_.last(d)]=c,this},b.getFieldFromElem=function(a,b){var c=a.split("."),d=b;return _.each(c,function(a){d&&(d=d[a])}),angular.copy(d)},b.setIdToElem=function(a,c){return b.setFieldToElem(b.restangularFields.id,a,c),this},b.getIdFromElem=function(a){return b.getFieldFromElem(b.restangularFields.id,a)},b.isValidId=function(a){return""!==a&&!_.isUndefined(a)&&!_.isNull(a)},b.setUrlToElem=function(a,c){return b.setFieldToElem(b.restangularFields.selfLink,a,c),this},b.getUrlFromElem=function(a){return b.getFieldFromElem(b.restangularFields.selfLink,a)},b.useCannonicalId=_.isUndefined(b.useCannonicalId)?!1:b.useCannonicalId,a.setUseCannonicalId=function(a){return b.useCannonicalId=a,this},b.getCannonicalIdFromElem=function(a){var c=a[b.restangularFields.cannonicalId],d=b.isValidId(c)?c:b.getIdFromElem(a);return d},b.responseInterceptors=b.responseInterceptors||[],b.defaultResponseInterceptor=function(a){return a},b.responseExtractor=function(a,c,d,e,f,g){var h=angular.copy(b.responseInterceptors);h.push(b.defaultResponseInterceptor);var i=a;return _.each(h,function(a){i=a(i,c,d,e,f,g)}),i},a.addResponseInterceptor=function(a){return b.responseInterceptors.push(a),this},b.errorInterceptors=b.errorInterceptors||[],a.addErrorInterceptor=function(a){return b.errorInterceptors.push(a),this},a.setResponseInterceptor=a.addResponseInterceptor,a.setResponseExtractor=a.addResponseInterceptor,a.setErrorInterceptor=a.addErrorInterceptor,b.requestInterceptors=b.requestInterceptors||[],b.defaultInterceptor=function(a,b,c,d,e,f,g){return{element:a,headers:e,params:f,httpConfig:g}},b.fullRequestInterceptor=function(a,c,d,e,f,g,h){var i=angular.copy(b.requestInterceptors),j=b.defaultInterceptor(a,c,d,e,f,g,h);return _.reduce(i,function(a,b){return _.extend(a,b(a.element,c,d,e,a.headers,a.params,a.httpConfig))},j)},a.addRequestInterceptor=function(a){return b.requestInterceptors.push(function(b,c,d,e,f,g,h){return{headers:f,params:g,element:a(b,c,d,e),httpConfig:h}}),this},a.setRequestInterceptor=a.addRequestInterceptor,a.addFullRequestInterceptor=function(a){return b.requestInterceptors.push(a),this},a.setFullRequestInterceptor=a.addFullRequestInterceptor,b.onBeforeElemRestangularized=b.onBeforeElemRestangularized||function(a){return a},a.setOnBeforeElemRestangularized=function(a){return b.onBeforeElemRestangularized=a,this},a.setRestangularizePromiseInterceptor=function(a){return b.restangularizePromiseInterceptor=a,this},b.onElemRestangularized=b.onElemRestangularized||function(a){return a},a.setOnElemRestangularized=function(a){return b.onElemRestangularized=a,this},b.shouldSaveParent=b.shouldSaveParent||function(){return!0},a.setParentless=function(a){return _.isArray(a)?b.shouldSaveParent=function(b){return!_.includes(a,b)}:_.isBoolean(a)&&(b.shouldSaveParent=function(){return!a}),this},b.suffix=_.isUndefined(b.suffix)?null:b.suffix,a.setRequestSuffix=function(a){return b.suffix=a,this},b.transformers=b.transformers||{},a.addElementTransformer=function(c,d,e){var f=null,g=null;2===arguments.length?g=d:(g=e,f=d);var h=b.transformers[c];return h||(h=b.transformers[c]=[]),h.push(function(a,b){return _.isNull(f)||a===f?g(b):b}),a},a.extendCollection=function(b,c){return a.addElementTransformer(b,!0,c)},a.extendModel=function(b,c){return a.addElementTransformer(b,!1,c)},b.transformElem=function(a,c,d,e,f){if(!f&&!b.transformLocalElements&&!a[b.restangularFields.fromServer])return a;var g=b.transformers[d],h=a;return g&&_.each(g,function(a){h=a(c,h)}),b.onElemRestangularized(h,c,d,e)},b.transformLocalElements=_.isUndefined(b.transformLocalElements)?!1:b.transformLocalElements,a.setTransformOnlyServerElements=function(a){b.transformLocalElements=!a},b.fullResponse=_.isUndefined(b.fullResponse)?!1:b.fullResponse,a.setFullResponse=function(a){return b.fullResponse=a,this},b.urlCreatorFactory={};var f=function(){};f.prototype.setConfig=function(a){return this.config=a,this},f.prototype.parentsArray=function(a){for(var b=[];a;)b.push(a),a=a[this.config.restangularFields.parentResource];return b.reverse()},f.prototype.resource=function(a,d,e,f,g,h,i,j){var k=_.defaults(g||{},this.config.defaultRequestParams.common),l=_.defaults(f||{},this.config.defaultHeaders);i&&(b.isSafe(j)?l["If-None-Match"]=i:l["If-Match"]=i);var m=this.base(a);if(h){var n="";/\/$/.test(m)||(n+="/"),n+=h,m+=n}return this.config.suffix&&-1===m.indexOf(this.config.suffix,m.length-this.config.suffix.length)&&!this.config.getUrlFromElem(a)&&(m+=this.config.suffix),a[this.config.restangularFields.httpConfig]=void 0,c(this.config,d,m,{getList:this.config.withHttpValues(e,{method:"GET",params:k,headers:l}),get:this.config.withHttpValues(e,{method:"GET",params:k,headers:l}),jsonp:this.config.withHttpValues(e,{method:"jsonp",params:k,headers:l}),put:this.config.withHttpValues(e,{method:"PUT",params:k,headers:l}),post:this.config.withHttpValues(e,{method:"POST",params:k,headers:l}),remove:this.config.withHttpValues(e,{method:"DELETE",params:k,headers:l}),head:this.config.withHttpValues(e,{method:"HEAD",params:k,headers:l}),trace:this.config.withHttpValues(e,{method:"TRACE",params:k,headers:l}),options:this.config.withHttpValues(e,{method:"OPTIONS",params:k,headers:l}),patch:this.config.withHttpValues(e,{method:"PATCH",params:k,headers:l})})};var g=function(){};g.prototype=new f,g.prototype.normalizeUrl=function(a){var b=/(http[s]?:\/\/)?(.*)?/.exec(a);return b[2]=b[2].replace(/[\\\/]+/g,"/"),"undefined"!=typeof b[1]?b[1]+b[2]:b[2]},g.prototype.base=function(a){var c=this;return _.reduce(this.parentsArray(a),function(a,d){var e,f=c.config.getUrlFromElem(d);if(f){if(c.config.isAbsoluteUrl(f))return f;e=f}else if(e=d[c.config.restangularFields.route],d[c.config.restangularFields.restangularCollection]){var g=d[c.config.restangularFields.ids];g&&(e+="/"+g.join(","))}else{var h;h=c.config.useCannonicalId?c.config.getCannonicalIdFromElem(d):c.config.getIdFromElem(d),b.isValidId(h)&&!d.singleOne&&(e+="/"+(c.config.encodeIds?encodeURIComponent(h):h))}return a=a.replace(/\/$/,"")+"/"+e,c.normalizeUrl(a)},this.config.baseUrl)},g.prototype.fetchUrl=function(a,b){var c=this.base(a);return b&&(c+="/"+b),c},g.prototype.fetchRequestedUrl=function(a,c){function d(a){var b=[];for(var c in a)a.hasOwnProperty(c)&&b.push(c);return b.sort()}function e(a,b,c){for(var e=d(a),f=0;f<e.length;f++)b.call(c,a[e[f]],e[f]);return e}function f(a,b){return encodeURIComponent(a).replace(/%40/gi,"@").replace(/%3A/gi,":").replace(/%24/g,"$").replace(/%2C/gi,",").replace(/%20/g,b?"%20":"+")}var g=this.fetchUrl(a,c),h=a[b.restangularFields.reqParams];if(!h)return g+(this.config.suffix||"");var i=[];return e(h,function(a,b){null!==a&&void 0!==a&&(angular.isArray(a)||(a=[a]),angular.forEach(a,function(a){angular.isObject(a)&&(a=angular.toJson(a)),i.push(f(b)+"="+f(a))}))}),g+(this.config.suffix||"")+(-1===g.indexOf("?")?"?":"&")+i.join("&")},b.urlCreatorFactory.path=g};var b={};a.init(this,b),this.$get=["$http","$q",function(c,d){function e(b){function f(a,c,d,e,f){if(c[b.restangularFields.route]=d,c[b.restangularFields.getRestangularUrl]=_.bind(P.fetchUrl,P,c),c[b.restangularFields.getRequestedUrl]=_.bind(P.fetchRequestedUrl,P,c),c[b.restangularFields.addRestangularMethod]=_.bind(L,c),c[b.restangularFields.clone]=_.bind(r,c,c),c[b.restangularFields.reqParams]=_.isEmpty(e)?null:e,c[b.restangularFields.withHttpConfig]=_.bind(z,c),c[b.restangularFields.plain]=_.bind(p,c,c),c[b.restangularFields.restangularized]=!0,c[b.restangularFields.one]=_.bind(g,c,c),c[b.restangularFields.all]=_.bind(h,c,c),c[b.restangularFields.several]=_.bind(i,c,c),c[b.restangularFields.oneUrl]=_.bind(j,c,c),c[b.restangularFields.allUrl]=_.bind(k,c,c),c[b.restangularFields.fromServer]=!!f,a&&b.shouldSaveParent(d)){var l=b.getIdFromElem(a),m=b.getUrlFromElem(a),n=_.union(_.values(_.pick(b.restangularFields,["route","singleOne","parentResource"])),b.extraFields),o=_.pick(a,n);b.isValidId(l)&&b.setIdToElem(o,l,d),b.isValidId(m)&&b.setUrlToElem(o,m,d),c[b.restangularFields.parentResource]=o}else c[b.restangularFields.parentResource]=null;return c}function g(a,c,d,e){var f;if(_.isNumber(c)||_.isNumber(a))throw f="You're creating a Restangular entity with the number ",f+="instead of the route or the parent. For example, you can't call .one(12).",new Error(f);if(_.isUndefined(c))throw f="You're creating a Restangular entity either without the path. ",f+="For example you can't call .one(). Please check if your arguments are valid.",new Error(f);var g={};return b.setIdToElem(g,d,c),b.setFieldToElem(b.restangularFields.singleOne,g,e),s(a,g,c,!1)}function h(a,b){return t(a,[],b,!1)}function i(a,c){var d=[];return d[b.restangularFields.ids]=Array.prototype.splice.call(arguments,2),t(a,d,c,!1)}function j(a,c,d){if(!c)throw new Error("Route is mandatory when creating new Restangular objects.");var e={};return b.setUrlToElem(e,d,c),s(a,e,c,!1)}function k(a,c,d){if(!c)throw new Error("Route is mandatory when creating new Restangular objects.");var e={};return b.setUrlToElem(e,d,c),t(a,e,c,!1)}function l(a,c,d){return a.call=_.bind(m,a),a.get=_.bind(n,a),a[b.restangularFields.restangularCollection]=c,c&&(a.push=_.bind(m,a,"push")),a.$object=d,b.restangularizePromiseInterceptor&&b.restangularizePromiseInterceptor(a),a}function m(a){var c=d.defer(),e=arguments,f={};return this.then(function(b){var d=Array.prototype.slice.call(e,1),g=b[a];g.apply(b,d),f=b,c.resolve(b)}),l(c.promise,this[b.restangularFields.restangularCollection],f)}function n(a){var c=d.defer(),e={};return this.then(function(b){e=b[a],c.resolve(e)}),l(c.promise,this[b.restangularFields.restangularCollection],e)}function o(a,c,d,e){return _.extend(e,d),b.fullResponse?a.resolve(_.extend(c,{data:d})):void a.resolve(d)}function p(a){if(_.isArray(a)){var c=[];return _.each(a,function(a){c.push(b.isRestangularized(a)?p(a):a)}),c}return _.omit(a,_.values(_.omit(b.restangularFields,"id")))}function q(a){a[b.restangularFields.customOperation]=_.bind(K,a),_.each(["put","post","get","delete"],function(b){_.each(["do","custom"],function(c){var d,e="delete"===b?"remove":b,f=c+b.toUpperCase();d="put"!==e&&"post"!==e?K:function(a,b,c,d,e){return _.bind(K,this)(a,c,d,e,b)},a[f]=_.bind(d,a,e)})}),a[b.restangularFields.customGETLIST]=_.bind(y,a),a[b.restangularFields.doGETLIST]=a[b.restangularFields.customGETLIST]}function r(a,c){var d=angular.copy(a,c);return s(d[b.restangularFields.parentResource],d,d[b.restangularFields.route],!0)}function s(a,c,d,e,g,h){var i=b.onBeforeElemRestangularized(c,!1,d),j=f(a,i,d,h,e);return b.useCannonicalId&&(j[b.restangularFields.cannonicalId]=b.getIdFromElem(j)),g&&(j[b.restangularFields.getParentList]=function(){return g}),j[b.restangularFields.restangularCollection]=!1,j[b.restangularFields.get]=_.bind(C,j),j[b.restangularFields.getList]=_.bind(y,j),j[b.restangularFields.put]=_.bind(E,j),j[b.restangularFields.post]=_.bind(F,j),j[b.restangularFields.remove]=_.bind(D,j),j[b.restangularFields.head]=_.bind(G,j),j[b.restangularFields.trace]=_.bind(H,j),j[b.restangularFields.options]=_.bind(I,j),j[b.restangularFields.patch]=_.bind(J,j),j[b.restangularFields.save]=_.bind(A,j),q(j),b.transformElem(j,!1,d,O,!0)}function t(a,c,d,e,g){var h=b.onBeforeElemRestangularized(c,!0,d),i=f(a,h,d,g,e);return i[b.restangularFields.restangularCollection]=!0,i[b.restangularFields.post]=_.bind(F,i,null),i[b.restangularFields.remove]=_.bind(D,i),i[b.restangularFields.head]=_.bind(G,i),i[b.restangularFields.trace]=_.bind(H,i),i[b.restangularFields.putElement]=_.bind(w,i),i[b.restangularFields.options]=_.bind(I,i),i[b.restangularFields.patch]=_.bind(J,i),i[b.restangularFields.get]=_.bind(v,i),i[b.restangularFields.getList]=_.bind(y,i,null),q(i),b.transformElem(i,!0,d,O,!0)}function u(a,b,c){var d=t(a,b,c,!1);return _.each(d,function(b){s(a,b,c,!1)}),d}function v(a,b,c){return this.customGET(a.toString(),b,c)}function w(a,c,e){var f=this,g=this[a],h=d.defer(),i=[];return i=b.transformElem(i,!0,g[b.restangularFields.route],O),g.put(c,e).then(function(b){var c=r(f);c[a]=b,i=c,h.resolve(c)},function(a){h.reject(a)}),l(h.promise,!0,i)}function x(a,c,d,e,f,g){var h=b.responseExtractor(a,c,d,e,f,g),i=f.headers("ETag");return h&&i&&(h[b.restangularFields.etag]=i),h}function y(a,e,f){var g=this,h=d.defer(),i="getList",j=P.fetchUrl(this,a),k=a||g[b.restangularFields.route],m=b.fullRequestInterceptor(null,i,k,j,f||{},e||{},this[b.restangularFields.httpConfig]||{}),n=[];n=b.transformElem(n,!0,k,O);var p="getList";b.jsonp&&(p="jsonp");var q=function(c){var d=c.data,e=c.config.params,f=x(d,i,k,j,c,h);if((_.isUndefined(f)||""===f)&&(f=[]),!_.isArray(f))throw new Error("Response for getList SHOULD be an array and not an object or something else");var l=_.map(f,function(c){return g[b.restangularFields.restangularCollection]?s(g[b.restangularFields.parentResource],c,g[b.restangularFields.route],!0,f):s(g,c,a,!0,f)});l=_.extend(f,l),g[b.restangularFields.restangularCollection]?o(h,c,t(g[b.restangularFields.parentResource],l,g[b.restangularFields.route],!0,e),n):o(h,c,t(g,l,a,!0,e),n)};return P.resource(this,c,m.httpConfig,m.headers,m.params,a,this[b.restangularFields.etag],i)[p]().then(q,function(a){304===a.status&&g[b.restangularFields.restangularCollection]?o(h,a,g,n):_.every(b.errorInterceptors,function(b){return b(a,h,q)!==!1})&&h.reject(a)}),l(h.promise,!0,n)}function z(a){return this[b.restangularFields.httpConfig]=a,this}function A(a,c){return this[b.restangularFields.fromServer]?this[b.restangularFields.put](a,c):_.bind(B,this)("post",void 0,a,void 0,c)}function B(a,e,f,g,h){var i=this,j=d.defer(),k=f||{},m=e||this[b.restangularFields.route],n=P.fetchUrl(this,e),q=g||this,r=q[b.restangularFields.etag]||("post"!==a?this[b.restangularFields.etag]:null);_.isObject(q)&&b.isRestangularized(q)&&(q=p(q));var t=b.fullRequestInterceptor(q,a,m,n,h||{},k||{},this[b.restangularFields.httpConfig]||{}),u={};u=b.transformElem(u,!1,m,O);var v=function(c){var d=c.data,e=c.config.params,f=x(d,a,m,n,c,j);if(f){var g;"post"!==a||i[b.restangularFields.restangularCollection]?(g=s(i[b.restangularFields.parentResource],f,i[b.restangularFields.route],!0,null,e),g[b.restangularFields.singleOne]=i[b.restangularFields.singleOne],o(j,c,g,u)):(g=s(i[b.restangularFields.parentResource],f,m,!0,null,e),o(j,c,g,u))}else o(j,c,void 0,u)},w=function(c){304===c.status&&b.isSafe(a)?o(j,c,i,u):_.every(b.errorInterceptors,function(a){return a(c,j,v)!==!1})&&j.reject(c)},y=a,z=_.extend({},t.headers),A=b.isOverridenMethod(a);return A?(y="post",z=_.extend(z,{"X-HTTP-Method-Override":"remove"===a?"DELETE":a.toUpperCase()})):b.jsonp&&"get"===y&&(y="jsonp"),b.isSafe(a)?A?P.resource(this,c,t.httpConfig,z,t.params,e,r,y)[y]({}).then(v,w):P.resource(this,c,t.httpConfig,z,t.params,e,r,y)[y]().then(v,w):P.resource(this,c,t.httpConfig,z,t.params,e,r,y)[y](t.element).then(v,w),l(j.promise,!1,u)}function C(a,b){return _.bind(B,this)("get",void 0,a,void 0,b)}function D(a,b){return _.bind(B,this)("remove",void 0,a,void 0,b)}function E(a,b){return _.bind(B,this)("put",void 0,a,void 0,b)}function F(a,b,c,d){return _.bind(B,this)("post",a,c,b,d)}function G(a,b){return _.bind(B,this)("head",void 0,a,void 0,b)}function H(a,b){return _.bind(B,this)("trace",void 0,a,void 0,b)}function I(a,b){return _.bind(B,this)("options",void 0,a,void 0,b)}function J(a,b,c){return _.bind(B,this)("patch",void 0,b,a,c)}function K(a,b,c,d,e){return _.bind(B,this)(a,b,c,e,d)}function L(a,c,d,e,f,g){var h;h="getList"===c?_.bind(y,this,d):_.bind(K,this,c,d);var i=function(a,b,c){var d=_.defaults({params:a,headers:b,elem:c},{params:e,headers:f,elem:g});return h(d.params,d.headers,d.elem)};b.isSafe(c)?this[a]=i:this[a]=function(a,b,c){return i(b,c,a)}}function M(c){var d=angular.copy(_.omit(b,"configuration"));return a.init(d,d),c(d),e(d)}function N(a,c){var d=_.values(b.restangularFields),e={},f=(c||O).all(a);e.one=_.bind(g,c||O,c,a),e.post=_.bind(f.post,f),e.getList=_.bind(f.getList,f);for(var h in f)f.hasOwnProperty(h)&&_.isFunction(f[h])&&!_.includes(d,h)&&(e[h]=_.bind(f[h],f));return e}var O={},P=new b.urlCreatorFactory[b.urlCreator];return P.setConfig(b),a.init(O,b),O.copy=_.bind(r,O),O.service=_.bind(N,O),O.withConfig=_.bind(M,O),O.one=_.bind(g,O,null),O.all=_.bind(h,O,null),O.several=_.bind(i,O,null),O.oneUrl=_.bind(j,O,null),O.allUrl=_.bind(k,O,null),O.stripRestangular=_.bind(p,O),O.restangularizeElement=_.bind(s,O),O.restangularizeCollection=_.bind(u,O),O}return e(b)}]})}();

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);
var ngCookies = __webpack_require__(680);
var ngMessages = __webpack_require__(14);
var ngSanitize = __webpack_require__(26);
var uiRouter = __webpack_require__(6);
var restangular = __webpack_require__(4); // eslint-disable-line no-unused-vars
__webpack_require__(23);
var olyDialog = __webpack_require__(24);

var olyCommonModule = __webpack_require__(3);
var analyticsModule = __webpack_require__(8);

var wowCommonModuleName = 'wowApp.common';

angular.module(wowCommonModuleName, [analyticsModule, olyCommonModule, ngCookies, ngMessages, ngSanitize, uiRouter, 'restangular', olyDialog]);

// Components

// high priority modules
__webpack_require__(546);
__webpack_require__(693);
__webpack_require__(695);
__webpack_require__(697);

__webpack_require__(546);
__webpack_require__(779);
__webpack_require__(782);
__webpack_require__(785);
__webpack_require__(788);
__webpack_require__(790);
__webpack_require__(793);
__webpack_require__(813);
__webpack_require__(815);
__webpack_require__(817);
__webpack_require__(819);
__webpack_require__(822);
__webpack_require__(835);
__webpack_require__(838);
__webpack_require__(840);
__webpack_require__(842);
__webpack_require__(844);
__webpack_require__(848);
__webpack_require__(25);
__webpack_require__(851);
__webpack_require__(853);
__webpack_require__(861);
__webpack_require__(864);
__webpack_require__(866);
__webpack_require__(869);
__webpack_require__(871);
__webpack_require__(873);
__webpack_require__(875);
__webpack_require__(880);
__webpack_require__(883);
__webpack_require__(886);
__webpack_require__(889);
__webpack_require__(893);
__webpack_require__(895);

module.exports = wowCommonModuleName;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

/**
 * State-based routing for AngularJS
 * @version v0.4.2
 * @link http://angular-ui.github.com/
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */

/* commonjs package manager support (eg componentjs) */
if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
  module.exports = 'ui.router';
}

(function (window, angular, undefined) {
/*jshint globalstrict:true*/
/*global angular:false*/
'use strict';

var isDefined = angular.isDefined,
    isFunction = angular.isFunction,
    isString = angular.isString,
    isObject = angular.isObject,
    isArray = angular.isArray,
    forEach = angular.forEach,
    extend = angular.extend,
    copy = angular.copy,
    toJson = angular.toJson;

function inherit(parent, extra) {
  return extend(new (extend(function() {}, { prototype: parent }))(), extra);
}

function merge(dst) {
  forEach(arguments, function(obj) {
    if (obj !== dst) {
      forEach(obj, function(value, key) {
        if (!dst.hasOwnProperty(key)) dst[key] = value;
      });
    }
  });
  return dst;
}

/**
 * Finds the common ancestor path between two states.
 *
 * @param {Object} first The first state.
 * @param {Object} second The second state.
 * @return {Array} Returns an array of state names in descending order, not including the root.
 */
function ancestors(first, second) {
  var path = [];

  for (var n in first.path) {
    if (first.path[n] !== second.path[n]) break;
    path.push(first.path[n]);
  }
  return path;
}

/**
 * IE8-safe wrapper for `Object.keys()`.
 *
 * @param {Object} object A JavaScript object.
 * @return {Array} Returns the keys of the object as an array.
 */
function objectKeys(object) {
  if (Object.keys) {
    return Object.keys(object);
  }
  var result = [];

  forEach(object, function(val, key) {
    result.push(key);
  });
  return result;
}

/**
 * IE8-safe wrapper for `Array.prototype.indexOf()`.
 *
 * @param {Array} array A JavaScript array.
 * @param {*} value A value to search the array for.
 * @return {Number} Returns the array index value of `value`, or `-1` if not present.
 */
function indexOf(array, value) {
  if (Array.prototype.indexOf) {
    return array.indexOf(value, Number(arguments[2]) || 0);
  }
  var len = array.length >>> 0, from = Number(arguments[2]) || 0;
  from = (from < 0) ? Math.ceil(from) : Math.floor(from);

  if (from < 0) from += len;

  for (; from < len; from++) {
    if (from in array && array[from] === value) return from;
  }
  return -1;
}

/**
 * Merges a set of parameters with all parameters inherited between the common parents of the
 * current state and a given destination state.
 *
 * @param {Object} currentParams The value of the current state parameters ($stateParams).
 * @param {Object} newParams The set of parameters which will be composited with inherited params.
 * @param {Object} $current Internal definition of object representing the current state.
 * @param {Object} $to Internal definition of object representing state to transition to.
 */
function inheritParams(currentParams, newParams, $current, $to) {
  var parents = ancestors($current, $to), parentParams, inherited = {}, inheritList = [];

  for (var i in parents) {
    if (!parents[i] || !parents[i].params) continue;
    parentParams = objectKeys(parents[i].params);
    if (!parentParams.length) continue;

    for (var j in parentParams) {
      if (indexOf(inheritList, parentParams[j]) >= 0) continue;
      inheritList.push(parentParams[j]);
      inherited[parentParams[j]] = currentParams[parentParams[j]];
    }
  }
  return extend({}, inherited, newParams);
}

/**
 * Performs a non-strict comparison of the subset of two objects, defined by a list of keys.
 *
 * @param {Object} a The first object.
 * @param {Object} b The second object.
 * @param {Array} keys The list of keys within each object to compare. If the list is empty or not specified,
 *                     it defaults to the list of keys in `a`.
 * @return {Boolean} Returns `true` if the keys match, otherwise `false`.
 */
function equalForKeys(a, b, keys) {
  if (!keys) {
    keys = [];
    for (var n in a) keys.push(n); // Used instead of Object.keys() for IE8 compatibility
  }

  for (var i=0; i<keys.length; i++) {
    var k = keys[i];
    if (a[k] != b[k]) return false; // Not '===', values aren't necessarily normalized
  }
  return true;
}

/**
 * Returns the subset of an object, based on a list of keys.
 *
 * @param {Array} keys
 * @param {Object} values
 * @return {Boolean} Returns a subset of `values`.
 */
function filterByKeys(keys, values) {
  var filtered = {};

  forEach(keys, function (name) {
    filtered[name] = values[name];
  });
  return filtered;
}

// like _.indexBy
// when you know that your index values will be unique, or you want last-one-in to win
function indexBy(array, propName) {
  var result = {};
  forEach(array, function(item) {
    result[item[propName]] = item;
  });
  return result;
}

// extracted from underscore.js
// Return a copy of the object only containing the whitelisted properties.
function pick(obj) {
  var copy = {};
  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
  forEach(keys, function(key) {
    if (key in obj) copy[key] = obj[key];
  });
  return copy;
}

// extracted from underscore.js
// Return a copy of the object omitting the blacklisted properties.
function omit(obj) {
  var copy = {};
  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
  for (var key in obj) {
    if (indexOf(keys, key) == -1) copy[key] = obj[key];
  }
  return copy;
}

function pluck(collection, key) {
  var result = isArray(collection) ? [] : {};

  forEach(collection, function(val, i) {
    result[i] = isFunction(key) ? key(val) : val[key];
  });
  return result;
}

function filter(collection, callback) {
  var array = isArray(collection);
  var result = array ? [] : {};
  forEach(collection, function(val, i) {
    if (callback(val, i)) {
      result[array ? result.length : i] = val;
    }
  });
  return result;
}

function map(collection, callback) {
  var result = isArray(collection) ? [] : {};

  forEach(collection, function(val, i) {
    result[i] = callback(val, i);
  });
  return result;
}

// issue #2676 #2889
function silenceUncaughtInPromise (promise) {
  return promise.then(undefined, function() {}) && promise;
}

/**
 * @ngdoc overview
 * @name ui.router.util
 *
 * @description
 * # ui.router.util sub-module
 *
 * This module is a dependency of other sub-modules. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 *
 */
angular.module('ui.router.util', ['ng']);

/**
 * @ngdoc overview
 * @name ui.router.router
 * 
 * @requires ui.router.util
 *
 * @description
 * # ui.router.router sub-module
 *
 * This module is a dependency of other sub-modules. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 */
angular.module('ui.router.router', ['ui.router.util']);

/**
 * @ngdoc overview
 * @name ui.router.state
 * 
 * @requires ui.router.router
 * @requires ui.router.util
 *
 * @description
 * # ui.router.state sub-module
 *
 * This module is a dependency of the main ui.router module. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 * 
 */
angular.module('ui.router.state', ['ui.router.router', 'ui.router.util']);

/**
 * @ngdoc overview
 * @name ui.router
 *
 * @requires ui.router.state
 *
 * @description
 * # ui.router
 * 
 * ## The main module for ui.router 
 * There are several sub-modules included with the ui.router module, however only this module is needed
 * as a dependency within your angular app. The other modules are for organization purposes. 
 *
 * The modules are:
 * * ui.router - the main "umbrella" module
 * * ui.router.router - 
 * 
 * *You'll need to include **only** this module as the dependency within your angular app.*
 * 
 * <pre>
 * <!doctype html>
 * <html ng-app="myApp">
 * <head>
 *   <script src="js/angular.js"></script>
 *   <!-- Include the ui-router script -->
 *   <script src="js/angular-ui-router.min.js"></script>
 *   <script>
 *     // ...and add 'ui.router' as a dependency
 *     var myApp = angular.module('myApp', ['ui.router']);
 *   </script>
 * </head>
 * <body>
 * </body>
 * </html>
 * </pre>
 */
angular.module('ui.router', ['ui.router.state']);

angular.module('ui.router.compat', ['ui.router']);

/**
 * @ngdoc object
 * @name ui.router.util.$resolve
 *
 * @requires $q
 * @requires $injector
 *
 * @description
 * Manages resolution of (acyclic) graphs of promises.
 */
$Resolve.$inject = ['$q', '$injector'];
function $Resolve(  $q,    $injector) {
  
  var VISIT_IN_PROGRESS = 1,
      VISIT_DONE = 2,
      NOTHING = {},
      NO_DEPENDENCIES = [],
      NO_LOCALS = NOTHING,
      NO_PARENT = extend($q.when(NOTHING), { $$promises: NOTHING, $$values: NOTHING });
  

  /**
   * @ngdoc function
   * @name ui.router.util.$resolve#study
   * @methodOf ui.router.util.$resolve
   *
   * @description
   * Studies a set of invocables that are likely to be used multiple times.
   * <pre>
   * $resolve.study(invocables)(locals, parent, self)
   * </pre>
   * is equivalent to
   * <pre>
   * $resolve.resolve(invocables, locals, parent, self)
   * </pre>
   * but the former is more efficient (in fact `resolve` just calls `study` 
   * internally).
   *
   * @param {object} invocables Invocable objects
   * @return {function} a function to pass in locals, parent and self
   */
  this.study = function (invocables) {
    if (!isObject(invocables)) throw new Error("'invocables' must be an object");
    var invocableKeys = objectKeys(invocables || {});
    
    // Perform a topological sort of invocables to build an ordered plan
    var plan = [], cycle = [], visited = {};
    function visit(value, key) {
      if (visited[key] === VISIT_DONE) return;
      
      cycle.push(key);
      if (visited[key] === VISIT_IN_PROGRESS) {
        cycle.splice(0, indexOf(cycle, key));
        throw new Error("Cyclic dependency: " + cycle.join(" -> "));
      }
      visited[key] = VISIT_IN_PROGRESS;
      
      if (isString(value)) {
        plan.push(key, [ function() { return $injector.get(value); }], NO_DEPENDENCIES);
      } else {
        var params = $injector.annotate(value);
        forEach(params, function (param) {
          if (param !== key && invocables.hasOwnProperty(param)) visit(invocables[param], param);
        });
        plan.push(key, value, params);
      }
      
      cycle.pop();
      visited[key] = VISIT_DONE;
    }
    forEach(invocables, visit);
    invocables = cycle = visited = null; // plan is all that's required
    
    function isResolve(value) {
      return isObject(value) && value.then && value.$$promises;
    }
    
    return function (locals, parent, self) {
      if (isResolve(locals) && self === undefined) {
        self = parent; parent = locals; locals = null;
      }
      if (!locals) locals = NO_LOCALS;
      else if (!isObject(locals)) {
        throw new Error("'locals' must be an object");
      }       
      if (!parent) parent = NO_PARENT;
      else if (!isResolve(parent)) {
        throw new Error("'parent' must be a promise returned by $resolve.resolve()");
      }
      
      // To complete the overall resolution, we have to wait for the parent
      // promise and for the promise for each invokable in our plan.
      var resolution = $q.defer(),
          result = silenceUncaughtInPromise(resolution.promise),
          promises = result.$$promises = {},
          values = extend({}, locals),
          wait = 1 + plan.length/3,
          merged = false;

      silenceUncaughtInPromise(result);
          
      function done() {
        // Merge parent values we haven't got yet and publish our own $$values
        if (!--wait) {
          if (!merged) merge(values, parent.$$values); 
          result.$$values = values;
          result.$$promises = result.$$promises || true; // keep for isResolve()
          delete result.$$inheritedValues;
          resolution.resolve(values);
        }
      }
      
      function fail(reason) {
        result.$$failure = reason;
        resolution.reject(reason);
      }

      // Short-circuit if parent has already failed
      if (isDefined(parent.$$failure)) {
        fail(parent.$$failure);
        return result;
      }
      
      if (parent.$$inheritedValues) {
        merge(values, omit(parent.$$inheritedValues, invocableKeys));
      }

      // Merge parent values if the parent has already resolved, or merge
      // parent promises and wait if the parent resolve is still in progress.
      extend(promises, parent.$$promises);
      if (parent.$$values) {
        merged = merge(values, omit(parent.$$values, invocableKeys));
        result.$$inheritedValues = omit(parent.$$values, invocableKeys);
        done();
      } else {
        if (parent.$$inheritedValues) {
          result.$$inheritedValues = omit(parent.$$inheritedValues, invocableKeys);
        }        
        parent.then(done, fail);
      }
      
      // Process each invocable in the plan, but ignore any where a local of the same name exists.
      for (var i=0, ii=plan.length; i<ii; i+=3) {
        if (locals.hasOwnProperty(plan[i])) done();
        else invoke(plan[i], plan[i+1], plan[i+2]);
      }
      
      function invoke(key, invocable, params) {
        // Create a deferred for this invocation. Failures will propagate to the resolution as well.
        var invocation = $q.defer(), waitParams = 0;
        function onfailure(reason) {
          invocation.reject(reason);
          fail(reason);
        }
        // Wait for any parameter that we have a promise for (either from parent or from this
        // resolve; in that case study() will have made sure it's ordered before us in the plan).
        forEach(params, function (dep) {
          if (promises.hasOwnProperty(dep) && !locals.hasOwnProperty(dep)) {
            waitParams++;
            promises[dep].then(function (result) {
              values[dep] = result;
              if (!(--waitParams)) proceed();
            }, onfailure);
          }
        });
        if (!waitParams) proceed();
        function proceed() {
          if (isDefined(result.$$failure)) return;
          try {
            invocation.resolve($injector.invoke(invocable, self, values));
            invocation.promise.then(function (result) {
              values[key] = result;
              done();
            }, onfailure);
          } catch (e) {
            onfailure(e);
          }
        }
        // Publish promise synchronously; invocations further down in the plan may depend on it.
        promises[key] = silenceUncaughtInPromise(invocation.promise);
      }
      
      return result;
    };
  };
  
  /**
   * @ngdoc function
   * @name ui.router.util.$resolve#resolve
   * @methodOf ui.router.util.$resolve
   *
   * @description
   * Resolves a set of invocables. An invocable is a function to be invoked via 
   * `$injector.invoke()`, and can have an arbitrary number of dependencies. 
   * An invocable can either return a value directly,
   * or a `$q` promise. If a promise is returned it will be resolved and the 
   * resulting value will be used instead. Dependencies of invocables are resolved 
   * (in this order of precedence)
   *
   * - from the specified `locals`
   * - from another invocable that is part of this `$resolve` call
   * - from an invocable that is inherited from a `parent` call to `$resolve` 
   *   (or recursively
   * - from any ancestor `$resolve` of that parent).
   *
   * The return value of `$resolve` is a promise for an object that contains 
   * (in this order of precedence)
   *
   * - any `locals` (if specified)
   * - the resolved return values of all injectables
   * - any values inherited from a `parent` call to `$resolve` (if specified)
   *
   * The promise will resolve after the `parent` promise (if any) and all promises 
   * returned by injectables have been resolved. If any invocable 
   * (or `$injector.invoke`) throws an exception, or if a promise returned by an 
   * invocable is rejected, the `$resolve` promise is immediately rejected with the 
   * same error. A rejection of a `parent` promise (if specified) will likewise be 
   * propagated immediately. Once the `$resolve` promise has been rejected, no 
   * further invocables will be called.
   * 
   * Cyclic dependencies between invocables are not permitted and will cause `$resolve`
   * to throw an error. As a special case, an injectable can depend on a parameter 
   * with the same name as the injectable, which will be fulfilled from the `parent` 
   * injectable of the same name. This allows inherited values to be decorated. 
   * Note that in this case any other injectable in the same `$resolve` with the same
   * dependency would see the decorated value, not the inherited value.
   *
   * Note that missing dependencies -- unlike cyclic dependencies -- will cause an 
   * (asynchronous) rejection of the `$resolve` promise rather than a (synchronous) 
   * exception.
   *
   * Invocables are invoked eagerly as soon as all dependencies are available. 
   * This is true even for dependencies inherited from a `parent` call to `$resolve`.
   *
   * As a special case, an invocable can be a string, in which case it is taken to 
   * be a service name to be passed to `$injector.get()`. This is supported primarily 
   * for backwards-compatibility with the `resolve` property of `$routeProvider` 
   * routes.
   *
   * @param {object} invocables functions to invoke or 
   * `$injector` services to fetch.
   * @param {object} locals  values to make available to the injectables
   * @param {object} parent  a promise returned by another call to `$resolve`.
   * @param {object} self  the `this` for the invoked methods
   * @return {object} Promise for an object that contains the resolved return value
   * of all invocables, as well as any inherited and local values.
   */
  this.resolve = function (invocables, locals, parent, self) {
    return this.study(invocables)(locals, parent, self);
  };
}

angular.module('ui.router.util').service('$resolve', $Resolve);



/**
 * @ngdoc object
 * @name ui.router.util.$templateFactoryProvider
 *
 * @description
 * Provider for $templateFactory. Manages which template-loading mechanism to
 * use, and will default to the most recent one ($templateRequest on Angular
 * versions starting from 1.3, $http otherwise).
 */
function TemplateFactoryProvider() {
  var shouldUnsafelyUseHttp = angular.version.minor < 3;

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactoryProvider#shouldUnsafelyUseHttp
   * @methodOf ui.router.util.$templateFactoryProvider
   *
   * @description
   * Forces $templateFactory to use $http instead of $templateRequest. This
   * might cause XSS, as $http doesn't enforce the regular security checks for
   * templates that have been introduced in Angular 1.3. Note that setting this
   * to false on Angular older than 1.3.x will crash, as the $templateRequest
   * service (and the security checks) are not implemented on these versions.
   *
   * See the $sce documentation, section
   * <a href="https://docs.angularjs.org/api/ng/service/$sce#impact-on-loading-templates">
   * Impact on loading templates</a> for more details about this mechanism.
   *
   * @param {boolean} value
   */
  this.shouldUnsafelyUseHttp = function(value) {
    shouldUnsafelyUseHttp = !!value;
  };

  /**
   * @ngdoc object
   * @name ui.router.util.$templateFactory
   *
   * @requires $http
   * @requires $templateCache
   * @requires $injector
   *
   * @description
   * Service. Manages loading of templates.
   */
  this.$get = ['$http', '$templateCache', '$injector', function($http, $templateCache, $injector){
    return new TemplateFactory($http, $templateCache, $injector, shouldUnsafelyUseHttp);}];
}


/**
 * @ngdoc object
 * @name ui.router.util.$templateFactory
 *
 * @requires $http
 * @requires $templateCache
 * @requires $injector
 *
 * @description
 * Service. Manages loading of templates.
 */
function TemplateFactory($http, $templateCache, $injector, shouldUnsafelyUseHttp) {

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromConfig
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template from a configuration object. 
   *
   * @param {object} config Configuration object for which to load a template. 
   * The following properties are search in the specified order, and the first one 
   * that is defined is used to create the template:
   *
   * @param {string|object} config.template html string template or function to 
   * load via {@link ui.router.util.$templateFactory#fromString fromString}.
   * @param {string|object} config.templateUrl url to load or a function returning 
   * the url to load via {@link ui.router.util.$templateFactory#fromUrl fromUrl}.
   * @param {Function} config.templateProvider function to invoke via 
   * {@link ui.router.util.$templateFactory#fromProvider fromProvider}.
   * @param {object} params  Parameters to pass to the template function.
   * @param {object} locals Locals to pass to `invoke` if the template is loaded 
   * via a `templateProvider`. Defaults to `{ params: params }`.
   *
   * @return {string|object}  The template html as a string, or a promise for 
   * that string,or `null` if no template is configured.
   */
  this.fromConfig = function (config, params, locals) {
    return (
      isDefined(config.template) ? this.fromString(config.template, params) :
      isDefined(config.templateUrl) ? this.fromUrl(config.templateUrl, params) :
      isDefined(config.templateProvider) ? this.fromProvider(config.templateProvider, params, locals) :
      null
    );
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromString
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template from a string or a function returning a string.
   *
   * @param {string|object} template html template as a string or function that 
   * returns an html template as a string.
   * @param {object} params Parameters to pass to the template function.
   *
   * @return {string|object} The template html as a string, or a promise for that 
   * string.
   */
  this.fromString = function (template, params) {
    return isFunction(template) ? template(params) : template;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromUrl
   * @methodOf ui.router.util.$templateFactory
   * 
   * @description
   * Loads a template from the a URL via `$http` and `$templateCache`.
   *
   * @param {string|Function} url url of the template to load, or a function 
   * that returns a url.
   * @param {Object} params Parameters to pass to the url function.
   * @return {string|Promise.<string>} The template html as a string, or a promise 
   * for that string.
   */
  this.fromUrl = function (url, params) {
    if (isFunction(url)) url = url(params);
    if (url == null) return null;
    else {
      if(!shouldUnsafelyUseHttp) {
        return $injector.get('$templateRequest')(url);
      } else {
        return $http
          .get(url, { cache: $templateCache, headers: { Accept: 'text/html' }})
          .then(function(response) { return response.data; });
      }
    }
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromProvider
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template by invoking an injectable provider function.
   *
   * @param {Function} provider Function to invoke via `$injector.invoke`
   * @param {Object} params Parameters for the template.
   * @param {Object} locals Locals to pass to `invoke`. Defaults to 
   * `{ params: params }`.
   * @return {string|Promise.<string>} The template html as a string, or a promise 
   * for that string.
   */
  this.fromProvider = function (provider, params, locals) {
    return $injector.invoke(provider, null, locals || { params: params });
  };
}

angular.module('ui.router.util').provider('$templateFactory', TemplateFactoryProvider);

var $$UMFP; // reference to $UrlMatcherFactoryProvider

/**
 * @ngdoc object
 * @name ui.router.util.type:UrlMatcher
 *
 * @description
 * Matches URLs against patterns and extracts named parameters from the path or the search
 * part of the URL. A URL pattern consists of a path pattern, optionally followed by '?' and a list
 * of search parameters. Multiple search parameter names are separated by '&'. Search parameters
 * do not influence whether or not a URL is matched, but their values are passed through into
 * the matched parameters returned by {@link ui.router.util.type:UrlMatcher#methods_exec exec}.
 *
 * Path parameter placeholders can be specified using simple colon/catch-all syntax or curly brace
 * syntax, which optionally allows a regular expression for the parameter to be specified:
 *
 * * `':'` name - colon placeholder
 * * `'*'` name - catch-all placeholder
 * * `'{' name '}'` - curly placeholder
 * * `'{' name ':' regexp|type '}'` - curly placeholder with regexp or type name. Should the
 *   regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
 *
 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
 * must be unique within the pattern (across both path and search parameters). For colon
 * placeholders or curly placeholders without an explicit regexp, a path parameter matches any
 * number of characters other than '/'. For catch-all placeholders the path parameter matches
 * any number of characters.
 *
 * Examples:
 *
 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
 * * `'/user/{id:[^/]*}'` - Same as the previous example.
 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
 *   parameter consists of 1 to 8 hex digits.
 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
 *   path into the parameter 'path'.
 * * `'/files/*path'` - ditto.
 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
 *   in the built-in  `date` Type matches `2014-11-12`) and provides a Date object in $stateParams.start
 *
 * @param {string} pattern  The pattern to compile into a matcher.
 * @param {Object} config  A configuration object hash:
 * @param {Object=} parentMatcher Used to concatenate the pattern/config onto
 *   an existing UrlMatcher
 *
 * * `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
 * * `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
 *
 * @property {string} prefix  A static prefix of this pattern. The matcher guarantees that any
 *   URL matching this matcher (i.e. any string for which {@link ui.router.util.type:UrlMatcher#methods_exec exec()} returns
 *   non-null) will start with this prefix.
 *
 * @property {string} source  The pattern that was passed into the constructor
 *
 * @property {string} sourcePath  The path portion of the source property
 *
 * @property {string} sourceSearch  The search portion of the source property
 *
 * @property {string} regex  The constructed regex that will be used to match against the url when
 *   it is time to determine which url will match.
 *
 * @returns {Object}  New `UrlMatcher` object
 */
function UrlMatcher(pattern, config, parentMatcher) {
  config = extend({ params: {} }, isObject(config) ? config : {});

  // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
  //   '*' name
  //   ':' name
  //   '{' name '}'
  //   '{' name ':' regexp '}'
  // The regular expression is somewhat complicated due to the need to allow curly braces
  // inside the regular expression. The placeholder regexp breaks down as follows:
  //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
  //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
  //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
  //    [^{}\\]+                       - anything other than curly braces or backslash
  //    \\.                            - a backslash escape
  //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
  var placeholder       = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
      searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
      compiled = '^', last = 0, m,
      segments = this.segments = [],
      parentParams = parentMatcher ? parentMatcher.params : {},
      params = this.params = parentMatcher ? parentMatcher.params.$$new() : new $$UMFP.ParamSet(),
      paramNames = [];

  function addParameter(id, type, config, location) {
    paramNames.push(id);
    if (parentParams[id]) return parentParams[id];
    if (!/^\w+([-.]+\w+)*(?:\[\])?$/.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
    if (params[id]) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
    params[id] = new $$UMFP.Param(id, type, config, location);
    return params[id];
  }

  function quoteRegExp(string, pattern, squash, optional) {
    var surroundPattern = ['',''], result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
    if (!pattern) return result;
    switch(squash) {
      case false: surroundPattern = ['(', ')' + (optional ? "?" : "")]; break;
      case true:
        result = result.replace(/\/$/, '');
        surroundPattern = ['(?:\/(', ')|\/)?'];
      break;
      default:    surroundPattern = ['(' + squash + "|", ')?']; break;
    }
    return result + surroundPattern[0] + pattern + surroundPattern[1];
  }

  this.source = pattern;

  // Split into static segments separated by path parameter placeholders.
  // The number of segments is always 1 more than the number of parameters.
  function matchDetails(m, isSearch) {
    var id, regexp, segment, type, cfg, arrayMode;
    id          = m[2] || m[3]; // IE[78] returns '' for unmatched groups instead of null
    cfg         = config.params[id];
    segment     = pattern.substring(last, m.index);
    regexp      = isSearch ? m[4] : m[4] || (m[1] == '*' ? '.*' : null);

    if (regexp) {
      type      = $$UMFP.type(regexp) || inherit($$UMFP.type("string"), { pattern: new RegExp(regexp, config.caseInsensitive ? 'i' : undefined) });
    }

    return {
      id: id, regexp: regexp, segment: segment, type: type, cfg: cfg
    };
  }

  var p, param, segment;
  while ((m = placeholder.exec(pattern))) {
    p = matchDetails(m, false);
    if (p.segment.indexOf('?') >= 0) break; // we're into the search part

    param = addParameter(p.id, p.type, p.cfg, "path");
    compiled += quoteRegExp(p.segment, param.type.pattern.source, param.squash, param.isOptional);
    segments.push(p.segment);
    last = placeholder.lastIndex;
  }
  segment = pattern.substring(last);

  // Find any search parameter names and remove them from the last segment
  var i = segment.indexOf('?');

  if (i >= 0) {
    var search = this.sourceSearch = segment.substring(i);
    segment = segment.substring(0, i);
    this.sourcePath = pattern.substring(0, last + i);

    if (search.length > 0) {
      last = 0;
      while ((m = searchPlaceholder.exec(search))) {
        p = matchDetails(m, true);
        param = addParameter(p.id, p.type, p.cfg, "search");
        last = placeholder.lastIndex;
        // check if ?&
      }
    }
  } else {
    this.sourcePath = pattern;
    this.sourceSearch = '';
  }

  compiled += quoteRegExp(segment) + (config.strict === false ? '\/?' : '') + '$';
  segments.push(segment);

  this.regexp = new RegExp(compiled, config.caseInsensitive ? 'i' : undefined);
  this.prefix = segments[0];
  this.$$paramNames = paramNames;
}

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#concat
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Returns a new matcher for a pattern constructed by appending the path part and adding the
 * search parameters of the specified pattern to this pattern. The current pattern is not
 * modified. This can be understood as creating a pattern for URLs that are relative to (or
 * suffixes of) the current pattern.
 *
 * @example
 * The following two matchers are equivalent:
 * <pre>
 * new UrlMatcher('/user/{id}?q').concat('/details?date');
 * new UrlMatcher('/user/{id}/details?q&date');
 * </pre>
 *
 * @param {string} pattern  The pattern to append.
 * @param {Object} config  An object hash of the configuration for the matcher.
 * @returns {UrlMatcher}  A matcher for the concatenated pattern.
 */
UrlMatcher.prototype.concat = function (pattern, config) {
  // Because order of search parameters is irrelevant, we can add our own search
  // parameters to the end of the new pattern. Parse the new pattern by itself
  // and then join the bits together, but it's much easier to do this on a string level.
  var defaultConfig = {
    caseInsensitive: $$UMFP.caseInsensitive(),
    strict: $$UMFP.strictMode(),
    squash: $$UMFP.defaultSquashPolicy()
  };
  return new UrlMatcher(this.sourcePath + pattern + this.sourceSearch, extend(defaultConfig, config), this);
};

UrlMatcher.prototype.toString = function () {
  return this.source;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#exec
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Tests the specified path against this matcher, and returns an object containing the captured
 * parameter values, or null if the path does not match. The returned object contains the values
 * of any search parameters that are mentioned in the pattern, but their value may be null if
 * they are not present in `searchParams`. This means that search parameters are always treated
 * as optional.
 *
 * @example
 * <pre>
 * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
 *   x: '1', q: 'hello'
 * });
 * // returns { id: 'bob', q: 'hello', r: null }
 * </pre>
 *
 * @param {string} path  The URL path to match, e.g. `$location.path()`.
 * @param {Object} searchParams  URL search parameters, e.g. `$location.search()`.
 * @returns {Object}  The captured parameter values.
 */
UrlMatcher.prototype.exec = function (path, searchParams) {
  var m = this.regexp.exec(path);
  if (!m) return null;
  searchParams = searchParams || {};

  var paramNames = this.parameters(), nTotal = paramNames.length,
    nPath = this.segments.length - 1,
    values = {}, i, j, cfg, paramName;

  if (nPath !== m.length - 1) throw new Error("Unbalanced capture group in route '" + this.source + "'");

  function decodePathArray(string) {
    function reverseString(str) { return str.split("").reverse().join(""); }
    function unquoteDashes(str) { return str.replace(/\\-/g, "-"); }

    var split = reverseString(string).split(/-(?!\\)/);
    var allReversed = map(split, reverseString);
    return map(allReversed, unquoteDashes).reverse();
  }

  var param, paramVal;
  for (i = 0; i < nPath; i++) {
    paramName = paramNames[i];
    param = this.params[paramName];
    paramVal = m[i+1];
    // if the param value matches a pre-replace pair, replace the value before decoding.
    for (j = 0; j < param.replace.length; j++) {
      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
    }
    if (paramVal && param.array === true) paramVal = decodePathArray(paramVal);
    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
    values[paramName] = param.value(paramVal);
  }
  for (/**/; i < nTotal; i++) {
    paramName = paramNames[i];
    values[paramName] = this.params[paramName].value(searchParams[paramName]);
    param = this.params[paramName];
    paramVal = searchParams[paramName];
    for (j = 0; j < param.replace.length; j++) {
      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
    }
    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
    values[paramName] = param.value(paramVal);
  }

  return values;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#parameters
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Returns the names of all path and search parameters of this pattern in an unspecified order.
 *
 * @returns {Array.<string>}  An array of parameter names. Must be treated as read-only. If the
 *    pattern has no parameters, an empty array is returned.
 */
UrlMatcher.prototype.parameters = function (param) {
  if (!isDefined(param)) return this.$$paramNames;
  return this.params[param] || null;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#validates
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Checks an object hash of parameters to validate their correctness according to the parameter
 * types of this `UrlMatcher`.
 *
 * @param {Object} params The object hash of parameters to validate.
 * @returns {boolean} Returns `true` if `params` validates, otherwise `false`.
 */
UrlMatcher.prototype.validates = function (params) {
  return this.params.$$validates(params);
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#format
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Creates a URL that matches this pattern by substituting the specified values
 * for the path and search parameters. Null values for path parameters are
 * treated as empty strings.
 *
 * @example
 * <pre>
 * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
 * // returns '/user/bob?q=yes'
 * </pre>
 *
 * @param {Object} values  the values to substitute for the parameters in this pattern.
 * @returns {string}  the formatted URL (path and optionally search part).
 */
UrlMatcher.prototype.format = function (values) {
  values = values || {};
  var segments = this.segments, params = this.parameters(), paramset = this.params;
  if (!this.validates(values)) return null;

  var i, search = false, nPath = segments.length - 1, nTotal = params.length, result = segments[0];

  function encodeDashes(str) { // Replace dashes with encoded "\-"
    return encodeURIComponent(str).replace(/-/g, function(c) { return '%5C%' + c.charCodeAt(0).toString(16).toUpperCase(); });
  }

  for (i = 0; i < nTotal; i++) {
    var isPathParam = i < nPath;
    var name = params[i], param = paramset[name], value = param.value(values[name]);
    var isDefaultValue = param.isOptional && param.type.equals(param.value(), value);
    var squash = isDefaultValue ? param.squash : false;
    var encoded = param.type.encode(value);

    if (isPathParam) {
      var nextSegment = segments[i + 1];
      var isFinalPathParam = i + 1 === nPath;

      if (squash === false) {
        if (encoded != null) {
          if (isArray(encoded)) {
            result += map(encoded, encodeDashes).join("-");
          } else {
            result += encodeURIComponent(encoded);
          }
        }
        result += nextSegment;
      } else if (squash === true) {
        var capture = result.match(/\/$/) ? /\/?(.*)/ : /(.*)/;
        result += nextSegment.match(capture)[1];
      } else if (isString(squash)) {
        result += squash + nextSegment;
      }

      if (isFinalPathParam && param.squash === true && result.slice(-1) === '/') result = result.slice(0, -1);
    } else {
      if (encoded == null || (isDefaultValue && squash !== false)) continue;
      if (!isArray(encoded)) encoded = [ encoded ];
      if (encoded.length === 0) continue;
      encoded = map(encoded, encodeURIComponent).join('&' + name + '=');
      result += (search ? '&' : '?') + (name + '=' + encoded);
      search = true;
    }
  }

  return result;
};

/**
 * @ngdoc object
 * @name ui.router.util.type:Type
 *
 * @description
 * Implements an interface to define custom parameter types that can be decoded from and encoded to
 * string parameters matched in a URL. Used by {@link ui.router.util.type:UrlMatcher `UrlMatcher`}
 * objects when matching or formatting URLs, or comparing or validating parameter values.
 *
 * See {@link ui.router.util.$urlMatcherFactory#methods_type `$urlMatcherFactory#type()`} for more
 * information on registering custom types.
 *
 * @param {Object} config  A configuration object which contains the custom type definition.  The object's
 *        properties will override the default methods and/or pattern in `Type`'s public interface.
 * @example
 * <pre>
 * {
 *   decode: function(val) { return parseInt(val, 10); },
 *   encode: function(val) { return val && val.toString(); },
 *   equals: function(a, b) { return this.is(a) && a === b; },
 *   is: function(val) { return angular.isNumber(val) isFinite(val) && val % 1 === 0; },
 *   pattern: /\d+/
 * }
 * </pre>
 *
 * @property {RegExp} pattern The regular expression pattern used to match values of this type when
 *           coming from a substring of a URL.
 *
 * @returns {Object}  Returns a new `Type` object.
 */
function Type(config) {
  extend(this, config);
}

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#is
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Detects whether a value is of a particular type. Accepts a native (decoded) value
 * and determines whether it matches the current `Type` object.
 *
 * @param {*} val  The value to check.
 * @param {string} key  Optional. If the type check is happening in the context of a specific
 *        {@link ui.router.util.type:UrlMatcher `UrlMatcher`} object, this is the name of the
 *        parameter in which `val` is stored. Can be used for meta-programming of `Type` objects.
 * @returns {Boolean}  Returns `true` if the value matches the type, otherwise `false`.
 */
Type.prototype.is = function(val, key) {
  return true;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#encode
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Encodes a custom/native type value to a string that can be embedded in a URL. Note that the
 * return value does *not* need to be URL-safe (i.e. passed through `encodeURIComponent()`), it
 * only needs to be a representation of `val` that has been coerced to a string.
 *
 * @param {*} val  The value to encode.
 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
 *        meta-programming of `Type` objects.
 * @returns {string}  Returns a string representation of `val` that can be encoded in a URL.
 */
Type.prototype.encode = function(val, key) {
  return val;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#decode
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Converts a parameter value (from URL string or transition param) to a custom/native value.
 *
 * @param {string} val  The URL parameter value to decode.
 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
 *        meta-programming of `Type` objects.
 * @returns {*}  Returns a custom representation of the URL parameter value.
 */
Type.prototype.decode = function(val, key) {
  return val;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#equals
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Determines whether two decoded values are equivalent.
 *
 * @param {*} a  A value to compare against.
 * @param {*} b  A value to compare against.
 * @returns {Boolean}  Returns `true` if the values are equivalent/equal, otherwise `false`.
 */
Type.prototype.equals = function(a, b) {
  return a == b;
};

Type.prototype.$subPattern = function() {
  var sub = this.pattern.toString();
  return sub.substr(1, sub.length - 2);
};

Type.prototype.pattern = /.*/;

Type.prototype.toString = function() { return "{Type:" + this.name + "}"; };

/** Given an encoded string, or a decoded object, returns a decoded object */
Type.prototype.$normalize = function(val) {
  return this.is(val) ? val : this.decode(val);
};

/*
 * Wraps an existing custom Type as an array of Type, depending on 'mode'.
 * e.g.:
 * - urlmatcher pattern "/path?{queryParam[]:int}"
 * - url: "/path?queryParam=1&queryParam=2
 * - $stateParams.queryParam will be [1, 2]
 * if `mode` is "auto", then
 * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
 * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
 */
Type.prototype.$asArray = function(mode, isSearch) {
  if (!mode) return this;
  if (mode === "auto" && !isSearch) throw new Error("'auto' array mode is for query parameters only");

  function ArrayType(type, mode) {
    function bindTo(type, callbackName) {
      return function() {
        return type[callbackName].apply(type, arguments);
      };
    }

    // Wrap non-array value as array
    function arrayWrap(val) { return isArray(val) ? val : (isDefined(val) ? [ val ] : []); }
    // Unwrap array value for "auto" mode. Return undefined for empty array.
    function arrayUnwrap(val) {
      switch(val.length) {
        case 0: return undefined;
        case 1: return mode === "auto" ? val[0] : val;
        default: return val;
      }
    }
    function falsey(val) { return !val; }

    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
    function arrayHandler(callback, allTruthyMode) {
      return function handleArray(val) {
        if (isArray(val) && val.length === 0) return val;
        val = arrayWrap(val);
        var result = map(val, callback);
        if (allTruthyMode === true)
          return filter(result, falsey).length === 0;
        return arrayUnwrap(result);
      };
    }

    // Wraps type (.equals) functions to operate on each value of an array
    function arrayEqualsHandler(callback) {
      return function handleArray(val1, val2) {
        var left = arrayWrap(val1), right = arrayWrap(val2);
        if (left.length !== right.length) return false;
        for (var i = 0; i < left.length; i++) {
          if (!callback(left[i], right[i])) return false;
        }
        return true;
      };
    }

    this.encode = arrayHandler(bindTo(type, 'encode'));
    this.decode = arrayHandler(bindTo(type, 'decode'));
    this.is     = arrayHandler(bindTo(type, 'is'), true);
    this.equals = arrayEqualsHandler(bindTo(type, 'equals'));
    this.pattern = type.pattern;
    this.$normalize = arrayHandler(bindTo(type, '$normalize'));
    this.name = type.name;
    this.$arrayMode = mode;
  }

  return new ArrayType(this, mode);
};



/**
 * @ngdoc object
 * @name ui.router.util.$urlMatcherFactory
 *
 * @description
 * Factory for {@link ui.router.util.type:UrlMatcher `UrlMatcher`} instances. The factory
 * is also available to providers under the name `$urlMatcherFactoryProvider`.
 */
function $UrlMatcherFactory() {
  $$UMFP = this;

  var isCaseInsensitive = false, isStrictMode = true, defaultSquashPolicy = false;

  // Use tildes to pre-encode slashes.
  // If the slashes are simply URLEncoded, the browser can choose to pre-decode them,
  // and bidirectional encoding/decoding fails.
  // Tilde was chosen because it's not a RFC 3986 section 2.2 Reserved Character
  function valToString(val) { return val != null ? val.toString().replace(/(~|\/)/g, function (m) { return {'~':'~~', '/':'~2F'}[m]; }) : val; }
  function valFromString(val) { return val != null ? val.toString().replace(/(~~|~2F)/g, function (m) { return {'~~':'~', '~2F':'/'}[m]; }) : val; }

  var $types = {}, enqueue = true, typeQueue = [], injector, defaultTypes = {
    "string": {
      encode: valToString,
      decode: valFromString,
      // TODO: in 1.0, make string .is() return false if value is undefined/null by default.
      // In 0.2.x, string params are optional by default for backwards compat
      is: function(val) { return val == null || !isDefined(val) || typeof val === "string"; },
      pattern: /[^/]*/
    },
    "int": {
      encode: valToString,
      decode: function(val) { return parseInt(val, 10); },
      is: function(val) { return val !== undefined && val !== null && this.decode(val.toString()) === val; },
      pattern: /\d+/
    },
    "bool": {
      encode: function(val) { return val ? 1 : 0; },
      decode: function(val) { return parseInt(val, 10) !== 0; },
      is: function(val) { return val === true || val === false; },
      pattern: /0|1/
    },
    "date": {
      encode: function (val) {
        if (!this.is(val))
          return undefined;
        return [ val.getFullYear(),
          ('0' + (val.getMonth() + 1)).slice(-2),
          ('0' + val.getDate()).slice(-2)
        ].join("-");
      },
      decode: function (val) {
        if (this.is(val)) return val;
        var match = this.capture.exec(val);
        return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
      },
      is: function(val) { return val instanceof Date && !isNaN(val.valueOf()); },
      equals: function (a, b) { return this.is(a) && this.is(b) && a.toISOString() === b.toISOString(); },
      pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
      capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
    },
    "json": {
      encode: angular.toJson,
      decode: angular.fromJson,
      is: angular.isObject,
      equals: angular.equals,
      pattern: /[^/]*/
    },
    "any": { // does not encode/decode
      encode: angular.identity,
      decode: angular.identity,
      equals: angular.equals,
      pattern: /.*/
    }
  };

  function getDefaultConfig() {
    return {
      strict: isStrictMode,
      caseInsensitive: isCaseInsensitive
    };
  }

  function isInjectable(value) {
    return (isFunction(value) || (isArray(value) && isFunction(value[value.length - 1])));
  }

  /**
   * [Internal] Get the default value of a parameter, which may be an injectable function.
   */
  $UrlMatcherFactory.$$getDefaultValue = function(config) {
    if (!isInjectable(config.value)) return config.value;
    if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
    return injector.invoke(config.value);
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#caseInsensitive
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Defines whether URL matching should be case sensitive (the default behavior), or not.
   *
   * @param {boolean} value `false` to match URL in a case sensitive manner; otherwise `true`;
   * @returns {boolean} the current value of caseInsensitive
   */
  this.caseInsensitive = function(value) {
    if (isDefined(value))
      isCaseInsensitive = value;
    return isCaseInsensitive;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#strictMode
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Defines whether URLs should match trailing slashes, or not (the default behavior).
   *
   * @param {boolean=} value `false` to match trailing slashes in URLs, otherwise `true`.
   * @returns {boolean} the current value of strictMode
   */
  this.strictMode = function(value) {
    if (isDefined(value))
      isStrictMode = value;
    return isStrictMode;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#defaultSquashPolicy
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Sets the default behavior when generating or matching URLs with default parameter values.
   *
   * @param {string} value A string that defines the default parameter URL squashing behavior.
   *    `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
   *    `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
   *             parameter is surrounded by slashes, squash (remove) one slash from the URL
   *    any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
   *             the parameter value from the URL and replace it with this string.
   */
  this.defaultSquashPolicy = function(value) {
    if (!isDefined(value)) return defaultSquashPolicy;
    if (value !== true && value !== false && !isString(value))
      throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
    defaultSquashPolicy = value;
    return value;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#compile
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Creates a {@link ui.router.util.type:UrlMatcher `UrlMatcher`} for the specified pattern.
   *
   * @param {string} pattern  The URL pattern.
   * @param {Object} config  The config object hash.
   * @returns {UrlMatcher}  The UrlMatcher.
   */
  this.compile = function (pattern, config) {
    return new UrlMatcher(pattern, extend(getDefaultConfig(), config));
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#isMatcher
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Returns true if the specified object is a `UrlMatcher`, or false otherwise.
   *
   * @param {Object} object  The object to perform the type check against.
   * @returns {Boolean}  Returns `true` if the object matches the `UrlMatcher` interface, by
   *          implementing all the same methods.
   */
  this.isMatcher = function (o) {
    if (!isObject(o)) return false;
    var result = true;

    forEach(UrlMatcher.prototype, function(val, name) {
      if (isFunction(val)) {
        result = result && (isDefined(o[name]) && isFunction(o[name]));
      }
    });
    return result;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#type
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Registers a custom {@link ui.router.util.type:Type `Type`} object that can be used to
   * generate URLs with typed parameters.
   *
   * @param {string} name  The type name.
   * @param {Object|Function} definition   The type definition. See
   *        {@link ui.router.util.type:Type `Type`} for information on the values accepted.
   * @param {Object|Function} definitionFn (optional) A function that is injected before the app
   *        runtime starts.  The result of this function is merged into the existing `definition`.
   *        See {@link ui.router.util.type:Type `Type`} for information on the values accepted.
   *
   * @returns {Object}  Returns `$urlMatcherFactoryProvider`.
   *
   * @example
   * This is a simple example of a custom type that encodes and decodes items from an
   * array, using the array index as the URL-encoded value:
   *
   * <pre>
   * var list = ['John', 'Paul', 'George', 'Ringo'];
   *
   * $urlMatcherFactoryProvider.type('listItem', {
   *   encode: function(item) {
   *     // Represent the list item in the URL using its corresponding index
   *     return list.indexOf(item);
   *   },
   *   decode: function(item) {
   *     // Look up the list item by index
   *     return list[parseInt(item, 10)];
   *   },
   *   is: function(item) {
   *     // Ensure the item is valid by checking to see that it appears
   *     // in the list
   *     return list.indexOf(item) > -1;
   *   }
   * });
   *
   * $stateProvider.state('list', {
   *   url: "/list/{item:listItem}",
   *   controller: function($scope, $stateParams) {
   *     console.log($stateParams.item);
   *   }
   * });
   *
   * // ...
   *
   * // Changes URL to '/list/3', logs "Ringo" to the console
   * $state.go('list', { item: "Ringo" });
   * </pre>
   *
   * This is a more complex example of a type that relies on dependency injection to
   * interact with services, and uses the parameter name from the URL to infer how to
   * handle encoding and decoding parameter values:
   *
   * <pre>
   * // Defines a custom type that gets a value from a service,
   * // where each service gets different types of values from
   * // a backend API:
   * $urlMatcherFactoryProvider.type('dbObject', {}, function(Users, Posts) {
   *
   *   // Matches up services to URL parameter names
   *   var services = {
   *     user: Users,
   *     post: Posts
   *   };
   *
   *   return {
   *     encode: function(object) {
   *       // Represent the object in the URL using its unique ID
   *       return object.id;
   *     },
   *     decode: function(value, key) {
   *       // Look up the object by ID, using the parameter
   *       // name (key) to call the correct service
   *       return services[key].findById(value);
   *     },
   *     is: function(object, key) {
   *       // Check that object is a valid dbObject
   *       return angular.isObject(object) && object.id && services[key];
   *     }
   *     equals: function(a, b) {
   *       // Check the equality of decoded objects by comparing
   *       // their unique IDs
   *       return a.id === b.id;
   *     }
   *   };
   * });
   *
   * // In a config() block, you can then attach URLs with
   * // type-annotated parameters:
   * $stateProvider.state('users', {
   *   url: "/users",
   *   // ...
   * }).state('users.item', {
   *   url: "/{user:dbObject}",
   *   controller: function($scope, $stateParams) {
   *     // $stateParams.user will now be an object returned from
   *     // the Users service
   *   },
   *   // ...
   * });
   * </pre>
   */
  this.type = function (name, definition, definitionFn) {
    if (!isDefined(definition)) return $types[name];
    if ($types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");

    $types[name] = new Type(extend({ name: name }, definition));
    if (definitionFn) {
      typeQueue.push({ name: name, def: definitionFn });
      if (!enqueue) flushTypeQueue();
    }
    return this;
  };

  // `flushTypeQueue()` waits until `$urlMatcherFactory` is injected before invoking the queued `definitionFn`s
  function flushTypeQueue() {
    while(typeQueue.length) {
      var type = typeQueue.shift();
      if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
      angular.extend($types[type.name], injector.invoke(type.def));
    }
  }

  // Register default types. Store them in the prototype of $types.
  forEach(defaultTypes, function(type, name) { $types[name] = new Type(extend({name: name}, type)); });
  $types = inherit($types, {});

  /* No need to document $get, since it returns this */
  this.$get = ['$injector', function ($injector) {
    injector = $injector;
    enqueue = false;
    flushTypeQueue();

    forEach(defaultTypes, function(type, name) {
      if (!$types[name]) $types[name] = new Type(type);
    });
    return this;
  }];

  this.Param = function Param(id, type, config, location) {
    var self = this;
    config = unwrapShorthand(config);
    type = getType(config, type, location);
    var arrayMode = getArrayMode();
    type = arrayMode ? type.$asArray(arrayMode, location === "search") : type;
    if (type.name === "string" && !arrayMode && location === "path" && config.value === undefined)
      config.value = ""; // for 0.2.x; in 0.3.0+ do not automatically default to ""
    var isOptional = config.value !== undefined;
    var squash = getSquashPolicy(config, isOptional);
    var replace = getReplace(config, arrayMode, isOptional, squash);

    function unwrapShorthand(config) {
      var keys = isObject(config) ? objectKeys(config) : [];
      var isShorthand = indexOf(keys, "value") === -1 && indexOf(keys, "type") === -1 &&
                        indexOf(keys, "squash") === -1 && indexOf(keys, "array") === -1;
      if (isShorthand) config = { value: config };
      config.$$fn = isInjectable(config.value) ? config.value : function () { return config.value; };
      return config;
    }

    function getType(config, urlType, location) {
      if (config.type && urlType) throw new Error("Param '"+id+"' has two type configurations.");
      if (urlType) return urlType;
      if (!config.type) return (location === "config" ? $types.any : $types.string);

      if (angular.isString(config.type))
        return $types[config.type];
      if (config.type instanceof Type)
        return config.type;
      return new Type(config.type);
    }

    // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
    function getArrayMode() {
      var arrayDefaults = { array: (location === "search" ? "auto" : false) };
      var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
      return extend(arrayDefaults, arrayParamNomenclature, config).array;
    }

    /**
     * returns false, true, or the squash value to indicate the "default parameter url squash policy".
     */
    function getSquashPolicy(config, isOptional) {
      var squash = config.squash;
      if (!isOptional || squash === false) return false;
      if (!isDefined(squash) || squash == null) return defaultSquashPolicy;
      if (squash === true || isString(squash)) return squash;
      throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
    }

    function getReplace(config, arrayMode, isOptional, squash) {
      var replace, configuredKeys, defaultPolicy = [
        { from: "",   to: (isOptional || arrayMode ? undefined : "") },
        { from: null, to: (isOptional || arrayMode ? undefined : "") }
      ];
      replace = isArray(config.replace) ? config.replace : [];
      if (isString(squash))
        replace.push({ from: squash, to: undefined });
      configuredKeys = map(replace, function(item) { return item.from; } );
      return filter(defaultPolicy, function(item) { return indexOf(configuredKeys, item.from) === -1; }).concat(replace);
    }

    /**
     * [Internal] Get the default value of a parameter, which may be an injectable function.
     */
    function $$getDefaultValue() {
      if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
      var defaultValue = injector.invoke(config.$$fn);
      if (defaultValue !== null && defaultValue !== undefined && !self.type.is(defaultValue))
        throw new Error("Default value (" + defaultValue + ") for parameter '" + self.id + "' is not an instance of Type (" + self.type.name + ")");
      return defaultValue;
    }

    /**
     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
     * default value, which may be the result of an injectable function.
     */
    function $value(value) {
      function hasReplaceVal(val) { return function(obj) { return obj.from === val; }; }
      function $replace(value) {
        var replacement = map(filter(self.replace, hasReplaceVal(value)), function(obj) { return obj.to; });
        return replacement.length ? replacement[0] : value;
      }
      value = $replace(value);
      return !isDefined(value) ? $$getDefaultValue() : self.type.$normalize(value);
    }

    function toString() { return "{Param:" + id + " " + type + " squash: '" + squash + "' optional: " + isOptional + "}"; }

    extend(this, {
      id: id,
      type: type,
      location: location,
      array: arrayMode,
      squash: squash,
      replace: replace,
      isOptional: isOptional,
      value: $value,
      dynamic: undefined,
      config: config,
      toString: toString
    });
  };

  function ParamSet(params) {
    extend(this, params || {});
  }

  ParamSet.prototype = {
    $$new: function() {
      return inherit(this, extend(new ParamSet(), { $$parent: this}));
    },
    $$keys: function () {
      var keys = [], chain = [], parent = this,
        ignore = objectKeys(ParamSet.prototype);
      while (parent) { chain.push(parent); parent = parent.$$parent; }
      chain.reverse();
      forEach(chain, function(paramset) {
        forEach(objectKeys(paramset), function(key) {
            if (indexOf(keys, key) === -1 && indexOf(ignore, key) === -1) keys.push(key);
        });
      });
      return keys;
    },
    $$values: function(paramValues) {
      var values = {}, self = this;
      forEach(self.$$keys(), function(key) {
        values[key] = self[key].value(paramValues && paramValues[key]);
      });
      return values;
    },
    $$equals: function(paramValues1, paramValues2) {
      var equal = true, self = this;
      forEach(self.$$keys(), function(key) {
        var left = paramValues1 && paramValues1[key], right = paramValues2 && paramValues2[key];
        if (!self[key].type.equals(left, right)) equal = false;
      });
      return equal;
    },
    $$validates: function $$validate(paramValues) {
      var keys = this.$$keys(), i, param, rawVal, normalized, encoded;
      for (i = 0; i < keys.length; i++) {
        param = this[keys[i]];
        rawVal = paramValues[keys[i]];
        if ((rawVal === undefined || rawVal === null) && param.isOptional)
          break; // There was no parameter value, but the param is optional
        normalized = param.type.$normalize(rawVal);
        if (!param.type.is(normalized))
          return false; // The value was not of the correct Type, and could not be decoded to the correct Type
        encoded = param.type.encode(normalized);
        if (angular.isString(encoded) && !param.type.pattern.exec(encoded))
          return false; // The value was of the correct type, but when encoded, did not match the Type's regexp
      }
      return true;
    },
    $$parent: undefined
  };

  this.ParamSet = ParamSet;
}

// Register as a provider so it's available to other providers
angular.module('ui.router.util').provider('$urlMatcherFactory', $UrlMatcherFactory);
angular.module('ui.router.util').run(['$urlMatcherFactory', function($urlMatcherFactory) { }]);

/**
 * @ngdoc object
 * @name ui.router.router.$urlRouterProvider
 *
 * @requires ui.router.util.$urlMatcherFactoryProvider
 * @requires $locationProvider
 *
 * @description
 * `$urlRouterProvider` has the responsibility of watching `$location`. 
 * When `$location` changes it runs through a list of rules one by one until a 
 * match is found. `$urlRouterProvider` is used behind the scenes anytime you specify 
 * a url in a state configuration. All urls are compiled into a UrlMatcher object.
 *
 * There are several methods on `$urlRouterProvider` that make it useful to use directly
 * in your module config.
 */
$UrlRouterProvider.$inject = ['$locationProvider', '$urlMatcherFactoryProvider'];
function $UrlRouterProvider(   $locationProvider,   $urlMatcherFactory) {
  var rules = [], otherwise = null, interceptDeferred = false, listener;

  // Returns a string that is a prefix of all strings matching the RegExp
  function regExpPrefix(re) {
    var prefix = /^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(re.source);
    return (prefix != null) ? prefix[1].replace(/\\(.)/g, "$1") : '';
  }

  // Interpolates matched values into a String.replace()-style pattern
  function interpolate(pattern, match) {
    return pattern.replace(/\$(\$|\d{1,2})/, function (m, what) {
      return match[what === '$' ? 0 : Number(what)];
    });
  }

  /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#rule
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Defines rules that are used by `$urlRouterProvider` to find matches for
   * specific URLs.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   // Here's an example of how you might allow case insensitive urls
   *   $urlRouterProvider.rule(function ($injector, $location) {
   *     var path = $location.path(),
   *         normalized = path.toLowerCase();
   *
   *     if (path !== normalized) {
   *       return normalized;
   *     }
   *   });
   * });
   * </pre>
   *
   * @param {function} rule Handler function that takes `$injector` and `$location`
   * services as arguments. You can use them to return a valid path as a string.
   *
   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
   */
  this.rule = function (rule) {
    if (!isFunction(rule)) throw new Error("'rule' must be a function");
    rules.push(rule);
    return this;
  };

  /**
   * @ngdoc object
   * @name ui.router.router.$urlRouterProvider#otherwise
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Defines a path that is used when an invalid route is requested.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   // if the path doesn't match any of the urls you configured
   *   // otherwise will take care of routing the user to the
   *   // specified url
   *   $urlRouterProvider.otherwise('/index');
   *
   *   // Example of using function rule as param
   *   $urlRouterProvider.otherwise(function ($injector, $location) {
   *     return '/a/valid/url';
   *   });
   * });
   * </pre>
   *
   * @param {string|function} rule The url path you want to redirect to or a function 
   * rule that returns the url path. The function version is passed two params: 
   * `$injector` and `$location` services, and must return a url string.
   *
   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
   */
  this.otherwise = function (rule) {
    if (isString(rule)) {
      var redirect = rule;
      rule = function () { return redirect; };
    }
    else if (!isFunction(rule)) throw new Error("'rule' must be a function");
    otherwise = rule;
    return this;
  };


  function handleIfMatch($injector, handler, match) {
    if (!match) return false;
    var result = $injector.invoke(handler, handler, { $match: match });
    return isDefined(result) ? result : true;
  }

  /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#when
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Registers a handler for a given url matching. 
   * 
   * If the handler is a string, it is
   * treated as a redirect, and is interpolated according to the syntax of match
   * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
   *
   * If the handler is a function, it is injectable. It gets invoked if `$location`
   * matches. You have the option of inject the match object as `$match`.
   *
   * The handler can return
   *
   * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
   *   will continue trying to find another one that matches.
   * - **string** which is treated as a redirect and passed to `$location.url()`
   * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
   *     if ($state.$current.navigable !== state ||
   *         !equalForKeys($match, $stateParams) {
   *      $state.transitionTo(state, $match, false);
   *     }
   *   });
   * });
   * </pre>
   *
   * @param {string|object} what The incoming path that you want to redirect.
   * @param {string|function} handler The path you want to redirect your user to.
   */
  this.when = function (what, handler) {
    var redirect, handlerIsString = isString(handler);
    if (isString(what)) what = $urlMatcherFactory.compile(what);

    if (!handlerIsString && !isFunction(handler) && !isArray(handler))
      throw new Error("invalid 'handler' in when()");

    var strategies = {
      matcher: function (what, handler) {
        if (handlerIsString) {
          redirect = $urlMatcherFactory.compile(handler);
          handler = ['$match', function ($match) { return redirect.format($match); }];
        }
        return extend(function ($injector, $location) {
          return handleIfMatch($injector, handler, what.exec($location.path(), $location.search()));
        }, {
          prefix: isString(what.prefix) ? what.prefix : ''
        });
      },
      regex: function (what, handler) {
        if (what.global || what.sticky) throw new Error("when() RegExp must not be global or sticky");

        if (handlerIsString) {
          redirect = handler;
          handler = ['$match', function ($match) { return interpolate(redirect, $match); }];
        }
        return extend(function ($injector, $location) {
          return handleIfMatch($injector, handler, what.exec($location.path()));
        }, {
          prefix: regExpPrefix(what)
        });
      }
    };

    var check = { matcher: $urlMatcherFactory.isMatcher(what), regex: what instanceof RegExp };

    for (var n in check) {
      if (check[n]) return this.rule(strategies[n](what, handler));
    }

    throw new Error("invalid 'what' in when()");
  };

  /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#deferIntercept
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Disables (or enables) deferring location change interception.
   *
   * If you wish to customize the behavior of syncing the URL (for example, if you wish to
   * defer a transition but maintain the current URL), call this method at configuration time.
   * Then, at run time, call `$urlRouter.listen()` after you have configured your own
   * `$locationChangeSuccess` event handler.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *
   *   // Prevent $urlRouter from automatically intercepting URL changes;
   *   // this allows you to configure custom behavior in between
   *   // location changes and route synchronization:
   *   $urlRouterProvider.deferIntercept();
   *
   * }).run(function ($rootScope, $urlRouter, UserService) {
   *
   *   $rootScope.$on('$locationChangeSuccess', function(e) {
   *     // UserService is an example service for managing user state
   *     if (UserService.isLoggedIn()) return;
   *
   *     // Prevent $urlRouter's default handler from firing
   *     e.preventDefault();
   *
   *     UserService.handleLogin().then(function() {
   *       // Once the user has logged in, sync the current URL
   *       // to the router:
   *       $urlRouter.sync();
   *     });
   *   });
   *
   *   // Configures $urlRouter's listener *after* your custom listener
   *   $urlRouter.listen();
   * });
   * </pre>
   *
   * @param {boolean} defer Indicates whether to defer location change interception. Passing
            no parameter is equivalent to `true`.
   */
  this.deferIntercept = function (defer) {
    if (defer === undefined) defer = true;
    interceptDeferred = defer;
  };

  /**
   * @ngdoc object
   * @name ui.router.router.$urlRouter
   *
   * @requires $location
   * @requires $rootScope
   * @requires $injector
   * @requires $browser
   *
   * @description
   *
   */
  this.$get = $get;
  $get.$inject = ['$location', '$rootScope', '$injector', '$browser', '$sniffer'];
  function $get(   $location,   $rootScope,   $injector,   $browser,   $sniffer) {

    var baseHref = $browser.baseHref(), location = $location.url(), lastPushedUrl;

    function appendBasePath(url, isHtml5, absolute) {
      if (baseHref === '/') return url;
      if (isHtml5) return baseHref.slice(0, -1) + url;
      if (absolute) return baseHref.slice(1) + url;
      return url;
    }

    // TODO: Optimize groups of rules with non-empty prefix into some sort of decision tree
    function update(evt) {
      if (evt && evt.defaultPrevented) return;
      var ignoreUpdate = lastPushedUrl && $location.url() === lastPushedUrl;
      lastPushedUrl = undefined;
      // TODO: Re-implement this in 1.0 for https://github.com/angular-ui/ui-router/issues/1573
      //if (ignoreUpdate) return true;

      function check(rule) {
        var handled = rule($injector, $location);

        if (!handled) return false;
        if (isString(handled)) $location.replace().url(handled);
        return true;
      }
      var n = rules.length, i;

      for (i = 0; i < n; i++) {
        if (check(rules[i])) return;
      }
      // always check otherwise last to allow dynamic updates to the set of rules
      if (otherwise) check(otherwise);
    }

    function listen() {
      listener = listener || $rootScope.$on('$locationChangeSuccess', update);
      return listener;
    }

    if (!interceptDeferred) listen();

    return {
      /**
       * @ngdoc function
       * @name ui.router.router.$urlRouter#sync
       * @methodOf ui.router.router.$urlRouter
       *
       * @description
       * Triggers an update; the same update that happens when the address bar url changes, aka `$locationChangeSuccess`.
       * This method is useful when you need to use `preventDefault()` on the `$locationChangeSuccess` event,
       * perform some custom logic (route protection, auth, config, redirection, etc) and then finally proceed
       * with the transition by calling `$urlRouter.sync()`.
       *
       * @example
       * <pre>
       * angular.module('app', ['ui.router'])
       *   .run(function($rootScope, $urlRouter) {
       *     $rootScope.$on('$locationChangeSuccess', function(evt) {
       *       // Halt state change from even starting
       *       evt.preventDefault();
       *       // Perform custom logic
       *       var meetsRequirement = ...
       *       // Continue with the update and state transition if logic allows
       *       if (meetsRequirement) $urlRouter.sync();
       *     });
       * });
       * </pre>
       */
      sync: function() {
        update();
      },

      listen: function() {
        return listen();
      },

      update: function(read) {
        if (read) {
          location = $location.url();
          return;
        }
        if ($location.url() === location) return;

        $location.url(location);
        $location.replace();
      },

      push: function(urlMatcher, params, options) {
         var url = urlMatcher.format(params || {});

        // Handle the special hash param, if needed
        if (url !== null && params && params['#']) {
            url += '#' + params['#'];
        }

        $location.url(url);
        lastPushedUrl = options && options.$$avoidResync ? $location.url() : undefined;
        if (options && options.replace) $location.replace();
      },

      /**
       * @ngdoc function
       * @name ui.router.router.$urlRouter#href
       * @methodOf ui.router.router.$urlRouter
       *
       * @description
       * A URL generation method that returns the compiled URL for a given
       * {@link ui.router.util.type:UrlMatcher `UrlMatcher`}, populated with the provided parameters.
       *
       * @example
       * <pre>
       * $bob = $urlRouter.href(new UrlMatcher("/about/:person"), {
       *   person: "bob"
       * });
       * // $bob == "/about/bob";
       * </pre>
       *
       * @param {UrlMatcher} urlMatcher The `UrlMatcher` object which is used as the template of the URL to generate.
       * @param {object=} params An object of parameter values to fill the matcher's required parameters.
       * @param {object=} options Options object. The options are:
       *
       * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
       *
       * @returns {string} Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
       */
      href: function(urlMatcher, params, options) {
        if (!urlMatcher.validates(params)) return null;

        var isHtml5 = $locationProvider.html5Mode();
        if (angular.isObject(isHtml5)) {
          isHtml5 = isHtml5.enabled;
        }

        isHtml5 = isHtml5 && $sniffer.history;
        
        var url = urlMatcher.format(params);
        options = options || {};

        if (!isHtml5 && url !== null) {
          url = "#" + $locationProvider.hashPrefix() + url;
        }

        // Handle special hash param, if needed
        if (url !== null && params && params['#']) {
          url += '#' + params['#'];
        }

        url = appendBasePath(url, isHtml5, options.absolute);

        if (!options.absolute || !url) {
          return url;
        }

        var slash = (!isHtml5 && url ? '/' : ''), port = $location.port();
        port = (port === 80 || port === 443 ? '' : ':' + port);

        return [$location.protocol(), '://', $location.host(), port, slash, url].join('');
      }
    };
  }
}

angular.module('ui.router.router').provider('$urlRouter', $UrlRouterProvider);

/**
 * @ngdoc object
 * @name ui.router.state.$stateProvider
 *
 * @requires ui.router.router.$urlRouterProvider
 * @requires ui.router.util.$urlMatcherFactoryProvider
 *
 * @description
 * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
 * on state.
 *
 * A state corresponds to a "place" in the application in terms of the overall UI and
 * navigation. A state describes (via the controller / template / view properties) what
 * the UI looks like and does at that place.
 *
 * States often have things in common, and the primary way of factoring out these
 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
 * nested states.
 *
 * The `$stateProvider` provides interfaces to declare these states for your app.
 */
$StateProvider.$inject = ['$urlRouterProvider', '$urlMatcherFactoryProvider'];
function $StateProvider(   $urlRouterProvider,   $urlMatcherFactory) {

  var root, states = {}, $state, queue = {}, abstractKey = 'abstract';

  // Builds state properties from definition passed to registerState()
  var stateBuilder = {

    // Derive parent state from a hierarchical name only if 'parent' is not explicitly defined.
    // state.children = [];
    // if (parent) parent.children.push(state);
    parent: function(state) {
      if (isDefined(state.parent) && state.parent) return findState(state.parent);
      // regex matches any valid composite state name
      // would match "contact.list" but not "contacts"
      var compositeName = /^(.+)\.[^.]+$/.exec(state.name);
      return compositeName ? findState(compositeName[1]) : root;
    },

    // inherit 'data' from parent and override by own values (if any)
    data: function(state) {
      if (state.parent && state.parent.data) {
        state.data = state.self.data = inherit(state.parent.data, state.data);
      }
      return state.data;
    },

    // Build a URLMatcher if necessary, either via a relative or absolute URL
    url: function(state) {
      var url = state.url, config = { params: state.params || {} };

      if (isString(url)) {
        if (url.charAt(0) == '^') return $urlMatcherFactory.compile(url.substring(1), config);
        return (state.parent.navigable || root).url.concat(url, config);
      }

      if (!url || $urlMatcherFactory.isMatcher(url)) return url;
      throw new Error("Invalid url '" + url + "' in state '" + state + "'");
    },

    // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
    navigable: function(state) {
      return state.url ? state : (state.parent ? state.parent.navigable : null);
    },

    // Own parameters for this state. state.url.params is already built at this point. Create and add non-url params
    ownParams: function(state) {
      var params = state.url && state.url.params || new $$UMFP.ParamSet();
      forEach(state.params || {}, function(config, id) {
        if (!params[id]) params[id] = new $$UMFP.Param(id, null, config, "config");
      });
      return params;
    },

    // Derive parameters for this state and ensure they're a super-set of parent's parameters
    params: function(state) {
      var ownParams = pick(state.ownParams, state.ownParams.$$keys());
      return state.parent && state.parent.params ? extend(state.parent.params.$$new(), ownParams) : new $$UMFP.ParamSet();
    },

    // If there is no explicit multi-view configuration, make one up so we don't have
    // to handle both cases in the view directive later. Note that having an explicit
    // 'views' property will mean the default unnamed view properties are ignored. This
    // is also a good time to resolve view names to absolute names, so everything is a
    // straight lookup at link time.
    views: function(state) {
      var views = {};

      forEach(isDefined(state.views) ? state.views : { '': state }, function (view, name) {
        if (name.indexOf('@') < 0) name += '@' + state.parent.name;
        view.resolveAs = view.resolveAs || state.resolveAs || '$resolve';
        views[name] = view;
      });
      return views;
    },

    // Keep a full path from the root down to this state as this is needed for state activation.
    path: function(state) {
      return state.parent ? state.parent.path.concat(state) : []; // exclude root from path
    },

    // Speed up $state.contains() as it's used a lot
    includes: function(state) {
      var includes = state.parent ? extend({}, state.parent.includes) : {};
      includes[state.name] = true;
      return includes;
    },

    $delegates: {}
  };

  function isRelative(stateName) {
    return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
  }

  function findState(stateOrName, base) {
    if (!stateOrName) return undefined;

    var isStr = isString(stateOrName),
        name  = isStr ? stateOrName : stateOrName.name,
        path  = isRelative(name);

    if (path) {
      if (!base) throw new Error("No reference point given for path '"  + name + "'");
      base = findState(base);
      
      var rel = name.split("."), i = 0, pathLength = rel.length, current = base;

      for (; i < pathLength; i++) {
        if (rel[i] === "" && i === 0) {
          current = base;
          continue;
        }
        if (rel[i] === "^") {
          if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + base.name + "'");
          current = current.parent;
          continue;
        }
        break;
      }
      rel = rel.slice(i).join(".");
      name = current.name + (current.name && rel ? "." : "") + rel;
    }
    var state = states[name];

    if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
      return state;
    }
    return undefined;
  }

  function queueState(parentName, state) {
    if (!queue[parentName]) {
      queue[parentName] = [];
    }
    queue[parentName].push(state);
  }

  function flushQueuedChildren(parentName) {
    var queued = queue[parentName] || [];
    while(queued.length) {
      registerState(queued.shift());
    }
  }

  function registerState(state) {
    // Wrap a new object around the state so we can store our private details easily.
    state = inherit(state, {
      self: state,
      resolve: state.resolve || {},
      toString: function() { return this.name; }
    });

    var name = state.name;
    if (!isString(name) || name.indexOf('@') >= 0) throw new Error("State must have a valid name");
    if (states.hasOwnProperty(name)) throw new Error("State '" + name + "' is already defined");

    // Get parent name
    var parentName = (name.indexOf('.') !== -1) ? name.substring(0, name.lastIndexOf('.'))
        : (isString(state.parent)) ? state.parent
        : (isObject(state.parent) && isString(state.parent.name)) ? state.parent.name
        : '';

    // If parent is not registered yet, add state to queue and register later
    if (parentName && !states[parentName]) {
      return queueState(parentName, state.self);
    }

    for (var key in stateBuilder) {
      if (isFunction(stateBuilder[key])) state[key] = stateBuilder[key](state, stateBuilder.$delegates[key]);
    }
    states[name] = state;

    // Register the state in the global state list and with $urlRouter if necessary.
    if (!state[abstractKey] && state.url) {
      $urlRouterProvider.when(state.url, ['$match', '$stateParams', function ($match, $stateParams) {
        if ($state.$current.navigable != state || !equalForKeys($match, $stateParams)) {
          $state.transitionTo(state, $match, { inherit: true, location: false });
        }
      }]);
    }

    // Register any queued children
    flushQueuedChildren(name);

    return state;
  }

  // Checks text to see if it looks like a glob.
  function isGlob (text) {
    return text.indexOf('*') > -1;
  }

  // Returns true if glob matches current $state name.
  function doesStateMatchGlob (glob) {
    var globSegments = glob.split('.'),
        segments = $state.$current.name.split('.');

    //match single stars
    for (var i = 0, l = globSegments.length; i < l; i++) {
      if (globSegments[i] === '*') {
        segments[i] = '*';
      }
    }

    //match greedy starts
    if (globSegments[0] === '**') {
       segments = segments.slice(indexOf(segments, globSegments[1]));
       segments.unshift('**');
    }
    //match greedy ends
    if (globSegments[globSegments.length - 1] === '**') {
       segments.splice(indexOf(segments, globSegments[globSegments.length - 2]) + 1, Number.MAX_VALUE);
       segments.push('**');
    }

    if (globSegments.length != segments.length) {
      return false;
    }

    return segments.join('') === globSegments.join('');
  }


  // Implicit root state that is always active
  root = registerState({
    name: '',
    url: '^',
    views: null,
    'abstract': true
  });
  root.navigable = null;


  /**
   * @ngdoc function
   * @name ui.router.state.$stateProvider#decorator
   * @methodOf ui.router.state.$stateProvider
   *
   * @description
   * Allows you to extend (carefully) or override (at your own peril) the 
   * `stateBuilder` object used internally by `$stateProvider`. This can be used 
   * to add custom functionality to ui-router, for example inferring templateUrl 
   * based on the state name.
   *
   * When passing only a name, it returns the current (original or decorated) builder
   * function that matches `name`.
   *
   * The builder functions that can be decorated are listed below. Though not all
   * necessarily have a good use case for decoration, that is up to you to decide.
   *
   * In addition, users can attach custom decorators, which will generate new 
   * properties within the state's internal definition. There is currently no clear 
   * use-case for this beyond accessing internal states (i.e. $state.$current), 
   * however, expect this to become increasingly relevant as we introduce additional 
   * meta-programming features.
   *
   * **Warning**: Decorators should not be interdependent because the order of 
   * execution of the builder functions in non-deterministic. Builder functions 
   * should only be dependent on the state definition object and super function.
   *
   *
   * Existing builder functions and current return values:
   *
   * - **parent** `{object}` - returns the parent state object.
   * - **data** `{object}` - returns state data, including any inherited data that is not
   *   overridden by own values (if any).
   * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
   *   or `null`.
   * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is 
   *   navigable).
   * - **params** `{object}` - returns an array of state params that are ensured to 
   *   be a super-set of parent's params.
   * - **views** `{object}` - returns a views object where each key is an absolute view 
   *   name (i.e. "viewName@stateName") and each value is the config object 
   *   (template, controller) for the view. Even when you don't use the views object 
   *   explicitly on a state config, one is still created for you internally.
   *   So by decorating this builder function you have access to decorating template 
   *   and controller properties.
   * - **ownParams** `{object}` - returns an array of params that belong to the state, 
   *   not including any params defined by ancestor states.
   * - **path** `{string}` - returns the full path from the root down to this state. 
   *   Needed for state activation.
   * - **includes** `{object}` - returns an object that includes every state that 
   *   would pass a `$state.includes()` test.
   *
   * @example
   * <pre>
   * // Override the internal 'views' builder with a function that takes the state
   * // definition, and a reference to the internal function being overridden:
   * $stateProvider.decorator('views', function (state, parent) {
   *   var result = {},
   *       views = parent(state);
   *
   *   angular.forEach(views, function (config, name) {
   *     var autoName = (state.name + '.' + name).replace('.', '/');
   *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
   *     result[name] = config;
   *   });
   *   return result;
   * });
   *
   * $stateProvider.state('home', {
   *   views: {
   *     'contact.list': { controller: 'ListController' },
   *     'contact.item': { controller: 'ItemController' }
   *   }
   * });
   *
   * // ...
   *
   * $state.go('home');
   * // Auto-populates list and item views with /partials/home/contact/list.html,
   * // and /partials/home/contact/item.html, respectively.
   * </pre>
   *
   * @param {string} name The name of the builder function to decorate. 
   * @param {object} func A function that is responsible for decorating the original 
   * builder function. The function receives two parameters:
   *
   *   - `{object}` - state - The state config object.
   *   - `{object}` - super - The original builder function.
   *
   * @return {object} $stateProvider - $stateProvider instance
   */
  this.decorator = decorator;
  function decorator(name, func) {
    /*jshint validthis: true */
    if (isString(name) && !isDefined(func)) {
      return stateBuilder[name];
    }
    if (!isFunction(func) || !isString(name)) {
      return this;
    }
    if (stateBuilder[name] && !stateBuilder.$delegates[name]) {
      stateBuilder.$delegates[name] = stateBuilder[name];
    }
    stateBuilder[name] = func;
    return this;
  }

  /**
   * @ngdoc function
   * @name ui.router.state.$stateProvider#state
   * @methodOf ui.router.state.$stateProvider
   *
   * @description
   * Registers a state configuration under a given state name. The stateConfig object
   * has the following acceptable properties.
   *
   * @param {string} name A unique state name, e.g. "home", "about", "contacts".
   * To create a parent/child state use a dot, e.g. "about.sales", "home.newest".
   * @param {object} stateConfig State configuration object.
   * @param {string|function=} stateConfig.template
   * <a id='template'></a>
   *   html template as a string or a function that returns
   *   an html template as a string which should be used by the uiView directives. This property 
   *   takes precedence over templateUrl.
   *   
   *   If `template` is a function, it will be called with the following parameters:
   *
   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by
   *     applying the current state
   *
   * <pre>template:
   *   "<h1>inline template definition</h1>" +
   *   "<div ui-view></div>"</pre>
   * <pre>template: function(params) {
   *       return "<h1>generated template</h1>"; }</pre>
   * </div>
   *
   * @param {string|function=} stateConfig.templateUrl
   * <a id='templateUrl'></a>
   *
   *   path or function that returns a path to an html
   *   template that should be used by uiView.
   *   
   *   If `templateUrl` is a function, it will be called with the following parameters:
   *
   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by 
   *     applying the current state
   *
   * <pre>templateUrl: "home.html"</pre>
   * <pre>templateUrl: function(params) {
   *     return myTemplates[params.pageId]; }</pre>
   *
   * @param {function=} stateConfig.templateProvider
   * <a id='templateProvider'></a>
   *    Provider function that returns HTML content string.
   * <pre> templateProvider:
   *       function(MyTemplateService, params) {
   *         return MyTemplateService.getTemplate(params.pageId);
   *       }</pre>
   *
   * @param {string|function=} stateConfig.controller
   * <a id='controller'></a>
   *
   *  Controller fn that should be associated with newly
   *   related scope or the name of a registered controller if passed as a string.
   *   Optionally, the ControllerAs may be declared here.
   * <pre>controller: "MyRegisteredController"</pre>
   * <pre>controller:
   *     "MyRegisteredController as fooCtrl"}</pre>
   * <pre>controller: function($scope, MyService) {
   *     $scope.data = MyService.getData(); }</pre>
   *
   * @param {function=} stateConfig.controllerProvider
   * <a id='controllerProvider'></a>
   *
   * Injectable provider function that returns the actual controller or string.
   * <pre>controllerProvider:
   *   function(MyResolveData) {
   *     if (MyResolveData.foo)
   *       return "FooCtrl"
   *     else if (MyResolveData.bar)
   *       return "BarCtrl";
   *     else return function($scope) {
   *       $scope.baz = "Qux";
   *     }
   *   }</pre>
   *
   * @param {string=} stateConfig.controllerAs
   * <a id='controllerAs'></a>
   * 
   * A controller alias name. If present the controller will be
   *   published to scope under the controllerAs name.
   * <pre>controllerAs: "myCtrl"</pre>
   *
   * @param {string|object=} stateConfig.parent
   * <a id='parent'></a>
   * Optionally specifies the parent state of this state.
   *
   * <pre>parent: 'parentState'</pre>
   * <pre>parent: parentState // JS variable</pre>
   *
   * @param {object=} stateConfig.resolve
   * <a id='resolve'></a>
   *
   * An optional map&lt;string, function&gt; of dependencies which
   *   should be injected into the controller. If any of these dependencies are promises, 
   *   the router will wait for them all to be resolved before the controller is instantiated.
   *   If all the promises are resolved successfully, the $stateChangeSuccess event is fired
   *   and the values of the resolved promises are injected into any controllers that reference them.
   *   If any  of the promises are rejected the $stateChangeError event is fired.
   *
   *   The map object is:
   *   
   *   - key - {string}: name of dependency to be injected into controller
   *   - factory - {string|function}: If string then it is alias for service. Otherwise if function, 
   *     it is injected and return value it treated as dependency. If result is a promise, it is 
   *     resolved before its value is injected into controller.
   *
   * <pre>resolve: {
   *     myResolve1:
   *       function($http, $stateParams) {
   *         return $http.get("/api/foos/"+stateParams.fooID);
   *       }
   *     }</pre>
   *
   * @param {string=} stateConfig.url
   * <a id='url'></a>
   *
   *   A url fragment with optional parameters. When a state is navigated or
   *   transitioned to, the `$stateParams` service will be populated with any 
   *   parameters that were passed.
   *
   *   (See {@link ui.router.util.type:UrlMatcher UrlMatcher} `UrlMatcher`} for
   *   more details on acceptable patterns )
   *
   * examples:
   * <pre>url: "/home"
   * url: "/users/:userid"
   * url: "/books/{bookid:[a-zA-Z_-]}"
   * url: "/books/{categoryid:int}"
   * url: "/books/{publishername:string}/{categoryid:int}"
   * url: "/messages?before&after"
   * url: "/messages?{before:date}&{after:date}"
   * url: "/messages/:mailboxid?{before:date}&{after:date}"
   * </pre>
   *
   * @param {object=} stateConfig.views
   * <a id='views'></a>
   * an optional map&lt;string, object&gt; which defined multiple views, or targets views
   * manually/explicitly.
   *
   * Examples:
   *
   * Targets three named `ui-view`s in the parent state's template
   * <pre>views: {
   *     header: {
   *       controller: "headerCtrl",
   *       templateUrl: "header.html"
   *     }, body: {
   *       controller: "bodyCtrl",
   *       templateUrl: "body.html"
   *     }, footer: {
   *       controller: "footCtrl",
   *       templateUrl: "footer.html"
   *     }
   *   }</pre>
   *
   * Targets named `ui-view="header"` from grandparent state 'top''s template, and named `ui-view="body" from parent state's template.
   * <pre>views: {
   *     'header@top': {
   *       controller: "msgHeaderCtrl",
   *       templateUrl: "msgHeader.html"
   *     }, 'body': {
   *       controller: "messagesCtrl",
   *       templateUrl: "messages.html"
   *     }
   *   }</pre>
   *
   * @param {boolean=} [stateConfig.abstract=false]
   * <a id='abstract'></a>
   * An abstract state will never be directly activated,
   *   but can provide inherited properties to its common children states.
   * <pre>abstract: true</pre>
   *
   * @param {function=} stateConfig.onEnter
   * <a id='onEnter'></a>
   *
   * Callback function for when a state is entered. Good way
   *   to trigger an action or dispatch an event, such as opening a dialog.
   * If minifying your scripts, make sure to explicitly annotate this function,
   * because it won't be automatically annotated by your build tools.
   *
   * <pre>onEnter: function(MyService, $stateParams) {
   *     MyService.foo($stateParams.myParam);
   * }</pre>
   *
   * @param {function=} stateConfig.onExit
   * <a id='onExit'></a>
   *
   * Callback function for when a state is exited. Good way to
   *   trigger an action or dispatch an event, such as opening a dialog.
   * If minifying your scripts, make sure to explicitly annotate this function,
   * because it won't be automatically annotated by your build tools.
   *
   * <pre>onExit: function(MyService, $stateParams) {
   *     MyService.cleanup($stateParams.myParam);
   * }</pre>
   *
   * @param {boolean=} [stateConfig.reloadOnSearch=true]
   * <a id='reloadOnSearch'></a>
   *
   * If `false`, will not retrigger the same state
   *   just because a search/query parameter has changed (via $location.search() or $location.hash()). 
   *   Useful for when you'd like to modify $location.search() without triggering a reload.
   * <pre>reloadOnSearch: false</pre>
   *
   * @param {object=} stateConfig.data
   * <a id='data'></a>
   *
   * Arbitrary data object, useful for custom configuration.  The parent state's `data` is
   *   prototypally inherited.  In other words, adding a data property to a state adds it to
   *   the entire subtree via prototypal inheritance.
   *
   * <pre>data: {
   *     requiredRole: 'foo'
   * } </pre>
   *
   * @param {object=} stateConfig.params
   * <a id='params'></a>
   *
   * A map which optionally configures parameters declared in the `url`, or
   *   defines additional non-url parameters.  For each parameter being
   *   configured, add a configuration object keyed to the name of the parameter.
   *
   *   Each parameter configuration object may contain the following properties:
   *
   *   - ** value ** - {object|function=}: specifies the default value for this
   *     parameter.  This implicitly sets this parameter as optional.
   *
   *     When UI-Router routes to a state and no value is
   *     specified for this parameter in the URL or transition, the
   *     default value will be used instead.  If `value` is a function,
   *     it will be injected and invoked, and the return value used.
   *
   *     *Note*: `undefined` is treated as "no default value" while `null`
   *     is treated as "the default value is `null`".
   *
   *     *Shorthand*: If you only need to configure the default value of the
   *     parameter, you may use a shorthand syntax.   In the **`params`**
   *     map, instead mapping the param name to a full parameter configuration
   *     object, simply set map it to the default parameter value, e.g.:
   *
   * <pre>// define a parameter's default value
   * params: {
   *     param1: { value: "defaultValue" }
   * }
   * // shorthand default values
   * params: {
   *     param1: "defaultValue",
   *     param2: "param2Default"
   * }</pre>
   *
   *   - ** array ** - {boolean=}: *(default: false)* If true, the param value will be
   *     treated as an array of values.  If you specified a Type, the value will be
   *     treated as an array of the specified Type.  Note: query parameter values
   *     default to a special `"auto"` mode.
   *
   *     For query parameters in `"auto"` mode, if multiple  values for a single parameter
   *     are present in the URL (e.g.: `/foo?bar=1&bar=2&bar=3`) then the values
   *     are mapped to an array (e.g.: `{ foo: [ '1', '2', '3' ] }`).  However, if
   *     only one value is present (e.g.: `/foo?bar=1`) then the value is treated as single
   *     value (e.g.: `{ foo: '1' }`).
   *
   * <pre>params: {
   *     param1: { array: true }
   * }</pre>
   *
   *   - ** squash ** - {bool|string=}: `squash` configures how a default parameter value is represented in the URL when
   *     the current parameter value is the same as the default value. If `squash` is not set, it uses the
   *     configured default squash policy.
   *     (See {@link ui.router.util.$urlMatcherFactory#methods_defaultSquashPolicy `defaultSquashPolicy()`})
   *
   *   There are three squash settings:
   *
   *     - false: The parameter's default value is not squashed.  It is encoded and included in the URL
   *     - true: The parameter's default value is omitted from the URL.  If the parameter is preceeded and followed
   *       by slashes in the state's `url` declaration, then one of those slashes are omitted.
   *       This can allow for cleaner looking URLs.
   *     - `"<arbitrary string>"`: The parameter's default value is replaced with an arbitrary placeholder of  your choice.
   *
   * <pre>params: {
   *     param1: {
   *       value: "defaultId",
   *       squash: true
   * } }
   * // squash "defaultValue" to "~"
   * params: {
   *     param1: {
   *       value: "defaultValue",
   *       squash: "~"
   * } }
   * </pre>
   *
   *
   * @example
   * <pre>
   * // Some state name examples
   *
   * // stateName can be a single top-level name (must be unique).
   * $stateProvider.state("home", {});
   *
   * // Or it can be a nested state name. This state is a child of the
   * // above "home" state.
   * $stateProvider.state("home.newest", {});
   *
   * // Nest states as deeply as needed.
   * $stateProvider.state("home.newest.abc.xyz.inception", {});
   *
   * // state() returns $stateProvider, so you can chain state declarations.
   * $stateProvider
   *   .state("home", {})
   *   .state("about", {})
   *   .state("contacts", {});
   * </pre>
   *
   */
  this.state = state;
  function state(name, definition) {
    /*jshint validthis: true */
    if (isObject(name)) definition = name;
    else definition.name = name;
    registerState(definition);
    return this;
  }

  /**
   * @ngdoc object
   * @name ui.router.state.$state
   *
   * @requires $rootScope
   * @requires $q
   * @requires ui.router.state.$view
   * @requires $injector
   * @requires ui.router.util.$resolve
   * @requires ui.router.state.$stateParams
   * @requires ui.router.router.$urlRouter
   *
   * @property {object} params A param object, e.g. {sectionId: section.id)}, that 
   * you'd like to test against the current active state.
   * @property {object} current A reference to the state's config object. However 
   * you passed it in. Useful for accessing custom data.
   * @property {object} transition Currently pending transition. A promise that'll 
   * resolve or reject.
   *
   * @description
   * `$state` service is responsible for representing states as well as transitioning
   * between them. It also provides interfaces to ask for current state or even states
   * you're coming from.
   */
  this.$get = $get;
  $get.$inject = ['$rootScope', '$q', '$view', '$injector', '$resolve', '$stateParams', '$urlRouter', '$location', '$urlMatcherFactory'];
  function $get(   $rootScope,   $q,   $view,   $injector,   $resolve,   $stateParams,   $urlRouter,   $location,   $urlMatcherFactory) {

    var TransitionSupersededError = new Error('transition superseded');

    var TransitionSuperseded = silenceUncaughtInPromise($q.reject(TransitionSupersededError));
    var TransitionPrevented = silenceUncaughtInPromise($q.reject(new Error('transition prevented')));
    var TransitionAborted = silenceUncaughtInPromise($q.reject(new Error('transition aborted')));
    var TransitionFailed = silenceUncaughtInPromise($q.reject(new Error('transition failed')));

    // Handles the case where a state which is the target of a transition is not found, and the user
    // can optionally retry or defer the transition
    function handleRedirect(redirect, state, params, options) {
      /**
       * @ngdoc event
       * @name ui.router.state.$state#$stateNotFound
       * @eventOf ui.router.state.$state
       * @eventType broadcast on root scope
       * @description
       * Fired when a requested state **cannot be found** using the provided state name during transition.
       * The event is broadcast allowing any handlers a single chance to deal with the error (usually by
       * lazy-loading the unfound state). A special `unfoundState` object is passed to the listener handler,
       * you can see its three properties in the example. You can use `event.preventDefault()` to abort the
       * transition and the promise returned from `go` will be rejected with a `'transition aborted'` value.
       *
       * @param {Object} event Event object.
       * @param {Object} unfoundState Unfound State information. Contains: `to, toParams, options` properties.
       * @param {State} fromState Current state object.
       * @param {Object} fromParams Current state params.
       *
       * @example
       *
       * <pre>
       * // somewhere, assume lazy.state has not been defined
       * $state.go("lazy.state", {a:1, b:2}, {inherit:false});
       *
       * // somewhere else
       * $scope.$on('$stateNotFound',
       * function(event, unfoundState, fromState, fromParams){
       *     console.log(unfoundState.to); // "lazy.state"
       *     console.log(unfoundState.toParams); // {a:1, b:2}
       *     console.log(unfoundState.options); // {inherit:false} + default options
       * })
       * </pre>
       */
      var evt = $rootScope.$broadcast('$stateNotFound', redirect, state, params);

      if (evt.defaultPrevented) {
        $urlRouter.update();
        return TransitionAborted;
      }

      if (!evt.retry) {
        return null;
      }

      // Allow the handler to return a promise to defer state lookup retry
      if (options.$retry) {
        $urlRouter.update();
        return TransitionFailed;
      }
      var retryTransition = $state.transition = $q.when(evt.retry);

      retryTransition.then(function() {
        if (retryTransition !== $state.transition) {
          $rootScope.$broadcast('$stateChangeCancel', redirect.to, redirect.toParams, state, params);
          return TransitionSuperseded;
        }
        redirect.options.$retry = true;
        return $state.transitionTo(redirect.to, redirect.toParams, redirect.options);
      }, function() {
        return TransitionAborted;
      });
      $urlRouter.update();

      return retryTransition;
    }

    root.locals = { resolve: null, globals: { $stateParams: {} } };

    $state = {
      params: {},
      current: root.self,
      $current: root,
      transition: null
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#reload
     * @methodOf ui.router.state.$state
     *
     * @description
     * A method that force reloads the current state. All resolves are re-resolved,
     * controllers reinstantiated, and events re-fired.
     *
     * @example
     * <pre>
     * var app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     $state.reload();
     *   }
     * });
     * </pre>
     *
     * `reload()` is just an alias for:
     * <pre>
     * $state.transitionTo($state.current, $stateParams, { 
     *   reload: true, inherit: false, notify: true
     * });
     * </pre>
     *
     * @param {string=|object=} state - A state name or a state object, which is the root of the resolves to be re-resolved.
     * @example
     * <pre>
     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item' 
     * //and current state is 'contacts.detail.item'
     * var app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     //will reload 'contact.detail' and 'contact.detail.item' states
     *     $state.reload('contact.detail');
     *   }
     * });
     * </pre>
     *
     * `reload()` is just an alias for:
     * <pre>
     * $state.transitionTo($state.current, $stateParams, { 
     *   reload: true, inherit: false, notify: true
     * });
     * </pre>

     * @returns {promise} A promise representing the state of the new transition. See
     * {@link ui.router.state.$state#methods_go $state.go}.
     */
    $state.reload = function reload(state) {
      return $state.transitionTo($state.current, $stateParams, { reload: state || true, inherit: false, notify: true});
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#go
     * @methodOf ui.router.state.$state
     *
     * @description
     * Convenience method for transitioning to a new state. `$state.go` calls 
     * `$state.transitionTo` internally but automatically sets options to 
     * `{ location: true, inherit: true, relative: $state.$current, notify: true }`. 
     * This allows you to easily use an absolute or relative to path and specify 
     * only the parameters you'd like to update (while letting unspecified parameters 
     * inherit from the currently active ancestor states).
     *
     * @example
     * <pre>
     * var app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.go('contact.detail');
     *   };
     * });
     * </pre>
     * <img src='../ngdoc_assets/StateGoExamples.png'/>
     *
     * @param {string} to Absolute state name or relative state path. Some examples:
     *
     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
     * - `$state.go('^')` - will go to a parent state
     * - `$state.go('^.sibling')` - will go to a sibling state
     * - `$state.go('.child.grandchild')` - will go to grandchild state
     *
     * @param {object=} params A map of the parameters that will be sent to the state, 
     * will populate $stateParams. Any parameters that are not specified will be inherited from currently 
     * defined parameters. Only parameters specified in the state definition can be overridden, new 
     * parameters will be ignored. This allows, for example, going to a sibling state that shares parameters
     * specified in a parent state. Parameter inheritance only works between common ancestor states, I.e.
     * transitioning to a sibling will get you the parameters for all parents, transitioning to a child
     * will get you all current parameters, etc.
     * @param {object=} options Options object. The options are:
     *
     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
     * - **`reload`** (v0.2.5) - {boolean=false|string|object}, If `true` will force transition even if no state or params
     *    have changed.  It will reload the resolves and views of the current state and parent states.
     *    If `reload` is a string (or state object), the state object is fetched (by name, or object reference); and \
     *    the transition reloads the resolves and views for that matched state, and all its children states.
     *
     * @returns {promise} A promise representing the state of the new transition.
     *
     * Possible success values:
     *
     * - $state.current
     *
     * <br/>Possible rejection values:
     *
     * - 'transition superseded' - when a newer transition has been started after this one
     * - 'transition prevented' - when `event.preventDefault()` has been called in a `$stateChangeStart` listener
     * - 'transition aborted' - when `event.preventDefault()` has been called in a `$stateNotFound` listener or
     *   when a `$stateNotFound` `event.retry` promise errors.
     * - 'transition failed' - when a state has been unsuccessfully found after 2 tries.
     * - *resolve error* - when an error has occurred with a `resolve`
     *
     */
    $state.go = function go(to, params, options) {
      return $state.transitionTo(to, params, extend({ inherit: true, relative: $state.$current }, options));
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#transitionTo
     * @methodOf ui.router.state.$state
     *
     * @description
     * Low-level method for transitioning to a new state. {@link ui.router.state.$state#methods_go $state.go}
     * uses `transitionTo` internally. `$state.go` is recommended in most situations.
     *
     * @example
     * <pre>
     * var app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.transitionTo('contact.detail');
     *   };
     * });
     * </pre>
     *
     * @param {string} to State name.
     * @param {object=} toParams A map of the parameters that will be sent to the state,
     * will populate $stateParams.
     * @param {object=} options Options object. The options are:
     *
     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
     * - **`inherit`** - {boolean=false}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
     * - **`reload`** (v0.2.5) - {boolean=false|string=|object=}, If `true` will force transition even if the state or params 
     *    have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd
     *    use this when you want to force a reload when *everything* is the same, including search params.
     *    if String, then will reload the state with the name given in reload, and any children.
     *    if Object, then a stateObj is expected, will reload the state found in stateObj, and any children.
     *
     * @returns {promise} A promise representing the state of the new transition. See
     * {@link ui.router.state.$state#methods_go $state.go}.
     */
    $state.transitionTo = function transitionTo(to, toParams, options) {
      toParams = toParams || {};
      options = extend({
        location: true, inherit: false, relative: null, notify: true, reload: false, $retry: false
      }, options || {});

      var from = $state.$current, fromParams = $state.params, fromPath = from.path;
      var evt, toState = findState(to, options.relative);

      // Store the hash param for later (since it will be stripped out by various methods)
      var hash = toParams['#'];

      if (!isDefined(toState)) {
        var redirect = { to: to, toParams: toParams, options: options };
        var redirectResult = handleRedirect(redirect, from.self, fromParams, options);

        if (redirectResult) {
          return redirectResult;
        }

        // Always retry once if the $stateNotFound was not prevented
        // (handles either redirect changed or state lazy-definition)
        to = redirect.to;
        toParams = redirect.toParams;
        options = redirect.options;
        toState = findState(to, options.relative);

        if (!isDefined(toState)) {
          if (!options.relative) throw new Error("No such state '" + to + "'");
          throw new Error("Could not resolve '" + to + "' from state '" + options.relative + "'");
        }
      }
      if (toState[abstractKey]) throw new Error("Cannot transition to abstract state '" + to + "'");
      if (options.inherit) toParams = inheritParams($stateParams, toParams || {}, $state.$current, toState);
      if (!toState.params.$$validates(toParams)) return TransitionFailed;

      toParams = toState.params.$$values(toParams);
      to = toState;

      var toPath = to.path;

      // Starting from the root of the path, keep all levels that haven't changed
      var keep = 0, state = toPath[keep], locals = root.locals, toLocals = [];

      if (!options.reload) {
        while (state && state === fromPath[keep] && state.ownParams.$$equals(toParams, fromParams)) {
          locals = toLocals[keep] = state.locals;
          keep++;
          state = toPath[keep];
        }
      } else if (isString(options.reload) || isObject(options.reload)) {
        if (isObject(options.reload) && !options.reload.name) {
          throw new Error('Invalid reload state object');
        }
        
        var reloadState = options.reload === true ? fromPath[0] : findState(options.reload);
        if (options.reload && !reloadState) {
          throw new Error("No such reload state '" + (isString(options.reload) ? options.reload : options.reload.name) + "'");
        }

        while (state && state === fromPath[keep] && state !== reloadState) {
          locals = toLocals[keep] = state.locals;
          keep++;
          state = toPath[keep];
        }
      }

      // If we're going to the same state and all locals are kept, we've got nothing to do.
      // But clear 'transition', as we still want to cancel any other pending transitions.
      // TODO: We may not want to bump 'transition' if we're called from a location change
      // that we've initiated ourselves, because we might accidentally abort a legitimate
      // transition initiated from code?
      if (shouldSkipReload(to, toParams, from, fromParams, locals, options)) {
        if (hash) toParams['#'] = hash;
        $state.params = toParams;
        copy($state.params, $stateParams);
        copy(filterByKeys(to.params.$$keys(), $stateParams), to.locals.globals.$stateParams);
        if (options.location && to.navigable && to.navigable.url) {
          $urlRouter.push(to.navigable.url, toParams, {
            $$avoidResync: true, replace: options.location === 'replace'
          });
          $urlRouter.update(true);
        }
        $state.transition = null;
        return $q.when($state.current);
      }

      // Filter parameters before we pass them to event handlers etc.
      toParams = filterByKeys(to.params.$$keys(), toParams || {});
      
      // Re-add the saved hash before we start returning things or broadcasting $stateChangeStart
      if (hash) toParams['#'] = hash;
      
      // Broadcast start event and cancel the transition if requested
      if (options.notify) {
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeStart
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired when the state transition **begins**. You can use `event.preventDefault()`
         * to prevent the transition from happening and then the transition promise will be
         * rejected with a `'transition prevented'` value.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         *
         * @example
         *
         * <pre>
         * $rootScope.$on('$stateChangeStart',
         * function(event, toState, toParams, fromState, fromParams){
         *     event.preventDefault();
         *     // transitionTo() promise will be rejected with
         *     // a 'transition prevented' error
         * })
         * </pre>
         */
        if ($rootScope.$broadcast('$stateChangeStart', to.self, toParams, from.self, fromParams, options).defaultPrevented) {
          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
          //Don't update and resync url if there's been a new transition started. see issue #2238, #600
          if ($state.transition == null) $urlRouter.update();
          return TransitionPrevented;
        }
      }

      // Resolve locals for the remaining states, but don't update any global state just
      // yet -- if anything fails to resolve the current state needs to remain untouched.
      // We also set up an inheritance chain for the locals here. This allows the view directive
      // to quickly look up the correct definition for each view in the current state. Even
      // though we create the locals object itself outside resolveState(), it is initially
      // empty and gets filled asynchronously. We need to keep track of the promise for the
      // (fully resolved) current locals, and pass this down the chain.
      var resolved = $q.when(locals);

      for (var l = keep; l < toPath.length; l++, state = toPath[l]) {
        locals = toLocals[l] = inherit(locals);
        resolved = resolveState(state, toParams, state === to, resolved, locals, options);
      }

      // Once everything is resolved, we are ready to perform the actual transition
      // and return a promise for the new state. We also keep track of what the
      // current promise is, so that we can detect overlapping transitions and
      // keep only the outcome of the last transition.
      var transition = $state.transition = resolved.then(function () {
        var l, entering, exiting;

        if ($state.transition !== transition) {
          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
          return TransitionSuperseded;
        }

        // Exit 'from' states not kept
        for (l = fromPath.length - 1; l >= keep; l--) {
          exiting = fromPath[l];
          if (exiting.self.onExit) {
            $injector.invoke(exiting.self.onExit, exiting.self, exiting.locals.globals);
          }
          exiting.locals = null;
        }

        // Enter 'to' states not kept
        for (l = keep; l < toPath.length; l++) {
          entering = toPath[l];
          entering.locals = toLocals[l];
          if (entering.self.onEnter) {
            $injector.invoke(entering.self.onEnter, entering.self, entering.locals.globals);
          }
        }

        // Run it again, to catch any transitions in callbacks
        if ($state.transition !== transition) {
          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
          return TransitionSuperseded;
        }

        // Update globals in $state
        $state.$current = to;
        $state.current = to.self;
        $state.params = toParams;
        copy($state.params, $stateParams);
        $state.transition = null;

        if (options.location && to.navigable) {
          $urlRouter.push(to.navigable.url, to.navigable.locals.globals.$stateParams, {
            $$avoidResync: true, replace: options.location === 'replace'
          });
        }

        if (options.notify) {
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeSuccess
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired once the state transition is **complete**.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         */
          $rootScope.$broadcast('$stateChangeSuccess', to.self, toParams, from.self, fromParams);
        }
        $urlRouter.update(true);

        return $state.current;
      }).then(null, function (error) {
        // propagate TransitionSuperseded error without emitting $stateChangeCancel
        // as it was already emitted in the success handler above
        if (error === TransitionSupersededError) return TransitionSuperseded;

        if ($state.transition !== transition) {
          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
          return TransitionSuperseded;
        }

        $state.transition = null;
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeError
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired when an **error occurs** during transition. It's important to note that if you
         * have any errors in your resolve functions (javascript errors, non-existent services, etc)
         * they will not throw traditionally. You must listen for this $stateChangeError event to
         * catch **ALL** errors.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         * @param {Error} error The resolve error object.
         */
        evt = $rootScope.$broadcast('$stateChangeError', to.self, toParams, from.self, fromParams, error);

        if (!evt.defaultPrevented) {
          $urlRouter.update();
        }

        return $q.reject(error);
      });

      silenceUncaughtInPromise(transition);
      return transition;
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#is
     * @methodOf ui.router.state.$state
     *
     * @description
     * Similar to {@link ui.router.state.$state#methods_includes $state.includes},
     * but only checks for the full state name. If params is supplied then it will be
     * tested for strict equality against the current active params object, so all params
     * must match with none missing and no extras.
     *
     * @example
     * <pre>
     * $state.$current.name = 'contacts.details.item';
     *
     * // absolute name
     * $state.is('contact.details.item'); // returns true
     * $state.is(contactDetailItemStateObject); // returns true
     *
     * // relative name (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
     * </pre>
     *
     * @param {string|object} stateOrName The state name (absolute or relative) or state object you'd like to check.
     * @param {object=} params A param object, e.g. `{sectionId: section.id}`, that you'd like
     * to test against the current active state.
     * @param {object=} options An options object.  The options are:
     *
     * - **`relative`** - {string|object} -  If `stateOrName` is a relative state name and `options.relative` is set, .is will
     * test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it is the state.
     */
    $state.is = function is(stateOrName, params, options) {
      options = extend({ relative: $state.$current }, options || {});
      var state = findState(stateOrName, options.relative);

      if (!isDefined(state)) { return undefined; }
      if ($state.$current !== state) { return false; }

      return !params || objectKeys(params).reduce(function(acc, key) {
        var paramDef = state.params[key];
        return acc && !paramDef || paramDef.type.equals($stateParams[key], params[key]);
      }, true);
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#includes
     * @methodOf ui.router.state.$state
     *
     * @description
     * A method to determine if the current active state is equal to or is the child of the
     * state stateName. If any params are passed then they will be tested for a match as well.
     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
     *
     * @example
     * Partial and relative names
     * <pre>
     * $state.$current.name = 'contacts.details.item';
     *
     * // Using partial names
     * $state.includes("contacts"); // returns true
     * $state.includes("contacts.details"); // returns true
     * $state.includes("contacts.details.item"); // returns true
     * $state.includes("contacts.list"); // returns false
     * $state.includes("about"); // returns false
     *
     * // Using relative names (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * <div ng-class="{highlighted: $state.includes('.item')}">Item</div>
     * </pre>
     *
     * Basic globbing patterns
     * <pre>
     * $state.$current.name = 'contacts.details.item.url';
     *
     * $state.includes("*.details.*.*"); // returns true
     * $state.includes("*.details.**"); // returns true
     * $state.includes("**.item.**"); // returns true
     * $state.includes("*.details.item.url"); // returns true
     * $state.includes("*.details.*.url"); // returns true
     * $state.includes("*.details.*"); // returns false
     * $state.includes("item.**"); // returns false
     * </pre>
     *
     * @param {string} stateOrName A partial name, relative name, or glob pattern
     * to be searched for within the current state name.
     * @param {object=} params A param object, e.g. `{sectionId: section.id}`,
     * that you'd like to test against the current active state.
     * @param {object=} options An options object.  The options are:
     *
     * - **`relative`** - {string|object=} -  If `stateOrName` is a relative state reference and `options.relative` is set,
     * .includes will test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it does include the state
     */
    $state.includes = function includes(stateOrName, params, options) {
      options = extend({ relative: $state.$current }, options || {});
      if (isString(stateOrName) && isGlob(stateOrName)) {
        if (!doesStateMatchGlob(stateOrName)) {
          return false;
        }
        stateOrName = $state.$current.name;
      }

      var state = findState(stateOrName, options.relative);
      if (!isDefined(state)) { return undefined; }
      if (!isDefined($state.$current.includes[state.name])) { return false; }
      if (!params) { return true; }

      var keys = objectKeys(params);
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i], paramDef = state.params[key];
        if (paramDef && !paramDef.type.equals($stateParams[key], params[key])) {
          return false;
        }
      }

      return objectKeys(params).reduce(function(acc, key) {
        var paramDef = state.params[key];
        return acc && !paramDef || paramDef.type.equals($stateParams[key], params[key]);
      }, true);
    };


    /**
     * @ngdoc function
     * @name ui.router.state.$state#href
     * @methodOf ui.router.state.$state
     *
     * @description
     * A url generation method that returns the compiled url for the given state populated with the given params.
     *
     * @example
     * <pre>
     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
     * </pre>
     *
     * @param {string|object} stateOrName The state name or state object you'd like to generate a url from.
     * @param {object=} params An object of parameter values to fill the state's required parameters.
     * @param {object=} options Options object. The options are:
     *
     * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
     *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
     *    ancestor with a valid url).
     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
     * 
     * @returns {string} compiled state url
     */
    $state.href = function href(stateOrName, params, options) {
      options = extend({
        lossy:    true,
        inherit:  true,
        absolute: false,
        relative: $state.$current
      }, options || {});

      var state = findState(stateOrName, options.relative);

      if (!isDefined(state)) return null;
      if (options.inherit) params = inheritParams($stateParams, params || {}, $state.$current, state);
      
      var nav = (state && options.lossy) ? state.navigable : state;

      if (!nav || nav.url === undefined || nav.url === null) {
        return null;
      }
      return $urlRouter.href(nav.url, filterByKeys(state.params.$$keys().concat('#'), params || {}), {
        absolute: options.absolute
      });
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#get
     * @methodOf ui.router.state.$state
     *
     * @description
     * Returns the state configuration object for any specific state or all states.
     *
     * @param {string|object=} stateOrName (absolute or relative) If provided, will only get the config for
     * the requested state. If not provided, returns an array of ALL state configs.
     * @param {string|object=} context When stateOrName is a relative state reference, the state will be retrieved relative to context.
     * @returns {Object|Array} State configuration object or array of all objects.
     */
    $state.get = function (stateOrName, context) {
      if (arguments.length === 0) return map(objectKeys(states), function(name) { return states[name].self; });
      var state = findState(stateOrName, context || $state.$current);
      return (state && state.self) ? state.self : null;
    };

    function resolveState(state, params, paramsAreFiltered, inherited, dst, options) {
      // Make a restricted $stateParams with only the parameters that apply to this state if
      // necessary. In addition to being available to the controller and onEnter/onExit callbacks,
      // we also need $stateParams to be available for any $injector calls we make during the
      // dependency resolution process.
      var $stateParams = (paramsAreFiltered) ? params : filterByKeys(state.params.$$keys(), params);
      var locals = { $stateParams: $stateParams };

      // Resolve 'global' dependencies for the state, i.e. those not specific to a view.
      // We're also including $stateParams in this; that way the parameters are restricted
      // to the set that should be visible to the state, and are independent of when we update
      // the global $state and $stateParams values.
      dst.resolve = $resolve.resolve(state.resolve, locals, dst.resolve, state);
      var promises = [dst.resolve.then(function (globals) {
        dst.globals = globals;
      })];
      if (inherited) promises.push(inherited);

      function resolveViews() {
        var viewsPromises = [];

        // Resolve template and dependencies for all views.
        forEach(state.views, function (view, name) {
          var injectables = (view.resolve && view.resolve !== state.resolve ? view.resolve : {});
          injectables.$template = [ function () {
            return $view.load(name, { view: view, locals: dst.globals, params: $stateParams, notify: options.notify }) || '';
          }];

          viewsPromises.push($resolve.resolve(injectables, dst.globals, dst.resolve, state).then(function (result) {
            // References to the controller (only instantiated at link time)
            if (isFunction(view.controllerProvider) || isArray(view.controllerProvider)) {
              var injectLocals = angular.extend({}, injectables, dst.globals);
              result.$$controller = $injector.invoke(view.controllerProvider, null, injectLocals);
            } else {
              result.$$controller = view.controller;
            }
            // Provide access to the state itself for internal use
            result.$$state = state;
            result.$$controllerAs = view.controllerAs;
            result.$$resolveAs = view.resolveAs;
            dst[name] = result;
          }));
        });

        return $q.all(viewsPromises).then(function(){
          return dst.globals;
        });
      }

      // Wait for all the promises and then return the activation object
      return $q.all(promises).then(resolveViews).then(function (values) {
        return dst;
      });
    }

    return $state;
  }

  function shouldSkipReload(to, toParams, from, fromParams, locals, options) {
    // Return true if there are no differences in non-search (path/object) params, false if there are differences
    function nonSearchParamsEqual(fromAndToState, fromParams, toParams) {
      // Identify whether all the parameters that differ between `fromParams` and `toParams` were search params.
      function notSearchParam(key) {
        return fromAndToState.params[key].location != "search";
      }
      var nonQueryParamKeys = fromAndToState.params.$$keys().filter(notSearchParam);
      var nonQueryParams = pick.apply({}, [fromAndToState.params].concat(nonQueryParamKeys));
      var nonQueryParamSet = new $$UMFP.ParamSet(nonQueryParams);
      return nonQueryParamSet.$$equals(fromParams, toParams);
    }

    // If reload was not explicitly requested
    // and we're transitioning to the same state we're already in
    // and    the locals didn't change
    //     or they changed in a way that doesn't merit reloading
    //        (reloadOnParams:false, or reloadOnSearch.false and only search params changed)
    // Then return true.
    if (!options.reload && to === from &&
      (locals === from.locals || (to.self.reloadOnSearch === false && nonSearchParamsEqual(from, fromParams, toParams)))) {
      return true;
    }
  }
}

angular.module('ui.router.state')
  .factory('$stateParams', function () { return {}; })
  .constant("$state.runtime", { autoinject: true })
  .provider('$state', $StateProvider)
  // Inject $state to initialize when entering runtime. #2574
  .run(['$injector', function ($injector) {
    // Allow tests (stateSpec.js) to turn this off by defining this constant
    if ($injector.get("$state.runtime").autoinject) {
      $injector.get('$state');
    }
  }]);


$ViewProvider.$inject = [];
function $ViewProvider() {

  this.$get = $get;
  /**
   * @ngdoc object
   * @name ui.router.state.$view
   *
   * @requires ui.router.util.$templateFactory
   * @requires $rootScope
   *
   * @description
   *
   */
  $get.$inject = ['$rootScope', '$templateFactory'];
  function $get(   $rootScope,   $templateFactory) {
    return {
      // $view.load('full.viewName', { template: ..., controller: ..., resolve: ..., async: false, params: ... })
      /**
       * @ngdoc function
       * @name ui.router.state.$view#load
       * @methodOf ui.router.state.$view
       *
       * @description
       *
       * @param {string} name name
       * @param {object} options option object.
       */
      load: function load(name, options) {
        var result, defaults = {
          template: null, controller: null, view: null, locals: null, notify: true, async: true, params: {}
        };
        options = extend(defaults, options);

        if (options.view) {
          result = $templateFactory.fromConfig(options.view, options.params, options.locals);
        }
        return result;
      }
    };
  }
}

angular.module('ui.router.state').provider('$view', $ViewProvider);

/**
 * @ngdoc object
 * @name ui.router.state.$uiViewScrollProvider
 *
 * @description
 * Provider that returns the {@link ui.router.state.$uiViewScroll} service function.
 */
function $ViewScrollProvider() {

  var useAnchorScroll = false;

  /**
   * @ngdoc function
   * @name ui.router.state.$uiViewScrollProvider#useAnchorScroll
   * @methodOf ui.router.state.$uiViewScrollProvider
   *
   * @description
   * Reverts back to using the core [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll) service for
   * scrolling based on the url anchor.
   */
  this.useAnchorScroll = function () {
    useAnchorScroll = true;
  };

  /**
   * @ngdoc object
   * @name ui.router.state.$uiViewScroll
   *
   * @requires $anchorScroll
   * @requires $timeout
   *
   * @description
   * When called with a jqLite element, it scrolls the element into view (after a
   * `$timeout` so the DOM has time to refresh).
   *
   * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
   * this can be enabled by calling {@link ui.router.state.$uiViewScrollProvider#methods_useAnchorScroll `$uiViewScrollProvider.useAnchorScroll()`}.
   */
  this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
    if (useAnchorScroll) {
      return $anchorScroll;
    }

    return function ($element) {
      return $timeout(function () {
        $element[0].scrollIntoView();
      }, 0, false);
    };
  }];
}

angular.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-view
 *
 * @requires ui.router.state.$state
 * @requires $compile
 * @requires $controller
 * @requires $injector
 * @requires ui.router.state.$uiViewScroll
 * @requires $document
 *
 * @restrict ECA
 *
 * @description
 * The ui-view directive tells $state where to place your templates.
 *
 * @param {string=} name A view name. The name should be unique amongst the other views in the
 * same state. You can have views of the same name that live in different states.
 *
 * @param {string=} autoscroll It allows you to set the scroll behavior of the browser window
 * when a view is populated. By default, $anchorScroll is overridden by ui-router's custom scroll
 * service, {@link ui.router.state.$uiViewScroll}. This custom service let's you
 * scroll ui-view elements into view when they are populated during a state activation.
 *
 * *Note: To revert back to old [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll)
 * functionality, call `$uiViewScrollProvider.useAnchorScroll()`.*
 *
 * @param {string=} onload Expression to evaluate whenever the view updates.
 *
 * @example
 * A view can be unnamed or named.
 * <pre>
 * <!-- Unnamed -->
 * <div ui-view></div>
 *
 * <!-- Named -->
 * <div ui-view="viewName"></div>
 * </pre>
 *
 * You can only have one unnamed view within any template (or root html). If you are only using a
 * single view and it is unnamed then you can populate it like so:
 * <pre>
 * <div ui-view></div>
 * $stateProvider.state("home", {
 *   template: "<h1>HELLO!</h1>"
 * })
 * </pre>
 *
 * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#methods_state `views`}
 * config property, by name, in this case an empty name:
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "": {
 *       template: "<h1>HELLO!</h1>"
 *     }
 *   }    
 * })
 * </pre>
 *
 * But typically you'll only use the views property if you name your view or have more than one view
 * in the same template. There's not really a compelling reason to name a view if its the only one,
 * but you could if you wanted, like so:
 * <pre>
 * <div ui-view="main"></div>
 * </pre>
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "main": {
 *       template: "<h1>HELLO!</h1>"
 *     }
 *   }    
 * })
 * </pre>
 *
 * Really though, you'll use views to set up multiple views:
 * <pre>
 * <div ui-view></div>
 * <div ui-view="chart"></div>
 * <div ui-view="data"></div>
 * </pre>
 *
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "": {
 *       template: "<h1>HELLO!</h1>"
 *     },
 *     "chart": {
 *       template: "<chart_thing/>"
 *     },
 *     "data": {
 *       template: "<data_thing/>"
 *     }
 *   }    
 * })
 * </pre>
 *
 * Examples for `autoscroll`:
 *
 * <pre>
 * <!-- If autoscroll present with no expression,
 *      then scroll ui-view into view -->
 * <ui-view autoscroll/>
 *
 * <!-- If autoscroll present with valid expression,
 *      then scroll ui-view into view if expression evaluates to true -->
 * <ui-view autoscroll='true'/>
 * <ui-view autoscroll='false'/>
 * <ui-view autoscroll='scopeVariable'/>
 * </pre>
 *
 * Resolve data:
 *
 * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
 * can be customized using [[ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
 *
 * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
 * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
 * depends on `$resolve` data.
 *
 * Example usage of $resolve in a view template
 * <pre>
 * $stateProvider.state('home', {
 *   template: '<my-component user="$resolve.user"></my-component>',
 *   resolve: {
 *     user: function(UserService) { return UserService.fetchUser(); }
 *   }
 * });
 * </pre>
 */
$ViewDirective.$inject = ['$state', '$injector', '$uiViewScroll', '$interpolate', '$q'];
function $ViewDirective(   $state,   $injector,   $uiViewScroll,   $interpolate,   $q) {

  function getService() {
    return ($injector.has) ? function(service) {
      return $injector.has(service) ? $injector.get(service) : null;
    } : function(service) {
      try {
        return $injector.get(service);
      } catch (e) {
        return null;
      }
    };
  }

  var service = getService(),
      $animator = service('$animator'),
      $animate = service('$animate');

  // Returns a set of DOM manipulation functions based on which Angular version
  // it should use
  function getRenderer(attrs, scope) {
    var statics = function() {
      return {
        enter: function (element, target, cb) { target.after(element); cb(); },
        leave: function (element, cb) { element.remove(); cb(); }
      };
    };

    if ($animate) {
      return {
        enter: function(element, target, cb) {
          if (angular.version.minor > 2) {
            $animate.enter(element, null, target).then(cb);
          } else {
            $animate.enter(element, null, target, cb);
          }
        },
        leave: function(element, cb) {
          if (angular.version.minor > 2) {
            $animate.leave(element).then(cb);
          } else {
            $animate.leave(element, cb);
          }
        }
      };
    }

    if ($animator) {
      var animate = $animator && $animator(scope, attrs);

      return {
        enter: function(element, target, cb) {animate.enter(element, null, target); cb(); },
        leave: function(element, cb) { animate.leave(element); cb(); }
      };
    }

    return statics();
  }

  var directive = {
    restrict: 'ECA',
    terminal: true,
    priority: 400,
    transclude: 'element',
    compile: function (tElement, tAttrs, $transclude) {
      return function (scope, $element, attrs) {
        var previousEl, currentEl, currentScope, latestLocals,
            onloadExp     = attrs.onload || '',
            autoScrollExp = attrs.autoscroll,
            renderer      = getRenderer(attrs, scope),
            inherited     = $element.inheritedData('$uiView');

        scope.$on('$stateChangeSuccess', function() {
          updateView(false);
        });

        updateView(true);

        function cleanupLastView() {
          if (previousEl) {
            previousEl.remove();
            previousEl = null;
          }

          if (currentScope) {
            currentScope.$destroy();
            currentScope = null;
          }

          if (currentEl) {
            var $uiViewData = currentEl.data('$uiViewAnim');
            renderer.leave(currentEl, function() {
              $uiViewData.$$animLeave.resolve();
              previousEl = null;
            });

            previousEl = currentEl;
            currentEl = null;
          }
        }

        function updateView(firstTime) {
          var newScope,
              name            = getUiViewName(scope, attrs, $element, $interpolate),
              previousLocals  = name && $state.$current && $state.$current.locals[name];

          if (!firstTime && previousLocals === latestLocals) return; // nothing to do
          newScope = scope.$new();
          latestLocals = $state.$current.locals[name];

          /**
           * @ngdoc event
           * @name ui.router.state.directive:ui-view#$viewContentLoading
           * @eventOf ui.router.state.directive:ui-view
           * @eventType emits on ui-view directive scope
           * @description
           *
           * Fired once the view **begins loading**, *before* the DOM is rendered.
           *
           * @param {Object} event Event object.
           * @param {string} viewName Name of the view.
           */
          newScope.$emit('$viewContentLoading', name);

          var clone = $transclude(newScope, function(clone) {
            var animEnter = $q.defer(), animLeave = $q.defer();
            var viewAnimData = {
              $animEnter: animEnter.promise,
              $animLeave: animLeave.promise,
              $$animLeave: animLeave
            };

            clone.data('$uiViewAnim', viewAnimData);
            renderer.enter(clone, $element, function onUiViewEnter() {
              animEnter.resolve();
              if(currentScope) {
                currentScope.$emit('$viewContentAnimationEnded');
              }

              if (angular.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
                $uiViewScroll(clone);
              }
            });
            cleanupLastView();
          });

          currentEl = clone;
          currentScope = newScope;
          /**
           * @ngdoc event
           * @name ui.router.state.directive:ui-view#$viewContentLoaded
           * @eventOf ui.router.state.directive:ui-view
           * @eventType emits on ui-view directive scope
           * @description
           * Fired once the view is **loaded**, *after* the DOM is rendered.
           *
           * @param {Object} event Event object.
           * @param {string} viewName Name of the view.
           */
          currentScope.$emit('$viewContentLoaded', name);
          currentScope.$eval(onloadExp);
        }
      };
    }
  };

  return directive;
}

$ViewDirectiveFill.$inject = ['$compile', '$controller', '$state', '$interpolate'];
function $ViewDirectiveFill (  $compile,   $controller,   $state,   $interpolate) {
  return {
    restrict: 'ECA',
    priority: -400,
    compile: function (tElement) {
      var initial = tElement.html();
      if (tElement.empty) {
        tElement.empty();
      } else {
        // ng 1.0.0 doesn't have empty(), which cleans up data and handlers
        tElement[0].innerHTML = null;
      }

      return function (scope, $element, attrs) {
        var current = $state.$current,
            name = getUiViewName(scope, attrs, $element, $interpolate),
            locals  = current && current.locals[name];

        if (! locals) {
          $element.html(initial);
          $compile($element.contents())(scope);
          return;
        }

        $element.data('$uiView', { name: name, state: locals.$$state });
        $element.html(locals.$template ? locals.$template : initial);

        var resolveData = angular.extend({}, locals);
        scope[locals.$$resolveAs] = resolveData;

        var link = $compile($element.contents());

        if (locals.$$controller) {
          locals.$scope = scope;
          locals.$element = $element;
          var controller = $controller(locals.$$controller, locals);
          if (locals.$$controllerAs) {
            scope[locals.$$controllerAs] = controller;
            scope[locals.$$controllerAs][locals.$$resolveAs] = resolveData;
          }
          if (isFunction(controller.$onInit)) controller.$onInit();
          $element.data('$ngControllerController', controller);
          $element.children().data('$ngControllerController', controller);
        }

        link(scope);
      };
    }
  };
}

/**
 * Shared ui-view code for both directives:
 * Given scope, element, and its attributes, return the view's name
 */
function getUiViewName(scope, attrs, element, $interpolate) {
  var name = $interpolate(attrs.uiView || attrs.name || '')(scope);
  var uiViewCreatedBy = element.inheritedData('$uiView');
  return name.indexOf('@') >= 0 ?  name :  (name + '@' + (uiViewCreatedBy ? uiViewCreatedBy.state.name : ''));
}

angular.module('ui.router.state').directive('uiView', $ViewDirective);
angular.module('ui.router.state').directive('uiView', $ViewDirectiveFill);

function parseStateRef(ref, current) {
  var preparsed = ref.match(/^\s*({[^}]*})\s*$/), parsed;
  if (preparsed) ref = current + '(' + preparsed[1] + ')';
  parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
  if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
  return { state: parsed[1], paramExpr: parsed[3] || null };
}

function stateContext(el) {
  var stateData = el.parent().inheritedData('$uiView');

  if (stateData && stateData.state && stateData.state.name) {
    return stateData.state;
  }
}

function getTypeInfo(el) {
  // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
  var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
  var isForm = el[0].nodeName === "FORM";

  return {
    attr: isForm ? "action" : (isSvg ? 'xlink:href' : 'href'),
    isAnchor: el.prop("tagName").toUpperCase() === "A",
    clickable: !isForm
  };
}

function clickHook(el, $state, $timeout, type, current) {
  return function(e) {
    var button = e.which || e.button, target = current();

    if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
      // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
      var transition = $timeout(function() {
        $state.go(target.state, target.params, target.options);
      });
      e.preventDefault();

      // if the state has no URL, ignore one preventDefault from the <a> directive.
      var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1: 0;

      e.preventDefault = function() {
        if (ignorePreventDefaultCount-- <= 0) $timeout.cancel(transition);
      };
    }
  };
}

function defaultOpts(el, $state) {
  return { relative: stateContext(el) || $state.$current, inherit: true };
}

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref
 *
 * @requires ui.router.state.$state
 * @requires $timeout
 *
 * @restrict A
 *
 * @description
 * A directive that binds a link (`<a>` tag) to a state. If the state has an associated
 * URL, the directive will automatically generate & update the `href` attribute via
 * the {@link ui.router.state.$state#methods_href $state.href()} method. Clicking
 * the link will trigger a state transition with optional parameters.
 *
 * Also middle-clicking, right-clicking, and ctrl-clicking on the link will be
 * handled natively by the browser.
 *
 * You can also use relative state paths within ui-sref, just like the relative
 * paths passed to `$state.go()`. You just need to be aware that the path is relative
 * to the state that the link lives in, in other words the state that loaded the
 * template containing the link.
 *
 * You can specify options to pass to {@link ui.router.state.$state#methods_go $state.go()}
 * using the `ui-sref-opts` attribute. Options are restricted to `location`, `inherit`,
 * and `reload`.
 *
 * @example
 * Here's an example of how you'd use ui-sref and how it would compile. If you have the
 * following template:
 * <pre>
 * <a ui-sref="home">Home</a> | <a ui-sref="about">About</a> | <a ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
 *     </li>
 * </ul>
 * </pre>
 *
 * Then the compiled html would be (assuming Html5Mode is off and current state is contacts):
 * <pre>
 * <a href="#/home" ui-sref="home">Home</a> | <a href="#/about" ui-sref="about">About</a> | <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
 *     </li>
 * </ul>
 *
 * <a ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
 * </pre>
 *
 * @param {string} ui-sref 'stateName' can be any valid absolute or relative state
 * @param {Object} ui-sref-opts options to pass to {@link ui.router.state.$state#methods_go $state.go()}
 */
$StateRefDirective.$inject = ['$state', '$timeout'];
function $StateRefDirective($state, $timeout) {
  return {
    restrict: 'A',
    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
    link: function(scope, element, attrs, uiSrefActive) {
      var ref    = parseStateRef(attrs.uiSref, $state.current.name);
      var def    = { state: ref.state, href: null, params: null };
      var type   = getTypeInfo(element);
      var active = uiSrefActive[1] || uiSrefActive[0];
      var unlinkInfoFn = null;
      var hookFn;

      def.options = extend(defaultOpts(element, $state), attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {});

      var update = function(val) {
        if (val) def.params = angular.copy(val);
        def.href = $state.href(ref.state, def.params, def.options);

        if (unlinkInfoFn) unlinkInfoFn();
        if (active) unlinkInfoFn = active.$$addStateInfo(ref.state, def.params);
        if (def.href !== null) attrs.$set(type.attr, def.href);
      };

      if (ref.paramExpr) {
        scope.$watch(ref.paramExpr, function(val) { if (val !== def.params) update(val); }, true);
        def.params = angular.copy(scope.$eval(ref.paramExpr));
      }
      update();

      if (!type.clickable) return;
      hookFn = clickHook(element, $state, $timeout, type, function() { return def; });
      element[element.on ? 'on' : 'bind']("click", hookFn);
      scope.$on('$destroy', function() {
        element[element.off ? 'off' : 'unbind']("click", hookFn);
      });
    }
  };
}

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-state
 *
 * @requires ui.router.state.uiSref
 *
 * @restrict A
 *
 * @description
 * Much like ui-sref, but will accept named $scope properties to evaluate for a state definition,
 * params and override options.
 *
 * @param {string} ui-state 'stateName' can be any valid absolute or relative state
 * @param {Object} ui-state-params params to pass to {@link ui.router.state.$state#methods_href $state.href()}
 * @param {Object} ui-state-opts options to pass to {@link ui.router.state.$state#methods_go $state.go()}
 */
$StateRefDynamicDirective.$inject = ['$state', '$timeout'];
function $StateRefDynamicDirective($state, $timeout) {
  return {
    restrict: 'A',
    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
    link: function(scope, element, attrs, uiSrefActive) {
      var type   = getTypeInfo(element);
      var active = uiSrefActive[1] || uiSrefActive[0];
      var group  = [attrs.uiState, attrs.uiStateParams || null, attrs.uiStateOpts || null];
      var watch  = '[' + group.map(function(val) { return val || 'null'; }).join(', ') + ']';
      var def    = { state: null, params: null, options: null, href: null };
      var unlinkInfoFn = null;
      var hookFn;

      function runStateRefLink (group) {
        def.state = group[0]; def.params = group[1]; def.options = group[2];
        def.href = $state.href(def.state, def.params, def.options);

        if (unlinkInfoFn) unlinkInfoFn();
        if (active) unlinkInfoFn = active.$$addStateInfo(def.state, def.params);
        if (def.href) attrs.$set(type.attr, def.href);
      }

      scope.$watch(watch, runStateRefLink, true);
      runStateRefLink(scope.$eval(watch));

      if (!type.clickable) return;
      hookFn = clickHook(element, $state, $timeout, type, function() { return def; });
      element[element.on ? 'on' : 'bind']("click", hookFn);
      scope.$on('$destroy', function() {
        element[element.off ? 'off' : 'unbind']("click", hookFn);
      });
    }
  };
}


/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref-active
 *
 * @requires ui.router.state.$state
 * @requires ui.router.state.$stateParams
 * @requires $interpolate
 *
 * @restrict A
 *
 * @description
 * A directive working alongside ui-sref to add classes to an element when the
 * related ui-sref directive's state is active, and removing them when it is inactive.
 * The primary use-case is to simplify the special appearance of navigation menus
 * relying on `ui-sref`, by having the "active" state's menu button appear different,
 * distinguishing it from the inactive menu items.
 *
 * ui-sref-active can live on the same element as ui-sref or on a parent element. The first
 * ui-sref-active found at the same level or above the ui-sref will be used.
 *
 * Will activate when the ui-sref's target state or any child state is active. If you
 * need to activate only when the ui-sref target state is active and *not* any of
 * it's children, then you will use
 * {@link ui.router.state.directive:ui-sref-active-eq ui-sref-active-eq}
 *
 * @example
 * Given the following template:
 * <pre>
 * <ul>
 *   <li ui-sref-active="active" class="item">
 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
 *   </li>
 * </ul>
 * </pre>
 *
 *
 * When the app state is "app.user" (or any children states), and contains the state parameter "user" with value "bilbobaggins",
 * the resulting HTML will appear as (note the 'active' class):
 * <pre>
 * <ul>
 *   <li ui-sref-active="active" class="item active">
 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
 *   </li>
 * </ul>
 * </pre>
 *
 * The class name is interpolated **once** during the directives link time (any further changes to the
 * interpolated value are ignored).
 *
 * Multiple classes may be specified in a space-separated format:
 * <pre>
 * <ul>
 *   <li ui-sref-active='class1 class2 class3'>
 *     <a ui-sref="app.user">link</a>
 *   </li>
 * </ul>
 * </pre>
 *
 * It is also possible to pass ui-sref-active an expression that evaluates
 * to an object hash, whose keys represent active class names and whose
 * values represent the respective state names/globs.
 * ui-sref-active will match if the current active state **includes** any of
 * the specified state names/globs, even the abstract ones.
 *
 * @Example
 * Given the following template, with "admin" being an abstract state:
 * <pre>
 * <div ui-sref-active="{'active': 'admin.*'}">
 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
 * </div>
 * </pre>
 *
 * When the current state is "admin.roles" the "active" class will be applied
 * to both the <div> and <a> elements. It is important to note that the state
 * names/globs passed to ui-sref-active shadow the state provided by ui-sref.
 */

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref-active-eq
 *
 * @requires ui.router.state.$state
 * @requires ui.router.state.$stateParams
 * @requires $interpolate
 *
 * @restrict A
 *
 * @description
 * The same as {@link ui.router.state.directive:ui-sref-active ui-sref-active} but will only activate
 * when the exact target state used in the `ui-sref` is active; no child states.
 *
 */
$StateRefActiveDirective.$inject = ['$state', '$stateParams', '$interpolate'];
function $StateRefActiveDirective($state, $stateParams, $interpolate) {
  return  {
    restrict: "A",
    controller: ['$scope', '$element', '$attrs', '$timeout', function ($scope, $element, $attrs, $timeout) {
      var states = [], activeClasses = {}, activeEqClass, uiSrefActive;

      // There probably isn't much point in $observing this
      // uiSrefActive and uiSrefActiveEq share the same directive object with some
      // slight difference in logic routing
      activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);

      try {
        uiSrefActive = $scope.$eval($attrs.uiSrefActive);
      } catch (e) {
        // Do nothing. uiSrefActive is not a valid expression.
        // Fall back to using $interpolate below
      }
      uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
      if (isObject(uiSrefActive)) {
        forEach(uiSrefActive, function(stateOrName, activeClass) {
          if (isString(stateOrName)) {
            var ref = parseStateRef(stateOrName, $state.current.name);
            addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
          }
        });
      }

      // Allow uiSref to communicate with uiSrefActive[Equals]
      this.$$addStateInfo = function (newState, newParams) {
        // we already got an explicit state provided by ui-sref-active, so we
        // shadow the one that comes from ui-sref
        if (isObject(uiSrefActive) && states.length > 0) {
          return;
        }
        var deregister = addState(newState, newParams, uiSrefActive);
        update();
        return deregister;
      };

      $scope.$on('$stateChangeSuccess', update);

      function addState(stateName, stateParams, activeClass) {
        var state = $state.get(stateName, stateContext($element));
        var stateHash = createStateHash(stateName, stateParams);

        var stateInfo = {
          state: state || { name: stateName },
          params: stateParams,
          hash: stateHash
        };

        states.push(stateInfo);
        activeClasses[stateHash] = activeClass;

        return function removeState() {
          var idx = states.indexOf(stateInfo);
          if (idx !== -1) states.splice(idx, 1);
        };
      }

      /**
       * @param {string} state
       * @param {Object|string} [params]
       * @return {string}
       */
      function createStateHash(state, params) {
        if (!isString(state)) {
          throw new Error('state should be a string');
        }
        if (isObject(params)) {
          return state + toJson(params);
        }
        params = $scope.$eval(params);
        if (isObject(params)) {
          return state + toJson(params);
        }
        return state;
      }

      // Update route state
      function update() {
        for (var i = 0; i < states.length; i++) {
          if (anyMatch(states[i].state, states[i].params)) {
            addClass($element, activeClasses[states[i].hash]);
          } else {
            removeClass($element, activeClasses[states[i].hash]);
          }

          if (exactMatch(states[i].state, states[i].params)) {
            addClass($element, activeEqClass);
          } else {
            removeClass($element, activeEqClass);
          }
        }
      }

      function addClass(el, className) { $timeout(function () { el.addClass(className); }); }
      function removeClass(el, className) { el.removeClass(className); }
      function anyMatch(state, params) { return $state.includes(state.name, params); }
      function exactMatch(state, params) { return $state.is(state.name, params); }

      update();
    }]
  };
}

angular.module('ui.router.state')
  .directive('uiSref', $StateRefDirective)
  .directive('uiSrefActive', $StateRefActiveDirective)
  .directive('uiSrefActiveEq', $StateRefActiveDirective)
  .directive('uiState', $StateRefDynamicDirective);

/**
 * @ngdoc filter
 * @name ui.router.state.filter:isState
 *
 * @requires ui.router.state.$state
 *
 * @description
 * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
 */
$IsStateFilter.$inject = ['$state'];
function $IsStateFilter($state) {
  var isFilter = function (state, params) {
    return $state.is(state, params);
  };
  isFilter.$stateful = true;
  return isFilter;
}

/**
 * @ngdoc filter
 * @name ui.router.state.filter:includedByState
 *
 * @requires ui.router.state.$state
 *
 * @description
 * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
 */
$IncludedByStateFilter.$inject = ['$state'];
function $IncludedByStateFilter($state) {
  var includesFilter = function (state, params, options) {
    return $state.includes(state, params, options);
  };
  includesFilter.$stateful = true;
  return  includesFilter;
}

angular.module('ui.router.state')
  .filter('isState', $IsStateFilter)
  .filter('includedByState', $IncludedByStateFilter);
})(window, window.angular);

/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var analyticsEvents = __webpack_require__(684);
var tagManagers = __webpack_require__(685);
var mapperTypes = __webpack_require__(686);

var _require = __webpack_require__(687),
    analyticsOnClickDirectiveDefinition = _require.analyticsOnClickDirectiveDefinition;

var AnalyticsService = __webpack_require__(688);
var analyticsInputDirectiveDefinition = __webpack_require__(689);
var analyticsFormErrorsDirectiveDefinition = __webpack_require__(690);

var analyticsModuleName = 'wowApp.analytics';

angular.module(analyticsModuleName, []).constant('AnalyticsEvents', analyticsEvents).constant('AnalyticsTagManagers', tagManagers).constant('AnalyticsMappertypes', mapperTypes).service('AnalyticsService', AnalyticsService).directive('olyAnalyticsOnClick', analyticsOnClickDirectiveDefinition).directive('analyticsInput', ['AnalyticsService', analyticsInputDirectiveDefinition]).directive('wowAnalyticsFormErrors', ['AnalyticsService', analyticsFormErrorsDirectiveDefinition]);

module.exports = analyticsModuleName;

/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    map = _require.map;

function createProductTile(product) {
    return {
        id: product.Stockcode,
        type: 'product',
        data: {
            product: product
        }
    };
}

function createProductTiles(products) {
    return map(products, function (product) {
        return createProductTile(product);
    });
}

function createBundleTile(bundle) {
    if (bundle.Products.length === 1) {
        return createProductTile(bundle.Products[0]);
    }

    return {
        id: bundle.Name,
        type: 'bundle',
        data: {
            bundle: bundle
        }
    };
}

function createBundleTiles(bundles) {
    var forceResponsive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var isDetail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var sfResponsive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    return map(bundles, function (bundle) {
        return createBundleTile(bundle, forceResponsive, isDetail, sfResponsive);
    });
}

module.exports = {
    createBundleTile: createBundleTile,
    createBundleTiles: createBundleTiles,
    createProductTile: createProductTile,
    createProductTiles: createProductTiles
};

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function LatLng(lat, lng) {
    if (lat && (typeof lat === 'undefined' ? 'undefined' : _typeof(lat)) === 'object') {
        // javascript overloading woo
        return new LatLng(lat.latitude, lat.longitude);
    }

    this.latitude = lat;
    this.longitude = lng;
}

module.exports = LatLng;

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.scrollbarSize = factory();
    }
}(this, function() {
    var scrollbarSize = null;

    return function() {
        if (scrollbarSize !== null)
            return scrollbarSize;

        if (window.document.readyState === "loading")
            return void 0;

        var div1, div2;

        div1 = window.document.createElement('div');
        div2 = window.document.createElement('div');

        div1.style.width = '100px';
        div1.style.overflowX = 'scroll';
        div2.style.width = '100px';

        window.document.body.appendChild(div1);
        window.document.body.appendChild(div2);

        scrollbarSize = div1.offsetHeight - div2.offsetHeight;

        window.document.body.removeChild(div1);
        window.document.body.removeChild(div2);

        return scrollbarSize;
    }
}));

/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["dialogPolyfill"] = __webpack_require__(682);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports=function(e){function t(o){if(n[o])return n[o].exports;var i=n[o]={i:o,l:!1,exports:{}};return e[o].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,t,n){Object.defineProperty(e,t,{configurable:!1,enumerable:!0,get:n})},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=4)}([function(e,t,n){"use strict";function o(){return{restrict:"EA",require:"^dialog",scope:{returnValue:"=?return"},link:function(e,t,n,o){t.on("click",function(){e.$apply(function(){o.close(e.returnValue)})})}}}function i(e){return{restrict:"EA",scope:{dialogName:"@olyDialogShow",isModal:"=?modal",anchorSelector:"@?anchor"},link:function(t,n){t.isModal=void 0!==t.isModal?t.isModal:!0,n.on("click",function(){var n=e.getDialog(t.dialogName);n&&t.$apply(function(){n.show(t.isModal,document.querySelector(t.anchorSelector))})})}}}n.d(t,"a",function(){return o}),n.d(t,"b",function(){return i})},function(e,t,n){"use strict";function o(){return{restrict:"E",transclude:!0,controller:["$scope","$element","$attrs","$transclude","$q","$interpolate","DialogRegistry",function(e,t,n,o,i,r,l){var a=this;this.name=r(n.name)(e),l.addDialog(this,this.name),t[0].parentElement!==document.body&&document.body.appendChild(t.detach()[0]);var u=t[0];"HTMLDialogElement"in window||!window.dialogPolyfill||window.dialogPolyfill.registerDialog(u),this.dialogReturnDeffered=null,this.show=function(t,n){return u.open?this.dialogReturnDeffered.promise:(t=void 0!==t?t:!0,t?u.showModal(n):u.show(n),e.$emit("$dialogShow",this),this.dialogReturnDeffered=i.defer(),this.dialogReturnDeffered.promise)},this.close=function(t){this.isOpen()&&(u.close(t),e.$emit("$dialogClose",this),this.dialogReturnDeffered&&(void 0!==t?this.dialogReturnDeffered.resolve(t):this.dialogReturnDeffered.reject()),this.dialogReturnDeffered=null)},this.isOpen=function(){return u.open},this.getReturnValue=function(){return u.returnValue},o(function(e){t.append(e)}),e.$on("$destroy",function(){a.close(),l.removeDialog(a.name),t.remove()})}]}}t.a=o},function(e,t,n){"use strict";function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),r="defaultDialog",l=function(){function e(){o(this,e),this.dialogs={}}return i(e,[{key:"addDialog",value:function(e,t){this.dialogs[t||r]=e}},{key:"removeDialog",value:function(e){delete this.dialogs[e||r]}},{key:"getDialog",value:function(e){return this.dialogs[e||r]}},{key:"getDialogs",value:function(){return this.dialogs}}]),e}();t.a=l},function(e,t){e.exports=angular},function(e,t,n){"use strict";var o=n(3),i=o&&o.__esModule?function(){return o["default"]}:function(){return o};n.d(i,"a",i);var r=n(1),l=n(0),a=n(2),u="oly.dialog",s=i.a.module(u,[]);s.service("DialogRegistry",[a.a]),s.directive("dialog",[r.a]),s.directive("olyDialogClose",[l.a]),s.directive("olyDialogShow",["DialogRegistry",l.b]),e.exports=u}]);

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Augments the Woolworths Loyalty points filter to display points.
 *
 * @param {Number} amount
 * @param {Number} conversionBase
 */
function loyaltyPointsCalulator(amount) {
  var conversionBase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var shouldRestrictToMax = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var maxPoints = 2000;
  var result = Math.round(conversionBase * amount);
  return shouldRestrictToMax && result > maxPoints ? maxPoints : result;
}

module.exports = loyaltyPointsCalulator;

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaypalBaseController = function () {
    function PaypalBaseController(settings, paypalService, digitalPayPaymentInstrumentsService) {
        _classCallCheck(this, PaypalBaseController);

        this.settings = settings;
        this.paypalService = paypalService;
        this.digitalPayPaymentInstrumentsService = digitalPayPaymentInstrumentsService;
    }

    _createClass(PaypalBaseController, [{
        key: '$onInit',
        value: function $onInit() {
            this.isPaypalReady = false;
            this.hasPaymentError = false;
            this.unlinkMessage = this.settings.digitalPayMessages.paypalUnlinkMessage;
        }
    }, {
        key: 'linkPaypal',
        value: function linkPaypal() {
            if (!this.isPaypalReady) {
                return;
            }
            this.paypalService.initAuthFlow();
        }
    }, {
        key: 'setupPaypal',
        value: function setupPaypal() {
            var _this = this;

            return this.paypalService.setup({
                amount: this.getAmount(), // The child will set this if needed
                currency: 'AUD'
            }, function (payload) {
                _this.isPaypalReady = false;
                _this.paypalService.linkAccountWithDp(payload.nonce).then(function (response) {
                    if (response.Success) {
                        _this.paypal = response.PayPal;
                        _this.refreshLinked();
                        _this.toggleSelected();
                    } else {
                        _this.onLinkFailed(response.ErrorCode, response.ErrorMessage);
                    }
                    _this.isPaypalReady = true;
                });
            }, this.token).then(function (response) {
                _this.isPaypalReady = true;
                return response;
            });
        }
    }, {
        key: 'unlinkPaypal',
        value: function unlinkPaypal() {
            var _this2 = this;

            var paymentInstrumentId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.paypal.PaymentInstrumentId;

            this.isPaypalReady = false;
            this.paypal = undefined;
            this.onUnlink();
            this.digitalPayPaymentInstrumentsService.deleteDigitalPayInstrument({ paymentInstrumentId: paymentInstrumentId }).then(function (response) {
                if (response.Success) {
                    _this2.refreshLinked();
                } else {
                    _this2.onUnlinkFailed(response.ErrorCode, response.ErrorMessage);
                }
            }).catch(function () {
                _this2.onUnlinkFailed();
            }).finally(function () {
                _this2.isPaypalReady = true;
            });
        }
    }, {
        key: 'togglePayPal',
        value: function togglePayPal() {
            if (!this.paypal) {
                this.linkPaypal();
            } else {
                this.toggleSelected();
            }
        }

        /**
         * Override ride this.
         * @Overridable
         */

    }, {
        key: 'refreshLinked',
        value: function refreshLinked() {}

        /**
         * Notifies when Paypal Unlink is successful.
         * @Overridable
         */

    }, {
        key: 'onUnlink',
        value: function onUnlink() {}

        /**
         * Notifies when Paypal Unlink fails.
         * @Overridable
         */

    }, {
        key: 'onUnlinkFailed',
        value: function onUnlinkFailed() {
            var errorCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        } // eslint-disable-line no-unused-vars


        /**
         * Notifies when Paypal Link fails.
         * @Overridable
         */

    }, {
        key: 'onLinkFailed',
        value: function onLinkFailed(errorCode, errorMessage) {} // eslint-disable-line no-unused-vars


        /**
         * Toggle Paypal Select.
         * @Overridable
         */

    }, {
        key: 'toggleSelected',
        value: function toggleSelected() {}

        // Override this if amount is needed

    }, {
        key: 'getAmount',
        value: function getAmount() {
            return undefined;
        }
    }]);

    return PaypalBaseController;
}();

var paypalBaseComponentDefinition = {
    controller: PaypalBaseController,
    bindings: {
        paypal: '<',
        token: '<?'
    }
};

module.exports = {
    PaypalBaseController: PaypalBaseController,
    paypalBaseComponentDefinition: paypalBaseComponentDefinition
};

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var $ = __webpack_require__(2);

var defaultController = 'shop';
var defaultAction = 'home';
var hashPrefix = '#!';

/**
 * Provides access to the different parts of URLs, paving over
 * @class
 * @param {String} url
 */
function UrlInfo(url) {
    this.url = url;
    this._a = window.document.createElement('a');
    this._a.href = url;
}

UrlInfo.prototype._getWindowProtocol = function () {
    return window.location.protocol;
};

UrlInfo.prototype._getWindowHost = function () {
    return window.location.host;
};

UrlInfo.prototype.href = function () {
    return this._a.href;
};

UrlInfo.prototype.origin = function () {
    if ('origin' in this._a) {
        return this._a.origin;
    }

    return this.protocol() + '//' + this.host();
};

UrlInfo.prototype.protocol = function (protocol) {
    if (protocol) {
        this._a.protocol = protocol + ':';
    }

    return this._a.protocol ? this._a.protocol : this._getWindowProtocol();
};

UrlInfo.prototype.host = function () {
    if (!this._a.host) {
        return this._getWindowHost();
    }

    // IE returns default port in |host|
    var re = { 'http:': /:80$/, 'https:': /:443$/, 'ftp:': /:21$/ }[this._a.protocol];
    return re ? this._a.host.replace(re, '') : this._a.host;
};

UrlInfo.prototype.hostname = function () {
    return this._a.hostname;
};

UrlInfo.prototype.port = function () {
    return this._a.port;
};

UrlInfo.prototype.pathname = function (pathname) {
    if (pathname !== undefined) {
        this._a.pathname = pathname;
    }

    // IE does not include leading '/' in |pathname|
    if (this._a.pathname.charAt(0) !== '/') {
        return '/' + this._a.pathname;
    }

    return this._a.pathname;
};

// Returns the search part as an Object
UrlInfo.prototype.getSearchObject = function () {
    try {
        return JSON.parse('{"' + decodeURI(this._a.search).replace('&amp;', '&').replace('?', '').replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
    } catch (e) {
        return {};
    }
};

UrlInfo.prototype.search = function (search, replace) {
    if (search !== undefined) {
        if ((typeof search === 'undefined' ? 'undefined' : _typeof(search)) !== 'object') {
            // prevents breaking any old call of this method
            this._a.search = search;
        } else {
            this._a.search = replace ? $.param(search) : $.param($.extend(this.getSearchObject(), search));
        }
    }

    return this._a.search;
};

UrlInfo.prototype.hash = function () {
    return this._a.hash;
};

/* Custom url information */
function getPathComponent(index, defaultValue) {
    var pathname = this.pathname();
    var url = this.href();
    if (url.indexOf(hashPrefix) > 0) {
        var indexOfHashUrl = url.indexOf(hashPrefix) + hashPrefix.length;
        pathname = decodeURIComponent(url.slice(indexOfHashUrl, url.length));
    }
    var pathComponents = pathname.split('/');
    return pathname === '/' || pathComponents.length < index + 1 ? defaultValue : pathComponents[index].toLowerCase();
}

UrlInfo.prototype.controller = function () {
    return getPathComponent.call(this, 1, defaultController);
};

UrlInfo.prototype.action = function () {
    return getPathComponent.call(this, 2, defaultAction);
};

UrlInfo.prototype.pathAndSearch = function () {
    return this.pathname() + this.search();
};

module.exports = UrlInfo;

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);
var ngMessages = __webpack_require__(14);
var uiRouter = __webpack_require__(6);
var restangular = __webpack_require__(4); // eslint-disable-line no-unused-vars

var olyCommonModule = __webpack_require__(3);
var wowCommonModule = __webpack_require__(5);

var walletModuleName = 'wowApp.wallet';

var DigitalPayPaymentInstrumentsService = __webpack_require__(928);
var DigitalPayIframeEventHandler = __webpack_require__(929);

angular.module(walletModuleName, [olyCommonModule, wowCommonModule, ngMessages, uiRouter, 'restangular']).service('DigitalPayPaymentInstrumentsService', ['$q', 'Restangular', DigitalPayPaymentInstrumentsService]).service('DigitalPayIframeEventHandler', ['$window', DigitalPayIframeEventHandler]);

__webpack_require__(930);
__webpack_require__(941);
__webpack_require__(946);
__webpack_require__(955);
__webpack_require__(962);

module.exports = walletModuleName;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IFRAMEID = 'credit-card-add-iframe';

var CreditCardAddBaseController = function () {
    function CreditCardAddBaseController($element, $sce, $timeout, settings, digitalPayPaymentInstrumentsService, digitalPayIframeEventHandler) {
        _classCallCheck(this, CreditCardAddBaseController);

        this.$element = $element;
        this.$sce = $sce;
        this.$timeout = $timeout;
        this.settings = settings;
        this.digitalPayPaymentInstrumentsService = digitalPayPaymentInstrumentsService;
        this.iframeEventHandler = digitalPayIframeEventHandler;
    }

    _createClass(CreditCardAddBaseController, [{
        key: '$onInit',
        value: function $onInit() {
            this.requiresVerification = false; // WM requires verify=true to be sent as part of credit card tokenization
            this.defaultIsSavingCard = this.isSavingCard;
            this.isLoading = true;
            this.iframeId = IFRAMEID;
            this.isIframeLoadedSuccess = false;
            this.iframeUrl = undefined;
            this.iframeLoadTimeoutPromise = undefined;
            this.timeoutPeriodInMillseconds = this.settings.digitalPay.iframeTimeoutInMilliseconds;
            this.creditCardTypes = this.settings.digitalPayCreditCardNetworks;
            this.setupListenerCallbacks();
            this.setupIframe();
        }

        /**
         * On component destroy, call super.$onDestroy() to unregister event handlers
         */

    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.disposeEventListeners();
        }
    }, {
        key: 'isNetworkAllowed',
        value: function isNetworkAllowed(networkName) {
            return !this.allowedNetworks || !this.allowedNetworks.length || (0, _lodash.find)(this.allowedNetworks, function (network) {
                return network === networkName;
            });
        }

        /**
         * Setups the iframe and starts a timer to ensure it loads
         */

    }, {
        key: 'setupIframe',
        value: function setupIframe() {
            var _this = this;

            this.isLoading = true;
            this.isIframeLoadedSuccess = false;
            this.iframeUrl = undefined;
            this.digitalPayPaymentInstrumentsService.initializeCreditCardIframe().then(function (response) {
                if (!response.Success) {
                    _this.payFrameFailLoad();
                    _this.setupIframeLoadTimer();
                    return;
                }
                _this.iframeUrl = _this.$sce.trustAsResourceUrl(response.IframeUrl);
                _this.registerEventListeners();

                _this.setupIframeLoadTimer();
            }).catch(function () {
                _this.isLoading = false;
            });
        }

        /**
         * Setup a timer to wait for the iframe to load
         */

    }, {
        key: 'setupIframeLoadTimer',
        value: function setupIframeLoadTimer() {
            var _this2 = this;

            this.iframeLoadTimeoutPromise = this.$timeout(function () {
                _this2.isLoading = false;
            }, this.timeoutPeriodInMillseconds);
        }
    }, {
        key: 'setupListenerCallbacks',
        value: function setupListenerCallbacks() {
            var _this3 = this;

            this.payFrameErrorCallback = function (response) {
                _this3.payFrameError(response);
            };

            this.payFrameSuccessCallback = function (response) {
                _this3.payFrameSuccess(response);
            };

            this.payFrameLoadedCallback = function () {
                _this3.payFrameLoaded();
            };

            this.payFrameValidCallback = function () {
                _this3.payFrameValid();
            };

            this.payFrameInvalidCallback = function () {
                _this3.payFrameInvalid();
            };

            this.payFrameFocusGainCallback = function (response) {
                _this3.payFrameFocusGain(response);
            };

            this.payFrameFocusLostCallback = function (response) {
                _this3.payFrameFocusLost(response);
            };

            this.payFrameEnterKeyPressedCallback = function () {
                _this3.payFrameEnterKeyPressed();
            };
        }
    }, {
        key: 'registerEventListeners',
        value: function registerEventListeners() {
            this.iframeEventHandler.on('pay-frame-error', this.payFrameErrorCallback);
            this.iframeEventHandler.on('pay-frame-success', this.payFrameSuccessCallback);
            this.iframeEventHandler.on('pay-frame-loaded', this.payFrameLoadedCallback);
            this.iframeEventHandler.on('pay-frame-valid', this.payFrameValidCallback);
            this.iframeEventHandler.on('pay-frame-invalid', this.payFrameInvalidCallback);
            this.iframeEventHandler.on('pay-frame-focus-gain', this.payFrameFocusGainCallback);
            this.iframeEventHandler.on('pay-frame-focus-lost', this.payFrameFocusLostCallback);
            this.iframeEventHandler.on('pay-frame-enterKey-pressed', this.payFrameEnterKeyPressedCallback);
        }
    }, {
        key: 'disposeEventListeners',
        value: function disposeEventListeners() {
            this.iframeEventHandler.off('pay-frame-error', this.payFrameErrorCallback);
            this.iframeEventHandler.off('pay-frame-success', this.payFrameSuccessCallback);
            this.iframeEventHandler.off('pay-frame-loaded', this.payFrameLoadedCallback);
            this.iframeEventHandler.off('pay-frame-valid', this.payFrameValidCallback);
            this.iframeEventHandler.off('pay-frame-invalid', this.payFrameInvalidCallback);
            this.iframeEventHandler.off('pay-frame-focus-gain', this.payFrameFocusGainCallback);
            this.iframeEventHandler.off('pay-frame-focus-lost', this.payFrameFocusLostCallback);
            this.iframeEventHandler.off('pay-frame-enterKey-pressed', this.payFrameEnterKeyPressedCallback);
        }

        /**
         * Event when the iframe fails to load from Trader side
         */

    }, {
        key: 'payFrameFailLoad',
        value: function payFrameFailLoad() {}

        /**
         * Event when the iframe first loads
         */

    }, {
        key: 'payFrameLoaded',
        value: function payFrameLoaded() {
            var _this4 = this;

            this.$timeout(function () {
                // Cancel the timer and let the view know the iframe was successfully loaded
                _this4.$timeout.cancel(_this4.iframeLoadTimeoutPromise);
                if (_this4.isLoading) {
                    _this4.isLoading = false;
                    _this4.isIframeLoadedSuccess = true;
                }
            });
        }

        /**
         * Event when the iframe does NOT successfully submit
         * @param {Object} response { eventId: 'pay-frame-error', paymentInstrumentId: (string), message: (string), code: (string), auditId: (string) }
         */
        // eslint-disable-next-line no-unused-vars

    }, {
        key: 'payFrameError',
        value: function payFrameError(response) {}

        /**
         * Event when the iframe successfully submits
         * @param {Object} response { eventId: 'pay-frame-success', paymentInstrumentId: (string), message: (string), code: (string), auditId: (string), stepUpToken: (string) }
         */
        // eslint-disable-next-line no-unused-vars

    }, {
        key: 'payFrameSuccess',
        value: function payFrameSuccess(response) {}

        /**
         * Event when the iframe goes from invalid to invalid
         * Note that this only fires when the form validation state changes (e.g. NOT valid -> valid)
         */

    }, {
        key: 'payFrameValid',
        value: function payFrameValid() {}

        /**
         * Event when the iframe goes from valid to invalid
         * Note that this only fires when the form validation state changes (e.g. NOT invalid -> invalid)
         */

    }, {
        key: 'payFrameInvalid',
        value: function payFrameInvalid() {}

        /**
         * Event when an input in the iframe obtains focus
         */

    }, {
        key: 'payFrameFocusGain',
        value: function payFrameFocusGain() {}

        /**
         * Event when an input in the iframe loses focus
         */

    }, {
        key: 'payFrameFocusLost',
        value: function payFrameFocusLost() {}

        /**
         * Event when enter is pressed in the iframe (typically used for submit actions)
         */

    }, {
        key: 'payFrameEnterKeyPressed',
        value: function payFrameEnterKeyPressed() {}

        /**
         * Signal the iframe to clear the contents of the form
         */

    }, {
        key: 'clearIframeContents',
        value: function clearIframeContents() {
            this.isSavingCard = this.defaultIsSavingCard;
            this.iframeEventHandler.emit(this.$element.find('#' + IFRAMEID)[0], { eventId: 'pay-frame-clear' });
            this.clearValidationState();
        }

        /**
         * Signal the iframe to submit the contents of the form
         */

    }, {
        key: 'submitIframe',
        value: function submitIframe() {
            this.iframeEventHandler.emit(this.$element.find('#' + IFRAMEID)[0], { eventId: 'pay-frame-submit', save: this.isSavingCard, verify: this.requiresVerification });
        }
    }]);

    return CreditCardAddBaseController;
}();

var creditCardAddBaseComponentDefinition = {
    controller: CreditCardAddBaseController
};

module.exports = {
    CreditCardAddBaseController: CreditCardAddBaseController,
    creditCardAddBaseComponentDefinition: creditCardAddBaseComponentDefinition
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    find = _require.find,
    merge = _require.merge;

var GiftCardAddBaseController = function () {
    function GiftCardAddBaseController($timeout, settings, digitalPayPaymentInstrumentsService, digitalPayFormValidator) {
        _classCallCheck(this, GiftCardAddBaseController);

        this.$timeout = $timeout;
        this.settings = settings;
        this.digitalPayPaymentInstrumentsService = digitalPayPaymentInstrumentsService;
        this.digitalPayFormValidator = digitalPayFormValidator;
    }

    _createClass(GiftCardAddBaseController, [{
        key: '$onInit',
        value: function $onInit() {
            this.unableToRetrieveBalanceWarningMessage = this.settings.digitalPayError.giftCardUnableToRetrieveBalanceMessage;
            this.hasTooManyRequestsMessage = this.settings.digitalPayError.giftCardTooManyRequestsMessage;

            this.validGiftCardPinNumberLength = this.settings.digitalPay.giftCardPinLength;
            this.validGiftCardNumberLength = this.settings.digitalPay.giftCardNumberLength;
            this.giftCardNumberValidation = {
                allowedBins: this.allowedBins,
                cardDigitLength: this.validGiftCardNumberLength
            };

            this.invalidateBalance();
        }
    }, {
        key: 'giftCardCaptureFocusGain',
        value: function giftCardCaptureFocusGain(event) {
            if (this.hasRetrievedBalance() || !this.focusLostObject) {
                return;
            }

            var errorMessage = this.digitalPayFormValidator.getGiftCardValidationError(this.focusLostObject, event.target.name);
            this.focusLostInvalidFieldsTimeoutPromise = this.invokeAddCardError(errorMessage);
            // Stop the missing fields message from displaying if focus on form is gained
            this.$timeout.cancel(this.focusLostBlankFieldsTimeoutPromise);
            this.focusLostBlankFieldsTimeoutPromise = undefined;
        }
    }, {
        key: 'giftCardCaptureFocusLost',
        value: function giftCardCaptureFocusLost(event) {
            if (this.hasRetrievedBalance()) {
                return;
            }

            var response = this.buildGiftCardCaptureState(event.target.name);
            if (response.allFieldsEmpty && event.target.name !== this.settings.digitalPayGiftCardFields.amount) {
                this.clearValidationState();
                return;
            }

            this.focusLostObject = response;

            var errorMessage = this.digitalPayFormValidator.getGiftCardValidationError(this.focusLostObject);
            this.focusLostInvalidFieldsTimeoutPromise = this.invokeAddCardError(errorMessage);

            // If the user moves away from the form, we display a missing fields message instead.
            // This is cancelled if the user focuses on the form immediately after moving away (e.g. tab from one field to another)
            if (this.hasBlankFields(this.focusLostObject)) {
                this.focusLostBlankFieldsTimeoutPromise = this.invokeAddCardError(this.settings.digitalPayError.giftCardFieldsMissingErrorsMessage);
            }
        }

        /**
         * Invokes card error
         * @overridable
         */

    }, {
        key: 'invokeAddCardError',
        value: function invokeAddCardError(errorMessage) {
            var _this = this;

            // Timeout exists here because we want to delay the error message appearing as a workaround for the UI design
            return this.$timeout(function () {
                _this.errorMessage = errorMessage;
            }, this.settings.digitalPay.formFocusOutTimeoutMilliseconds);
        }
    }, {
        key: 'hasBlankFields',
        value: function hasBlankFields(response) {
            return response.cardValid === null || response.pinValid === null;
        }
    }, {
        key: 'buildGiftCardCaptureState',
        value: function buildGiftCardCaptureState(fieldName) {
            var cardNumber = this.giftCardAddForm.giftCardNumber;
            var pin = this.giftCardAddForm.giftCardPin;
            return {
                allFieldsEmpty: (!cardNumber.$viewValue || !cardNumber.$viewValue.length) && (!pin.$viewValue || !pin.$viewValue.length),
                field: fieldName,
                cardValid: !cardNumber.$viewValue || !cardNumber.$viewValue.length ? null : !cardNumber.$invalid,
                pinValid: !pin.$viewValue || !pin.$viewValue.length ? null : !pin.$invalid
            };
        }
    }, {
        key: 'hasRetrievedBalance',
        value: function hasRetrievedBalance() {
            return this.hasValidGiftCardBalance || !this.card.BalanceApiAvailable;
        }
    }, {
        key: 'hasValidBalance',
        value: function hasValidBalance() {
            return this.hasValidGiftCardBalance && this.card.Balance || !this.card.BalanceApiAvailable;
        }
    }, {
        key: 'setCardValidity',
        value: function setCardValidity(isValid) {
            this.giftCardAddForm.giftCardNumber.$setValidity('card', isValid);
            this.giftCardAddForm.giftCardPin.$setValidity('card', isValid);
        }
    }, {
        key: 'isGiftCardBalanceAmountExist',
        value: function isGiftCardBalanceAmountExist() {
            return parseFloat(this.card.Balance) || parseFloat(this.card.Balance) === 0;
        }
    }, {
        key: 'isBalanceSameAsAvailableAmount',
        value: function isBalanceSameAsAvailableAmount() {
            return parseFloat(this.card.Amount) === parseFloat(this.card.Balance);
        }

        /**
         * Gets gift card balance
         * @overridable
         */

    }, {
        key: 'getBalance',
        value: function getBalance() {
            var _this2 = this;

            this.invalidateBalance();
            this.setCardValidity(true);
            if (this.giftCardAddForm.giftCardNumber.$invalid || this.giftCardAddForm.giftCardPin.$invalid || this.card.CardNumber.length !== this.validGiftCardNumberLength || this.card.Pin.length !== this.validGiftCardPinNumberLength) {
                return;
            }
            this.startLoadingBalance();

            this.digitalPayPaymentInstrumentsService.getUnsavedGiftCardBalances({
                GiftCards: [{
                    CardNumber: this.card.CardNumber,
                    PinCode: this.card.Pin
                }]
            }).then(function (response) {
                _this2.hasValidGiftCardBalance = false;
                if (response.Success) {
                    var giftCardBalance = find(response.GiftCardBalances, { CardNumber: _this2.card.CardNumber });
                    if (!giftCardBalance) {
                        return;
                    }

                    merge(_this2.card, giftCardBalance);
                    _this2.hasValidGiftCardBalance = true;

                    if (_this2.card.ErrorCode === _this2.settings.digitalPayErrorCodes.giftCardKnownBalanceCheckFailed) {
                        _this2.card.BalanceApiAvailable = false;
                    } else if (_this2.card.ErrorCode === _this2.settings.digitalPayErrorCodes.giftCardUnableToRetrieveDetails) {
                        _this2.errorMessage = _this2.settings.digitalPayError.giftCardIncorrectDetailsMessage;
                        _this2.setCardValidity(false);
                    } else if (_this2.card.Expired) {
                        _this2.errorMessage = _this2.settings.digitalPayError.giftCardAddExpiredMessage;
                        _this2.card.Balance = undefined;
                    } else if (_this2.card.Balance === 0) {
                        _this2.errorMessage = _this2.settings.digitalPayError.giftCardAddInsufficientFundsMessage;
                    } else {
                        _this2.setCardValidity(true);
                        _this2.errorMessage = '';
                        _this2.onGetValidBalance();
                    }
                } else if (response.HttpStatusCode === 500) {
                    _this2.card.BalanceApiAvailable = false;
                } else if (response.HttpStatusCode === 429) {
                    _this2.hasTooManyRequests = true;
                }
                _this2.onBalanceCalled(_this2.card.ErrorCode === _this2.settings.digitalPayErrorCodes.giftCardUnableToRetrieveDetails, _this2.card.Expired, _this2.card.Balance === 0);
            }).finally(function () {
                _this2.stopLoadingBalance();
            });
        }

        /**
         * Resets card information and errors
         * @overridable
         */

    }, {
        key: 'invalidateBalance',
        value: function invalidateBalance() {
            this.card.BalanceApiAvailable = true;
            this.hasTooManyRequests = false;
            this.card.Balance = undefined;
            this.card.Amount = undefined;
            if (this.hasValidGiftCardBalance || this.card.Number && this.card.Pin) {
                this.errorMessage = '';
            }
            this.hasValidGiftCardBalance = false;
        }

        /**
         * Resets validation object and errors
         * @overridable
         */

    }, {
        key: 'clearValidationState',
        value: function clearValidationState() {
            this.focusLostObject = undefined;
            this.errorMessage = '';
            this.resetErrorDisplayTimeouts();
        }

        /**
         * For starting the loading spinner
         * @overridable
         */

    }, {
        key: 'startLoadingBalance',
        value: function startLoadingBalance() {}

        /**
         * For stopping the loading spinner
         * @overridable
         */

    }, {
        key: 'stopLoadingBalance',
        value: function stopLoadingBalance() {}

        /**
         * Event when the balance is called
         * @overridable
         */

    }, {
        key: 'onBalanceCalled',
        value: function onBalanceCalled() {
            var isInvalid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var isExpired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var isZeroBalance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        } // eslint-disable-line no-unused-vars


        /**
         * Event when a valid balance is found
         * @overridable
         */

    }, {
        key: 'onGetValidBalance',
        value: function onGetValidBalance() {}
    }, {
        key: 'resetErrorDisplayTimeouts',
        value: function resetErrorDisplayTimeouts() {
            this.$timeout.cancel(this.focusLostBlankFieldsTimeoutPromise);
            this.$timeout.cancel(this.focusLostInvalidFieldsTimeoutPromise);
            this.focusLostBlankFieldsTimeoutPromise = undefined;
            this.focusLostInvalidFieldsTimeoutPromise = undefined;
        }
    }]);

    return GiftCardAddBaseController;
}();

var giftCardAddBaseComponentDefinition = {
    controller: GiftCardAddBaseController,
    bindings: {
        allowedBins: '<'
    }
};

module.exports = {
    GiftCardAddBaseController: GiftCardAddBaseController,
    giftCardAddBaseComponentDefinition: giftCardAddBaseComponentDefinition
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    NONE: 'None',
    CREDITCARD: 'CreditCard',
    PAYPAL: 'PayPal',
    ACCOUNT: 'Account'
};

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    global: {
        wowContactNumber: '1800 000 610',
        wowContactEmail: 'newshoponline@woolworths.com.au',
        wowCustomerCareUrl: '/shop/discover/about-us/contact-us'
    }
};

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var walletModule = __webpack_require__(41);

var _require = __webpack_require__(963),
    paymentDigitalPayComponentDefinition = _require.paymentDigitalPayComponentDefinition,
    _require2 = __webpack_require__(965),
    digitalPayInstrumentsComponentDefinition = _require2.digitalPayInstrumentsComponentDefinition,
    _require3 = __webpack_require__(968),
    stagedAmountDisplayComponentDefinition = _require3.stagedAmountDisplayComponentDefinition;

var digitalPayModuleName = 'wowApp.digitalpay';

angular.module(digitalPayModuleName, [walletModule]).component('wowPaymentDigitalPay', paymentDigitalPayComponentDefinition).component('wowDigitalPayInstruments', digitalPayInstrumentsComponentDefinition).component('wowStagedAmountDisplay', stagedAmountDisplayComponentDefinition);

__webpack_require__(970);
__webpack_require__(973);
__webpack_require__(984);
__webpack_require__(989);
__webpack_require__(992);

module.exports = digitalPayModuleName;

/***/ }),
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.common');

var _require = __webpack_require__(692),
    BootstrapService = _require.BootstrapService;

wowApp.service('BootstrapService', BootstrapService);

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    forEach = _require.forEach,
    clone = _require.clone;

var DigitalPayPaymentErrorStateException = __webpack_require__(954);
var DigitalPayPaymentErrorState = __webpack_require__(548);

/**
 * Maintains error states for DigitalPay payment instruments following an attempt at placing an order.
 */

var DigitalPayPaymentErrorStateService = function () {
    function DigitalPayPaymentErrorStateService() {
        _classCallCheck(this, DigitalPayPaymentErrorStateService);

        this._paymentErrorStates = [];
    }

    /**
     * Initialise Payment Error State
     */


    _createClass(DigitalPayPaymentErrorStateService, [{
        key: 'init',
        value: function init() {
            this.clearErrors();
        }

        /**
         * Add a set of errors
         * @param {Array} errorState
         */

    }, {
        key: 'addErrors',
        value: function addErrors(errorStates) {
            if (!errorStates || !errorStates.length) return;

            var validErrorStates = true;
            // Ensure given error states are valid.
            forEach(errorStates, function (errorState) {
                if (!(errorState instanceof DigitalPayPaymentErrorState)) {
                    validErrorStates = false;
                }
            });

            if (!validErrorStates) {
                throw new DigitalPayPaymentErrorStateException('Invalid error state provided.');
            }

            // Return cloned errorStates to ensure onChange events are triggered.
            this._paymentErrorStates = clone(errorStates);
        }

        /**
         * Get all errors
         */

    }, {
        key: 'getErrors',
        value: function getErrors() {
            // Clone to allow SimpleChange detection.
            return this._paymentErrorStates || [];
        }

        /**
         * Clear all errors
         */

    }, {
        key: 'clearErrors',
        value: function clearErrors() {
            this._paymentErrorStates = [];
        }
    }]);

    return DigitalPayPaymentErrorStateService;
}();

module.exports = DigitalPayPaymentErrorStateService;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Represents a DigitalPay Payment Error Associated With A Payment Instrument Id.
 */
var DigitalPayPaymentErrorState = function DigitalPayPaymentErrorState(key, state) {
    _classCallCheck(this, DigitalPayPaymentErrorState);

    this.key = key;
    this.state = state;
};

module.exports = DigitalPayPaymentErrorState;

/***/ }),
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var AnnouncerServiceDefinition = __webpack_require__(572);

angular.module('oly.common').service('AnnouncerService', AnnouncerServiceDefinition);

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var $ = __webpack_require__(2);

var AnnouncerService = function () {
    /* Announcer for screen-readers
       Based on the md-live-annoucer
       For accessiblity especially in IE11 + JAWS
       https://github.com/angular/material/blob/master/src/core/services/liveAnnouncer/live-announcer.js
    */

    function AnnouncerService($timeout) {
        _classCallCheck(this, AnnouncerService);

        this.$timeout = $timeout;
        this.srElement = this.createScreenReaderElement();
    }

    _createClass(AnnouncerService, [{
        key: 'announce',
        value: function announce(message) {
            var _this = this;

            // The timeout + clearing the message is necessary to trick screen readers into reading the message
            this.srElement.text('');

            this.$timeout(function () {
                _this.srElement.text(message);
            }, 100, false);
        }
    }, {
        key: 'createScreenReaderElement',
        value: function createScreenReaderElement() {
            var srElement = $('<div class="sr-only" role="status" aria-atomic="true" aria-live="polite"></div>');
            $('body').append(srElement);
            return srElement;
        }
    }]);

    return AnnouncerService;
}();

AnnouncerService.$inject = ['$timeout'];

module.exports = AnnouncerService;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(574),
    autocompleteComponentDefinition = _require.autocompleteComponentDefinition;

angular.module('oly.common').component('olyAutocomplete', autocompleteComponentDefinition);

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var angular = __webpack_require__(1);

var _require = __webpack_require__(0),
    debounce = _require.debounce,
    throttle = _require.throttle,
    take = _require.take;

var key = {
    up: 38, down: 40, enter: 13, esc: 27
};

var AutocompleteController = function () {
    function AutocompleteController($scope, $element, $timeout, moveFocus, announcerService, $transclude) {
        _classCallCheck(this, AutocompleteController);

        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
        this.moveFocus = moveFocus;
        this.announcerService = announcerService;
        this.$transclude = $transclude;
    }

    _createClass(AutocompleteController, [{
        key: '$onInit',
        value: function $onInit() {
            this.text = this.text ? this.text : '';
            if (this.selectedItem) {
                this.selectItem(this.selectedItem);
            } else {
                this.selectedItem = null;
            }

            this.prefixPresent = function () {
                return this.$transclude.isSlotFilled('dropDownPrefixSlot');
            };

            this.placeholder = this.placeholder ? this.placeholder : '';
            this.minLength = this.minLength ? this.minLength : 4;
            this.debounce = this.debounce ? this.debounce : 250;
            this.isThrottled = this.throttle !== undefined;
            this.isDisabled = this.isDisabled !== undefined ? this.isDisabled : false;
            this.isPersistentDropdown = this.persistentDropdown !== undefined ? this.persistentDropdown : false;
            this.isDropdownOpen = this.isDropdownOpen !== undefined ? this.isDropdownOpen : false;
            this.requireMatch = this.requireMatch !== undefined ? this.requireMatch : false;
            this.requireMatchText = this.requireMatchText ? this.requireMatchText : 'Please select an item from the dropdown';
            this.selectOnFocus = this.selectOnFocus !== undefined ? this.selectOnFocus : false;
            this.showSearchButton = this.showSearchButton !== undefined ? this.showSearchButton : false;
            this.showClearButton = this.showClearButton !== undefined ? this.showClear : true;
            this.showPrefix = this.showPrefix !== undefined ? this.showPrefix : this.prefixPresent();
            this.isRequired = this.isRequired !== undefined ? this.isRequired : 'This field is required';
            this.showNotFoundMessage = this.showNotFoundMessage !== undefined ? this.showNotFoundMessage : true;

            this.isSearching = false;
            this.selectedItemIndex = null;
            this.itemResults = [];

            this.rateLimitedSearchBoxChanged = this.isThrottled ? throttle(this.searchBoxChangedExecute, this.throttle) : debounce(this.searchBoxChangedExecute, this.debounce);
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.forceDisabled && this.forceDisabled) {
                this.itemResults = [];
                this.updateScroll();
            }
        }
        // Gets the autocomplete items based on this.text
        // Checks length if defined, takes a maximum if defined

    }, {
        key: 'getAutocompleteItems',
        value: function getAutocompleteItems() {
            var _this = this;

            // Ensure that the text length > minimum length
            if (angular.isFunction(this.items) && this.minLength === 0 || this.text && this.text.trim().length >= this.minLength) {
                this.items().then(function (result) {
                    // Take only top X results if defined
                    _this.itemResults = _this.maxItems ? take(result, _this.maxItems) : result;
                    _this.announcerService.announce(_this.itemResults.length + ' results found');
                    _this.isSearching = false;
                    _this.updateScroll();
                });
            } else {
                this.itemResults = [];
                this.announcerService.announce('No results found');
                this.isSearching = false;
                if (!this.isPersistentDropdown && this.text && this.text.trim().length < this.minLength) {
                    this.isDropdownOpen = false;
                }
            }
        }

        // ng-change will only trigger if the input is changed via the input box

    }, {
        key: 'searchBoxChanged',
        value: function searchBoxChanged() {
            if (this.isPersistentDropdown || this.minLength === 0 || this.text && this.text.trim().length >= this.minLength) {
                this.isSearching = true;
                this.isDropdownOpen = true;
                this.rateLimitedSearchBoxChanged();
            } else {
                this.isSearching = false;
                this.isDropdownOpen = false;
                this.itemResults = [];
            }
            this.selectedItem = null;
            this.selectedItemIndex = null;
        }

        // Executes the search (searchBoxChanged only sets debounce timer)

    }, {
        key: 'searchBoxChangedExecute',
        value: function searchBoxChangedExecute() {
            this.getAutocompleteItems();

            if (angular.isFunction(this.textChanged)) {
                this.textChanged();
            }
        }

        // When an item is clicked

    }, {
        key: 'itemOnClicked',
        value: function itemOnClicked(selectedItem) {
            var _this2 = this;

            this.selectItem(selectedItem);
            this.closeDropdown();
            if (angular.isFunction(this.runOnSelect)) {
                // Workaround for double-binding (wait for a tick)
                this.$timeout(function () {
                    return _this2.runOnSelect();
                });
            }
        }

        // When the user presses enter (only care if the user selected an item)

    }, {
        key: 'searchBoxOnEnter',
        value: function searchBoxOnEnter() {
            var _this3 = this;

            if (this.selectedItemIndex != null) {
                this.selectItem(this.itemResults[this.selectedItemIndex]);

                if (angular.isFunction(this.runOnSelect)) {
                    // Workaround for double-binding (wait for a tick)
                    this.$timeout(function () {
                        return _this3.runOnSelect();
                    });
                }
                this.closeDropdown();
            } else if (angular.isFunction(this.runOnEnter) && this.text) {
                // Workaround for double-binding (wait for a tick)
                this.$timeout(function () {
                    return _this3.runOnEnter();
                });
            }
        }

        // Runs when an item is selected, update the text as well

    }, {
        key: 'selectItem',
        value: function selectItem(selectedItem) {
            this.selectedItem = selectedItem;
            this.changeSearchText(selectedItem);
        }

        // When the clear button is pressed

    }, {
        key: 'clearSearch',
        value: function clearSearch() {
            this.text = '';
            this.selectedItem = null;
            this.itemResults = [];
            this.moveFocus('#' + (this.inputId ? this.inputId : ''));
        }

        // When an item is hovered over, select it

    }, {
        key: 'onItemHover',
        value: function onItemHover(index) {
            this.selectedItemIndex = index;
        }

        // Handles Enter/Esc/UpArrow/DownArrow key presses

    }, {
        key: 'onKeyDown',
        value: function onKeyDown($event) {
            switch ($event.keyCode) {
                // Enter
                case key.enter:
                    $event.stopPropagation();
                    $event.preventDefault();
                    this.searchBoxOnEnter();
                    break;
                // Escape
                case key.esc:
                    $event.stopPropagation();
                    $event.preventDefault();
                    this.closeDropdown();
                    break;
                // Up Arrow
                case key.up:
                    $event.stopPropagation();
                    $event.preventDefault();
                    this.dropdownItemsOnArrow(true);
                    this.updateScroll();
                    break;
                // Down Arrow
                case key.down:
                    $event.stopPropagation();
                    $event.preventDefault();
                    this.dropdownItemsOnArrow(false);
                    this.updateScroll();
                    break;
                // Others
                default:
                    break;
            }
        }

        // Handles up and down arrow key presses

    }, {
        key: 'dropdownItemsOnArrow',
        value: function dropdownItemsOnArrow(isUpKey) {
            if (this.isDropdownOpen && this.itemResults.length > 0) {
                if (isUpKey) {
                    this.selectedItemIndex = this.selectedItemIndex !== null ? Math.max(0, this.selectedItemIndex - 1) : Math.max(0, this.itemResults.length - 1);
                } else {
                    this.selectedItemIndex = this.selectedItemIndex !== null ? Math.min(this.itemResults.length - 1, this.selectedItemIndex + 1) : 0;
                }
            } else {
                this.showDropdown();
            }
        }

        // Changes the search text based on the itemText() function, or if not specified, treat as text

    }, {
        key: 'changeSearchText',
        value: function changeSearchText(item) {
            if (this.itemText && angular.isFunction(this.itemText())) {
                this.text = this.itemText()(item);
            } else {
                // No custom item text expression given, assume it's text
                this.text = item;
            }
        }

        // On Focus / On Click

    }, {
        key: 'showDropdown',
        value: function showDropdown() {
            if (this.isPersistentDropdown || this.minLength === 0 || this.text && this.text.trim().length > this.minLength) {
                this.isDropdownOpen = true;
                this.searchBoxChanged();
            }
        }

        // On select item / press enter / lost focus / press esc

    }, {
        key: 'closeDropdown',
        value: function closeDropdown() {
            this.isDropdownOpen = false;
            this.isDisabled = false;
            if (angular.isFunction(this.runOnClose)) {
                this.runOnClose();
            }
        }

        // Scroll to the correct position when up/down arrows are pressed

    }, {
        key: 'updateScroll',
        value: function updateScroll() {
            var listContainerElement = this.$element.find('ul').first();
            var contentsElement = listContainerElement.find('li');

            if (contentsElement.length === 0) {
                return;
            }

            var containerHeight = listContainerElement.height();
            var contentHeight = contentsElement.height();
            var topOfContent = contentHeight * this.selectedItemIndex;
            var bottomOfContent = topOfContent + contentHeight;
            var currentScrollPosition = listContainerElement.scrollTop();

            if (bottomOfContent > currentScrollPosition + containerHeight) {
                listContainerElement.scrollTop(bottomOfContent - containerHeight);
            } else if (topOfContent < currentScrollPosition) {
                listContainerElement.scrollTop(topOfContent);
            }
        }
    }]);

    return AutocompleteController;
}();

AutocompleteController.$inject = ['$scope', '$element', '$timeout', 'MoveFocus', 'AnnouncerService', '$transclude'];

var autocompleteComponentDefinition = {
    controller: AutocompleteController,
    bindings: {
        inputId: '@', // Unique Id for the autocomplete (string), used for properly focusing
        inputName: '@', // Name for the autocomplete (string), for validation (should not be dynamic)
        // Current Text
        parentName: '@?', // Name for the component who uses autocomplete component. e.g. fulfilment selector, signup, etc
        text: '=?', // Current text in the textbox (string)
        selectedItem: '=?', // Currently selected item (object)
        itemText: '&', // Expression for the text inside the autocomplete box (Func<string>)
        placeholder: '@', // Placeholder text (string)
        label: '@', // Label text (string), falls back to placeholder if not available
        // Items & Item Fetching Options
        items: '&', // Promise returning a list (Func(List<any>[])), assumes List<string> but can be customized
        maxItems: '<?', // Maximum number of items to show in the autocomplete (int, infinite)
        minLength: '<?', // Minimum length of text before the autocomplete tries to get items (int, 1)
        debounce: '<?', // Amount of time in ms to wait for input (int, 250)
        throttle: '<?', // Amount of time in ms to throttle autocompletions (int, 250). Supersedes debounce.
        showNotFoundMessage: '<?', // Whether or not to show the Not Found message if there are no items (bool, true)
        // 'Events'
        runOnSelect: '&?', // Expression that runs when an item is selected (Func)
        runOnEnter: '&?', // Expression that runs when the user presses enter (unless an item is selected in which case runOnSelect runs) (Func)
        textChange: '&?', // Expression that runs when text is changed (Func)
        runOnClose: '&?', // Expression that runs when the dropdown is closed (Func)
        // Status of the dropdown
        persistentDropdown: '<?', // External force the dropdown to always show when on focus regardless fo searchTerm length (for always available options) (bool)
        forceDisabled: '<?', // External disable the autocomplete, this will not be modified by the autocomplete (bool)
        isDisabled: '=?', // Is the autocomplete disabled (bool, false)
        isDropdownOpen: '=?', // Used for external features that need to know if the dropdown is currently open or not
        // Validation
        isRequired: '<?', // Whether or not this field is required or not (bool)
        requireMatch: '=?', // Requires a match on a selected item (bool) // TODO
        requireMatchText: '@', // Validation message when requireMatch flags that the text is not a match // TODO
        validationMinLength: '@', // Minimum length for validation (number) // TODO
        validationMaxLength: '@', // Maxumum length for validation (number) // TODO
        // Cosmetics
        selectOnFocus: '<?', // Whether or not to select the text when clicking on the autocomplete (bool, false)
        showSearchButton: '<', // Whether or not to show the search button (bool, false)
        showClearButton: '<', // Whether or not to show the clear button (bool, true)
        showPrefix: '<?', // Whether or not to show the prefix item if it exists (bool, true if slot is filled)
        searchBoxClass: '@', // Class to apply to the search box
        dropdownWrapperClass: '@', // Class to apply to the div before the dropdown menu wrapper (for sizing of the box)
        dropdownClass: '@', // Class to apply to the dropdown menu wrapper
        itemClass: '@', // Class to apply to each individual item
        itemSelectClass: '@', // Class to apply when an item is selected through the keyboard
        actionButtonWrapperClass: '@', // Class to apply for the action buttons container
        actionButtonClass: '@', // Class to apply in general for an action button
        clearButtonClass: '@', // Class to apply for the clear button
        searchButtonClass: '@' // Class to apply for the search button
    },
    transclude: {
        itemSlot: 'autocompleteItem',
        dropDownSuffixSlot: '?autocompleteSuffix',
        dropDownPrefixSlot: '?autocompletePrefix',
        notFoundSlot: '?autocompleteNotFound'
    },
    template: __webpack_require__(575).trim()
};

module.exports = {
    AutocompleteController: AutocompleteController,
    autocompleteComponentDefinition: autocompleteComponentDefinition
};

/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports = "<div class=\"autocomplete\" tabindex=\"-1\" oly-on-blur=\"$ctrl.closeDropdown()\">\r\n    <div class=\"autocomplete-searchBar\">\r\n        <label ng-if=\"$ctrl.label\" for=\"{{$ctrl.inputId}}\">\r\n            {{$ctrl.label}}\r\n        </label>\r\n        <!-- Input -->\r\n        <input\r\n            id=\"{{$ctrl.inputId}}\"\r\n            name=\"{{$ctrl.inputName || $ctrl.inputId}}\"\r\n            ng-class=\"[$ctrl.searchBoxClass, {'autocomplete-searchBoxClear': $ctrl.showClearButton && $ctrl.text}]\"\r\n            type=\"search\"\r\n            autocomplete=\"off\"\r\n            ng-disabled=\"$ctrl.isDisabled || $ctrl.forceDisabled\"\r\n            placeholder=\"{{$ctrl.placeholder}}\"\r\n            ng-model=\"$ctrl.text\"\r\n            ng-focus=\"$ctrl.showDropdown()\"\r\n            ng-change=\"$ctrl.searchBoxChanged()\"\r\n            ng-keydown=\"$ctrl.onKeyDown($event)\"\r\n            ng-required=\"$ctrl.isRequired\"\r\n            aria-owns=\"{{$ctrl.inputId}}-results\"\r\n            aria-label=\"{{$ctrl.label || $ctrl.placeholder}}\"\r\n            role=\"combobox\"\r\n            aria-haspopup=\"true\"\r\n            aria-expanded=\"{{$ctrl.isDropdownOpen}}\"\r\n            aria-autocomplete=\"both\"\r\n            aria-activedescendant=\"{{$ctrl.selectedItemIndex !== null && $ctrl.selectedItemIndex !== undefined ? $ctrl.inputId + '-' + $ctrl.selectedItemIndex : ''}}\" />\r\n\r\n        <div class=\"autocomplete-dropdownWrapper\" ng-show=\"$ctrl.isDropdownOpen\" ng-class=\"$ctrl.dropdownWrapperClass\">\r\n            <!-- Results -->\r\n            <ul class=\"autocomplete-dropdown\"\r\n                ng-class=\"[$ctrl.dropdownClass]\"\r\n                id=\"{{$ctrl.inputId}}-results\"\r\n                role=\"listbox\">\r\n\r\n                <!-- Dropdown Prefix Template -->\r\n                <li ng-transclude=\"dropDownPrefixSlot\" class=\"autocomplete-prefix\" ng-if=\"$ctrl.prefixPresent() && $ctrl.showPrefix\">\r\n                </li>\r\n                <li\r\n                    ng-repeat=\"item in $ctrl.itemResults\"\r\n                    ng-if=\"!$ctrl.isDisabled\"\r\n                    id=\"{{$ctrl.inputId + '-' + $index}}\"\r\n                    role=\"option\"\r\n                    aria-selected=\"{{$ctrl.selectedItemIndex === $index}}\"\r\n                    ng-mouseover=\"$ctrl.onItemHover($index)\"\r\n                    ng-class=\"[$ctrl.itemClass, {'is-itemSelected': $ctrl.selectedItemIndex === $index}, $ctrl.selectedItemIndex === $index ? $ctrl.itemSelectClass : '']\"\r\n                    class=\"autocomplete-item\"\r\n                    ng-click=\"$ctrl.itemOnClicked(item)\"\r\n                    type=\"button\"\r\n                    tabindex=\"-1\"\r\n                    transclude-inject=\"itemSlot\"\r\n                    injected-item=\"item\">\r\n                </li>\r\n\r\n                <!-- Items Not Found Template -->\r\n                <li class=\"autocomplete-notFound\"\r\n                    ng-if=\"$ctrl.showNotFoundMessage && $ctrl.text && !$ctrl.isSearching && (!$ctrl.itemResults || $ctrl.itemResults.length === 0)\"\r\n                    ng-transclude=\"notFoundSlot\">\r\n                </li>\r\n\r\n                <!-- Dropdown Suffix Template -->\r\n                <li ng-transclude=\"dropDownSuffixSlot\">\r\n                </li>\r\n            </ul>\r\n        </div>\r\n\r\n        <div class=\"autocomplete-actionButtonWrapper\" ng-class=\"$ctrl.actionButtonWrapperClass\">\r\n            <!-- Clear Button -->\r\n            <button\r\n                aria-label=\"Clear Search\"\r\n                type=\"button\"\r\n                class=\"autocomplete-actionButton\"\r\n                ng-class=\"[$ctrl.actionButtonClass, $ctrl.clearButtonClass]\"\r\n                ng-click=\"$ctrl.clearSearch()\"\r\n                ng-disabled=\"$ctrl.isDisabled || $ctrl.forceDisabled\"\r\n                ng-if=\"$ctrl.showClearButton && $ctrl.text\"\r\n                value=\"Clear Search\">\r\n                    <i class=\"iconww-Cross\"></i>\r\n            </button>\r\n            <!-- Search Button -->\r\n            <button\r\n                aria-label=\"Search\"\r\n                type=\"button\"\r\n                class=\"autocomplete-actionButton autocomplete-searchButton\"\r\n                ng-class=\"[$ctrl.actionButtonClass, $ctrl.searchButtonClass]\"\r\n                ng-click=\"$ctrl.text && $ctrl.runOnEnter()\"\r\n                ng-disabled=\"$ctrl.isDisabled || $ctrl.forceDisabled\"\r\n                ng-if=\"$ctrl.showSearchButton\"\r\n                value=\"Search\">\r\n                    <i class=\"iconww-Search\"></i>\r\n            </button>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('oly.common');

wowApp.service('ConfirmationDialogService', ['$q', __webpack_require__(577)]);

wowApp.directive('wowConfirmationDialog', ['ConfirmationDialogService', __webpack_require__(578)]);

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _$q = void 0;

var ConfirmationDialogService = function ConfirmationDialogService($q) {
    _$q = $q;
};

ConfirmationDialogService.prototype.showConfirmationDialog = function (opts) {

    // Set options
    this.showDialog = true;
    this.message = opts.message;
    this.classes = opts.classes;

    // Create a promise and return it.
    this.deferred = _$q.defer();

    return this.deferred.promise;
};

ConfirmationDialogService.prototype.resolveDialog = function (result) {
    if (result) {
        this.deferred.resolve(result);
    } else {
        this.deferred.reject('cancel');
    }
    this.showDialog = false;
};

module.exports = ConfirmationDialogService;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (confirmationDialogService) {
    return {
        restrict: 'E',
        link: function link(scope) {
            scope.confirmationDialog = confirmationDialogService;

            // Click Handlers
            scope.continue = confirmationDialogService.resolveDialog.bind(confirmationDialogService, true);
            scope.cancel = confirmationDialogService.resolveDialog.bind(confirmationDialogService, false);
        },

        template: __webpack_require__(579).trim()
    };
};

/***/ }),
/* 579 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirmationDialog\" ng-class=\"'confirmationDialog--' + confirmationDialog.classes\" ng-show=\"confirmationDialog.showDialog\">\r\n    <div class=\"confirmationDialog-message\">\r\n        {{confirmationDialog.message}}\r\n    </div>\r\n    <button class=\"button button--primary\" ng-click=\"continue()\">Continue</button>\r\n    <button class=\"button\" ng-click=\"cancel()\">Cancel</button>\r\n</div>\r\n<div class=\"confirmationDialog-mask\" ng-show=\"confirmationDialog.showDialog\"></div>\r\n"

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('oly.common');

wowApp.directive('olyDisablePanel', [__webpack_require__(581)]);

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// "Disables" a panel by adding a blank div just inside the element, before its first child and
// applying grayed out styling.
module.exports = function () {
    return {
        restrict: 'A',
        scope: {
            disabled: '=olyDisablePanel'
        },
        link: function link(scope, element) {
            scope.$watch('disabled', function (isDisabled) {
                element.toggleClass('u-disabledPanel', isDisabled);
            });
        }
    };
};

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('oly.common');

wowApp.directive('olyInlineDropdown', ['$timeout', __webpack_require__(583)]);

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

module.exports = function ($timeout) {
    return {
        restrict: 'E',
        scope: {
            options: '=',
            labelKey: '@?',
            selectedLabelKey: '@?',
            onChange: '&?',
            customSrMessage: '@?'
        },
        require: 'ngModel',
        link: function link(scope, element, attrs, ngModel) {
            scope.labelKey = scope.labelKey || 'text';
            scope.selectedLabelKey = scope.selectedLabelKey || scope.labelKey;
            scope.srMessage = scope.customSrMessage ? scope.customSrMessage : 'selected, activate for more options';

            ngModel.$render = function () {
                scope.view = scope.renderOption(ngModel.$viewValue, scope.selectedLabelKey);
            };

            scope.renderOption = function (option, key) {
                var labelKey = key || scope.labelKey;
                return _.isObject(option) ? option[labelKey] : option;
            };

            var $dropdownElement = element.find('.olyDropdown');
            var $dropdownItemsContainer = element.find('.olyDropdown-items');
            var $dropdownItems = $dropdownItemsContainer.find('.olyDropdown-item');
            var currentIndex = 0;
            var isOpen = false;

            $dropdownItemsContainer[0].addEventListener('blur', function () {
                $timeout(function () {
                    if ($dropdownItemsContainer.has(document.activeElement).length === 0) {
                        // If the active document element is not one of the drop down items, we
                        // have tabbed out of the dropdown and so we close it.
                        $dropdownElement.removeClass('is-active');
                        isOpen = false;
                    }
                });
            }, true);

            scope.toggleDropdown = function ($event) {
                $event.stopPropagation();

                // Set focus on the first item in the list
                $timeout(function () {
                    $dropdownElement.toggleClass('is-active');
                    $dropdownElement.find('.olyDropdown-link:first').focus();
                    $dropdownItems = $dropdownItemsContainer.find('.olyDropdown-item');
                    currentIndex = 0;
                    isOpen = !isOpen;
                });
            };

            scope.selectOption = function (option) {
                $dropdownElement.removeClass('is-active');

                ngModel.$setViewValue(option);
                ngModel.$render();

                if (scope.onChange) {
                    scope.onChange({ option: option });
                }
            };

            scope.onKeyDown = function (event) {
                if (!isOpen) {
                    return true;
                }

                switch (event.keyCode) {
                    case 38:
                        // UP
                        event.preventDefault();
                        if (currentIndex > 0) {
                            currentIndex--;
                            $dropdownItems.get(currentIndex).firstElementChild.focus();
                        }
                        return false;
                    case 40:
                        // DOWN
                        event.preventDefault();
                        if (currentIndex < $dropdownItems.length - 1) {
                            currentIndex++;
                            $dropdownItems.get(currentIndex).firstElementChild.focus();
                        }
                        return false;
                    default:
                        return true;
                }
            };
        },

        template: __webpack_require__(584).trim()
    };
};

/***/ }),
/* 584 */
/***/ (function(module, exports) {

module.exports = "<div class=\"olyDropdown olyDropdown--inline\">\r\n    <a href=\"javascript:;\" class=\"olyDropdown--inline-selectedInlineItem\" ng-click=\"toggleDropdown($event)\">\r\n        {{view}}\r\n        <span class=\"sr-only\">{{srMessage}}</span>\r\n        <i class=\"iconww-ArrowDown olyDropdown-chevronDown\"></i>\r\n    </a>\r\n    <ul class=\"olyDropdown-items\" ng-keydown=\"onKeyDown($event)\">\r\n        <li class=\"olyDropdown-item\" ng-repeat=\"option in options\">\r\n            <a href=\"javascript:;\" class=\"olyDropdown-link\" ng-click=\"selectOption(option)\" tabindex=\"-1\">\r\n                {{renderOption(option)}}\r\n                <i class=\"iconww-ArrowUp olyDropdown-chevronUp\" ng-if=\"$first\"></i>\r\n            </a>\r\n        </li>\r\n    </ul>\r\n</div>\r\n"

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('oly.common');

wowApp.directive('olyErrorSrc', [__webpack_require__(586)]);

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var transparentPixel = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

// replace the image by the error image if not found
module.exports = function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            element.on('error', function () {
                element.off('error'); // if the error src isn't found don't try to load it repeatedly.

                var olyErrorSrc = attrs.olyErrorSrc && attrs.olyErrorSrc.length > 0 ? attrs.olyErrorSrc : transparentPixel;

                attrs.$set('src', olyErrorSrc);
            });

            scope.$on('$destroy', function () {
                element.off('error');
            });
        }
    };
};

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('oly.common');

wowApp.directive('lazyLoadComponent', ['SettingsService', '$document', '$timeout', '$compile', __webpack_require__(588)]);

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (settingsService, $document, $timeout, $compile) {
    return {
        restrict: 'EA',
        compile: function compile(tElement, tAttr) {
            if (tElement.prop('tagName') === 'IMG') {
                return {
                    post: function postLink(scope, element) {

                        function checkInView() {
                            var pageTop = $(window).scrollTop();
                            var pageBottom = pageTop + $(window).height() * 2;
                            var elementTop = element.offset().top;
                            var elementBottom = elementTop + element.height();
                            return elementTop <= pageBottom && elementBottom >= pageTop;
                        }

                        settingsService.getSettingValue('Content', 'EnableLazilyLoadedImages').then(function (enabled) {
                            if (enabled) {
                                if (!checkInView()) {
                                    $timeout(function () {
                                        tElement.attr('src', tAttr.lazySrc);
                                    }, 2000);
                                } else {
                                    tElement.attr('src', tAttr.lazySrc);
                                }
                            } else {
                                tElement.attr('src', tAttr.lazySrc);
                            }
                        });
                    }
                };
            }
            var content = tElement.html();
            tElement.html('');
            return {
                post: function postLink(scope, element) {

                    settingsService.getSettingValue('Content', 'EnableLazilyLoadedImages').then(function (enabled) {
                        if (enabled) {
                            var timeoutFree = void 0;
                            var isContentSet = false;
                            scope.$on('http:request', function () {
                                if (!isContentSet) {
                                    if (timeoutFree) {
                                        $timeout.cancel(timeoutFree);
                                    }
                                    timeoutFree = $timeout(function () {
                                        element.html(content);
                                        $compile(element.contents())(scope);
                                        isContentSet = true;
                                    }, 1000);
                                }
                            });
                        } else {
                            element.html(content);
                            $compile(element.contents())(scope);
                        }
                    });
                }
            };
        }
    };
};

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('oly.common');

wowApp.filter('paragraphize', [__webpack_require__(590)]);
wowApp.filter('sentenceCase', [__webpack_require__(591)]);

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

module.exports = function () {
    return function (text) {
        text = ('' + text || '').toLowerCase().trim();
        return _.filter(text.split('\n'), function (maybeParagraph) {
            return maybeParagraph;
        });
    };
};

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// lower case and add a capital letter to the first letter of each sentence

module.exports = function () {
    return function (paragraph) {
        if (paragraph && paragraph.length > 0 && typeof paragraph === 'string') {
            return paragraph.replace(/.+?[.?!](\s|$)/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        }

        return paragraph;
    };
};

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var common = __webpack_require__(1).module('oly.common');

var _require = __webpack_require__(593),
    formDirectiveDefinition = _require.formDirectiveDefinition,
    ngFormDirectiveDefinition = _require.ngFormDirectiveDefinition;

var _require2 = __webpack_require__(594),
    DeliveryFormControlState = _require2.DeliveryFormControlState;

common.service('DeliveryFormControlState', DeliveryFormControlState);

common.directive('form', formDirectiveDefinition).directive('ngForm', ngFormDirectiveDefinition);

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* These directive extensions are necessary because nested ng-forms
   do not set $submitted when their root form is submitted. */
var formDirectiveDefinition = function formDirectiveDefinition() {
    return {
        restrict: 'E',
        require: 'form',
        link: function link(scope, elem, attrs) {
            elem.on('submit', function () {
                if (!('nobroadcast' in attrs)) {
                    scope.$broadcast('$submitted');
                    scope.$apply();
                }
            });
        }
    };
};

var ngFormDirectiveDefinition = function ngFormDirectiveDefinition() {
    return {
        restrict: 'EA',
        require: 'form',
        link: function link(scope, elem, attrs, formCtrl) {
            scope.$on('$submitted', function () {
                formCtrl.$setSubmitted();
            });
        }
    };
};

module.exports = { formDirectiveDefinition: formDirectiveDefinition, ngFormDirectiveDefinition: ngFormDirectiveDefinition };

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Controls submit between nested forms inside Checkout Delivery Component
 */
var DeliveryFormControlState = function () {
    function DeliveryFormControlState() {
        _classCallCheck(this, DeliveryFormControlState);
    }

    _createClass(DeliveryFormControlState, [{
        key: "setChildFormSubmitting",
        value: function setChildFormSubmitting() {
            this.isChildFormSubmitting = true;
        }
    }, {
        key: "getChildFormSubmitting",
        value: function getChildFormSubmitting() {
            return this.isChildFormSubmitting;
        }
    }, {
        key: "clearFormSubmitting",
        value: function clearFormSubmitting() {
            this.isChildFormSubmitting = false;
        }
    }]);

    return DeliveryFormControlState;
}();

module.exports = {
    DeliveryFormControlState: DeliveryFormControlState
};

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('oly.common');

var _require = __webpack_require__(596),
    formValidationSummaryComponentDefinition = _require.formValidationSummaryComponentDefinition;

wowApp.component('olyFormValidationSummary', formValidationSummaryComponentDefinition);

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    each = _require.each,
    some = _require.some,
    uniq = _require.uniq;

var FormValidationSummaryController = function () {
    function FormValidationSummaryController($scope, $element, moveFocus) {
        _classCallCheck(this, FormValidationSummaryController);

        this.$element = $element;
        this.moveFocus = moveFocus;
        $scope.$on('$submitted', function () {
            moveFocus($element.find('._errorMessage'));
        });
    }

    _createClass(FormValidationSummaryController, [{
        key: '$onInit',
        value: function $onInit() {
            // We need to track the form's prototype so that we can check if a field in error
            // is actually a whole nested form
            this.formPrototype = Object.getPrototypeOf(this.form).constructor;
        }
    }, {
        key: 'hasValidationErrors',
        value: function hasValidationErrors() {
            return this.form.$submitted && some(this.form.$error);
        }
    }, {
        key: 'getElementsWithErrorsForForm',
        value: function getElementsWithErrorsForForm(form) {
            var _this = this;

            var formName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var elementsWithErrors = [];

            each(form.$error, function (errorType) {
                each(errorType, function (error) {
                    var parentFormName = error.$$parentForm ? error.$$parentForm.$name : ' ';
                    // Recursive for ng-forms
                    if (error instanceof _this.formPrototype) {
                        elementsWithErrors = elementsWithErrors.concat(_this.getElementsWithErrorsForForm(error, parentFormName));
                    } else {
                        // If the form does not have a name, ensure it's unique (by using a space)
                        // This will not work if there is a ng-repeat of ng-forms with the same name
                        // - a unique name must be used for this to work correctly
                        elementsWithErrors.push('' + (formName || '') + parentFormName + error.$name);
                    }
                });
            });

            return uniq(elementsWithErrors);
        }
    }, {
        key: 'errorCount',
        value: function errorCount() {
            return this.getElementsWithErrorsForForm(this.form).length;
        }
    }, {
        key: 'setFocusOnFirstError',
        value: function setFocusOnFirstError() {
            this.moveFocus(this.$element.parent('[name=' + this.form.$name + ']').find('.ng-invalid:focusable').first());
        }
    }]);

    return FormValidationSummaryController;
}();

FormValidationSummaryController.$inject = ['$scope', '$element', 'MoveFocus'];

var formValidationSummaryComponentDefinition = {
    controller: FormValidationSummaryController,
    bindings: {
        userMessage: '@?',
        serverErrorMessage: '@?'
    },
    require: {
        form: '^form'
    },
    template: __webpack_require__(597).trim()
};

module.exports = {
    FormValidationSummaryController: FormValidationSummaryController,
    formValidationSummaryComponentDefinition: formValidationSummaryComponentDefinition
};

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports = "<div class=\"formValidationSummary alert alert--error\" role=\"alert\" tabindex=\"-1\" ng-if=\"$ctrl.hasValidationErrors()\">\r\n    <div class=\"formValidationSummary-userMessageAndIcon\">\r\n        <i class=\"iconww-error formValidationSummary-icon\"></i>\r\n        <span class=\"formValidationSummary-text\">{{$ctrl.userMessage}}</span>\r\n    </div>\r\n    <p class=\"alert-serverErrorMessage\" ng-if=\"$ctrl.serverErrorMessage\">\r\n        {{$ctrl.serverErrorMessage}}\r\n    </p>\r\n    <button type=\"button\" class=\"formValidationSummary-errorText linkButton _errorMessage\" ng-click=\"$ctrl.setFocusOnFirstError()\"> There are {{$ctrl.errorCount()}} field(s) that require your attention.</button>\r\n</div>\r\n"

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1).module('oly.common').factory('geolocation', [__webpack_require__(599)]);

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
    return navigator.geolocation;
};

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1).module('oly.common').factory('GoogleMapsApi', ['$q', 'ResourceInjector', 'SettingsService', __webpack_require__(601)]).directive('olyGoogleMap', [__webpack_require__(602).googleMapDirectiveDefinition]).directive('olyGoogleMapMarker', [__webpack_require__(603).googleMarkerDirectiveDefinition]).directive('olyGoogleInfoWindow', [__webpack_require__(604).googleInfoWindowDirectiveDefinition]).directive('olyGoogleDirectionsRenderer', [__webpack_require__(605).googleDirectionsRendererDirectiveDefinition]).directive('olyGoogleMapGeocenter', [__webpack_require__(606).googleMapGeocenterDirectiveDefinition]).directive('olyPlacesAutocomplete', [__webpack_require__(607).googlePlacesAutocompleteDirectiveDefinition]).service('GoogleMapService', ['SettingsService', 'GoogleMapsApi', __webpack_require__(608)]);

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($q, resourceInjector) {
    return function getGoogleMapsApi(url) {
        return $q(function (resolve) {
            url = url + "&callback=onGoogleMapsReady";

            if (resourceInjector.isScriptInjected(url) && window.google && window.google.maps) {
                resolve(window.google);
            }

            window.onGoogleMapsReady = function () {
                delete window.onGoogleMapsReady;
                resolve(window.google);
            };

            resourceInjector.injectScript(url);
        });
    };
};

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GoogleMapController = function () {
    function GoogleMapController($scope, $element) {
        var _this = this;

        _classCallCheck(this, GoogleMapController);

        this.$scope = $scope;
        this.mapEl = $element.find('.googleMap-canvas')[0];
        this.map = new google.maps.Map(this.mapEl, this.mapOptions || {});

        this.removeTabs = this.removeTabs !== undefined ? this.removeTabs : false;

        setTimeout(function () {
            return _this.addListeners();
        });

        $scope.$watch(function () {
            return _this.mapOptions;
        }, function () {
            return _this.map.setOptions(_this.mapOptions);
        }, true);
    }

    _createClass(GoogleMapController, [{
        key: 'addListeners',
        value: function addListeners() {
            var _this2 = this;

            if (this.onIdle) {
                this.map.addListener('idle', function () {
                    return _this2.$scope.$apply(function () {
                        return _this2.onIdle();
                    });
                });
            }

            if (this.onClick) {
                this.map.addListener('click', function () {
                    return _this2.$scope.$apply(function () {
                        return _this2.onClick();
                    });
                });
            }

            if (this.onZoomChanged) {
                this.map.addListener('zoom_changed', function () {
                    return _this2.$scope.$apply(function () {
                        return _this2.onZoomChanged();
                    });
                });
            }

            if (this.removeTabs) {
                this.map.addListener('tilesloaded', function () {
                    return _this2.removeLinks();
                });
            }
        }
    }, {
        key: 'removeLinks',
        value: function removeLinks() {
            var _this3 = this;

            setTimeout(function () {
                $(_this3.mapEl).find('a').prop('tabIndex', -1);
                $(_this3.mapEl).find('a').prop('aria-hidden', true);
            }, 3000);
        }
    }, {
        key: 'triggerResize',
        value: function triggerResize() {
            google.maps.event.trigger(this.map, 'resize');
        }
    }, {
        key: 'getMap',
        value: function getMap() {
            return this.map;
        }
    }]);

    return GoogleMapController;
}();

var googleMapDirectiveDefinition = function googleMapDirectiveDefinition() {
    return {
        restrict: 'E',
        scope: {},
        bindToController: {
            map: '=?',
            mapOptions: '=',
            mapStyle: '=?',
            onIdle: '&?',
            onZoomChanged: '&?',
            onClick: '&?',
            removeTabs: '<?'
        },
        controller: ['$scope', '$element', GoogleMapController],
        controllerAs: 'googleMapCtrl',
        transclude: true,
        template: '<div ng-style="googleMapCtrl.mapStyle" class="googleMap-canvas"></div><ng-transclude></ng-transclude>'
    };
};

module.exports = {
    GoogleMapController: GoogleMapController,
    googleMapDirectiveDefinition: googleMapDirectiveDefinition
};

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GoogleMarkerController = function () {
    function GoogleMarkerController($scope) {
        var _this = this;

        _classCallCheck(this, GoogleMarkerController);

        this.marker = this.markerOptions instanceof google.maps.Marker ? this.markerOptions : new google.maps.Marker(this.markerOptions);

        if (this.onClick) {
            this.marker.addListener('click', function () {
                return $scope.$apply(function () {
                    return _this.onClick({ marker: _this.marker });
                });
            });
        }

        $scope.$on('$destroy', function () {
            return _this.setMap(null);
        });
    }

    _createClass(GoogleMarkerController, [{
        key: 'setMap',
        value: function setMap(map) {
            this.map = map;
            this.marker.setMap(map);
        }
    }]);

    return GoogleMarkerController;
}();

var googleMarkerDirectiveDefinition = function googleMarkerDirectiveDefinition() {
    return {
        restrict: 'E',
        require: ['olyGoogleMapMarker', '^olyGoogleMap'],
        scope: {},
        bindToController: {
            marker: '=?',
            markerOptions: '=',
            onClick: '&?'
        },
        controller: ['$scope', GoogleMarkerController],
        controllerAs: 'googleMarkerCtrl',
        link: function link(scope, element, attrs, controllers) {
            var markerCtrl = controllers[0];
            var mapCtrl = controllers[1];

            markerCtrl.setMap(mapCtrl.getMap());
        },

        template: ''
    };
};

module.exports = {
    GoogleMarkerController: GoogleMarkerController,
    googleMarkerDirectiveDefinition: googleMarkerDirectiveDefinition
};

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GoogleInfoWindowController = function () {
    function GoogleInfoWindowController($scope) {
        var _this = this;

        _classCallCheck(this, GoogleInfoWindowController);

        this.infoWindow = new google.maps.InfoWindow(this.infoWindowOptions);

        this.infoWindow.addListener('closeclick', function () {
            return $scope.$apply(function () {
                return _this.closeclick();
            });
        });

        $scope.$watch(function () {
            return _this.content;
        }, function () {
            return _this.infoWindow.setContent(_this.content);
        });

        $scope.$watchGroup([function () {
            return _this.isOpen;
        }, function () {
            return _this.anchor;
        }], function () {
            return _this.toggleInfoWindow();
        });
    }

    _createClass(GoogleInfoWindowController, [{
        key: 'toggleInfoWindow',
        value: function toggleInfoWindow() {
            if (!this.isOpen) {
                this.infoWindow.close();
                return;
            }

            if (!this.map || !this.anchor) return;

            this.infoWindow.open(this.map, this.anchor);
        }
    }, {
        key: 'closeclick',
        value: function closeclick() {
            this.isOpen = false;
            if (this.onCloseClick) {
                this.onCloseClick();
            }
        }
    }, {
        key: 'setMap',
        value: function setMap(map) {
            this.map = map;
        }
    }]);

    return GoogleInfoWindowController;
}();

var googleInfoWindowDirectiveDefinition = function googleInfoWindowDirectiveDefinition() {
    return {
        restrict: 'E',
        require: ['olyGoogleInfoWindow', '^olyGoogleMap'],
        scope: {},
        bindToController: {
            infoWindow: '=?',
            infoWindowOptions: '=?',
            content: '=?',
            isOpen: '=',
            anchor: '=?',
            onCloseClick: '&?'
        },
        controller: ['$scope', GoogleInfoWindowController],
        controllerAs: 'googleInfoWindowCtrl',
        link: function link(scope, element, attrs, controllers) {
            var infoWindowCtrl = controllers[0];
            var mapCtrl = controllers[1];

            infoWindowCtrl.setMap(mapCtrl.getMap());
        }
    };
};

module.exports = {
    GoogleInfoWindowController: GoogleInfoWindowController,
    googleInfoWindowDirectiveDefinition: googleInfoWindowDirectiveDefinition
};

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GoogleDirectionsRendererController = function () {
    function GoogleDirectionsRendererController($scope) {
        var _this = this;

        _classCallCheck(this, GoogleDirectionsRendererController);

        this.directionsRenderer = new google.maps.DirectionsRenderer(this.directionsRendererOptions);

        $scope.$watch(function () {
            return _this.directions;
        }, function () {
            return _this.setDirections(_this.directions);
        });

        $scope.$watch(function () {
            return _this.routeIndex;
        }, function () {
            return _this.setRouteIndex(_this.routeIndex);
        });
    }

    _createClass(GoogleDirectionsRendererController, [{
        key: 'setDirections',
        value: function setDirections(directions) {
            if (directions) {
                this.directionsRenderer.setDirections(directions);
                this.setRouteIndex(this.routeIndex);
            }
        }
    }, {
        key: 'setRouteIndex',
        value: function setRouteIndex(routeIndex) {
            if (routeIndex != null) {
                this.directionsRenderer.setRouteIndex(routeIndex);
            }
        }
    }, {
        key: 'setMap',
        value: function setMap(map) {
            this.map = map;
            this.directionsRenderer.setMap(map);
        }
    }]);

    return GoogleDirectionsRendererController;
}();

var googleDirectionsRendererDirectiveDefinition = function googleDirectionsRendererDirectiveDefinition() {
    return {
        restrict: 'E',
        require: ['olyGoogleDirectionsRenderer', '^olyGoogleMap'],
        scope: {},
        bindToController: {
            directionsRenderer: '=?',
            directionsRendererOptions: '=?',
            directions: '=',
            routeIndex: '='
        },
        controller: ['$scope', GoogleDirectionsRendererController],
        controllerAs: 'googleDirectionsRendererCtrl',
        link: function link(scope, element, attrs, controllers) {
            var directionsRendererCtrl = controllers[0];
            var mapCtrl = controllers[1];

            directionsRendererCtrl.setMap(mapCtrl.getMap());
        }
    };
};

module.exports = {
    GoogleDirectionsRendererController: GoogleDirectionsRendererController,
    googleDirectionsRendererDirectiveDefinition: googleDirectionsRendererDirectiveDefinition
};

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GoogleMapGeocenterController = function () {
    function GoogleMapGeocenterController($q, geolocation) {
        _classCallCheck(this, GoogleMapGeocenterController);

        this.$q = $q;
        this.geolocation = geolocation;
    }

    _createClass(GoogleMapGeocenterController, [{
        key: 'getLocation',
        value: function getLocation() {
            var _this = this;

            return this.$q(function (resolve, reject) {
                if (_this.geolocation) {
                    _this.geolocation.getCurrentPosition(resolve, reject);
                } else {
                    reject();
                }
            });
        }
    }, {
        key: 'setMap',
        value: function setMap(map) {
            var _this2 = this;

            this.map = map;

            this.getLocation().then(function (position) {
                return _this2.setCenter(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
            });
        }
    }, {
        key: 'setCenter',
        value: function setCenter(latlng) {
            this.map.setCenter(latlng);

            if (this.onCenter) {
                this.onCenter({ latlng: latlng });
            }
        }
    }]);

    return GoogleMapGeocenterController;
}();

var googleMapGeocenterDirectiveDefinition = function googleMapGeocenterDirectiveDefinition() {
    return {
        restrict: 'E',
        require: ['olyGoogleMapGeocenter', '^olyGoogleMap'],
        scope: {},
        bindToController: {
            onCenter: '&?'
        },
        controller: ['$q', 'geolocation', GoogleMapGeocenterController],
        controllerAs: 'googleMapGeocenterCtrl',
        link: function link(scope, element, attrs, controllers) {
            var geocenterCtrl = controllers[0];
            var mapCtrl = controllers[1];

            geocenterCtrl.setMap(mapCtrl.getMap());
        }
    };
};

module.exports = {
    GoogleMapGeocenterController: GoogleMapGeocenterController,
    googleMapGeocenterDirectiveDefinition: googleMapGeocenterDirectiveDefinition
};

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var $ = __webpack_require__(2);

var GooglePlacesAutocompleteController = function () {
    function GooglePlacesAutocompleteController($scope, $element, $timeout) {
        var _this = this;

        _classCallCheck(this, GooglePlacesAutocompleteController);

        this.$scope = $scope;
        this.$timeout = $timeout;

        this.autocomplete = new window.google.maps.places.Autocomplete($element[0], {
            componentRestrictions: { country: 'au' }
        });

        this.autocomplete.addListener('place_changed', function () {
            return _this.$scope.$apply(function () {
                return _this.placeChanged();
            });
        });

        // This prevents form submission when selecting a place from the dropdown
        // using the enter key. We need to do this because the form submission
        // happens before google updates the selected place, meaning the form
        // is submitted without having selected the new place.
        // see: https://stackoverflow.com/questions/27072844/google-places-autocomplete-place-changed-event-fires-after-form-submission-when
        $element.on('keydown', function (e) {
            if (e.which === 13 && $('.pac-container:visible').length) {
                e.preventDefault();
            }
        });
    }

    _createClass(GooglePlacesAutocompleteController, [{
        key: 'placeChanged',
        value: function placeChanged() {
            var _this2 = this;

            this.place = this.autocomplete.getPlace();

            this.$timeout(function () {
                return _this2.onPlaceChanged();
            });
        }
    }]);

    return GooglePlacesAutocompleteController;
}();

var googlePlacesAutocompleteDirectiveDefinition = function googlePlacesAutocompleteDirectiveDefinition() {
    return {
        restrict: 'A',
        scope: {},
        bindToController: {
            autocomplete: '=?',
            place: '=',
            onPlaceChanged: '&'
        },
        controller: ['$scope', '$element', '$timeout', GooglePlacesAutocompleteController],
        controllerAs: 'googlePlacesAutocompleteCtrl'
    };
};

module.exports = {
    GooglePlacesAutocompleteController: GooglePlacesAutocompleteController,
    googlePlacesAutocompleteDirectiveDefinition: googlePlacesAutocompleteDirectiveDefinition
};

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GoogleMapService = function () {
    function GoogleMapService(settingsService, googleMapsApi) {
        _classCallCheck(this, GoogleMapService);

        this.settingsService = settingsService;
        this.googleMapsApi = googleMapsApi;
    }

    _createClass(GoogleMapService, [{
        key: 'loadMap',
        value: function loadMap() {
            return this.settingsService.getSettingValue('StoreLocator', 'StoreLocatorGoogleMapApiURL').then(this.googleMapsApi).then(function (googleApi) {
                window.google = googleApi;
            });
        }
    }, {
        key: 'loadMapWithCallback',
        value: function loadMapWithCallback(callback) {
            return this.settingsService.getSettingValue('StoreLocator', 'StoreLocatorGoogleMapApiURL').then(this.googleMapsApi).then(function (googleApi) {
                window.google = googleApi;
                callback();
            });
        }
    }]);

    return GoogleMapService;
}();

module.exports = GoogleMapService;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('oly.common');

wowApp.directive('olyGrabFocus', ['$timeout', __webpack_require__(610)]);

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 * Usage: set "focusInput=true" inside an event like ng-click or on-change, then set the below syntax correctly on the target element.
 * syntax: <input oly-grab-focus="focusInput" />
 * target: the element where oly-grab-focus is specified.
 *
 * example 1: The following will grab focus on the target element after the initiator changes
 *
 *          <oly-inline-dropdown on-change="focusInput=true" class="checkoutPayment-methodsDropdown"></oly-inline-dropdown> //initiate
 *
 *          <input type="checkbox" oly-grab-focus="focusInput" /> //target
 *
 *
 */

module.exports = function ($timeout) {
    return function (scope, elem, attrs) {
        var expression = attrs.olyGrabFocus;
        scope.$watch(expression, function (value) {
            if (value) {
                $timeout(function () {
                    elem.focus();
                });
            }
        });
    };
};

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('oly.common');

wowApp.factory('GuidFactory', [__webpack_require__(612)]);

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }

    return function () {
        return "" + s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
    };
}

module.exports = guid;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('oly.common');

wowApp.directive('wowHideScroll', ['BreakpointsService', __webpack_require__(614)]);

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(2),
    scrollSize = __webpack_require__(21),
    _ = __webpack_require__(0);

/**
 * The hidescroll directive hides the scrollbar of a div on which is is applied.
 * It works by wrapping the children of the div in a container which is wider than
 * the parent by the width of the scrollbar, and hiding the overflow of the parent.
 */
module.exports = function HideScroll(breakpointsService) {
    return {
        restrict: 'A',
        controller: ['$scope', function ($scope) {
            this.listeners = [];

            this.onScrollStop = function (listener) {
                this.listeners.push(listener);

                return _.partial(_.remove, this.listeners, function (registeredListener) {
                    return registeredListener === listener;
                });
            };

            this.canScroll = function () {
                return $scope.canScroll();
            };

            this.scrollBottom = function () {
                return $scope.scrollBottom();
            };
        }],
        compile: function compile(element, attrs) {
            if (attrs.disableHideScrollSf !== undefined && breakpointsService.isInSmallFormat) {
                return function () {};
            }

            var wrapperClass = 'hideScroll-wrapper';
            var wrapper = $('<div class="' + wrapperClass + ' ' + (attrs.wowHideScroll || '') + '"></div>');
            wrapper.css({
                width: 'calc(100% + ' + scrollSize() + 'px)',
                height: '100%',
                'overflow-y': 'scroll',
                'overflow-x': 'hidden',
                '-webkit-overflow-scrolling': 'touch'
            });

            element.css({
                overflow: 'hidden'
            });

            element.children().wrapAll(wrapper);

            return function postLink(scope, linkedElement, iAttrs, controller) {
                var wrapperInDom = linkedElement.find('.' + wrapperClass);

                function scrollHandler(e) {
                    if (controller.listeners.length) {
                        requestAnimationFrame(function () {
                            var scrollTop = wrapperInDom.scrollTop();
                            var eventData = {
                                scrollTop: scrollTop,
                                scrollBottom: wrapperInDom[0].scrollHeight - wrapperInDom.height() - scrollTop
                            };

                            _.forEach(controller.listeners, function (listener) {
                                listener(e, eventData);
                            });
                        });
                    }
                }

                wrapperInDom.on('scroll', scrollHandler);

                scope.canScroll = function () {
                    return wrapperInDom[0].scrollHeight > wrapperInDom.height();
                };

                scope.scrollBottom = function () {
                    return wrapperInDom[0].scrollHeight - wrapperInDom.height() - wrapperInDom.scrollTop();
                };
            };
        }
    };
};

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var HoverMenuService = __webpack_require__(616);

angular.module('oly.common').service('HoverMenuService', HoverMenuService).directive('olyHoverMenu', __webpack_require__(617)).directive('olyHoverMenuAction', ['$parse', __webpack_require__(618)]);

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    map = _require.map;

var HoverMenuService = function () {
    function HoverMenuService() {
        _classCallCheck(this, HoverMenuService);
    }

    _createClass(HoverMenuService, [{
        key: 'getDir',
        value: function getDir(menu, submenu) {
            var menuOffset = menu.offset();
            var submenuOffset = submenu.offset();

            var topDiff = Math.abs(menuOffset.top - submenuOffset.top);
            var leftDiff = Math.abs(menuOffset.left - submenuOffset.left);

            if (topDiff > leftDiff) {
                return menuOffset.top > submenuOffset.top ? 'up' : 'down';
            }
            return menuOffset.left > submenuOffset.top ? 'left' : 'right';
        }
    }, {
        key: 'getHoverCone',
        value: function getHoverCone(event, el, dir) {
            var _this = this;

            // Determine rotation required
            var rotation = this._getRotation(dir);

            // Get important coordinates

            var _getPoints2 = this._getPoints(event, el, rotation),
                bl = _getPoints2.bl,
                br = _getPoints2.br,
                m = _getPoints2.m;

            // Get line formula


            var _getLineFormula2 = this._getLineFormula(bl, br, m),
                left = _getLineFormula2.left,
                right = _getLineFormula2.right,
                centre = _getLineFormula2.centre;

            return function (x, y) {
                // Transform cursor position into rotated space
                var c = _this._rotate(_this._removeOffset({ x: x, y: y }, el), rotation);
                // Get y value from appropriate line
                var lineY = (c.x === m.x ? centre : c.x < m.x ? left : right)(c);
                // If we are above this y value we are within the cone
                return c.y >= lineY;
            };
        }
    }, {
        key: '_getRotation',
        value: function _getRotation(dir) {
            if (dir === 'up') {
                return Math.PI;
            }
            if (dir === 'left') {
                return -Math.PI / 2;
            }
            if (dir === 'right') {
                return Math.PI / 2;
            }
            return 0;
        }
    }, {
        key: '_removeOffset',
        value: function _removeOffset(coord, el) {
            return { x: coord.x - el.offset().left, y: coord.y - el.offset().top };
        }
    }, {
        key: '_rotate',
        value: function _rotate(coords, rotation) {
            return {
                x: Math.cos(rotation) * coords.x - Math.sin(rotation) * coords.y,
                y: Math.sin(rotation) * coords.x + Math.cos(rotation) * coords.y
            };
        }
    }, {
        key: '_getPoints',
        value: function _getPoints(event, el, rotation) {
            var _this2 = this;

            var originalCoords = [{ x: 0, y: 0 }, // TL
            { x: el.width(), y: 0 }, // TR
            { x: el.width(), y: el.height() }, // BR
            { x: 0, y: el.height() }];

            var transformedCoords = map(originalCoords, function (c) {
                return _this2._rotate(c, rotation);
            });

            // Rotated point coordinates
            var coords = this._rotateArray(transformedCoords, rotation);

            var m = this._rotate(this._removeOffset({ x: event.clientX, y: event.clientY }, el), rotation);

            return {
                bl: coords[3],
                br: coords[2],
                m: m
            };
        }
    }, {
        key: '_getLineFormula',
        value: function _getLineFormula(bl, br, m) {
            var _this3 = this;

            var lc = 0,
                rc = 0;

            var left = function left(c) {
                return _this3._line(bl, m, c.x, lc);
            };
            var right = function right(c) {
                return _this3._line(m, br, c.x, rc);
            };
            var centre = function centre() {
                return m.y;
            };

            // Determine the correct y intercepts
            lc = m.y - left(m);
            rc = m.y - right(m);

            return { left: left, right: right, centre: centre };
        }
    }, {
        key: '_rotateArray',
        value: function _rotateArray(arr, rotation) {
            return arr.slice(-rotation / (Math.PI / 2), arr.length).concat(arr.slice(0, -rotation / (Math.PI / 2)));
        }
    }, {
        key: '_line',
        value: function _line(c1, c2, x, c) {
            // Definition of a line
            return (c2.y - c1.y) / (c2.x - c1.x) * x + c;
        }
    }]);

    return HoverMenuService;
}();

module.exports = HoverMenuService;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * Usage:
 * syntax:
 * <nav oly-hover-menu oly-hover-menu-target="#sub-menu">
 *  <a oly-hover-menu-action="$ctrl.selectItem(1)" />
 *  <a oly-hover-menu-action="$ctrl.selectItem(2)" />
 * </nav>
 *
 * <div id="sub-menu">
 *  <nav ng-if="$ctrl.isSelected">
 *  </nav>
 * </div>
 * target:
 */

var HoverMenuController = function () {
    function HoverMenuController($timeout, hoverMenuService) {
        _classCallCheck(this, HoverMenuController);

        this.$timeout = $timeout;
        this.hoverMenuService = hoverMenuService;

        this.isInCone = function () {
            return false;
        };
    }

    _createClass(HoverMenuController, [{
        key: 'registerActionElement',
        value: function registerActionElement(actionElement, action) {
            var _this = this;

            if (!action) {
                return;
            }

            actionElement.on('mouseover', function (event) {
                if (_this.isInCone(event.clientX, event.clientY)) {
                    return;
                }

                _this.isInCone = function () {
                    return false;
                };

                _this.$timeout(function () {
                    action({ event: event });
                    _this.isInCone = _this.hoverMenuService.getHoverCone(event, _this.hoverMenuElement, _this.hoverMenuDir);
                    var currentCone = _this.isInCone;
                    _this.$timeout(function () {
                        if (currentCone === _this.isInCone) {
                            _this.isInCone = function () {
                                return false;
                            };
                        }
                    }, 500);
                });
            });
        }
    }]);

    return HoverMenuController;
}();

module.exports = function () {
    return {
        restrict: 'A',
        controller: ['$timeout', 'HoverMenuService', HoverMenuController],
        controllerAs: '$hoverMenuController',
        link: function link(scope, elem, attr) {
            scope.$hoverMenuController.hoverMenuDir = attr.olyHoverMenuDir;
            scope.$hoverMenuController.hoverMenuElement = !attr.olyHoverMenu ? elem : elem.find(attr.olyHoverMenu);

            scope.$hoverMenuController.hoverMenuElement.on('mouseleave', function () {
                scope.$hoverMenuController.isInCone = function () {
                    return false;
                };
            });
        }
    };
};

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
    return {
        require: '^^?olyHoverMenu',
        restrict: 'A',
        link: function link(scope, elem, attr, hoverMenuController) {
            var hoverMenuAction = function hoverMenuAction(params) {
                return scope.$eval(attr.olyHoverMenuAction, params);
            };

            if (hoverMenuController) {
                hoverMenuController.registerActionElement(elem, hoverMenuAction);
            }
        }
    };
};

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var common = __webpack_require__(1).module('oly.common');

var inputDirectives = __webpack_require__(620);

common.directive('wowInputContainer', ['$parse', inputDirectives.inputContainer]);
common.directive('label', [inputDirectives.label]);
common.directive('input', ['GuidFactory', inputDirectives.input]);
common.directive('textarea', ['GuidFactory', inputDirectives.input]);
common.directive('placeholder', [inputDirectives.placeholder]);
common.directive('restrictAlpha', [inputDirectives.restrictAlpha]);
common.directive('olyMaxLength', [inputDirectives.maxLength]);

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1),
    _require = __webpack_require__(0),
    isEmpty = _require.isEmpty;

function inputContainerDirective() {
    return {
        restrict: 'E',
        controller: ['$scope', '$element', function ($scope, $element) {
            var _this = this;

            this.element = $element;
            this.messagePanel = $element.find('[ng-messages]').first();
            this.setFocused = function (isFocused) {
                $element.toggleClass('is-focused', !!isFocused);
            };
            this.setHasValue = function (hasValue) {
                $element.toggleClass('has-value', !!hasValue);
            };
            this.setInvalid = function (isInvalid) {
                $element.toggleClass('is-invalid', !!isInvalid);

                // Set aria attribute to input so error message is read out on focus.
                if (this.messagePanel.length) {
                    if (isInvalid) {
                        var msgId = this.messagePanel.attr('id');
                        if (!msgId) {
                            msgId = this.input.attr('id') + '-messages';
                            this.messagePanel.attr('id', msgId);
                        }

                        this.input.attr('aria-describedby', msgId);
                    } else {
                        this.input.removeAttr('aria-describedby');
                    }
                }
            };
            $scope.$watch(function () {
                return _this.label && _this.input;
            }, function (hasLabelAndInput) {
                if (hasLabelAndInput && !_this.label.attr('for')) {
                    _this.label.attr('for', _this.input.attr('id'));
                }
            });
        }]
    };
}

function fakeNgModel() {
    return {
        $fake: true,
        $setViewValue: function $setViewValue(value) {
            this.$viewValue = value;
            this.$render(value);
            this.$viewChangeListeners.forEach(function (cb) {
                cb();
            });
        },
        $isEmpty: function $isEmpty(value) {
            return ('' + value).length === 0;
        },

        $parsers: [],
        $formatters: [],
        $viewChangeListeners: [],
        $render: angular.noop
    };
}

function inputDirective(guid) {
    return {
        restrict: 'E',
        require: ['^?wowInputContainer', '?ngModel', '^?form'],
        link: function link(scope, element, attr, ctrls) {

            var containerCtrl = ctrls[0];
            var ngModelCtrl = ctrls[1] || fakeNgModel();
            var ngForm = ctrls[2] || { $submitted: true };
            var isReadonly = angular.isDefined(attr.readonly);
            if (!containerCtrl) {
                return;
            }
            if (containerCtrl.input) {
                throw new Error('<wow-input-container> can only have *one* <input> child element!');
            }
            containerCtrl.input = element;

            element.addClass('wowInput');
            if (!element.attr('id')) {
                element.attr('id', 'input_' + guid());
            }

            function ngModelPipelineCheckValue(arg) {
                containerCtrl.setHasValue(!ngModelCtrl.$isEmpty(arg));
                return arg;
            }

            function inputCheckValue() {
                // An input's value counts if its length > 0,
                // or if the input's validity state says it has bad input (eg string in a number input)
                containerCtrl.setHasValue(element.val().length > 0 || (element[0].validity || {}).badInput);
            }

            var isErrorGetter = function isErrorGetter() {
                // check if field is invalid when submitted or validated asynchronusly
                return ngModelCtrl.$invalid && (ngForm.$submitted || ngModelCtrl.$dirty && !isEmpty(ngModelCtrl.$asyncValidators));
            };

            scope.$watch(isErrorGetter, function (isInvalid) {
                containerCtrl.setInvalid(isInvalid);
                element.attr('aria-invalid', isInvalid);
            });

            ngModelCtrl.$parsers.push(ngModelPipelineCheckValue);
            ngModelCtrl.$formatters.push(ngModelPipelineCheckValue);

            element.on('input', inputCheckValue);

            if (!isReadonly) {
                element.on('focus', function () {
                    containerCtrl.setFocused(true);
                }).on('blur', function () {
                    containerCtrl.setFocused(false);
                    inputCheckValue();
                });
            }

            scope.$on('$destroy', function () {
                containerCtrl.setFocused(false);
                containerCtrl.setHasValue(false);
                containerCtrl.input = null;
            });
        }
    };
}

function labelDirective() {
    return {
        restrict: 'E',
        require: '^?wowInputContainer',
        link: function link(scope, element, attr, containerCtrl) {
            if (!containerCtrl) {
                return;
            }

            containerCtrl.label = element;
            element.addClass('wowLabel');

            scope.$on('$destroy', function () {
                containerCtrl.label = null;
            });
        }
    };
}

function placeholderDirective() {
    return {
        restrict: 'A',
        require: '^^?wowInputContainer',
        link: function link(scope, element, attr, inputContainer) {
            if (!inputContainer || attr.keepPlaceholder) {
                return;
            }
            var placeholderText = attr.placeholder;
            element.removeAttr('placeholder');

            inputContainer.element.find('input').after('<div class="wowPlaceholder">' + placeholderText + '</div>');
        }
    };
}

function getKeyCode(evt) {
    var key = evt.key;
    var keyCode = evt.keyCode;
    if (key && !keyCode) {
        keyCode = key.charCodeAt(0);
    }
    return keyCode;
}

function isEnterKey(keyCode) {
    return keyCode && keyCode === 13;
}

function isBackspace(keyCode) {
    return keyCode && keyCode === 8;
}

function matchesPattern(regex, value) {
    return regex.test(value);
}

function restrictAlphaDirective() {
    return {
        restrict: 'A',
        link: function link(scope, element) {
            function isNumeric(keyCode) {
                return keyCode && keyCode >= 48 && keyCode <= 57;
            }
            element.bind('keypress', function (event) {
                var keyCode = getKeyCode(event);
                if (!isBackspace(keyCode) && !isNumeric(keyCode) && !isEnterKey(keyCode)) {
                    event.preventDefault();
                }
            });
            element.bind('keyup', function () {
                if (!matchesPattern(/^\d+$/, element.val())) {
                    element.val('');
                }
            });
        }
    };
}

function maxLengthDirective() {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            function hasReachedMaxLength(value, maxLength) {
                return value && value.length && value.length === maxLength;
            }
            function hasSelectedText(selectionIndexStart, selectionIndexEnd, maxLength) {
                return selectionIndexStart !== maxLength && selectionIndexStart !== selectionIndexEnd;
            }
            function hasPassedMaxLength(value, maxLength) {
                return value && value.length && value.length > maxLength;
            }
            element.bind('keypress', function (event) {
                var maxLength = scope.$eval(attrs.olyMaxLength);
                var value = element.val();
                var keyCode = getKeyCode(event);
                if (!isBackspace(keyCode) && hasReachedMaxLength(value, maxLength) && !hasSelectedText(event.target.selectionStart, event.target.selectionEnd, maxLength)) {
                    event.preventDefault();
                }
            });
            element.bind('keyup', function () {
                var maxLength = scope.$eval(attrs.olyMaxLength);
                var value = element.val();
                if (hasPassedMaxLength(value, maxLength)) {
                    element.val('');
                }
            });
        }
    };
}

module.exports = {
    inputContainer: inputContainerDirective,
    input: inputDirective,
    label: labelDirective,
    placeholder: placeholderDirective,
    restrictAlpha: restrictAlphaDirective,
    maxLength: maxLengthDirective
};

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(622),
    spinnerComponentDefinition = _require.spinnerComponentDefinition;

var _require2 = __webpack_require__(624),
    smallSpinnerComponentDefinition = _require2.smallSpinnerComponentDefinition;

angular.module('oly.common').component('wowLoadingSpinner', spinnerComponentDefinition).component('wowSmallSpinner', smallSpinnerComponentDefinition);

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// IMPORTANT : don't use this directive on an ng-show! use ng-if instead
var SpinnerController = function () {
    function SpinnerController() {
        _classCallCheck(this, SpinnerController);
    }

    _createClass(SpinnerController, [{
        key: '$onInit',
        value: function $onInit() {
            this.isMessageSrOnly = this.isMessageSrOnly !== undefined ? this.isMessageSrOnly : true;
        }
    }]);

    return SpinnerController;
}();

var spinnerComponentDefinition = {
    bindings: {
        message: '@',
        isMessageSrOnly: '<?',
        customSpinnerClass: '@'
    },
    controller: SpinnerController,
    template: __webpack_require__(623).trim()
};

module.exports = {
    SpinnerController: SpinnerController,
    spinnerComponentDefinition: spinnerComponentDefinition
};

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports = "<div ng-class=\"::$ctrl.customSpinnerClass\" class=\"spinner spinner-circle\">\r\n    <div class=\"spinner-container container1\">\r\n        <div class=\"circle circle1\"></div>\r\n        <div class=\"circle circle2\"></div>\r\n        <div class=\"circle circle3\"></div>\r\n        <div class=\"circle circle4\"></div>\r\n    </div>\r\n    <div class=\"spinner-container container2\">\r\n        <div class=\"circle circle1\"></div>\r\n        <div class=\"circle circle2\"></div>\r\n        <div class=\"circle circle3\"></div>\r\n        <div class=\"circle circle4\"></div>\r\n    </div>\r\n    <div class=\"spinner-container container3\">\r\n        <div class=\"circle circle1\"></div>\r\n        <div class=\"circle circle2\"></div>\r\n        <div class=\"circle circle3\"></div>\r\n        <div class=\"circle circle4\"></div>\r\n    </div>\r\n</div>\r\n\r\n<p\r\n    ng-if=\"$ctrl.message\"\r\n    class=\"spinner-message\"\r\n    ng-class=\"{'sr-only': $ctrl.isMessageSrOnly}\"\r\n    role=\"alert\"\r\n    aria-live=\"assertive\">\r\n    {{ $ctrl.message }}\r\n</p>\r\n"

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SmallSpinnerController = function SmallSpinnerController() {
    _classCallCheck(this, SmallSpinnerController);
};

var smallSpinnerComponentDefinition = {
    controller: SmallSpinnerController,
    template: __webpack_require__(625).trim()
};

module.exports = {
    SmallSpinnerController: SmallSpinnerController,
    smallSpinnerComponentDefinition: smallSpinnerComponentDefinition
};

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports = "<div class=\"small-spinner\">\r\n    <div></div>\r\n    <div></div>\r\n    <div></div>\r\n    <div></div>\r\n    <div></div>\r\n    <div></div>\r\n    <div></div>\r\n    <div></div>\r\n    <div></div>\r\n    <div></div>\r\n    <div></div>\r\n    <div></div>\r\n</div>\r\n"

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1).module('oly.common').service('LocationService', ['geolocation', '$q', __webpack_require__(627)]);

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LatLng = __webpack_require__(17);

var LocationService = function () {
    function LocationService(geolocation, $q) {
        _classCallCheck(this, LocationService);

        this.$q = $q;
        this.geolocation = geolocation;
        this.latlng = {};
    }

    _createClass(LocationService, [{
        key: 'getCurrentLocation',
        value: function getCurrentLocation() {
            var _this = this;

            return this.$q(function (resolve, reject) {
                _this.geolocation.getCurrentPosition(function (position) {
                    _this.latlng = new LatLng(position.coords);
                    resolve(_this.latlng);
                }, reject);
            });
        }
    }, {
        key: 'isLocationEnabled',
        value: function isLocationEnabled() {
            return this.getCurrentLocation();
        }
    }]);

    return LocationService;
}();

module.exports = LocationService;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1).module('oly.common').directive('wowMask', [__webpack_require__(629)]);

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(630);

var MaskController = function MaskController($attrs, $element) {
    _classCallCheck(this, MaskController);

    $attrs.$observe('wowMask', function (val) {
        return $element.mask(val);
    });
};

module.exports = function () {
    return {
        restrict: 'A',
        scope: false,
        controller: ['$attrs', '$element', MaskController]
    };
};

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * jquery.mask.js
 * @version: v1.13.4
 * @author: Igor Escobar
 *
 * Created by Igor Escobar on 2012-03-10. Please report any bug at http://blog.igorescobar.com
 *
 * Copyright (c) 2012 Igor Escobar http://blog.igorescobar.com
 *
 * The MIT License (http://www.opensource.org/licenses/mit-license.php)
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 */

/* jshint laxbreak: true */
/* global define, jQuery, Zepto */



// UMD (Universal Module Definition) patterns for JavaScript modules that work everywhere.
// https://github.com/umdjs/umd/blob/master/jqueryPluginCommonjs.js
(function (factory) {

    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery || Zepto);
    }

}(function ($) {

    var Mask = function (el, mask, options) {
        el = $(el);

        var jMask = this, oldValue = el.val(), regexMask;

        mask = typeof mask === 'function' ? mask(el.val(), undefined, el,  options) : mask;

        var p = {
            invalid: [],
            getCaret: function () {
                try {
                    var sel,
                        pos = 0,
                        ctrl = el.get(0),
                        dSel = document.selection,
                        cSelStart = ctrl.selectionStart;

                    // IE Support
                    if (dSel && navigator.appVersion.indexOf('MSIE 10') === -1) {
                        sel = dSel.createRange();
                        sel.moveStart('character', el.is('input') ? -el.val().length : -el.text().length);
                        pos = sel.text.length;
                    }
                    // Firefox support
                    else if (cSelStart || cSelStart === '0') {
                        pos = cSelStart;
                    }

                    return pos;
                } catch (e) {}
            },
            setCaret: function(pos) {
                try {
                    if (el.is(':focus')) {
                        var range, ctrl = el.get(0);

                        if (ctrl.setSelectionRange) {
                            ctrl.setSelectionRange(pos,pos);
                        } else if (ctrl.createTextRange) {
                            range = ctrl.createTextRange();
                            range.collapse(true);
                            range.moveEnd('character', pos);
                            range.moveStart('character', pos);
                            range.select();
                        }
                    }
                } catch (e) {}
            },
            events: function() {
                el
                .on('input.mask keyup.mask', p.behaviour)
                .on('paste.mask drop.mask', function() {
                    setTimeout(function() {
                        el.keydown().keyup();
                    }, 100);
                })
                .on('change.mask', function(){
                    el.data('changed', true);
                })
                .on('blur.mask', function(){
                    if (oldValue !== el.val() && !el.data('changed')) {
                        el.triggerHandler('change');
                    }
                    el.data('changed', false);
                })
                // it's very important that this callback remains in this position
                // otherwhise oldValue it's going to work buggy
                .on('blur.mask', function() {
                    oldValue = el.val();
                })
                // select all text on focus
                .on('focus.mask', function (e) {
                    if (options.selectOnFocus === true) {
                        $(e.target).select();
                    }
                })
                // clear the value if it not complete the mask
                .on('focusout.mask', function() {
                    if (options.clearIfNotMatch && !regexMask.test(p.val())) {
                       p.val('');
                   }
                });
            },
            getRegexMask: function() {
                var maskChunks = [], translation, pattern, optional, recursive, oRecursive, r;

                for (var i = 0; i < mask.length; i++) {
                    translation = jMask.translation[mask.charAt(i)];

                    if (translation) {

                        pattern = translation.pattern.toString().replace(/.{1}$|^.{1}/g, '');
                        optional = translation.optional;
                        recursive = translation.recursive;

                        if (recursive) {
                            maskChunks.push(mask.charAt(i));
                            oRecursive = {digit: mask.charAt(i), pattern: pattern};
                        } else {
                            maskChunks.push(!optional && !recursive ? pattern : (pattern + '?'));
                        }

                    } else {
                        maskChunks.push(mask.charAt(i).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
                    }
                }

                r = maskChunks.join('');

                if (oRecursive) {
                    r = r.replace(new RegExp('(' + oRecursive.digit + '(.*' + oRecursive.digit + ')?)'), '($1)?')
                         .replace(new RegExp(oRecursive.digit, 'g'), oRecursive.pattern);
                }

                return new RegExp(r);
            },
            destroyEvents: function() {
                el.off(['input', 'keydown', 'keyup', 'paste', 'drop', 'blur', 'focusout', ''].join('.mask '));
            },
            val: function(v) {
                var isInput = el.is('input'),
                    method = isInput ? 'val' : 'text',
                    r;

                if (arguments.length > 0) {
                    if (el[method]() !== v) {
                        el[method](v);
                    }
                    r = el;
                } else {
                    r = el[method]();
                }

                return r;
            },
            getMCharsBeforeCount: function(index, onCleanVal) {
                for (var count = 0, i = 0, maskL = mask.length; i < maskL && i < index; i++) {
                    if (!jMask.translation[mask.charAt(i)]) {
                        index = onCleanVal ? index + 1 : index;
                        count++;
                    }
                }
                return count;
            },
            caretPos: function (originalCaretPos, oldLength, newLength, maskDif) {
                var translation = jMask.translation[mask.charAt(Math.min(originalCaretPos - 1, mask.length - 1))];

                return !translation ? p.caretPos(originalCaretPos + 1, oldLength, newLength, maskDif)
                                    : Math.min(originalCaretPos + newLength - oldLength - maskDif, newLength);
            },
            behaviour: function(e) {
                e = e || window.event;
                p.invalid = [];
                var keyCode = e.keyCode || e.which;
                if ($.inArray(keyCode, jMask.byPassKeys) === -1) {

                    var caretPos = p.getCaret(),
                        currVal = p.val(),
                        currValL = currVal.length,
                        changeCaret = caretPos < currValL,
                        newVal = p.getMasked(),
                        newValL = newVal.length,
                        maskDif = p.getMCharsBeforeCount(newValL - 1) - p.getMCharsBeforeCount(currValL - 1);

                    p.val(newVal);

                    // change caret but avoid CTRL+A
                    if (changeCaret && !(keyCode === 65 && e.ctrlKey)) {
                        // Avoid adjusting caret on backspace or delete
                        if (!(keyCode === 8 || keyCode === 46)) {
                            caretPos = p.caretPos(caretPos, currValL, newValL, maskDif);
                        }
                        p.setCaret(caretPos);
                    }

                    return p.callbacks(e);
                }
            },
            getMasked: function(skipMaskChars) {
                var buf = [],
                    value = p.val(),
                    m = 0, maskLen = mask.length,
                    v = 0, valLen = value.length,
                    offset = 1, addMethod = 'push',
                    resetPos = -1,
                    lastMaskChar,
                    check;

                if (options.reverse) {
                    addMethod = 'unshift';
                    offset = -1;
                    lastMaskChar = 0;
                    m = maskLen - 1;
                    v = valLen - 1;
                    check = function () {
                        return m > -1 && v > -1;
                    };
                } else {
                    lastMaskChar = maskLen - 1;
                    check = function () {
                        return m < maskLen && v < valLen;
                    };
                }

                while (check()) {
                    var maskDigit = mask.charAt(m),
                        valDigit = value.charAt(v),
                        translation = jMask.translation[maskDigit];

                    if (translation) {
                        if (valDigit.match(translation.pattern)) {
                            buf[addMethod](valDigit);
                             if (translation.recursive) {
                                if (resetPos === -1) {
                                    resetPos = m;
                                } else if (m === lastMaskChar) {
                                    m = resetPos - offset;
                                }

                                if (lastMaskChar === resetPos) {
                                    m -= offset;
                                }
                            }
                            m += offset;
                        } else if (translation.optional) {
                            m += offset;
                            v -= offset;
                        } else if (translation.fallback) {
                            buf[addMethod](translation.fallback);
                            m += offset;
                            v -= offset;
                        } else {
                          p.invalid.push({p: v, v: valDigit, e: translation.pattern});
                        }
                        v += offset;
                    } else {
                        if (!skipMaskChars) {
                            buf[addMethod](maskDigit);
                        }

                        if (valDigit === maskDigit) {
                            v += offset;
                        }

                        m += offset;
                    }
                }

                var lastMaskCharDigit = mask.charAt(lastMaskChar);
                if (maskLen === valLen + 1 && !jMask.translation[lastMaskCharDigit]) {
                    buf.push(lastMaskCharDigit);
                }

                return buf.join('');
            },
            callbacks: function (e) {
                var val = p.val(),
                    changed = val !== oldValue,
                    defaultArgs = [val, e, el, options],
                    callback = function(name, criteria, args) {
                        if (typeof options[name] === 'function' && criteria) {
                            options[name].apply(this, args);
                        }
                    };

                callback('onChange', changed === true, defaultArgs);
                callback('onKeyPress', changed === true, defaultArgs);
                callback('onComplete', val.length === mask.length, defaultArgs);
                callback('onInvalid', p.invalid.length > 0, [val, e, el, p.invalid, options]);
            }
        };


        // public methods
        jMask.mask = mask;
        jMask.options = options;
        jMask.remove = function() {
            var caret = p.getCaret();
            p.destroyEvents();
            p.val(jMask.getCleanVal());
            p.setCaret(caret - p.getMCharsBeforeCount(caret));
            return el;
        };

        // get value without mask
        jMask.getCleanVal = function() {
           return p.getMasked(true);
        };

       jMask.init = function(onlyMask) {
            onlyMask = onlyMask || false;
            options = options || {};

            jMask.byPassKeys = $.jMaskGlobals.byPassKeys;
            jMask.translation = $.jMaskGlobals.translation;

            jMask.translation = $.extend({}, jMask.translation, options.translation);
            jMask = $.extend(true, {}, jMask, options);

            regexMask = p.getRegexMask();

            if (onlyMask === false) {

                if (options.placeholder) {
                    el.attr('placeholder' , options.placeholder);
                }

                // this is necessary, otherwise if the user submit the form
                // and then press the "back" button, the autocomplete will erase
                // the data. Works fine on IE9+, FF, Opera, Safari.
                if ($('input').length && 'oninput' in $('input')[0] === false && el.attr('autocomplete') === 'on') {
                  el.attr('autocomplete', 'off');
                }

                p.destroyEvents();
                p.events();

                var caret = p.getCaret();
                p.val(p.getMasked());
                p.setCaret(caret + p.getMCharsBeforeCount(caret, true));

            } else {
                p.events();
                p.val(p.getMasked());
            }
        };

        jMask.init(!el.is('input'));
    };

    $.maskWatchers = {};
    var HTMLAttributes = function () {
            var input = $(this),
                options = {},
                prefix = 'data-mask-',
                mask = input.attr('data-mask');

            if (input.attr(prefix + 'reverse')) {
                options.reverse = true;
            }

            if (input.attr(prefix + 'clearifnotmatch')) {
                options.clearIfNotMatch = true;
            }

            if (input.attr(prefix + 'selectonfocus') === 'true') {
               options.selectOnFocus = true;
            }

            if (notSameMaskObject(input, mask, options)) {
                return input.data('mask', new Mask(this, mask, options));
            }
        },
        notSameMaskObject = function(field, mask, options) {
            options = options || {};
            var maskObject = $(field).data('mask'),
                stringify = JSON.stringify,
                value = $(field).val() || $(field).text();
            try {
                if (typeof mask === 'function') {
                    mask = mask(value);
                }
                return typeof maskObject !== 'object' || stringify(maskObject.options) !== stringify(options) || maskObject.mask !== mask;
            } catch (e) {}
        };


    $.fn.mask = function(mask, options) {
        options = options || {};
        var selector = this.selector,
            globals = $.jMaskGlobals,
            interval = $.jMaskGlobals.watchInterval,
            maskFunction = function() {
                if (notSameMaskObject(this, mask, options)) {
                    return $(this).data('mask', new Mask(this, mask, options));
                }
            };

        $(this).each(maskFunction);

        if (selector && selector !== '' && globals.watchInputs) {
            clearInterval($.maskWatchers[selector]);
            $.maskWatchers[selector] = setInterval(function(){
                $(document).find(selector).each(maskFunction);
            }, interval);
        }
        return this;
    };

    $.fn.unmask = function() {
        clearInterval($.maskWatchers[this.selector]);
        delete $.maskWatchers[this.selector];
        return this.each(function() {
            var dataMask = $(this).data('mask');
            if (dataMask) {
                dataMask.remove().removeData('mask');
            }
        });
    };

    $.fn.cleanVal = function() {
        return this.data('mask').getCleanVal();
    };

    $.applyDataMask = function(selector) {
        selector = selector || $.jMaskGlobals.maskElements;
        var $selector = (selector instanceof $) ? selector : $(selector);
        $selector.filter($.jMaskGlobals.dataMaskAttr).each(HTMLAttributes);
    };

    var globals = {
        maskElements: 'input,td,span,div',
        dataMaskAttr: '*[data-mask]',
        dataMask: true,
        watchInterval: 300,
        watchInputs: true,
        watchDataMask: false,
        byPassKeys: [9, 16, 17, 18, 36, 37, 38, 39, 40, 91],
        translation: {
            '0': {pattern: /\d/},
            '9': {pattern: /\d/, optional: true},
            '#': {pattern: /\d/, recursive: true},
            'A': {pattern: /[a-zA-Z0-9]/},
            'S': {pattern: /[a-zA-Z]/}
        }
    };

    $.jMaskGlobals = $.jMaskGlobals || {};
    globals = $.jMaskGlobals = $.extend(true, {}, globals, $.jMaskGlobals);

    // looking for inputs with data-mask attribute
    if (globals.dataMask) { $.applyDataMask(); }

    setInterval(function(){
        if ($.jMaskGlobals.watchDataMask) { $.applyDataMask(); }
    }, globals.watchInterval);
}));


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1).module('oly.common').service('MemoScrollService', ['$timeout', __webpack_require__(632)]);

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var $ = __webpack_require__(2);

var MemoScrollService = function () {
    function MemoScrollService($timeout) {
        _classCallCheck(this, MemoScrollService);

        this.$timeout = $timeout;
        this.scrollPositions = {};
        this.previousUrl = '';
        this.currentUrl = '';
    }

    /**
     * Restores a scroll position saved under the given name to the element. If no element is provided,
     * the scroll position is restored to the document.
     * @param {String} name - The name under which the scroll position was saved.
     * @param {(Element|jQuery|String)} [element=document] - The element which the scroll position should be restored to.
     */


    _createClass(MemoScrollService, [{
        key: 'restoreScrollPosition',
        value: function restoreScrollPosition(name, element) {
            var _this = this;

            var $el = $(element || document);

            if (name in this.scrollPositions) {
                this.$timeout(function () {
                    $el.scrollTop(_this.scrollPositions[name]);
                    _this.forgetScrollPosition(name);
                }, 100, false);
            } else {
                $el.scrollTop(0);
            }
        }

        /**
         * Remembers the scroll position of a given element.
         * @param {String} name - The name under which to save the scroll position.
         * @param {(Element|jQuery|String)} [element=document] - The element from which the scroll position should be fetched.
         */

    }, {
        key: 'rememberScrollPosition',
        value: function rememberScrollPosition(name, element) {
            var $el = $(element || document);

            if ($el.scrollTop() > 0) {
                this.scrollPositions[name] = $el.scrollTop() > $(window).height() ? $el.scrollTop() - $(window).height() : $el.scrollTop();
            }
        }

        /**
         * Forgets the scroll position for a given memo.
         * @param {String} name  - The name of the memo to forget.
         * @returns {Boolean}
         */

    }, {
        key: 'forgetScrollPosition',
        value: function forgetScrollPosition(name) {
            return delete this.scrollPositions[name];
        }
    }]);

    return MemoScrollService;
}();

module.exports = MemoScrollService;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('oly.common');

wowApp.factory('MoveFocus', ['$timeout', '$q', __webpack_require__(634)]);

wowApp.directive('olyMoveFocus', ['MoveFocus', __webpack_require__(635)]);

wowApp.directive('olyMoveFocusOndelete', ['MoveFocus', __webpack_require__(636)]);

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(2);

module.exports = function ($timeout, $q) {
    function focus(elementOrCb) {
        // If the element passed was a function, execute the function.
        var element = typeof elementOrCb === 'function' ? elementOrCb() : elementOrCb;

        // Use the jquery object passed, or select one.
        var $element = element instanceof $ ? element : $(element);
        if ($element.length) {
            // check to see if item can accept focus
            if (!$element.is(':focusable') && typeof $element.attr('tabindex') === 'undefined') {
                $element.attr('tabindex', '-1');
            }

            $element.focus();
        }
    }

    return function (elementOrCb) {
        var immediate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        return immediate ? $q.when(focus(elementOrCb)) : $timeout(function () {
            return focus(elementOrCb);
        }, 0, false);
    };
};

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 * Usage:
 * syntax: <input oly-move-focus="target"/>
 * target: value of the name attribute of the input to be tabbed to (required as getting the 'next' element is complicated)
 *
 * example 1: The following will tab to an input with id 'input-box' when a checkbox is ticked
 *          <input type="checkbox" oly-move-focus="idOfTarget"/>
 *
 * example 2: The following will tab to another element not in natural tab order on blur
 *          <input type="text" id="somebox" oly-move-focus="to-element-id" oly-move-focus-event="blur" />
 *
 * Doesn't work if the element needed to move focus to isn't visible.
 */

module.exports = function (focus) {
    return function (scope, elem, attr) {
        var event = attr.olyMoveFocusEvent || 'click';
        elem.on(event, function () {
            if (scope.isEnabled) {
                if (attr.olyMoveFocus.indexOf('.') === -1 && attr.olyMoveFocus.indexOf('#') === -1) {
                    focus('#' + attr.olyMoveFocus);
                } else {
                    focus(attr.olyMoveFocus);
                }
            }
        });
        var ifExpression = attr.olyMoveFocusIf;
        scope.$watch(ifExpression, function (value) {
            scope.isEnabled = value === undefined ? true : value;
        });
    };
};

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This directive manages focus on items which can be removed from the DOM and are in a ng-repeat.
 * Focus will move to the next item in the list, or previous if there is no next item.
 * if there are no more items in the list, then move to the parent.
 *
 * Works best when tracking changes of the ng-repeat is optimized by a "track by" expression.
 */
module.exports = function (moveFocus) {
    return function (scope, element) {
        scope.$on('$destroy', function () {
            var $parent = element.parent();
            var $elemNext = element.next();
            var $elemToFocus = $elemNext.length && element[0].nodeName === $elemNext[0].nodeName ? $elemNext : element.prev();

            // move focus if element to focus is the same as this, or move to parent element.
            moveFocus($elemToFocus.length && element[0].nodeName === $elemToFocus[0].nodeName ? $elemToFocus : $parent);
        });
    };
};

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('oly.common');

wowApp.service('NotificationService', ['$timeout', __webpack_require__(638)]);

wowApp.directive('wowNotification', ['NotificationService', __webpack_require__(639)]);

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var globalTargetName = '_global';

var NotificationService = function NotificationService($timeout) {
    this.$timeout = $timeout;

    // A dictionary of notification targets;
    this.targets = {};

    this.targets[globalTargetName] = {
        visible: false,
        message: '',
        classes: []
    };
};
NotificationService.prototype.showNotification = function (notification, target) {
    var classList = _([]);

    if (!target) {
        classList.push('notification--global');
    }

    classList = classList.concat(notification.classes);

    target = target || globalTargetName; // if target is falsey target the global notification area.

    this.targets[target].message = notification.message;
    this.targets[target].classes = classList.valueOf();
    this.targets[target].visible = true;

    if (notification.timeout) {
        this.$timeout(this.hideNotification.bind(this, target), notification.timeout);
    }
};

NotificationService.prototype.showErrorNotification = function (notification, target) {
    notification.classes.push('notification--error');

    return this.showNotification(notification, target);
};

NotificationService.prototype.hideNotification = function (target) {
    target = target || globalTargetName;

    this.targets[target].visible = false;
};

NotificationService.prototype.registerNotficationTarget = function (target) {
    target = target || globalTargetName;
    if (!(target in this.targets)) {
        this.targets[target] = {
            visible: false,
            message: '',
            classes: []
        };
    }

    return this.targets[target];
};

module.exports = NotificationService;

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (notificationService) {
    return {
        restrict: 'E',
        scope: {
            name: '@?'
        },
        link: function link(scope) {
            scope.notification = notificationService.registerNotficationTarget(scope.name);

            scope.closeNotification = notificationService.hideNotification.bind(notificationService, scope.name);
        },

        template: __webpack_require__(640).trim()
    };
};

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports = "<div class=\"notification\" ng-show=\"notification.visible\" ng-class=\"notification.classes\">\r\n    {{notification.message}}\r\n\r\n    <i class=\"icon-close_x notification-close\" ng-click=\"closeNotification()\"></i>\r\n</div>"

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('oly.common');

wowApp.directive('olyNumeric', [__webpack_require__(642)]);

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 * Restricts the text input to be numerical characters only (only works with input of type text)
 * Supports decimal numbers if you assign the directive attribute a value of "decimal". Example: wow-numeric="decimal"
 */
module.exports = function () {
    return {
        restrict: 'A',
        require: '?ngModel',
        link: function link(scope, element, attrs, ngModelCtrl) {
            var last = '';
            ngModelCtrl.$parsers.push(function (val) {
                if (!val) {
                    val = '';
                }
                var clean = '';
                if (attrs.olyNumeric === 'decimal') {
                    clean = val.replace(/[^0-9.]+/g, '');
                    if (clean.indexOf('.') !== clean.lastIndexOf('.')) {
                        if (clean.lastIndexOf('.') === clean.length - 1) {
                            clean = clean.substring(-1, clean.length - 1);
                        } else {
                            // If we get here they tried to paste a number in that made it invalid (multiple decimal points) so revert it to the old value
                            clean = last;
                        }
                    }
                } else {
                    clean = val.replace(/[^0-9]+/g, '');
                }
                if (val !== clean) {
                    ngModelCtrl.$setViewValue(clean);
                    ngModelCtrl.$render();
                }
                last = clean;
                return clean;
            });
        }
    };
};

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(644),
    onBlurDirectiveDefinition = _require.onBlurDirectiveDefinition;

angular.module('oly.common').directive('olyOnBlur', [onBlurDirectiveDefinition]);

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @ngdoc directive
 * @name olyOnBlur
 *
 * This component captures blur events from all children of an element and evaluates the given
 * expression whenever focus moves out of the element where is was put.
 *
 * This differs from ng-blur because ng-blur doesn't capture blur events from children.
 */
var onBlurDirectiveDefinition = function onBlurDirectiveDefinition() {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            function closeIfFocusOutside($event) {
                setTimeout(function () {
                    /* RelatedTarget & document.activeElement works in Chrome
                       ExplicitOriginalTarget works in Firefox
                       In Safari, RelatedTarget and document.activeElement returns an incorrect value (usually the body) if a button/input is clicked
                    */
                    var focusedElement = $event.relatedTarget || $event.explicitOriginalTarget || document.activeElement;

                    if (focusedElement !== null && !element.is(focusedElement) && element.has(focusedElement).length === 0) {
                        scope.$apply(function () {
                            return scope.$evalAsync(attrs.olyOnBlur);
                        });
                    }
                });
            }

            // capture allows us to get blur events from children
            element[0].addEventListener('blur', function ($event) {
                return closeIfFocusOutside($event);
            }, true);
        }
    };
};

module.exports = {
    onBlurDirectiveDefinition: onBlurDirectiveDefinition
};

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(646),
    onTouchendDirectiveDefinition = _require.onTouchendDirectiveDefinition;

angular.module('oly.common').directive('olyOnTouchend', [onTouchendDirectiveDefinition]);

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var onTouchendDirectiveDefinition = function onTouchendDirectiveDefinition() {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            function onTouchEnd(event) {
                scope.$apply(function () {
                    return scope.$evalAsync(attrs.olyOnTouchend, { $event: event });
                });
            }

            element.bind('touchend', onTouchEnd);
        }
    };
};

module.exports = { onTouchendDirectiveDefinition: onTouchendDirectiveDefinition };

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1).module('oly.common').directive('olyOpenWindow', [__webpack_require__(648)]);

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

module.exports = function () {
    return {
        restrict: 'A',
        scope: false,
        controller: ['$element', '$attrs', function ($element, $attrs) {
            var features = {
                menubar: $attrs.windowMenubar || 'no',
                toolbar: $attrs.windowToolbar || 'no',
                resizable: $attrs.windowResizable || 'yes',
                scrollbars: $attrs.windowScrollbars || 'yes',
                height: $attrs.windowHeight || 420,
                width: $attrs.windowWidth || 550
            };
            var featureString = _.map(features, function (value, feature) {
                return feature + '=' + value;
            }).join(',');

            $element.on('click', function (e) {
                e.preventDefault();

                window.open($attrs.href, $attrs.windowTitle, featureString);
            });
        }]
    };
};

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(650),
    pagingComponentDefinition = _require.pagingComponentDefinition;

angular.module('oly.common').component('olyPaging', pagingComponentDefinition);

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    range = _require.range;

function getPageNumberSlice(pageNumbers, currentPage, totalPages, pagingElement) {
    var isPrevVisible = currentPage !== 1;
    var isNextVisible = currentPage !== totalPages;
    var numberOfPageNumbersToDisplay = Math.floor((pagingElement.width() - parseInt(parseFloat(pagingElement.css('marginLeft')) + parseFloat(pagingElement.css('marginRight'))) - (isPrevVisible ? pagingElement.find('._pagingPrevious').width() : 0) - (isNextVisible ? pagingElement.find('._pagingNext').width() : 0)) / (pagingElement.find('._pageNumber').width() || 45));

    // Make the slice a be window centered on the current page.
    // In the case that the numbe if pages to display is even, show higher numbers
    var startingIndex = currentPage - Math.floor(numberOfPageNumbersToDisplay / 2) - (numberOfPageNumbersToDisplay % 2 === 0 ? 0 : 1);

    // Clamp the starting index to the array bounds
    startingIndex = Math.max(0, Math.min(pageNumbers.length - numberOfPageNumbersToDisplay, startingIndex));

    return pageNumbers.slice(startingIndex, startingIndex + numberOfPageNumbersToDisplay);
}

var PagingController = function () {
    function PagingController($state, $element, $timeout, pageMetadataService) {
        _classCallCheck(this, PagingController);

        this.$state = $state;
        this.$element = $element;
        this.$timeout = $timeout;
        this.pageMetadataService = pageMetadataService;
    }

    _createClass(PagingController, [{
        key: '$onInit',
        value: function $onInit() {
            this.updateMetadata = this.updateMetadata !== undefined ? this.updateMetadata : true;
            this.totalCount = this.totalCount === undefined ? 0 : this.totalCount;

            this.onUpdateCurrentPage();
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.pageSize || changes.totalCount) {
                this.shouldDisplay = this.pageSize < this.totalCount;
                this.pageNumbers = range(1, Math.ceil(this.totalCount / this.pageSize) + 1);

                if (changes.currentPage) {
                    this.onUpdateCurrentPage();
                }

                this.updateVisiblePageNumbers();
            }
        }
    }, {
        key: 'onUpdateCurrentPage',
        value: function onUpdateCurrentPage() {
            if (this.currentPage > this.pageNumbers.length) {
                this.$state.go('error.404', null, { location: 'replace' });
            }

            this.showPreviousButton = this.currentPage !== 1;
            this.showNextButton = this.currentPage !== this.pageNumbers.length;

            if (this.updateMetadata) {
                this.pageMetadataService.controlSeries(this.currentPage, this.pageNumbers.length);
            }

            this.pageMetadataService.setMetaRobotOnPageChange(this.currentPage, this.updateMetadata);
        }
    }, {
        key: 'updateVisiblePageNumbers',
        value: function updateVisiblePageNumbers() {
            var _this = this;

            this.$timeout(function () {
                _this.visiblePageNumbers = getPageNumberSlice(_this.pageNumbers, _this.currentPage, _this.pageNumbers.length, _this.$element.find('._pagingControl'));
            });
        }
    }, {
        key: 'updatePageNumber',
        value: function updatePageNumber(page) {
            this.$state.go('.', { pageNumber: page });
        }
    }]);

    return PagingController;
}();

PagingController.$inject = ['$state', '$element', '$timeout', 'PageMetadataService'];

var pagingComponentDefinition = {
    bindings: {
        currentPage: '<',
        pageSize: '<',
        totalCount: '<',
        onPageSelect: '&',
        updateMetadata: '<?'
    },
    controller: PagingController,
    template: __webpack_require__(651).trim()
};

module.exports = {
    PagingController: PagingController,
    pagingComponentDefinition: pagingComponentDefinition
};

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports = "<div class=\"paging _pagingControl\"\r\n     ng-if=\"$ctrl.shouldDisplay\">\r\n    <a rel=\"prev\"\r\n       class=\"paging-previous _pagingPrevious\"\r\n       ng-if=\"$ctrl.showPreviousButton\"\r\n       ng-click=\"$ctrl.updatePageNumber($ctrl.currentPage - 1); $ctrl.onPageSelect({ pageNumber: $ctrl.currentPage - 1 })\">\r\n        <i class=\"iconww-ArrowLeft\"></i>Previous <span class=\"sr-only\">Page</span>\r\n    </a>\r\n\r\n    <a class=\"paging-pageNumber _pageNumber {{'_pageNumber' + pageNumber}}\"\r\n       ng-class=\"{'is-selected': $ctrl.currentPage === pageNumber}\"\r\n       ng-click=\"$ctrl.updatePageNumber(pageNumber); $ctrl.onPageSelect({ pageNumber: pageNumber })\"\r\n       ng-repeat=\"pageNumber in $ctrl.visiblePageNumbers track by pageNumber\">\r\n        <span class=\"sr-only\" ng-if=\"$ctrl.currentPage === pageNumber\">You are on </span>\r\n        <span class=\"sr-only\">Page</span>\r\n        {{pageNumber}}\r\n    </a>\r\n\r\n    <a rel=\"next\"\r\n       class=\"paging-next _pagingNext\"\r\n       ng-if=\"$ctrl.showNextButton\"\r\n       ng-click=\"$ctrl.updatePageNumber($ctrl.currentPage + 1); $ctrl.onPageSelect({ pageNumber: $ctrl.currentPage + 1 });\">\r\n        Next <span class=\"sr-only\">Page</span><i class=\"iconww-ArrowRight\"></i>\r\n    </a>\r\n</div>\r\n"

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('oly.common');

wowApp.directive('wowPostCode', [__webpack_require__(653)]);

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

module.exports = function () {
    return {
        restrict: 'A',
        require: '?ngModel',
        link: function link(scope, element, attrs, ngModelCtrl) {
            if (!ngModelCtrl) {
                return;
            }

            scope.validate = function (model, postcode) {
                if (postcode.length === 0) {
                    ngModelCtrl.$setValidity('required', false);
                } else if (postcode.length > 0) {
                    ngModelCtrl.$setValidity('required', true);
                }
                if (postcode.length > 0 && postcode.length < 4) {
                    ngModelCtrl.$setValidity('invalid', false);
                } else if (postcode.length === 0 || postcode.length === 4) {
                    ngModelCtrl.$setValidity('invalid', true);
                }
            };

            ngModelCtrl.$parsers.push(function (val) {
                if (angular.isUndefined(val)) {
                    val = '';
                }
                var clean = val.replace(/[^0-9]+/g, '');

                if (clean.length > 4) {
                    clean = clean.substring(0, 4);
                }

                if (val !== clean) {
                    ngModelCtrl.$setViewValue(clean);
                    ngModelCtrl.$render();
                }

                scope.validate(ngModelCtrl, clean);
                return clean;
            });

            element.bind('keypress', function (event) {
                if (event.keyCode === 32) {
                    event.preventDefault();
                }
            });
        }
    };
};

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var resourceInjector = __webpack_require__(655);

angular.module('oly.common').service('ResourceInjector', resourceInjector);

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    merge = _require.merge;

var ResourceInjector = function () {
    function ResourceInjector($document, $q) {
        _classCallCheck(this, ResourceInjector);

        this.$document = $document[0];
        this.$q = $q;
    }

    _createClass(ResourceInjector, [{
        key: 'createScript',
        value: function createScript(url) {
            var tagParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var script = this.$document.createElement('script');
            script.type = 'text/javascript';
            script.src = url;
            if (tagParams) {
                script = merge(script, tagParams);
            }
            return script;
        }
    }, {
        key: 'createLink',
        value: function createLink(url) {
            var tagParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var link = this.$document.createElement('link');
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.href = url;
            if (tagParams) {
                link = merge(link, tagParams);
            }
            return link;
        }
    }, {
        key: 'isScriptInjected',
        value: function isScriptInjected(url, element) {
            return !!(element || this.$document.head).querySelector('[src="' + url + '"]');
        }
    }, {
        key: 'isStylesheetInjected',
        value: function isStylesheetInjected(url, element) {
            return !!(element || this.$document.head).querySelector('[href="' + url + '"]');
        }
    }, {
        key: 'injectScript',
        value: function injectScript(url) {
            var tagParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            return this.injectResource(url, this.createScript.bind(this), this.isScriptInjected.bind(this), tagParams);
        }
    }, {
        key: 'injectStylesheet',
        value: function injectStylesheet(url) {
            var tagParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            return this.injectResource(url, this.createLink.bind(this), this.isStylesheetInjected.bind(this), tagParams);
        }
    }, {
        key: 'injectScripts',
        value: function injectScripts(urls) {
            return this.$q.all(urls.map(this.injectScript.bind(this)));
        }
    }, {
        key: 'injectStylesheets',
        value: function injectStylesheets(urls) {
            return this.$q.all(urls.map(this.injectStylesheet.bind(this)));
        }
    }, {
        key: 'injectResource',
        value: function injectResource(url, buildAssetFn, isInjectedFn) {
            var tagParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

            var deferred = this.$q.defer();
            if (!isInjectedFn(url)) {
                var assetEl = buildAssetFn(url, tagParams);
                assetEl.onload = deferred.resolve;
                assetEl.onerror = deferred.reject;
                document.head.appendChild(assetEl);
            } else {
                deferred.resolve();
            }

            return deferred.promise;
        }
    }]);

    return ResourceInjector;
}();

ResourceInjector.$inject = ['$document', '$q'];

module.exports = ResourceInjector;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1).module('oly.common').directive('wowScrollbar', ['$timeout', __webpack_require__(657)]);

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(2),
    scrollSize = __webpack_require__(21);

module.exports = function ($timeout) {
    return {
        restrict: 'A',
        require: 'wowHideScroll',
        controller: ['$element', '$attrs', function ($element, $attrs) {
            // Get our jquery objects
            var $window = $(window);

            var $scrollRail = $('<div class="wowScrollbar"><div class="wowScrollbar-indicator"></div></div>');
            var $scrollIndicator = $scrollRail.children('.wowScrollbar-indicator');
            var $scrollArea = $element.children('.hideScroll-wrapper').first();
            var $scrollHeader = $element.find('._autoHideScrollHeader');
            var scrollingEnabled = false,
                timeoutPromise = null,
                visibleHeight = void 0,
                indicatorHeight = void 0,
                maxScrollTop = void 0,
                previousScrollPos = 0;

            var hasScrollbar = scrollSize() > 0,

            // The minimum indicator width can be overridden. This is used for the visual
            // shopping scroller but SHOULD NOT be used otherwise.
            minIndicatorWidth = parseInt($attrs.wowScrollbar) || 10;

            function getIndicatorPosition(scrollTop) {
                return scrollTop / maxScrollTop * (visibleHeight - indicatorHeight);
            }

            function getScrollTop(indicatorPosition) {
                return maxScrollTop * indicatorPosition / (visibleHeight - indicatorHeight);
            }

            function translateToRelative(yCoord, element) {
                element = element || $scrollRail;

                return yCoord - element.offset().top;
            }

            function isClickInsideScrollIndicator(clickY) {
                var scrollIndicatorTop = $scrollIndicator.offset().top;
                var scrollIndicatorBottom = scrollIndicatorTop + indicatorHeight;
                return clickY >= scrollIndicatorTop && clickY <= scrollIndicatorBottom;
            }

            function scrollToIndicatorPosition(indicatorPosition) {
                return $scrollArea.scrollTop(getScrollTop(indicatorPosition));
            }

            function recalculateSizes() {
                // Get the heights we're concerned with.
                var contentHeight = $scrollArea[0].scrollHeight;
                visibleHeight = $element.height();

                // Set the indicator's height proportianally.
                indicatorHeight = Math.max(minIndicatorWidth, visibleHeight / contentHeight * visibleHeight);
                $scrollIndicator.css('height', indicatorHeight);

                maxScrollTop = contentHeight - visibleHeight;

                $scrollRail.toggleClass('is-notScrollable', visibleHeight === indicatorHeight);
            }

            function onRailMousedown(mousedownEvent) {
                mousedownEvent.preventDefault();

                var origClickY = mousedownEvent.pageY;
                var origScrollIndicatorTop = $scrollIndicator.position().top;

                if (!isClickInsideScrollIndicator(mousedownEvent.pageY)) {
                    origScrollIndicatorTop = translateToRelative(mousedownEvent.pageY) - 0.1 * indicatorHeight;
                    scrollToIndicatorPosition(origScrollIndicatorTop);
                }

                $window.on('mousemove.scrollbar', function (mousemoveEvent) {
                    mousemoveEvent.preventDefault();

                    requestAnimationFrame(function () {
                        var mouseDeltaY = origClickY - mousemoveEvent.pageY;
                        var newIndicatorPosition = origScrollIndicatorTop - mouseDeltaY;
                        scrollToIndicatorPosition(newIndicatorPosition);
                    });
                });

                $window.on('mouseup', function () {
                    $window.off('mousemove.scrollbar');
                });
            }

            function hideScrollHeader() {
                if ($scrollHeader.length) {
                    var currentScrollPos = $scrollArea.scrollTop();
                    var isBottom = $scrollArea[0].clientHeight + $scrollArea[0].scrollTop >= $scrollArea[0].scrollHeight;
                    var isTop = $scrollArea.scrollTop() < 0;
                    // Make sure the positions don't match and not the top or bottom of the page (fix for iOS bouncing at the top/bottom)
                    if (previousScrollPos !== currentScrollPos && !isBottom) {
                        // Check if it's a scroll up or scroll down and if the header is on the screen. Then set the CSS properties
                        var isScrollUp = previousScrollPos > currentScrollPos;
                        var isHeaderStillOnScreen = $scrollHeader.height() > currentScrollPos;
                        var transform = isScrollUp || isHeaderStillOnScreen ? 'none' : 'translateY(-100%)';
                        var position = (isHeaderStillOnScreen || isTop) && !isScrollUp ? 'static' : 'sticky';
                        var webkitPosition = (isHeaderStillOnScreen || isTop) && !isScrollUp ? 'static' : '-webkit-sticky';
                        // Set transition if the header is not of screen. Adding a buffer of 20, so the transition doesn't flicker
                        var transition = $scrollHeader.height() + 20 < currentScrollPos ? 'transform 300ms linear' : 'none';

                        $scrollHeader.css({
                            '-webkit-transform': transform,
                            transform: transform,
                            position: position,
                            transition: transition
                        });
                        $scrollHeader.css({ position: webkitPosition });

                        previousScrollPos = currentScrollPos;
                    }
                }
            }

            function onScrollAreaSroll() {
                requestAnimationFrame(function () {
                    // Cancel the timeout if we scroll before it completes
                    if (timeoutPromise) {
                        $timeout.cancel(timeoutPromise);
                    }
                    var scrollTop = $scrollArea.scrollTop();
                    // The indicator position is the proportion of scrollability multiplied by the space that is available to scroll within.
                    var indicatorPosition = getIndicatorPosition(scrollTop);

                    // Set the position
                    $scrollIndicator.css('top', indicatorPosition + 'px');

                    // Show the indicator
                    $scrollRail.addClass('is-active');
                    $element.toggleClass('is-scrolled', scrollTop > 0);

                    // Hide the header if exists
                    hideScrollHeader();
                    // Set a timeout to hide the indicator
                    timeoutPromise = $timeout(function () {
                        $scrollRail.removeClass('is-active');
                    }, 1200, false);
                });
            }

            this.enableScrolling = function () {
                if (hasScrollbar && !scrollingEnabled) {
                    scrollingEnabled = true;

                    $element.append($scrollRail);

                    recalculateSizes();

                    $scrollArea.on('scroll.scrollbar', onScrollAreaSroll);
                    $scrollRail.on('mousedown.scrollbar', onRailMousedown);

                    $scrollArea.on('scrollstart.scrollbar', recalculateSizes);
                    $scrollRail.on('mouseenter.scrollbar', recalculateSizes);

                    $scrollArea.on('mouseenter.scrollbar', recalculateSizes);
                }
            };

            this.disableScrolling = function () {
                if (hasScrollbar && scrollingEnabled) {
                    scrollingEnabled = false;

                    $scrollRail.detach();

                    $scrollArea.off('scroll.scrollbar');
                    $scrollRail.off('mousedown.scrollbar');

                    $scrollArea.off('scrollstart.scrollbar');
                    $scrollRail.off('mouseenter.scrollbar');

                    $scrollArea.off('mouseenter.scrollbar');
                }
            };

            if (!hasScrollbar || $scrollArea.length <= 0) {
                // we are most likely on a mobile device
                $scrollArea.on('scroll', function () {
                    requestAnimationFrame(function () {
                        var scrollTop = $scrollArea.scrollTop();
                        // Let the element style itself when it's scrolled
                        $element.toggleClass('is-scrolled', scrollTop > 0);

                        // Hide the header if exists
                        hideScrollHeader();
                    });
                });
            } else {
                this.enableScrolling();
            }
        }]
    };
};

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1).module('oly.common').directive('wowSelectContainer', [__webpack_require__(659)]);

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
    return {
        restrict: 'E',
        transclude: true,
        link: function link(scope, element, iAttrs, controller, transcludeFn) {
            transcludeFn(function (clone) {
                element.append(clone);
            });

            var selectLabel = element.find('label');
            if (selectLabel && selectLabel.length) {
                selectLabel.addClass('olySelect-label');
                element.find('select').addClass('olySelect-select wowInput');
            } else {
                element.find('select').addClass('olySelect-selectNoLabel wowInput');
            }
        },

        template: '<i class="olySelect-icon iconww-ArrowDown"></i>'
    };
};

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1).module('oly.common').factory('serializeAsync', ['$q', __webpack_require__(661)]);

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($q) {
    /**
     * Takes a function that returns a promise and creates a new function that,
     * when called many times will reject previously returned promises when they
     * resolve.
     * @param {Function} fn - Function that returns a promise
     * @param {Object} [context] - The context to bind the function to.
     * @returns {Promise}
     */
    return function serializeAsync(fn, context) {
        var callCount = 0;

        return function () {
            callCount++;
            var version = callCount;

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            var promise = fn.apply(context, args);

            return promise.then(function () {
                if (version < callCount) {
                    return $q.reject('Async action superseded.');
                }

                return promise;
            });
        };
    };
};

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1).module('oly.common').directive('olySlideup', __webpack_require__(663).slideupStickyDirectiveDefinition);

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var $ = __webpack_require__(2);

var _require = __webpack_require__(0),
    isNumber = _require.isNumber;

/**
 * This directive adds the following class to an element when the document scrolls at a certain direction.
 *  - is-default : default behaviour, this is added when the scroll direction is not detected.
 *  - is-scrolled-up : when the site is being scrolled up.
 *  - is-scrolled-down : when the site is being scrolled down
 * It leaves the actual implemntation of the classes up to the caller.
 */


var SlideupStickyController = function () {
    function SlideupStickyController($element, $window, $timeout) {
        _classCallCheck(this, SlideupStickyController);

        this.$element = $element;
        this.$window = $window;
        this.$timeout = $timeout;
    }

    _createClass(SlideupStickyController, [{
        key: '$onInit',
        value: function $onInit() {
            this.prevOffset = -1;
            this.scrollState = 'is-default';
        }
    }, {
        key: '$postLink',
        value: function $postLink() {
            var _this = this;

            this.$timeout(function () {
                _this.activeOffset = _this.getActiveOffset();
            }, 0, false);
            this.$element.addClass(this.scrollState);

            this.onScroll = function () {
                return requestAnimationFrame(function () {
                    return _this.toggleSlideup();
                });
            };
            document.addEventListener('scroll', this.onScroll, { passive: true });
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            document.removeEventListener('scroll', this.onScroll, { passive: true });
        }
    }, {
        key: 'getActiveOffset',
        value: function getActiveOffset() {
            if (this.offset == null) {
                return 0;
            }
            if (isNumber(this.offset)) {
                return this.offset;
            }

            return $(this.offset).outerHeight();
        }
    }, {
        key: 'toggleSlideup',
        value: function toggleSlideup() {
            // pageYOffset for IE
            var currentScroll = this.$window.scrollY || this.$window.pageYOffset,
                delta = currentScroll - this.prevOffset;
            var state = void 0;

            // always display as normal when the window is scrolled beyond the active offset.
            // Otherwise check the scroll difference and switch class accordingly.
            if (!(currentScroll > this.activeOffset)) {
                state = 'is-default';
            } else if (delta < 0) {
                state = 'is-scrolled-up';
            } else if (delta > 0) {
                state = 'is-scrolled-down';
            }

            if (state && this.scrollState !== state) this.changeState(state);
            this.prevOffset = currentScroll;
        }
    }, {
        key: 'changeState',
        value: function changeState(state) {
            this.$element.removeClass('is-default is-scrolled-down is-scrolled-up');
            this.$element.addClass(state);
            this.scrollState = state;
        }
    }]);

    return SlideupStickyController;
}();

var slideupStickyDirectiveDefinition = function slideupStickyDirectiveDefinition() {
    return {
        restrict: 'A',
        scope: {
            offset: '=?olySlideup'
        },
        controller: ['$element', '$window', '$timeout', SlideupStickyController],
        bindToController: true,
        controllerAs: '$ctrl'
    };
};

module.exports = {
    SlideupStickyController: SlideupStickyController,
    slideupStickyDirectiveDefinition: slideupStickyDirectiveDefinition
};

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(665),
    stickyDirectiveDefinition = _require.stickyDirectiveDefinition;

angular.module('oly.common').directive('olySticky', [stickyDirectiveDefinition]);

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var $ = __webpack_require__(2);

var _require = __webpack_require__(0),
    isNumber = _require.isNumber;

/**
 * This directive adds a class "is-sticky" to an element when the document scrolls past a given position.
 * It leaves the actual implemntation of the "is-sticky" class up to the caller.
 *
 * @class StickyController
 */


var StickyController = function () {
    function StickyController($element, $timeout) {
        _classCallCheck(this, StickyController);

        this.$element = $element;
        this.$timeout = $timeout;
    }

    _createClass(StickyController, [{
        key: '$onInit',
        value: function $onInit() {
            this.isSticky = false;
        }
    }, {
        key: '$postLink',
        value: function $postLink() {
            var _this = this;

            this.$timeout(function () {
                _this.stickAtScrollPosition = _this.calculateStickAt();
                _this.toggleSticky();
            }, 0, false);

            this.scrollingElement = document.scrollingElement ? document.scrollingElement : document.documentElement;

            this.onScroll = function () {
                return requestAnimationFrame(function () {
                    return _this.toggleSticky();
                });
            };
            document.addEventListener('scroll', this.onScroll, { passive: true });
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            document.removeEventListener('scroll', this.onScroll, { passive: true });
        }
    }, {
        key: 'calculateStickAt',
        value: function calculateStickAt() {
            if (this.stickAtScrollPosition) {
                return this.stickAtScrollPosition;
            }
            if (this.stickTo == null) {
                // By default, stick when this element reaches the top.
                return this.$element.offset().top;
            }

            if (isNumber(this.stickTo)) {
                return this.stickTo;
            }

            var $el = $(this.stickTo);

            if ($el && $el.length > 0) {
                return $el.offset().top + $el.outerHeight();
            }

            throw Error('Provided position to stick to must be a number.');
        }
    }, {
        key: 'toggleSticky',
        value: function toggleSticky() {
            var wasSticky = this.isSticky;
            this.isSticky = this.scrollingElement.scrollTop > this.calculateStickAt();

            if (!wasSticky && this.isSticky) {
                this.$element.addClass('is-sticky');
            } else if (wasSticky && !this.isSticky) {
                this.$element.removeClass('is-sticky');
            }
        }
    }]);

    return StickyController;
}();

var stickyDirectiveDefinition = function stickyDirectiveDefinition() {
    return {
        restrict: 'A',
        scope: {
            stickTo: '=?olySticky'
        },
        controller: ['$element', '$timeout', StickyController],
        bindToController: true,
        controllerAs: '$ctrl'
    };
};

module.exports = {
    StickyController: StickyController,
    stickyDirectiveDefinition: stickyDirectiveDefinition
};

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1).module('oly.common').directive('olyTooltip', [__webpack_require__(667)]).directive('olyQuestionmarkTooltip', [__webpack_require__(668)]);

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var messageDataAttr = 'data-tooltip-message';
var olyTooltipClass = 'oly-tooltip';
var isTooltipshownClass = 'is-tooltipShown';

var $ = __webpack_require__(2);

module.exports = function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {

            // Ensure that the ::after will be positioned correctly
            if (element.css('position') === 'static') {
                element.css('position', 'relative');
            }

            // Add the class that does most of the work
            element.addClass(olyTooltipClass);

            // Determine where the value should come from
            scope.$watch(attrs.olyTooltip, function (val) {
                element.attr(messageDataAttr, val);
            });

            element.on('touchstart', function () {
                element.toggleClass(isTooltipshownClass);

                setTimeout(function () {
                    $(document).off('touchstart.tooltip').one('touchstart.tooltip', function () {
                        element.removeClass(isTooltipshownClass);
                    });
                });
            });
        }
    };
};

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            message: '@?',
            customTooltipClass: '@?'
        },
        template: '<div class="tooltipQuestionmark" ng-class="{{customTooltipClass}}" oly-tooltip="message">\n                        <i class="iconww-DeliveryNotSet"></i>\n                    </div>'
    };
};

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(670),
    transcludeInjectDirectiveDefinition = _require.transcludeInjectDirectiveDefinition;

angular.module('oly.common').directive('transcludeInject', transcludeInjectDirectiveDefinition);

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var transcludeInjectDirectiveDefinition = function transcludeInjectDirectiveDefinition() {
    return {
        scope: {
            slot: '@?transcludeInject',
            injectedItem: '=',
            injectedProperty: '@'
        },

        link: function link($scope, $element, $attrs, controller, $transclude) {
            var injectedProperty = $scope.injectedProperty || 'item';

            if (!$transclude) {
                throw new Error('Cannot inject scope into a non-transcluded child.');
            }

            $transclude(function (clone, scope) {
                scope[injectedProperty] = $scope.injectedItem;
                $element.empty();
                $element.append(clone);
            }, undefined, $scope.slot);
        }
    };
};

module.exports = { transcludeInjectDirectiveDefinition: transcludeInjectDirectiveDefinition };

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(32);

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(673),
    viewMoreComponentDefinition = _require.viewMoreComponentDefinition;

angular.module('oly.common').component('olyViewMore', viewMoreComponentDefinition);

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VIEWMORE_ENABLE_HEIGHT = 72;

var ViewMoreController = function () {
    function ViewMoreController($sce, $timeout, $element) {
        _classCallCheck(this, ViewMoreController);

        this.$sce = $sce;
        this.$timeout = $timeout;
        this.$element = $element;
    }

    _createClass(ViewMoreController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.fullTextValue = this.$sce.trustAsHtml(this.fullText);

            if (!this.isShowHideMode) {
                if (this.charCount < this.fullText.length) {
                    this.isExpanded = false;
                    this.displayText = this.$sce.trustAsHtml(this.fullText.slice(0, this.charCount) + ' ...');
                }
            } else {
                // show hide mode
                this.isExpanded = false;
                this.showMore = true;
                this.$timeout(function () {
                    var actualHeight = _this.$element.find('.js-fulltext-container')[0].scrollHeight;
                    var viewMoreEnableHeight = _this.viewMoreEnableHeight || VIEWMORE_ENABLE_HEIGHT;

                    if (actualHeight <= viewMoreEnableHeight) {
                        _this.showMore = false;
                    }
                });
            }
        }
    }]);

    return ViewMoreController;
}();

var viewMoreComponentDefinition = {
    bindings: {
        charCount: '=',
        isShowHideMode: '=',
        customCollapsedClass: '@',
        fullText: '=',
        customExpandoClass: '@',
        viewMoreEnableHeight: '@'
    },
    controller: ['$sce', '$timeout', '$element', ViewMoreController],
    template: __webpack_require__(674).trim()
};

module.exports = {
    ViewMoreController: ViewMoreController,
    viewMoreComponentDefinition: viewMoreComponentDefinition
};

/***/ }),
/* 674 */
/***/ (function(module, exports) {

module.exports = "<div class=\"viewMore\">\r\n    <div ng-if=\"!$ctrl.isShowHideMode\" ng-switch=\"::$ctrl.charCount < $ctrl.fullText.length\">\r\n        <div class=\"viewMore-expando\" ng-switch-when=\"true\" ng-switch=\"$ctrl.isExpanded\" ng-class=\"{'is-expanded': $ctrl.isExpanded, '{{$ctrl.customExpandoClass}}' : {{!!$ctrl.customExpandoClass}} }\">\r\n            <p ng-bind-html=\"$ctrl.displayText\" ng-switch-when=\"false\" class=\"viewMore-text\"></p>\r\n            <p ng-bind-html=\"$ctrl.fullTextValue\" ng-switch-when=\"true\" class=\"viewMore-text\"></p>\r\n\r\n            <button type=\"button\" class=\"linkButton viewMore-toggle\" ng-click=\"$ctrl.isExpanded = !$ctrl.isExpanded\">\r\n                View {{ $ctrl.isExpanded ? 'less' : 'more' }} <i ng-class=\"$ctrl.isExpanded ? 'iconww-ArrowUp' : 'iconww-ArrowDown'\"></i>\r\n            </button>\r\n        </div>\r\n        <p ng-switch-when=\"false\" ng-bind-html=\"$ctrl.fullTextValue\"></p>\r\n    </div>\r\n\r\n    <div ng-if=\"::$ctrl.isShowHideMode\">\r\n        <div class=\"viewMore-collapsed\" ng-if=\"$ctrl.showMore\" ng-class=\"{'viewMore-expanded' : $ctrl.isExpanded}\">\r\n            <p ng-bind-html=\"$ctrl.fullTextValue\" ng-class=\"{'{{$ctrl.customCollapsedClass}}' : !$ctrl.isExpanded}\" class=\"viewMore-text js-fulltext-container\"></p>\r\n\r\n            <button type=\"button\" class=\"linkButton viewMore-toggle\" ng-click=\"$ctrl.isExpanded = !$ctrl.isExpanded\">\r\n                View {{ $ctrl.isExpanded ? 'less' : 'more' }} <i ng-class=\"$ctrl.isExpanded ? 'iconww-ArrowUp' : 'iconww-ArrowDown'\"></i>\r\n            </button>\r\n        </div>\r\n        <p ng-if=\"!$ctrl.showMore\" ng-bind-html=\"$ctrl.fullTextValue\"></p>\r\n    </div>\r\n\r\n\r\n</div>\r\n"

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var common = __webpack_require__(1).module('oly.common');

var maxlengthcounterDirectives = __webpack_require__(676);

common.directive('olyShowMaxlengthCounter', [maxlengthcounterDirectives.showMaxlengthCounter]);

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

function showMaxlengthCounterDirective() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, element, attr, ngModel) {
            var maxlength = attr.maxlength || attr.ngMaxlength;
            var parentCounterEl = element.parent();
            var counterEl = angular.element('<div class="maxlengthCounter">');
            var srOverMaxLengthEl = angular.element('<span class="sr-only" aria-live="assertive" role="alert">Limit reached. You can only have ' + maxlength + ' characters in this field.</span>');

            counterEl.text(String(maxlength));
            parentCounterEl.append(counterEl);

            function renderCharCount(value) {
                counterEl.text(String(value));
                return value;
            }

            scope.$watch(function () {
                return ngModel.$viewValue;
            }, function (value) {
                if (!value) {
                    renderCharCount(maxlength);
                    return;
                }
                if (angular.isNumber(value.length)) {
                    var charsLeft = maxlength - value.length;

                    // If the characters exceeds the maxlength, turn it red and also set it to 0
                    if (charsLeft >= 0) {
                        counterEl.removeClass('maxlengthCounter-error');
                        renderCharCount(charsLeft);
                    } else {
                        counterEl.addClass('maxlengthCounter-error');
                        renderCharCount(0);
                    }

                    // Screen-reader text for character limit
                    if (charsLeft > 0) {
                        srOverMaxLengthEl.remove();
                    } else {
                        parentCounterEl.append(srOverMaxLengthEl);
                    }
                }
            });
        }
    };
}

module.exports = {
    showMaxlengthCounter: showMaxlengthCounterDirective
};

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('oly.common');

var _require = __webpack_require__(678),
    breadCrumbsComponentDefinition = _require.breadCrumbsComponentDefinition;

wowApp.component('wowBreadcrumbs', breadCrumbsComponentDefinition);

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var breadCrumbsController = function breadCrumbsController() {
    _classCallCheck(this, breadCrumbsController);
};

var breadCrumbsComponentDefinition = {
    bindings: {
        backLink: '<?',
        links: '<?'
    },
    controller: breadCrumbsController,
    template: __webpack_require__(679).trim()
};

module.exports = {
    breadCrumbsController: breadCrumbsController,
    breadCrumbsComponentDefinition: breadCrumbsComponentDefinition
};

/***/ }),
/* 679 */
/***/ (function(module, exports) {

module.exports = "<div class=\"breadcrumbs\" ng-if=\"$ctrl.backLink || $ctrl.links\">\r\n    <div ng-if=\"$ctrl.backLink\">\r\n    </div>\r\n    <ul class=\"breadcrumbs-linkList\" ng-if=\"$ctrl.links\">\r\n        <li class=\"breadcrumbs-link\" ng-repeat=\"link in $ctrl.links\">\r\n            <i class=\"iconww-ArrowLeft breadcrumbs-linkPointer hidden-sm hidden-md hidden-lg\"></i>\r\n            <i class=\"iconww-ArrowRight breadcrumbs-linkPointer hidden-xs\"></i>\r\n            <span ng-switch=\"!!link.url\">\r\n                <span ng-switch-when=\"false\">{{link.text}}</span>\r\n                <a ng-href=\"{{link.url}}\" ng-switch-when=\"true\">{{link.text}}</a>\r\n             </span>\r\n        </li>\r\n    </ul>\r\n</div>\r\n"

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(681);
module.exports = 'ngCookies';


/***/ }),
/* 681 */
/***/ (function(module, exports) {

/**
 * @license AngularJS v1.5.5
 * (c) 2010-2016 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/**
 * @ngdoc module
 * @name ngCookies
 * @description
 *
 * # ngCookies
 *
 * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
 *
 *
 * <div doc-module-components="ngCookies"></div>
 *
 * See {@link ngCookies.$cookies `$cookies`} for usage.
 */


angular.module('ngCookies', ['ng']).
  /**
   * @ngdoc provider
   * @name $cookiesProvider
   * @description
   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
   * */
   provider('$cookies', [function $CookiesProvider() {
    /**
     * @ngdoc property
     * @name $cookiesProvider#defaults
     * @description
     *
     * Object containing default options to pass when setting cookies.
     *
     * The object may have following properties:
     *
     * - **path** - `{string}` - The cookie will be available only for this path and its
     *   sub-paths. By default, this is the URL that appears in your `<base>` tag.
     * - **domain** - `{string}` - The cookie will be available only for this domain and
     *   its sub-domains. For security reasons the user agent will not accept the cookie
     *   if the current domain is not a sub-domain of this domain or equal to it.
     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
     *   or a Date object indicating the exact date/time this cookie will expire.
     * - **secure** - `{boolean}` - If `true`, then the cookie will only be available through a
     *   secured connection.
     *
     * Note: By default, the address that appears in your `<base>` tag will be used as the path.
     * This is important so that cookies will be visible for all routes when html5mode is enabled.
     *
     **/
    var defaults = this.defaults = {};

    function calcOptions(options) {
      return options ? angular.extend({}, defaults, options) : defaults;
    }

    /**
     * @ngdoc service
     * @name $cookies
     *
     * @description
     * Provides read/write access to browser's cookies.
     *
     * <div class="alert alert-info">
     * Up until Angular 1.3, `$cookies` exposed properties that represented the
     * current browser cookie values. In version 1.4, this behavior has changed, and
     * `$cookies` now provides a standard api of getters, setters etc.
     * </div>
     *
     * Requires the {@link ngCookies `ngCookies`} module to be installed.
     *
     * @example
     *
     * ```js
     * angular.module('cookiesExample', ['ngCookies'])
     *   .controller('ExampleController', ['$cookies', function($cookies) {
     *     // Retrieving a cookie
     *     var favoriteCookie = $cookies.get('myFavorite');
     *     // Setting a cookie
     *     $cookies.put('myFavorite', 'oatmeal');
     *   }]);
     * ```
     */
    this.$get = ['$$cookieReader', '$$cookieWriter', function($$cookieReader, $$cookieWriter) {
      return {
        /**
         * @ngdoc method
         * @name $cookies#get
         *
         * @description
         * Returns the value of given cookie key
         *
         * @param {string} key Id to use for lookup.
         * @returns {string} Raw cookie value.
         */
        get: function(key) {
          return $$cookieReader()[key];
        },

        /**
         * @ngdoc method
         * @name $cookies#getObject
         *
         * @description
         * Returns the deserialized value of given cookie key
         *
         * @param {string} key Id to use for lookup.
         * @returns {Object} Deserialized cookie value.
         */
        getObject: function(key) {
          var value = this.get(key);
          return value ? angular.fromJson(value) : value;
        },

        /**
         * @ngdoc method
         * @name $cookies#getAll
         *
         * @description
         * Returns a key value object with all the cookies
         *
         * @returns {Object} All cookies
         */
        getAll: function() {
          return $$cookieReader();
        },

        /**
         * @ngdoc method
         * @name $cookies#put
         *
         * @description
         * Sets a value for given cookie key
         *
         * @param {string} key Id for the `value`.
         * @param {string} value Raw value to be stored.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        put: function(key, value, options) {
          $$cookieWriter(key, value, calcOptions(options));
        },

        /**
         * @ngdoc method
         * @name $cookies#putObject
         *
         * @description
         * Serializes and sets a value for given cookie key
         *
         * @param {string} key Id for the `value`.
         * @param {Object} value Value to be stored.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        putObject: function(key, value, options) {
          this.put(key, angular.toJson(value), options);
        },

        /**
         * @ngdoc method
         * @name $cookies#remove
         *
         * @description
         * Remove given cookie
         *
         * @param {string} key Id of the key-value pair to delete.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        remove: function(key, options) {
          $$cookieWriter(key, undefined, calcOptions(options));
        }
      };
    }];
  }]);

angular.module('ngCookies').
/**
 * @ngdoc service
 * @name $cookieStore
 * @deprecated
 * @requires $cookies
 *
 * @description
 * Provides a key-value (string-object) storage, that is backed by session cookies.
 * Objects put or retrieved from this storage are automatically serialized or
 * deserialized by angular's toJson/fromJson.
 *
 * Requires the {@link ngCookies `ngCookies`} module to be installed.
 *
 * <div class="alert alert-danger">
 * **Note:** The $cookieStore service is **deprecated**.
 * Please use the {@link ngCookies.$cookies `$cookies`} service instead.
 * </div>
 *
 * @example
 *
 * ```js
 * angular.module('cookieStoreExample', ['ngCookies'])
 *   .controller('ExampleController', ['$cookieStore', function($cookieStore) {
 *     // Put cookie
 *     $cookieStore.put('myFavorite','oatmeal');
 *     // Get cookie
 *     var favoriteCookie = $cookieStore.get('myFavorite');
 *     // Removing a cookie
 *     $cookieStore.remove('myFavorite');
 *   }]);
 * ```
 */
 factory('$cookieStore', ['$cookies', function($cookies) {

    return {
      /**
       * @ngdoc method
       * @name $cookieStore#get
       *
       * @description
       * Returns the value of given cookie key
       *
       * @param {string} key Id to use for lookup.
       * @returns {Object} Deserialized cookie value, undefined if the cookie does not exist.
       */
      get: function(key) {
        return $cookies.getObject(key);
      },

      /**
       * @ngdoc method
       * @name $cookieStore#put
       *
       * @description
       * Sets a value for given cookie key
       *
       * @param {string} key Id for the `value`.
       * @param {Object} value Value to be stored.
       */
      put: function(key, value) {
        $cookies.putObject(key, value);
      },

      /**
       * @ngdoc method
       * @name $cookieStore#remove
       *
       * @description
       * Remove given cookie
       *
       * @param {string} key Id of the key-value pair to delete.
       */
      remove: function(key) {
        $cookies.remove(key);
      }
    };

  }]);

/**
 * @name $$cookieWriter
 * @requires $document
 *
 * @description
 * This is a private service for writing cookies
 *
 * @param {string} name Cookie name
 * @param {string=} value Cookie value (if undefined, cookie will be deleted)
 * @param {Object=} options Object with options that need to be stored for the cookie.
 */
function $$CookieWriter($document, $log, $browser) {
  var cookiePath = $browser.baseHref();
  var rawDocument = $document[0];

  function buildCookieString(name, value, options) {
    var path, expires;
    options = options || {};
    expires = options.expires;
    path = angular.isDefined(options.path) ? options.path : cookiePath;
    if (angular.isUndefined(value)) {
      expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
      value = '';
    }
    if (angular.isString(expires)) {
      expires = new Date(expires);
    }

    var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
    str += path ? ';path=' + path : '';
    str += options.domain ? ';domain=' + options.domain : '';
    str += expires ? ';expires=' + expires.toUTCString() : '';
    str += options.secure ? ';secure' : '';

    // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
    // - 300 cookies
    // - 20 cookies per unique domain
    // - 4096 bytes per cookie
    var cookieLength = str.length + 1;
    if (cookieLength > 4096) {
      $log.warn("Cookie '" + name +
        "' possibly not set or overflowed because it was too large (" +
        cookieLength + " > 4096 bytes)!");
    }

    return str;
  }

  return function(name, value, options) {
    rawDocument.cookie = buildCookieString(name, value, options);
  };
}

$$CookieWriter.$inject = ['$document', '$log', '$browser'];

angular.module('ngCookies').provider('$$cookieWriter', function $$CookieWriterProvider() {
  this.$get = $$CookieWriter;
});


})(window, window.angular);


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;(function() {

  // nb. This is for IE10 and lower _only_.
  var supportCustomEvent = window.CustomEvent;
  if (!supportCustomEvent || typeof supportCustomEvent === 'object') {
    supportCustomEvent = function CustomEvent(event, x) {
      x = x || {};
      var ev = document.createEvent('CustomEvent');
      ev.initCustomEvent(event, !!x.bubbles, !!x.cancelable, x.detail || null);
      return ev;
    };
    supportCustomEvent.prototype = window.Event.prototype;
  }

  /**
   * @param {Element} el to check for stacking context
   * @return {boolean} whether this el or its parents creates a stacking context
   */
  function createsStackingContext(el) {
    while (el && el !== document.body) {
      var s = window.getComputedStyle(el);
      var invalid = function(k, ok) {
        return !(s[k] === undefined || s[k] === ok);
      }
      if (s.opacity < 1 ||
          invalid('zIndex', 'auto') ||
          invalid('transform', 'none') ||
          invalid('mixBlendMode', 'normal') ||
          invalid('filter', 'none') ||
          invalid('perspective', 'none') ||
          s['isolation'] === 'isolate' ||
          s.position === 'fixed' ||
          s.webkitOverflowScrolling === 'touch') {
        return true;
      }
      el = el.parentElement;
    }
    return false;
  }

  /**
   * Finds the nearest <dialog> from the passed element.
   *
   * @param {Element} el to search from
   * @return {HTMLDialogElement} dialog found
   */
  function findNearestDialog(el) {
    while (el) {
      if (el.localName === 'dialog') {
        return /** @type {HTMLDialogElement} */ (el);
      }
      el = el.parentElement;
    }
    return null;
  }

  /**
   * Blur the specified element, as long as it's not the HTML body element.
   * This works around an IE9/10 bug - blurring the body causes Windows to
   * blur the whole application.
   *
   * @param {Element} el to blur
   */
  function safeBlur(el) {
    if (el && el.blur && el !== document.body) {
      el.blur();
    }
  }

  /**
   * @param {!NodeList} nodeList to search
   * @param {Node} node to find
   * @return {boolean} whether node is inside nodeList
   */
  function inNodeList(nodeList, node) {
    for (var i = 0; i < nodeList.length; ++i) {
      if (nodeList[i] === node) {
        return true;
      }
    }
    return false;
  }

  /**
   * @param {HTMLFormElement} el to check
   * @return {boolean} whether this form has method="dialog"
   */
  function isFormMethodDialog(el) {
    if (!el || !el.hasAttribute('method')) {
      return false;
    }
    return el.getAttribute('method').toLowerCase() === 'dialog';
  }

  /**
   * @param {!HTMLDialogElement} dialog to upgrade
   * @constructor
   */
  function dialogPolyfillInfo(dialog) {
    this.dialog_ = dialog;
    this.replacedStyleTop_ = false;
    this.openAsModal_ = false;

    // Set a11y role. Browsers that support dialog implicitly know this already.
    if (!dialog.hasAttribute('role')) {
      dialog.setAttribute('role', 'dialog');
    }

    dialog.show = this.show.bind(this);
    dialog.showModal = this.showModal.bind(this);
    dialog.close = this.close.bind(this);

    if (!('returnValue' in dialog)) {
      dialog.returnValue = '';
    }

    if ('MutationObserver' in window) {
      var mo = new MutationObserver(this.maybeHideModal.bind(this));
      mo.observe(dialog, {attributes: true, attributeFilter: ['open']});
    } else {
      // IE10 and below support. Note that DOMNodeRemoved etc fire _before_ removal. They also
      // seem to fire even if the element was removed as part of a parent removal. Use the removed
      // events to force downgrade (useful if removed/immediately added).
      var removed = false;
      var cb = function() {
        removed ? this.downgradeModal() : this.maybeHideModal();
        removed = false;
      }.bind(this);
      var timeout;
      var delayModel = function(ev) {
        if (ev.target !== dialog) { return; }  // not for a child element
        var cand = 'DOMNodeRemoved';
        removed |= (ev.type.substr(0, cand.length) === cand);
        window.clearTimeout(timeout);
        timeout = window.setTimeout(cb, 0);
      };
      ['DOMAttrModified', 'DOMNodeRemoved', 'DOMNodeRemovedFromDocument'].forEach(function(name) {
        dialog.addEventListener(name, delayModel);
      });
    }
    // Note that the DOM is observed inside DialogManager while any dialog
    // is being displayed as a modal, to catch modal removal from the DOM.

    Object.defineProperty(dialog, 'open', {
      set: this.setOpen.bind(this),
      get: dialog.hasAttribute.bind(dialog, 'open')
    });

    this.backdrop_ = document.createElement('div');
    this.backdrop_.className = 'backdrop';
    this.backdrop_.addEventListener('click', this.backdropClick_.bind(this));
  }

  dialogPolyfillInfo.prototype = {

    get dialog() {
      return this.dialog_;
    },

    /**
     * Maybe remove this dialog from the modal top layer. This is called when
     * a modal dialog may no longer be tenable, e.g., when the dialog is no
     * longer open or is no longer part of the DOM.
     */
    maybeHideModal: function() {
      if (this.dialog_.hasAttribute('open') && document.body.contains(this.dialog_)) { return; }
      this.downgradeModal();
    },

    /**
     * Remove this dialog from the modal top layer, leaving it as a non-modal.
     */
    downgradeModal: function() {
      if (!this.openAsModal_) { return; }
      this.openAsModal_ = false;
      this.dialog_.style.zIndex = '';

      // This won't match the native <dialog> exactly because if the user set top on a centered
      // polyfill dialog, that top gets thrown away when the dialog is closed. Not sure it's
      // possible to polyfill this perfectly.
      if (this.replacedStyleTop_) {
        this.dialog_.style.top = '';
        this.replacedStyleTop_ = false;
      }

      // Clear the backdrop and remove from the manager.
      this.backdrop_.parentNode && this.backdrop_.parentNode.removeChild(this.backdrop_);
      dialogPolyfill.dm.removeDialog(this);
    },

    /**
     * @param {boolean} value whether to open or close this dialog
     */
    setOpen: function(value) {
      if (value) {
        this.dialog_.hasAttribute('open') || this.dialog_.setAttribute('open', '');
      } else {
        this.dialog_.removeAttribute('open');
        this.maybeHideModal();  // nb. redundant with MutationObserver
      }
    },

    /**
     * Handles clicks on the fake .backdrop element, redirecting them as if
     * they were on the dialog itself.
     *
     * @param {!Event} e to redirect
     */
    backdropClick_: function(e) {
      if (!this.dialog_.hasAttribute('tabindex')) {
        // Clicking on the backdrop should move the implicit cursor, even if dialog cannot be
        // focused. Create a fake thing to focus on. If the backdrop was _before_ the dialog, this
        // would not be needed - clicks would move the implicit cursor there.
        var fake = document.createElement('div');
        this.dialog_.insertBefore(fake, this.dialog_.firstChild);
        fake.tabIndex = -1;
        fake.focus();
        this.dialog_.removeChild(fake);
      } else {
        this.dialog_.focus();
      }

      var redirectedEvent = document.createEvent('MouseEvents');
      redirectedEvent.initMouseEvent(e.type, e.bubbles, e.cancelable, window,
          e.detail, e.screenX, e.screenY, e.clientX, e.clientY, e.ctrlKey,
          e.altKey, e.shiftKey, e.metaKey, e.button, e.relatedTarget);
      this.dialog_.dispatchEvent(redirectedEvent);
      e.stopPropagation();
    },

    /**
     * Focuses on the first focusable element within the dialog. This will always blur the current
     * focus, even if nothing within the dialog is found.
     */
    focus_: function() {
      // Find element with `autofocus` attribute, or fall back to the first form/tabindex control.
      var target = this.dialog_.querySelector('[autofocus]:not([disabled])');
      if (!target && this.dialog_.tabIndex >= 0) {
        target = this.dialog_;
      }
      if (!target) {
        // Note that this is 'any focusable area'. This list is probably not exhaustive, but the
        // alternative involves stepping through and trying to focus everything.
        var opts = ['button', 'input', 'keygen', 'select', 'textarea'];
        var query = opts.map(function(el) {
          return el + ':not([disabled])';
        });
        // TODO(samthor): tabindex values that are not numeric are not focusable.
        query.push('[tabindex]:not([disabled]):not([tabindex=""])');  // tabindex != "", not disabled
        target = this.dialog_.querySelector(query.join(', '));
      }
      safeBlur(document.activeElement);
      target && target.focus();
    },

    /**
     * Sets the zIndex for the backdrop and dialog.
     *
     * @param {number} dialogZ
     * @param {number} backdropZ
     */
    updateZIndex: function(dialogZ, backdropZ) {
      if (dialogZ < backdropZ) {
        throw new Error('dialogZ should never be < backdropZ');
      }
      this.dialog_.style.zIndex = dialogZ;
      this.backdrop_.style.zIndex = backdropZ;
    },

    /**
     * Shows the dialog. If the dialog is already open, this does nothing.
     */
    show: function() {
      if (!this.dialog_.open) {
        this.setOpen(true);
        this.focus_();
      }
    },

    /**
     * Show this dialog modally.
     */
    showModal: function() {
      if (this.dialog_.hasAttribute('open')) {
        throw new Error('Failed to execute \'showModal\' on dialog: The element is already open, and therefore cannot be opened modally.');
      }
      if (!document.body.contains(this.dialog_)) {
        throw new Error('Failed to execute \'showModal\' on dialog: The element is not in a Document.');
      }
      if (!dialogPolyfill.dm.pushDialog(this)) {
        throw new Error('Failed to execute \'showModal\' on dialog: There are too many open modal dialogs.');
      }

      if (createsStackingContext(this.dialog_.parentElement)) {
        console.warn('A dialog is being shown inside a stacking context. ' +
            'This may cause it to be unusable. For more information, see this link: ' +
            'https://github.com/GoogleChrome/dialog-polyfill/#stacking-context');
      }

      this.setOpen(true);
      this.openAsModal_ = true;

      // Optionally center vertically, relative to the current viewport.
      if (dialogPolyfill.needsCentering(this.dialog_)) {
        dialogPolyfill.reposition(this.dialog_);
        this.replacedStyleTop_ = true;
      } else {
        this.replacedStyleTop_ = false;
      }

      // Insert backdrop.
      this.dialog_.parentNode.insertBefore(this.backdrop_, this.dialog_.nextSibling);

      // Focus on whatever inside the dialog.
      this.focus_();
    },

    /**
     * Closes this HTMLDialogElement. This is optional vs clearing the open
     * attribute, however this fires a 'close' event.
     *
     * @param {string=} opt_returnValue to use as the returnValue
     */
    close: function(opt_returnValue) {
      if (!this.dialog_.hasAttribute('open')) {
        throw new Error('Failed to execute \'close\' on dialog: The element does not have an \'open\' attribute, and therefore cannot be closed.');
      }
      this.setOpen(false);

      // Leave returnValue untouched in case it was set directly on the element
      if (opt_returnValue !== undefined) {
        this.dialog_.returnValue = opt_returnValue;
      }

      // Triggering "close" event for any attached listeners on the <dialog>.
      var closeEvent = new supportCustomEvent('close', {
        bubbles: false,
        cancelable: false
      });
      this.dialog_.dispatchEvent(closeEvent);
    }

  };

  var dialogPolyfill = {};

  dialogPolyfill.reposition = function(element) {
    var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    var topValue = scrollTop + (window.innerHeight - element.offsetHeight) / 2;
    element.style.top = Math.max(scrollTop, topValue) + 'px';
  };

  dialogPolyfill.isInlinePositionSetByStylesheet = function(element) {
    for (var i = 0; i < document.styleSheets.length; ++i) {
      var styleSheet = document.styleSheets[i];
      var cssRules = null;
      // Some browsers throw on cssRules.
      try {
        cssRules = styleSheet.cssRules;
      } catch (e) {}
      if (!cssRules) { continue; }
      for (var j = 0; j < cssRules.length; ++j) {
        var rule = cssRules[j];
        var selectedNodes = null;
        // Ignore errors on invalid selector texts.
        try {
          selectedNodes = document.querySelectorAll(rule.selectorText);
        } catch(e) {}
        if (!selectedNodes || !inNodeList(selectedNodes, element)) {
          continue;
        }
        var cssTop = rule.style.getPropertyValue('top');
        var cssBottom = rule.style.getPropertyValue('bottom');
        if ((cssTop && cssTop !== 'auto') || (cssBottom && cssBottom !== 'auto')) {
          return true;
        }
      }
    }
    return false;
  };

  dialogPolyfill.needsCentering = function(dialog) {
    var computedStyle = window.getComputedStyle(dialog);
    if (computedStyle.position !== 'absolute') {
      return false;
    }

    // We must determine whether the top/bottom specified value is non-auto.  In
    // WebKit/Blink, checking computedStyle.top == 'auto' is sufficient, but
    // Firefox returns the used value. So we do this crazy thing instead: check
    // the inline style and then go through CSS rules.
    if ((dialog.style.top !== 'auto' && dialog.style.top !== '') ||
        (dialog.style.bottom !== 'auto' && dialog.style.bottom !== '')) {
      return false;
    }
    return !dialogPolyfill.isInlinePositionSetByStylesheet(dialog);
  };

  /**
   * @param {!Element} element to force upgrade
   */
  dialogPolyfill.forceRegisterDialog = function(element) {
    if (window.HTMLDialogElement || element.showModal) {
      console.warn('This browser already supports <dialog>, the polyfill ' +
          'may not work correctly', element);
    }
    if (element.localName !== 'dialog') {
      throw new Error('Failed to register dialog: The element is not a dialog.');
    }
    new dialogPolyfillInfo(/** @type {!HTMLDialogElement} */ (element));
  };

  /**
   * @param {!Element} element to upgrade, if necessary
   */
  dialogPolyfill.registerDialog = function(element) {
    if (!element.showModal) {
      dialogPolyfill.forceRegisterDialog(element);
    }
  };

  /**
   * @constructor
   */
  dialogPolyfill.DialogManager = function() {
    /** @type {!Array<!dialogPolyfillInfo>} */
    this.pendingDialogStack = [];

    var checkDOM = this.checkDOM_.bind(this);

    // The overlay is used to simulate how a modal dialog blocks the document.
    // The blocking dialog is positioned on top of the overlay, and the rest of
    // the dialogs on the pending dialog stack are positioned below it. In the
    // actual implementation, the modal dialog stacking is controlled by the
    // top layer, where z-index has no effect.
    this.overlay = document.createElement('div');
    this.overlay.className = '_dialog_overlay';
    this.overlay.addEventListener('click', function(e) {
      this.forwardTab_ = undefined;
      e.stopPropagation();
      checkDOM([]);  // sanity-check DOM
    }.bind(this));

    this.handleKey_ = this.handleKey_.bind(this);
    this.handleFocus_ = this.handleFocus_.bind(this);

    this.zIndexLow_ = 100000;
    this.zIndexHigh_ = 100000 + 150;

    this.forwardTab_ = undefined;

    if ('MutationObserver' in window) {
      this.mo_ = new MutationObserver(function(records) {
        var removed = [];
        records.forEach(function(rec) {
          for (var i = 0, c; c = rec.removedNodes[i]; ++i) {
            if (!(c instanceof Element)) {
              continue;
            } else if (c.localName === 'dialog') {
              removed.push(c);
            }
            removed = removed.concat(c.querySelectorAll('dialog'));
          }
        });
        removed.length && checkDOM(removed);
      });
    }
  };

  /**
   * Called on the first modal dialog being shown. Adds the overlay and related
   * handlers.
   */
  dialogPolyfill.DialogManager.prototype.blockDocument = function() {
    document.documentElement.addEventListener('focus', this.handleFocus_, true);
    document.addEventListener('keydown', this.handleKey_);
    this.mo_ && this.mo_.observe(document, {childList: true, subtree: true});
  };

  /**
   * Called on the first modal dialog being removed, i.e., when no more modal
   * dialogs are visible.
   */
  dialogPolyfill.DialogManager.prototype.unblockDocument = function() {
    document.documentElement.removeEventListener('focus', this.handleFocus_, true);
    document.removeEventListener('keydown', this.handleKey_);
    this.mo_ && this.mo_.disconnect();
  };

  /**
   * Updates the stacking of all known dialogs.
   */
  dialogPolyfill.DialogManager.prototype.updateStacking = function() {
    var zIndex = this.zIndexHigh_;

    for (var i = 0, dpi; dpi = this.pendingDialogStack[i]; ++i) {
      dpi.updateZIndex(--zIndex, --zIndex);
      if (i === 0) {
        this.overlay.style.zIndex = --zIndex;
      }
    }

    // Make the overlay a sibling of the dialog itself.
    var last = this.pendingDialogStack[0];
    if (last) {
      var p = last.dialog.parentNode || document.body;
      p.appendChild(this.overlay);
    } else if (this.overlay.parentNode) {
      this.overlay.parentNode.removeChild(this.overlay);
    }
  };

  /**
   * @param {Element} candidate to check if contained or is the top-most modal dialog
   * @return {boolean} whether candidate is contained in top dialog
   */
  dialogPolyfill.DialogManager.prototype.containedByTopDialog_ = function(candidate) {
    while (candidate = findNearestDialog(candidate)) {
      for (var i = 0, dpi; dpi = this.pendingDialogStack[i]; ++i) {
        if (dpi.dialog === candidate) {
          return i === 0;  // only valid if top-most
        }
      }
      candidate = candidate.parentElement;
    }
    return false;
  };

  dialogPolyfill.DialogManager.prototype.handleFocus_ = function(event) {
    if (this.containedByTopDialog_(event.target)) { return; }

    event.preventDefault();
    event.stopPropagation();
    safeBlur(/** @type {Element} */ (event.target));

    if (this.forwardTab_ === undefined) { return; }  // move focus only from a tab key

    var dpi = this.pendingDialogStack[0];
    var dialog = dpi.dialog;
    var position = dialog.compareDocumentPosition(event.target);
    if (position & Node.DOCUMENT_POSITION_PRECEDING) {
      if (this.forwardTab_) {  // forward
        dpi.focus_();
      } else {  // backwards
        document.documentElement.focus();
      }
    } else {
      // TODO: Focus after the dialog, is ignored.
    }

    return false;
  };

  dialogPolyfill.DialogManager.prototype.handleKey_ = function(event) {
    this.forwardTab_ = undefined;
    if (event.keyCode === 27) {
      event.preventDefault();
      event.stopPropagation();
      var cancelEvent = new supportCustomEvent('cancel', {
        bubbles: false,
        cancelable: true
      });
      var dpi = this.pendingDialogStack[0];
      if (dpi && dpi.dialog.dispatchEvent(cancelEvent)) {
        dpi.dialog.close();
      }
    } else if (event.keyCode === 9) {
      this.forwardTab_ = !event.shiftKey;
    }
  };

  /**
   * Finds and downgrades any known modal dialogs that are no longer displayed. Dialogs that are
   * removed and immediately readded don't stay modal, they become normal.
   *
   * @param {!Array<!HTMLDialogElement>} removed that have definitely been removed
   */
  dialogPolyfill.DialogManager.prototype.checkDOM_ = function(removed) {
    // This operates on a clone because it may cause it to change. Each change also calls
    // updateStacking, which only actually needs to happen once. But who removes many modal dialogs
    // at a time?!
    var clone = this.pendingDialogStack.slice();
    clone.forEach(function(dpi) {
      if (removed.indexOf(dpi.dialog) !== -1) {
        dpi.downgradeModal();
      } else {
        dpi.maybeHideModal();
      }
    });
  };

  /**
   * @param {!dialogPolyfillInfo} dpi
   * @return {boolean} whether the dialog was allowed
   */
  dialogPolyfill.DialogManager.prototype.pushDialog = function(dpi) {
    var allowed = (this.zIndexHigh_ - this.zIndexLow_) / 2 - 1;
    if (this.pendingDialogStack.length >= allowed) {
      return false;
    }
    if (this.pendingDialogStack.unshift(dpi) === 1) {
      this.blockDocument();
    }
    this.updateStacking();
    return true;
  };

  /**
   * @param {!dialogPolyfillInfo} dpi
   */
  dialogPolyfill.DialogManager.prototype.removeDialog = function(dpi) {
    var index = this.pendingDialogStack.indexOf(dpi);
    if (index === -1) { return; }

    this.pendingDialogStack.splice(index, 1);
    if (this.pendingDialogStack.length === 0) {
      this.unblockDocument();
    }
    this.updateStacking();
  };

  dialogPolyfill.dm = new dialogPolyfill.DialogManager();
  dialogPolyfill.formSubmitter = null;
  dialogPolyfill.useValue = null;

  /**
   * Installs global handlers, such as click listers and native method overrides. These are needed
   * even if a no dialog is registered, as they deal with <form method="dialog">.
   */
  if (window.HTMLDialogElement === undefined) {

    /**
     * If HTMLFormElement translates method="DIALOG" into 'get', then replace the descriptor with
     * one that returns the correct value.
     */
    var testForm = document.createElement('form');
    testForm.setAttribute('method', 'dialog');
    if (testForm.method !== 'dialog') {
      var methodDescriptor = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, 'method');
      if (methodDescriptor) {
        // TODO: older iOS and older PhantomJS fail to return the descriptor here
        var realGet = methodDescriptor.get;
        methodDescriptor.get = function() {
          if (isFormMethodDialog(this)) {
            return 'dialog';
          }
          return realGet.call(this);
        };
        var realSet = methodDescriptor.set;
        methodDescriptor.set = function(v) {
          if (typeof v === 'string' && v.toLowerCase() === 'dialog') {
            return this.setAttribute('method', v);
          }
          return realSet.call(this, v);
        };
        Object.defineProperty(HTMLFormElement.prototype, 'method', methodDescriptor);
      }
    }

    /**
     * Global 'click' handler, to capture the <input type="submit"> or <button> element which has
     * submitted a <form method="dialog">. Needed as Safari and others don't report this inside
     * document.activeElement.
     */
    document.addEventListener('click', function(ev) {
      dialogPolyfill.formSubmitter = null;
      dialogPolyfill.useValue = null;
      if (ev.defaultPrevented) { return; }  // e.g. a submit which prevents default submission

      var target = /** @type {Element} */ (ev.target);
      if (!target || !isFormMethodDialog(target.form)) { return; }

      var valid = (target.type === 'submit' && ['button', 'input'].indexOf(target.localName) > -1);
      if (!valid) {
        if (!(target.localName === 'input' && target.type === 'image')) { return; }
        // this is a <input type="image">, which can submit forms
        dialogPolyfill.useValue = ev.offsetX + ',' + ev.offsetY;
      }

      var dialog = findNearestDialog(target);
      if (!dialog) { return; }

      dialogPolyfill.formSubmitter = target;
    }, false);

    /**
     * Replace the native HTMLFormElement.submit() method, as it won't fire the
     * submit event and give us a chance to respond.
     */
    var nativeFormSubmit = HTMLFormElement.prototype.submit;
    function replacementFormSubmit() {
      if (!isFormMethodDialog(this)) {
        return nativeFormSubmit.call(this);
      }
      var dialog = findNearestDialog(this);
      dialog && dialog.close();
    }
    HTMLFormElement.prototype.submit = replacementFormSubmit;

    /**
     * Global form 'dialog' method handler. Closes a dialog correctly on submit
     * and possibly sets its return value.
     */
    document.addEventListener('submit', function(ev) {
      var form = /** @type {HTMLFormElement} */ (ev.target);
      if (!isFormMethodDialog(form)) { return; }
      ev.preventDefault();

      var dialog = findNearestDialog(form);
      if (!dialog) { return; }

      // Forms can only be submitted via .submit() or a click (?), but anyway: sanity-check that
      // the submitter is correct before using its value as .returnValue.
      var s = dialogPolyfill.formSubmitter;
      if (s && s.form === form) {
        dialog.close(dialogPolyfill.useValue || s.value);
      } else {
        dialog.close();
      }
      dialogPolyfill.formSubmitter = null;
    }, true);
  }

  dialogPolyfill['forceRegisterDialog'] = dialogPolyfill.forceRegisterDialog;
  dialogPolyfill['registerDialog'] = dialogPolyfill.registerDialog;

  if ("function" === 'function' && 'amd' in __webpack_require__(683)) {
    // AMD support
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() { return dialogPolyfill; }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === 'object' && typeof module['exports'] === 'object') {
    // CommonJS support
    module['exports'] = dialogPolyfill;
  } else {
    // all others
    window['dialogPolyfill'] = dialogPolyfill;
  }
})();


/***/ }),
/* 683 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    ADD_TO_CART: 'Add to Cart',
    REMOVE_FROM_CART: 'Remove from Cart',
    ADD_ALL: 'Add all',
    SAVE_TO_LIST: 'Save to list',
    SAVE_TROLLEY_LIST: 'Save trolley as list',
    VIEW_ALL_SIZES: 'View all sizes',
    KEEP_RECIPE: 'Keep',
    SIGN_UP: {
        START: 'Sign Up Start',
        END: 'Sign Up End',
        COMPLETED: 'Sign Up Completed',
        FAILURE: 'Sign Up Failed'
    },
    LOGIN: {
        START: 'Login Form Start',
        END: 'Login Form End',
        FORM_FILL_EMAIL_ADDRESS: 'Login Form Fill: EmailAddress',
        FORM_FILL_PASSWORD: 'Login Form Fill: Password',
        FORM_FILL_REMEMBER_ME: 'Login Form Fill: RememberMe',
        COMPLETED_MANUAL: 'Login Form Completed: Manual',
        COMPLETED_AUTO: 'Login Form Completed: Auto',
        FAILURE: 'Login Failed'
    },
    PRODUCT_STAMP: {
        SIZE_LARGE: 'Product Stamp Size: Large',
        SIZE_SMALL: 'Product Stamp Size: Small'
    },
    TOGGLE_PANEL: 'Toggle panel',
    SOCIAL_SHARE: {
        FACEBOOK: 'Social share: Facebook',
        TWITTER: 'Social share: Twitter',
        PINTEREST: 'Social share: Pinterest',
        GOOGLEPLUS: 'Social share: Google Plus'
    },
    BANNER_CLICK: 'Banners',
    CARDS_LIST_SORT_BY_MENU: 'Sort By Menu',
    PRINT_RECIPE: 'Print recipe',
    DISCOVER_MORE: 'Discover more',
    VIDEO_TRACK: 'Video Tracking',
    CONTINUE_SHOPPING: 'Continue shopping', // This event is for when the shopper press 'Continue shopping' at the top left of the page at checkout/hyf
    RETURN_TO_SHOPPING: 'Return to shopping', // This event is for when the shopper encounters an error in checkout header and clicks the 'Return to Shopping' link inside error
    RICH_RELEVANCE_TIMEOUT: 'RichRelevance timeout'
};

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    gtm: {
        module: 'gtm',
        service: 'GtmService'
    },
    dtm: {
        module: 'dtm',
        service: 'DtmService'
    },
    tealium: {
        module: 'tealium',
        service: 'TealiumService'
    }
};

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    default: 'default',

    common: {
        event: 'event',
        error: 'error'
    },

    account: {
        login: 'login',
        shopper: 'shopper',
        shopperPreferences: 'shopperPreferences',
        shopperMyAccount: 'shopperMyAccount'
    },

    content: {
        dynamicContent: 'dynamicContent',
        general: 'content',
        inspiration: 'inspiration',
        recipeCategory: 'recipeCategory',
        recipeDetail: 'recipe',
        catalogue: 'catalogue'
    },

    customEvent: {
        bannerClick: 'bannerClick',
        dialogClick: 'dialogClick',
        productClick: 'productClick',
        linkClick: 'linkClick',
        recipeClick: 'recipeClick',
        menuClick: 'menuClick',
        customEvent: 'customEvent',
        trolley: {
            addTo: 'trolleyAddTo',
            addAllTo: 'trolleyAddAllTo',
            productClick: 'trolleyProductClick',
            productClickAddAllTo: 'trolleyProductClickAddAllTo',
            cartAdd: 'cartAdd',
            cartRemove: 'cartRemove',
            cartBuyOnline: 'cartBuyOnline',
            save: 'trolleySave',
            clear: 'trolleyClear'
        },
        order: {
            cancel: 'orderCancel'
        },
        store: {
            select: 'selectStore'
        },
        account: {
            userRegister: 'userRegister',
            userLogin: 'userLogin',
            accountEdit: 'accountEdit'
        },
        search: {
            success: 'searchSuccess'
        },
        list: {
            Add: 'listAdd',
            AddOrder: 'listAddOrder'
        }
    },

    search: {
        filter: 'filter',
        result: 'result'
    },

    seo: {
        pageTitle: 'pageTitle',
        pageInfo: 'pageInfo',
        metaData: 'pageMetadata'
    },

    shop: {
        checkout: 'checkout',
        checkoutPackagingPreference: 'checkoutPackagingPreference',
        checkoutSteps: 'checkoutSteps',
        fulfilment: 'fulfilment',
        fulfilmentSelector: {
            fulfilmentSelectorDialog: 'fulfilmentSelectorDialog'
        },
        onBoardingDialog: 'onBoardingDialog',
        order: 'orderAnalytics',
        productCategory: 'productCategory',
        productdetail: 'productdetail',
        promoCode: 'promoCode',
        trolley: 'trolley',
        cart: 'cart',
        orderConfirmation: 'orderConfirmation',
        myList: 'myList',
        userPreference: 'userPreference',
        stockChecker: 'stockChecker'
    },

    store: {
        tripPlanner: 'tripPlanner',
        search: 'storeLocator',
        detail: 'storeDetail',
        productDetail: 'storeProductDetail'
    },

    deliveryPlus: 'deliveryPlus'
};

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AnalyticsOnClickController = function AnalyticsOnClickController($element, analytics) {
    var _this = this;

    _classCallCheck(this, AnalyticsOnClickController);

    this.analytics = analytics;
    $element.on('click', function () {
        _this.analytics.pushEvent(_this.event);
    });
};

var analyticsOnClickDirectiveDefinition = function analyticsOnClickDirectiveDefinition() {
    return {
        restrict: 'A',
        scope: {},
        bindToController: {
            event: '@olyAnalyticsOnClick'
        },
        controller: ['$element', 'AnalyticsService', AnalyticsOnClickController],
        controllerAs: 'analyticsOnClickCtrl'
    };
};

module.exports = {
    AnalyticsOnClickController: AnalyticsOnClickController,
    analyticsOnClickDirectiveDefinition: analyticsOnClickDirectiveDefinition
};

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    isArray = _require.isArray,
    forEach = _require.forEach;

var AnalyticsService = function () {
    function AnalyticsService($q, $log, $injector, $ocLazyLoad, sessionStorage, settings, events, bootstrapService, tagManagers, mapperTypes) {
        _classCallCheck(this, AnalyticsService);

        this.$q = $q;
        this.$log = $log;
        this.$injector = $injector;
        this.$ocLazyLoad = $ocLazyLoad;
        this.sessionStorage = sessionStorage;
        this.settings = settings;
        this.events = events;
        this.bootstrap = bootstrapService;
        this.tagManagers = tagManagers;
        this.mapperTypes = mapperTypes;
        this.init();
    }

    _createClass(AnalyticsService, [{
        key: 'init',
        value: function init() {
            this.tagManagerList = [];

            // check the switches.
            if (this.settings.analytics.useDtm) {
                this.tagManagerList.push(this.tagManagers.dtm.module);
            }
            if (this.settings.analytics.useGtm) {
                this.tagManagerList.push(this.tagManagers.gtm.module);
            }
            if (this.settings.analytics.useTealium) {
                this.tagManagerList.push(this.tagManagers.tealium.module);
            }

            // push user detail to update tealium analytics
            this.pushUserDetail('shouldTrackLoginEvent');
            this.pushUserDetail('shouldTrackSignupEvent');
        }
    }, {
        key: 'loadMapperServices',
        value: function loadMapperServices() {
            var _this = this;

            if (!this.mapperServicePromise) {
                this.mapperServicePromise = this.$ocLazyLoad.load(this.tagManagerList);

                this.mapperServicePromise.then(function () {
                    _this.tagManagerServices = [];

                    // load the tag services.
                    forEach(_this.tagManagers, function (tagManager) {
                        if (_this.$injector.has(tagManager.service)) {
                            _this.tagManagerServices.push(_this.$injector.get(tagManager.service));
                        }
                    });
                });
            }

            return this.mapperServicePromise;
        }
    }, {
        key: 'push',
        value: function push(_ref) {
            var _this2 = this;

            var _ref$data = _ref.data,
                data = _ref$data === undefined ? {} : _ref$data,
                _ref$type = _ref.type,
                type = _ref$type === undefined ? this.mapperTypes.default : _ref$type;

            this.loadMapperServices().then(function () {
                forEach(_this2.tagManagerServices, function (tagManagerService) {
                    tagManagerService.push(data, tagManagerService.getMapper(type));
                });
            });
        }
    }, {
        key: 'pushEvent',
        value: function pushEvent(event) {
            this.push({ data: event, type: this.mapperTypes.common.event });
        }
    }, {
        key: 'pushError',
        value: function pushError(error) {
            this.push({ data: error, type: this.mapperTypes.common.error });
        }
    }, {
        key: 'pushErrors',
        value: function pushErrors(errors) {
            if (!errors) {
                this.$log.error('Truthy value is expected as the first argument of Analytics.pushErrors.');
                return;
            }

            if (!isArray(errors) || errors.length === 0) {
                this.$log.error('A populated array is expected as the first argument of Analytics.pushErrors.');
                return;
            }

            this.pushError(errors.join('|'));
        }
    }, {
        key: 'pushUserDetail',
        value: function pushUserDetail(sessionStorageName) {
            if (this.sessionStorage.getAndRemove(sessionStorageName)) {
                this.push({
                    data: this.getUserDetail(),
                    type: sessionStorageName === 'shouldTrackSignupEvent' ? this.mapperTypes.customEvent.account.userRegister : this.mapperTypes.customEvent.account.userLogin
                });
            }
        }
    }, {
        key: 'getUserDetail',
        value: function getUserDetail() {
            var shopperDetails = void 0,
                address = void 0,
                rewards = null;
            if (this.bootstrap.isBootstrapped(this.bootstrap.bootstrapped.ShopperDetails) && this.bootstrap.isBootstrapped(this.bootstrap.bootstrapped.Trolley)) {
                shopperDetails = this.bootstrap.getBootstrappedData(this.bootstrap.bootstrapped.ShopperDetails) || {};
                address = shopperDetails.Address;
                shopperDetails.FirstName = 'REDACTED';
                shopperDetails.LastName = 'REDACTED';
                shopperDetails.DateOfBirthInput = 'REDACTED';
                shopperDetails.Email = 'REDACTED';
                shopperDetails.Phone = 'REDACTED';
                shopperDetails.SecondaryPhone = 'REDACTED';
                shopperDetails.Age = 'REDACTED';
                shopperDetails.CompanyName = 'REDACTED';
                shopperDetails.ABN = 'REDACTED';
                shopperDetails.PromptParams = this.sessionStorage.storage.PromptParams === undefined ? 'Prompted' : this.sessionStorage.storage.PromptParams;
                rewards = this.bootstrap.getBootstrappedData(this.bootstrap.bootstrapped.Trolley).WowRewardsSummary;
            }
            return {
                shopperDetails: shopperDetails,
                address: address,
                rewards: rewards,
                trackingType: 'link'
            };
        }
    }]);

    return AnalyticsService;
}();

AnalyticsService.$inject = ['$q', '$log', '$injector', '$ocLazyLoad', 'SessionStorageWrapper', 'Settings', 'AnalyticsEvents', 'BootstrapService', 'AnalyticsTagManagers', 'AnalyticsMappertypes'];

module.exports = AnalyticsService;

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(2);

module.exports = function (analytics) {
    return {
        restrict: 'A',
        scope: {},
        link: function link(scope, element, attrs) {
            $(element).change(function () {
                analytics.pushEvent(attrs.analyticsInput);
            });
        }
    };
};

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var formNameParser = __webpack_require__(691);

/**
* Use this directive to capture <form /> client-side errors in Analytics.
* Usage Example:
***************************************************************************************************************************
*  <form name= "myForm" wow-analytics-form-errors ng-submit=submitForm() >
*      <input id = "myForm-Firstname" name = "FirstName" ngModel="FirstNameModel" />
*  </form
********************************************************************************************************************************
* If the id of the input field has periods in it, the last value after a period will be used (eg: <input id="formName" name="ctrl.formName"> will use formName as the form name. name="ctrl.form.name" will use name as the form name)
* Also note that validity for the input field needs to be "false" for it to display in the summary. Server errors will explicitly need to have validity set to false for the corresponding field.
*
* Based on the directive olyFormValidationSummary (not a dependency)
*/
module.exports = function (analyticsService) {
    return {
        restrict: 'A',
        require: 'form',
        link: function link(scope, element, attrs, formCtrl) {
            var formName = formNameParser(formCtrl.$name);

            /**
             * The angular built-in validation tokens.
             */
            var formValidationTokens = ['email', 'max', 'maxlength', 'min', 'minlength', 'number', 'pattern', 'required', 'url', 'date', 'datetimelocal', 'time', 'week', 'month'];

            /**
             * Check whether there are any custom errors in the error object.
             * Custom form validation error types are often handled within component containing the form element.
             * This check can be used to avoid duplication of error pushes to Analytics.
            */
            var hasCustomFormError = function hasCustomFormError(error) {
                var isCustomError = false;
                _.forOwn(error, function (value, key) {
                    if (!_.includes(formValidationTokens, key)) {
                        isCustomError = true; // Set custom error is present.
                    }
                });

                return isCustomError;
            };

            var pushErrors = function pushErrors() {
                if (hasCustomFormError(formCtrl.$error)) return;

                var errors = [];
                _.forEach(formCtrl, function (value, field) {
                    if (formCtrl[field] && formCtrl[field].$invalid) {
                        errors.push(formName + '.' + formCtrl[field].$name + ' is invalid.');
                    }
                });

                if (errors.length > 0) {
                    analyticsService.pushErrors(errors);
                }
            };

            scope.$watch(function () {
                return formCtrl.$invalid && formCtrl.$dirty && formCtrl.$submitted;
            }, function (newValue) {
                if (newValue === true) {
                    pushErrors();
                }
            });

            scope.$watch(function () {
                return formCtrl.$submitted;
            }, function (newValue) {
                if (newValue === true) {
                    pushErrors();
                }
            });
        }
    };
};

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (formName) {
    if (formName.indexOf('.') > 0) {
        var fields = formName.split('.');
        return fields.length > 1 ? fields[fields.length - 1] : fields[0];
    }
    return formName;
};

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    isUndefined = _require.isUndefined,
    cloneDeep = _require.cloneDeep;

var BootstrapService = function () {
    function BootstrapService($window) {
        _classCallCheck(this, BootstrapService);

        this._data = $window.wowBootstrap || {};

        // A map of objects which are bootstrapped
        this.bootstrapped = {
            Config: 'ConfigRequest',
            Settings: 'SettingRequest',
            Shopper: 'ShopperRequest',
            ShopperDetails: 'ShopperDetailsRequest',
            ShopperBasicPreferences: 'BasicShopperPreferencesRequest',
            Categories: 'ListAllPiesCategoriesWithSpecialsRequest',
            RootCategories: 'ListTopLevelPiesCategories',
            Trolley: 'TrolleyRequest',
            DeliveryInfo: 'GetDeliveryInfoRequest',
            SpecialsGroups: 'SpecialsGroupListForShopRequest',
            SpecialsCategories: 'ListCategoriesForSpecialsRequest',
            RecipeCategories: 'ListRecipeCategoriesRequest',
            SavedLists: 'ListSavedListsRequest',
            SuggestedLists: 'ListSuggestedListsRequest',
            PastShops: 'ListPastShopsRequest',
            SearchPhraseActions: 'ListSearchPhraseActionsRequest',
            Panels: 'PanelsRequest',
            Subscriptions: 'SubscriptionsRequest',
            ShopperPreferences: 'ShopperPreferencesRequest'
        };
    }

    _createClass(BootstrapService, [{
        key: 'getBootstrappedData',
        value: function getBootstrappedData(key) {
            return cloneDeep(this._data[key]);
        }
    }, {
        key: 'isBootstrapped',
        value: function isBootstrapped(key) {
            return key in this._data && !!this._data[key];
        }
    }, {
        key: 'getBootstrappedDataIfPresent',
        value: function getBootstrappedDataIfPresent(key) {
            return this.isBootstrapped(key) ? this.getBootstrappedData(key) : null;
        }
    }, {
        key: 'setData',
        value: function setData(key, value, subKey) {
            if (isUndefined(subKey) || subKey === null || subKey === '') {
                this._data[key] = value;
            } else {
                this._data[key][subKey] = value;
            }
        }
    }]);

    return BootstrapService;
}();

BootstrapService.$inject = ['$window'];

module.exports = { BootstrapService: BootstrapService };

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1).module('wowApp.common').factory('config', ['BootstrapService', __webpack_require__(694)]);

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (bootstrap) {
    return bootstrap.getBootstrappedData(bootstrap.bootstrapped.Config) || {};
};

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.common');

wowApp.service('FeatureService', [__webpack_require__(696)]);

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Checks whether a feature is enabled or not by looking for a class on the HTML tag
 * (similar to Modernizr). Used for CSS/JavaScript based feature switching.
 * @class
 */
function FeatureService() {
    var classes = document.documentElement.className.split(/\s+/);
    this._features = {};

    for (var i = 0; i < classes.length; i++) {
        this._features[classes[i]] = true;
    }
}

FeatureService.prototype.isEnabled = function (featureName) {
    return featureName in this._features && this._features[featureName];
};

FeatureService.prototype.setFeature = function (featureName, isEnabled) {
    this._features[featureName] = isEnabled;
};

/* STOP ADDING THINGS TO THIS, USE THE SETTINGS SERVICE! :) */
FeatureService.prototype.features = {
    checkout: 'conversational-checkout-wizard',
    sfExpandPersonalShopperComment: 'sf-expand-personal-shopper-comment',
    mfExpandPersonalShopperComment: 'mf-expand-personal-shopper-comment',
    lfExpandPersonalShopperComment: 'lf-expand-personal-shopper-comment',
    checkoutPerformanceEnhancements: 'checkout-performance-enhancements',
    clickAndCollectStoreSearch: 'click-and-collect-store-search',
    enableDiscoverLandingPage: 'enable-discover-landing-page',
    enableGetEdrPointsBalanceOnLogin: 'enable-get-edr-points-balance-on-login',
    recipeSocialMedia: 'recipe-social-media',
    recipePrintExport: 'recipe-export-print',
    rememberMe: 'remember-me-enabled',
    checkoutWithPaypal: 'enable-checkout-with-paypal',
    enableCustomCouponPromotionSuccessMessage: 'enable-custom-coupon-promotion-success-message',
    showAcceptedCardsInCheckout: 'show-accepted-cards-in-checkout',
    wos4048: 'wos4048',
    enableMyInvoicesPage: 'enable-my-invoices-page',
    enableRichRelevanceRecommendations: 'enable-rich-relevance-recommendations',
    // following features are used to determine which page groups have RR placements
    // enabled. Naming convention 'rr-show-placements-in-{pagegroup}-pages' is
    // expected by the RR instrumentation components.
    rrShowPlacementsInCategoryPages: 'rr-show-placements-in-category-pages',
    rrShowPlacementsInHomepagePages: 'rr-show-placements-in-homepage-pages',
    rrShowPlacementsInHyfPages: 'rr-show-placements-in-hyf-pages',
    rrShowPlacementsInreorderPages: 'rr-show-placements-in-reorder-pages',
    rrShowPlacementsInSpecialsGroupPages: 'rr-show-placements-in-specials-group-pages'

    /* STOP ADDING THINGS TO THIS, USE THE SETTINGS SERVICE! :) */
};

module.exports = FeatureService;

// Provided for backwards compat with code in Behaviour.js and Shop.js
// Delete once no longer needed
if (!('wowFeatures' in window)) {
    window.wowFeatures = new FeatureService();
}

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(698),
    SettingsService = _require.SettingsService;

var _require2 = __webpack_require__(699),
    settings = _require2.settings,
    settingDefaults = _require2.settingDefaults;

var _require3 = __webpack_require__(775),
    SettingsByBreakpointService = _require3.SettingsByBreakpointService;

var settingsDirectiveDefinition = __webpack_require__(776);
var htmlSettingDirectiveDefinition = __webpack_require__(777);

angular.module('wowApp.common').run(__webpack_require__(778)).constant('Settings', settings).constant('SettingDefaults', settingDefaults).service('SettingsService', SettingsService).service('SettingsByBreakpointService', SettingsByBreakpointService).directive('wowSetting', ['SettingsService', settingsDirectiveDefinition]).directive('wowHtmlSetting', ['SettingsService', htmlSettingDirectiveDefinition]);

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    camelCase = _require.camelCase,
    forEach = _require.forEach;

/**
 * Service for managing settings.
 * Stores settings in the 'Settings' constant object in the format `settings.groupName.settingName`
 */


var SettingsService = function () {
    function SettingsService($q, restangular, settings) {
        _classCallCheck(this, SettingsService);

        this.$q = $q;
        this.api = restangular.all('Settings');
        this.settings = settings;
    }

    _createClass(SettingsService, [{
        key: 'updateSettings',
        value: function updateSettings(settings) {
            var _this = this;

            forEach(settings, function (setting) {
                return _this._updateSetting(setting.Group, setting.Name, setting.Value);
            });
        }
    }, {
        key: '_updateSetting',
        value: function _updateSetting(group, name, value) {
            group = camelCase(group);
            name = camelCase(name);

            this.settings[group] = this.settings[group] || {};
            this.settings[group][name] = value;
        }

        /**
         * Gets a promise to the value of the provided setting
         *
         * @deprecated Use 'settingsService.settings.groupName.settingName', or inject 'Settings' and use 'settings.groupName.settingName'
         */

    }, {
        key: 'getSettingValue',
        value: function getSettingValue(group, name) {
            group = camelCase(group);
            name = camelCase(name);

            if (!(group in this.settings)) {
                return this.$q.reject(new Error('Error getting setting ' + group + '-' + name + '. Setting group not found.'));
            }

            var groupSettings = this.settings[group];

            if (!(name in groupSettings)) {
                return this.$q.reject(new Error('Error getting setting ' + group + '-' + name + '. Setting name not found.'));
            }

            return this.$q.when(groupSettings[name]);
        }

        /**
         * Invalidates and updates setting values
         */

    }, {
        key: 'invalidate',
        value: function invalidate() {
            var _this2 = this;

            return this.api.doGET().then(function (settings) {
                return _this2.updateSettings(settings);
            });
        }
    }]);

    return SettingsService;
}();

SettingsService.$inject = ['$q', 'Restangular', 'Settings'];

module.exports = {
    SettingsService: SettingsService
};

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _require = __webpack_require__(0),
    cloneDeep = _require.cloneDeep,
    merge = _require.merge;

function requireSettingGroups() {
    var context = __webpack_require__(700);

    return context.keys().map(function (k) {
        return context(k);
    });
}

var settingDefaults = Object.freeze(merge.apply(undefined, [{}].concat(_toConsumableArray(requireSettingGroups()))));
var settings = cloneDeep(settingDefaults);

module.exports = {
    settings: settings,
    settingDefaults: settingDefaults
};

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./abn-lookup.js": 701,
	"./agent.js": 702,
	"./analytics.js": 703,
	"./b2B.js": 704,
	"./banners.js": 705,
	"./care-package.js": 706,
	"./cart.js": 707,
	"./category.js": 708,
	"./checkout-confirmation.js": 709,
	"./checkout.js": 710,
	"./crowd-sourced-delivery.js": 711,
	"./delivery-window-alerts.js": 712,
	"./delivery.js": 713,
	"./deliverysaver.js": 714,
	"./digitalpay-creditcard-fields.js": 715,
	"./digitalpay-creditcard-networks.js": 716,
	"./digitalpay-error.js": 717,
	"./digitalpay-errorcodes.js": 718,
	"./digitalpay-giftcard-fields.js": 719,
	"./digitalpay-messages.js": 720,
	"./digitalpay-orderplacement-errorcodes.js": 721,
	"./digitalpay-paymenttypes.js": 722,
	"./digitalpay-screenreader-messages.js": 723,
	"./digitalpay.js": 724,
	"./dpu-overlay.js": 725,
	"./dynamic-content.js": 726,
	"./everyday-rewards.js": 727,
	"./express-landing-page.js": 728,
	"./filter.js": 729,
	"./footer.js": 730,
	"./fulfilment-method.js": 731,
	"./fulfilment-selector.js": 732,
	"./fulfilment-timetable.js": 733,
	"./global.js": 47,
	"./google-sem.js": 734,
	"./handy-hint.js": 735,
	"./lists.js": 736,
	"./loyalty.js": 737,
	"./merchant-hosted.js": 738,
	"./my-account.js": 739,
	"./my-profile.js": 740,
	"./myaccount.js": 741,
	"./onboarding.js": 742,
	"./onesite.js": 743,
	"./order-confirmation.js": 744,
	"./order-management.js": 745,
	"./packaging-fee-switches.js": 746,
	"./packaging-fee.js": 747,
	"./pickup.js": 748,
	"./product-detail-availability.js": 749,
	"./product-details-additional-attributes.js": 750,
	"./product-restrictions.js": 751,
	"./product-tile-availability.js": 752,
	"./quick-reorder.js": 753,
	"./ratingreview.js": 754,
	"./recipe.js": 755,
	"./registration.js": 756,
	"./rewards.js": 757,
	"./ringcaptcha-messages.js": 758,
	"./search.js": 759,
	"./shelf-product-tile.js": 760,
	"./sign-up-form.js": 761,
	"./site-census.js": 762,
	"./smart-banner.js": 763,
	"./sponsored-ads.js": 764,
	"./stock-checker.js": 765,
	"./subscriptions-errorcodes.js": 766,
	"./substitutions-instructions-link-text.js": 767,
	"./substitutions.js": 768,
	"./track-my-order-deliverymethod.js": 769,
	"./track-my-order-eta.js": 770,
	"./track-my-order-progress.js": 771,
	"./track-my-order.js": 772,
	"./trolley.js": 773,
	"./unsub-edm.js": 774
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 700;

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    abnLookup: {
        errorMessage: "Unable to find a match for your ABN. Please check the number you have entered.\n            Alternatively, call 1300 665 386 or email business@woolworths.com.au to sign up with us"
    }
};

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    agent: {
        // From a content setting.
        redirectToAgentUrlText: '<p>Now you can purchase ingredients from the&nbsp;<a href="{RedirectToAgentUrl}" target="_parent" style="color: #E95716;">menu tab</a></p>'
    }
};

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    analytics: {
        useDtm: true,
        useGtm: true,
        useTealium: false,
        tealiumAccount: 'woolworths',
        tealiumProfile: 'supermarkets',
        tealiumEnvironment: 'dev',
        tealiumNotAvailableValue: '',
        /* page type exceptions array contains pages with pre-defined types
        * if the page is not in this list it will be identified as 'other' page type
        */
        tealiumPageTypeExceptions: ['root', 'shop.page', 'shop.catalogue', 'shop.browse', 'shop.productdetails', 'shop.recipes', 'shop.recipedetail', 'shop.search', 'shop.locator', 'shop.tripplanner', 'shop.cart', 'shop.list', 'checkout', 'hyf', 'shop.confirmation', 'shop.myaccount', 'shop.inspiration', 'shop.new', 'shop.offergroup', 'shop.productgroup', 'shop.guestList', 'shop.suggestedlists', 'shop.authentication']
    }
};

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// added for unit test purpose only
module.exports = {
    b2B: { businessTypeCategoryMapping: null }
};

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    banners: {
        tobaccoDefault: 'https://cdn0.woolworths.media/content/banners/stopsmoking-groupbanner-lf.jpg',
        tobaccoSmall: 'https://cdn0.woolworths.media/content/banners/stopsmoking-groupbanner-sf.jpg'
    }
};

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    carePackage: {
        cartConfirmationModalTitle: 'Heads up!<br/>If you add a Woolworths Basics Box to your cart, we’ll automatically remove all other items in your cart.',
        cartConfirmationModalContent: 'This is because Woolworths Basics Boxes are delivered by Australia Post, so we are unable to add any additional items to your order.'
    }
};

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    cart: {
        clearTrolleyConfirmationMessage: 'Are you sure you would like to remove all products from the cart?',
        expressUnavailableHeader: 'Delivery Now is currently unavailable',
        meatStockLossMessage: 'Weight is approximate. We won\'t overcharge you if we give you more, and we\'ll refund the difference if it\'s less.',
        removeAllProductsLinkText: 'Remove all products',
        estimatedDeliveryFee: '$0.00 - $19.00',
        deliveryFeeOptionLink: 'https://www.woolworths.com.au/shop/discover/shopping-online/delivery',
        estimatedPackagingFee: '$0.00 - $2.50',
        packagingFeeOptionLink: 'https://www.woolworths.com.au/shop/discover/reusable-bags'
    }
};

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    category: {
        myWeeklyPicksException: 'You have not added your rewards card to your online account. To start earning points online link your card now.',
        myWeeklyPicksExceptionV2: 'Oops. We can\'t find an Everyday Rewards Card attached to your Woolworths Online account.',
        tokenizedWeeklyPicksExceptionMessage: 'Please give us a second chance and hit \'reload page\' to see them.',
        disableCategoryMenuHover: false,
        excludeSpecials: false,
        myWeeklyPicksExceptionRewards: 'To see your favourites and start collecting points, please use the button below to add your Everyday Rewards Cards.'
    }
};

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    checkoutConfirmation: {
        deliveryMethodMessagePickup: 'Your order can be collected from',
        deliveryMethodMessageDeliver: 'Your order will be delivered to'
    }
};

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    checkout: {
        staffDiscountLabel: 'Team Member Discount',
        eVoucherDisplayName: 'eVoucher',
        zeroPaymentDisplayMessage: 'Your balance is less or equal to zero. Please submit your order.',
        isNewCheckoutConfirmBehavior: false,
        b2bTsAndCsDisclaimer: '<p>By placing this order, you confirm that you agree to Woolworths <a href="https://www.woolworthsonline.com.au/shop/discover/shopping-online/my-business-terms-and-conditions" target="_blank">terms and conditions</a> (including our <a href="https://www.woolworthsonline.com.au/Shop/Discover/about-us/privacy-policy" target="_blank">privacy policy</a>).</p>',
        b2cTsAndCsDisclaimer: '<p>By placing this order, you confirm that you agree to Woolworths <a href="https://www.woolworthsonline.com.au/Shop/Discover/about-us/terms-and-conditions" target="_blank">terms and conditions</a> (including our <a href="https://www.woolworthsonline.com.au/Shop/Discover/about-us/privacy-policy" target="_blank">privacy policy</a>).</p>',
        restrictedByCrowdDeliveryMessage: "Sorry, these products aren't available for your chosen window"
    }
};

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    crowdSourcedDelivery: {
        crowdSourcedLimitLabel: 'Max. 40 item limit',
        crowdSourcedDeliveryLabel: 'Partner Delivery Driver'
    }
};

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    deliveryWindowAlerts: {
        alertTitle: 'Delivery Window Alert',
        expressDeliveryUnavailableMessage: 'Sorry, Delivery Now is no longer available at this current time. Choose another delivery method or pickup.',
        orderLimitExceededWarningError: 'Your cart has exceeded the limit for Delivery Now'
    }
};

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    delivery: {
        canLeaveUnattendedPreferenceHintText: 'If you might not be home during your delivery window but still wish to receive your delivery at that time, you can choose to have your items left unattended',
        canLeaveUnattendedPreferenceText: 'Leave items unattended',
        deliveryInstructionLabel: 'Do you have instructions for the driver?',
        deliveryInstructionPlaceholder: 'Eg. put items in ice cooler',
        deliverySubmitError: 'All delivery information needs to be set before you confirm delivery.',
        deliveryWindowReloadingMessage: 'Updating...',
        deliveryWindowReservedMessage: 'Exclusive access',
        frozenDeliveryWarning: '\n                <h4 style="margin-bottom: 8px;">Just a heads up</h4>\n                <p style="margin: 0;font-weight: normal;">Your order includes chilled items that may spoil if left unattended.</p>\n            ',
        mobileErrorMessage: 'It seems like the mobile number you\'ve entered isn\'t a valid number',
        mobileErrorTitle: 'Please check your mobile number',
        mobileHintText: '*We\'ll call this number if there are any delays or issues with the delivery of your order',
        pickupInstructionLabel: 'Instructions for my Pick Up store',
        pickupInstructionPlaceholder: 'Eg. My partner will pick up the order',
        restrictionWarningDeliverySignature: '\n                <h4 style="margin-bottom: 8px;">Your order contains restricted items.</h4>\n                <p style="margin: 0;font-weight: normal;">Please ensure someone over 18 with a valid photo ID is available to sign for this delivery.</p>\n            ',
        restrictionWarningDeliverySignatureAndPhotoId: '\n                <h4 style="margin-bottom: 8px;">Your order contains restricted items.</h4>\n                <p style="margin: 0;font-weight: normal;">Please ensure someone over 18 with a valid photo ID is available to sign and have their ID scanned for this delivery.</p>\n            ',
        restrictionWarningPickupSignature: '\n                <h4 style="margin-bottom: 8px;">Your order contains restricted items.</h4>\n                <p style="margin: 0;font-weight: normal;">Please ensure someone over 18 with a valid photo ID is available to sign.</p>\n            ',
        restrictionWarningPickupSignatureAndPhotoId: '\n                <h4 style="margin-bottom: 8px;">Your order contains restricted items.</h4>\n                <p style="margin: 0;font-weight: normal;">Please ensure someone over 18 with a valid photo ID is available to sign and have their ID scanned.</p>\n            '
    }
};

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    deliverySaver: {
        landingInclusionsHtml: '\n            <li>Unlimited deliveries</li>\n            <li>Covers our \'Crate to bench\' service and reusable bags</li>\n            <li>Applies on all orders over $100</li>\n            <li>Cancel renewal at any time</li>\n        ',
        freeTrialLandingInclusionsHtml: '\n            <li>Unlimited deliveries, including next day delivery (just order before 6pm!)</li>\n            <li>Covers our \'Crate to bench\' service and reusable bags</li>\n            <li>Applies on all orders over $100</li>\n            <li>Cancel renewal at any time</li>\n        ',
        freeTrialLandingContentHtml: '\n            <p>Ready to pick your plan? You won\'t be charged for 30 days.</p>\n            <p class=\'u-disclaimer\'>Free trial for new customers only.</p>\n        ',
        landingTitle: 'Welcome back',
        freeTrialLandingTitle: 'Free trial for 30 days',
        freeTrialLandingSubHeader: 'It\'s easy to get started with Delivery Unlimited',
        personalPlansNotEligibleTitle: 'Business Subscription Pricing',
        personalPlansNotEligibleText: 'You are currently logged into a business account, log in with your personal account to subscribe with the below prices.',

        businessPlansNotEligibleTitle: 'Personal Subscription Pricing',
        businessPlansNotEligibleText: 'You are currently logged into a personal account, log in with your business account to subscribe with the below prices.',

        seniorPlansEligibleTitle: 'Great news!',
        seniorPlansEligibleText: "You're eligible for Seniors Delivery Unlimited pricing. Please see your updated prices below.",

        seniorPlansNotEligibleForB2bTitle: "Your're logged into a business account",
        seniorPlansNotEligibleForPersonalTitle: "Your're logged into a personal account",
        seniorPlansNotEligibleText: 'Currently Senior Delivery Unlimited is available for eligible customers only'
    },
    deliverySaverFeatures: {
        freeTrial: '{freeTrialDays} days free trial',
        handPicked: 'All orders hand picked by one of our Personal Shoppers',
        coversPackingCosts: 'Covers crate to bench and reusable bag costs',
        // eslint-disable-next-line no-template-curly-in-string
        minimumOrderAmount: 'Orders must exceed ${minimumOrderAmount}',
        cancelAnytime: 'Cancel your subscription at anytime',
        deliveryAddressPerAccount: '4 delivery addresses per account',
        midweek: 'Covers Delivery costs on Tues - Thurs',
        anyDay: 'Covers Delivery costs 7 days a week',
        deliveryNowSameDay: 'Delivery Now* & Same Day deliveries',
        bulkAndRemoteOrder: 'Special Bulk & Remote orders'
    },
    deliverySaverEligibilities: {
        person60AndOver: 'Persons 60 years and over'
    }
};

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    digitalPayCreditCardFields: {
        cardNumber: 'card',
        month: 'month',
        year: 'year',
        cvv: 'cvv'
    }
};

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    digitalPayCreditCardNetworks: {
        visa: 'VISA',
        mastercard: 'MASTERCARD',
        americanexpress: 'AMEX',
        diners: 'DINERS',
        jcb: 'JCB'
    }
};

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
        /**
         * The comment following each variable inside is referring to an external document that contains the Error variable and sometimes Error Code(s)
         * They are included to make it easier to search for an error message here.
         */
        digitalPayError: {
                // Typeless
                deliveryWindowExpiryErrorMessage: 'Your delivery reservation has expired. Please select another delivery time slot to continue.', // delivery_timeslot_session_expired
                genericGlobalPaymentMessage: 'There was an error making your payment. Please try another payment method.', // single_payment_default_failed_message
                genericGlobalSplitPaymentMessage: 'There was an error making your payment.', // split_payment_default_failed_message
                multipleGlobalPaymentErrorMessage: 'There was an error making your payment. Please review and try again.', // split_payment_failed_saved_cc
                paymentInstrumentNotFoundMessage: 'The payment method you tried to pay with no longer exists. Please choose another payment method.', // single_payment_payment_instrument_not_found
                paymentInstrumentNotFoundSplitPaymentMessage: 'The payment method you tried to pay with no longer exists.', // split_payment_payment_instrument_not_found
                tokenizationFailureMessage: 'There was an error making your payment. Please try again.', // tokenisation_failed

                // On Account
                onAccountInvalidPasswordMessage: 'Please enter the correct password to verify your account.', // on_account_invalid_password

                // Credit Card
                creditCardAddCaptureFormExpiryFailure: 'This form has expired, please provide your details again.', // iframe_session_expired
                creditCardAddCaptureFormLoadFailure: 'We\'re currently unable to process new credit cards.', // new_card_iframe_failed_to_load
                creditCardAddCardFailure: 'We\'ve encountered a technical issue and were unable to add your credit card. Please try again later.', // creditcard_add_failed
                creditCardDeleteErrorMessage: 'We have encountered a technical issue and were unable to remove your credit card. Please try again later.', // creditcard_delete_failed
                creditCardDeleteLinkedCardForbiddenMessage: 'Sorry, you can\'t remove a card which is linked to your Delivery Unlimited subscription. Please link a new card before removing.', // creditcard_delete_linkedcard_forbidden
                creditCardEditCaptureFormLoadFailure: 'We\'re currently unable to update credit card details.', // update_card_iframe_failed_to_load
                creditCardInvalidCardNumberMessage: 'Please provide a valid credit card number.', // invalid_credit_card_number
                creditCardInvalidCvvMessage: 'Please provide a valid CVV/CVC.', // invalid_cvv
                creditCardInvalidExpiryDetailsMessage: 'Please provide valid expiry details.', // invalid_exp_details
                creditCardInvalidMonthMessage: 'Please provide a valid expiry month.', // invalid_expiry_month
                creditCardInvalidYearMessage: 'Please provide a valid expiry year.', // invalid_expiry_year
                creditCardMultipleExpiredWarning: 'You have expired credit cards.', // expired_credit_card_multiple
                creditCardFieldsMissingErrorsMessage: 'Please provide the missing details or clear the form to continue.', // partially_filled_credit_card_details
                creditCardMultipleValidationErrorsMessage: 'Please provide valid credit card details.', // multiple_invalid_credit_card_fields
                creditCardNotSupportedMessage: 'The card you have provided is not currently supported.', // non_supported_credit_card_number
                creditCardPaymentNewCreditCardFailure: 'There was an error making your payment. Please try another payment method.', // single_payment_new_creditcard_failure
                creditCardSplitPaymentNewCreditCardFailure: 'Credit Card: There was an error making your payment.', // split_payment_new_creditcard_failure
                creditCardPaymentSaveNewCreditCardFailure: 'There was an error making your payment and it could not be saved. Please try another payment method.', // single_payment_new_creditcard_opt_save_failure
                creditCardSplitPaymentSaveNewCreditCardFailure: 'Credit Card: There was an error making your payment and it could not be saved.', // single_payment_new_creditcard_opt_save_failure
                creditCardSavedCardPaymentFailure: 'X-{0}: has been declined by your financial provider. Please try another payment method.', // single_payment_saved_creditcard_failure
                creditCardSavedCardSplitPaymentFailure: 'X-{0}: has been declined by your financial provider.', // split_payment_saved_creditcard_failure
                creditCardSingleExpiredWarning: 'You have an expired credit card.', // expired_credit_card
                creditCardDialogCvvExpiredMessage: 'The CVV form has expired, please press cancel and try again.', // modal_cvv_iframe_session_expired
                creditCardUpdateFailMessage: 'We\'ve encountered a technical issue and were unable to update your credit card. Please try again later.', // update_credit_card_failed

                // Gift Card
                giftCardAddExpiredMessage: 'This gift card has expired, please choose another payment method.', // ES105 giftcard_expired
                giftCardAddInsufficientFundsMessage: 'This gift card has insufficient funds for purchase, please choose another payment method.', // gift_card_insufficient_funds_new
                giftCardAddDuplicateCardMessage: 'This gift card has already been added, please provide a different gift card number.', // giftcard_duplicate_card
                giftCardAmountAvailableExceedMessage: 'The amount value cannot exceed {AMOUNTAVAILABLE}', // giftcard_amount_greator_than_balance
                giftCardBalanceApiWarningMessage: 'We were unable to obtain the gift card balance for some of your gift cards, you may still make a payment', // ES611 giftcard_balance_check_failed_some_card
                giftCardDeleteErrorMessage: 'We have encountered a technical issue and were unable to remove your gift card. Please try again later.', // giftcard_delete_failed
                giftCardExpiredMessage: 'You have an expired gift card', // expired_gift_card
                giftCardGenericPaymentErrorMessageTemplate: 'X-{0}: has been declined. Please try another payment method.', // single_payment_saved_giftcard_generic_failure, single_payment_new_giftcard_generic_failure
                giftCardGenericSplitPaymentErrorMessageTemplate: 'X-{0}: has been declined.', // split_payment_saved_giftcard_generic_failure, single_payment_new_giftcard_generic_failure
                giftCardIncorrectDetailsMessage: 'Please provide valid gift card details.', // ES120 invalid_gift_card_from_wex, invalid_gift_card_pin_from_wex
                giftCardInsufficientFundsMessage: 'You have a card with insufficient funds for purchase', // ES151 gift_card_insufficient_funds_saved_single
                giftCardInvalidCardNumberMessage: 'Please provide a valid gift card number.', // ES120 invalid_gift_card_number
                giftCardInvalidPinMessage: 'Please provide a valid gift card PIN.', // invalid_gift_card_pin
                giftCardMultipleErroredCardsMessage: 'You have cards that require action: <br/> - {0} <br/> - {1}',
                giftCardMultipleExpiredErrorMessage: 'You have expired gift cards', // expired_gift_card_multiple
                giftCardMultipleValidationErrorsMessage: 'Please provide valid gift card details.', // multiple_invalid_gift_card_fields
                giftCardMultipleInsufficientFundsErrorMessage: 'You have cards with insufficient funds for purchase', // ES151 gift_card_insufficient_funds_saved_multiple
                giftCardFieldsMissingErrorsMessage: 'Please provide the missing details or clear the form to continue.', // partially_filled_gift_card_details
                giftCardPaymentNotAcceptedByBannerErrorMessage: 'This gift card is not accepted in this store. Please enter a different card number or select an alternative payment method.', // ES130 gift_card_not_accepted_by_banner
                giftCardSpecificPaymentErrorMessageTemplate: 'X-{0}: {1} Please try another payment method.', // single_payment_saved_giftcard_specific_failure, single_payment_new_giftcard_specific_failure
                giftCardSpecificSplitPaymentErrorMessageTemplate: 'X-{0}: {1}.', // split_payment_saved_giftcard_specific_failure, single_payment_new_giftcard_specific_failure
                giftCardUnableToRetrieveBalanceMessage: 'We are currently unavailable to retrieve your gift card balance but you may continue to make a payment.', // ES611 giftcard_balance_check_failed
                giftCardAddErrorMessage: 'We have encountered a technical issue and were unable to add your gift card. Please try again later.', // giftcard_delete_failed
                giftCardNumberRequiredMessage: 'Gift card number is required.',
                giftCardPinRequiredMessage: 'PIN is required.',
                giftCardTooManyRequestsMessage: 'We are currently unable to retrieve your gift card balance.', // giftcard_balance_too_many_request

                // Paypal
                paypalInsufficientFundsMessage: 'The PayPal account has insufficient funds for purchase, please choose another payment method.',
                paypalLinkFailureErrorMessage: 'We\'ve encountered a technical issue and were unable to link your Paypal account. Please try again later.', // paypal_linking_failed
                paypalPaymentGenericErrorMessage: 'There was an error making your payment. Please try another payment method.', // single_payment_paypal_generic_failure
                paypalSplitPaymentGenericErrorMessage: 'There was an error making your payment.', // split_payment_paypal_generic_failure
                paypalPaymentUnregisteredExternallyErrorMessage: 'The PayPal account provided no longer exists and has been unlinked. Please link a new PayPal account if you wish to continue with this payment method.', // ES470 paypal_unregistered_externally_single_payment
                paypalUnlinkFailureErrorMessage: 'We\'ve encountered a technical issue and were unable to unlink your PayPal account. Please try again later.', // paypal_unlinking_failed

                // Wallet
                walletGiftCardBalanceApiWarning: 'We were unable to obtain the gift card balance for some of your gift cards.',
                walletGiftCardUnableToRetrieveBalanceWarning: 'We are currently unavailable to retrieve your gift card balance.', // ES611 giftcard_balance_check_failed
                walletRemoveFailureTitle: 'There was an error removing your payment method.',
                walletPaypalLinkFailureTitle: 'There was an error linking your PayPal account.',
                walletPaypalUnlinkFailureTitle: 'There was an error unlinking your PayPal account.',
                walletGenericDeleteErrorMessage: 'We have encountered a technical issue and were unable to remove your payment method. Please try again later.',
                walletAddFailureTitle: 'There was an error adding your payment method.'
        }
};

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    digitalPayErrorCodes: {
        // Apigee error codes
        unknown: 'UN99',

        // Container error codes
        creditCardCaptureFormExpired: 'BI10',
        creditCardDeleteLinkedCardForbidden: 'BV37',
        creditCardIframeSucceededPreviously: 'IF06', // Iframe was submitted previously and succeed.
        creditCardIframeUnableToProcessRequest: 'IF98',
        creditCardStepUpTokenRequired: 'BV59',
        giftCardKnownBalanceCheckFailed: 'ES611',
        giftCardNotAcceptedByBanner: 'ES130',
        giftCardUnableToRetrieveDetails: 'ES120',
        giftCardUnknownBalanceCheckFailed: 'ES52',
        giftCardZeroBalance: 'ES56',
        paymentInstrumentExpired: 'ES105',
        paymentInstrumentNotFound: 'BI24',
        paypalAccountLockedOrClosed: 'ES470',
        insufficientFunds: 'ES151',
        unknownPayment: 'ES52',

        // Custom error codes
        giftCardBalanceApiUnavailable: 'DpGiftCardBalanceApiUnavailable'
    }
};

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    digitalPayGiftCardFields: {
        cardNumber: 'giftCardNumber',
        pin: 'giftCardPin',
        amount: 'giftCardAmount'
    }
};

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    digitalPayMessages: {
        creditCardCvvMessage: 'In order to proceed with your order we need to verify your credit card',
        genericDeleteMessage: 'Are you sure you would like to delete your saved card from your account?',
        creditCardDeleteMessage: 'Are you sure you would like to delete your saved card from your account?',
        giftCardDeleteMessage: 'Are you sure you would like to delete your saved card from your account?',
        paypalUnlinkMessage: 'Are you sure you would like to unlink PayPal from your account?',
        accountPaymentWhenListUnavailableMessage: 'You can continue to make Account payments or try refreshing the page.'
    }
};

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    digitalPayOrderPlacementErrorCodes: {
        declined: 'Declined',
        deliveryWindow: 'DeliveryWindow',
        invalidPassword: 'InvalidPassword',
        timeout: 'Timeout'
    }
};

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    digitalPayPaymentTypes: {
        giftCardType: 'GiftCard',
        paypalType: 'PayPal',
        creditCardType: 'CreditCard',
        onAccountType: 'OnAccount',
        emptyType: 'None',
        unknownType: 'NotSet'
    }
};

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    digitalPayScreenReaderMessages: {
        accountPasswordDisableStateMessage: 'Account password is blank or invalid.',
        creditCardAddDisableMessage: 'Credit Card is blank or invalid.',
        creditCardCvvDisableMessage: 'Credit Card X-{0} CVV is blank or invalid.',
        creditCardManageModeDisableMessage: 'You are in credit card manage mode. Close it to enable placing orders.',
        giftCardAddDisableMessage: 'Gift Card is invalid or blank.',
        giftCardManageModeDisableMessage: 'You are in gift card manage mode. Close it to enable placing orders.',
        giftCardAmountDisableMessage: 'Gift Card X-{0} amount is incomplete.',
        placeOrderInvalidDisableMessage: 'Unable to place order. Reasons: {0}',
        placeOrderProcessingDisableMessage: 'Currently placing order, please wait.',
        subscriptionProcessingDisableMessage: 'Currently processing subscription, please wait.'
    }
};

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    digitalPay: {
        creditCardGenericIcon: 'card', // Maps to the generic card icon image
        giftCardNumberLength: 19,
        giftCardPinLength: 4,
        iframeTimeoutInMilliseconds: 30000,
        inlineCvvIframeSpinnerDelayInMilliseconds: 500,
        inlineCvvIframeTimeoutInMilliseconds: 20000,
        formFocusOutTimeoutMilliseconds: 500,
        transactionHistoryContent: 'Review and track your financial transactions related to online orders you\'ve made with Woolworths.',
        paymentMethodsContent: 'Securely save additional and manage existing payment methods that you can use with your Woolworths account to quickly make payments during checkout.'
    }
};

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    dpuOverlay: {
        popupWidth: 700,
        popupHeight: 500,
        maxShowPopupTimeInMinutesWithNoResponse: 5, // 5 mins maximum
        popupWindowCheckingFrequency: 1 // how often to check the status of popup window in seconds, 1 = 1 second, 0.8 = 800 milliseconds
    }
};

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    dynamicContent: {
        defaultScheduleKey: ''
    }
};

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    everydayRewards: {
        cardName: 'Woolworths Rewards',
        cardNameV2: 'Everyday Rewards',
        enableRewardsPlus: false,
        enableProjectPortugal: false,
        forgottenPasswordRewardsLink: 'https://www.woolworthsrewards.com.au/index.html#/forgot-password',
        isRewardsPlus: false,
        rewardsBannerTitle: 'Your Woolworths Rewards Card has been linked.',
        rewardsBannerSubtitle: 'Start shopping to enjoy all your benefits.',
        rewardsBannerButtonText: 'Get Started',
        rewardsLoginPromotionText: 'When you add your card, you can see your favourite weekly picks, start earning points and more.',
        rewardsLoginValidationErrorTitle: 'Adding your Woolworths Rewards card was not successful.',
        rewardsLoginServerError: 'Your specified Woolworths Reward card number has not been accepted. Please check your entry or call the Customer Service Team on 1800 000 610 for assistance.',
        rewardsLoginSubmitButton: 'Link my card',
        rewardsLoginForgotPasswordLinkText: 'Forgotten your password?',
        rewardsLoginGreyBackgroundText: 'This page will refresh once your accounts are successfully linked in the Woolworths Rewards browser.',
        rewardsMembershipAppliedMessage: 'Rewards membership applied',
        rewardsNumberLoginTitle: 'Woolworths Rewards Number',
        rewardsPasswordHintText: 'Please enter the same password you use to access your Woolworths Reward card account on www.woolworthsrewards.com.au',
        rewardsPlusBenefitTiles: '[{"iconClass": "iconww-SetTimeDelivery", "title": "Free Delivery", "subtitle": "On Woolworths, BWS and Dan Murphy\'s orders"}, {"iconClass": "iconww-SetTime", "title": "Priority Timeslot", "subtitle": "Prioritised choice of delivery timeslots"}, {"iconClass": "iconww-Specials", "title": "Double Points", "subtitle": "For every $ spent on fresh food - instore, and online (Delivery & Pick up)"}]',
        rewardsPlusBenefitsTitle: 'Additional Rewards Benefits',
        rewardsPlusFooterText: 'Please contact our Customer Team on <strong>1800 1000 610</strong> or email us at <a href="mailto:rewards@woolworths.com.au">rewards@woolworths.com.au</a> if you have any questions or want to cancel your trial.',
        rewardsPlusFreeDeliveryMessage: 'You saved {DeliveryFee} on delivery',
        rewardsPlusTitle: 'My additional benefits',
        rewardsPointsFuelDiscountsSubtitle: '{X} saved on fuel since {Y}',
        rewardsPointsFuelDiscountsTitle: 'Current Fuel Discounts^',
        rewardsPointsLifetimeRedeemedSubtitle: 'Since joining',
        rewardsPointsLifetimeRedeemedTitle: 'Woolworths Dollars Redeemed',
        rewardsPointsSaveForLaterChristmasIcon: 'iconww-SaveForLaterChristmasIcon',
        rewardsPointsSaveForLaterChristmasSubtitle: 'Available from {X}',
        rewardsPointsSaveForLaterChristmasTitle: 'Saved for Christmas',
        rewardsPointsSaveForLaterChristmasEmptyText: 'You\'re saving for Christmas',
        rewardsPointsSaveForLaterDefaultIcon: 'iconww-SaveForLaterDefault',
        rewardsPointsSaveForLaterDefaultSubtitle: 'Automatically save on your next shop',
        rewardsPointsSaveForLaterDefaultTitle: 'Off your next shop',
        rewardsPointsSaveForLaterQuarterlyOffIcon: 'iconww-SaveForLaterQuarterlyOff',
        rewardsPointsSaveForLaterQuarterlyOffSubtitle: '{X} Qantas Points will be transferred on {Y}',
        rewardsPointsSaveForLaterQuarterlyOffTitle: 'Woolworths Dollars to Convert',
        rewardsPointsSaveForLaterQuarterlyOffEmptyText: 'You\'re saving for Qantas Points',
        rewardsPointsServerError: 'There was an issue loading your rewards points. Please try again later.',
        rewardsPointsTitle: 'My Rewards Points',
        rewardsPointsTotalMaximum: 2000,
        rewardsPointsTotalSubtitle: 'Earn {X} more to get $10 off your next shop*',
        rewardsPointsQantasTotalSubtitle: '2000 Woolworths Points = 1000 Qantas Points',
        rewardsPointsTotalTitle: 'Points',
        rewardsStatusAcceptedText: 'Your Woolworths Rewards card has been accepted',
        rewardsStatusAdditionalBenefitsTitle: 'Your Rewards+ account is:',
        rewardsStatusRemoveCardErrorMessage: 'There was an issue removing your card. Please try again later.',
        rewardsStatusTitle: 'My Woolworths Rewards card',
        rewardsPlusUrlToMyDanMurphysPage: 'https://test.my.woolworthsrewards.com.au/coa/#/nbpoi/',
        rewardsSignUpTitleText: 'Your Rewards account has been created',
        rewardsSignUpSubText: 'Check your email for more information about your new account'
    }
};

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    expressLandingPage: {
        backgroundImagePath: 'https://uatcdn0.woolworths.media/content/express/background-address-validation_large.jpg',
        expressAvailabilityMessage: 'Woolworths is trading delivery now until',
        expressNonAvailabilityMessage: 'Sorry delivery now is unavailable in your area',
        expressWindowClosedMessage: 'Sorry delivery now is unavailable at this time',
        expressValueProposition: 'Delivered in <span class="expressAddressPanel-titleMessageEstimatedTime">an hour</span>, hand picked with care',
        etaValueProposition: 'Delivered in a hurry, hand picked with care',
        expressSuccessfullySelectedMessage: 'Delivery Now has been successfully activated as your current delivery method.',
        expressETASuccessfullySelectedSubMessage: 'Delivered in a hurry, hand picked with care. You can now start express shopping.',
        expressSuccessfullySelectedSubMessage: 'Delivered in an hour, hand picked with care. You can now start express shopping.',
        expressImagesPath: 'https://uatcdn0.woolworths.media/content/express/',
        expressETAEnabled: true
    }
};

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    filter: {
        showFiltersOpen: false
    }
};

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    footer: {
        customerServiceLinks: [['Customer Service'], ['Product Safety', '/shop/discover/about-us/product-safety'], ['Product Recalls', '/shop/discover/about-us/product-recalls'], ['Scam Warning', '/shop/discover/about-us/scam-alert'], ['Help & Support', '/shop/page/help-and-support-faq'], ['Feedback', '/shop/page/help-and-support-faq'], ['Contact Us', '/shop/discover/about-us/contact-us'], ['Return Policy', '/shop/discover/about-us/returns-policy'], ['Offers & Competitions', '/shop/discover/about-us/offers-and-competitions'], ['Accessibility', '/shop/support/accessibility']],
        generalServiceLinks: [['Services'], ['Delivery', '/shop/discover/shopping-online/delivery'], ['Click & Collect', '/shop/discover/shopping-online/click-collect'], ['New to our Store?', '/shop/discover/shopping-online/new-to-online'], ['My Business', '/shop/discover/shopping-online/my-business'], ['Community Donations', '/shop/discover/community-donations']],
        toolsLinks: [['Tools'], ['Delivery Saver', '/shop/discover/shopping-online/delivery-saver'], ['Track My Order', '/shop/trackmyorder'], ['Woolworths Apps', '/shop/discover/about-us/woolworths-app'], ['Vendors', 'http://www.wowlink.com.au/wps/portal'], ['Woolworths Flowers', 'http://www.woolworthsflowers.com.au/home.aspx'], ['WOW Careers', 'http://www.wowcareers.com.au/']],
        aboutUsLinks: [['About Us'], ['Our Stores', '/shop/storelocator'], ['Our Brands', '/shop/discover/our-brands'], ['Affiliates', '/shop/discover/about-us/partner-program'], ['Clubs'], ['Woolworths Rewards', 'https://www.woolworthsrewards.com.au/'], ['Baby and Toddler Club', 'https://woolworthsbabyandtoddlerclub.com.au/']]
    }
};

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    fulfilmentMethod: {
        pickupOptionName: 'Pick Up',
        deliveryOptionName: 'Delivery',
        noneOptionName: 'Choose later',
        pickupOptionSubheading: '$30 minimum spend',
        deliveryOptionSubheading: '$50 minimum spend',
        expressDeliveryOptionSubheading: '$0 minimum spend',
        noneOptionSubheading: '',
        pickupOptionMessage: 'to collect my groceries',
        deliveryOptionMessage: 'my groceries delivered',
        noneOptionMessage: 'to choose later',
        questionnaireHeading: 'Delivery or Collection?',
        timetablePickupName: 'pickup',
        showDeliveryHint: true,
        deliveryHintText: 'A variable minimum spend may apply'
    }
};

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _global = __webpack_require__(47);

module.exports = {
    fulfilmentSelector: {
        fulfilmentMethodSelectorTitle: 'How would you like to receive your groceries?',
        selectedAddressTitle: 'Today\'s shop:',
        manualAddressTitle: 'Enter a new delivery address',
        pickupOptionSubheading: '$30 min. spend',
        deliveryOptionSubheading: '$50 min. spend',
        pickupStoresPerPage: 3,
        pickupStoreInputLabel: 'Pick up from',
        deliveryAddressInputLabel: 'Deliver to',
        manualAddressStreet1InputLabel: 'Street Address 1',
        manualAddressStreet2InputLabel: 'Street Address 2',
        manualAddressPostcodeInputLabel: 'Postcode',
        manualAddressSuburbInputLabel: 'Suburb',
        welcomeMessage: 'Welcome,',
        numberOfKeystrokesToTriggerSearch: 4,
        searchByCurrentLocationLabel: 'Using your current location',
        confirmLaterLabel: 'Confirm later',
        notServicedNotificationTitle: 'Unable to Deliver',
        notServicedNotificationMessage: 'You may be in an unserviced or remote area. Please contact our <a href=\'' + _global.global.wowCustomerCareUrl + '\' onclick="utag.link({\'event.Action\':\'click\',\'event.Category\':\'Fulfilment Modal\', \'event.Hash\': Math.random(0, Number.MAX_VALUE).toString(36), \'event.Label\': \'Non serviced address error\', \'event.Name\': \'Hyperlink_click\', \'site.Section\': \'shop:discover\'});">Customer Care Team</a> for options. Alternatively you could choose pick up.',
        remoteOrderNotificationTitle: 'Rural and Remote Customers',
        remoteOrderNotificationMessage: "If you live in a remote area we might have to set you up differently. Please speak to our <a href='http://woolworths.com.au' onclick=\"utag.link({'event.Action':'click','event.Category':'Fulfilment Modal', 'event.Hash': Math.random(0, Number.MAX_VALUE).toString(36), 'event.Label': 'Remote Order Info', 'event.Name': 'Hyperlink_click', 'site.Section': 'shop:discover'});\">Customer Care Team</a>",
        addressRequiredError: 'Address is required.',
        locationRequiredError: 'Location is required.',
        errorImageURL: 'https://www.woolworths.com.au/content/spilledmilk-373x322.png',
        errorTitle: 'Oops!',
        errorMessage: "We're having some issues. We'll send you to the Homepage while we try and figure this out."
    }
};

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _global = __webpack_require__(47);

module.exports = {
    fulfilmentTimetable: {
        showTimesWhenAllowDecideLater: false,
        noAvailableTimesMessage: 'You may be in an unserviced or remote area. Please contact our  <a href=\'' + _global.global.wowCustomerCareUrl + '\' onclick="utag.link({\'event.Action\':\'click\',\'event.Category\':\'Fulfilment Modal\', \'event.Hash\': Math.random(0, Number.MAX_VALUE).toString(36), \'event.Label\': \'Non serviced address error\', \'event.Name\': \'Hyperlink_click\', \'site.Section\': \'shop:discover\'});">Customer Care Team</a> for options. Alternatively you could choose pick up.',
        deliveryTwoHourReservationMessage: 'Once you pick a window, we’ll reserve it for the next 2 hours. You may see some new Delivery options below, such as Partner Delivery. To find out more, <a href="https://www.woolworths.com.au/shop/discover/shopping-online/delivery" target="_blank">click here.</a> Happy shopping!'
    }
};

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    googleSem: {
        storeCodeParamPrefix: 'woolworths_supermarkets_',
        defaultBasePriceStoreCode: 1649 // New South Wales
    }
};

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    handyHint: {
        edrPassword: 'Please enter the same password you use to access your Woolworths Reward card account on www.woolworthsrewards.com.au',
        idCardToolTip: 'Please provide senior card identification in order to receive/buy a Care Package.',
        idCardNumberToolTip: 'Current eligible concession cards: <br></br><ul style="list-style: disc;margin-left:  20px;"><li style="padding-left: 5px;">Australian Senior Card (NSW, ACT, WA, SA, NT, QLD)</li><li style="padding-left: 5px;">Companion Card (WA, NSW, TAS, QLD)</li><li style="padding-left: 5px;">Senior Savers (NSW)</li><li style="padding-left: 5px;">MyPost Senior Card </li><li style="padding-left: 5px;">My Aged Care Card</li><li style="padding-left: 5px;">Carers Card (QLD)</li><li style="padding-left: 5px;">Woolworths Kindness Card</li></ul> By providing this information you accept the terms in our <a href="/">Collection Notice</a> and <a href="/">Privacy Policy</a>.'
    }
};

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    lists: {
        confirmDeleteTitle: 'Are you sure you would like to delete this list?',
        confirmDeleteSubtext: 'This is permanent and cannot be undone.',
        createListTitle: 'Create new list',
        createListSubtext: 'What are you going to name this list?',
        createListServerErrorText: 'Could not communicate with the server.',
        createListPatternValidationText: 'Certain symbols (e.g. & < > ") give Lists a headache.',
        createListExistingValidationText: 'Ah! You already have a list with this name.',
        createListRequiredValidationText: 'A list name is required.',
        createListSmallLength: 4,
        createListSmallLengthText: 'This name is a good length :)',
        createListMediumLength: 18,
        createListMediumLengthText: 'It\'s getting a bit long now.',
        createListLargeLength: 30,
        createListLargeLengthText: 'You\'re going to run out of characters soon...',
        createListMaxLength: 36,
        createListMaxLengthText: 'OK, that\'s the character limit!',
        listsTitleText: 'Welcome back,',
        myListTitleText: 'My Lists',
        enableListHome: false,
        smartListTitleText: 'Things you might need',
        smartListSubHeading: 'Recommendations updated every week to make your shopping faster.',
        enableSmartList: false,
        smartListsToolTipText: 'smart lists',
        smartListCarouselItemCount: 16,
        myWoolworthsRewardsListPageHeading: 'Products I Purchased with my Woolworths Rewards Card',
        noPastShopsMessage: 'No past shop exists.',
        myListsShowMoreThreshold: 4,
        pastShopsShowMoreThreshold: 3,
        includedDepartmentIds: ['1-E5BEE36E', '1_D5A2236', '1_DEB537E', '1_6E4F4E4', '1_39FD49C', '1_ACA2FC2', '1_5AF3A0A', '1_C8BFD01', '1_B63CF9E', '1_61D6FEB', '1_717A94B', '1_894D0A8', '1_2432B58'],
        groupByName: 'Categorise',
        suggestedListsToolTipText: 'Our Suggested Lists are designed to inspire you with products you might like to add to your own lists.',
        allProductsTitle: 'All Products',
        allProductsSubTitle: 'Every product you\'ve ever bought conveniently brought together in one list.',
        allProductsCta: 'View now',
        allProductsUnavailableText: 'Unavailable until first shop is complete',
        pastShopsTitle: 'Past Shops',
        pastShopsSubTitle: 'Browse all your past shops',
        pastShopsCta: 'View now',
        pastShopsUnavailableText: 'Unavailable until first shop is complete',
        previouslyBoughtText: 'Previously Bought',
        linkRewardsText: 'Have you linked your rewards card?',
        linkRewardsTextV2: 'Have you linked your Everyday Rewards card?',
        linkRewardsToolTip: 'When you link your Rewards Card we’re able to connect both your online and in-store purchases, bringing them together under All Products.',
        linkRewardsToolTipV2: 'When your Everyday Rewards Card is linked, your in-store and online purchases will be shown under Everything I’ve Ever Bought.',
        enableV3EverythingBought: false,
        previouslyBoughtNoResultsText: 'Unfortunately, we couldn\'t find any products purchased',
        previouslyBoughtNoResultsSubText: 'It looks like there are no items that correspond to your request. Bummer!',
        freeTextGroupTitle: 'General Items Searched',
        freeTextSearchCta: 'View all products',
        freeTextNoResultsText: 'Unfortunately, we couldn\'t find any products matching your search term.',
        tileListCta: 'Save to list',
        showCoachmarkOnTopNav: false
    }
};

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    loyalty: {
        rewardsConversionBase: 200
    }
};

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    merchantHosted: {
        productDetailPriceNotice: 'In-store price. Prices may differ for online purchases.',
        productDetailPriceDisclaimer: 'Online range and prices shown',
        displayProductTags: true,
        storeChangerModalTitle: 'Change your store'
    }
};

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    myAccount: {
        securityTabToolTipText: 'Try it!'
    }
};

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    myProfile: {
        updateBusinessDetailsMessage: 'Please contact us on <strong><a href="tel:1300665386">1300 665 386</a></strong> or email <strong><a href="mailto:business@woolworths.com.au">business@woolworths.com.au</a></strong> and we\'ll update your business account.'
    }
};

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    myAccountPref: {
        substituteTitle: 'Substitute preferences',
        substituteText: 'Would you always like to opt-in for a substitute when an item you have ordered is not available?',
        successText: 'Your preferences have been saved successfully',
        commsTitle: 'Communication Preferences'
    }
};

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    onBoarding: {
        bannerImageUrl: 'https://wowdevmediaaae.blob.core.windows.net/content/rewards-header.jpg',
        enableRewardsOnBoarding: false,
        titleLoginContent: '<h2>Start saving with your Rewards card today</h2>',
        textLoginContent: 'You can <a href="/shop/myaccount/woolworthsrewards" style="color:#F47920">join rewards</a> and link your card to start redeeming special offers and products tailored just for you, as you shop.',
        titleSignUpContent: '<h2>Welcome, start saving with your Rewards card today.</h2>',
        textSignUpContent: 'You can <a href="/shop/myaccount/woolworthsrewards" style="color:#F47920">join rewards</a> and begin redeeming special offers and products tailored for you, as you shop in store and online. Or if you\'re already a rewards member you can link your card by clicking on the button below.'

    }
};

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    // This is for legacy purposes - avoid adding to this for new settings
    oneSite: {
        maxCharactersPersonalShopperNote: 100
    }
};

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
        orderConfirmation: {
                pickupMessage: 'Your order can be collected from',
                deliveryMessage: 'Your order will be delivered to',

                orderConfirmedMessage: 'Order confirmed',
                orderCancelledMessage: 'Order cancelled',

                orderConfirmedAdditionalMessage: 'Thanks for shopping with Woolworths!',
                orderCancelledAdditionalMessage: 'The order value will be refunded to you soon!',

                // For the delivery details section header
                courierDeliveryDetailsHeader: 'DELIVERY ORDER DETAILS',
                expressDeliveryDetailsHeader: 'YOUR ORDER WILL BE DELIVERED',
                pickupDeliveryDetailsHeader: 'PICK UP ORDER DETAILS',

                // For the order confirmation header
                courierOrderConfirmationHeader: 'Delivery',
                expressDeliveryOrderConfirmationHeader: 'Delivery Now',
                pickupDeliveryOrderConfirmationHeader: 'Pick up',

                // Different delivery methods for the order
                courierDeliveryMethod: 'Courier',
                expressDeliveryMethod: 'XpressD',
                pickupDeliveryMethod: 'Pickup',
                hubspokDeliveryMethod: 'HubSpok',

                // Payment Breakdown Key
                creditCardKey: 'CreditCard',
                paypalKey: 'PayPal',
                giftCardKey: 'GiftCard',

                // Order Save to List
                saveToListHeading: 'Save time shopping',
                saveToListContent: 'Don\'t build your basket from scratch: save your order to Lists and add it straight to the cart in one click next time. <br/><br/>Shop faster with Lists.',
                saveToListError: 'Sorry, something went wrong.'
        }
};

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    orderManagement: {
        editDeliveryInfoPickUp: 'to collect my groceries from',
        editDeliveryInfoDelivery: 'my groceries delivered to',
        itemPickupFrom: 'Collect From:',
        itemHubSpok: 'Collect From:',
        noOrdersMessage: 'You currently have no open orders to display',
        amendingNotificationBannerTitle: 'You\'re currently changing your order',
        amendingNotificationBannerMessage: 'Please submit your changes at Checkout by {0}, or you\'ll receive your original order.',
        cutoffNotificationBannerTitle: 'You can no longer change your order',
        cutoffNotificationBannerMessage: 'Your order is currently being hand picked, packed and checked.'
    }
};

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    packagingFeeSwitches: {
        enablePreferencePreselection: true,
        packagingNotificationEnabled: true
    }
};

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    packagingFee: {
        headerDefault: 'How would you like your groceries packed ?',
        headerSmall: 'How would you like your groceries packed ?',
        info: 'We’re now proudly single-use plastic bag free.',
        dialogContent: '\n            <p class="packagingPreferences-dialogContentValue">\n                The removal of single-use plastic bags has been a really important topic for our customers and our team. We are committed to playing our part in reducing plastic usage and believe that this is the right thing to do for our environment.\n            </p>\n            <p class="packagingPreferences-dialogContentValue">\n                You have the choice between having your order packed into reusable plastic bags or directly into our delivery crates (delivery orders only and when \u2018leave unattended\u2019 is not selected). Please note that some products will continue to be packed into produce or reusable bags for food safety reasons.\n            </p>\n            <p class="packagingPreferences-dialogContentValue">\n                We are continuing to trial and review additional packing options, and are excited to offer a further range of options into the future.\n            </p>',
        blueHeaderDefault: 'Another step for a greener future',
        blueHeaderSmall: 'Another step for a greener future'
    }
};

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    pickup: {
        pickupSubmitError: 'Please provide all Pick up information to continue.'
    }
};

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    productDetailAvailability: {
        notRanged: 'Sorry, temporarily unavailable.',
        outOfStock: 'This item is currently out of stock at the store that services your location.'
    }
};

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    productDetailsAdditionalAttributes: {
        productDetailsHealthStarRatingPath: 'https://wowuatmediaaae.blob.core.windows.net/content/hsricons/'
    }
};

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    productRestrictions: {
        expressQuantityRestrictedByBundlesMessage: 'Bundles contain multiple individual items that count towards your overall limit for Delivery Now.',
        productTileRestrictionDeliveryOnly: 'Available for delivery orders only',
        productTileRestrictionExpressDeliveryOnly: 'Available for delivery now orders only',
        productTileRestrictionPickUpOnly: 'Available for pick up orders only',
        productTileRestrictionPmDelivery: 'Available for afternoon delivery and pick up orders',
        restrictedByExpressDeliveryMessage: 'These items are not available for Delivery Now, please select another delivery method'
    }
};

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    productTileAvailability: {
        notRanged: 'Sorry, temporarily unavailable.',
        notRangedMobile: 'Sorry, temporarily unavailable.',
        outOfStock: 'Sorry, currently not in stock',
        outOfStockMobile: 'Currently not in stock.'
    }
};

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    quickReorder: {
        noProductMessage: 'No Products',
        quickReorderPageName: 'Buy Again!'
    }
};

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    ratingreview: {
        reviewSource: [['Bunch', 'Sourced from bunch.woolworths.com.au'], ['BazaarVoice', 'Independently moderated by bazaarvoice.com']],
        maxRating: 5,
        minRatingCount: 10,
        pageSize: 10,
        reviewCharCountBeforeViewMoreCutoff: 300,
        errorReviewMessage: 'No reviews currently available',
        minReviewCount: 10
    }
};

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    recipe: {
        disclaimerMessageUnavailableProducts: 'Please note that recipe ingredients are subject to availability. While every effort is made to ensure recipe ingredients are available to “add to cart”, if any product is showing as unavailable you can use the search bar at the top of this page to find alternative ingredients in your location.'
    }
};

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// added for unit test purpose only
module.exports = {
    registration: {
        receiveSmsOfferByDefault: null,
        receiveEmailsByDefault: null,
        receiveSampleByDefault: null
    }
};

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    rewards: {
        accountImageBanner: 'https://wowdevmediaaae.blob.core.windows.net/content/dpu-desktop-image-1136x328.jpg',
        accountImageBannerMobile: 'https://wowdevmediaaae.blob.core.windows.net/content/dpu-mobile-320x168.jpg',
        accountImageFloat: 'https://wowdevmediaaae.blob.core.windows.net/content/dpu-card-art.png',
        accountTitle: 'Link your card to see your offers, specials & points',
        accountButtonCta: 'Link your Rewards card',
        accountSubtext: 'Not a member?',
        accountSubtextLinkCta: 'Join Rewards',
        accountSubtextLink: 'https://www.woolworthsrewards.com.au/register.html',
        accountErrorText: 'We are unable to link this Rewards card at this time. Please call Customer Hub on 02 9000 8000.'
    }
};

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    ringCaptchaMessages: {
        incorrectPhoneNumber: 'Please enter a valid mobile number.',
        invalidPinCode: 'The PIN number does not match.',
        retryLimitReachedContentMessage: 'You\'ve reached the maximum amount of attempts to enter your PIN correctly to validate your number.',
        retryLimitReachedTitleMessage: 'PIN entry limit reached',
        ringCaptchaAppKey: '6uby5u5akama3o6e5egu',
        ringCaptchaWidgetJsPath: 'https://cdn.ringcaptcha.com/widget/v2/bundle.min.js',
        sendPinCodeToPhoneLabel: 'We will SMS you a PIN code to verify your number.',
        sendSmsButtonLabel: 'Send SMS',
        sendSmsCheckPinCodeLabel: 'A 4 digital PIN number has been sent via SMS to',
        sessionExpiredContentMessage: 'The session for your 4 digit PIN has expired. You can obtain a new PIN code by clicking the link below.',
        sessionExpiredTitleMessage: 'Your PIN has expired',
        smsNotificationSummaryText: '*Required',
        toolTipContent: 'It is important that you provide a verified contact number so we can ensure you receive important information about your order and so the driver can contact you if there are issues with its delivery.',
        tryAgainLinkText: 'I didn\'t receive a SMS',
        validationSuccessMessage: 'Your contact mobile number has been verified for your order.',
        widgetTitleText: 'Verify your mobile number*',
        backendApiValidationFailedTitle: 'Oops!!! Something is Wrong.',
        backendApiValidationFailedMessage: 'Your contact mobile number cannot be verified for your order.'
    }
};

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    search: {
        externalRedirectionDelay: 0,
        searchSuggestionThrottleTimeout: undefined,
        zeroSearchResultsMessage: 'Your search term "{search}" returns no results',
        shouldRememberSort: false,
        categoryFilterName: 'Category'
    }
};

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    shelfProductTile: {
        showSaveToListAsLink: false,
        showTags: true
    }
};

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    signUpForm: {
        pickupTitle: 'Click & Collect',
        pickupDescription: 'Collect your groceries from a local store for FREE',
        fulfilmentSelectionTitle: 'How would you like to receive your groceries?',
        benefitCardCheckboxText: 'I have a Seniors or Pensioners card',
        benefitCardNumberText: 'Please enter your card identification number',
        benefitCardNumberPatternError: 'Please remove any spaces, symbols or letters that aren’t on your card.',
        agreeToTsAndCsErrorMessage: 'To sign up you must accept the above terms.',
        freeSampleTitle: 'Samples (A whole lot of great food to try. Free!)',
        freeSampleDescription: 'Would you like to receive free samples from time to time?',
        shopperTsAndCsUrl: '/shop/discover/about-us/terms-and-conditions',
        businessTsAndCsUrl: '/shop/discover/shopping-online/my-business-terms-and-conditions',
        commsTitle: 'Promotional and Marketing Communication Preferences',
        tsAndCsTitle: 'Woolworths Online Terms and Conditions',
        reminderNote: '*Please note, you can change these preferences at any time by logging into your account.'
    }
};

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    siteCensus: {
        responsysTrackingPixel: 'https://emailonline.woolworths.com.au/pub/cct?_ri_=X0Gzc2X%3DYQpglLjHJlTQGtC0r9zd59j6TCftglzbGONNW&_ei_=El69Zfbs5ddWnWyOwa--6Do&ORDERID={OrderID}&ORDERTOTAL={OrderTotal}&NUMITEMS={OrderQty}&CUSTOMERID={ShopperID}'
    }
};

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    smartBanner: {
        enableSmartBanner: false,
        daysHiddenAfterClose: 15,
        daysHiddenAfterView: 90,
        title: 'Woolworths',
        author: 'Woolworths',
        appleStore: 'On the App Store',
        googleStore: 'In Google Play'
    }
};

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    sponsoredAds: {
        sponsoredProductText: 'Sponsored'
    }
};

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    stockChecker: {
        modalTitle: 'Check stock in our stores',
        modalDisclaimer: 'Stock levels updated every 2 hours',
        productPageLinkText: 'Check stock in our stores',
        showOnProductPage: false
    }
};

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    subscriptionsErrorCodes: {
        alreadySubscribed: 'SS1',
        planNotFound: 'SS2'
    }
};

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    substitutionsInstructionsLinkText: {
        add: 'Add Instructions',
        hide: 'Hide Instructions',
        show: 'Show Instructions'
    }
};

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    substitutions: {
        addInstructionsMessage: 'Add instructions for your personal shopper',
        addInstructionsMessageMobile: 'Personal shopper instructions',
        helpMessageToolTip: "You can choose to have all or part of your order substituted for items of equal or more value if any items in your order are out of stock. If you don't wish to have your items substituted you will be refunded for any out of stock items.",
        substitutionIconTooltipText: 'Substitutions'
    }
};

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    trackMyOrderDeliveryMethod: {
        notretrieved: 'NotRetrieved',
        delivery: 'Delivery',
        pickup: 'Pickup',
        express: 'Express'
    }
};

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    trackMyOrderEta: {
        disclaimer: '',
        googleMapApiUrl: '',
        googleMapsEnabled: true
    }
};

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    trackMyOrderProgress: {
        dispatched: 'Dispatched',
        placed: 'Placed'
    }
};

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    trackMyOrder: {
        deliveryEtaDisclaimer: '*Please note the estimated time of delivery is an indicative time of when the driver will arrive, your order may still arrive any time within the delivery window you selected. The estimated time of arrival may change due to traffic conditions and other reasons outside Woolworths Online control.',
        deliveryMessage: "We'll let you know the estimated time of delivery for your order soon. Generally this is available the day of delivery, or after the cut off time for same day orders (where available).",
        dispatchedText: 'Order due today',
        pickupMessage: 'We\'ll send you an SMS when your order is ready to pick up.',
        pickupMessageWithEmailInfo: 'We\'ll send you an email (and SMS if we have your mobile number) when your order is ready to pick up.',
        expressDeliveryMessage: 'We\'ll send you an SMS when your Delivery Now order is on it\'s way.',
        placedText: 'Order placed',
        readyText: 'Order ready',

        deliveryLocationLabel: 'Delivery location',
        pickupLocationLabel: 'Pick up location',

        deliveryWindowLabel: 'Delivery Order Details',
        pickupWindowLabel: 'Pick Up Order Details',
        expressDeliveryWindowLabel: 'Your order will be delivered',

        tradingHoursLabel: 'Trading hours',
        noOrdersMessage: 'No active orders to track',

        // track my order tips and directions.
        trackYourOrderText: 'We\'ll send you an SMS from the mobile number 0400 400 400 with your estimated delivery time and driver\'s contact number.',
        deliveryTips: '\n        <h3>Helpful tips for delivery:</h3>\n        <ul style="list-style: initial; margin-left: 20px">\n            <li>Leave a light on for your driver if your delivery is after dark.</li>\n            <li>Secure any pets that may limit access for your driver.</li>\n        </ul>\n        ',
        pickupTips: '\n        <h3>Pick up is easy:</h3>\n        <ol style="list-style: decimal; margin-left: 20px">\n            <li>Simply go to the Pick up point in store.</li>\n            <li>Present your photo ID and Order Number to a Woolworths team member.</li>\n            <li>Take home your groceries.</li>\n        </ol>\n        <h3>Tips for faster Pick up:</h3>\n        <p>\n            <a href="/Shop/Discover/about-us/woolworths-app">\n            Download our mobile app</a> and we\'ll send you a notification when your order is ready. Plus you can tell us when you\'re\n            close by, so that we can have everything ready for your arrival.\n        </p>\n        '
    }
};

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    trolley: {
        productsUnavailableAtDeliveryLocation: 'These products are not available from your new delivery location.',
        productsUnavailableAtPickupLocation: 'These products are not available from your new pick up location.'
    }
};

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    unsubEdm: {
        unsubSuccessHeading: 'You have successfully unsubscribed from all Woolworths Supermarkets Online emails',
        instructions: "You'll no longer receive marketing emails from Woolworths Online. Please allow up to 5 business days to take effect",
        unsubNotes: '<b>Please note:</b> You’ll continue to receive communications containing factual information about your orders and account. You may also continue to receive Woolworths Rewards marketing emails if you subscribed for them.',
        loginLinkText: "If you'd like to receive these emails again, visit <a href=\"/shop/myaccount/preferences\">My Preferences</a> in your online account and resubscribe.",
        alreadyUnsubedHeading: 'You are already unsubscribed from Woolworths Online marketing emails.',
        alreadyUnsubedSubHeading: 'If you would like to subscribe to receive Woolworths Online marketing emails to hear about free delivery offers, exclusive discounts, inspiring recipes and special offers, please <a href="/shop/myaccount/preferences">click here</a>.',
        confirmationInstruction: "If you proceed, you'll no longer receive emails about product specials, recipes and food inspiration, or discounts and offers for shopping online.",
        unsubYesMessage: "Yes, i'd like to unsubscribe from marketing emails",
        unsubNoMessage: "No, i'd like to stay subscribed to marketing emails"
    }
};

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    camelCase = _require.camelCase;

var SettingsByBreakpointService = function () {
    function SettingsByBreakpointService($q, settings, breakpointsService) {
        _classCallCheck(this, SettingsByBreakpointService);

        this.$q = $q;
        this.settings = settings;
        this.breakpointsService = breakpointsService;
    }

    _createClass(SettingsByBreakpointService, [{
        key: 'getSettingValueByBreakpoint',
        value: function getSettingValueByBreakpoint(group, settingNames) {
            if (this.breakpointsService.isInLargeFormat) {
                return this.settings[camelCase(group)][camelCase(settingNames.largeFormat)];
            }

            if (this.breakpointsService.isInMediumFormat) {
                return this.settings[camelCase(group)][camelCase(settingNames.mediumFormat)];
            }

            if (this.breakpointsService.isInSmallFormat) {
                return this.settings[camelCase(group)][camelCase(settingNames.smallFormat)];
            }

            return undefined;
        }
    }]);

    return SettingsByBreakpointService;
}();

SettingsByBreakpointService.$inject = ['$q', 'Settings', 'BreakpointsService'];

module.exports = { SettingsByBreakpointService: SettingsByBreakpointService };

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (settingsService) {
    return {
        restrict: 'E',
        scope: {
            settingGroup: '@',
            settingName: '@'
        },
        link: function link(scope) {
            settingsService.getSettingValue(scope.settingGroup, scope.settingName).then(function (value) {
                scope.settingValue = value;
            });
        },

        template: '{{settingValue}}'
    };
};

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (settingsService) {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            settingsService.getSettingValue(attrs.settingGroup, attrs.settingName).then(function (value) {
                element.html(value);
            });
        }
    };
};

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var settingsConfig = function settingsConfig(settingsService, bootstrap) {
    settingsService.updateSettings(bootstrap.getBootstrappedData(bootstrap.bootstrapped.Settings));
};

settingsConfig.$inject = ['SettingsService', 'BootstrapService'];

module.exports = settingsConfig;

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.common');

wowApp.service('BreakpointsService', ['$rootScope', __webpack_require__(780)]);

wowApp.service('BrowserWindowService', ['$rootScope', 'BreakpointsService', __webpack_require__(781)]);

wowApp.run(['$rootScope', 'BrowserWindowService', 'BreakpointsService', function ($rootScope, browserWindowService, breakpointsService) {
    browserWindowService.init();

    // While this is a bit dodgy to have globally, it will save
    // mountains of boilerplate injecting this service just to use
    // it in templates.
    $rootScope.$breakpoints = breakpointsService;
}]);

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkBreakpoints() {
    var windowWidth = window.innerWidth;
    this.isInSmallFormat = this.isFormat(this.breakpoints.smallFormat, windowWidth);
    this.isInMediumFormat = this.isFormat(this.breakpoints.mediumFormat, windowWidth);
    this.isInLargeFormat = this.isFormat(this.breakpoints.largeFormat, windowWidth);
    this.isInMediumFormatGlobalHeader = this.isFormat(this.breakpoints.globalHeaderMf, windowWidth);
    this.isInMediumFormatPortrait = this.isFormat(this.breakpoints.mediumFormatPortrait, windowWidth);
    this.isInGreaterThanMediumFormatLandscape = this.isFormat(this.breakpoints.greaterThanMediumFormatLandscape, windowWidth);
    this.isInDropDownMenuFormat = this.isFormat(this.breakpoints.dropDownMenuFormat, windowWidth);
    this.isInCartIconFormat = this.isFormat(this.breakpoints.cartIconFormat, windowWidth);

    this.currentFormat = this.getFormat();
}

// service for checking breakpoints (old browsers compatible)
// we don't sync css breakpoint for performance issues
// you need to manually change css breakpoints when you updates the javascript one
function BreakpointsService($rootScope) {
    var _this = this;

    this._smallFormatBreakpoint = 768;
    this._mediumFormatLandscapeBreakpoint = 1024;
    this._mediumFormatBreakpoint = 1270;
    this._mediumFormatGlobalHeaderBreakpoint = 950;

    this._smallFormatBreakpointSm = 320;
    this._smallFormatBreakpointMd = 500;
    this._smallFormatBreakpointLg = 630;

    this._cartIconFormat = 1281;

    this.breakpoints = {
        smallFormat: {
            min: 0,
            max: this._smallFormatBreakpoint
        },
        mediumFormat: {
            min: this._smallFormatBreakpoint,
            max: this._mediumFormatBreakpoint
        },
        largeFormat: {
            min: this._mediumFormatBreakpoint,
            max: Number.MAX_VALUE
        },

        globalHeaderMf: {
            min: this._smallFormatBreakpoint,
            max: this._mediumFormatGlobalHeaderBreakpoint
        },

        checkoutMlf: {
            min: this._mediumFormatLandscapeBreakpoint,
            max: this._mediumFormatBreakpoint
        },
        checkoutMf: {
            min: this._smallFormatBreakpoint,
            max: this._mediumFormatLandscapeBreakpoint
        },
        checkoutSf: {
            min: 0,
            max: this._smallFormatBreakpoint
        },
        mediumFormatPortrait: {
            min: this._smallFormatBreakpoint,
            max: this._mediumFormatLandscapeBreakpoint
        },
        greaterThanMediumFormatLandscape: {
            min: this._mediumFormatLandscapeBreakpoint + 1,
            max: Number.MAX_VALUE
        },
        dropDownMenuFormat: {
            min: 0,
            max: this._mediumFormatLandscapeBreakpoint + 1
        },
        cartIconFormat: {
            min: 0,
            max: this._cartIconFormat
        }
    };

    this.isInSmallFormat = false;
    this.isInMediumFormat = false;
    this.isInLargeFormat = false;
    this.isInMediumFormatGlobalHeader = false;
    this.isInMediumFormatPortrait = false;
    this.isInGreaterThanMediumFormatLandscape = false;
    this.isInDropDownMenuFormat = false;
    this.isInCartIconFormat = false;

    $rootScope.$on('window:resize', function () {
        checkBreakpoints.call(_this);
    });

    checkBreakpoints.call(this);
}

BreakpointsService.prototype.isFormat = function (format, windowWidth) {
    windowWidth = windowWidth === undefined ? window.innerWidth : windowWidth;

    return format.min <= windowWidth && windowWidth < format.max;
};

BreakpointsService.prototype.isSmallFormat = function () {
    return this.isInSmallFormat;
};

BreakpointsService.prototype.isMediumFormat = function () {
    return this.isInMediumFormat;
};

BreakpointsService.prototype.isLargeFormat = function () {
    return this.isInLargeFormat;
};

BreakpointsService.prototype.MediumFormatGlobalHeader = function () {
    return this.isInMediumFormatGlobalHeader;
};

BreakpointsService.prototype.getFormat = function () {
    return this.isInSmallFormat ? 'SmallFormat' : this.isInMediumFormat ? 'MediumFormat' : 'LargeFormat';
};

BreakpointsService.prototype.getDeviceDisplayFormatString = function () {
    if (this.isInSmallFormat) {
        return 'SF';
    }
    if (this.isInMediumFormat) {
        return 'MF';
    }
    if (this.isInLargeFormat) {
        return 'LF';
    }

    return '';
};

module.exports = BreakpointsService;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(2);
var _ = __webpack_require__(0);

// Set event for the browser window like resize and orientation change
// debounce the event, get the params
// broadcast events and params
// important: need to call init() (happen only one time)
function BrowserWindowService($rootScope, breakpointsService) {
    this.window = {};
    this.window.height = 0;
    this.window.width = 0;
    this.isInit = false;
    this.$rootScope = $rootScope;
    this.breakpointsService = breakpointsService;

    this.availableFormat = {
        large: 'lg',
        medium: 'md',
        small: 'sm'
    };

    this.selectedFormat = this.availableFormat.Large;
}

BrowserWindowService.prototype.init = function () {
    var _this = this;

    if (!this.isInit) {
        $(window).resize(_.debounce(function () {
            var resizeChanges = _this.getWindowSize();
            _this.$rootScope.$broadcast('window:resize', _this.window);

            if (resizeChanges.widthChanged) {
                _this.$rootScope.$broadcast('window:widthResize', _this.window);
                _this.broadcastFormatChange();
            }
            if (resizeChanges.heightChanged) {
                _this.$rootScope.$broadcast('window:heightResize', _this.window);
            }

            _this.$rootScope.$apply();
        }, 500));

        this.getWindowSize();
    }
    this.isInit = true;
};

// broadcast when the format change: if you want to watch more than one state, you can do a watch on BrowserWindowService.selectedFormat
BrowserWindowService.prototype.broadcastFormatChange = function () {
    if (this.breakpointsService.isSmallFormat() && this.selectedFormat !== this.availableFormat.small) {
        this.$rootScope.$broadcast('window:widthResize:small', self.window);
        this.selectedFormat = this.availableFormat.small;
    } else if (!this.breakpointsService.isSmallFormat()) {
        this.$rootScope.$broadcast('window:widthResize:mediumorlarge', self.window);
        if (this.breakpointsService.isMediumFormat() && this.selectedFormat !== this.availableFormat.medium) {
            this.$rootScope.$broadcast('window:widthResize:medium', self.window);
            this.selectedFormat = this.availableFormat.medium;
        } else if (this.breakpointsService.isLargeFormat() && this.selectedFormat !== this.availableFormat.large) {
            this.$rootScope.$broadcast('window:widthResize:large', self.window);
            this.selectedFormat = this.availableFormat.large;
        }
    }
};

BrowserWindowService.prototype.getWindowSize = function () {
    var heightChanged = false;
    var widthChanged = false;

    if (this.window.height !== $(window).height()) {
        this.window.height = $(window).height();
        heightChanged = true;
    }

    if (this.window.width !== $(window).width()) {
        this.window.width = $(window).width();
        widthChanged = true;
    }

    return { widthChanged: widthChanged, heightChanged: heightChanged };
};

module.exports = BrowserWindowService;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.common');

wowApp.directive('olyButton', ['$compile', 'MoveFocus', __webpack_require__(783)]);

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($compile, moveFocus) {
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            // loading variable
            loading: '=?',
            spinnerClass: '@?',
            buttonClass: '@?',
            childSpinnerClass: '@?',
            spinnerButtonClass: '@?'
        },
        compile: function compile(tElem) {
            var loading = tElem.find('._oly-button-loading');

            return {
                post: function post(scope, element, iAttrs, controller, transcludeFn) {
                    transcludeFn(function (clone) {
                        element.find('._oly-button-transclude').html($compile(clone)(scope));
                    });

                    loading = element.find('._oly-button-loading');

                    // check if there is a link with an href
                    var button = element.find('[href]');

                    if (!button || button.length <= 0) {
                        // if there is no element with [href], we look for an element with button class
                        button = element.find('.button');
                    }

                    scope.btnClass = button.attr('class');

                    // default loading state
                    if (!scope.loading) {
                        scope.loading = {
                            state: false,
                            message: 'loading, please wait'
                        };
                    } else {
                        scope.$watch(function () {
                            return scope.loading;
                        }, function (newVal, oldVal) {
                            if (newVal.state && !oldVal.state) {
                                moveFocus(loading);
                            }
                        });
                    }
                }
            };
        },

        template: __webpack_require__(784).trim()
    };
};

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports = "<div class=\"oly-button\" ng-class=\"buttonClass\">\r\n    <div class=\"_oly-button-transclude\" ng-show=\"!loading.state\"></div>\r\n    <div ng-show=\"loading.state\" class=\"oly-button-loading _oly-button-loading\" ng-class=\"[btnClass, spinnerButtonClass]\" tabindex=\"0\">\r\n        <wow-loading-spinner custom-spinner-class=\"{{ childSpinnerClass }}\" ng-if=\"loading.state\" message=\"{{ loading.message }}\" class=\"{{ spinnerClass }}\"></wow-loading-spinner>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.common');

wowApp.component('wowCopyright', __webpack_require__(786).copyrightControllerComponentDefinition);

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CopyrightController = function CopyrightController() {
    _classCallCheck(this, CopyrightController);
};

var copyrightControllerComponentDefinition = {
    controller: [CopyrightController],
    template: __webpack_require__(787).trim()
};

module.exports = {
    CopyrightController: CopyrightController,
    copyrightControllerComponentDefinition: copyrightControllerComponentDefinition
};

/***/ }),
/* 787 */
/***/ (function(module, exports) {

module.exports = "<div class=\"copyright\" wow-html-setting setting-group=\"Copyright\" setting-name=\"OnesiteCopyrightFooterHtml\"></div>"

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var DeliveryPassService = __webpack_require__(789);

angular.module('wowApp.common').service('DeliveryPassService', ['$q', 'Restangular', DeliveryPassService]);

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DeliveryPassService = function DeliveryPassService($q, restangular) {
    this._api = restangular.one('DeliveryPass');
    this.$q = $q;
    this.deliveryPassPrompt = undefined;
    this.deliveryPassesInTrolley = [];
    this.deliveryPasses = [];
};

DeliveryPassService.prototype.showShopperDeliveryPassPrompt = function () {
    return this.deliveryPassPrompt ? this.$q.when(this.deliveryPassPrompt) : this._fetchShopperDeliveryPassPrompt();
};

DeliveryPassService.prototype._fetchShopperDeliveryPassPrompt = function () {
    var _this = this;

    return this._api.one('Prompt').get().then(function (response) {
        _this.deliveryPassPrompt = response.plain();
        return _this.deliveryPassPrompt;
    });
};

DeliveryPassService.prototype._fetchShopperDeliveryPasses = function () {
    var _this2 = this;

    return this._api.getList().then(function (response) {
        _this2.deliveryPasses = response;
    });
};

DeliveryPassService.prototype.hasDeliveryPassInTrolley = function () {
    return this.deliveryPassesInTrolley.length > 0;
};

module.exports = DeliveryPassService;

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.common');

wowApp.directive('wowDialog', ['SettingsService', 'DialogRegistry', __webpack_require__(791)]);

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (settingsService, dialogRegistry) {
    return {
        restrict: 'E',
        scope: {
            dialogName: '@',
            settingGroup: '@?',
            settingName: '@?',
            message: '@?',
            onDismiss: '&?'
        },
        template: __webpack_require__(792).trim(),
        link: function link(scope) {
            if (scope.settingGroup && scope.settingName) {
                settingsService.getSettingValue(scope.settingGroup, scope.settingName).then(function (response) {
                    scope.dialogMessage = response;
                });
            } else {
                scope.dialogMessage = scope.message || '';
            }

            scope.settingDialog = dialogRegistry.getDialog(scope.dialogName);
            if (scope.settingDialog) {
                scope.settingDialog.show();
            }

            scope.closeDialog = function () {
                if (scope.settingDialog) {
                    scope.settingDialog.close();
                    if (scope.onDismiss) {
                        scope.onDismiss();
                    }
                }
            };
        }
    };
};

/***/ }),
/* 792 */
/***/ (function(module, exports) {

module.exports = "<dialog\r\n    name=\"{{dialogName}}\"\r\n    class=\"olyDialog olyDialog--modalDialog modalDialog\"\r\n    aria-describedby=\"modalDialog-textBody\"\r\n    role=\"alertdialog\">\r\n\r\n    <div class=\"olyDialog-scrollableArea modalDialog-scrollableArea \">\r\n        <i class=\"icon-alert_exclamation modalDialog-icon\"></i>\r\n        <div class=\"modalDialog-textWrapper\">\r\n            <p id=\"modalDialog-textBody\" class=\"modalDialog-textBody\" role=\"document\" tabindex=\"0\" oly-grab-focus=\"true\">{{dialogMessage}}</p>\r\n        </div>\r\n        <a href=\"javascript:;\" ng-click=\"closeDialog()\" class=\"modalDialog-dismiss\">\r\n            <span class=\"sr-only\">close dialog</span>\r\n            <i class=\"icon-close_x\"></i>\r\n        </a>\r\n    </div>\r\n</dialog>"

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var DynamicContentService = __webpack_require__(794);
var DynamicContentCarouselService = __webpack_require__(795);
var DynamicContentScheduleKeyService = __webpack_require__(796);
var dynamicContentUrlScheduleDirectiveDefinition = __webpack_require__(797);
var dynamicContentGlobalScheduleDirectiveDefinition = __webpack_require__(798);
var manageDynamicContentDirectiveDefinition = __webpack_require__(799);
var dynamicContentDirectiveDefinition = __webpack_require__(800);
var dynamicContentDialogDirectiveDefinition = __webpack_require__(801);
var dynamicContentHideViewDirectiveDefinition = __webpack_require__(803);
var dynamicContentProductGroupDirectiveDefinition = __webpack_require__(804);

var _require = __webpack_require__(805),
    dynamicContentProductGroupTileListComponentDefinition = _require.dynamicContentProductGroupTileListComponentDefinition;

var dynamicContentItemDirectiveFactory = __webpack_require__(806);

var _require2 = __webpack_require__(807),
    dynamicContentRestrictedProductComponentDefinition = _require2.dynamicContentRestrictedProductComponentDefinition;

var _require3 = __webpack_require__(809),
    dynamicContentRestrictedProductGroupComponentDefinition = _require3.dynamicContentRestrictedProductGroupComponentDefinition;

var _require4 = __webpack_require__(811),
    dynamicContentRestrictedProductGroupNavigationComponentDefinition = _require4.dynamicContentRestrictedProductGroupNavigationComponentDefinition;

angular.module('wowApp.common').factory('DynamicContentService', ['Restangular', DynamicContentService]).service('DynamicContentCarouselService', ['SettingsService', DynamicContentCarouselService]).service('DynamicContentScheduleKeyService', ['Settings', DynamicContentScheduleKeyService]).directive('olyDcUrlSchedule', ['$location', 'Settings', dynamicContentUrlScheduleDirectiveDefinition]).directive('olyDcGlobalSchedule', ['$location', 'DynamicContentScheduleKeyService', dynamicContentGlobalScheduleDirectiveDefinition]).directive('wowManageDc', [manageDynamicContentDirectiveDefinition]).directive('olyDynamicContent', ['TrolleyService', 'ShelfProductService', 'DynamicContentService', 'DynamicContentCarouselService', 'InspirationService', '$location', 'AnalyticsService', dynamicContentDirectiveDefinition]).directive('olyDcDialog', ['DynamicContentService', 'DialogRegistry', dynamicContentDialogDirectiveDefinition]).directive('olyDcHideViewed', [dynamicContentHideViewDirectiveDefinition]).directive('olyDcProductGroup', [dynamicContentProductGroupDirectiveDefinition]).component('olyDcProductGroupTileList', dynamicContentProductGroupTileListComponentDefinition).directive('olyDynamicContentProduct', [dynamicContentItemDirectiveFactory('<wow-shelf-product-tile product="item" ng-if="item"></wow-shelf-product-tile>', 'Products')]).directive('olyDynamicContentRecipe', [dynamicContentItemDirectiveFactory('<wow-recipe-tile recipe="item" ng-if="item"></wow-recipe-tile>', 'Recipes')]).directive('olyDynamicContentCard', [dynamicContentItemDirectiveFactory('<wow-inspiration-tile card="item" ng-if="item"></wow-inspiration-tile>', 'Cards')]).component('olyDynamicContentRestrictedProduct', dynamicContentRestrictedProductComponentDefinition).component('olyDynamicContentRestrictedProductGroup', dynamicContentRestrictedProductGroupComponentDefinition).component('olyDynamicContentRestrictedProductGroupNavigation', dynamicContentRestrictedProductGroupNavigationComponentDefinition).run(['$templateCache', function ($templateCache) {
    var bootstrap = $('.dynamic-content-bootstrap');
    for (var i = 0; i < bootstrap.length; ++i) {
        var templateBootstrap = bootstrap[i];
        var scheduleKey = templateBootstrap.attributes['schedule-key'].value;
        var templateCacheKey = '/Shop/DynamicContent2Panel?scheduleKey=' + scheduleKey;
        $templateCache.put(templateCacheKey, templateBootstrap.innerHTML);
    }
}]);

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (Restangular) {
    function DynamicContentService() {
        this._api = Restangular.one('DynamicContent');
        this._logMetricsApi = this._api.all('LogMetrics');
    }

    DynamicContentService.prototype.getServerItems = function (params) {
        return this._api.get(params).then(function (items) {
            return items.plain();
        });
    };

    DynamicContentService.prototype.isManagementEnabled = function () {
        // If dc is in window, the dynamic content management scripts are enabled,
        // meaning the user is able to manage dynamic content.
        return 'dc' in window;
    };

    DynamicContentService.prototype.postMetricsClick = function (itemId) {
        return this._logMetricsApi.post({ itemId: itemId });
    };

    return new DynamicContentService();
};

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(2);

var desktopCarouselSelector = '.desktop-carousel';
var tabletCarouselSelector = '.tablet-carousel';
var mobileCarouselSelector = '.mobile-carousel';
var carouselInnerSelector = '.carousel-inner';
var dynamicContentItem2Selector = '.dynamic-content2-item';
var desktopCarouselDuration = 'data-desktop-carouselduration';
var tabletCarouselDuration = 'data-tablet-carouselduration';
var mobileCarouselDuration = 'data-mobile-carouselduration';
var idAttribute = 'id';
var itemClassName = 'item';
var activeClassName = 'active';
var slideClassName = 'slide';
var carouselClassName = 'carousel';
var sfHomeCarouselSelector = '.categoryList-Carousel';
var sfImageSelector = 'img.img-responsive';
var smalFormatlHomeCardSelector = '.inspirationCard.has-homepage-small-image';
var smalFormatlHomeCardTextSelector = '.inspirationCard.has-homepage-small-image .inspirationCard-textWrapper.is-showing-image';

function DynamicContentCarouselService() {
    this.smallFormatHomeCarouselHeight = 0;
    this.indicatorColor = null;
}

DynamicContentCarouselService.prototype.populateNavArrows = function (elm, id) {
    var buttons = '<button class="carousel-control left" href="#' + id + '" role="button" data-slide="prev"><i class="iconww-ArrowLeft nav-icon"></i><span class="sr-only">Previous</span></button>';
    buttons += '<button class="carousel-control right" href="#' + id + '" role="button" data-slide="next"><i class="iconww-ArrowRight nav-icon"></i><span class="sr-only">Next</span></button>';

    elm.find(carouselInnerSelector).after(buttons);
};

DynamicContentCarouselService.prototype.populateIndicator = function (elm, id) {
    var itemCount = elm.find(dynamicContentItem2Selector).length;
    var indicators = '<ol class="carousel-indicators">';
    for (var i = 0; i < itemCount; i++) {
        if (i === 0) {
            indicators += '<li data-target="#' + id + '" data-slide-to="' + i + '" class="active"></li>';
        } else {
            indicators += '<li data-target="#' + id + '" data-slide-to="' + i + '"></li>';
        }
    }
    indicators += '</ol>';

    elm.find(carouselInnerSelector).before(indicators);
};

DynamicContentCarouselService.prototype.initializeCarousel = function (elm, id, duration) {
    if (elm.find(carouselInnerSelector).length !== 0) {
        return;
    }
    elm.addClass(carouselClassName).addClass(slideClassName);
    elm.find(dynamicContentItem2Selector).addClass(itemClassName).wrapAll('<div class=\'carousel-inner\' />');
    elm.find(dynamicContentItem2Selector).eq(0).addClass(activeClassName);
    this.populateIndicator(elm, id);
    this.populateNavArrows(elm, id);
    var option = {
        pause: 'hover',
        swipe: 30
    };
    if (duration !== undefined && duration > 0) {
        duration = duration >= 1000 ? duration : duration * 1000;
        option.interval = duration;
    }
    elm.carousel(option);
};

function updateCardImageHeight(carousel, height) {
    var cardHeight = height - 20;
    carousel.find(smalFormatlHomeCardSelector).css('height', cardHeight);
    carousel.find(smalFormatlHomeCardTextSelector).css('width', 'calc(100% - ' + cardHeight + 'px)');
}

DynamicContentCarouselService.prototype.init = function () {
    var dynamicContentWindowWidthCal = $(window).width();
    var isScrollBarCal = $(document).height() > $(window).height();
    var transitionWidthCal = isScrollBarCal ? 950 : 960;
    if (dynamicContentWindowWidthCal > transitionWidthCal) {
        this.initializeCarouselBySelector(desktopCarouselSelector);
    } else if (dynamicContentWindowWidthCal > 767) {
        this.initializeCarouselBySelector(tabletCarouselSelector);
    } else {
        this.initializeCarouselBySelector(mobileCarouselSelector);
    }
};

DynamicContentCarouselService.prototype.initializeCarouselBySelector = function (selector) {
    var _this = this;

    $(selector).each(function (i, v) {
        if ($(v).find(carouselInnerSelector).length === 0) {
            var id = $(v).attr(idAttribute);
            var durationAttr = selector === desktopCarouselSelector ? desktopCarouselDuration : selector === tabletCarouselSelector ? tabletCarouselDuration : mobileCarouselDuration;
            var duration = $(v).attr(durationAttr);
            _this.initializeCarousel($(v), id, duration);
        }
    });
};

DynamicContentCarouselService.prototype.getSmallFormatHomeCarouselHeight = function () {
    var height = 0;
    var sfHomeCarousel = $(sfHomeCarouselSelector).find(mobileCarouselSelector);
    if (sfHomeCarousel.length) {
        var images = sfHomeCarousel.find(sfImageSelector);
        var parentItem = $(images[0]).parents(dynamicContentItem2Selector);
        var visible = parentItem.hasClass(activeClassName);
        if (!visible) {
            parentItem.addClass(activeClassName);
        }
        height = $(images[0]).height();
        if (!visible) {
            parentItem.removeClass(activeClassName);
        }
        updateCardImageHeight(sfHomeCarousel, height);
    }
    return height;
};

module.exports = DynamicContentCarouselService;

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    forEach = _require.forEach,
    find = _require.find,
    endsWith = _require.endsWith;

var DynamicContentScheduleKeyService = function () {
    function DynamicContentScheduleKeyService(settings) {
        _classCallCheck(this, DynamicContentScheduleKeyService);

        this.settings = settings;
        this.globalScheduleInclusions = null;
    }

    /**
     * Gets a mapping of all paths to show global dynamic content on.
     * @example
     * {
     *  '/shop': true, (Show global content on /Shop)
     *  '/shop/*': true, (Show global content on /Shop and all it's children)
     * }
     * @returns {Object}
     */


    _createClass(DynamicContentScheduleKeyService, [{
        key: 'getGlobalScheduleInclusions',
        value: function getGlobalScheduleInclusions() {
            var _this = this;

            if (this.globalScheduleInclusions) {
                return this.globalScheduleInclusions;
            }

            this.globalScheduleInclusions = {};

            forEach(this.settings.dynamicContent.globalScheduleLocations, function (exclusion) {
                if (endsWith(exclusion, '/')) {
                    exclusion = exclusion.substr(0, exclusion.length - 1);
                }
                _this.globalScheduleInclusions[exclusion.toLowerCase()] = true;
            });

            return this.globalScheduleInclusions;
        }

        /**
         * Returns true if the provided path matches a path in the global schedule inclusions.
         * @param {string} fullPath
         * @returns {boolean}
         */

    }, {
        key: 'isGlobalScheduleInclusionDefined',
        value: function isGlobalScheduleInclusionDefined(fullPath) {
            var inclusions = this.getGlobalScheduleInclusions();

            fullPath = fullPath.toLowerCase();

            // Check if exact path is included
            if (inclusions[fullPath]) {
                return true;
            }

            var paths = this._getWildcardPaths(fullPath);
            // Check if any wildcard paths match
            return !!find(paths, function (path) {
                return inclusions[path];
            });
        }

        /**
         * Splits the provided path into matching wildcard paths
         * @example
         * // returns [/*, /shop/*, /shop/browse/*]
         * this._getWildcardPaths('/shop/browse')
         * @param {string} fullPath
         * @returns {Array<string>}
         */

    }, {
        key: '_getWildcardPaths',
        value: function _getWildcardPaths(fullPath) {
            fullPath = fullPath.toLowerCase();

            var paths = [];

            forEach(fullPath.split('/'), function (part, i) {
                paths[i] = i === 0 ? '' : paths[i - 1] + '/' + part;
            });

            forEach(paths, function (path, i) {
                paths[i] = path + '/*';
            });

            return paths;
        }
    }]);

    return DynamicContentScheduleKeyService;
}();

module.exports = DynamicContentScheduleKeyService;

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($location, settings) {
    return {
        restrict: 'A',
        require: 'olyDynamicContent',
        link: function link(scope, element, attrs, olyDynamicContent) {
            function getScheduleKey(panel) {
                var path = $location.path();
                var key = settings.dynamicContent.defaultScheduleKey;
                if (path) {
                    return path + (panel ? '-' + panel + key : '' + key);
                }

                return null;
            }

            function updateScheduleKey() {
                olyDynamicContent.scheduleKey(getScheduleKey(attrs.olyDcUrlSchedule));
            }

            updateScheduleKey();

            scope.$on('$locationChangeSuccess', updateScheduleKey.bind(this));
        }
    };
};

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($location, scheduleKeyService) {
    return {
        restrict: 'A',
        require: 'olyDynamicContent',
        link: function link(scope, element, attrs, olyDynamicContent) {
            function getScheduleKey() {
                var path = $location.path();

                if (scheduleKeyService.isGlobalScheduleInclusionDefined(path)) {
                    return 'global';
                }

                return null;
            }

            function updateScheduleKey() {
                olyDynamicContent.scheduleKey(getScheduleKey());
            }

            updateScheduleKey();

            scope.$on('$locationChangeSuccess', updateScheduleKey.bind(this));
        }
    };
};

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* global dc */

var $ = __webpack_require__(2);

var manageButtonTemplate = '<a class="btn manage-dc">Manage Dynamic Content</a>';

module.exports = function () {
    return {
        restrict: 'A',
        scope: {
            scheduleKey: '@',
            layoutId: '@'
        },
        link: function link(scope, element) {
            var centerScroll = $('#center-panel > .hideScroll-wrapper');

            function manageDynamicContent() {
                if (scope.scheduleKey !== undefined) {
                    $('.manage-dc').remove();
                    dc.initialize(element, scope.scheduleKey, scope.layoutId);
                    // If the dc is at the bottom, sometimes we need to scroll to it
                    // in order to be able to edit.
                    centerScroll.scrollTop(element.position().top);
                }
            }

            element.append($(manageButtonTemplate));

            element.find('.manage-dc').one('click', manageDynamicContent);
        }
    };
};

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

module.exports = function (trolleyService, shelfProductService, dynamicContentService, dynamicContentCarouselService, inspirationService, $location, analyticsService) {
    return {
        restrict: 'AE',
        scope: {
            scheduleKey: '=?',
            onload: '&?',
            forceSmallFormatView: '=?'
        },
        controllerAs: 'dcCtrl',
        controller: ['$q', '$timeout', '$scope', '$rootScope', function ($q, $timeout, $scope, $rootScope) {
            var serverItemRequests = {};

            /**
             * Request an item from the server. Will be resolved once all items have been requested
             * for the layout.
             * @param {any} id
             * @param {any} type
             */
            this.getServerItem = function (id, type) {
                if (!(type in serverItemRequests)) {
                    serverItemRequests[type] = {};
                }
                var requestsForType = serverItemRequests[type];
                if (!(id in requestsForType)) {
                    requestsForType[id] = $q.defer();
                }

                return requestsForType[id].promise;
            };

            function getRequestIds(requests) {
                return _.reduce(requests, function (result, itemRequests, itemType) {
                    result[itemType] = _.keys(itemRequests);
                    return result;
                }, {});
            }

            function resolveServerItemPromises(serverItems) {
                _.forEach(serverItems, function (items, type) {
                    _.forEach(items, function (item) {
                        var idKey = type === 'Products' ? 'Stockcode' : 'ID';
                        serverItemRequests[type][item[idKey]].resolve(item);
                    });
                });
            }

            this.onLoad = function () {
                this.getServerItems().then(function () {
                    $timeout(function () {
                        // timeout to ensure server items have rendered
                        if ($scope.onload) {
                            $scope.onload();
                        }

                        $scope.toggleIsEmpty();
                        $scope.initCarousel();
                    }).then(function () {
                        // fire a content changed event with classes as parameters when loading is done.
                        $rootScope.$broadcast('DynamicContent:onContentChanged', $scope.getElementClasses());
                    });
                });
            };

            /**
             * Load all of the items which have been requested for the layout.
             */
            this.getServerItems = function () {
                if (!_.some(serverItemRequests)) {
                    return $q(function (resolve) {
                        resolve();
                    });
                }

                return dynamicContentService.getServerItems(getRequestIds(serverItemRequests)).then(resolveServerItemPromises).finally(function () {
                    serverItemRequests = {};
                });
            };

            this.scheduleKey = function (scheduleKey) {
                if (scheduleKey !== undefined) {
                    $scope.scheduleKey = scheduleKey;
                }

                return $scope.scheduleKey;
            };
        }],
        link: function link(scope, element) {
            function getTemplateUrl(scheduleKey) {
                return scheduleKey !== null && scheduleKey !== undefined ? '/Shop/DynamicContent2Panel?scheduleKey=' + scheduleKey : null;
            }

            scope.$watch('scheduleKey', function (scheduleKey) {
                scope.templateUrl = getTemplateUrl(scheduleKey);
            });

            scope.addItemToTrolley = function (stockcode, quantity, source, itemId) {
                inspirationService.setDynamicContentCardIdSessionStorage(itemId);

                shelfProductService.getProductDetail(stockcode).then(function (products) {
                    if (products != null) {
                        scope.addOrUpdateItemToTrolley(products[0], quantity, source);
                    }
                });
                dynamicContentService.postMetricsClick(itemId);
            };

            scope.addOrUpdateItemToTrolley = function (product, quantity, source) {
                // Check item is in trolley. If it's update quantity.
                if (product.IsInTrolley) {
                    var addQuantity = product.QuantityInTrolley + quantity;
                    trolleyService.updateTrolleyItem(product, addQuantity);
                } else {
                    trolleyService.addItemToTrolley(product, quantity, source);
                }
            };

            scope.addMultiItemsToTrolley = function (stockcodes, source, itemId) {
                inspirationService.setDynamicContentCardIdSessionStorage(itemId);

                shelfProductService.getProductDetail(stockcodes).then(function (products) {
                    if (products != null) {
                        trolleyService.addItemsToTrolley(products);
                    }
                });
                dynamicContentService.postMetricsClick(itemId);
            };

            scope.toggleIsEmpty = function () {
                var visibleItems = element.find('.dynamic-content2-item:visible');
                element.find('.dynamic-content-canvas').first().toggleClass('is-empty', visibleItems.length === 0);
            };

            scope.initCarousel = function () {
                dynamicContentCarouselService.init();
                setTimeout(function () {
                    dynamicContentCarouselService.smallFormatHomeCarouselHeight = dynamicContentCarouselService.getSmallFormatHomeCarouselHeight();
                }, 500);
            };

            scope.postMetricsClick = function (itemId, name) {
                dynamicContentService.postMetricsClick(itemId);
                analyticsService.push({ data: { id: itemId, name: name, location: $location.path() }, type: analyticsService.mapperTypes.customEvent.bannerClick });
                analyticsService.pushEvent(analyticsService.events.BANNER_CLICK);
            };

            scope.setDynamicContentCardId = function (cardId) {
                inspirationService.setDynamicContentCardIdSessionStorage(cardId);
            };

            scope.getElementClasses = function () {
                return _.split(element.attr('class'), ' ');
            };

            scope.$on('window:resize', scope.toggleIsEmpty);
        },

        template: '<div class="dynamic-content2-panel" ng-include="templateUrl" onload="dcCtrl.onLoad()"></div>'
    };
};

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function dynamicContentDialog(dynamicContentService, dialogRegistry) {
    return {
        restrict: 'A',
        scope: {
            dialogName: '@olyDcDialog',
            scheduleKey: '=?'
        },
        transclude: true,
        link: function link(scope, element) {
            var dialog = dialogRegistry.getDialog(scope.dialogName);

            // We disable the mask when dynamic content management is enabled
            // so that it doesn't cover up the dynamic content management tool
            // and make it impossible to edit dynamic content.
            var shouldMask = !dynamicContentService.isManagementEnabled();

            // We set the schedule key to null because we don't want to load
            // the dynamic content until the dialog is shown.
            var scheduleKey = scope.scheduleKey || scope.dialogName;
            scope.scheduleKey = null;

            element.on('click.dcDialog', function () {
                scope.$apply(function () {
                    scope.scheduleKey = scheduleKey;
                });
            });

            scope.showDialog = function () {
                dialog.show(shouldMask).finally(function () {
                    // When the dialog is closed, we set the schedule key to null
                    // in order to destroy the dynamic content. This is important
                    // in case something like a YouTube video is playing in the dialog.
                    scope.scheduleKey = null;
                });
            };

            scope.$on('$destroy', function () {
                element.off('click.dcDialog');
            });
        },

        template: __webpack_require__(802).trim()
    };
};

/***/ }),
/* 802 */
/***/ (function(module, exports) {

module.exports = "<ng-transclude></ng-transclude>\r\n\r\n<dialog class=\"olyDialog olyDialog--dynamicContent\" name=\"{{dialogName}}\">\r\n    <a href=\"javascript:;\" class=\"olyDialog-close\" oly-dialog-close>\r\n        <span class=\"sr-only\">Close dialog</span> <i class=\"icon-close_x\"></i>\r\n    </a>\r\n    <oly-dynamic-content onload=\"showDialog()\" schedule-key=\"scheduleKey\"></oly-dynamic-content>\r\n</dialog>\r\n"

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0),
    $ = __webpack_require__(2);

module.exports = function dynamicContentHideDirective() {
    var defaultKey = 'wowHideViewedContent';

    function loadFromStorage() {
        var savedState = this.localStorageWrapper.get(this._storageKey);
        if (savedState) {
            try {
                _.assign(this, _.pick(JSON.parse(savedState), 'impressions', 'isClicked'));
            } catch (e) {
                console.error('Error loading dc-hide-viewed state', e);
            }
        }
    }

    function saveToStorage() {
        this.localStorageWrapper.set(this._storageKey, JSON.stringify(_.pick(this, 'impressions', 'isClicked')));
    }

    function DynamicContentHideViewedController($scope, $element, $attrs, dynamicContentService, localStorageWrapper) {
        var _this = this;

        this._storageKey = 'dc_' + ($attrs.olyDcHideViewed || defaultKey);
        this._maxImpressions = parseInt($attrs.maxImpressions) || 5;
        this._dcService = dynamicContentService;
        this.impressions = 0;
        this.isClicked = false;
        this.localStorageWrapper = localStorageWrapper;

        loadFromStorage.call(this);

        // Whenever we instantiate the directive, that counts as an impression.
        this.impressions += 1;

        $element.on('click.dcHideViewed', this.clicked.bind(this, true));
        $(window).on('unload.dcHideViewed', saveToStorage.bind(this));

        $scope.$on('$destroy', function () {
            saveToStorage.call(_this);
            $element.off('click.dcHideViewed');
            $(window).off('unload.dcHideViewed');
        });

        if (!this.shouldShow()) {
            $element.detach();
        }
    }

    DynamicContentHideViewedController.prototype.shouldShow = function () {
        return this._dcService.isManagementEnabled() || this.impressions <= this._maxImpressions && !this.isClicked;
    };

    DynamicContentHideViewedController.prototype.clicked = function (isClicked) {
        if (isClicked !== undefined) {
            this.isClicked = isClicked;
        }

        return isClicked;
    };

    return {
        restrict: 'A',
        controller: ['$scope', '$element', '$attrs', 'DynamicContentService', 'LocalStorageWrapper', DynamicContentHideViewedController]
    };
};

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
    function DynamicContentProductGroupController(productGroupService) {
        var _this = this;

        productGroupService.selectProductGroup(this.groupName).then(function (group) {
            _this.productGroupExists = group !== undefined;
        });
    }

    return {
        restrict: 'E',
        scope: {
            groupName: '@'
        },
        bindToController: true,
        controllerAs: 'ctrl',
        controller: ['ProductGroupService', DynamicContentProductGroupController],
        template: '\n            <oly-dc-product-group-tile-list\n                ng-if="ctrl.productGroupExists"\n                product-group-id="ctrl.groupName">\n            </oly-dc-product-group-tile-list>\n        '
    };
};

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(10),
    createBundleTiles = _require.createBundleTiles;

var DynamicContentProductGroupTileListController = function () {
    function DynamicContentProductGroupTileListController(settings, productGroupService) {
        _classCallCheck(this, DynamicContentProductGroupTileListController);

        this.settings = settings;
        this.productGroupService = productGroupService;
    }

    _createClass(DynamicContentProductGroupTileListController, [{
        key: 'createTiles',
        value: function createTiles(products) {
            return {
                items: createBundleTiles(products.items),
                totalRecordCount: products.totalRecordCount
            };
        }
    }, {
        key: 'getTiles',
        value: function getTiles() {
            var _this = this;

            return this.productGroupService.selectProductGroup(this.productGroupId).then(function () {
                return _this.productGroupService.getProducts({ pageNumber: 1, pageSize: 9999999, sortType: 'Name' });
            }).then(function (products) {
                return _this.createTiles(products);
            });
        }
    }]);

    return DynamicContentProductGroupTileListController;
}();

DynamicContentProductGroupTileListController.$inject = ['Settings', 'ProductGroupService'];

var dynamicContentProductGroupTileListComponentDefinition = {
    bindings: {
        productGroupId: '<?'
    },
    controller: DynamicContentProductGroupTileListController,
    template: '\n        <wow-tile-list\n            should-get-inspiration-cards="false"\n            get-tiles="$ctrl.getTiles()">\n        </wow-tile-list>\n    '
};

module.exports = {
    DynamicContentProductGroupTileListController: DynamicContentProductGroupTileListController,
    dynamicContentProductGroupTileListComponentDefinition: dynamicContentProductGroupTileListComponentDefinition
};

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function dynamicContentProduct(template, itemType) {
    return function () {
        return {
            restrict: 'E',
            require: '^olyDynamicContent',
            scope: {
                itemId: '@',
                forceSmallFormatView: '=?'
            },
            link: function link(scope, element, attrs, dcCtrl) {
                dcCtrl.getServerItem(parseInt(scope.itemId), itemType).then(function (item) {
                    scope.item = item;
                });
            },

            template: template
        };
    };
};

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    find = _require.find;

var DynamicContentRestrictedProductController = function () {
    function DynamicContentRestrictedProductController(settings, dynamicContentService, shopperService, validateProductService, $filter, trolleyService, $rootScope, $document, $timeout) {
        var _this = this;

        _classCallCheck(this, DynamicContentRestrictedProductController);

        this.settings = settings;
        this.dynamicContentService = dynamicContentService;
        this.shopperService = shopperService;
        this.validateProductService = validateProductService;
        this.$filter = $filter;
        this.trolleyService = trolleyService;
        this.$document = $document;
        this.$timeout = $timeout;

        this.eligibleForCarePackage = true;
        this.limitExceeded = false;
        this.enableCheckoutButton = false;

        this.removeNoScroll();

        if (!this.shopperService.IsGuest) {
            if (this.settings.carePackage.isEnabled) {
                this.validateProductService.validate([this.itemId]).then(function (res) {
                    var product = find(res.Eligibility, { StockCode: _this.itemId });
                    if (!product.Eligible) {
                        var day = _this.formatDate(_this.$filter('date')(product.NextEligibleDate, 'd'));
                        var month = _this.$filter('date')(product.NextEligibleDate, 'MMMM');
                        _this.limitExceededTitle = _this.settings.carePackage.limitExceededTitle.replace('{date}', day + ' ' + month);
                        _this.limitExceededMessage = _this.settings.carePackage.limitExceededMessage.replace(/{date}/gi, day + ' ' + month);
                        _this.limitExceeded = true;
                    }
                });
            } else {
                this.eligibleForCarePackage = false;
            }
        }

        this.getProduct();

        $rootScope.$on('trolley:update', function () {
            _this.removeNoScroll();
            _this.checkOutButtonStatus();
        });
    }

    _createClass(DynamicContentRestrictedProductController, [{
        key: 'formatDate',
        value: function formatDate(day) {
            var quotient = (day - day % 10) / 10;
            var remainder = day % 10;

            if (quotient === 1) {
                return day + 'th';
            }
            switch (remainder) {
                case 1:
                    return day + 'st';
                case 2:
                    return day + 'nd';
                case 3:
                    return day + 'rd';
                default:
                    return day + 'th';
            }
        }
    }, {
        key: 'getProduct',
        value: function getProduct() {
            var _this2 = this;

            this.dynamicContentService.getServerItems({ Products: [this.itemId] }).then(function (res) {
                _this2.item = res.Products[0];
                _this2.checkOutButtonStatus();
            });
        }
    }, {
        key: 'checkOutButtonStatus',
        value: function checkOutButtonStatus() {
            var trolleyItem = this.trolleyService.getTrolleyItem(this.itemId);
            if (trolleyItem !== undefined && trolleyItem !== null) {
                if (trolleyItem.Quantity > 0) {
                    this.enableCheckoutButton = true;
                }
            }
            if (trolleyItem === undefined || trolleyItem === null || trolleyItem.Quantity === 0) {
                this.enableCheckoutButton = false;
            }
        }
    }, {
        key: 'removeNoScroll',
        value: function removeNoScroll() {
            var _this3 = this;

            this.$timeout(function () {
                _this3.$document.find('body').removeClass('noscroll');
            }, 300);
        }
    }]);

    return DynamicContentRestrictedProductController;
}();

DynamicContentRestrictedProductController.$inject = ['Settings', 'DynamicContentService', 'ShopperService', 'ValidateProductService', '$filter', 'TrolleyService', '$rootScope', '$document', '$timeout'];

var dynamicContentRestrictedProductComponentDefinition = {
    bindings: {
        itemId: '<'
    },
    controller: DynamicContentRestrictedProductController,
    template: __webpack_require__(808).trim()
};

module.exports = {
    DynamicContentRestrictedProductController: DynamicContentRestrictedProductController,
    dynamicContentRestrictedProductComponentDefinition: dynamicContentRestrictedProductComponentDefinition
};

/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports = "<section class=\"restrictedProduct\">\r\n    <div class=\"restrictedProduct-warning\" ng-if=\"!$ctrl.eligibleForCarePackage || $ctrl.limitExceeded\">\r\n        <wow-notification-message\r\n            is-dismissible=\"false\"\r\n            type=\"error\"\r\n            title=\"{{ ::$ctrl.settings.carePackage.notEligibleTitle }}\"\r\n            message=\"{{ ::$ctrl.settings.carePackage.notEligibleMessage }}\"\r\n            ng-if=\"!$ctrl.eligibleForCarePackage\"\r\n        />\r\n        <wow-notification-message\r\n            is-dismissible=\"false\"\r\n            type=\"warning\"\r\n            title=\"{{ ::$ctrl.limitExceededTitle }}\"\r\n            message=\"{{ ::$ctrl.limitExceededMessage }}\"\r\n            ng-if=\"$ctrl.limitExceeded\"\r\n        />\r\n    </div>\r\n    <div ng-if=\"$ctrl.item\">\r\n        <wow-bb-product-tile\r\n            product=\"$ctrl.item\"\r\n            show-save-to-list=\"false\"\r\n            enable-navigate-to-detail-page=\"false\">\r\n        </wow-bb-product-tile>\r\n    </div>\r\n    <div class=\"restrictedProduct-checkoutPanel\" ng-if=\"$ctrl.item\">\r\n        <a href=\"/checkout/basics-box\" target=\"_self\">\r\n            <button ng-class=\"$ctrl.enableCheckoutButton ? 'button button--primary restrictedProduct-checkoutButton' : 'button button--secondaryLight restrictedProduct-checkoutButton'\" ng-disabled=\"!$ctrl.enableCheckoutButton\">\r\n                Continue To Checkout\r\n                <i class=\"iconww-ArrowRight\"></i>\r\n            </button>\r\n        </a>\r\n    </div>\r\n</section>\r\n"

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DynamicContentRestrictedProductGroupController = function () {
    function DynamicContentRestrictedProductGroupController($state, $rootScope, $timeout, $document, productGroupService, trolleyService, settings, settingsService, dialogRegistry, $sce) {
        var _this = this;

        _classCallCheck(this, DynamicContentRestrictedProductGroupController);

        this.$state = $state;
        this.$timeout = $timeout;
        this.$document = $document;
        this.productGroupService = productGroupService;
        this.trolleyService = trolleyService;
        this.settings = settings;
        this.enableCheckoutButton = false;
        this.hasSettingValidated = false;
        this.settingsService = settingsService;
        this.dialogRegistry = dialogRegistry;
        this.$sce = $sce;

        this.removeNoScroll();

        $rootScope.$on('trolley:update', function () {
            _this.removeNoScroll();
            if (_this.hasSettingValidated === false || _this.trolleyService.itemCount === 0 || _this.trolleyService.itemCount === 1) {
                _this.settingsService.invalidate().then(function () {
                    _this.updateCheckoutButtonStatus();
                    _this.hasSettingValidated = true;
                });
            } else {
                _this.updateCheckoutButtonStatus();
            }
        });
    }

    _createClass(DynamicContentRestrictedProductGroupController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            this.productGroupService.selectProductGroup(this.productGroupId).then(function (group) {
                _this2.productGroupDetails = group;
                _this2.toggleDialog(true);
            });
            this.updateCheckoutButtonStatus();
        }
    }, {
        key: 'removeNoScroll',
        value: function removeNoScroll() {
            var _this3 = this;

            this.$timeout(function () {
                _this3.$document.find('body').removeClass('noscroll');
            }, 300);
        }
    }, {
        key: 'updateCheckoutButtonStatus',
        value: function updateCheckoutButtonStatus() {
            this.enableCheckoutButton = this.trolleyService.itemPriceTotal >= this.settings.checkout.minimumSpend && this.trolleyService.HasPfdItems;
        }
    }, {
        key: 'shouldShowCategories',
        value: function shouldShowCategories() {
            return this.productGroupService.categories.length > 0;
        }
    }, {
        key: 'toggleDialog',
        value: function toggleDialog(showDialog) {
            var popupMessageDialog = this.dialogRegistry.getDialog('popupMessage');

            if (showDialog) {
                if (popupMessageDialog && this.settings.pfd.productListPageAlertMessage && this.trolleyService.itemCount !== 0) {
                    popupMessageDialog.show();
                }
            } else {
                popupMessageDialog.close();
            }
        }
    }]);

    return DynamicContentRestrictedProductGroupController;
}();

var dynamicContentRestrictedProductGroupComponentDefinition = {
    bindings: {
        productGroupId: '@'
    },
    controller: DynamicContentRestrictedProductGroupController,
    template: __webpack_require__(810).trim()
};

DynamicContentRestrictedProductGroupController.$inject = ['$state', '$rootScope', '$timeout', '$document', 'ProductGroupService', 'TrolleyService', 'Settings', 'SettingsService', 'DialogRegistry', '$sce'];
module.exports = {
    DynamicContentRestrictedProductGroupController: DynamicContentRestrictedProductGroupController,
    dynamicContentRestrictedProductGroupComponentDefinition: dynamicContentRestrictedProductGroupComponentDefinition
};

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports = "<section class=\"restrictedProductGroup\">\r\n    <div class=\"shop-leftPanel\" tabindex=\"-1\" ng-if=\"$ctrl.shouldShowCategories()\">\r\n        <oly-dynamic-content-restricted-product-group-navigation\r\n            filter=\"$ctrl.$state.params.filter\">\r\n        </oly-dynamic-content-restricted-product-group-navigation>\r\n    </div>\r\n    <div class=\"shop-centerPanel\">\r\n        <wow-product-group-tile-list\r\n            ng-if=\"::$ctrl.productGroupService.selectedGroup\"\r\n            product-group-id=\"$ctrl.productGroupId\"\r\n            page-number=\"$ctrl.$state.params.pageNumber || 1\"\r\n            sort-by=\"$ctrl.$state.params.sortBy\"\r\n            filter=\"$ctrl.$state.params.filter\"\r\n            show-save-to-list=\"false\"\r\n            enable-navigate-to-detail-page=\"false\">\r\n        </wow-product-group-tile-list>\r\n\r\n        <div class=\"restrictedProductGroup-checkoutPanel\">\r\n            <a href=\"/checkout/pfd\" target=\"_self\">\r\n                <button ng-class=\"$ctrl.enableCheckoutButton ? 'button button--primary restrictedProductGroup-checkoutButton' : 'button button--secondaryLight restrictedProductGroup-checkoutButton'\" ng-disabled=\"!$ctrl.enableCheckoutButton\">\r\n                    Checkout\r\n                    <i class=\"iconww-ArrowRight\"></i>\r\n                </button>\r\n            </a>\r\n            <div class=\"u-flexCenter\">\r\n                <div class=\"restrictedProductGroup-cartIcon\">\r\n                    <i class=\"iconww-Cart\"></i>\r\n                </div>\r\n                <div>\r\n                    <div class=\"restrictedProductGroup-cartLabel\">Your order</div>\r\n                    <div class=\"restrictedProductGroup-cartValue\"><b>{{$ctrl.trolleyService.itemPriceTotal | wowCurrency}}</b></div>\r\n                </div>\r\n            </div>\r\n            <div class=\"u-flexCenter restrictedProductGroup-info\">\r\n                <div>\r\n                    <i class=\"iconww-QtyDeliveryLimit restrictedProductGroup-informationIcon\"></i>\r\n                </div>\r\n                <div class=\"restrictedProductGroup-information\">{{$ctrl.settings.pfd.minimumSpendMessage}}</div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <dialog name=\"popupMessage\" class=\"olyDialog modalDialog restrictedProductGroup-modal\" id=\"_restrictedProductGroupDialog\">\r\n        <button oly-dialog-close\r\n            ng-click=\"$ctrl.toggleDialog(false)\"\r\n            class=\"olyDialog-close iconButton\">\r\n            <span class=\"sr-only\">close dialog</span>\r\n            <i class=\"icon-close_x\"></i>\r\n        </button>\r\n        <div class=\"modalDialog-textWrapper\">\r\n            <div ng-bind-html=\"$ctrl.$sce.trustAsHtml($ctrl.settings.pfd.productListPageAlertMessage)\"></div>\r\n            <a href=\"javascript:;\" class=\"linkButton\" ng-click=\"$ctrl.toggleDialog(false)\">\r\n                <span>Ok, got it</span>\r\n            </a>\r\n        </div>\r\n    </dialog>\r\n</section>\r\n"

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    filter = _require.filter;

var DynamicContentRestrictedProductGroupNavigationController = function () {
    function DynamicContentRestrictedProductGroupNavigationController($scope, $state, $location, breakpointsService, productGroupService) {
        _classCallCheck(this, DynamicContentRestrictedProductGroupNavigationController);

        this.$scope = $scope;
        this.$state = $state;
        this.$location = $location;

        this.breakpointsService = breakpointsService;
        this.productGroupService = productGroupService;
        this.categoryFilterName = productGroupService.getCategoryFilterName();
    }

    _createClass(DynamicContentRestrictedProductGroupNavigationController, [{
        key: '$onInit',
        value: function $onInit() {
            this.isSelectAll = this.filter === undefined;
            this.isCategoriesExpanded = true;
        }
    }, {
        key: 'categoryClick',
        value: function categoryClick(categoryId) {
            this.isSelectAll = categoryId === undefined;

            var path = this.$location.path();
            var parent = path.substring(path.lastIndexOf('/') + 1);
            var filters = categoryId !== undefined ? this.formFilters(categoryId) : undefined;
            this.$state.go('.', { filter: filters, parent: parent }, { inherit: false });
        }
    }, {
        key: 'formFilters',
        value: function formFilters(categoryId) {
            var _this = this;

            var applied = this.filter ? { filters: filter(this.filter.filters, function (f) {
                    return f.Key !== _this.categoryFilterName;
                }) } : { filters: [] };

            applied.filters.push({ Key: this.categoryFilterName, Items: [{ Term: categoryId }] });
            return applied;
        }
    }, {
        key: 'isActiveCategory',
        value: function isActiveCategory(category) {
            var _this2 = this;

            if (this.isSelectAll) {
                return false;
            }

            var categoryFilter = this.filter ? this.filter.filters.find(function (f) {
                return f.Key === _this2.categoryFilterName;
            }) : {};
            return category.NodeId === (categoryFilter && categoryFilter.Items ? categoryFilter.Items[0].Term : null);
        }
    }, {
        key: 'toggleCategories',
        value: function toggleCategories() {
            this.isCategoriesExpanded = !this.isCategoriesExpanded;
        }
    }]);

    return DynamicContentRestrictedProductGroupNavigationController;
}();

DynamicContentRestrictedProductGroupNavigationController.$inject = ['$scope', '$state', '$location', 'BreakpointsService', 'ProductGroupService'];

var dynamicContentRestrictedProductGroupNavigationComponentDefinition = {
    bindings: {
        filter: '<'
    },
    controller: DynamicContentRestrictedProductGroupNavigationController,
    template: __webpack_require__(812).trim()
};

module.exports = {
    DynamicContentRestrictedProductGroupNavigationController: DynamicContentRestrictedProductGroupNavigationController,
    dynamicContentRestrictedProductGroupNavigationComponentDefinition: dynamicContentRestrictedProductGroupNavigationComponentDefinition
};

/***/ }),
/* 812 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"navigation\">\r\n    <button class=\"linkButton navigation-header navigation-link treeNavigation-parent\"\r\n        ng-class=\"{ 'is-open': $ctrl.isCategoriesExpanded }\"\r\n        ng-click=\"$ctrl.toggleCategories()\"\r\n        aria-controls=\"_searchResultCategories\"\r\n        aria-expanded=\"{{ $ctrl.isCategoriesExpanded }}\">\r\n        <span>\r\n            Categories&nbsp;<i class=\"iconww-ArrowDown treeNavigation-expandIcon\"></i><i class=\"iconww-ArrowUp treeNavigation-collapseIcon\"></i>\r\n        </span>\r\n    </button>\r\n    <ul id=\"_searchResultCategories\" aria-label=\"Search result categories\" class=\"treeNavigation-children\">\r\n        <li>\r\n            <a class=\"navigation-link\"\r\n                href=\"javascript:;\"\r\n                ng-click=\"$ctrl.categoryClick()\"\r\n                ng-class=\"{ 'is-active': $ctrl.isSelectAll }\">\r\n                <span class=\"categoriesNavigation-linkText\">\r\n                    <span>All PFD Products</span>&nbsp;<i class=\"iconww-ArrowRight\"></i>\r\n                </span>\r\n            </a>\r\n        </li>\r\n        <li ng-repeat=\"category in $ctrl.productGroupService.categories | orderBy:'-ProductCount' track by (category.NodeId + $ctrl.isSpecial)\">\r\n            <a class=\"navigation-link\"\r\n                href=\"javascript:;\"\r\n                ng-click=\"$ctrl.categoryClick(category.NodeId)\"\r\n                ng-class=\"{ 'is-active': $ctrl.isActiveCategory(category) }\">\r\n\r\n                <span class=\"navigation-linkText\">\r\n                    {{ ::category.Description }}&nbsp;{{ (!$ctrl.productGroupService.searchCounts.loadingCount && category.ProductCount) ? '(' + category.ProductCount + ')' : '' }}&nbsp;<i class=\"iconww-ArrowRight\"></i>\r\n                </span>\r\n            </a>\r\n        </li>\r\n    </ul>\r\n</nav>\r\n"

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

angular.module('wowApp.common').directive('wowEmailValidator', __webpack_require__(814));

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var EMAIL_REGEXP = /([a-zA-Z0-9_\-\\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})/;

module.exports = function () {
    return {
        require: '^?ngModel',
        restrict: 'A',
        link: function link(scope, elem, attr, ctrl) {
            if (ctrl && ctrl.$validators.email) {
                ctrl.$validators.email = function (modelValue) {
                    return ctrl.$isEmpty(modelValue) || EMAIL_REGEXP.test(modelValue);
                };
            }
        }
    };
};

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

angular.module('wowApp.common').directive('wowNameLengthWarnings', __webpack_require__(816));

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: function link(scope, elem, attr, ngModel) {
            scope.options = attr.wowNameLengthWarnings ? JSON.parse(attr.wowNameLengthWarnings) : [];

            // For DOM -> model validation
            ngModel.$parsers.unshift(function (value) {
                var preferredOption = void 0;
                scope.options.forEach(function (option) {
                    if (value.length >= option.length) {
                        if (!preferredOption || option.length > preferredOption.length) {
                            preferredOption = option;
                        }
                    }
                    if (ngModel[option.type]) {
                        delete ngModel[option.type][option.name];
                    }
                });
                if (preferredOption) {
                    if (!ngModel[preferredOption.type]) {
                        ngModel[preferredOption.type] = {};
                    }
                    ngModel[preferredOption.type][preferredOption.name] = true;
                }
                return value;
            });

            // For model -> DOM validation
            ngModel.$formatters.unshift(function (value) {
                var preferredOption = void 0;
                scope.options.forEach(function (option) {
                    if (value.length >= option.length) {
                        if (!preferredOption || option.length > preferredOption.length) {
                            preferredOption = option;
                        }
                    }
                    if (ngModel[option.type]) {
                        delete ngModel[option.type][option.name];
                    }
                });
                if (preferredOption) {
                    if (!ngModel[preferredOption.type]) {
                        ngModel[preferredOption.type] = {};
                    }
                    ngModel[preferredOption.type][preferredOption.name] = true;
                }
                return value;
            });
        }
    };
};

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

angular.module('wowApp.common').directive('wowEventRecorder', ['AnalyticsService', __webpack_require__(818)]);

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (analytics) {
    return {
        scope: {
            erCategory: '@',
            erValue: '@?',
            erLabel: '@',
            erName: '@?',
            erTriggerKeyCode: '@?'
        },
        restrict: 'A',
        link: function link(scope, elem, attr) {
            var eventAction = attr.wowEventRecorder;
            if (!eventAction) return;

            var getEventData = function getEventData() {
                return {
                    category: scope.erCategory || '',
                    value: scope.erValue || '',
                    label: scope.erLabel || '',
                    name: scope.erName
                };
            };

            elem.bind(eventAction, function (evt) {

                if (scope.erTriggerKeyCode && evt.which !== parseInt(scope.erTriggerKeyCode)) {
                    return;
                }

                analytics.push({
                    data: {
                        event: getEventData(),
                        trackingType: 'link'
                    },
                    type: analytics.mapperTypes.customEvent.customEvent
                });
            });
        }
    };
};

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.common');

wowApp.directive('wowErrorPage', ['$sce', '$timeout', 'SettingsService', 'ShopPageStateService', 'LoadingIndicatorService', '$state', 'PageMetadataService', __webpack_require__(820)]);

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($sce, $timeout, settingsService, shopPageStateService, loadingIndicatorService, $state, pageMetadataService) {
    return {
        restrict: 'E',
        scope: {
            errorPage: '=',
            showIcon: '<',
            icon: '@',
            message: '@',
            secondaryMessage: '@',
            pageClass: '@',
            messageClass: '@',
            secondaryMessageClass: '@'
        },
        link: function link(scope) {
            var currentState = $state.current.name;
            var previousMetadata = void 0;
            if (!previousMetadata) {
                previousMetadata = pageMetadataService.getCurrentMetadata();
            }

            if (!scope.message && !scope.secondaryMessage) {
                $timeout(function () {
                    settingsService.getSettingValue('ErrorPage', scope.errorPage).then(function (setting) {
                        scope.errorPageContent = $sce.trustAsHtml(setting);
                        loadingIndicatorService.finishLoading();
                    });
                }, 500);
            }

            // If the user is on these error page for more than 20 seconds, then auto redirect to home page.
            var shouldRedirectToHomePage = function shouldRedirectToHomePage(stateName) {
                switch (stateName) {
                    case 'error.403':
                    case 'error.404':
                    case 'error.500':
                    case 'shop.recipes.recipenotfound':
                        return true;
                    default:
                        return false;
                }
            };
            var secondsToRedirectToHome = 20000;
            $timeout(function () {
                if (shouldRedirectToHomePage($state.current.name)) {
                    $state.go('root');
                }
            }, secondsToRedirectToHome);

            // center panel scroll top
            shopPageStateService.resetCenterPanelScroll();

            scope.$on('$destroy', function () {
                if (currentState === 'error.404') {
                    previousMetadata.meta404 = null;
                    pageMetadataService.setMetadata(previousMetadata);
                }
            });
        },

        template: __webpack_require__(821).trim()
    };
};

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports = "<div class=\"errorPage\" ng-class=\"::pageClass\">\r\n    <div ng-bind-html=\"errorPageContent\" ng-if=\"!message\"></div>\r\n    <i class=\"errorPage-icon\" ng-if=\"showIcon\" ng-class=\"icon ? '{{icon}}' : 'iconww-QtyDeliveryLimit'\"></i>\r\n    <div ng-if=\"message\" ng-class=\"::messageClass\">{{message}}</div>\r\n    <div ng-if=\"secondaryMessage\" ng-class=\"::secondaryMessageClass\">{{secondaryMessage}}</div>\r\n</div>\r\n"

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.common');

wowApp.filter('wowCurrency', ['currencyFilter', __webpack_require__(823)]);
wowApp.filter('wowCurrencyFull', ['wowCurrencyFilter', __webpack_require__(824)]);
wowApp.filter('wowCurrencyCents', ['wowCurrencyFilter', __webpack_require__(825)]);
wowApp.filter('wowMaskCardNumber', [__webpack_require__(826)]);
wowApp.filter('sanitize', ['$sce', __webpack_require__(827)]);
wowApp.filter('hyphenate', [__webpack_require__(828)]);
wowApp.filter('usernamelimiter', [__webpack_require__(831)]);
wowApp.filter('wowLoyaltyPoints', ['Settings', __webpack_require__(832)]);
wowApp.filter('wowTrim', [__webpack_require__(833)]);
wowApp.filter('wowPackagingPriceLabel', ['$filter', 'Settings', __webpack_require__(834)]);

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Custom currency filter for Woolworths
module.exports = function (currencyFilter) {
    return function (amount) {
        var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '$';

        // 0 precision when the amount is less than 1 cent, otherwise 2 decimal places.
        return currencyFilter(amount, symbol, amount < 0.01 ? 0 : 2);
    };
};

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (wowCurrencyFilter) {
    return function (amount) {
        if (typeof amount !== 'undefined' && amount <= 0) {
            return 'Free';
        }

        return wowCurrencyFilter(amount);
    };
};

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (wowCurrencyFilter) {
    /**
     * Augments the Woolworths currency filter to display amounts under $1 formatted as cents (e.g. 50c).
     *
     * @param {Number} amount
     * @param {String} [symbol='$']
     * @param {String} [centsSymbol='¢']
     */
    return function (amount) {
        var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '$';
        var centsSymbol = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '¢';

        var amountInCents = Math.round(amount * 100);

        if (amountInCents < 100 && amountInCents !== 0) {
            return '' + amountInCents + centsSymbol;
        }

        return wowCurrencyFilter(amount, symbol);
    };
};

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    padStart = _require.padStart;

module.exports = function () {
    return function () {
        var cardNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        return padStart(cardNumber.slice(-4), 19, 'XXXX XXXX XXXX XXXX');
    };
};

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($sce) {
    return function (htmlCode) {
        return htmlCode && htmlCode.length > 0 && typeof htmlCode === 'string' ? $sce.trustAsHtml(htmlCode) : htmlCode;
    };
};

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringHelpers = __webpack_require__(829);

module.exports = function () {
    return stringHelpers.hyphenate;
};

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hyphenate = __webpack_require__(830);

module.exports = {
    hyphenate: hyphenate
};

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (input) {
    input = ('' + input || '').toLowerCase().trim();
    return input.replace(/[^a-z0-9]+/gi, '-'); // Replace non alpha numeric strings with a hyphen.
};

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var charactersLimit = 11;

module.exports = function () {
    return function (input) {
        if (!input || input.length > charactersLimit) {
            return 'Hello';
        }

        return 'Hi, ' + input;
    };
};

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var loyaltyPointsCalculator = __webpack_require__(25);

module.exports = function (settings) {
    var conversionBaseSetting = settings.loyalty.rewardsConversionBase;

    function wowLoyaltyFilter(amount) {
        var shouldRestrictToMax = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (conversionBaseSetting) {
            return loyaltyPointsCalculator(amount, conversionBaseSetting, shouldRestrictToMax);
        }

        return amount;
    }

    // This filter is stateful because it depends on the setting value for the conversion base.
    // See https://docs.angularjs.org/guide/filter#stateful-filters
    wowLoyaltyFilter.$stateful = true;

    return wowLoyaltyFilter;
};

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {

    function wowTrimFilter(trimString, shouldTrim) {
        var trimLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;

        if (shouldTrim) {
            if (trimString && typeof trimString === 'string' && trimString.length >= trimLength) {
                return trimString.substring(0, trimLength);
            }
        }

        return trimString;
    }

    return wowTrimFilter;
};

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($filter, settings) {
    return function (packagingPreference) {
        var collapsed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (settings.checkout.enablePackagingUnitPricing && !packagingPreference.IsFlatFee) {
            return collapsed ? '(approx ' + packagingPreference.EstimatedCount + ' &times; ' + $filter('wowCurrencyCents')(packagingPreference.UnitCost) + ' each)' : '<div>approx ' + packagingPreference.EstimatedCount + '</div><div>(' + $filter('wowCurrencyCents')(packagingPreference.UnitCost) + ' each)</div>';
        }
        return 'Per order';
    };
};

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.common');

// Directive
wowApp.component('wowFooter', __webpack_require__(836).footerControllerComponentDefinition);

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    forEach = _require.forEach;

var FooterController = function () {
    function FooterController($anchorScroll, settings, analyticsService, breakpoints, moveFocus) {
        _classCallCheck(this, FooterController);

        this.$anchorScroll = $anchorScroll;
        this.settings = settings;
        this.analyticsService = analyticsService;
        this.breakpoints = breakpoints;
        this.moveFocus = moveFocus;
    }

    _createClass(FooterController, [{
        key: '$onInit',
        value: function $onInit() {
            this.footerColumns = {
                customerService: this.formatLinks(this.settings.footer.customerServiceLinks),
                service: this.formatLinks(this.settings.footer.generalServiceLinks),
                tools: this.formatLinks(this.settings.footer.toolsLinks),
                aboutUs: this.formatLinks(this.settings.footer.aboutUsLinks)
            };
        }
    }, {
        key: 'formatLinks',
        value: function formatLinks(footerLinkRaw) {
            var footerLinks = [];
            forEach(footerLinkRaw, function (value) {
                if (value.length === 1) {
                    footerLinks.push({
                        heading: value[0],
                        children: []
                    });
                } else if (value.length === 2 && footerLinks.length) {
                    footerLinks[footerLinks.length - 1].children.push({
                        heading: value[0],
                        link: value[1]
                    });
                }
            });
            return footerLinks;
        }
    }, {
        key: 'isPanelSelected',
        value: function isPanelSelected(panel) {
            return this.selectedPanel === panel.heading;
        }
    }, {
        key: 'togglePanel',
        value: function togglePanel(panel) {
            if (panel.children.length) {
                this.selectedPanel = this.selectedPanel !== panel.heading ? panel.heading : null;
            }
        }
    }, {
        key: 'expandPanel',
        value: function expandPanel(panel) {
            this.selectedPanel = panel.heading;
        }
    }, {
        key: 'centerPanelFocus',
        value: function centerPanelFocus() {
            this.$anchorScroll();
            this.moveFocus('#body-container');
        }
    }, {
        key: 'pushToAnalytics',
        value: function pushToAnalytics(category, row) {
            var eventData = !category || !row ? null : {
                category: category.heading || '',
                value: row.link || '',
                label: row.heading || ''
            };

            this.analyticsService.push({
                data: {
                    event: eventData,
                    trackingType: 'link'
                },
                type: this.analyticsService.mapperTypes.customEvent.linkClick
            });
        }
    }]);

    return FooterController;
}();

var footerControllerComponentDefinition = {
    controller: ['$anchorScroll', 'Settings', 'AnalyticsService', 'BreakpointsService', 'MoveFocus', FooterController],
    template: __webpack_require__(837).trim()
};

module.exports = {
    FooterController: FooterController,
    footerControllerComponentDefinition: footerControllerComponentDefinition
};

/***/ }),
/* 837 */
/***/ (function(module, exports) {

module.exports = "<div class=\"footer\" id=\"footer\">\r\n\t<a href=\"javascript:;\" ng-click=\"$ctrl.centerPanelFocus()\" class=\"footer-back\">Back to top <i class=\"iconww-ArrowUp footer-backChevron\"></i></a>\r\n\t<div class=\"footer-socialmedia\" wow-html-setting setting-group=\"FooterColumns\" setting-name=\"SocialMediaLinks\"></div>\r\n\r\n\t<div class=\"footer-links _footer-site-links\">\r\n\t\t<div class=\"footer-col\" ng-repeat=\"(key, column) in ::$ctrl.footerColumns track by key\">\r\n\r\n\t\t\t<div class=\"footer-colPanel\" ng-repeat=\"panel in ::column track by panel.heading\" ng-class=\"{ 'is-selected' : $ctrl.isPanelSelected(panel) }\">\r\n\t\t\t\t<h4 class=\"footer-heading\" ng-if=\"!$ctrl.breakpoints.isInSmallFormat\">\r\n\t\t\t\t\t{{ ::panel.heading }}\r\n\t\t\t\t</h4>\r\n\r\n\t\t\t\t<button\r\n\t\t\t\t\tng-if=\"$ctrl.breakpoints.isInSmallFormat\"\r\n\t\t\t\t\tng-click=\"$ctrl.togglePanel(panel)\"\r\n\t\t\t\t\tclass=\"footer-heading\"\r\n\t\t\t\t\taria-expanded=\"{{ $ctrl.isPanelSelected(panel) }}\">\r\n\r\n\t\t\t\t\t<span class=\"footer-headingContainer\">\r\n\t\t\t\t\t\t<span class=\"sr-only\">\r\n\t\t\t\t\t\t\tClick to {{ $ctrl.isPanelSelected(panel) ? 'collapse' : 'expand' }} section\r\n\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t<h4 class=\"footer-headingText\">\r\n\t\t\t\t\t\t\t{{ ::panel.heading }}\r\n\t\t\t\t\t\t</h4>\r\n\t\t\t\t\t\t<i class=\"footer-linkHeaderArrow\" ng-class=\"$ctrl.isPanelSelected(panel) ? 'iconww-ArrowUp' : 'iconww-ArrowDown'\"></i>\r\n\t\t\t\t\t</span>\r\n\t\t\t\t</button>\r\n\r\n\t\t\t\t<div class=\"footer-linkContainer\" ng-if=\"!$ctrl.breakpoints.isInSmallFormat || $ctrl.isPanelSelected(panel)\">\r\n\t\t\t\t\t<a\r\n\t\t\t\t\t\tng-click=\"$ctrl.pushToAnalytics(panel, row)\"\r\n\t\t\t\t\t\tng-href=\"{{ row.link }}\"\r\n\t\t\t\t\t\tclass=\"footer-linkItems\"\r\n\t\t\t\t\t\tng-repeat=\"row in ::panel.children track by row.heading\">\r\n\t\t\t\t\t\t{{ ::row.heading }} <i class=\"iconww-ArrowRight\"></i>\r\n\t\t\t\t\t</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<div class=\"footer-banner\">\r\n\t\t<div class=\"footer-bannerContent\" wow-html-setting setting-group=\"FooterColumns\" setting-name=\"FooterBanner\"></div>\r\n\t</div>\r\n\r\n\t<div class=\"footer-copyright\" wow-html-setting setting-group=\"Copyright\" setting-name=\"OnesiteCopyrightFooterHtml\"></div>\r\n</div>\r\n"

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.common');

var _require = __webpack_require__(839),
    FrontendManagementService = _require.FrontendManagementService;

wowApp.service('FrontendManagementService', FrontendManagementService);

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FrontendManagementService = function () {
    function FrontendManagementService($cookies, settings, trolleyService) {
        _classCallCheck(this, FrontendManagementService);

        this.$cookies = $cookies;
        this.trolleyService = trolleyService;
        this.frontendManagement = settings.frontendManagement || {};
        this.enableDigitalPay = settings.payment && settings.payment.enableDigitalPay;
    }

    _createClass(FrontendManagementService, [{
        key: 'useAngular2PlusCheckout',
        value: function useAngular2PlusCheckout() {
            return this.frontendManagement.useAngular2PlusCheckout && !this.isAngular2PlusUnavailable() && this.enableDigitalPay || this.trolleyService.HasPfdItems;
        }
    }, {
        key: 'useAngular2PlusHaveYouForgotten',
        value: function useAngular2PlusHaveYouForgotten() {
            return this.frontendManagement.useAngular2PlusHaveYouForgotten && !this.isAngular2PlusUnavailable();
        }
    }, {
        key: 'useAngular2PlusQuickReorder',
        value: function useAngular2PlusQuickReorder() {
            return this.frontendManagement.useAngular2PlusQuickReorder && !this.isAngular2PlusUnavailable();
        }
    }, {
        key: 'isAngular2PlusUnavailable',
        value: function isAngular2PlusUnavailable() {
            // When the backend is having issues loading the Angular2Plus frontend,
            // it will set this cookie so we stop trying to redirect to it
            return Boolean(this.$cookies.get('w-isAngular2PlusUnavailable'));
        }
    }]);

    return FrontendManagementService;
}();

FrontendManagementService.$inject = ['$cookies', 'Settings', 'TrolleyService'];

module.exports = { FrontendManagementService: FrontendManagementService };

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var MultiFactorAuthenticationService = __webpack_require__(841);

angular.module('wowApp.common').service('MultiFactorAuthenticationService', ['Settings', 'RestangularV3', MultiFactorAuthenticationService]);

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MultiFactorAuthenticationService = function () {
    function MultiFactorAuthenticationService(settings, restangularV3) {
        _classCallCheck(this, MultiFactorAuthenticationService);

        this.settings = settings;
        this._apiV3 = restangularV3.one('authentication/multi-factor');
    }

    _createClass(MultiFactorAuthenticationService, [{
        key: 'getStatus',
        value: function getStatus() {
            return this._apiV3.one('status').get();
        }
    }, {
        key: 'getDevices',
        value: function getDevices() {
            return this._apiV3.one('devices').get();
        }
    }, {
        key: 'removeDevice',
        value: function removeDevice(tokenId) {
            return this._apiV3.post('removetoken', { TokenId: tokenId });
        }
    }]);

    return MultiFactorAuthenticationService;
}();

MultiFactorAuthenticationService.$inject = ['Settings', 'RestangularV3'];

module.exports = MultiFactorAuthenticationService;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1).module('wowApp.common').service('HeartbeatService', ['$interval', 'Restangular', 'ShopperService', 'config', '$window', __webpack_require__(843)]).run(['HeartbeatService', function (heartbeatService) {
    heartbeatService.startContextHeartbeat();
}]);

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HeartbeatService = function () {
    function HeartbeatService($interval, Restangular, shopperService, config, $window) {
        _classCallCheck(this, HeartbeatService);

        this.$interval = $interval;
        this.api = Restangular.one('heartbeat');
        this.shopperService = shopperService;
        this.$window = $window;

        this.config = config;
    }

    _createClass(HeartbeatService, [{
        key: 'checkContextIsValid',


        /**
         * This function get the current server side version and check if context is valid. If the api call
         * returns a 200 ok then the context is considered valid. Otherwise if the api call returns a 401 then
         * the application will deal with that globally as a side effect.
         */
        value: function checkContextIsValid() {
            var _this = this;

            if (!this.shopperService.IsGuest) {
                this.api.one('context').get().then(function (response) {
                    return _this.checkVersionInfo(response);
                });
            } else {
                this.api.one('guest').get().then(function (response) {
                    return _this.checkVersionInfo(response);
                });
            }
        }
    }, {
        key: 'checkVersionInfo',
        value: function checkVersionInfo(response) {
            if (response.VersionInfo !== this.config.CurrentVersion) {
                this.$window.location.reload();
            }
        }
    }, {
        key: 'startWaitingForContextExpiry',
        value: function startWaitingForContextExpiry(interval) {
            var _this2 = this;

            if (this.contextExpiryInterval) {
                this.$interval.cancel(this.contextExpiryInterval);
            }

            this.contextExpiryInterval = this.$interval(function () {
                return _this2.checkContextIsValid();
            }, interval);
        }
    }, {
        key: 'startContextHeartbeat',
        value: function startContextHeartbeat() {
            var interval = this.config.ContextExpiryPeriod + 60000;
            if (this.config.JwtsEnabled) {
                interval = this.jwtExpiryRefreshInterval;
            }
            this.startWaitingForContextExpiry(interval);
        }
    }, {
        key: 'jwtExpiryRefreshInterval',
        get: function get() {
            return 1000 * 60 * this.config.JwtExpiryMinutes / 2;
        }
    }]);

    return HeartbeatService;
}();

module.exports = HeartbeatService;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.common');

var _require = __webpack_require__(845),
    listGroupComponentDefinition = _require.listGroupComponentDefinition;

// Service


wowApp.service('ListProductService', [__webpack_require__(847)]).component('wowListGroup', listGroupComponentDefinition);

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    isUndefined = _require.isUndefined;

var listGroupController = function () {
    function listGroupController(shopperService, announcerService) {
        _classCallCheck(this, listGroupController);

        this.shopperService = shopperService;
        this.expanded = isUndefined(this.expanded) ? true : this.expanded;
        this.announcerService = announcerService;
    }

    _createClass(listGroupController, [{
        key: 'toggleGroup',
        value: function toggleGroup() {
            this.expanded = !this.expanded;
            this.announcerService.announce(this.groupName + ' has been ' + (this.groupToggleState ? 'expanded' : 'minimized'));
        }
    }]);

    return listGroupController;
}();

listGroupController.$inject = ['ShopperService', 'AnnouncerService'];

var listGroupComponentDefinition = {
    bindings: {
        groupName: '@',
        toolTipText: '@?',
        expanded: '=?'
    },
    transclude: {
        cta: '?wowListGroupCta',
        content: 'wowListGroupContent'
    },
    controller: listGroupController,
    template: __webpack_require__(846).trim()
};

module.exports = {
    listGroupController: listGroupController,
    listGroupComponentDefinition: listGroupComponentDefinition
};

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports = "<div class=\"listGroup\">\r\n    <div class=\"listGroupControls\">\r\n        <div class=\"listGroupHeading\" ng-click=\"$ctrl.toggleGroup()\">\r\n            {{$ctrl.groupName}}\r\n            <oly-questionmark-tooltip\r\n                ng-if=\"$ctrl.toolTipText\"\r\n                custom-tooltip-class=\"'listGroup-toolTip'\"\r\n                message=\"{{$ctrl.toolTipText}}\">\r\n            </oly-questionmark-tooltip>\r\n        </div>\r\n        <span ng-if=\"$ctrl.toolTipText\" class=\"sr-only\"> Tooltip - {{$ctrl.toolTipText}}</span>\r\n        <div class=\"listGroupControlsInline\">\r\n            <div ng-transclude=\"cta\" class=\"listGroup-desktopCta\"></div>\r\n            <a href=\"javascript:;\" class=\"listGroupControlsToggle\" ng-click=\"$ctrl.toggleGroup()\">\r\n                <span class=\"sr-only\">Toggle {{ $ctrl.groupName }} group Dropdown</span>\r\n                <i class=\"listGroupControlsToggleChevron\" ng-class=\"$ctrl.expanded ? 'iconww-ArrowUp' : 'iconww-ArrowDown'\"></i>\r\n            </a>\r\n        </div>\r\n    </div>\r\n    <div ng-show=\"$ctrl.expanded\" ng-transclude=\"content\">no content.</div>\r\n    <div ng-transclude=\"cta\" class=\"listGroup-mobileCta\"></div>\r\n</div>\r\n"

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ListProductService = function ListProductService() {
    this.suggestedListClickedPreviously = false;
};

module.exports = ListProductService;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var loadingIndicatorService = __webpack_require__(849);

var _require = __webpack_require__(850),
    loadingIndicatorComponentDefinition = _require.loadingIndicatorComponentDefinition;

angular.module('wowApp.common').service('LoadingIndicatorService', loadingIndicatorService).component('wowLoadingIndicator', loadingIndicatorComponentDefinition);

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoadingIndicatorService = function () {
    function LoadingIndicatorService() {
        _classCallCheck(this, LoadingIndicatorService);

        this._isLoading = false;
        this._isMasked = false;
        this._message = null;
        this._isMessageSrOnly = true;
    }

    _createClass(LoadingIndicatorService, [{
        key: "startLoading",
        value: function startLoading() {
            var isMasked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var isMessageSrOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            this._isLoading = true;
            this._isMasked = isMasked;
            this._message = message;
            this._isMessageSrOnly = isMessageSrOnly;
        }
    }, {
        key: "finishLoading",
        value: function finishLoading() {
            this._isLoading = false;
            this._isMasked = false;
            this._message = null;
        }
    }]);

    return LoadingIndicatorService;
}();

module.exports = LoadingIndicatorService;

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoadingIndicatorController = function LoadingIndicatorController(loadingIndicatorService) {
    _classCallCheck(this, LoadingIndicatorController);

    this.loading = loadingIndicatorService;
};

var loadingIndicatorComponentDefinition = {
    controller: ['LoadingIndicatorService', LoadingIndicatorController],
    template: '\n        <wow-loading-spinner\n            class="loadingIndicator"\n            ng-if="$ctrl.loading._isLoading"\n            custom-spinner-class="loadingIndicator-spinner"\n            message="{{ $ctrl.loading._message }}"\n            is-message-sr-only="$ctrl.loading._isMessageSrOnly">\n        </wow-loading-spinner>\n\n        <div ng-if="$ctrl.loading._isMasked" class="loadingIndicator-mask"></div>\n    '
};

module.exports = {
    LoadingIndicatorController: LoadingIndicatorController,
    loadingIndicatorComponentDefinition: loadingIndicatorComponentDefinition
};

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

angular.module('wowApp.common').directive('wowMatchExistingTextValidator', __webpack_require__(852));

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: function link(scope, elem, attr, ngModel) {
            // For DOM -> model validation
            ngModel.$parsers.unshift(function (value) {
                scope.existingText = attr.wowMatchExistingTextValidator ? JSON.parse(attr.wowMatchExistingTextValidator) : [];
                var valid = scope.existingText.filter(function (text) {
                    return text.toLowerCase() === value.toLowerCase();
                }).length === 0;
                ngModel.$setValidity('matchExisting', valid);
                return valid ? value : undefined;
            });

            // For model -> DOM validation
            ngModel.$formatters.unshift(function (value) {
                scope.existingText = attr.wowMatchExistingTextValidator ? JSON.parse(attr.wowMatchExistingTextValidator) : [];
                var valid = scope.existingText.filter(function (text) {
                    return text.toLowerCase() === value.toLowerCase();
                }).length === 0;
                ngModel.$setValidity('matchExisting', valid);
                return value;
            });
        }
    };
};

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(854),
    MobilePhoneValidationSuccessComponentDefinition = _require.MobilePhoneValidationSuccessComponentDefinition;

var _require2 = __webpack_require__(856),
    MobilePhoneValidationErrorComponentDefinition = _require2.MobilePhoneValidationErrorComponentDefinition;

angular.module('wowApp.common').component('wowMobilePhoneValidationSuccess', MobilePhoneValidationSuccessComponentDefinition).component('wowMobilePhoneValidationError', MobilePhoneValidationErrorComponentDefinition).directive('wowMobilePhoneValidator', __webpack_require__(858)).directive('wowMobilePhoneVerification', ['Settings', '$window', 'ResourceInjector', __webpack_require__(859)]);

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MobilePhoneValidationSuccessController = function () {
    function MobilePhoneValidationSuccessController() {
        _classCallCheck(this, MobilePhoneValidationSuccessController);
    }

    _createClass(MobilePhoneValidationSuccessController, [{
        key: '$onInit',
        value: function $onInit() {
            this.formattedNumber = this.formatNumber(this.phoneNumber);
        }
    }, {
        key: 'formatNumber',
        value: function formatNumber(mobileNumber) {
            if (mobileNumber.length === 11) {
                // remove MSISDN fix
                mobileNumber = mobileNumber.substring(2, mobileNumber.length);
            }

            if (mobileNumber.length === 10) {
                // remove leading zero
                mobileNumber = mobileNumber.substring(1, mobileNumber.length);
            }

            // Add the Australian prefix (only AUS numbers allowed) and spaces between sets of digits.
            return '+61 ' + mobileNumber.substring(0, 3) + ' ' + mobileNumber.substring(3, 6) + ' ' + mobileNumber.substring(6, 9);
        }
    }]);

    return MobilePhoneValidationSuccessController;
}();

var MobilePhoneValidationSuccessComponentDefinition = {
    controller: MobilePhoneValidationSuccessController,
    template: __webpack_require__(855).trim(),
    bindings: {
        successMessage: '<',
        phoneNumber: '<',
        onEnterNewMobilePhoneNumber: '&'
    }
};

module.exports = {
    MobilePhoneValidationSuccessController: MobilePhoneValidationSuccessController,
    MobilePhoneValidationSuccessComponentDefinition: MobilePhoneValidationSuccessComponentDefinition
};

/***/ }),
/* 855 */
/***/ (function(module, exports) {

module.exports = "<div class=\"mobilePhoneValidationSuccess\">\r\n    <div class=\"mobilePhoneValidationSuccess-topContainer\">\r\n        <div class=\"mobilePhoneValidationSuccess-icon\"></div>\r\n        <h1 class=\"mobilePhoneValidationSuccess-heading\">Thank you!</h1>\r\n        <p class=\"mobilePhoneValidationSuccess-message\">{{$ctrl.successMessage}}</p>\r\n    </div>\r\n    <div class=\"mobilePhoneValidationSuccess-bottomContainer\">\r\n        <div class=\"mobilePhoneValidationSuccess-number\">{{$ctrl.formattedNumber}}</div>\r\n        <button\r\n            ng-click=\"$ctrl.onEnterNewMobilePhoneNumber()\"\r\n            type=\"button\"\r\n            class=\"mobilePhoneValidationSuccess-button\">Edit</button>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"separator\"></div>\r\n"

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MobilePhoneValidationErrorController = function MobilePhoneValidationErrorController() {
    _classCallCheck(this, MobilePhoneValidationErrorController);
};

var MobilePhoneValidationErrorComponentDefinition = {
    controller: MobilePhoneValidationErrorController,
    template: __webpack_require__(857).trim(),
    bindings: {
        headerMessage: '<',
        contentMessage: '<',
        onRequestNewPinCode: '&'
    }
};

module.exports = {
    MobilePhoneValidationErrorController: MobilePhoneValidationErrorController,
    MobilePhoneValidationErrorComponentDefinition: MobilePhoneValidationErrorComponentDefinition
};

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports = "<div class=\"mobilePhoneValidationError\">\r\n    <i class=\"iconww-error mobilePhoneValidationError-icon\" title=\"iconww-error\"></i>\r\n    <div class=\"mobilePhoneValidationError-header\">\r\n        {{$ctrl.headerMessage}}\r\n    </div>\r\n    <div class=\"mobilePhoneValidationError-message\">\r\n        {{$ctrl.contentMessage}}\r\n    </div>\r\n</div>\r\n\r\n<button\r\n    ng-click=\"$ctrl.onRequestNewPinCode()\"\r\n    type=\"button\"\r\n    class=\"mobilePhoneValidationError-button\">\r\n    Get a new PIN code\r\n</button>\r\n\r\n<div class=\"separator\"></div>\r\n"

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function isMobilePhoneValid(number) {
    if (!number) return false;

    number = String(number);

    number = number.replace(/ /g, '');

    if (isNaN(number)) return false;

    // MSISDN prefix
    if (number.startsWith('614') || number.startsWith('615')) {
        return number.length === 11;
    }

    // Local prefix
    if (number.startsWith('04') || number.startsWith('05')) {
        return number.length === 10;
    }

    return false;
}

module.exports = function () {
    return {
        require: '^?ngModel',
        restrict: 'A',
        link: function link(scope, elem, attr, ctrl) {
            ctrl.$validators.invalidMobilePhone = function (modelValue, viewValue) {
                var value = modelValue || viewValue;
                return isMobilePhoneValid(value);
            };
        }
    };
};

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Retrieve the Phone Number that is ready to set in the widget.
 * @param {string} mobileNumber
 */
function getMobileNumberForWidget(mobileNumber) {
    if (isNaN(mobileNumber)) return '';

    if (mobileNumber.length === 11) {
        // remove MSISDN fix
        return mobileNumber.substring(2, mobileNumber.length);
    }

    if (mobileNumber.length === 10) {
        // remove leading zero
        return mobileNumber.substring(1, mobileNumber.length);
    }

    return mobileNumber;
}

/**
 * Retrieve the Phone Number from the Widget.
 * @param {string} phoneNumber
 */
function getPrePolulatedPhoneNumberFromWidget(phoneNumber) {
    var dataString = localStorage.getItem('ringcaptcha.widget.' + phoneNumber);
    var data = dataString ? JSON.parse(dataString) : null;
    if (!data && !data.phoneNumber) {
        var phone = '' + data.phoneNumber.substring(3, data.phoneNumber.length);
        return phone;
    }
    return '';
}

/**
 * Actions to perform when RingCaptcha widget is ready.
 * @param {string} key
 * @param {string} scope
 */
function onWidgetReady(key, phoneNumber) {
    // Overriding the ghost text inside the mobile number text box
    $('input[type=tel]').attr('placeholder', '');
    // Handle desktop version
    $('.country-list a').click(function () {
        setInterval(function () {
            $('input[type=tel]').attr('placeholder', '');
        }, 5);
    });
    // Handle mobile version
    $('.country-list-mobile').click(function () {
        setInterval(function () {
            $('input[type=tel]').attr('placeholder', '');
        }, 5);
    });

    // when going back to cart and do some changes, and come back to checkout panel, scope.phoneNumber become undefined randomly.
    // but since the widget is already loaded with the mobile number, mobile number is read from the Widget
    if (!phoneNumber) {
        var phoneNumberForWidget = getMobileNumberForWidget(getPrePolulatedPhoneNumberFromWidget(key));
        $('input.form-control.phone-input.phone-input-verify').val(phoneNumberForWidget);
    } else {
        // parsing the shopper mobile number in to the widget
        var _phoneNumberForWidget = getMobileNumberForWidget(phoneNumber);
        $('input.form-control.phone-input.phone-input-verify').val(_phoneNumberForWidget);
    }
    $(this).off('click', '.country-button');
}

/**
 * Load the Ring Captcha widget.
 * @param {object} scope Directive scope.
 * @param {object} settings Frontend settings
 */
function loadWidget(scope, settings) {
    // We have to disable linting as we can't workaround using the widget.
    // eslint-disable-next-line
    new RingCaptcha.Widget('#ring-captcha', {
        app: settings.ringCaptchaMessages.ringCaptchaAppKey,
        events: {
            ready: function ready() {
                onWidgetReady(settings.ringCaptchaMessages.ringCaptchaAppKey, scope.phoneNumber);
            },
            verified: function verified() {
                // extracting the phone number validated by the widget
                var dataString = localStorage.getItem('ringcaptcha.widget.' + settings.ringCaptchaMessages.ringCaptchaAppKey);
                var data = dataString ? JSON.parse(dataString) : null;
                var phone = '0' + data.phoneNumber.substring(3, data.phoneNumber.length);
                // extracting token
                var tokenAssigned = data.token;
                // Gets the hidden input value with name = 'ringcaptcha_pin_code'
                var code = $('input[name="ringcaptcha_pin_code"]').val();

                scope.onVerification({
                    verifiedPhoneNumber: phone, token: tokenAssigned, otpCode: code
                });
                scope.$apply();
            },

            // Trigger the session expired message
            error: function error(event) {
                if (event.type === 'error' && (event.error === 'session_expired' || event.error === 'invalid_session')) {
                    scope.onSessionTimeOut();
                    scope.$apply();
                }
            },

            // display error message when number of tries to enter PIN is exceeded.
            max_validations: function max_validations() {
                scope.onExceedMaximumRetries();
                scope.$apply();
            }
        }
    });
}

module.exports = function (settings, $window, resourceInjector) {
    $window.RingCaptchaLocale = {
        en: {
            'code.title': '',
            'code.service.sms.summary': settings.ringCaptchaMessages.smsNotificationSummaryText,
            'code.service.sms.label': settings.ringCaptchaMessages.sendSmsButtonLabel,
            'check.title.sms': settings.ringCaptchaMessages.sendSmsCheckPinCodeLabel,
            'check.retry': settings.ringCaptchaMessages.tryAgainLinkText,
            'code.summary': settings.ringCaptchaMessages.sendPinCodeToPhoneLabel,
            'error.session_expired': '',
            'help:': '',
            'check.summary': '',
            'check.help': '',
            'error.invalid_number_length': settings.ringCaptchaMessages.incorrectPhoneNumber,
            'error.invalid_number': settings.ringCaptchaMessages.incorrectPhoneNumber,
            'error.invalid_pin_code': settings.ringCaptchaMessages.invalidPinCode,
            'check.error.invalid_pin_code': settings.ringCaptchaMessages.invalidPinCode
        }
    };

    return {
        require: '^?ngModel',
        restrict: 'A',
        scope: {
            phoneNumber: '=',
            deliveryOptions: '@?',
            onVerification: '&',
            onSessionTimeOut: '&',
            onExceedMaximumRetries: '&'
        },
        template: __webpack_require__(860).trim(),
        link: function link(scope) {
            resourceInjector.injectScript(settings.ringCaptchaMessages.ringCaptchaWidgetJsPath).then(function () {

                // TODO Use $timeout instead of setTimeout
                setTimeout(function () {
                    loadWidget(scope, settings);
                });
            });
        }
    };
};

/***/ }),
/* 860 */
/***/ (function(module, exports) {

module.exports = "<div class=\"mobilePhoneVerification\" id=\"ring-captcha\" data-widget data-locale=\"en\" data-mode=\"verification\" data-type=\"sms\"\r\n    ng-model=\"$ctrl.deliveryOptions.MobilePhone\"\r\n    ng-change=\"$ctrl.onOptionChange()\"\r\n    wow-mobile-phone-validator>\r\n</div>\r\n"

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.common');

wowApp.controller('PageMetadataController', ['$location', 'PageMetadataService', __webpack_require__(862)]);

wowApp.service('PageMetadataService', ['Restangular', '$location', '$state', '$q', '$window', 'AnalyticsService', __webpack_require__(863)]);

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($location, pageMetaDataService) {
    this.metaData = pageMetaDataService;

    this.currentUrl = function () {
        return $location.absUrl();
    };
};

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _api = void 0,
    _location = void 0,
    _state = void 0,
    _q = void 0,
    _analytics = void 0,
    _window = void 0;

var _ = __webpack_require__(0),
    angular = __webpack_require__(1),
    $ = __webpack_require__(2),
    UrlInfo = __webpack_require__(32);

var cache = {};

var pushGtm = function pushGtm(data, state) {
    if (state && state.current && state.current.name === 'root') {
        data = $(document).attr('title');
    }
    _analytics.push({ data: data, type: _analytics.mapperTypes.seo.pageTitle });
};

function constructCanonicalUrl(canonicalUrl) {
    switch (_state.current.name) {
        case 'shop.recipes.category':
            return _window.location.origin + '/shop/recipes/' + _state.params.category;
        case 'shop.recipes.category.subCategory':
            return _window.location.origin + '/shop/recipes/' + _state.params.category + '/' + _state.params.subCategory;
        default:
            return canonicalUrl;
    }
}

function parseCanonical(canonical) {
    if (!_state.current.name.startsWith('shop.recipes.category')) {
        return canonical;
    }

    var match = canonical.toLowerCase().match(/(pagenumber=[0-9]+)/);
    var canonicalUrl = constructCanonicalUrl(canonical);

    if (!match) {
        return canonicalUrl;
    }

    return canonicalUrl + '?' + match[0];
}

function PageMetadata(restangular, $location, $state, $q, $window, analytics) {
    _api = restangular.one('SeoMetatags');
    _location = $location;
    _state = $state;
    _q = $q;
    _window = $window;
    _analytics = analytics;
}

PageMetadata.prototype.defaultMetadata = {
    title: '',
    metaDescription: '',
    metaRobot: '',
    meta404: '',
    metaPrevUrl: '',
    metaNextUrl: '',
    sessionGroups: null,
    openGraph: {
        image: '',
        imageWidth: '',
        imageHeight: ''
    },
    canonical: null
};

function normalize(metaData) {
    var title = metaData.Title || metaData.title || '';
    var metaDescription = metaData.MetaDescription || metaData.metaDescription || '';
    var metaRobot = metaData.MetaRobot || metaData.metaRobot || null;
    var meta404 = metaData.meta404 || null;
    var sessionGroups = metaData.sessionGroups || metaData.Groups || null;
    var openGraph = metaData.openGraph || { image: '' };
    var canonical = parseCanonical(metaData.canonical) || null;
    pushGtm(title, _state);

    return {
        title: title,
        metaDescription: metaDescription,
        metaRobot: metaRobot,
        meta404: meta404,
        metaPrevUrl: metaData.metaPrevUrl,
        metaNextUrl: metaData.metaNextUrl,
        sessionGroups: sessionGroups,
        openGraph: openGraph,
        canonical: canonical
    };
}

PageMetadata.prototype.controlSeries = function (currentPage, totalPages) {
    var currentUrl = _location.url();
    var urlInfo = new UrlInfo(currentUrl);

    // if current pageNumber 1, do not show prev
    if (currentPage === 1) {
        // don't show previous
        this.metaPrevUrl = '';
    } else {
        // show previous
        var prevPage = currentPage - 1;
        urlInfo.search({ pageNumber: prevPage }, true);
        this.metaPrevUrl = urlInfo.href();
    }

    // if current page is last page, do not show next
    if (currentPage === totalPages) {
        // don't show next
        this.metaNextUrl = '';
    } else {
        var nextPage = currentPage + 1;
        urlInfo.search({ pageNumber: nextPage }, true);
        this.metaNextUrl = urlInfo.href();
    }
};

/**
 * Sets metadata for robot meta tag
 * @param {bool} isIndex - if page is indexed, set null or undefined if dont care.
 * @param {bool} isFollow - if page is followed, set null or undefined if dont care.
 */
PageMetadata.prototype.setMetaRobot = function (isIndex, isFollow) {
    var metaRobot = [];

    if (isIndex !== undefined && isIndex !== null) {
        metaRobot.push(isIndex ? 'index' : 'noindex');
    }

    if (isFollow !== undefined && isFollow !== null) {
        metaRobot.push(isFollow ? 'follow' : 'nofollow');
    }

    if (metaRobot.length) {
        return metaRobot.join(', ');
    }

    return '';
};

/**
 * Sets metadata for robot meta tag, handles whether the currentPage is greater than 2
 * @param {Object} currentPage - The current page for the list you're on
 */
PageMetadata.prototype.setMetaRobotOnPageChange = function (currentPage, updateMetadata) {
    if (_state.current.name.startsWith('shop.recipes.category')) {
        this.metaRobot = null;
    } else if (currentPage && currentPage > 1) {
        this.metaRobot = updateMetadata ? this.setMetaRobot(false, true) : null;
    }
};

/**
 * Gets metadata from the server which has been set up in site management.
 * @param {Object} formatObject - The format object contains key/value pairs which can be used in
 *  the format string which is set up in site management
 * @param {boolean} [isSpecial] - If this is true, will only search for metadata created for
 *  specials pages.
 * @param {String} urlPath - This is the key which metadata is created against and which will be
 *  used to search for the metadata.
 * @param {String} [pageType] - This is used to search for metadata from only one of these categories:
 *  Department, Aisle, LandingPage, Product, Recipe, FreeText, RecipeCategory, Home.
 * @param {Object} extraMetadata - Key/value pairs to merge into the metadata result returned from
 *  the server (e.g. opengraph metadata).
 * @returns {Promise}
 */
PageMetadata.prototype.getMetadata = function (formatObject, isSpecial, urlPath, pageType, extraMetadata) {
    var path = urlPath || _location.path();
    var special = isSpecial || false;
    var key = path + '-' + special + '-' + pageType;
    // reset this variable to remove <meta name="robot" value="noindex, follow"> when navigating to a different list
    return key in cache ? _q.when(cache[key]) : _api.doPOST({
        UrlPath: path,
        IsSpecial: special,
        FormatObject: JSON.stringify(formatObject || {}),
        PageType: pageType
    }).then(function (metaResponse) {
        return _.assign(metaResponse, extraMetadata);
    }).then(normalize.bind(this)).then(function (result) {
        cache[key] = result;
        window.prerenderReady = true;
        return result;
    });
};

PageMetadata.prototype.getCurrentMetadata = function () {
    return {
        title: this.title,
        metaDescription: this.metaDescription,
        metaRobot: this.metaRobot,
        meta404: this.meta404,
        metaPrevUrl: this.metaPrevUrl,
        metaNextUrl: this.metaNextUrl,
        sessionGroups: this.sessionGroups,
        openGraph: this.openGraph
    };
};

PageMetadata.prototype.setMetadata = function (metaData) {
    if (!metaData) {
        return;
    }

    if (angular.isFunction(metaData.then)) {
        metaData.then(this.setMetadata.bind(this));
    } else {
        _.assign(this, normalize.call(this, metaData));
    }
};

PageMetadata.prototype.useCurrentStateMetadata = function () {
    if (_state.shouldGetMetaData()) {
        this.setMetadata(_state.getMetadata());
    }
};

module.exports = PageMetadata;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1).module('wowApp.common').service('PastShopService', __webpack_require__(865));

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    find = _require.find;

var PastShopService = function () {
    function PastShopService($q, $location, restangular, restangularV3, bootstrap, listProductService) {
        _classCallCheck(this, PastShopService);

        this.api = restangular.one('pastshops');
        this.apiV3 = restangularV3.one('pastshops');
        this.$q = $q;
        this.$location = $location;
        this.listProductService = listProductService;
        this.pastShops = [];

        // Promise used to cache past shops
        this.pastShopPromise = null;

        if (bootstrap.isBootstrapped(bootstrap.bootstrapped.PastShops)) {
            this.pastShopPromise = this.$q.when(this.setPastShops(bootstrap.getBootstrappedData(bootstrap.bootstrapped.PastShops)));
        }
    }

    _createClass(PastShopService, [{
        key: 'setPastShops',
        value: function setPastShops(data) {
            this.pastShops = data.Response;
            return this.pastShops;
        }
    }, {
        key: 'invalidateCache',
        value: function invalidateCache() {
            // This will reset the past shops promise to fetch from the API. This is needed when the
            // result is unpredictable / impractial to determine using the frontend only.
            this.pastShopPromise = null;
            return this.listPastShops();
        }
    }, {
        key: 'listPastShops',
        value: function listPastShops() {
            var _this = this;

            if (!this.pastShopPromise) {
                // Cache has been invalidated, fetch from API
                this.pastShopPromise = this.api.one('list').get().then(function (data) {
                    return _this.setPastShops(data);
                });
            }
            return this.pastShopPromise;
        }
    }, {
        key: 'getOrder',
        value: function getOrder(orderId) {
            var _this2 = this;

            return this.listPastShops().then(function (pastShops) {
                return _this2.$q.when(find(pastShops, function (pastShop) {
                    return pastShop.OrderId === orderId;
                }));
            });
        }
    }, {
        key: 'getProducts',
        value: function getProducts(orderId, pageSize, pageNumber, sortType, filters) {
            return this.api.post(orderId === 'everything' ? 'AllProducts' : orderId + '/Products', {
                PageSize: pageSize || 10,
                PageNumber: pageNumber,
                SortType: sortType,
                Location: this.$location.url(),
                Filters: filters ? filters.filters : []
            });
        }
    }, {
        key: 'getPastShopProductCount',
        value: function getPastShopProductCount() {
            return this.apiV3.post('AllProductsCount');
        }
    }, {
        key: 'getAllProducts',
        value: function getAllProducts(pageSize, pageNumber, sortType, filters, includeOnline, includeInstore) {
            return this.apiV3.post('AllProducts', {
                PageSize: pageSize || 10,
                PageNumber: pageNumber,
                SortType: sortType,
                Location: this.$location.url(),
                Filters: filters ? filters.filters : [],
                IncludeOnline: includeOnline,
                IncludeInstore: includeInstore
            });
        }
    }]);

    return PastShopService;
}();

PastShopService.$inject = ['$q', '$location', 'Restangular', 'RestangularV3', 'BootstrapService', 'ListProductService'];

module.exports = PastShopService;

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.common');

wowApp.service('PaypalService', ['Restangular', '$q', __webpack_require__(867)]);

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var braintree = __webpack_require__(868);

var _require = __webpack_require__(0),
    assign = _require.assign;

var PaypalService = function () {
    function PaypalService(restangular, $q) {
        _classCallCheck(this, PaypalService);

        this.$q = $q;
        this.api = restangular.one('Paypal');
        this.dpApi = restangular.one('DigitalPay');
        this.integration = null;
        this.deviceData = null;
    }

    _createClass(PaypalService, [{
        key: 'setup',
        value: function setup(paypal, callBack) {
            var _this = this;

            var clientToken = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            var deferred = this.$q.defer();
            this.token = null;
            this.nonce = null;
            this.deviceData = null;
            this.customerEmail = null;
            this.integration = null;

            var options = assign({
                singleUse: false,
                displayName: 'WoolWorths',
                enableShippingAddress: false,
                enableBillingAddress: false,
                headless: true
            }, paypal);

            if (!clientToken) {
                this.api.post('Token').then(function (response) {
                    _this.setupBrainTree(response.ClientToken, options, deferred, callBack);
                });
            } else {
                this.setupBrainTree(clientToken, options, deferred, callBack);
            }

            return deferred.promise;
        }
    }, {
        key: 'setupBrainTree',
        value: function setupBrainTree(clientToken, options, deferred, callBack) {
            var _this2 = this;

            braintree.setup(clientToken, 'custom', {
                dataCollector: {
                    paypal: true
                },
                onReady: function onReady(integration) {
                    _this2.integration = integration;
                    _this2.deviceData = integration.deviceData;
                    deferred.resolve({ hasError: false });
                },
                onError: function onError(type, message) {
                    deferred.reject({ hasError: true, type: type, message: message });
                },
                onPaymentMethodReceived: function onPaymentMethodReceived(payload) {
                    // retrieve nonce from payload.nonce
                    if (callBack != null) {
                        callBack(payload);
                    }
                },
                paypal: options
            });
        }
    }, {
        key: 'initAuthFlow',
        value: function initAuthFlow() {
            this.integration.paypal.initAuthFlow();
        }
    }, {
        key: 'getCurrentCustomer',
        value: function getCurrentCustomer() {
            return this.api.post('Customer');
        }
    }, {
        key: 'getDeviceData',
        value: function getDeviceData() {
            return this.deviceData;
        }
    }, {
        key: 'removeAccount',
        value: function removeAccount() {
            var _this3 = this;

            return this.api.post('Remove').then(function () {
                _this3.token = null;
                _this3.nonce = null;
            });
        }
    }, {
        key: 'isReady',
        value: function isReady() {
            return !!this.integration;
        }
    }, {
        key: 'isTokenized',
        value: function isTokenized() {
            return !!this.token;
        }
    }, {
        key: 'linkAccount',
        value: function linkAccount(nonce, email, deviceData) {
            var _this4 = this;

            return this.api.post('Link', { Nonce: nonce, Email: email, DeviceData: deviceData }).then(function (payload) {
                _this4.token = payload.Token;
                _this4.customerEmail = email;
                return payload;
            });
        }
    }, {
        key: 'linkAccountWithDp',
        value: function linkAccountWithDp(nonce) {
            return this.dpApi.post('Paypal/Link', { Nonce: nonce });
        }
    }, {
        key: 'resolveAddress',
        value: function resolveAddress(details) {
            if (details.shippingAddress) {
                return details.shippingAddress;
            }

            if (details.billingAddress) {
                return details.billingAddress;
            }

            return null;
        }
    }]);

    return PaypalService;
}();

module.exports = PaypalService;

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var require;var require;!function(){function t(e,n){e instanceof t?(this.enc=e.enc,this.pos=e.pos):(this.enc=e,this.pos=n)}function e(t,e,n,i,o){this.stream=t,this.header=e,this.length=n,this.tag=i,this.sub=o}function n(t){var e,n,i="";for(e=0;e+3<=t.length;e+=3)n=parseInt(t.substring(e,e+3),16),i+=et.charAt(n>>6)+et.charAt(63&n);for(e+1==t.length?(n=parseInt(t.substring(e,e+1),16),i+=et.charAt(n<<2)):e+2==t.length&&(n=parseInt(t.substring(e,e+2),16),i+=et.charAt(n>>2)+et.charAt((3&n)<<4));(3&i.length)>0;)i+=nt;return i}function i(t){var e,n,i,o="",r=0;for(e=0;e<t.length&&t.charAt(e)!=nt;++e)i=et.indexOf(t.charAt(e)),0>i||(0==r?(o+=l(i>>2),n=3&i,r=1):1==r?(o+=l(n<<2|i>>4),n=15&i,r=2):2==r?(o+=l(n),o+=l(i>>2),n=3&i,r=3):(o+=l(n<<2|i>>4),o+=l(15&i),r=0));return 1==r&&(o+=l(n<<2)),o}function o(t){var e,n=i(t),o=new Array;for(e=0;2*e<n.length;++e)o[e]=parseInt(n.substring(2*e,2*e+2),16);return o}function r(t,e,n){null!=t&&("number"==typeof t?this.fromNumber(t,e,n):null==e&&"string"!=typeof t?this.fromString(t,256):this.fromString(t,e))}function s(){return new r(null)}function a(t,e,n,i,o,r){for(;--r>=0;){var s=e*this[t++]+n[i]+o;o=Math.floor(s/67108864),n[i++]=67108863&s}return o}function c(t,e,n,i,o,r){for(var s=32767&e,a=e>>15;--r>=0;){var c=32767&this[t],u=this[t++]>>15,l=a*c+u*s;c=s*c+((32767&l)<<15)+n[i]+(1073741823&o),o=(c>>>30)+(l>>>15)+a*u+(o>>>30),n[i++]=1073741823&c}return o}function u(t,e,n,i,o,r){for(var s=16383&e,a=e>>14;--r>=0;){var c=16383&this[t],u=this[t++]>>14,l=a*c+u*s;c=s*c+((16383&l)<<14)+n[i]+o,o=(c>>28)+(l>>14)+a*u,n[i++]=268435455&c}return o}function l(t){return ct.charAt(t)}function h(t,e){var n=ut[t.charCodeAt(e)];return null==n?-1:n}function p(t){for(var e=this.t-1;e>=0;--e)t[e]=this[e];t.t=this.t,t.s=this.s}function d(t){this.t=1,this.s=0>t?-1:0,t>0?this[0]=t:-1>t?this[0]=t+this.DV:this.t=0}function f(t){var e=s();return e.fromInt(t),e}function m(t,e){var n;if(16==e)n=4;else if(8==e)n=3;else if(256==e)n=8;else if(2==e)n=1;else if(32==e)n=5;else{if(4!=e)return void this.fromRadix(t,e);n=2}this.t=0,this.s=0;for(var i=t.length,o=!1,s=0;--i>=0;){var a=8==n?255&t[i]:h(t,i);0>a?"-"==t.charAt(i)&&(o=!0):(o=!1,0==s?this[this.t++]=a:s+n>this.DB?(this[this.t-1]|=(a&(1<<this.DB-s)-1)<<s,this[this.t++]=a>>this.DB-s):this[this.t-1]|=a<<s,s+=n,s>=this.DB&&(s-=this.DB))}8==n&&0!=(128&t[0])&&(this.s=-1,s>0&&(this[this.t-1]|=(1<<this.DB-s)-1<<s)),this.clamp(),o&&r.ZERO.subTo(this,this)}function y(){for(var t=this.s&this.DM;this.t>0&&this[this.t-1]==t;)--this.t}function g(t){if(this.s<0)return"-"+this.negate().toString(t);var e;if(16==t)e=4;else if(8==t)e=3;else if(2==t)e=1;else if(32==t)e=5;else{if(4!=t)return this.toRadix(t);e=2}var n,i=(1<<e)-1,o=!1,r="",s=this.t,a=this.DB-s*this.DB%e;if(s-->0)for(a<this.DB&&(n=this[s]>>a)>0&&(o=!0,r=l(n));s>=0;)e>a?(n=(this[s]&(1<<a)-1)<<e-a,n|=this[--s]>>(a+=this.DB-e)):(n=this[s]>>(a-=e)&i,0>=a&&(a+=this.DB,--s)),n>0&&(o=!0),o&&(r+=l(n));return o?r:"0"}function v(){var t=s();return r.ZERO.subTo(this,t),t}function _(){return this.s<0?this.negate():this}function b(t){var e=this.s-t.s;if(0!=e)return e;var n=this.t;if(e=n-t.t,0!=e)return this.s<0?-e:e;for(;--n>=0;)if(0!=(e=this[n]-t[n]))return e;return 0}function E(t){var e,n=1;return 0!=(e=t>>>16)&&(t=e,n+=16),0!=(e=t>>8)&&(t=e,n+=8),0!=(e=t>>4)&&(t=e,n+=4),0!=(e=t>>2)&&(t=e,n+=2),0!=(e=t>>1)&&(t=e,n+=1),n}function w(){return this.t<=0?0:this.DB*(this.t-1)+E(this[this.t-1]^this.s&this.DM)}function A(t,e){var n;for(n=this.t-1;n>=0;--n)e[n+t]=this[n];for(n=t-1;n>=0;--n)e[n]=0;e.t=this.t+t,e.s=this.s}function C(t,e){for(var n=t;n<this.t;++n)e[n-t]=this[n];e.t=Math.max(this.t-t,0),e.s=this.s}function N(t,e){var n,i=t%this.DB,o=this.DB-i,r=(1<<o)-1,s=Math.floor(t/this.DB),a=this.s<<i&this.DM;for(n=this.t-1;n>=0;--n)e[n+s+1]=this[n]>>o|a,a=(this[n]&r)<<i;for(n=s-1;n>=0;--n)e[n]=0;e[s]=a,e.t=this.t+s+1,e.s=this.s,e.clamp()}function T(t,e){e.s=this.s;var n=Math.floor(t/this.DB);if(n>=this.t)return void(e.t=0);var i=t%this.DB,o=this.DB-i,r=(1<<i)-1;e[0]=this[n]>>i;for(var s=n+1;s<this.t;++s)e[s-n-1]|=(this[s]&r)<<o,e[s-n]=this[s]>>i;i>0&&(e[this.t-n-1]|=(this.s&r)<<o),e.t=this.t-n,e.clamp()}function I(t,e){for(var n=0,i=0,o=Math.min(t.t,this.t);o>n;)i+=this[n]-t[n],e[n++]=i&this.DM,i>>=this.DB;if(t.t<this.t){for(i-=t.s;n<this.t;)i+=this[n],e[n++]=i&this.DM,i>>=this.DB;i+=this.s}else{for(i+=this.s;n<t.t;)i-=t[n],e[n++]=i&this.DM,i>>=this.DB;i-=t.s}e.s=0>i?-1:0,-1>i?e[n++]=this.DV+i:i>0&&(e[n++]=i),e.t=n,e.clamp()}function S(t,e){var n=this.abs(),i=t.abs(),o=n.t;for(e.t=o+i.t;--o>=0;)e[o]=0;for(o=0;o<i.t;++o)e[o+n.t]=n.am(0,i[o],e,o,0,n.t);e.s=0,e.clamp(),this.s!=t.s&&r.ZERO.subTo(e,e)}function x(t){for(var e=this.abs(),n=t.t=2*e.t;--n>=0;)t[n]=0;for(n=0;n<e.t-1;++n){var i=e.am(n,e[n],t,2*n,0,1);(t[n+e.t]+=e.am(n+1,2*e[n],t,2*n+1,i,e.t-n-1))>=e.DV&&(t[n+e.t]-=e.DV,t[n+e.t+1]=1)}t.t>0&&(t[t.t-1]+=e.am(n,e[n],t,2*n,0,1)),t.s=0,t.clamp()}function P(t,e,n){var i=t.abs();if(!(i.t<=0)){var o=this.abs();if(o.t<i.t)return null!=e&&e.fromInt(0),void(null!=n&&this.copyTo(n));null==n&&(n=s());var a=s(),c=this.s,u=t.s,l=this.DB-E(i[i.t-1]);l>0?(i.lShiftTo(l,a),o.lShiftTo(l,n)):(i.copyTo(a),o.copyTo(n));var h=a.t,p=a[h-1];if(0!=p){var d=p*(1<<this.F1)+(h>1?a[h-2]>>this.F2:0),f=this.FV/d,m=(1<<this.F1)/d,y=1<<this.F2,g=n.t,v=g-h,_=null==e?s():e;for(a.dlShiftTo(v,_),n.compareTo(_)>=0&&(n[n.t++]=1,n.subTo(_,n)),r.ONE.dlShiftTo(h,_),_.subTo(a,a);a.t<h;)a[a.t++]=0;for(;--v>=0;){var b=n[--g]==p?this.DM:Math.floor(n[g]*f+(n[g-1]+y)*m);if((n[g]+=a.am(0,b,n,v,0,h))<b)for(a.dlShiftTo(v,_),n.subTo(_,n);n[g]<--b;)n.subTo(_,n)}null!=e&&(n.drShiftTo(h,e),c!=u&&r.ZERO.subTo(e,e)),n.t=h,n.clamp(),l>0&&n.rShiftTo(l,n),0>c&&r.ZERO.subTo(n,n)}}}function O(t){var e=s();return this.abs().divRemTo(t,null,e),this.s<0&&e.compareTo(r.ZERO)>0&&t.subTo(e,e),e}function R(t){this.m=t}function D(t){return t.s<0||t.compareTo(this.m)>=0?t.mod(this.m):t}function M(t){return t}function U(t){t.divRemTo(this.m,null,t)}function L(t,e,n){t.multiplyTo(e,n),this.reduce(n)}function F(t,e){t.squareTo(e),this.reduce(e)}function k(){if(this.t<1)return 0;var t=this[0];if(0==(1&t))return 0;var e=3&t;return e=e*(2-(15&t)*e)&15,e=e*(2-(255&t)*e)&255,e=e*(2-((65535&t)*e&65535))&65535,e=e*(2-t*e%this.DV)%this.DV,e>0?this.DV-e:-e}function B(t){this.m=t,this.mp=t.invDigit(),this.mpl=32767&this.mp,this.mph=this.mp>>15,this.um=(1<<t.DB-15)-1,this.mt2=2*t.t}function j(t){var e=s();return t.abs().dlShiftTo(this.m.t,e),e.divRemTo(this.m,null,e),t.s<0&&e.compareTo(r.ZERO)>0&&this.m.subTo(e,e),e}function V(t){var e=s();return t.copyTo(e),this.reduce(e),e}function H(t){for(;t.t<=this.mt2;)t[t.t++]=0;for(var e=0;e<this.m.t;++e){var n=32767&t[e],i=n*this.mpl+((n*this.mph+(t[e]>>15)*this.mpl&this.um)<<15)&t.DM;for(n=e+this.m.t,t[n]+=this.m.am(0,i,t,e,0,this.m.t);t[n]>=t.DV;)t[n]-=t.DV,t[++n]++}t.clamp(),t.drShiftTo(this.m.t,t),t.compareTo(this.m)>=0&&t.subTo(this.m,t)}function z(t,e){t.squareTo(e),this.reduce(e)}function Y(t,e,n){t.multiplyTo(e,n),this.reduce(n)}function G(){return 0==(this.t>0?1&this[0]:this.s)}function W(t,e){if(t>4294967295||1>t)return r.ONE;var n=s(),i=s(),o=e.convert(this),a=E(t)-1;for(o.copyTo(n);--a>=0;)if(e.sqrTo(n,i),(t&1<<a)>0)e.mulTo(i,o,n);else{var c=n;n=i,i=c}return e.revert(n)}function q(t,e){var n;return n=256>t||e.isEven()?new R(e):new B(e),this.exp(t,n)}function K(t,e){return new r(t,e)}function Q(t,e){if(e<t.length+11)throw new Error("Message too long for RSA");for(var n=new Array,i=t.length-1;i>=0&&e>0;){var o=t.charCodeAt(i--);128>o?n[--e]=o:o>127&&2048>o?(n[--e]=63&o|128,n[--e]=o>>6|192):(n[--e]=63&o|128,n[--e]=o>>6&63|128,n[--e]=o>>12|224)}n[--e]=0;for(var s=0,a=0,c=0;e>2;)0==c&&(a=lt.random.randomWords(1,0)[0]),s=a>>c&255,c=(c+8)%32,0!=s&&(n[--e]=s);return n[--e]=2,n[--e]=0,new r(n)}function Z(){this.n=null,this.e=0,this.d=null,this.p=null,this.q=null,this.dmp1=null,this.dmq1=null,this.coeff=null}function $(t,e){if(!(null!=t&&null!=e&&t.length>0&&e.length>0))throw new Error("Invalid RSA public key");this.n=K(t,16),this.e=parseInt(e,16)}function X(t){return t.modPowInt(this.e,this.n)}function J(t){var e=Q(t,this.n.bitLength()+7>>3);if(null==e)return null;var n=this.doPublic(e);if(null==n)return null;var i=n.toString(16);return 0==(1&i.length)?i:"0"+i}t.prototype.get=function(t){if(void 0==t&&(t=this.pos++),t>=this.enc.length)throw"Requesting byte offset "+t+" on a stream of length "+this.enc.length;return this.enc[t]},t.prototype.hexDigits="0123456789ABCDEF",t.prototype.hexByte=function(t){return this.hexDigits.charAt(t>>4&15)+this.hexDigits.charAt(15&t)},t.prototype.hexDump=function(t,e){for(var n="",i=t;e>i;++i)switch(n+=this.hexByte(this.get(i)),15&i){case 7:n+="  ";break;case 15:n+="\n";break;default:n+=" "}return n},t.prototype.parseStringISO=function(t,e){for(var n="",i=t;e>i;++i)n+=String.fromCharCode(this.get(i));return n},t.prototype.parseStringUTF=function(t,e){for(var n="",i=0,o=t;e>o;){var i=this.get(o++);n+=String.fromCharCode(128>i?i:i>191&&224>i?(31&i)<<6|63&this.get(o++):(15&i)<<12|(63&this.get(o++))<<6|63&this.get(o++))}return n},t.prototype.reTime=/^((?:1[89]|2\d)?\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/,t.prototype.parseTime=function(t,e){var n=this.parseStringISO(t,e),i=this.reTime.exec(n);return i?(n=i[1]+"-"+i[2]+"-"+i[3]+" "+i[4],i[5]&&(n+=":"+i[5],i[6]&&(n+=":"+i[6],i[7]&&(n+="."+i[7]))),i[8]&&(n+=" UTC","Z"!=i[8]&&(n+=i[8],i[9]&&(n+=":"+i[9]))),n):"Unrecognized time: "+n},t.prototype.parseInteger=function(t,e){var n=e-t;if(n>4){n<<=3;var i=this.get(t);if(0==i)n-=8;else for(;128>i;)i<<=1,--n;return"("+n+" bit)"}for(var o=0,r=t;e>r;++r)o=o<<8|this.get(r);return o},t.prototype.parseBitString=function(t,e){var n=this.get(t),i=(e-t-1<<3)-n,o="("+i+" bit)";if(20>=i){var r=n;o+=" ";for(var s=e-1;s>t;--s){for(var a=this.get(s),c=r;8>c;++c)o+=a>>c&1?"1":"0";r=0}}return o},t.prototype.parseOctetString=function(t,e){var n=e-t,i="("+n+" byte) ";n>20&&(e=t+20);for(var o=t;e>o;++o)i+=this.hexByte(this.get(o));return n>20&&(i+=String.fromCharCode(8230)),i},t.prototype.parseOID=function(t,e){for(var n,i=0,o=0,r=t;e>r;++r){var s=this.get(r);i=i<<7|127&s,o+=7,128&s||(void 0==n?n=parseInt(i/40)+"."+i%40:n+="."+(o>=31?"bigint":i),i=o=0),n+=String.fromCharCode()}return n},e.prototype.typeName=function(){if(void 0==this.tag)return"unknown";var t=this.tag>>6,e=(this.tag>>5&1,31&this.tag);switch(t){case 0:switch(e){case 0:return"EOC";case 1:return"BOOLEAN";case 2:return"INTEGER";case 3:return"BIT_STRING";case 4:return"OCTET_STRING";case 5:return"NULL";case 6:return"OBJECT_IDENTIFIER";case 7:return"ObjectDescriptor";case 8:return"EXTERNAL";case 9:return"REAL";case 10:return"ENUMERATED";case 11:return"EMBEDDED_PDV";case 12:return"UTF8String";case 16:return"SEQUENCE";case 17:return"SET";case 18:return"NumericString";case 19:return"PrintableString";case 20:return"TeletexString";case 21:return"VideotexString";case 22:return"IA5String";case 23:return"UTCTime";case 24:return"GeneralizedTime";case 25:return"GraphicString";case 26:return"VisibleString";case 27:return"GeneralString";case 28:return"UniversalString";case 30:return"BMPString";default:return"Universal_"+e.toString(16)}case 1:return"Application_"+e.toString(16);case 2:return"["+e+"]";case 3:return"Private_"+e.toString(16)}},e.prototype.content=function(){if(void 0==this.tag)return null;var t=this.tag>>6;if(0!=t)return null==this.sub?null:"("+this.sub.length+")";var e=31&this.tag,n=this.posContent(),i=Math.abs(this.length);switch(e){case 1:return 0==this.stream.get(n)?"false":"true";case 2:return this.stream.parseInteger(n,n+i);case 3:return this.sub?"("+this.sub.length+" elem)":this.stream.parseBitString(n,n+i);case 4:return this.sub?"("+this.sub.length+" elem)":this.stream.parseOctetString(n,n+i);case 6:return this.stream.parseOID(n,n+i);case 16:case 17:return"("+this.sub.length+" elem)";case 12:return this.stream.parseStringUTF(n,n+i);case 18:case 19:case 20:case 21:case 22:case 26:return this.stream.parseStringISO(n,n+i);case 23:case 24:return this.stream.parseTime(n,n+i)}return null},e.prototype.toString=function(){return this.typeName()+"@"+this.stream.pos+"[header:"+this.header+",length:"+this.length+",sub:"+(null==this.sub?"null":this.sub.length)+"]"},e.prototype.print=function(t){if(void 0==t&&(t=""),document.writeln(t+this),null!=this.sub){t+="  ";for(var e=0,n=this.sub.length;n>e;++e)this.sub[e].print(t)}},e.prototype.toPrettyString=function(t){void 0==t&&(t="");var e=t+this.typeName()+" @"+this.stream.pos;if(this.length>=0&&(e+="+"),e+=this.length,32&this.tag?e+=" (constructed)":3!=this.tag&&4!=this.tag||null==this.sub||(e+=" (encapsulates)"),e+="\n",null!=this.sub){t+="  ";for(var n=0,i=this.sub.length;i>n;++n)e+=this.sub[n].toPrettyString(t)}return e},e.prototype.posStart=function(){return this.stream.pos},e.prototype.posContent=function(){return this.stream.pos+this.header},e.prototype.posEnd=function(){return this.stream.pos+this.header+Math.abs(this.length)},e.decodeLength=function(t){var e=t.get(),n=127&e;if(n==e)return n;if(n>3)throw"Length over 24 bits not supported at position "+(t.pos-1);if(0==n)return-1;e=0;for(var i=0;n>i;++i)e=e<<8|t.get();return e},e.hasContent=function(n,i,o){if(32&n)return!0;if(3>n||n>4)return!1;var r=new t(o);3==n&&r.get();var s=r.get();if(s>>6&1)return!1;try{var a=e.decodeLength(r);return r.pos-o.pos+a==i}catch(c){return!1}},e.decode=function(n){n instanceof t||(n=new t(n,0));var i=new t(n),o=n.get(),r=e.decodeLength(n),s=n.pos-i.pos,a=null;if(e.hasContent(o,r,n)){var c=n.pos;if(3==o&&n.get(),a=[],r>=0){for(var u=c+r;n.pos<u;)a[a.length]=e.decode(n);if(n.pos!=u)throw"Content size is not correct for container starting at offset "+c}else try{for(;;){var l=e.decode(n);if(0==l.tag)break;a[a.length]=l}r=c-n.pos}catch(h){throw"Exception while decoding undefined length content: "+h}}else n.pos+=r;return new e(i,s,r,o,a)};var tt,et="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",nt="=",it=0xdeadbeefcafe,ot=15715070==(16777215&it);ot&&"Microsoft Internet Explorer"==navigator.appName?(r.prototype.am=c,tt=30):ot&&"Netscape"!=navigator.appName?(r.prototype.am=a,tt=26):(r.prototype.am=u,tt=28),r.prototype.DB=tt,r.prototype.DM=(1<<tt)-1,r.prototype.DV=1<<tt;var rt=52;r.prototype.FV=Math.pow(2,rt),r.prototype.F1=rt-tt,r.prototype.F2=2*tt-rt;var st,at,ct="0123456789abcdefghijklmnopqrstuvwxyz",ut=new Array;for(st="0".charCodeAt(0),at=0;9>=at;++at)ut[st++]=at;for(st="a".charCodeAt(0),at=10;36>at;++at)ut[st++]=at;for(st="A".charCodeAt(0),at=10;36>at;++at)ut[st++]=at;R.prototype.convert=D,R.prototype.revert=M,R.prototype.reduce=U,R.prototype.mulTo=L,R.prototype.sqrTo=F,B.prototype.convert=j,B.prototype.revert=V,B.prototype.reduce=H,B.prototype.mulTo=Y,B.prototype.sqrTo=z,r.prototype.copyTo=p,r.prototype.fromInt=d,r.prototype.fromString=m,r.prototype.clamp=y,r.prototype.dlShiftTo=A,r.prototype.drShiftTo=C,r.prototype.lShiftTo=N,r.prototype.rShiftTo=T,r.prototype.subTo=I,r.prototype.multiplyTo=S,r.prototype.squareTo=x,r.prototype.divRemTo=P,r.prototype.invDigit=k,r.prototype.isEven=G,r.prototype.exp=W,r.prototype.toString=g,r.prototype.negate=v,r.prototype.abs=_,r.prototype.compareTo=b,r.prototype.bitLength=w,r.prototype.mod=O,r.prototype.modPowInt=q,r.ZERO=f(0),r.ONE=f(1),Z.prototype.doPublic=X,Z.prototype.setPublic=$,Z.prototype.encrypt=J;var lt={cipher:{},hash:{},keyexchange:{},mode:{},misc:{},codec:{},exception:{corrupt:function(t){this.toString=function(){return"CORRUPT: "+this.message},this.message=t},invalid:function(t){this.toString=function(){return"INVALID: "+this.message},this.message=t},bug:function(t){this.toString=function(){return"BUG: "+this.message},this.message=t},notReady:function(t){this.toString=function(){return"NOT READY: "+this.message},this.message=t}}};"undefined"!=typeof module&&module.exports&&(module.exports=lt),lt.cipher.aes=function(t){this._tables[0][0][0]||this._precompute();var e,n,i,o,r,s=this._tables[0][4],a=this._tables[1],c=t.length,u=1;if(4!==c&&6!==c&&8!==c)throw new lt.exception.invalid("invalid aes key size");for(this._key=[o=t.slice(0),r=[]],e=c;4*c+28>e;e++)i=o[e-1],(e%c===0||8===c&&e%c===4)&&(i=s[i>>>24]<<24^s[i>>16&255]<<16^s[i>>8&255]<<8^s[255&i],e%c===0&&(i=i<<8^i>>>24^u<<24,u=u<<1^283*(u>>7))),o[e]=o[e-c]^i;for(n=0;e;n++,e--)i=o[3&n?e:e-4],r[n]=4>=e||4>n?i:a[0][s[i>>>24]]^a[1][s[i>>16&255]]^a[2][s[i>>8&255]]^a[3][s[255&i]]},lt.cipher.aes.prototype={encrypt:function(t){return this._crypt(t,0)},decrypt:function(t){return this._crypt(t,1)},_tables:[[[],[],[],[],[]],[[],[],[],[],[]]],_precompute:function(){var t,e,n,i,o,r,s,a,c,u=this._tables[0],l=this._tables[1],h=u[4],p=l[4],d=[],f=[];for(t=0;256>t;t++)f[(d[t]=t<<1^283*(t>>7))^t]=t;for(e=n=0;!h[e];e^=i||1,n=f[n]||1)for(s=n^n<<1^n<<2^n<<3^n<<4,s=s>>8^255&s^99,h[e]=s,p[s]=e,r=d[o=d[i=d[e]]],c=16843009*r^65537*o^257*i^16843008*e,a=257*d[s]^16843008*s,t=0;4>t;t++)u[t][e]=a=a<<24^a>>>8,l[t][s]=c=c<<24^c>>>8;for(t=0;5>t;t++)u[t]=u[t].slice(0),l[t]=l[t].slice(0)},_crypt:function(t,e){if(4!==t.length)throw new lt.exception.invalid("invalid aes block size");var n,i,o,r,s=this._key[e],a=t[0]^s[0],c=t[e?3:1]^s[1],u=t[2]^s[2],l=t[e?1:3]^s[3],h=s.length/4-2,p=4,d=[0,0,0,0],f=this._tables[e],m=f[0],y=f[1],g=f[2],v=f[3],_=f[4];for(r=0;h>r;r++)n=m[a>>>24]^y[c>>16&255]^g[u>>8&255]^v[255&l]^s[p],i=m[c>>>24]^y[u>>16&255]^g[l>>8&255]^v[255&a]^s[p+1],o=m[u>>>24]^y[l>>16&255]^g[a>>8&255]^v[255&c]^s[p+2],l=m[l>>>24]^y[a>>16&255]^g[c>>8&255]^v[255&u]^s[p+3],p+=4,a=n,c=i,u=o;for(r=0;4>r;r++)d[e?3&-r:r]=_[a>>>24]<<24^_[c>>16&255]<<16^_[u>>8&255]<<8^_[255&l]^s[p++],n=a,a=c,c=u,u=l,l=n;return d}},lt.bitArray={bitSlice:function(t,e,n){return t=lt.bitArray._shiftRight(t.slice(e/32),32-(31&e)).slice(1),void 0===n?t:lt.bitArray.clamp(t,n-e)},extract:function(t,e,n){var i,o=Math.floor(-e-n&31);return i=-32&(e+n-1^e)?t[e/32|0]<<32-o^t[e/32+1|0]>>>o:t[e/32|0]>>>o,i&(1<<n)-1},concat:function(t,e){if(0===t.length||0===e.length)return t.concat(e);var n=t[t.length-1],i=lt.bitArray.getPartial(n);return 32===i?t.concat(e):lt.bitArray._shiftRight(e,i,0|n,t.slice(0,t.length-1))},bitLength:function(t){var e,n=t.length;return 0===n?0:(e=t[n-1],32*(n-1)+lt.bitArray.getPartial(e))},clamp:function(t,e){if(32*t.length<e)return t;t=t.slice(0,Math.ceil(e/32));var n=t.length;return e=31&e,n>0&&e&&(t[n-1]=lt.bitArray.partial(e,t[n-1]&2147483648>>e-1,1)),t},partial:function(t,e,n){return 32===t?e:(n?0|e:e<<32-t)+1099511627776*t},getPartial:function(t){return Math.round(t/1099511627776)||32},equal:function(t,e){if(lt.bitArray.bitLength(t)!==lt.bitArray.bitLength(e))return!1;var n,i=0;for(n=0;n<t.length;n++)i|=t[n]^e[n];return 0===i},_shiftRight:function(t,e,n,i){var o,r,s=0;for(void 0===i&&(i=[]);e>=32;e-=32)i.push(n),n=0;if(0===e)return i.concat(t);for(o=0;o<t.length;o++)i.push(n|t[o]>>>e),n=t[o]<<32-e;return s=t.length?t[t.length-1]:0,r=lt.bitArray.getPartial(s),i.push(lt.bitArray.partial(e+r&31,e+r>32?n:i.pop(),1)),i},_xor4:function(t,e){return[t[0]^e[0],t[1]^e[1],t[2]^e[2],t[3]^e[3]]}},lt.codec.hex={fromBits:function(t){var e,n="";for(e=0;e<t.length;e++)n+=((0|t[e])+0xf00000000000).toString(16).substr(4);return n.substr(0,lt.bitArray.bitLength(t)/4)},toBits:function(t){var e,n,i=[];for(t=t.replace(/\s|0x/g,""),n=t.length,t+="00000000",e=0;e<t.length;e+=8)i.push(0^parseInt(t.substr(e,8),16));return lt.bitArray.clamp(i,4*n)}},lt.codec.utf8String={fromBits:function(t){var e,n,i="",o=lt.bitArray.bitLength(t);for(e=0;o/8>e;e++)0===(3&e)&&(n=t[e/4]),i+=String.fromCharCode(n>>>24),n<<=8;return decodeURIComponent(escape(i))},toBits:function(t){t=unescape(encodeURIComponent(t));var e,n=[],i=0;for(e=0;e<t.length;e++)i=i<<8|t.charCodeAt(e),3===(3&e)&&(n.push(i),i=0);return 3&e&&n.push(lt.bitArray.partial(8*(3&e),i)),n}},lt.codec.base64={_chars:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",fromBits:function(t,e,n){var i,o="",r=0,s=lt.codec.base64._chars,a=0,c=lt.bitArray.bitLength(t);for(n&&(s=s.substr(0,62)+"-_"),i=0;6*o.length<c;)o+=s.charAt((a^t[i]>>>r)>>>26),6>r?(a=t[i]<<6-r,r+=26,i++):(a<<=6,r-=6);for(;3&o.length&&!e;)o+="=";return o},toBits:function(t,e){t=t.replace(/\s|=/g,"");var n,i,o=[],r=0,s=lt.codec.base64._chars,a=0;for(e&&(s=s.substr(0,62)+"-_"),n=0;n<t.length;n++){if(i=s.indexOf(t.charAt(n)),0>i)throw new lt.exception.invalid("this isn't base64!");r>26?(r-=26,o.push(a^i>>>r),a=i<<32-r):(r+=6,a^=i<<32-r)}return 56&r&&o.push(lt.bitArray.partial(56&r,a,1)),o}},lt.codec.base64url={fromBits:function(t){return lt.codec.base64.fromBits(t,1,1)},toBits:function(t){return lt.codec.base64.toBits(t,1)}},void 0===lt.beware&&(lt.beware={}),lt.beware["CBC mode is dangerous because it doesn't protect message integrity."]=function(){lt.mode.cbc={name:"cbc",encrypt:function(t,e,n,i){if(i&&i.length)throw new lt.exception.invalid("cbc can't authenticate data");if(128!==lt.bitArray.bitLength(n))throw new lt.exception.invalid("cbc iv must be 128 bits");var o,r=lt.bitArray,s=r._xor4,a=r.bitLength(e),c=0,u=[];if(7&a)throw new lt.exception.invalid("pkcs#5 padding only works for multiples of a byte");for(o=0;a>=c+128;o+=4,c+=128)n=t.encrypt(s(n,e.slice(o,o+4))),u.splice(o,0,n[0],n[1],n[2],n[3]);return a=16843009*(16-(a>>3&15)),n=t.encrypt(s(n,r.concat(e,[a,a,a,a]).slice(o,o+4))),u.splice(o,0,n[0],n[1],n[2],n[3]),u},decrypt:function(t,e,n,i){if(i&&i.length)throw new lt.exception.invalid("cbc can't authenticate data");if(128!==lt.bitArray.bitLength(n))throw new lt.exception.invalid("cbc iv must be 128 bits");if(127&lt.bitArray.bitLength(e)||!e.length)throw new lt.exception.corrupt("cbc ciphertext must be a positive multiple of the block size");var o,r,s,a=lt.bitArray,c=a._xor4,u=[];for(i=i||[],o=0;o<e.length;o+=4)r=e.slice(o,o+4),s=c(n,t.decrypt(r)),u.splice(o,0,s[0],s[1],s[2],s[3]),n=r;if(r=255&u[o-1],0==r||r>16)throw new lt.exception.corrupt("pkcs#5 padding corrupt");if(s=16843009*r,!a.equal(a.bitSlice([s,s,s,s],0,8*r),a.bitSlice(u,32*u.length-8*r,32*u.length)))throw new lt.exception.corrupt("pkcs#5 padding corrupt");return a.bitSlice(u,0,32*u.length-8*r)}}},lt.misc.hmac=function(t,e){this._hash=e=e||lt.hash.sha256;var n,i=[[],[]],o=e.prototype.blockSize/32;for(this._baseHash=[new e,new e],t.length>o&&(t=e.hash(t)),n=0;o>n;n++)i[0][n]=909522486^t[n],i[1][n]=1549556828^t[n];this._baseHash[0].update(i[0]),this._baseHash[1].update(i[1])},lt.misc.hmac.prototype.encrypt=lt.misc.hmac.prototype.mac=function(t,e){var n=new this._hash(this._baseHash[0]).update(t,e).finalize();return new this._hash(this._baseHash[1]).update(n).finalize()},lt.hash.sha256=function(t){this._key[0]||this._precompute(),t?(this._h=t._h.slice(0),this._buffer=t._buffer.slice(0),this._length=t._length):this.reset()},lt.hash.sha256.hash=function(t){return(new lt.hash.sha256).update(t).finalize()},lt.hash.sha256.prototype={blockSize:512,reset:function(){return this._h=this._init.slice(0),this._buffer=[],this._length=0,this},update:function(t){"string"==typeof t&&(t=lt.codec.utf8String.toBits(t));var e,n=this._buffer=lt.bitArray.concat(this._buffer,t),i=this._length,o=this._length=i+lt.bitArray.bitLength(t);for(e=512+i&-512;o>=e;e+=512)this._block(n.splice(0,16));return this},finalize:function(){var t,e=this._buffer,n=this._h;for(e=lt.bitArray.concat(e,[lt.bitArray.partial(1,1)]),t=e.length+2;15&t;t++)e.push(0);for(e.push(Math.floor(this._length/4294967296)),e.push(0|this._length);e.length;)this._block(e.splice(0,16));return this.reset(),n},_init:[],_key:[],_precompute:function(){function t(t){return 4294967296*(t-Math.floor(t))|0}var e,n=0,i=2;t:for(;64>n;i++){for(e=2;i>=e*e;e++)if(i%e===0)continue t;8>n&&(this._init[n]=t(Math.pow(i,.5))),this._key[n]=t(Math.pow(i,1/3)),n++}},_block:function(t){var e,n,i,o,r=t.slice(0),s=this._h,a=this._key,c=s[0],u=s[1],l=s[2],h=s[3],p=s[4],d=s[5],f=s[6],m=s[7];for(e=0;64>e;e++)16>e?n=r[e]:(i=r[e+1&15],o=r[e+14&15],n=r[15&e]=(i>>>7^i>>>18^i>>>3^i<<25^i<<14)+(o>>>17^o>>>19^o>>>10^o<<15^o<<13)+r[15&e]+r[e+9&15]|0),n=n+m+(p>>>6^p>>>11^p>>>25^p<<26^p<<21^p<<7)+(f^p&(d^f))+a[e],m=f,f=d,d=p,p=h+n|0,h=l,l=u,u=c,c=n+(u&l^h&(u^l))+(u>>>2^u>>>13^u>>>22^u<<30^u<<19^u<<10)|0;s[0]=s[0]+c|0,s[1]=s[1]+u|0,s[2]=s[2]+l|0,s[3]=s[3]+h|0,s[4]=s[4]+p|0,s[5]=s[5]+d|0,s[6]=s[6]+f|0,s[7]=s[7]+m|0}},lt.random={randomWords:function(t,e){var n,i,o=[],r=this.isReady(e);if(r===this._NOT_READY)throw new lt.exception.notReady("generator isn't seeded");for(r&this._REQUIRES_RESEED&&this._reseedFromPools(!(r&this._READY)),n=0;t>n;n+=4)(n+1)%this._MAX_WORDS_PER_BURST===0&&this._gate(),i=this._gen4words(),o.push(i[0],i[1],i[2],i[3]);return this._gate(),o.slice(0,t)},setDefaultParanoia:function(t){this._defaultParanoia=t},addEntropy:function(t,e,n){n=n||"user";var i,o,r,s=(new Date).valueOf(),a=this._robins[n],c=this.isReady(),u=0;switch(i=this._collectorIds[n],void 0===i&&(i=this._collectorIds[n]=this._collectorIdNext++),void 0===a&&(a=this._robins[n]=0),this._robins[n]=(this._robins[n]+1)%this._pools.length,typeof t){case"number":void 0===e&&(e=1),this._pools[a].update([i,this._eventId++,1,e,s,1,0|t]);break;case"object":var l=Object.prototype.toString.call(t);if("[object Uint32Array]"===l){for(r=[],o=0;o<t.length;o++)r.push(t[o]);t=r}else for("[object Array]"!==l&&(u=1),o=0;o<t.length&&!u;o++)"number"!=typeof t[o]&&(u=1);if(!u){if(void 0===e)for(e=0,o=0;o<t.length;o++)for(r=t[o];r>0;)e++,r>>>=1;this._pools[a].update([i,this._eventId++,2,e,s,t.length].concat(t))}break;case"string":void 0===e&&(e=t.length),this._pools[a].update([i,this._eventId++,3,e,s,t.length]),this._pools[a].update(t);break;default:u=1}if(u)throw new lt.exception.bug("random: addEntropy only supports number, array of numbers or string");this._poolEntropy[a]+=e,this._poolStrength+=e,c===this._NOT_READY&&(this.isReady()!==this._NOT_READY&&this._fireEvent("seeded",Math.max(this._strength,this._poolStrength)),this._fireEvent("progress",this.getProgress()))},isReady:function(t){var e=this._PARANOIA_LEVELS[void 0!==t?t:this._defaultParanoia];return this._strength&&this._strength>=e?this._poolEntropy[0]>this._BITS_PER_RESEED&&(new Date).valueOf()>this._nextReseed?this._REQUIRES_RESEED|this._READY:this._READY:this._poolStrength>=e?this._REQUIRES_RESEED|this._NOT_READY:this._NOT_READY},getProgress:function(t){var e=this._PARANOIA_LEVELS[t?t:this._defaultParanoia];return this._strength>=e?1:this._poolStrength>e?1:this._poolStrength/e},startCollectors:function(){if(!this._collectorsStarted){if(window.addEventListener)window.addEventListener("load",this._loadTimeCollector,!1),window.addEventListener("mousemove",this._mouseCollector,!1);else{if(!document.attachEvent)throw new lt.exception.bug("can't attach event");document.attachEvent("onload",this._loadTimeCollector),document.attachEvent("onmousemove",this._mouseCollector)}this._collectorsStarted=!0}},stopCollectors:function(){this._collectorsStarted&&(window.removeEventListener?(window.removeEventListener("load",this._loadTimeCollector,!1),window.removeEventListener("mousemove",this._mouseCollector,!1)):window.detachEvent&&(window.detachEvent("onload",this._loadTimeCollector),window.detachEvent("onmousemove",this._mouseCollector)),this._collectorsStarted=!1)},addEventListener:function(t,e){this._callbacks[t][this._callbackI++]=e},removeEventListener:function(t,e){var n,i,o=this._callbacks[t],r=[];for(i in o)o.hasOwnProperty(i)&&o[i]===e&&r.push(i);for(n=0;n<r.length;n++)i=r[n],delete o[i]},_pools:[new lt.hash.sha256],_poolEntropy:[0],_reseedCount:0,_robins:{},_eventId:0,_collectorIds:{},_collectorIdNext:0,_strength:0,_poolStrength:0,_nextReseed:0,_key:[0,0,0,0,0,0,0,0],_counter:[0,0,0,0],_cipher:void 0,_defaultParanoia:6,_collectorsStarted:!1,_callbacks:{progress:{},seeded:{}},_callbackI:0,_NOT_READY:0,_READY:1,_REQUIRES_RESEED:2,_MAX_WORDS_PER_BURST:65536,_PARANOIA_LEVELS:[0,48,64,96,128,192,256,384,512,768,1024],_MILLISECONDS_PER_RESEED:3e4,_BITS_PER_RESEED:80,_gen4words:function(){for(var t=0;4>t&&(this._counter[t]=this._counter[t]+1|0,!this._counter[t]);t++);return this._cipher.encrypt(this._counter)},_gate:function(){this._key=this._gen4words().concat(this._gen4words()),this._cipher=new lt.cipher.aes(this._key)},_reseed:function(t){this._key=lt.hash.sha256.hash(this._key.concat(t)),this._cipher=new lt.cipher.aes(this._key);for(var e=0;4>e&&(this._counter[e]=this._counter[e]+1|0,!this._counter[e]);e++);},_reseedFromPools:function(t){var e,n=[],i=0;for(this._nextReseed=n[0]=(new Date).valueOf()+this._MILLISECONDS_PER_RESEED,e=0;16>e;e++)n.push(4294967296*Math.random()|0);for(e=0;e<this._pools.length&&(n=n.concat(this._pools[e].finalize()),i+=this._poolEntropy[e],this._poolEntropy[e]=0,t||!(this._reseedCount&1<<e));e++);this._reseedCount>=1<<this._pools.length&&(this._pools.push(new lt.hash.sha256),this._poolEntropy.push(0)),this._poolStrength-=i,i>this._strength&&(this._strength=i),this._reseedCount++,this._reseed(n)},_mouseCollector:function(t){var e=t.x||t.clientX||t.offsetX||0,n=t.y||t.clientY||t.offsetY||0;lt.random.addEntropy([e,n],2,"mouse")},_loadTimeCollector:function(t){lt.random.addEntropy((new Date).valueOf(),2,"loadtime")},_fireEvent:function(t,e){var n,i=lt.random._callbacks[t],o=[];for(n in i)i.hasOwnProperty(n)&&o.push(i[n]);for(n=0;n<o.length;n++)o[n](e)}},function(){try{var t=new Uint32Array(32);crypto.getRandomValues(t),lt.random.addEntropy(t,1024,"crypto.getRandomValues")}catch(e){}}(),function(){for(var t in lt.beware)lt.beware.hasOwnProperty(t)&&lt.beware[t]()}();var ht={sjcl:lt,version:"1.3.10"};ht.generateAesKey=function(){return{key:lt.random.randomWords(8,0),encrypt:function(t){return this.encryptWithIv(t,lt.random.randomWords(4,0))},encryptWithIv:function(t,e){var n=new lt.cipher.aes(this.key),i=lt.codec.utf8String.toBits(t),o=lt.mode.cbc.encrypt(n,i,e),r=lt.bitArray.concat(e,o);return lt.codec.base64.fromBits(r)}}},ht.create=function(t){return new ht.EncryptionClient(t)},ht.EncryptionClient=function(t){var i=this,r=[];i.publicKey=t,i.version=ht.version;var s=function(t,e){var n,i,o;n=document.createElement(t);for(i in e)e.hasOwnProperty(i)&&(o=e[i],n.setAttribute(i,o));return n},a=function(t){return window.jQuery&&t instanceof jQuery?t[0]:t.nodeType&&1===t.nodeType?t:document.getElementById(t)},c=function(t){var e,n,i,o,r=[];if("INTEGER"===t.typeName()&&(e=t.posContent(),n=t.posEnd(),i=t.stream.hexDump(e,n).replace(/[ \n]/g,""),r.push(i)),null!==t.sub)for(o=0;o<t.sub.length;o++)r=r.concat(c(t.sub[o]));return r},u=function(t){var e,n,i=[],o=t.children;for(n=0;n<o.length;n++)e=o[n],1===e.nodeType&&e.attributes["data-encrypted-name"]?i.push(e):e.children&&e.children.length>0&&(i=i.concat(u(e)));return i},l=function(){var n,i,r,s,a,u;try{a=o(t),n=e.decode(a)}catch(l){throw"Invalid encryption key. Please use the key labeled 'Client-Side Encryption Key'"}if(r=c(n),2!==r.length)throw"Invalid encryption key. Please use the key labeled 'Client-Side Encryption Key'";return s=r[0],i=r[1],u=new Z,u.setPublic(s,i),u},h=function(){return{key:lt.random.randomWords(8,0),sign:function(t){var e=new lt.misc.hmac(this.key,lt.hash.sha256),n=e.encrypt(t);return lt.codec.base64.fromBits(n)}}};i.encrypt=function(t){var e=l(),o=ht.generateAesKey(),r=h(),s=o.encrypt(t),a=r.sign(lt.codec.base64.toBits(s)),c=lt.bitArray.concat(o.key,r.key),u=lt.codec.base64.fromBits(c),p=e.encrypt(u),d="$bt4|javascript_"+i.version.replace(/\./g,"_")+"$",f=null;return p&&(f=n(p)),d+f+"$"+s+"$"+a},i.encryptForm=function(t){var e,n,o,c,l,h;for(t=a(t),h=u(t);r.length>0;){try{t.removeChild(r[0])}catch(p){}r.splice(0,1)}for(l=0;l<h.length;l++)e=h[l],o=e.getAttribute("data-encrypted-name"),n=i.encrypt(e.value),e.removeAttribute("name"),c=s("input",{value:n,type:"hidden",name:o}),r.push(c),t.appendChild(c)},i.onSubmitEncryptForm=function(t,e){var n;t=a(t),n=function(n){return i.encryptForm(t),e?e(n):n},window.jQuery?window.jQuery(t).submit(n):t.addEventListener?t.addEventListener("submit",n,!1):t.attachEvent&&t.attachEvent("onsubmit",n)},i.formEncrypter={encryptForm:i.encryptForm,extractForm:a,onSubmitEncryptForm:i.onSubmitEncryptForm},lt.random.startCollectors()},window.Braintree=ht;

}(),function(t){if(true)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,e.braintree=t()}}(function(){var t;return function e(t,n,i){function o(s,a){if(!n[s]){if(!t[s]){var c="function"==typeof require&&require;if(!a&&c)return require(s,!0);if(r)return r(s,!0);var u=new Error("Cannot find module '"+s+"'");throw u.code="MODULE_NOT_FOUND",u}var l=n[s]={exports:{}};t[s][0].call(l.exports,function(e){var n=t[s][1][e];return o(n?n:e)},l,l.exports,e,t,n,i)}return n[s].exports}for(var r="function"==typeof require&&require,s=0;s<i.length;s++)o(i[s]);return o}({1:[function(t,e,n){(function(n){"use strict";function i(t){var e=t.analyticsConfiguration||{},i=n.braintree?n.braintree.VERSION:null,o=i?"braintree/web/"+i:"";return{sdkVersion:e.sdkVersion||o,merchantAppId:e.merchantAppId||n.location.host}}function o(t){var e=i(t);this.options=t,this.driver=t.driver||m({enableCORS:y(t)}),this.customerId=t.customerId,this.integration=t.integrationType||t.integration||"",this.sdkVersion=e.sdkVersion,this.merchantAppId=e.merchantAppId,this.sessionId=t.channel||_(),this.authorization=t.authorization||t.clientToken,c.isTokenizationKey(this.authorization)?(this.authorizationType=v.authorizationTypes.TOKENIZATION_KEY,this.gatewayConfiguration=t.gatewayConfiguration):(this.gatewayConfiguration=t.gatewayConfiguration||a(this.authorization),this.authorizationFingerprint=a(this.authorization).authorizationFingerprint,this.authorizationType=v.authorizationTypes.CLIENT_TOKEN),this.requestTimeout=t.hasOwnProperty("timeout")?t.timeout:6e4}var r=t(87),s=t(26),a=t(8),c=t(13),u=t(11),l=t(5),h=t(4),p=t(2),d=t(9),f=t(7).normalizeCreditCardFields,m=t(40).chooseDriver,y=t(12),g=t(6),v=t(3),_=t(49).uuid;o.prototype._getGatewayConfiguration=function(t){var e=this;return this.gatewayConfiguration?void t(null,this.gatewayConfiguration):void g({authorization:this.authorization,enableCORS:y(this.options)},function(n,i){return n?void t(n,null):(e.gatewayConfiguration=i,void t(null,i))})},o.prototype._getAttrs=function(t){var e={};return this.options.hasOwnProperty("sharedCustomerIdentifier")&&(e.sharedCustomerIdentifier=this.options.sharedCustomerIdentifier),e.sharedCustomerIdentifierType=this.options.sharedCustomerIdentifierType,e.braintreeLibraryVersion=this.sdkVersion,t.merchantAccountId&&(e.merchantAccountId=t.merchantAccountId),this.authorizationType===v.authorizationTypes.TOKENIZATION_KEY?e.clientKey=this.options.authorization:e.authorizationFingerprint=this.authorizationFingerprint,e._meta={sessionId:this.sessionId},e},o.prototype.getCreditCards=function(t){this._getGatewayConfiguration(r(function(e,n){return e?t(e):void this.driver.get(c.joinUrlFragments([n.clientApiUrl,"v1","payment_methods"]),this._getAttrs(n),function(t){var e=0,n=t.paymentMethods.length,i=[];for(e;n>e;e++)i.push(new h(t.paymentMethods[e]));return i},t,this.requestTimeout)},this))},o.prototype.tokenizeCoinbase=function(t,e){t.options={validate:!1},this.addCoinbase(t,function(t,n){t?e(t,null):n&&n.nonce?e(t,n):e("Unable to tokenize coinbase account.",null)})},o.prototype.tokenizePayPalAccount=function(t,e){t.options={validate:!1},this.addPayPalAccount(t,function(t,n){t?e(t,null):n&&n.nonce?e(null,n):e("Unable to tokenize paypal account.",null)})},o.prototype.tokenizeCard=function(t,e){t.options={validate:!1},this.addCreditCard(t,function(t,n){n&&n.nonce?e(t,n.nonce,{type:n.type,details:n.details}):e("Unable to tokenize card.",null)})},o.prototype.lookup3DS=function(t,e){this._getGatewayConfiguration(r(function(n,i){var o,r;return n?e(n):(o=c.joinUrlFragments([i.clientApiUrl,"v1/payment_methods",t.nonce,"three_d_secure/lookup"]),r=c.mergeOptions(this._getAttrs(i),{amount:t.amount}),void this.driver.post(o,r,function(t){return t},e,this.requestTimeout))},this))},o.prototype.createSEPAMandate=function(t,e){this._getGatewayConfiguration(r(function(n,i){var o;return n?e(n):(o=c.mergeOptions(this._getAttrs(i),{sepaMandate:t}),void this.driver.post(c.joinUrlFragments([i.clientApiUrl,"v1","sepa_mandates.json"]),o,function(t){return{sepaMandate:new u(t.europeBankAccounts[0].sepaMandates[0]),sepaBankAccount:new l(t.europeBankAccounts[0])}},e,this.requestTimeout))},this))},o.prototype.getSEPAMandate=function(t,e){this._getGatewayConfiguration(r(function(n,i){var o;return n?e(n):(o=c.mergeOptions(this._getAttrs(i),t),void this.driver.get(c.joinUrlFragments([i.clientApiUrl,"v1","sepa_mandates.json"]),o,function(t){return{sepaMandate:new u(t.sepaMandates[0])}},e,this.requestTimeout))},this))},o.prototype.addCoinbase=function(t,e){this._getGatewayConfiguration(r(function(n,i){var o;return n?e(n):(delete t.share,o=c.mergeOptions(this._getAttrs(i),{coinbaseAccount:t,_meta:{integration:this.integration||"custom",source:"coinbase",sessionId:this.sessionId}}),void this.driver.post(c.joinUrlFragments([i.clientApiUrl,"v1","payment_methods/coinbase_accounts"]),o,function(t){return new p(t.coinbaseAccounts[0])},e,this.requestTimeout))},this))},o.prototype.addPayPalAccount=function(t,e){this._getGatewayConfiguration(r(function(n,i){var o;return n?e(n):(delete t.share,o=c.mergeOptions(this._getAttrs(i),{paypalAccount:t,_meta:{integration:this.integration||"paypal",source:"paypal",sessionId:this.sessionId}}),void this.driver.post(c.joinUrlFragments([i.clientApiUrl,"v1","payment_methods","paypal_accounts"]),o,function(t){return new d(t.paypalAccounts[0])},e,this.requestTimeout))},this))},o.prototype.addCreditCard=function(t,e){this._getGatewayConfiguration(r(function(n,i){var o,r,s;return n?e(n):(s=t.share,delete t.share,r=f(t),o=c.mergeOptions(this._getAttrs(i),{share:s,creditCard:r,_meta:{integration:this.integration||"custom",source:"form",sessionId:this.sessionId}}),void this.driver.post(c.joinUrlFragments([i.clientApiUrl,"v1","payment_methods/credit_cards"]),o,function(t){return new h(t.creditCards[0])},e,this.requestTimeout))},this))},o.prototype.sendAnalyticsEvents=function(t,e){this._getGatewayConfiguration(r(function(i,o){var r,s,a,u;if(i)return void e(i);if(a=o.analytics.url,u=[],t=c.isArray(t)?t:[t],!a)return void(e&&e(null,{}));for(s in t)t.hasOwnProperty(s)&&u.push({kind:t[s]});r=c.mergeOptions(this._getAttrs(o),{analytics:u,_meta:{merchantAppId:this.merchantAppId,platform:"web",platformVersion:n.navigator.userAgent,integrationType:this.integration,sdkVersion:this.sdkVersion,sessionId:this.sessionId}}),this.driver.post(a,r,function(t){return t},e,v.ANALYTICS_TIMEOUT_MS)},this))},o.prototype.decryptBrowserswitchPayload=function(t,e){this._getGatewayConfiguration(r(function(n,i){var o,r;return n?e(n):(o=c.mergeOptions(this._getAttrs(i),{asymmetricEncryptedPayload:t}),r=c.joinUrlFragments([i.clientApiUrl,"/v1/paypal_browser_switch/decrypt"]),void this.driver.post(r,o,function(t){return t},e,this.requestTimeout))},this))},o.prototype.encryptBrowserswitchReturnPayload=function(t,e,n){this._getGatewayConfiguration(r(function(i,o){var r,s;return i?n(i):(r=c.mergeOptions(this._getAttrs(o),{payload:t,aesKey:e}),s=c.joinUrlFragments([o.clientApiUrl,"/v1/paypal_browser_switch/encrypt"]),void this.driver.post(s,r,function(t){return t},n,this.requestTimeout))},this))},o.prototype.exchangePaypalTokenForConsentCode=function(t,e){this._getGatewayConfiguration(r(function(n,i){var o,r;return n?e(n):(o=c.mergeOptions(this._getAttrs(i),t),i.merchantAccountId&&(o.merchantAccountId=i.merchantAccountId),r=c.joinUrlFragments([i.clientApiUrl,"/v1/paypal_account_service/merchant_consent"]),void this.driver.post(r,o,function(t){return t},e,this.requestTimeout))},this))},o.prototype.getAmexRewardsBalance=function(t,e){this._getGatewayConfiguration(r(function(n,i){var o;return n?e(n):(o=c.mergeOptions(this._getAttrs(i),t),o.nonce&&(o.paymentMethodNonce=o.nonce,delete o.nonce),void this.driver.get(c.joinUrlFragments([i.clientApiUrl,"v1/payment_methods/amex_rewards_balance"]),o,function(t){return t},e,this.requestTimeout))},this))},o.prototype.getAmexExpressCheckoutNonceProfile=function(t,e){this._getGatewayConfiguration(r(function(n,i){var o;return n?e(n):(o=c.mergeOptions(this._getAttrs(i),t),o.nonce&&(o.paymentMethodNonce=o.nonce,delete o.nonce),void this.driver.get(c.joinUrlFragments([i.clientApiUrl,"v1/payment_methods/amex_express_checkout_cards",o.paymentMethodNonce]),o,function(t){return t},e,this.requestTimeout))},this))},o.prototype.verify3DS=function(){var t=arguments;return this._secure3d?this._secure3d.verify.apply(this._secure3d,t):void this._getGatewayConfiguration(r(function(e,n){var i;return e?(i=t[t.length-1])(e):(this._secure3d=s.create(this,{container:this.options.container,clientToken:n}),this._secure3d.verify.apply(this._secure3d,t))},this))},e.exports=o}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{11:11,12:12,13:13,2:2,26:26,3:3,4:4,40:40,49:49,5:5,6:6,7:7,8:8,87:87,9:9}],2:[function(t,e,n){"use strict";function i(t){var e,n;for(e=0;e<o.length;e++)n=o[e],this[n]=t[n]}var o=["nonce","type","description","details"];e.exports=i},{}],3:[function(t,e,n){"use strict";var i={production:"https://api.braintreegateway.com:443",sandbox:"https://api.sandbox.braintreegateway.com:443"};e.exports={apiUrls:i,errors:{UNKNOWN_ERROR:"Unknown error",INVALID_TIMEOUT:"Timeout must be a number"},ANALYTICS_TIMEOUT_MS:4e3,authorizationTypes:{CLIENT_TOKEN:"CLIENT_TOKEN",TOKENIZATION_KEY:"TOKENIZATION_KEY"}}},{}],4:[function(t,e,n){"use strict";function i(t){var e,n;for(e=0;e<o.length;e++)n=o[e],this[n]=t[n]}var o=["billingAddress","branding","createdAt","createdAtMerchant","createdAtMerchantName","details","isLocked","lastUsedAt","lastUsedAtMerchant","lastUsedAtMerchantName","lastUsedByCurrentMerchant","nonce","securityQuestions","type"];e.exports=i},{}],5:[function(t,e,n){"use strict";function i(t){var e,n=["bic","maskedIBAN","nonce","accountHolderName"],i=0;for(i=0;i<n.length;i++)e=n[i],this[e]=t[e]}e.exports=i},{}],6:[function(t,e,n){"use strict";function i(t){var e=t.split("_"),n=e[0],i=e.slice(2).join("_");return{merchantId:i,environment:n}}function o(t,e){var n,o,l,h=a({enableCORS:c(t)}),p={};s.isTokenizationKey(t.authorization)?(p.clientKey=t.authorization,o=i(t.authorization),n=u.apiUrls[o.environment]+"/merchants/"+o.merchantId+"/client_api/v1/configuration"):(l=r(t.authorization),p.authorizationFingerprint=l.authorizationFingerprint,n=l.configUrl),t.sessionId&&(p._meta={sessionId:t.sessionId}),h.get(n,p,function(t){return t},e,t.timeout)}var r=t(8),s=t(13),a=t(40).chooseDriver,c=t(12),u=t(3);e.exports=o},{12:12,13:13,3:3,40:40,8:8}],7:[function(t,e,n){"use strict";function i(t){var e,n={billingAddress:t.billingAddress||{}};for(e in t)if(t.hasOwnProperty(e))switch(e.replace(/_/g,"").toLowerCase()){case"postalcode":case"countryname":case"countrycodenumeric":case"countrycodealpha2":case"countrycodealpha3":case"region":case"extendedaddress":case"locality":case"firstname":case"lastname":case"company":case"streetaddress":n.billingAddress[e]=t[e];break;default:n[e]=t[e]}return n}e.exports={normalizeCreditCardFields:i}},{}],8:[function(t,e,n){"use strict";function i(t){var e;if(!t)throw new Error("Braintree API Client Misconfigured: clientToken required.");if("object"==typeof t&&null!==t)e=t;else{try{t=window.atob(t)}catch(n){}try{e=JSON.parse(t)}catch(i){throw new Error("Braintree API Client Misconfigured: clientToken is not valid JSON.")}}if(!e.hasOwnProperty("clientApiUrl")||!o.isWhitelistedDomain(e.clientApiUrl))throw new Error("Braintree API Client Misconfigured: the clientApiUrl provided in the clientToken is invalid.");return e}var o=t(49);t(10),e.exports=i},{10:10,49:49}],9:[function(t,e,n){"use strict";function i(t){var e,n;for(e=0;e<o.length;e++)n=o[e],this[n]=t[n]}var o=["nonce","type","description","details"];e.exports=i},{}],10:[function(t,e,n){(function(t){"use strict";var n=function(t){var e=new RegExp("^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})([=]{1,2})?$"),n="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",i="";if(!e.test(t))throw new Error("Non base64 encoded input passed to window.atob polyfill");var o=0;do{var r=n.indexOf(t.charAt(o++)),s=n.indexOf(t.charAt(o++)),a=n.indexOf(t.charAt(o++)),c=n.indexOf(t.charAt(o++)),u=(63&r)<<2|s>>4&3,l=(15&s)<<4|a>>2&15,h=(3&a)<<6|63&c;i+=String.fromCharCode(u)+(l?String.fromCharCode(l):"")+(h?String.fromCharCode(h):"")}while(o<t.length);return i};t.atob=t.atob||n,e.exports={atobPolyfill:n}}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],11:[function(t,e,n){"use strict";function i(t){var e,n=0,i=["accountHolderName","bic","longFormURL","mandateReferenceNumber","maskedIBAN","shortForm"];for(n=0;n<i.length;n++)e=i[n],this[e]=t[e]}e.exports=i},{}],12:[function(t,e,n){"use strict";e.exports=function(t){return null!=t.enableCORS?t.enableCORS:t.merchantConfiguration?t.merchantConfiguration.enableCORS:!1}},{}],13:[function(t,e,n){"use strict";function i(t){var e,n,i=[];for(n=0;n<t.length;n++)e=t[n],"/"===e.charAt(e.length-1)&&(e=e.substring(0,e.length-1)),"/"===e.charAt(0)&&(e=e.substring(1)),i.push(e);return i.join("/")}function o(t){return t&&"object"==typeof t&&"number"==typeof t.length&&"[object Array]"===Object.prototype.toString.call(t)||!1}function r(t,e){var n,i={};for(n in t)t.hasOwnProperty(n)&&(i[n]=t[n]);for(n in e)e.hasOwnProperty(n)&&(i[n]=e[n]);return i}function s(t){return/^[a-zA-Z0-9]+_[a-zA-Z0-9]+_[a-zA-Z0-9_]+$/.test(t)}e.exports={joinUrlFragments:i,isArray:o,mergeOptions:r,isTokenizationKey:s}},{}],14:[function(t,e,n){"use strict";function i(t){return new o(t)}var o=t(1),r=t(13),s=t(8),a=t(6);e.exports={Client:o,configure:i,util:r,parseClientToken:s,_getConfiguration:a}},{1:1,13:13,6:6,8:8}],15:[function(t,e,n){"use strict";var i,o=Array.prototype.indexOf;i=o?function(t,e){return t.indexOf(e)}:function(t,e){for(var n=0,i=t.length;i>n;n++)if(t[n]===e)return n;return-1},e.exports={indexOf:i}},{}],16:[function(t,e,n){"use strict";function i(t){var e,n,i="";for(e=0;e<t.length;e++)i+="%",n=t[e].charCodeAt(0).toString(16).toUpperCase(),n.length<2&&(i+="0"),i+=n;return i}function o(t){return decodeURIComponent(i(atob(t)))}e.exports={decodeUtf8:o}},{}],17:[function(t,e,n){"use strict";function i(t,e){if(e=e||"["+t+"] is not a valid DOM Element",t&&t.nodeType&&1===t.nodeType)return t;if(t&&window.jQuery&&(t instanceof jQuery||"jquery"in Object(t))&&0!==t.length)return t[0];if("string"==typeof t&&document.getElementById(t))return document.getElementById(t);throw new Error(e)}e.exports={normalizeElement:i}},{}],18:[function(t,e,n){"use strict";function i(t,e,n,i){t.addEventListener?t.addEventListener(e,n,i||!1):t.attachEvent&&t.attachEvent("on"+e,n)}function o(t,e,n,i){t.removeEventListener?t.removeEventListener(e,n,i||!1):t.detachEvent&&t.detachEvent("on"+e,n)}function r(t){t.preventDefault?t.preventDefault():t.returnValue=!1}e.exports={addEventListener:i,removeEventListener:o,preventDefault:r}},{}],19:[function(t,e,n){"use strict";function i(t){return"[object Function]"===r.call(t)}function o(t,e){return function(){return t.apply(e,arguments)}}var r=Object.prototype.toString;e.exports={bind:o,isFunction:i}},{}],20:[function(t,e,n){"use strict";function i(t){var e,n,i,o,r=[{min:0,max:180,chars:7},{min:181,max:620,chars:14},{min:621,max:960,chars:22}];for(o=r.length,t=t||window.innerWidth,n=0;o>n;n++)i=r[n],t>=i.min&&t<=i.max&&(e=i.chars);return e||60}function o(t,e){var n,i;return-1===t.indexOf("@")?t:(t=t.split("@"),n=t[0],i=t[1],n.length>e&&(n=n.slice(0,e)+"..."),i.length>e&&(i="..."+i.slice(-e)),n+"@"+i)}e.exports={truncateEmail:o,getMaxCharLength:i}},{}],21:[function(t,e,n){"use strict";function i(){return"https:"===window.location.protocol}function o(t){switch(t){case null:case void 0:return"";case!0:return"1";case!1:return"0";default:return encodeURIComponent(t)}}function r(t,e){var n,i,s=[];for(i in t)if(t.hasOwnProperty(i)){var a=t[i];n=e?e+"["+i+"]":i,"object"==typeof a?s.push(r(a,n)):void 0!==a&&null!==a&&s.push(o(n)+"="+o(a))}return s.join("&")}function s(t){for(var e={},n=t.split("&"),i=0;i<n.length;i++){var o=n[i].split("="),r=o[0],s=decodeURIComponent(o[1]);e[r]=s}return e}function a(t){var e=t.split("?");return 2!==e.length?{}:s(e[1])}function c(t){if(t=t.toLowerCase(),!/^http/.test(t))return!1;l.href=t;var e=l.hostname.split("."),n=e.slice(-2).join(".");return-1===u.indexOf(h,n)?!1:!0}var u=t(15),l=document.createElement("a"),h=["paypal.com","braintreepayments.com","braintreegateway.com","localhost"];e.exports={isBrowserHttps:i,makeQueryString:r,decodeQueryString:s,getParams:a,isWhitelistedDomain:c}},{15:15}],22:[function(t,e,n){"use strict";function i(){return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(t){var e=16*Math.random()|0,n="x"===t?e:3&e|8;return n.toString(16)})}e.exports=i},{}],23:[function(t,e,n){var i=t(17),o=t(21),r=t(19),s=t(18),a=t(20),c=t(15),u=t(16),l=t(22);e.exports={string:a,array:c,normalizeElement:i.normalizeElement,isBrowserHttps:o.isBrowserHttps,makeQueryString:o.makeQueryString,decodeQueryString:o.decodeQueryString,getParams:o.getParams,isWhitelistedDomain:o.isWhitelistedDomain,removeEventListener:s.removeEventListener,addEventListener:s.addEventListener,preventDefault:s.preventDefault,bind:r.bind,isFunction:r.isFunction,base64ToUtf8:u.decodeUtf8,uuid:l}},{15:15,16:16,17:17,18:18,19:19,20:20,21:21,22:22}],24:[function(t,e,n){"use strict";function i(t,e){var n=window.getComputedStyle?getComputedStyle(t):t.currentStyle;return n[e]}function o(){return{html:{height:s.style.height||"",overflow:i(s,"overflow"),position:i(s,"position")},body:{height:a.style.height||"",overflow:i(a,"overflow")}}}function r(t,e){this.assetsUrl=t,this.container=e||document.body,this.iframe=null,s=document.documentElement,a=document.body,this.merchantPageDefaultStyles=o()}var s,a,c=t(23),u=t(143),l=t(31),h="1.3.3";r.prototype.get=function(t,e){var n=this,i=this.constructAuthorizationURL(t);this.container&&u(this.container)?this.container(i+"&no_style=1"):this.insertIframe(i),new l(function(t){u(n.container)||n.removeIframe(),e(t)})},r.prototype.removeIframe=function(){this.container&&this.container.nodeType&&1===this.container.nodeType?this.container.removeChild(this.iframe):this.container&&window.jQuery&&this.container instanceof jQuery?$(this.iframe,this.container).remove():"string"==typeof this.container&&document.getElementById(this.container).removeChild(this.iframe),this.unlockMerchantWindowSize()},r.prototype.insertIframe=function(t){var e=document.createElement("iframe");if(e.src=t,this.applyStyles(e),this.lockMerchantWindowSize(),this.container&&this.container.nodeType&&1===this.container.nodeType)this.container.appendChild(e);else if(this.container&&window.jQuery&&this.container instanceof jQuery&&0!==this.container.length)this.container.append(e);else{if("string"!=typeof this.container||!document.getElementById(this.container))throw new Error("Unable to find valid container for iframe.");document.getElementById(this.container).appendChild(e)}this.iframe=e},r.prototype.applyStyles=function(t){t.style.position="fixed",t.style.top="0",t.style.left="0",t.style.height="100%",t.style.width="100%",t.setAttribute("frameborder","0"),t.setAttribute("allowTransparency","true"),t.style.border="0",t.style.zIndex="99999"},r.prototype.lockMerchantWindowSize=function(){s.style.overflow="hidden",a.style.overflow="hidden",a.style.height="100%"},r.prototype.unlockMerchantWindowSize=function(){var t=this.merchantPageDefaultStyles;a.style.height=t.body.height,a.style.overflow=t.body.overflow,s.style.overflow=t.html.overflow},r.prototype.constructAuthorizationURL=function(t){var e,n=window.location.href;return n.indexOf("#")>-1&&(n=n.split("#")[0]),e=c.makeQueryString({acsUrl:t.acsUrl,pareq:t.pareq,termUrl:t.termUrl+"&three_d_secure_version="+h,md:t.md,parentUrl:n}),this.assetsUrl+"/3ds/"+h+"/html/style_frame?"+e},e.exports=r},{143:143,23:23,31:31}],25:[function(t,e,n){"use strict";function i(){}function o(t,e){e=e||{},this.clientToken=e.clientToken,this.container=e.container,this.api=t,this.nonce=null,this._loader=null,this._boundHandleUserClose=s(this._handleUserClose,this)}var r=t(23),s=t(87),a=t(143),c=t(24),u=t(27);o.prototype.verify=function(t,e){if(!a(e))throw this.api.sendAnalyticsEvents("3ds.web.no_callback"),new Error("No suitable callback argument was given");a(t.onUserClose)&&(this._onUserClose=t.onUserClose),a(t.onLookupComplete)&&(this._onLookupComplete=t.onLookupComplete),(void 0===t.useDefaultLoader||t.useDefaultLoader===!0)&&this._createDefaultLoader();var n={nonce:"",amount:t.amount},i=t.creditCard;if("string"==typeof i)n.nonce=i,this.api.sendAnalyticsEvents("3ds.web.verify.nonce"),this.startVerification(n,e);else{var o=this,r=function(t,i){return t?(o._removeDefaultLoader(),e(t)):(n.nonce=i,void o.startVerification(n,e))};this.api.sendAnalyticsEvents("3ds.web.verify.credit_card"),this.api.tokenizeCard(i,r)}},o.prototype.startVerification=function(t,e){this.api.lookup3DS(t,s(this.handleLookupResponse(e),this))},o.prototype.handleLookupResponse=function(t){var e=this;return function(n,i){var o;this._onLookupComplete(),n?t(n.error):i.lookup&&i.lookup.acsUrl&&i.lookup.acsUrl.length>0?(e.nonce=i.paymentMethod.nonce,o=new c(this.clientToken.assetsUrl,this.container),o.get(i.lookup,s(this.handleAuthenticationResponse(t),this)),this._detachListeners(),this._attachListeners()):(e.nonce=i.paymentMethod.nonce,t(null,{nonce:e.nonce,verificationDetails:i.threeDSecureInfo}))}},o.prototype.handleAuthenticationResponse=function(t){return function(e){var n,i=r.decodeQueryString(e);i.user_closed||(n=JSON.parse(i.auth_response),n.success?t(null,{nonce:n.paymentMethod.nonce,verificationDetails:n.threeDSecureInfo}):n.threeDSecureInfo&&n.threeDSecureInfo.liabilityShiftPossible?t(null,{nonce:this.nonce,verificationDetails:n.threeDSecureInfo}):t(n.error))}},o.prototype._attachListeners=function(){r.addEventListener(window,"message",this._boundHandleUserClose)},o.prototype._detachListeners=function(){r.removeEventListener(window,"message",this._boundHandleUserClose)},o.prototype._createDefaultLoader=function(){this._loader=new u,document.body.appendChild(this._loader.getElement())},o.prototype._removeDefaultLoader=function(){if(this._loader){var t=this._loader.getElement(),e=t.parentNode;e&&e.removeChild(t),this._loader.dispose(),this._loader=null}},o.prototype._handleUserClose=function(t){"user_closed=true"===t.data&&this._onUserClose()},o.prototype._onUserClose=i,o.prototype._onLookupComplete=function(){this._removeDefaultLoader()},e.exports=o},{143:143,23:23,24:24,27:27,87:87}],26:[function(t,e,n){"use strict";var i=t(25);e.exports={create:function(t,e){var n=new i(t,e);return n}}},{25:25}],27:[function(t,e,n){"use strict";function i(){this._element=document.createElement("div"),this._element.style.cssText=this._cssDeclarations,this._display=null,this._initialize()}var o=t(28),r=t(29),s=t(30);i.prototype._cssDeclarations=["filter:progid:DXImageTransform.Microsoft.Gradient(StartColorStr=#7F000000, EndColorStr=#7F000000)","background-color: rgba(0, 0, 0, 0.5)","display: table","height: 100%","left: 0","position: fixed","right: 0","top: 0","width: 100%","z-index: 99999"].join(";"),i.prototype.getElement=function(){return this._element},i.prototype.dispose=function(){this._display.dispose(),this._display=null,this._element=null},i.prototype._initialize=function(){var t=new s,e=window.SVGElement&&window.SVGAnimateElement&&window.SVGAnimateTransformElement;e||(t=new r("Loading...")),this._display=new o(t),this.getElement().appendChild(this._display.getElement())},e.exports=i},{28:28,29:29,30:30}],28:[function(t,e,n){"use strict";function i(t){this._element=document.createElement("div"),this._element.style.cssText=this._cssDeclarations,this._displayObject=t,this._initialize()}i.prototype._cssDeclarations=["display: table-cell","vertical-align: middle"].join(";"),i.prototype.getElement=function(){return this._element},i.prototype.dispose=function(){this._displayObject.dispose(),this._displayObject=null,this._element=null},i.prototype._initialize=function(){this.getElement().appendChild(this._displayObject.getElement())},e.exports=i},{}],29:[function(t,e,n){"use strict";function i(t){this._element=document.createElement("div"),this._element.style.cssText=this._cssDeclarations,this._element.innerHTML=t}i.prototype._cssDeclarations=["color: #fff","font-family: Helvetica, sans-serif","font-size: 12px","text-align: center"].join(";"),i.prototype.getElement=function(){return this._element},i.prototype.dispose=function(){this._element=null},e.exports=i},{}],30:[function(t,e,n){"use strict";function i(){this._element=document.createElement("div"),this._element.style.cssText=this._cssDeclarations,this._element.innerHTML=this._markup}i.prototype._cssDeclarations=["height: 36px","margin-left: auto","margin-right: auto","width: 36px"].join(";"),i.prototype._markup=['<svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"','width="100%" height="100%" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">','  <path fill="#FFF" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">','    <animateTransform attributeType="xml"','    attributeName="transform"','    type="rotate"','    from="0 25 25"','    to="360 25 25"','    dur="780ms"','    repeatCount="indefinite"','    calcMode="spline"','    keySplines="0.44, 0.22, 0, 1"','    keyTimes="0;1"/>',"  </path>","</svg>"].join(""),i.prototype.getElement=function(){return this._element},i.prototype.dispose=function(){this._element=null},e.exports=i},{}],31:[function(t,e,n){"use strict";function i(t){this.postMessageReceiver(t),this.hashChangeReceiver(t)}var o=t(23);i.prototype.postMessageReceiver=function(t){var e=this;this.wrappedCallback=function(n){var i=n.data;(/^(auth_response=)/.test(i)||"user_closed=true"===i)&&(t(i),e.stopListening())},o.addEventListener(window,"message",this.wrappedCallback)},i.prototype.hashChangeReceiver=function(t){var e,n=window.location.hash,i=this;this.poll=setInterval(function(){e=window.location.hash,e.length>0&&e!==n&&(i.stopListening(),e=e.substring(1,e.length),t(e),window.location.hash=n.length>0?n:"")},10)},i.prototype.stopListening=function(){clearTimeout(this.poll),o.removeEventListener(window,"message",this.wrappedCallback)},e.exports=i},{23:23}],32:[function(t,e,n){(function(n){"use strict";function i(){return h?new XMLHttpRequest:new XDomainRequest}function o(t,e,n,i,o){var r=a.createURLParams(t,e);s("GET",r,null,n,i,o)}function r(t,e,n,i,o){s("POST",t,e,n,i,o)}function s(t,e,n,o,r,s){var a,p,d=i();r=r||function(){},h?d.onreadystatechange=function(){4===d.readyState&&(a=d.status,p=u(d.responseText),a>=400||0===a?r.call(null,p||{errors:l.errors.UNKNOWN_ERROR},null):a>0&&r.call(null,null,o(p)))}:(d.onload=function(){r.call(null,null,o(u(d.responseText)))},d.onerror=function(){r.call(null,d.responseText,null)},d.onprogress=function(){},d.ontimeout=function(){r.call(null,{errors:l.errors.UNKNOWN_ERROR},null)}),d.open(t,e,!0),d.timeout=null==s?6e4:s,h&&"POST"===t&&d.setRequestHeader("Content-Type","application/json"),setTimeout(function(){d.send(c(t,n))},0)}var a=t(39),c=t(38),u=t(37),l=t(34),h=n.XMLHttpRequest&&"withCredentials"in new n.XMLHttpRequest;e.exports={get:o,post:r}}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{34:34,37:37,38:38,39:39}],33:[function(t,e,n){"use strict";function i(t){var e=s.getUserAgent(),n=!(s.isHTTP()&&/(MSIE\s(8|9))|(Phantom)/.test(e));return t=t||{},t.enableCORS&&n?r:o}var o=t(35),r=t(32),s=t(39);e.exports=i},{32:32,35:35,39:39}],34:[function(t,e,n){e.exports={errors:{UNKNOWN_ERROR:"Unknown error",INVALID_TIMEOUT:"Timeout must be a number"}}},{}],35:[function(t,e,n){"use strict";function i(t,e){return t.status>=400?[t,null]:[null,e(t)]}function o(){}function r(t,e,n,r,s,a){var c;s=s||o,null==a&&(a=6e4),c=r(t,e,function(t,e,o){l[o]&&(clearTimeout(l[o]),t?s.call(null,t):s.apply(null,i(e,function(t){return n(t)})))}),"number"==typeof a?l[c]=setTimeout(function(){l[c]=null,s.apply(null,[{errors:u.errors.UNKNOWN_ERROR},null])},a):s.apply(null,[{errors:u.errors.INVALID_TIMEOUT},null])}function s(t,e,n,i,o){e._method="POST",r(t,e,n,c.get,i,o)}function a(t,e,n,i,o){r(t,e,n,c.get,i,o)}var c=t(36),u=t(34),l=[];e.exports={get:a,post:s}},{34:34,36:36}],36:[function(t,e,n){(function(n){"use strict";function i(t,e){var n=document.createElement("script"),i=!1;n.src=t,n.async=!0;var o=e||u.error;"function"==typeof o&&(n.onerror=function(e){o({url:t,event:e})}),n.onload=n.onreadystatechange=function(){i||this.readyState&&"loaded"!==this.readyState&&"complete"!==this.readyState||(i=!0,n.onload=n.onreadystatechange=null,n&&n.parentNode&&n.parentNode.removeChild(n))},s||(s=document.getElementsByTagName("head")[0]),s.appendChild(n)}function o(t,e,n,o){var r,s;return o=o||u.callbackName||"callback",s=o+"_json"+a.generateUUID(),e[o]=s,r=a.createURLParams(t,e),c[s]=function(t){n(null,t,s);try{delete c[s]}catch(e){}c[s]=null},i(r,function(t){n(t,null,s)}),s}function r(t){u=t}var s,a=t(39),c=n,u={};e.exports={get:o,init:r}}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{39:39}],37:[function(t,e,n){"use strict";e.exports=function(t){try{t=JSON.parse(t)}catch(e){}return t}},{}],38:[function(t,e,n){"use strict";e.exports=function(t,e){if("string"!=typeof t)throw new Error("Method must be a string");return"get"!==t.toLowerCase()&&null!=e&&(e="string"==typeof e?e:JSON.stringify(e)),e}},{}],39:[function(t,e,n){(function(t){"use strict";function n(t){var e;for(e in t)if(t.hasOwnProperty(e))return!0;return!1}function i(t){return t&&"object"==typeof t&&"number"==typeof t.length&&"[object Array]"===Object.prototype.toString.call(t)||!1}function o(t,e){var n,r,s,a=[];for(s in t)t.hasOwnProperty(s)&&(r=t[s],n=e?i(t)?e+"[]":e+"["+s+"]":s,a.push("object"==typeof r?o(r,n):encodeURIComponent(n)+"="+encodeURIComponent(r)));return a.join("&")}function r(){return"xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g,function(t){var e=Math.floor(16*Math.random()),n="x"===t?e:3&e|8;return n.toString(16)})}function s(t,e){return t=t||"",null!=e&&"object"==typeof e&&n(e)&&(t+=-1===t.indexOf("?")?"?":"",t+=-1!==t.indexOf("=")?"&":"",t+=o(e)),t}function a(){return t.navigator.userAgent}function c(){return"http:"===t.location.protocol}e.exports={isArray:i,generateUUID:r,stringify:o,createURLParams:s,getUserAgent:a,isHTTP:c}}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],40:[function(t,e,n){"use strict";var i=t(32),o=t(35),r=t(33),s=t(39);e.exports={AJAXDriver:i,JSONPDriver:o,chooseDriver:r,util:s}},{32:32,33:33,35:35,39:39}],41:[function(t,e,n){arguments[4][15][0].apply(n,arguments)},{15:15}],42:[function(t,e,n){arguments[4][16][0].apply(n,arguments)},{16:16}],43:[function(t,e,n){arguments[4][17][0].apply(n,arguments)},{17:17}],44:[function(t,e,n){arguments[4][18][0].apply(n,arguments)},{18:18}],45:[function(t,e,n){arguments[4][19][0].apply(n,arguments)},{19:19}],46:[function(t,e,n){arguments[4][20][0].apply(n,arguments)},{20:20}],47:[function(t,e,n){arguments[4][21][0].apply(n,arguments)},{21:21,41:41}],48:[function(t,e,n){arguments[4][22][0].apply(n,arguments)},{22:22}],49:[function(t,e,n){arguments[4][23][0].apply(n,arguments)},{23:23,41:41,42:42,43:43,44:44,45:45,46:46,47:47,48:48}],50:[function(t,e,n){"use strict";function i(t,e){this.host=t||window,this.channel=e||null,this.handlers=[],o.addEventListener(this.host,"message",o.bind(this.receive,this))}var o=t(64);i.prototype.receive=function(t){
var e,n,o,r;try{o=JSON.parse(t.data)}catch(s){return}for(r=o.type,n=new i.Message(this,t.source,o.data),e=0;e<this.handlers.length;e++)this.handlers[e].type===r&&this.handlers[e].handler(n)},i.prototype.send=function(t,e,n){try{t.postMessage(JSON.stringify({type:this._namespaceEvent(e),data:n}),"*")}catch(i){}},i.prototype.register=function(t,e){this.handlers.push({type:this._namespaceEvent(t),handler:e})},i.prototype.unregister=function(t,e){for(var n=this.handlers.length-1;n>=0;n--)if(this.handlers[n].type===t&&this.handlers[n].handler===e)return this.handlers.splice(n,1)},i.prototype._namespaceEvent=function(t){return this.channel?["braintree",this.channel,t].join(":"):t},i.Message=function(t,e,n){this.bus=t,this.source=e,this.content=n},i.Message.prototype.reply=function(t,e){this.bus.send(this.source,t,e)},e.exports=i},{64:64}],51:[function(t,e,n){"use strict";function i(t,e){this.bus=t,this.target=e,this.handlers=[],this.bus.register("publish",o.bind(this._handleMessage,this))}var o=t(64);i.prototype._handleMessage=function(t){var e,n=t.content,i=this.handlers[n.channel];if("undefined"!=typeof i)for(e=0;e<i.length;e++)i[e](n.data)},i.prototype.publish=function(t,e){this.bus.send(this.target,"publish",{channel:t,data:e})},i.prototype.subscribe=function(t,e){this.handlers[t]=this.handlers[t]||[],this.handlers[t].push(e)},i.prototype.unsubscribe=function(t,e){var n,i=this.handlers[t];if("undefined"!=typeof i)for(n=0;n<i.length;n++)i[n]===e&&i.splice(n,1)},e.exports=i},{64:64}],52:[function(t,e,n){"use strict";function i(t){this.bus=t,this.frames=[],this.handlers=[]}i.prototype.subscribe=function(t,e){this.handlers[t]=this.handlers[t]||[],this.handlers[t].push(e)},i.prototype.registerFrame=function(t){this.frames.push(t)},i.prototype.unregisterFrame=function(t){for(var e=0;e<this.frames.length;e++)this.frames[e]===t&&this.frames.splice(e,1)},i.prototype.publish=function(t,e){var n,i=this.handlers[t];if("undefined"!=typeof i)for(n=0;n<i.length;n++)i[n](e);for(n=0;n<this.frames.length;n++)this.bus.send(this.frames[n],"publish",{channel:t,data:e})},i.prototype.unsubscribe=function(t,e){var n,i=this.handlers[t];if("undefined"!=typeof i)for(n=0;n<i.length;n++)i[n]===e&&i.splice(n,1)},e.exports=i},{}],53:[function(t,e,n){"use strict";function i(t,e){this.bus=t,this.target=e||window.parent,this.counter=0,this.callbacks={},this.bus.register("rpc_response",o.bind(this._handleResponse,this))}var o=t(64);i.prototype._handleResponse=function(t){var e=t.content,n=this.callbacks[e.id];"function"==typeof n&&(n.apply(null,e.response),delete this.callbacks[e.id])},i.prototype.invoke=function(t,e,n){var i=this.counter++;this.callbacks[i]=n,this.bus.send(this.target,"rpc_request",{id:i,method:t,args:e})},e.exports=i},{64:64}],54:[function(t,e,n){"use strict";function i(t){this.bus=t,this.methods={},this.bus.register("rpc_request",o.bind(this._handleRequest,this))}var o=t(64);i.prototype._handleRequest=function(t){var e,n=t.content,i=n.args||[],o=this.methods[n.method];"function"==typeof o&&(e=function(){t.reply("rpc_response",{id:n.id,response:Array.prototype.slice.call(arguments)})},i.push(e),o.apply(null,i))},i.prototype.reset=function(){this.methods={}},i.prototype.define=function(t,e){this.methods[t]=e},e.exports=i},{64:64}],55:[function(t,e,n){var i=t(50),o=t(51),r=t(52),s=t(53),a=t(54);e.exports={MessageBus:i,PubsubClient:o,PubsubServer:r,RPCClient:s,RPCServer:a}},{50:50,51:51,52:52,53:53,54:54}],56:[function(t,e,n){arguments[4][15][0].apply(n,arguments)},{15:15}],57:[function(t,e,n){arguments[4][16][0].apply(n,arguments)},{16:16}],58:[function(t,e,n){arguments[4][17][0].apply(n,arguments)},{17:17}],59:[function(t,e,n){arguments[4][18][0].apply(n,arguments)},{18:18}],60:[function(t,e,n){arguments[4][19][0].apply(n,arguments)},{19:19}],61:[function(t,e,n){arguments[4][20][0].apply(n,arguments)},{20:20}],62:[function(t,e,n){arguments[4][21][0].apply(n,arguments)},{21:21,56:56}],63:[function(t,e,n){arguments[4][22][0].apply(n,arguments)},{22:22}],64:[function(t,e,n){arguments[4][23][0].apply(n,arguments)},{23:23,56:56,57:57,58:58,59:59,60:60,61:61,62:62,63:63}],65:[function(t,e,n){arguments[4][15][0].apply(n,arguments)},{15:15}],66:[function(t,e,n){arguments[4][16][0].apply(n,arguments)},{16:16}],67:[function(t,e,n){arguments[4][17][0].apply(n,arguments)},{17:17}],68:[function(t,e,n){arguments[4][18][0].apply(n,arguments)},{18:18}],69:[function(t,e,n){arguments[4][19][0].apply(n,arguments)},{19:19}],70:[function(t,e,n){arguments[4][20][0].apply(n,arguments)},{20:20}],71:[function(t,e,n){arguments[4][21][0].apply(n,arguments)},{21:21,65:65}],72:[function(t,e,n){arguments[4][22][0].apply(n,arguments)},{22:22}],73:[function(t,e,n){arguments[4][23][0].apply(n,arguments)},{23:23,65:65,66:66,67:67,68:68,69:69,70:70,71:71,72:72}],74:[function(t,e,n){"use strict";function i(t){if(!(this instanceof i))return new i(t);var e,n=r(t.className).split(/\s+/);for(this._elem=t,this.length=0,e=0;e<n.length;e+=1)n[e]&&s.push.call(this,n[e])}e.exports=i;var o=t(75),r=t(76),s=Array.prototype;i.prototype.add=function(){var t,e;for(e=0;e<arguments.length;e+=1)t=""+arguments[e],o(this,t)>=0||s.push.call(this,t);return this._elem.className=this.toString(),this},i.prototype.remove=function(){var t,e,n;for(n=0;n<arguments.length;n+=1)e=""+arguments[n],t=o(this,e),0>t||s.splice.call(this,t,1);return this._elem.className=this.toString(),this},i.prototype.contains=function(t){return t+="",o(this,t)>=0},i.prototype.toggle=function(t,e){return t+="",e===!0?this.add(t):e===!1?this.remove(t):this[this.contains(t)?"remove":"add"](t)},i.prototype.toString=function(){return s.join.call(this," ")}},{75:75,76:76}],75:[function(t,e,n){e.exports=function(t,e){if(t.indexOf)return t.indexOf(e);for(var n=0;n<t.length;++n)if(t[n]===e)return n;return-1}},{}],76:[function(t,e,n){function i(t){return t.replace(/^\s*|\s*$/g,"")}n=e.exports=i,n.left=function(t){return t.replace(/^\s*/,"")},n.right=function(t){return t.replace(/\s*$/,"")}},{}],77:[function(t,e,n){"use strict";function i(){this._teardownRegistry=[]}var o=t(78),r=t(79);i.prototype.registerFunctionForTeardown=function(t){r.isFunction(t)&&this._teardownRegistry.push(t)},i.prototype.teardown=function(t){o(this._teardownRegistry,r.bind(function(e){this._teardownRegistry=[],r.isFunction(t)&&t(e)},this))},e.exports=i},{78:78,79:79}],78:[function(t,e,n){"use strict";function i(t,e){var n,i=0===t.length;i?(t(),e(null)):(n=o(e),t(n))}function o(t){var e=!1;return function(){e||(e=!0,t.apply(this,arguments))}}e.exports=function(t,e){var n=t.length,o=n;if(0===n)return void e(null);for(var r=0;n>r;r++)i(t[r],function(t){return t?void e(t):(o-=1,void(0===o&&e(null)))})}},{}],79:[function(t,e,n){arguments[4][19][0].apply(n,arguments)},{19:19}],80:[function(t,e,n){(function(t){"use strict";function n(t){if(("string"==typeof t||t instanceof String)&&(t=document.getElementById(t)),!(t instanceof HTMLFormElement))throw new TypeError("FormNapper requires an HTMLFormElement element or the id string of one.");this.htmlForm=t}n.prototype.hijack=function(e){this.submitHandler||(this.submitHandler=function(t){t.preventDefault?t.preventDefault():t.returnValue=!1,e(t)},null!=t.addEventListener?this.htmlForm.addEventListener("submit",this.submitHandler,!1):null!=t.attachEvent?this.htmlForm.attachEvent("onsubmit",this.submitHandler):this.htmlForm.onsubmit=this.submitHandler)},n.prototype.inject=function(t,e){var n=this.htmlForm.querySelector('input[name="'+t+'"]');return null==n&&(n=document.createElement("input"),n.type="hidden",n.name=t,this.htmlForm.appendChild(n)),n.value=e,n},n.prototype.submit=function(){HTMLFormElement.prototype.submit.call(this.htmlForm)},n.prototype.detach=function(){this.submitHandler&&(null!=t.removeEventListener?this.htmlForm.removeEventListener("submit",this.submitHandler,!1):null!=t.detachEvent?this.htmlForm.detachEvent("onsubmit",this.submitHandler):this.htmlForm.onsubmit=null,delete this.submitHandler)},e.exports=n}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],81:[function(e,n,i){"use strict";!function(e,o){"object"==typeof i&&"undefined"!=typeof n?n.exports=o():"function"==typeof t&&t.amd?t([],o):e.framebus=o()}(this,function(){function t(t){return null==t?!1:null==t.Window?!1:t.constructor!==t.Window?!1:(_.push(t),!0)}function e(t){var e,n={};for(e in v)v.hasOwnProperty(e)&&(n[e]=v[e]);return n._origin=t||"*",n}function n(t){var e,n,i=r(this);return s(t)?!1:s(i)?!1:(n=Array.prototype.slice.call(arguments,1),e=a(t,n,i),e===!1?!1:(d(g.top,e,i),!0))}function i(t,e){var n=r(this);return y(t,e,n)?!1:(b[n]=b[n]||{},b[n][t]=b[n][t]||[],b[n][t].push(e),!0)}function o(t,e){var n,i,o=r(this);if(y(t,e,o))return!1;if(i=b[o]&&b[o][t],!i)return!1;for(n=0;n<i.length;n++)if(i[n]===e)return i.splice(n,1),!0;return!1}function r(t){return t&&t._origin||"*"}function s(t){return"string"!=typeof t}function a(t,e,n){var i=!1,o={event:t,origin:n},r=e[e.length-1];"function"==typeof r&&(o.reply=m(r,n),e=e.slice(0,-1)),o.args=e;try{i=E+JSON.stringify(o)}catch(s){throw new Error("Could not stringify event: "+s.message)}return i}function c(t){var e,n,i,o;if(t.data.slice(0,E.length)!==E)return!1;try{e=JSON.parse(t.data.slice(E.length))}catch(r){return!1}return null!=e.reply&&(n=t.origin,i=t.source,o=e.reply,e.reply=function(t){var e=a(o,[t],n);return e===!1?!1:void i.postMessage(e,n)},e.args.push(e.reply)),e}function u(t){g||(g=t||window,g.addEventListener?g.addEventListener("message",h,!1):g.attachEvent?g.attachEvent("onmessage",h):null===g.onmessage?g.onmessage=h:g=null)}function l(){return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(t){var e=16*Math.random()|0,n="x"===t?e:3&e|8;return n.toString(16)})}function h(t){var e;s(t.data)||(e=c(t),e&&(p("*",e.event,e.args,t),p(t.origin,e.event,e.args,t),f(t.data,e.origin,t.source)))}function p(t,e,n,i){var o;if(b[t]&&b[t][e])for(o=0;o<b[t][e].length;o++)b[t][e][o].apply(i,n)}function d(t,e,n){var i;try{for(t.postMessage(e,n),t.opener&&t.opener!==t&&!t.opener.closed&&t.opener!==g&&d(t.opener.top,e,n),i=0;i<t.frames.length;i++)d(t.frames[i],e,n)}catch(o){}}function f(t,e,n){var i,o;for(i=_.length-1;i>=0;i--)o=_[i],o.closed===!0?_=_.slice(i,1):n!==o&&d(o.top,t,e)}function m(t,e){function n(o,r){t(o,r),v.target(e).unsubscribe(i,n)}var i=l();return v.target(e).subscribe(i,n),i}function y(t,e,n){return s(t)?!0:"function"!=typeof e?!0:s(n)?!0:!1}var g,v,_=[],b={},E="/*framebus*/";return u(),v={target:e,include:t,publish:n,pub:n,trigger:n,emit:n,subscribe:i,sub:i,on:i,unsubscribe:o,unsub:o,off:o}})},{}],82:[function(t,e,n){"use strict";var i=t(147),o=t(146),r=t(84),s=t(83);e.exports=function(t){var e=document.createElement("iframe"),n=i({},s,t);return n.style&&!o(n.style)&&(i(e.style,n.style),delete n.style),r(e,n),e.getAttribute("id")||(e.id=e.name),e}},{146:146,147:147,83:83,84:84}],83:[function(t,e,n){e.exports={src:"about:blank",frameBorder:0,allowtransparency:!0,scrolling:"no"}},{}],84:[function(t,e,n){e.exports=function(t,e){var n;for(var i in e)e.hasOwnProperty(i)&&(n=e[i],null==n?t.removeAttribute(i):t.setAttribute(i,n))}},{}],85:[function(t,e,n){function i(t){if(c(t)&&!a(t)&&!(t instanceof o)){if(t instanceof r)return t;if(h.call(t,"__chain__")&&h.call(t,"__wrapped__"))return u(t)}return new r(t)}var o=t(90),r=t(91),s=t(104),a=t(142),c=t(130),u=t(139),l=Object.prototype,h=l.hasOwnProperty;i.prototype=s.prototype,e.exports=i},{104:104,130:130,139:139,142:142,90:90,91:91}],86:[function(t,e,n){var i=t(121),o=i(Date,"now"),r=o||function(){return(new Date).getTime()};e.exports=r},{121:121}],87:[function(t,e,n){var i=t(117),o=t(135),r=t(89),s=1,a=32,c=r(function(t,e,n){var r=s;if(n.length){var u=o(n,c.placeholder);r|=a}return i(t,r,e,n,u)});c.placeholder={},e.exports=c},{117:117,135:135,89:89}],88:[function(t,e,n){var i=t(100),o=t(117),r=t(149),s=t(89),a=1,c=s(function(t,e){e=e.length?i(e):r(t);for(var n=-1,s=e.length;++n<s;){var c=e[n];t[c]=o(t[c],a,t)}return t});e.exports=c},{100:100,117:117,149:149,89:89}],89:[function(t,e,n){function i(t,e){if("function"!=typeof t)throw new TypeError(o);return e=r(void 0===e?t.length-1:+e||0,0),function(){for(var n=arguments,i=-1,o=r(n.length-e,0),s=Array(o);++i<o;)s[i]=n[e+i];switch(e){case 0:return t.call(this,s);case 1:return t.call(this,n[0],s);case 2:return t.call(this,n[0],n[1],s)}var a=Array(e+1);for(i=-1;++i<e;)a[i]=n[i];return a[e]=s,t.apply(this,a)}}var o="Expected a function",r=Math.max;e.exports=i},{}],90:[function(t,e,n){function i(t){this.__wrapped__=t,this.__actions__=[],this.__dir__=1,this.__filtered__=!1,this.__iteratees__=[],this.__takeCount__=s,this.__views__=[]}var o=t(99),r=t(104),s=Number.POSITIVE_INFINITY;i.prototype=o(r.prototype),i.prototype.constructor=i,e.exports=i},{104:104,99:99}],91:[function(t,e,n){function i(t,e,n){this.__wrapped__=t,this.__actions__=n||[],this.__chain__=!!e}var o=t(99),r=t(104);i.prototype=o(r.prototype),i.prototype.constructor=i,e.exports=i},{104:104,99:99}],92:[function(t,e,n){function i(t,e){var n=-1,i=t.length;for(e||(e=Array(i));++n<i;)e[n]=t[n];return e}e.exports=i},{}],93:[function(t,e,n){function i(t,e){for(var n=-1,i=t.length;++n<i&&e(t[n],n,t)!==!1;);return t}e.exports=i},{}],94:[function(t,e,n){function i(t,e){for(var n=-1,i=e.length,o=t.length;++n<i;)t[o+n]=e[n];return t}e.exports=i},{}],95:[function(t,e,n){function i(t,e,n){for(var i=-1,r=o(e),s=r.length;++i<s;){var a=r[i],c=t[a],u=n(c,e[a],a,t,e);(u===u?u===c:c!==c)&&(void 0!==c||a in t)||(t[a]=u)}return t}var o=t(150);e.exports=i},{150:150}],96:[function(t,e,n){function i(t,e){return null==e?t:o(e,r(e),t)}var o=t(98),r=t(150);e.exports=i},{150:150,98:98}],97:[function(t,e,n){function i(t,e,n,f,m,y,g){var _;if(n&&(_=m?n(t,f,m):n(t)),void 0!==_)return _;if(!p(t))return t;var b=h(t);if(b){if(_=c(t),!e)return o(t,_)}else{var w=k.call(t),A=w==v;if(w!=E&&w!=d&&(!A||m))return L[w]?u(t,w,e):m?t:{};if(_=l(A?{}:t),!e)return s(_,t)}y||(y=[]),g||(g=[]);for(var C=y.length;C--;)if(y[C]==t)return g[C];return y.push(t),g.push(_),(b?r:a)(t,function(o,r){_[r]=i(o,e,n,r,t,y,g)}),_}var o=t(92),r=t(93),s=t(96),a=t(102),c=t(122),u=t(123),l=t(124),h=t(142),p=t(145),d="[object Arguments]",f="[object Array]",m="[object Boolean]",y="[object Date]",g="[object Error]",v="[object Function]",_="[object Map]",b="[object Number]",E="[object Object]",w="[object RegExp]",A="[object Set]",C="[object String]",N="[object WeakMap]",T="[object ArrayBuffer]",I="[object Float32Array]",S="[object Float64Array]",x="[object Int8Array]",P="[object Int16Array]",O="[object Int32Array]",R="[object Uint8Array]",D="[object Uint8ClampedArray]",M="[object Uint16Array]",U="[object Uint32Array]",L={};L[d]=L[f]=L[T]=L[m]=L[y]=L[I]=L[S]=L[x]=L[P]=L[O]=L[b]=L[E]=L[w]=L[C]=L[R]=L[D]=L[M]=L[U]=!0,L[g]=L[v]=L[_]=L[A]=L[N]=!1;var F=Object.prototype,k=F.toString;e.exports=i},{102:102,122:122,123:123,124:124,142:142,145:145,92:92,93:93,96:96}],98:[function(t,e,n){function i(t,e,n){n||(n={});for(var i=-1,o=e.length;++i<o;){var r=e[i];n[r]=t[r]}return n}e.exports=i},{}],99:[function(t,e,n){var i=t(145),o=function(){function t(){}return function(e){if(i(e)){t.prototype=e;var n=new t;t.prototype=void 0}return n||{}}}();e.exports=o},{145:145}],100:[function(t,e,n){function i(t,e,n,u){u||(u=[]);for(var l=-1,h=t.length;++l<h;){var p=t[l];c(p)&&a(p)&&(n||s(p)||r(p))?e?i(p,e,n,u):o(u,p):n||(u[u.length]=p)}return u}var o=t(94),r=t(141),s=t(142),a=t(125),c=t(130);e.exports=i},{125:125,130:130,141:141,142:142,94:94}],101:[function(t,e,n){var i=t(112),o=i();e.exports=o},{112:112}],102:[function(t,e,n){function i(t,e){return o(t,e,r)}var o=t(101),r=t(150);e.exports=i},{101:101,150:150}],103:[function(t,e,n){function i(t,e){for(var n=-1,i=e.length,r=-1,s=[];++n<i;){var a=e[n];o(t[a])&&(s[++r]=a)}return s}var o=t(143);e.exports=i},{143:143}],104:[function(t,e,n){function i(){}e.exports=i},{}],105:[function(t,e,n){function i(t){return function(e){return null==e?void 0:e[t]}}e.exports=i},{}],106:[function(t,e,n){var i=t(152),o=t(132),r=o?function(t,e){return o.set(t,e),t}:i;e.exports=r},{132:132,152:152}],107:[function(t,e,n){function i(t,e,n){if("function"!=typeof t)return o;if(void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 3:return function(n,i,o){return t.call(e,n,i,o)};case 4:return function(n,i,o,r){return t.call(e,n,i,o,r)};case 5:return function(n,i,o,r,s){return t.call(e,n,i,o,r,s)}}return function(){return t.apply(e,arguments)}}var o=t(152);e.exports=i},{152:152}],108:[function(t,e,n){(function(t){function n(t){var e=new i(t.byteLength),n=new o(e);return n.set(new o(t)),e}var i=t.ArrayBuffer,o=t.Uint8Array;e.exports=n}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],109:[function(t,e,n){function i(t,e,n){for(var i=n.length,r=-1,s=o(t.length-i,0),a=-1,c=e.length,u=Array(c+s);++a<c;)u[a]=e[a];for(;++r<i;)u[n[r]]=t[r];for(;s--;)u[a++]=t[r++];return u}var o=Math.max;e.exports=i},{}],110:[function(t,e,n){function i(t,e,n){for(var i=-1,r=n.length,s=-1,a=o(t.length-r,0),c=-1,u=e.length,l=Array(a+u);++s<a;)l[s]=t[s];for(var h=s;++c<u;)l[h+c]=e[c];for(;++i<r;)l[h+n[i]]=t[s++];return l}var o=Math.max;e.exports=i},{}],111:[function(t,e,n){function i(t){return s(function(e,n){var i=-1,s=null==e?0:n.length,a=s>2?n[s-2]:void 0,c=s>2?n[2]:void 0,u=s>1?n[s-1]:void 0;for("function"==typeof a?(a=o(a,u,5),s-=2):(a="function"==typeof u?u:void 0,s-=a?1:0),c&&r(n[0],n[1],c)&&(a=3>s?void 0:a,s=1);++i<s;){var l=n[i];l&&t(e,l,a)}return e})}var o=t(107),r=t(127),s=t(89);e.exports=i},{107:107,127:127,89:89}],112:[function(t,e,n){function i(t){return function(e,n,i){for(var r=o(e),s=i(e),a=s.length,c=t?a:-1;t?c--:++c<a;){var u=s[c];if(n(r[u],u,r)===!1)break}return e}}var o=t(138);e.exports=i},{138:138}],113:[function(t,e,n){(function(n){function i(t,e){function i(){var o=this&&this!==n&&this instanceof i?r:t;return o.apply(e,arguments)}var r=o(t);return i}var o=t(114);e.exports=i}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{114:114}],114:[function(t,e,n){function i(t){return function(){var e=arguments;switch(e.length){case 0:return new t;case 1:return new t(e[0]);case 2:return new t(e[0],e[1]);case 3:return new t(e[0],e[1],e[2]);case 4:return new t(e[0],e[1],e[2],e[3]);case 5:return new t(e[0],e[1],e[2],e[3],e[4]);case 6:return new t(e[0],e[1],e[2],e[3],e[4],e[5]);case 7:return new t(e[0],e[1],e[2],e[3],e[4],e[5],e[6])}var n=o(t.prototype),i=t.apply(n,e);return r(i)?i:n}}var o=t(99),r=t(145);e.exports=i},{145:145,99:99}],115:[function(t,e,n){(function(n){function i(t,e,E,w,A,C,N,T,I,S){function x(){for(var f=arguments.length,m=f,y=Array(f);m--;)y[m]=arguments[m];if(w&&(y=r(y,w,A)),C&&(y=s(y,C,N)),D||U){var _=x.placeholder,F=l(y,_);if(f-=F.length,S>f){var k=T?o(T):void 0,B=b(S-f,0),j=D?F:void 0,V=D?void 0:F,H=D?y:void 0,z=D?void 0:y;e|=D?g:v,e&=~(D?v:g),M||(e&=~(p|d));var Y=[t,e,E,H,j,z,V,k,I,B],G=i.apply(void 0,Y);return c(t)&&h(G,Y),G.placeholder=_,G}}var W=O?E:this,q=R?W[t]:t;return T&&(y=u(y,T)),P&&I<y.length&&(y.length=I),this&&this!==n&&this instanceof x&&(q=L||a(t)),q.apply(W,y)}var P=e&_,O=e&p,R=e&d,D=e&m,M=e&f,U=e&y,L=R?void 0:a(t);return x}var o=t(92),r=t(109),s=t(110),a=t(114),c=t(128),u=t(134),l=t(135),h=t(136),p=1,d=2,f=4,m=8,y=16,g=32,v=64,_=128,b=Math.max;e.exports=i}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{109:109,110:110,114:114,128:128,134:134,135:135,136:136,92:92}],116:[function(t,e,n){(function(n){function i(t,e,i,s){function a(){for(var e=-1,o=arguments.length,r=-1,l=s.length,h=Array(l+o);++r<l;)h[r]=s[r];for(;o--;)h[r++]=arguments[++e];var p=this&&this!==n&&this instanceof a?u:t;return p.apply(c?i:this,h)}var c=e&r,u=o(t);return a}var o=t(114),r=1;e.exports=i}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{114:114}],117:[function(t,e,n){function i(t,e,n,i,g,v,_,b){var E=e&p;if(!E&&"function"!=typeof t)throw new TypeError(m);var w=i?i.length:0;if(w||(e&=~(d|f),i=g=void 0),w-=g?g.length:0,e&f){var A=i,C=g;i=g=void 0}var N=E?void 0:c(t),T=[t,e,n,i,g,A,C,v,_,b];if(N&&(u(T,N),e=T[1],b=T[9]),T[9]=null==b?E?0:t.length:y(b-w,0)||0,e==h)var I=r(T[0],T[2]);else I=e!=d&&e!=(h|d)||T[4].length?s.apply(void 0,T):a.apply(void 0,T);var S=N?o:l;return S(I,T)}var o=t(106),r=t(113),s=t(115),a=t(116),c=t(118),u=t(131),l=t(136),h=1,p=2,d=32,f=64,m="Expected a function",y=Math.max;e.exports=i},{106:106,113:113,115:115,116:116,118:118,131:131,136:136}],118:[function(t,e,n){var i=t(132),o=t(153),r=i?function(t){return i.get(t)}:o;e.exports=r},{132:132,153:153}],119:[function(t,e,n){function i(t){for(var e=t.name+"",n=o[e],i=n?n.length:0;i--;){var r=n[i],s=r.func;if(null==s||s==t)return r.name}return e}var o=t(133);e.exports=i},{133:133}],120:[function(t,e,n){var i=t(105),o=i("length");e.exports=o},{105:105}],121:[function(t,e,n){function i(t,e){var n=null==t?void 0:t[e];return o(n)?n:void 0}var o=t(144);e.exports=i},{144:144}],122:[function(t,e,n){function i(t){var e=t.length,n=new t.constructor(e);return e&&"string"==typeof t[0]&&r.call(t,"index")&&(n.index=t.index,n.input=t.input),n}var o=Object.prototype,r=o.hasOwnProperty;e.exports=i},{}],123:[function(t,e,n){function i(t,e,n){var i=t.constructor;switch(e){case l:return o(t);case r:case s:return new i(+t);case h:case p:case d:case f:case m:case y:case g:case v:case _:var E=t.buffer;return new i(n?o(E):E,t.byteOffset,t.length);case a:case u:return new i(t);case c:var w=new i(t.source,b.exec(t));w.lastIndex=t.lastIndex}return w}var o=t(108),r="[object Boolean]",s="[object Date]",a="[object Number]",c="[object RegExp]",u="[object String]",l="[object ArrayBuffer]",h="[object Float32Array]",p="[object Float64Array]",d="[object Int8Array]",f="[object Int16Array]",m="[object Int32Array]",y="[object Uint8Array]",g="[object Uint8ClampedArray]",v="[object Uint16Array]",_="[object Uint32Array]",b=/\w*$/;e.exports=i},{108:108}],124:[function(t,e,n){function i(t){var e=t.constructor;return"function"==typeof e&&e instanceof e||(e=Object),new e}e.exports=i},{}],125:[function(t,e,n){function i(t){return null!=t&&r(o(t))}var o=t(120),r=t(129);e.exports=i},{120:120,129:129}],126:[function(t,e,n){function i(t,e){return t="number"==typeof t||o.test(t)?+t:-1,e=null==e?r:e,t>-1&&t%1==0&&e>t}var o=/^\d+$/,r=9007199254740991;e.exports=i},{}],127:[function(t,e,n){function i(t,e,n){if(!s(n))return!1;var i=typeof e;if("number"==i?o(n)&&r(e,n.length):"string"==i&&e in n){var a=n[e];return t===t?t===a:a!==a}return!1}var o=t(125),r=t(126),s=t(145);e.exports=i},{125:125,126:126,145:145}],128:[function(t,e,n){function i(t){var e=s(t),n=a[e];if("function"!=typeof n||!(e in o.prototype))return!1;if(t===n)return!0;var i=r(n);return!!i&&t===i[0]}var o=t(90),r=t(118),s=t(119),a=t(85);e.exports=i},{118:118,119:119,85:85,90:90}],129:[function(t,e,n){function i(t){return"number"==typeof t&&t>-1&&t%1==0&&o>=t}var o=9007199254740991;e.exports=i},{}],130:[function(t,e,n){function i(t){return!!t&&"object"==typeof t}e.exports=i},{}],131:[function(t,e,n){function i(t,e){var n=t[1],i=e[1],m=n|i,y=h>m,g=i==h&&n==l||i==h&&n==p&&t[7].length<=e[8]||i==(h|p)&&n==l;if(!y&&!g)return t;i&c&&(t[2]=e[2],m|=n&c?0:u);var v=e[3];if(v){var _=t[3];t[3]=_?r(_,v,e[4]):o(v),t[4]=_?a(t[3],d):o(e[4])}return v=e[5],v&&(_=t[5],t[5]=_?s(_,v,e[6]):o(v),t[6]=_?a(t[5],d):o(e[6])),v=e[7],v&&(t[7]=o(v)),i&h&&(t[8]=null==t[8]?e[8]:f(t[8],e[8])),null==t[9]&&(t[9]=e[9]),t[0]=e[0],t[1]=m,t}var o=t(92),r=t(109),s=t(110),a=t(135),c=1,u=4,l=8,h=128,p=256,d="__lodash_placeholder__",f=Math.min;e.exports=i},{109:109,110:110,135:135,92:92}],132:[function(t,e,n){(function(n){var i=t(121),o=i(n,"WeakMap"),r=o&&new o;e.exports=r}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{121:121}],133:[function(t,e,n){var i={};e.exports=i},{}],134:[function(t,e,n){function i(t,e){for(var n=t.length,i=s(e.length,n),a=o(t);i--;){var c=e[i];t[i]=r(c,n)?a[c]:void 0}return t}var o=t(92),r=t(126),s=Math.min;e.exports=i},{126:126,92:92}],135:[function(t,e,n){function i(t,e){for(var n=-1,i=t.length,r=-1,s=[];++n<i;)t[n]===e&&(t[n]=o,s[++r]=n);return s}var o="__lodash_placeholder__";e.exports=i},{}],136:[function(t,e,n){var i=t(106),o=t(86),r=150,s=16,a=function(){var t=0,e=0;return function(n,a){var c=o(),u=s-(c-e);if(e=c,u>0){if(++t>=r)return n}else t=0;return i(n,a)}}();e.exports=a},{106:106,86:86}],137:[function(t,e,n){function i(t){for(var e=c(t),n=e.length,i=n&&t.length,u=!!i&&a(i)&&(r(t)||o(t)),h=-1,p=[];++h<n;){var d=e[h];(u&&s(d,i)||l.call(t,d))&&p.push(d)}return p}var o=t(141),r=t(142),s=t(126),a=t(129),c=t(151),u=Object.prototype,l=u.hasOwnProperty;e.exports=i},{126:126,129:129,141:141,142:142,151:151}],138:[function(t,e,n){function i(t){return o(t)?t:Object(t)}var o=t(145);e.exports=i},{145:145}],139:[function(t,e,n){function i(t){return t instanceof o?t.clone():new r(t.__wrapped__,t.__chain__,s(t.__actions__))}var o=t(90),r=t(91),s=t(92);e.exports=i},{90:90,91:91,92:92}],140:[function(t,e,n){function i(t,e,n){return"function"==typeof e?o(t,!0,r(e,n,3)):o(t,!0)}var o=t(97),r=t(107);e.exports=i},{107:107,97:97}],141:[function(t,e,n){function i(t){return r(t)&&o(t)&&a.call(t,"callee")&&!c.call(t,"callee")}var o=t(125),r=t(130),s=Object.prototype,a=s.hasOwnProperty,c=s.propertyIsEnumerable;e.exports=i},{125:125,130:130}],142:[function(t,e,n){var i=t(121),o=t(129),r=t(130),s="[object Array]",a=Object.prototype,c=a.toString,u=i(Array,"isArray"),l=u||function(t){return r(t)&&o(t.length)&&c.call(t)==s};e.exports=l},{121:121,129:129,130:130}],143:[function(t,e,n){function i(t){return o(t)&&a.call(t)==r}var o=t(145),r="[object Function]",s=Object.prototype,a=s.toString;e.exports=i},{145:145}],144:[function(t,e,n){function i(t){return null==t?!1:o(t)?l.test(c.call(t)):r(t)&&s.test(t)}var o=t(143),r=t(130),s=/^\[object .+?Constructor\]$/,a=Object.prototype,c=Function.prototype.toString,u=a.hasOwnProperty,l=RegExp("^"+c.call(u).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");e.exports=i},{130:130,143:143}],145:[function(t,e,n){function i(t){var e=typeof t;return!!t&&("object"==e||"function"==e)}e.exports=i},{}],146:[function(t,e,n){function i(t){return"string"==typeof t||o(t)&&a.call(t)==r}var o=t(130),r="[object String]",s=Object.prototype,a=s.toString;e.exports=i},{130:130}],147:[function(t,e,n){var i=t(95),o=t(96),r=t(111),s=r(function(t,e,n){return n?i(t,e,n):o(t,e)});e.exports=s},{111:111,95:95,96:96}],148:[function(t,e,n){function i(t,e,n){var i=r(t);return n&&s(t,e,n)&&(e=void 0),e?o(i,e):i}var o=t(96),r=t(99),s=t(127);e.exports=i},{127:127,96:96,99:99}],149:[function(t,e,n){function i(t){return o(t,r(t))}var o=t(103),r=t(151);e.exports=i},{103:103,151:151}],150:[function(t,e,n){var i=t(121),o=t(125),r=t(145),s=t(137),a=i(Object,"keys"),c=a?function(t){var e=null==t?void 0:t.constructor;return"function"==typeof e&&e.prototype===t||"function"!=typeof t&&o(t)?s(t):r(t)?a(t):[]}:s;e.exports=c},{121:121,125:125,137:137,145:145}],151:[function(t,e,n){function i(t){if(null==t)return[];c(t)||(t=Object(t));var e=t.length;e=e&&a(e)&&(r(t)||o(t))&&e||0;for(var n=t.constructor,i=-1,u="function"==typeof n&&n.prototype===t,h=Array(e),p=e>0;++i<e;)h[i]=i+"";for(var d in t)p&&s(d,e)||"constructor"==d&&(u||!l.call(t,d))||h.push(d);return h}var o=t(141),r=t(142),s=t(126),a=t(129),c=t(145),u=Object.prototype,l=u.hasOwnProperty;e.exports=i},{126:126,129:129,141:141,142:142,145:145}],152:[function(t,e,n){function i(t){return t}e.exports=i},{}],153:[function(t,e,n){function i(){}e.exports=i},{}],154:[function(t,e,n){function i(t){try{return Array.prototype.slice.call(t)}catch(e){for(var n=[],i=0;i<t.length;i++)n.push(t[i]);return n}}"undefined"!=typeof e&&(e.exports=i)},{}],155:[function(t,e,n){"use strict";function i(t){if(t=t||{},this.channel=t.channel,!this.channel)throw new Error("Channel ID must be specified");this.merchantUrl=t.merchantUrl,this._isDestroyed=!1,this._isVerbose=!1,this._listeners=[],this._log("new bus on channel "+this.channel,[location.href])}var o=t(81),r=t(157),s=t(156).checkOrigin;i.prototype.on=function(t,e){var n,i,r=e,a=this;this._isDestroyed||(this.merchantUrl&&(r=function(){s(this.origin,a.merchantUrl)&&e.apply(this,arguments)}),n=this._namespaceEvent(t),i=Array.prototype.slice.call(arguments),i[0]=n,i[1]=r,this._log("on",i),o.on.apply(o,i),this._listeners.push({eventName:t,handler:r,originalHandler:e}))},i.prototype.emit=function(t){var e;this._isDestroyed||(e=Array.prototype.slice.call(arguments),e[0]=this._namespaceEvent(t),this._log("emit",e),o.emit.apply(o,e))},i.prototype._offDirect=function(t){var e=Array.prototype.slice.call(arguments);this._isDestroyed||(e[0]=this._namespaceEvent(t),this._log("off",e),o.off.apply(o,e))},i.prototype.off=function(t,e){var n,i,o=e;if(!this._isDestroyed){if(this.merchantUrl)for(n=0;n<this._listeners.length;n++)i=this._listeners[n],i.originalHandler===e&&(o=i.handler);this._offDirect(t,o)}},i.prototype._namespaceEvent=function(t){return["braintree",this.channel,t].join(":")},i.prototype.teardown=function(){var t,e;for(e=0;e<this._listeners.length;e++)t=this._listeners[e],this._offDirect(t.eventName,t.handler);this._listeners.length=0,this._isDestroyed=!0},i.prototype._log=function(t,e){this._isVerbose&&console.log(t,e)},i.events=r,e.exports=i},{156:156,157:157,81:81}],156:[function(t,e,n){"use strict";function i(t,e){var n,i,r=document.createElement("a");return r.href=e,i="https:"===r.protocol?r.host.replace(/:443$/,""):"http:"===r.protocol?r.host.replace(/:80$/,""):r.host,n=r.protocol+"//"+i,n===t||o.test(t)}var o=/^https:\/\/([a-zA-Z0-9-]+\.)*(braintreepayments|braintreegateway|paypal)\.com(:\d{1,5})?$/;e.exports={checkOrigin:i}},{}],157:[function(t,e,n){"use strict";var i,o,r=["PAYMENT_METHOD_REQUEST","PAYMENT_METHOD_RECEIVED","PAYMENT_METHOD_GENERATED","PAYMENT_METHOD_NOT_GENERATED","PAYMENT_METHOD_CANCELLED","PAYMENT_METHOD_ERROR","CONFIGURATION_REQUEST","ROOT_METADATA_REQUEST","ERROR","WARNING","UI_POPUP_DID_OPEN","UI_POPUP_DID_CLOSE","UI_POPUP_FORCE_CLOSE","ASYNC_DEPENDENCY_INITIALIZING","ASYNC_DEPENDENCY_READY","USER_FORM_SUBMIT_REQUEST","SEND_ANALYTICS_EVENTS"],s={};for(i=0;i<r.length;i++)o=r[i],s[o]=o;e.exports=s},{}],158:[function(t,e,n){"use strict";function i(t){var e,n={};if(t){for(e in t)t.hasOwnProperty(e)&&(n[o(e)]=t[e]);return n}}function o(t){return t.replace(/([A-Z])/g,function(t){return"_"+t.toLowerCase()})}e.exports={convertToLegacyShippingAddress:i}},{}],159:[function(t,e,n){"use strict";e.exports={ROOT_SUCCESS_CALLBACK:"onPaymentMethodReceived",ROOT_ERROR_CALLBACK:"onError",ROOT_READY_CALLBACK:"onReady",TEARDOWN_STATE:{IN_PROGRESS:"inProgress",COMPLETE:"complete"}}},{}],160:[function(t,e,n){(function(n){"use strict";function i(){}function o(t){t.paypal=t.paypal||{}}function r(){this._dependenciesRemaining++}function s(){this._dependenciesRemaining--,0===this._dependenciesRemaining&&(delete this._dependenciesRemaining,this.bus.off(l.events.ASYNC_DEPENDENCY_INITIALIZING,this._handleDependencyInitializing),this.bus.off(l.events.ASYNC_DEPENDENCY_READY,this._handleDependencyReady),this._onIntegrationReady())}function a(t){this.configuration=t,this.isReady=!1,this.destructor=new h,this.bus=new l({channel:this.configuration.channel,merchantUrl:n.location.href}),this.apiClient=new u.Client(this.configuration),this._configureCallbacks(),this._configureAnalytics(),this._attachEvents(),this._emitInitializing()}var c=t(166).cloneAndStripDOM,u=t(14),l=t(155),h=t(77),p=t(87),d=t(159),f=t(171),m=t(169),y=t(167),g=t(185);a.prototype._emitInitializing=function(){this.bus.emit(l.events.ASYNC_DEPENDENCY_INITIALIZING)},a.prototype._configureCallbacks=function(){function t(t){return function(e){t(f(e))}}var e=m(this.configuration.merchantConfiguration);this.onSuccess=t(e(d.ROOT_SUCCESS_CALLBACK)),
this.onError=e(d.ROOT_ERROR_CALLBACK,y),this.onReady=e(d.ROOT_READY_CALLBACK)},a.prototype._configureAnalytics=function(){var t="web."+this.configuration.integrationType+".",e=this.apiClient;this.bus.on(l.events.SEND_ANALYTICS_EVENTS,function(n,i){var o;for(n instanceof Array||(n=[n]),o=0;o<n.length;o++)n[o]=t+n[o];e.sendAnalyticsEvents(n,i)})},a.prototype._attachEvents=function(){var t=c(this.configuration);"dropin"===t.integrationType&&o(t.merchantConfiguration),this.bus.on(l.events.ERROR,this.onError),this.bus.on(l.events.PAYMENT_METHOD_RECEIVED,this.onSuccess),this.bus.on(l.events.WARNING,function(t){try{console.warn(t)}catch(e){}}),this.bus.on(l.events.CONFIGURATION_REQUEST,function(e){e(t)}),this._dependenciesRemaining=0,this._handleDependencyInitializing=p(r,this),this._handleDependencyReady=p(s,this),this.bus.on(l.events.ASYNC_DEPENDENCY_INITIALIZING,this._handleDependencyInitializing),this.bus.on(l.events.ASYNC_DEPENDENCY_READY,this._handleDependencyReady)},a.prototype._addDeviceData=function(t){var e;if(null!=this.configuration.merchantConfiguration.dataCollector){try{e=g.setup(this.configuration.merchantConfiguration.dataCollector)}catch(n){this.bus.emit(l.events.ERROR,{type:"CONFIGURATION",message:n.message})}null!=e&&(this.destructor.registerFunctionForTeardown(function(){e.teardown()}),t.deviceData=e.deviceData)}},a.prototype.teardown=function(t){if(this.teardownState===d.TEARDOWN_STATE.IN_PROGRESS)throw new Error("Cannot call teardown while in progress");if(this.teardownState===d.TEARDOWN_STATE.COMPLETE)throw new Error("Cannot teardown integration more than once");this.teardownMerchantCallback=t||i,this.teardownState=d.TEARDOWN_STATE.IN_PROGRESS,this.destructor.teardown(p(this._handleTeardown,this))},a.prototype._handleTeardown=function(){this.bus.teardown(),this.teardownState=d.TEARDOWN_STATE.COMPLETE,this.teardownMerchantCallback()},a.prototype._wrapWithTeardownReply=function(t,e){var n=this;return function(){if(n.teardownState===d.TEARDOWN_STATE.IN_PROGRESS)throw new Error("Cannot call "+t+" while teardown is in progress");if(n.teardownState===d.TEARDOWN_STATE.COMPLETE)throw new Error("Cannot call "+t+" after teardown has completed");e()}},a.prototype._onIntegrationReady=function(t){this.returnedInstance=t||{},this.returnedInstance.teardown=p(this.teardown,this),this._addDeviceData(this.returnedInstance),this.isReady=!0,this.onReady(this.returnedInstance)},e.exports=a}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{14:14,155:155,159:159,166:166,167:167,169:169,171:171,185:185,77:77,87:87}],161:[function(t,e,n){"use strict";function i(){var t,e;u.apply(this,arguments),e=o(this.configuration),e.apiClient=this.apiClient,this._attachBusEvents(),t=a.create(e),null!=t&&this.destructor.registerFunctionForTeardown(function(e){t.teardown(e)}),this.bus.emit(c.events.ASYNC_DEPENDENCY_READY)}var o=t(166).cloneAndPreserveDOM,r=t(148),s=t(87),a=t(173),c=t(155),u=t(160);i.prototype=r(u.prototype,{constructor:i}),i.prototype._attachBusEvents=function(){this.bus.on(c.events.PAYMENT_METHOD_GENERATED,s(this._onPaymentMethodGenerated,this))},i.prototype._onPaymentMethodGenerated=function(t){this.bus.emit(c.events.PAYMENT_METHOD_RECEIVED,t)},e.exports=i},{148:148,155:155,160:160,166:166,173:173,87:87}],162:[function(t,e,n){"use strict";function i(){g.apply(this,arguments),null!=this.configuration.merchantConfiguration.hostedFields?this._setupHostedFields():this._setupForm(),this._setupPayPal(),this._setupCoinbase(),this.bus.emit(m.events.ASYNC_DEPENDENCY_READY)}function o(t,e){return function(n){return e in t&&h(t[e][n])?t[e][n]:function(){}}}var r=t(166).cloneAndPreserveDOM,s=t(148),a=t(194),c=t(206),u=t(173),l=t(87),h=t(143),p=t(200),d=t(80),f=t(159),m=t(155),y=t(158).convertToLegacyShippingAddress,g=t(160),v=t(168);i.prototype=s(g.prototype,{constructor:i}),i.prototype._setupHostedFields=function(){var t,e=this.configuration.merchantConfiguration,n=e[f.ROOT_SUCCESS_CALLBACK],i=new d(e.id),o=p.create(this.configuration),r=new v({formNapper:i,rootCallback:n,channel:this.configuration.channel});return null==i.htmlForm?void this.bus.emit(m.events.ERROR,{type:"CONFIGURATION",message:"options.id does not reference a valid DOM element"}):(t=l(r.handleSubmitRequest,r),i.hijack(t),this.bus.on(m.events.USER_FORM_SUBMIT_REQUEST,t),void this.destructor.registerFunctionForTeardown(l(function(t){r.teardown(),i.detach(),o.teardown(t)},this)))},i.prototype._setupForm=function(){var t,e,n,i=this.configuration.merchantConfiguration;i.id?(n=a.setup(this.apiClient,this.configuration),t=!h(i[f.ROOT_SUCCESS_CALLBACK]),t||(e=this.onSuccess,n.onNonceReceived=l(function(t,n){t?this.bus.emit(m.events.ERROR,t):e(n)},this)),this.destructor.registerFunctionForTeardown(function(){n.teardown()})):this.bus.on(m.events.PAYMENT_METHOD_GENERATED,l(function(t){this.bus.emit(m.events.PAYMENT_METHOD_RECEIVED,t)},this))},i.prototype._setupPayPal=function(){var t,e,n,i,s,a,u;this.configuration.merchantConfiguration.paypal&&(t=r(this.configuration),u=t.merchantConfiguration,a=u.paypal,e=o(u,"paypal"),n=e("onSuccess"),i=e("onCancelled"),a.paymentMethodNonceInputField||(s=document.createElement("input"),s.id="braintree-custom-integration-dummy-input",a.paymentMethodNonceInputField=s),a.onSuccess=function(t){n(t.nonce,t.details.email,y(t.details.shippingAddress))},a.onCancelled=function(){i()},u.enableCORS&&(a.enableCORS=!0),this.paypalIntegration=c.create(t),null!=this.paypalIntegration&&this.destructor.registerFunctionForTeardown(l(function(){this.paypalIntegration.teardown()},this)))},i.prototype._setupCoinbase=function(){var t,e;this.configuration.merchantConfiguration.coinbase&&(navigator.userAgent.match(/MSIE 8\.0/)||(t=r(this.configuration),t.apiClient=this.apiClient,e=u.create(t),null!=e&&this.destructor.registerFunctionForTeardown(function(t){e.teardown(t)})))},i.prototype._onIntegrationReady=function(){var t=this,e={};this.paypalIntegration&&(e.paypal={initAuthFlow:this._wrapWithTeardownReply("initAuthFlow",function(){t.bus.emit(m.events.SEND_ANALYTICS_EVENTS,"paypal.auth.init"),t.paypalIntegration.initAuthFlow()}),closeAuthFlow:this._wrapWithTeardownReply("closeAuthFlow",function(){t.bus.emit(m.events.SEND_ANALYTICS_EVENTS,"paypal.auth.close"),t.paypalIntegration.closeAuthFlow()})}),g.prototype._onIntegrationReady.call(this,e)},e.exports=i},{143:143,148:148,155:155,158:158,159:159,160:160,166:166,168:168,173:173,194:194,200:200,206:206,80:80,87:87}],163:[function(t,e,n){"use strict";function i(t){return l(t.paymentMethodNonceReceived)?t.paymentMethodNonceReceived:null}function o(t){return l(t[p.ROOT_SUCCESS_CALLBACK])}function r(){var t,e,n,r,a;f.apply(this,arguments),a=s(this.configuration),t=a.merchantConfiguration,e=i(t),n=o(t),(e||n)&&(t.paymentMethodNonceReceived=u(function(t){e&&e(t.originalEvent,t.nonce),this.bus.emit(h.events.PAYMENT_METHOD_RECEIVED,d(t))},this)),r=c.create(a),this.destructor.registerFunctionForTeardown(function(t){r.teardown(t)}),this.bus.emit(h.events.ASYNC_DEPENDENCY_READY)}var s=t(166).cloneAndPreserveDOM,a=t(148),c=t(192),u=t(87),l=t(143),h=t(155),p=t(159),d=t(171),f=t(160);r.prototype=a(f.prototype,{constructor:r}),e.exports=r},{143:143,148:148,155:155,159:159,160:160,166:166,171:171,192:192,87:87}],164:[function(t,e,n){"use strict";e.exports={custom:t(162),dropin:t(163),paypal:t(165),coinbase:t(161)}},{161:161,162:162,163:163,165:165}],165:[function(t,e,n){"use strict";function i(t){return"onSuccess"in t&&l(t.onSuccess)?t.onSuccess:"paypal"in t&&l(t.paypal.onSuccess)?t.paypal.onSuccess:null}function o(t){return l(t[h.ROOT_SUCCESS_CALLBACK])}function r(t){var e,n,r,a;t=s(t),t.merchantConfiguration.paypal=t.merchantConfiguration.paypal||{};for(a in t.merchantConfiguration)t.merchantConfiguration.hasOwnProperty(a)&&"paypal"!==a&&(t.merchantConfiguration.paypal[a]=t.merchantConfiguration[a]);f.call(this,t),e=this.configuration.merchantConfiguration,n=i(e),r=o(e),(n||r)&&(e.paypal.onSuccess=u(function(t){n&&n(t.nonce,t.details.email,d(t.details.shippingAddress)),this.bus.emit(p.events.PAYMENT_METHOD_RECEIVED,t)},this)),this.paypalIntegration=c.create(this.configuration),this.destructor.registerFunctionForTeardown(u(function(){this.paypalIntegration.teardown()},this)),this.bus.emit(p.events.ASYNC_DEPENDENCY_READY)}var s=t(166).cloneAndPreserveDOM,a=t(148),c=t(206),u=t(87),l=t(143),h=t(159),p=t(155),d=t(158).convertToLegacyShippingAddress,f=t(160);r.prototype=a(f.prototype,{constructor:r}),r.prototype._onIntegrationReady=function(){var t=this,e={};this.paypalIntegration&&(e.paypal={initAuthFlow:this._wrapWithTeardownReply("initAuthFlow",function(){t.bus.emit(p.events.SEND_ANALYTICS_EVENTS,"paypal.auth.init"),t.paypalIntegration.initAuthFlow()}),closeAuthFlow:this._wrapWithTeardownReply("closeAuthFlow",function(){t.bus.emit(p.events.SEND_ANALYTICS_EVENTS,"paypal.auth.close"),t.paypalIntegration.closeAuthFlow()})}),f.prototype._onIntegrationReady.call(this,e)},e.exports=r},{143:143,148:148,155:155,158:158,159:159,160:160,166:166,206:206,87:87}],166:[function(t,e,n){"use strict";function i(t){return r(t,function(t){return a(t)?t.get(0):c(t)?t:void 0})}function o(t){return r(t,function(t){return a(t)||c(t)?{}:void 0})}var r=t(140),s=t(170),a=s.isJQueryElement,c=s.isHTMLElement;e.exports={cloneAndPreserveDOM:i,cloneAndStripDOM:o}},{140:140,170:170}],167:[function(t,e,n){"use strict";e.exports=function(t){if("CONFIGURATION"===t.type||"IMMEDIATE"===t.type)throw new Error(t.message);try{console.error(-1===navigator.userAgent.indexOf("MSIE")?t:JSON.stringify(t,null,2))}catch(e){}}},{}],168:[function(t,e,n){"use strict";function i(t){this.paymentMethod=null,this.nonceInputElement=null,this.bus=new o({channel:t.channel}),this.formNapper=t.formNapper,this.rootCallback=t.rootCallback,this._attachEvents()}var o=t(155),r=t(200),s="web.custom.hosted-fields.via.",a="payment_method_nonce";i.prototype._shouldStrictlyValidate=function(t){return null!=t?!1:null==this.paymentMethod||"CreditCard"===this.paymentMethod.type},i.prototype._clearNonce=function(){this.paymentMethod&&this.paymentMethod.nonce&&(this.paymentMethod=null,this.nonceInputElement=this.formNapper.inject(a,""))},i.prototype._attachEvents=function(){var t=this;this.bus.on(o.events.PAYMENT_METHOD_CANCELLED,function(){t._clearNonce()}),this.bus.on(o.events.PAYMENT_METHOD_GENERATED,function(e){t.paymentMethod=e,t.nonceInputElement=t.formNapper.inject(a,t.paymentMethod.nonce)})},i.prototype.handleSubmitRequest=function(){var t=this;this.bus.emit(r.events.TOKENIZATION_REQUEST,function(e){var n=e[0],i=e[1];return n?void t.bus.emit(o.events.ERROR,n):(t.paymentMethod=i||t.paymentMethod,t._shouldStrictlyValidate(i)?(t.bus.emit(r.events.VALIDATE_STRICT),void t.bus.emit(o.events.ERROR,{type:"VALIDATION",message:"User did not enter a payment method"})):void(t.rootCallback?t.bus.emit(o.events.SEND_ANALYTICS_EVENTS,s+"callback.success",function(){t.rootCallback(t.paymentMethod)}):t.bus.emit(o.events.SEND_ANALYTICS_EVENTS,s+"formsubmit.success",function(){t.nonceInputElement=t.formNapper.inject(a,t.paymentMethod.nonce),t.formNapper.submit()})))})},i.prototype.teardown=function(){this._clearNonce()},e.exports=i},{155:155,200:200}],169:[function(t,e,n){"use strict";function i(){}var o=t(143);e.exports=function(t){return function(e,n){return o(t[e])?t[e]:o(n)?n:i}}},{143:143}],170:[function(t,e,n){"use strict";function i(t){return Boolean(t)&&"object"==typeof t&&"jquery"in t}function o(t){return Boolean(t)&&1===t.nodeType}e.exports={isJQueryElement:i,isHTMLElement:o}},{}],171:[function(t,e,n){"use strict";e.exports=function(t){return{nonce:t.nonce,details:t.details,type:t.type}}},{}],172:[function(t,e,n){(function(n){"use strict";function i(t,e,i){var s;if(!c.hasOwnProperty(e))throw new Error(e+" is an unsupported integration");i=i||{},s=p.uuid(),r._getConfiguration({enableCORS:i.enableCORS||!1,authorization:t,sessionId:s},function(r,a){var d;return r?(d=h(i)(u.ROOT_ERROR_CALLBACK,l),void d({message:r.errors})):void new c[e]({channel:s,authorization:t,gatewayConfiguration:a,integrationType:e,merchantConfiguration:i,analyticsConfiguration:{sdkVersion:"braintree/web/"+o,merchantAppId:n.location.host},isMerchantPageHttps:p.isBrowserHttps()})})}var o="2.18.0",r=t(14),s=t(206),a=t(192),c=t(164),u=t(159),l=t(167),h=t(169),p=t(73),d=t(185);e.exports={api:r,data:d,cse:n.Braintree,paypal:s,dropin:a,hostedFields:{VERSION:t(200).VERSION},setup:i,VERSION:o}}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{14:14,159:159,164:164,167:167,169:169,185:185,192:192,200:200,206:206,73:73}],173:[function(t,e,n){"use strict";function i(t){var e=new o(t);return e.canCreateIntegration?e:null}var o=t(176);e.exports={create:i}},{176:176}],174:[function(t,e,n){(function(t){"use strict";function n(e){return e=e||t.navigator.userAgent,/AppleWebKit\//.test(e)&&/Mobile\//.test(e)?e.replace(/.* OS ([0-9_]+) like Mac OS X.*/,"$1").replace(/_/g,"."):null}function i(e){var n=e||t.navigator.userAgent,i=null,o=/MSIE.(\d+)/.exec(n);return/Trident/.test(n)&&(i=11),o&&(i=parseInt(o[1],10)),i}function o(e){return e=e||t.navigator.userAgent,/Android/.test(e)?e.replace(/^.* Android ([0-9\.]+).*$/,"$1"):null}e.exports={ieVersion:i,iOSSafariVersion:n,androidVersion:o}}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],175:[function(t,e,n){"use strict";function i(t,e,n){return t?(n.bus.emit(o.ERROR,t.error),void n.bus.emit(o.SEND_ANALYTICS_EVENTS,"coinbase.generate.nonce.failed")):(n.bus.emit(o.PAYMENT_METHOD_GENERATED,e),void n.bus.emit(o.SEND_ANALYTICS_EVENTS,"coinbase.generate.nonce.succeeded"))}var o=t(155).events;e.exports={tokenize:i}},{155:155}],176:[function(t,e,n){(function(n){"use strict";function i(t){return{clientId:t.gatewayConfiguration.coinbase.clientId,redirectUrl:t.gatewayConfiguration.coinbase.redirectUrl,scopes:t.gatewayConfiguration.coinbase.scopes||d.SCOPES,meta:{authorizations_merchant_account:t.gatewayConfiguration.coinbase.merchantAccount||""}}}function o(t){return function(e,n){t.emit(m.events.ERROR,{type:n,message:e})}}function r(t,e){var n=(t.merchantConfiguration||{}).coinbase,i=o(e);if(null==t.apiClient)i("apiClient is required for coinbase",d.CONFIGURATION_ERROR);else if(t.gatewayConfiguration.coinbaseEnabled)if(n&&(n.container||n.button))if(n.container&&n.button)i("options.coinbase.container and options.coinbase.button are mutually exclusive",d.CONFIGURATION_ERROR);else{if(f.isSupportedBrowser())return!0;i("Coinbase is not supported by your browser. Please consider upgrading",d.UNSUPPORTED_BROWSER_ERROR)}else i("Either options.coinbase.container or options.coinbase.button is required for Coinbase integrations",d.CONFIGURATION_ERROR);else i("Coinbase is not enabled for your merchant account",d.CONFIGURATION_ERROR);return!1}function s(t){var e,o,s=this;this.configuration=t,this.destructor=new u,o={channel:t.channel};try{t.coinbase.container&&(o.merchantUrl=n.location.href)}catch(l){}this.bus=t.bus||new m(o),this.canCreateIntegration=r(t,this.bus),this.canCreateIntegration&&(this.buttonId=t.merchantConfiguration.coinbase.button||d.BUTTON_ID,this.apiClient=t.apiClient||new y.Client(t),this._onOAuthSuccess=a(this._onOAuthSuccess,this),this._handleButtonClick=a(this._handleButtonClick,this),this.popupParams=i(t),this.redirectDoneInterval=null,t.merchantConfiguration.coinbase.container?(e=c.normalizeElement(t.merchantConfiguration.coinbase.container),this._insertFrame(e)):(n.braintreeCoinbasePopupCallback=this._onOAuthSuccess,e=document.body,c.addEventListener(e,"click",this._handleButtonClick),this.bus.emit(m.events.SEND_ANALYTICS_EVENTS,"coinbase.initialized"),this.destructor.registerFunctionForTeardown(function(){s._closePopup()}),this.bus.on(d.TEARDOWN_EVENT,a(this.destructor.teardown,this.destructor))))}var a=t(87),c=t(73),u=t(77),l=t(180),h=t(183),p=t(175),d=t(177),f=t(178),m=t(155),y=t(14);s.prototype._insertFrame=function(t){var e=this,n=l.createFrame({channel:this.configuration.channel});this.bus.emit(m.events.ASYNC_DEPENDENCY_INITIALIZING),t.appendChild(n),this.destructor.registerFunctionForTeardown(function(){t.removeChild(n)}),setTimeout(function(){n.src=e.configuration.gatewayConfiguration.assetsUrl+"/coinbase/"+d.VERSION+"/coinbase-frame.html#"+e.configuration.channel},0)},s.prototype._onOAuthSuccess=function(t){var e=this;return t.code?(this.bus.emit("coinbase:view:navigate","loading"),this.bus.emit(m.events.SEND_ANALYTICS_EVENTS,"coinbase.popup.authorized"),this.apiClient.tokenizeCoinbase({code:t.code,query:h.getQueryString()},function(t,n){p.tokenize.apply(null,[t,n,e])}),void this._closePopup()):(this.bus.emit(m.events.SEND_ANALYTICS_EVENTS,"coinbase.popup.denied"),void this._closePopup())},s.prototype._clearPollForRedirectDone=function(){this.redirectDoneInterval&&(clearInterval(this.redirectDoneInterval),this.redirectDoneInterval=null)},s.prototype._closePopup=function(t){t=t||this.popup,null!=t&&(f.shouldCloseFromParent()&&t.close(),this._popupCleanup())},s.prototype._popupCleanup=function(){this._clearPollForRedirectDone(),this.bus.emit(m.events.UI_POPUP_DID_CLOSE,{source:d.INTEGRATION_NAME})},s.prototype._pollForRedirectDone=function(t){var e=this,n=setInterval(function(){var n;if(null==t||t.closed)return e.bus.emit(m.events.SEND_ANALYTICS_EVENTS,"coinbase.popup.aborted"),void e._popupCleanup();try{if("about:blank"===t.location.href)throw new Error("Not finished loading");n=c.decodeQueryString(t.location.search.replace(/^\?/,"")).code}catch(i){return}e._onOAuthSuccess({code:n})},100);return this.redirectDoneInterval=n,n},s.prototype._openPopup=function(){var t;this.bus.emit(m.events.SEND_ANALYTICS_EVENTS,"coinbase.popup.started"),t=l.createPopup(h.compose(this._getOAuthBaseUrl(),this.popupParams)),t.focus(),this._pollForRedirectDone(t),this.bus.emit(m.events.UI_POPUP_DID_OPEN,{source:d.INTEGRATION_NAME}),this.bus.on(m.events.UI_POPUP_FORCE_CLOSE,function(e){e.target===d.INTEGRATION_NAME&&t.close()}),this.popup=t},s.prototype._getOAuthBaseUrl=function(){var t;return t="shared_sandbox"===this.configuration.gatewayConfiguration.coinbase.environment?d.SANDBOX_OAUTH_BASE_URL:d.PRODUCTION_OAUTH_BASE_URL},s.prototype._handleButtonClick=function(t){for(var e=t.target||t.srcElement;;){if(null==e)return;if(e===t.currentTarget)return;if(e.id===this.buttonId)break;e=e.parentNode}t&&t.preventDefault?t.preventDefault():t.returnValue=!1,this._openPopup()},s.prototype.teardown=function(t){var e=this;return this.canCreateIntegration?void this.bus.emit(d.TEARDOWN_EVENT,function(){e.destructor.teardown(function(n){return n?t(n):(e.bus.teardown(),void t(null))})}):void t(null)},e.exports=s}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{14:14,155:155,175:175,177:177,178:178,180:180,183:183,73:73,77:77,87:87}],177:[function(t,e,n){"use strict";e.exports={PRODUCTION_OAUTH_BASE_URL:"https://coinbase.com",SANDBOX_OAUTH_BASE_URL:"https://sandbox.coinbase.com",ORIGIN_URL:"https://www.coinbase.com",FRAME_NAME:"braintree-coinbase-frame",POPUP_NAME:"coinbase",BUTTON_ID:"bt-coinbase-button",SCOPES:"send",VERSION:"2.18.0",INTEGRATION_NAME:"Coinbase",CONFIGURATION_ERROR:"CONFIGURATION",UNSUPPORTED_BROWSER_ERROR:"UNSUPPORTED_BROWSER",TEARDOWN_EVENT:"coinbase:TEARDOWN"}},{}],178:[function(t,e,n){"use strict";function i(){var t=a.ieVersion();return!t||t>8}function o(){var t=a.androidVersion();return null==t?!1:/^5/.test(t)}function r(){return!(o()||s())}function s(){var t=a.iOSSafariVersion();return null==t?!1:/^8\.0/.test(t)||/^8\.1$/.test(t)}var a=t(174);e.exports={isSupportedBrowser:i,shouldCloseFromParent:r,shouldDisplayIOSClose:s,shouldDisplayLollipopClose:o}},{174:174}],179:[function(t,e,n){"use strict";function i(t){var e=document.createElement("button");return t=t||{},e.id=t.id||"coinbase-button",e.style.backgroundColor=t.backgroundColor||"#EEE",e.style.color=t.color||"#4597C3",e.style.border=t.border||"0",e.style.borderRadius=t.borderRadius||"6px",e.style.padding=t.padding||"12px",e.innerHTML=t.innerHTML||"coinbase",e}e.exports={create:i}},{}],180:[function(t,e,n){"use strict";var i=t(182),o=t(179),r=t(181);e.exports={createButton:o.create,createPopup:i.create,createFrame:r.create}},{179:179,181:181,182:182}],181:[function(t,e,n){"use strict";function i(){return r({name:o.FRAME_NAME,height:"70px",width:"100%",style:{padding:0,margin:0,border:0,outline:"none"}})}var o=t(177),r=t(82);e.exports={create:i}},{177:177,82:82}],182:[function(t,e,n){(function(n){"use strict";function i(t){var e,n=[];for(e in t)t.hasOwnProperty(e)&&n.push([e,t[e]].join("="));return n.join(",")}function o(){var t=580,e=810;return i({width:t,height:e,left:(screen.width-t)/2,top:(screen.height-e)/4})}function r(t){return n.open(t,s.POPUP_NAME,o())}var s=t(177);e.exports={create:r}}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{177:177}],183:[function(t,e,n){"use strict";function i(){return"version="+r.VERSION}function o(t,e){var n,o=t+"/oauth/authorize?response_type=code",r=e.redirectUrl+"?"+i();if(o+="&redirect_uri="+encodeURIComponent(r),o+="&client_id="+e.clientId,e.scopes&&(o+="&scope="+encodeURIComponent(e.scopes)),e.meta)for(n in e.meta)e.meta.hasOwnProperty(n)&&(o+="&meta["+encodeURIComponent(n)+"]="+encodeURIComponent(e.meta[n]));return o}var r=t(177);e.exports={compose:o,getQueryString:i}},{177:177}],184:[function(t,e,n){"use strict";function i(){return new o}function o(){this.sessionId=r(),this._beaconId=s(this.sessionId),this._parameterBlock=a(this.sessionId,this._beaconId),this._thirdPartyBlock=c()}function r(){var t,e="";for(t=0;32>t;t++)e+=Math.floor(16*Math.random()).toString(16);return e}function s(t){var e=(new Date).getTime()/1e3;return"https://b.stats.paypal.com/counter.cgi?i=127.0.0.1&p="+t+"&t="+e+"&a=14"}function a(t,e){var n=document.body.appendChild(document.createElement("script"));return n.type="application/json",n.setAttribute("fncls","fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99"),n.text=JSON.stringify({f:t,s:"BRAINTREE_SIGNIN",b:e}),n}function c(){function t(){n._l()}var e,n,i="https://www.paypalobjects.com/webstatic/r/fb/",o=document.createElement("iframe");o.src="about:blank",o.title="",o.role="presentation",(o.frameElement||o).style.cssText="width: 0; height: 0; border: 0",document.body.appendChild(o);try{n=o.contentWindow.document}catch(r){e=document.domain,o.src='javascript:var d=document.open();d.domain="'+e+'";void(0);',n=o.contentWindow.document}return n.open()._l=function(){var t=this.createElement("script");e&&(this.domain=e),t.id="js-iframe-async",t.src=i+"fb-all-prod.pp.min.js",this.body.appendChild(t)},o.addEventListener?o.addEventListener("load",t,!1):o.attachEvent?o.attachEvent("onload",t):n.write('<body onload="document._l();">'),n.close(),o}o.prototype.teardown=function(){this._thirdPartyBlock.parentNode.removeChild(this._thirdPartyBlock)},e.exports={setup:i}},{}],185:[function(t,e,n){"use strict";function i(t){function e(){var t;for(t=0;t<a.length;t++)a[t].teardown()}var n,i,s,a=[];return null!=t.kount?(i=o.setup(t.kount),n=i.deviceData,a.push(i)):n={},t.paypal===!0&&(s=r.setup(),n.correlation_id=s.sessionId,a.push(s)),{deviceData:JSON.stringify(n),teardown:e}}var o=t(186),r=t(184);e.exports={setup:i}},{184:184,186:186}],186:[function(t,e,n){(function(t){"use strict";function n(t){var e=null!=t?t:{};return new i(e)}function i(t){o.random.startCollectors(),this._currentEnvironment=this._initializeEnvironment(t),this._deviceSessionId=this._generateDeviceSessionId(),this.deviceData=this._getDeviceData(),this._iframe=this._setupIFrame()}var o=t.Braintree.sjcl,r="braintreeDataFrame",s="600000",a={qa:"https://assets.qa.braintreepayments.com/data",sandbox:"https://assets.braintreegateway.com/sandbox/data",production:"https://assets.braintreegateway.com/data"};i.prototype.teardown=function(){o.random.stopCollectors(),this._removeIframe()},i.prototype._removeIframe=function(){this._iframe.parentNode.removeChild(this._iframe)},i.prototype._getDeviceData=function(){return{device_session_id:this._deviceSessionId,fraud_merchant_id:this._currentEnvironment.id}},i.prototype._generateDeviceSessionId=function(){var t,e;return t=o.random.randomWords(4,0),e=o.codec.hex.fromBits(t)},i.prototype._setupIFrame=function(){var t,e=this,n=document.getElementById(r);return null!=n?n:(t="?m="+this._currentEnvironment.id+"&s="+this._deviceSessionId,n=document.createElement("iframe"),n.width=1,n.id=r,n.height=1,n.frameBorder=0,n.scrolling="no",document.body.appendChild(n),setTimeout(function(){n.src=e._currentEnvironment.url+"/logo.htm"+t,n.innerHTML='<img src="'+e._currentEnvironment.url+"/logo.gif"+t+'" />'},10),n)},i.prototype._initializeEnvironment=function(t){var e=a[t.environment];if(null==e)throw new Error(t.environment+" is not a valid environment for kount.environment");return{url:e,name:t.environment,id:null==t.merchantId?s:t.merchantId}},e.exports={setup:n,Kount:i,environmentUrls:a}}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],187:[function(t,e,n){"use strict";function i(t){this.apiClient=t}var o=["unlockCreditCard"];i.prototype.attach=function(t){function e(e){t.define(e,function(){n.apiClient[e].apply(n.apiClient,arguments)})}var n=this,i=0,r=o.length;for(i;r>i;i++)e(o[i])},e.exports=i},{}],188:[function(t,e,n){(function(n){"use strict";function i(t,e){var n=window.getComputedStyle?getComputedStyle(t):t.currentStyle;return n[e]}function o(){return{html:{height:a.style.height||"",overflow:i(a,"overflow"),position:i(a,"position")},body:{height:c.style.height||"",overflow:i(c,"overflow")}}}function r(){var t=/Android|iPhone|iPod|iPad/i.test(window.navigator.userAgent);return t}function s(t){var e,i,o,r=this;this.configuration=t,this.destructor=new h,this.container=null,this.merchantFormManager=null,this.configurationRequests=[],this.braintreeApiClient=new u.Client(this.configuration),this.braintreeBus=new l({merchantUrl:n.location.href,channel:this.configuration.channel}),this.bus=new p.MessageBus(this.configuration.root,this.configuration.channel),this.rpcServer=new p.RPCServer(this.bus),this.apiProxyServer=new y(this.braintreeApiClient),this.apiProxyServer.attach(this.rpcServer),e=this.configuration.inlineFramePath||this.configuration.gatewayConfiguration.assetsUrl+"/dropin/"+b+"/inline-frame.html",i=this.configuration.modalFramePath||this.configuration.gatewayConfiguration.assetsUrl+"/dropin/"+b+"/modal-frame.html",a=document.documentElement,c=document.body,this.frames={inline:this._createFrame(e,_.INLINE_FRAME_NAME),modal:this._createFrame(i,_.MODAL_FRAME_NAME)},this.container=f(this.configuration.merchantConfiguration.container,"Unable to find valid container."),o=f(this.configuration.merchantConfiguration.form||this._findClosest(this.container,"form")),this.merchantFormManager=new g({form:o,frames:this.frames,onSubmit:this.configuration.merchantConfiguration.paymentMethodNonceReceived,apiClient:this.braintreeApiClient}).initialize(),this.destructor.registerFunctionForTeardown(function(){r.merchantFormManager.teardown()}),this.configuration.gatewayConfiguration.paypalEnabled&&this._configurePayPal(),this.braintreeApiClient.sendAnalyticsEvents("dropin.web.initialized")}var a,c,u=t(14),l=t(155),h=t(77),p=t(55),d=t(73),f=d.normalizeElement,m=t(87),y=t(187),g=t(191),v=t(190),_=t(193),b="2.18.0",E=t(210);s.prototype.initialize=function(){var t,e=this;this._initializeModal(),this.braintreeBus.emit(l.events.ASYNC_DEPENDENCY_INITIALIZING),this.container.appendChild(this.frames.inline.element),c.appendChild(this.frames.modal.element),this.destructor.registerFunctionForTeardown(function(t){e._hideModal(function(){e.container.removeChild(e.frames.inline.element),c.removeChild(e.frames.modal.element),t()})}),this.rpcServer.define("receiveSharedCustomerIdentifier",function(n){for(e.braintreeApiClient.attrs.sharedCustomerIdentifier=n,e.braintreeApiClient.attrs.sharedCustomerIdentifierType="browser_session_cookie_store",t=0;t<e.configurationRequests.length;t++)e.configurationRequests[t](e.encodedClientToken);e.configurationRequests=[]}),this.braintreeBus.on(l.events.PAYMENT_METHOD_GENERATED,m(this._handleAltPayData,this)),this.rpcServer.define("selectPaymentMethod",function(t){e.frames.modal.rpcClient.invoke("selectPaymentMethod",[t]),e._showModal()}),this.rpcServer.define("sendAddedPaymentMethod",function(t){e.merchantFormManager.setNoncePayload(t),e.frames.inline.rpcClient.invoke("receiveNewPaymentMethod",[t])}),this.rpcServer.define("sendUsedPaymentMethod",function(t){e.frames.inline.rpcClient.invoke("selectPaymentMethod",[t])}),this.rpcServer.define("sendUnlockedNonce",function(t){e.merchantFormManager.setNoncePayload(t)}),this.rpcServer.define("clearNonce",function(){e.merchantFormManager.clearNoncePayload()}),this.rpcServer.define("closeDropInModal",function(){e._hideModal()}),this.rpcServer.define("setInlineFrameHeight",function(t){e.frames.inline.element.style.height=t+"px"}),this.bus.register("ready",function(t){t.source===e.frames.inline.element.contentWindow?e.frames.inline.rpcClient=new p.RPCClient(e.bus,t.source):t.source===e.frames.modal.element.contentWindow&&(e.frames.modal.rpcClient=new p.RPCClient(e.bus,t.source))})},s.prototype._createFrame=function(t,e){return new v(t,e,this.braintreeBus)},s.prototype._initializeModal=function(){this.frames.modal.element.style.display="none",this.frames.modal.element.style.position=r()?"absolute":"fixed",this.frames.modal.element.style.top="0",this.frames.modal.element.style.left="0",this.frames.modal.element.style.height="100%",this.frames.modal.element.style.width="100%"},s.prototype._lockMerchantWindowSize=function(){setTimeout(function(){a.style.overflow="hidden",c.style.overflow="hidden",c.style.height="100%",r()&&(a.style.position="relative",a.style.height=window.innerHeight+"px")},160)},s.prototype._unlockMerchantWindowSize=function(){var t=this.merchantPageDefaultStyles;t&&(c.style.height=t.body.height,c.style.overflow=t.body.overflow,a.style.overflow=t.html.overflow,r()&&(a.style.height=t.html.height,a.style.position=t.html.position),delete this.merchantPageDefaultStyles)},s.prototype._showModal=function(){var t=this,e=this.frames.modal.element;this.merchantPageDefaultStyles=o(),e.style.display="block",this.frames.modal.rpcClient.invoke("open",[],function(){setTimeout(function(){t._lockMerchantWindowSize(),e.contentWindow.focus()},200)})},s.prototype._hideModal=function(t){this._unlockMerchantWindowSize(),this.frames.modal.element.style.display="none",t&&t()},s.prototype._configurePayPal=function(){var t=this.configuration.merchantConfiguration.paypal||{};this.paypalModalView=new E({channel:this.configuration.channel,insertFrameFunction:t.insertFrame,paypalAssetsUrl:this.configuration.gatewayConfiguration.paypal.assetsUrl,isHermes:Boolean(t.singleUse)&&Boolean(t.amount)&&Boolean(t.currency)})},s.prototype._handleAltPayData=function(t){this.merchantFormManager.setNoncePayload(t),this.frames.inline.rpcClient.invoke("receiveNewPaymentMethod",[t]),this.frames.modal.rpcClient.invoke("modalViewClose")},s.prototype._findClosest=function(t,e){e=e.toUpperCase();do{if(t.nodeName===e)return t;t=t.parentNode}while(t);throw new Error("Unable to find a valid "+e)},s.prototype.teardown=function(t){var e=this;this.paypalModalView&&this.paypalModalView.teardown(),this.braintreeBus.emit(_.MODAL_FRAME_TEARDOWN_EVENT,function(){e.braintreeBus.emit(_.INLINE_FRAME_TEARDOWN_EVENT,function(){e.destructor.teardown(function(n){return n?t(n):(e.braintreeBus.teardown(),void t())})})})},e.exports=s}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{14:14,155:155,187:187,190:190,191:191,193:193,210:210,55:55,73:73,77:77,87:87}],189:[function(t,e,n){"use strict";function i(t){var e=new o(t);return e.initialize(),
e}var o=t(188),r="2.18.0";e.exports={create:i,VERSION:r}},{188:188}],190:[function(t,e,n){"use strict";function i(){var t,e=document.createElement("fakeelement");for(t in u)if("undefined"!=typeof e.style[t])return u[t];return null}function o(t,e){function n(i){i.target===t&&"height"===i.propertyName&&(e.emit(s.events.ASYNC_DEPENDENCY_READY),t.removeEventListener(o,n))}var o=i();o?t.addEventListener(o,n):setTimeout(function(){e.emit(s.events.ASYNC_DEPENDENCY_READY)},500)}function r(t,e,n){var i="height 210ms cubic-bezier(0.390, 0.575, 0.565, 1.000)",r=c({name:e,width:"100%",height:"68",style:{transition:i,WebkitTransition:i,MozTransition:i,msTransition:i,OTransition:i,border:"0",zIndex:"9999"}});this.element=r,setTimeout(function(){r.src=t+"#"+n.channel},0),e===a.INLINE_FRAME_NAME&&o(r,n)}var s=t(155),a=t(193),c=t(82),u={transition:"transitionend","-o-transition":"otransitionEnd","-moz-transition":"transitionend","-webkit-transition":"webkitTransitionEnd"};e.exports=r},{155:155,193:193,82:82}],191:[function(t,e,n){"use strict";function i(t){this.formNapper=new r(t.form),this.frames=t.frames,this.onSubmit=t.onSubmit,this.apiClient=t.apiClient}var o=t(87),r=t(80);i.prototype.initialize=function(){return this._isSubmitBased()&&this._setElements(),this._setEvents(),this},i.prototype.setNoncePayload=function(t){this.noncePayload=t},i.prototype.clearNoncePayload=function(){this.noncePayload=null},i.prototype._isSubmitBased=function(){return!this.onSubmit},i.prototype._isCallbackBased=function(){return Boolean(this.onSubmit)},i.prototype._setElements=function(){this.nonceInput=this.formNapper.inject("payment_method_nonce","")},i.prototype._setEvents=function(){this.formNapper.hijack(o(this._handleFormSubmit,this))},i.prototype._handleFormSubmit=function(t){var e=this;this.noncePayload&&this.noncePayload.nonce?this._handleNonceReply(t):this.frames.inline.rpcClient.invoke("requestNonce",[],function(n){e.setNoncePayload(n),e._handleNonceReply(t)})},i.prototype._handleNonceReply=function(t){var e=this;this._isCallbackBased()?this.apiClient.sendAnalyticsEvents("dropin.web.end.callback",function(){var n=e.noncePayload;n.originalEvent=t,e.onSubmit(n),setTimeout(function(){delete n.originalEvent,e.frames.inline.rpcClient.invoke("clearLoadingState"),e.frames.inline.rpcClient.invoke("receiveNewPaymentMethod",[n])},200)}):this._triggerFormSubmission()},i.prototype._triggerFormSubmission=function(){var t=this;this.nonceInput=this.formNapper.inject("payment_method_nonce",this.noncePayload.nonce),this.apiClient.sendAnalyticsEvents("dropin.web.end.auto-submit",function(){t.formNapper.submit()})},i.prototype.teardown=function(){var t;this.nonceInput&&(t=this.formNapper.htmlForm,t.removeChild(this.nonceInput)),this.formNapper.detach()},e.exports=i},{80:80,87:87}],192:[function(t,e,n){"use strict";e.exports=t(189)},{189:189}],193:[function(t,e,n){e.exports={PAYPAL_INTEGRATION_NAME:"PayPal",INLINE_FRAME_NAME:"braintree-dropin-frame",MODAL_FRAME_NAME:"braintree-dropin-modal-frame",PAYMENT_METHOD_TYPES:["CoinbaseAccount","PayPalAccount","CreditCard"],cssClassMap:{"American Express":"american-express","Diners Club":"diners-club",DinersClub:"diners-club",Discover:"discover",JCB:"jcb",Maestro:"maestro",MasterCard:"master-card",Solo:"solo",Switch:"switch",UKMaestro:"maestro",UnionPay:"unionpay",Visa:"visa"},INLINE_FRAME_TEARDOWN_EVENT:"dropin:TEARDOWN_INLINE_FRAME",MODAL_FRAME_TEARDOWN_EVENT:"dropin:TEARDOWN_MODAL_FRAME"}},{}],194:[function(t,e,n){"use strict";function i(t,e){var n=e.merchantConfiguration||{},i=document.getElementById(n.id),s=n.useCreditCard!==!1;if(!i)throw new Error('Unable to find form with id: "'+n.id+'"');return s&&r(i),new o(t,e)}var o=t(196),r=t(199);e.exports={setup:i}},{196:196,199:199}],195:[function(t,e,n){(function(t){"use strict";function n(t,e){var o,s,a,c=t.children;for(e=e||{},s=0;s<c.length;s++)o=c[s],r(o)?(a=o.getAttribute("data-braintree-name"),"postal_code"===a?e.billingAddress={postalCode:o.value}:e[a]=o.value,i(o)):o.children&&o.children.length>0&&n(o,e);return e}function i(t){try{t.attributes.removeNamedItem("name")}catch(e){}}function o(t){n(t)}function r(t){return t.nodeType===s&&t.attributes["data-braintree-name"]}var s=t.Node?t.Node.ELEMENT_NODE:1;e.exports={extractValues:n,scrubAllAttributes:o,scrubAttributes:i,isBraintreeNode:r}}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],196:[function(t,e,n){(function(n){"use strict";function i(t,e){var i=e.merchantConfiguration,o="object"==typeof i.paymentMethodNonceInputField,r=this;this.destructor=new a,this.apiClient=t,this.isCreditCardForm=i.useCreditCard!==!1,this.htmlForm=document.getElementById(i.id),this.paymentMethodNonceInput=l(i.paymentMethodNonceInputField),this.htmlForm.appendChild(this.paymentMethodNonceInput),this.destructor.registerFunctionForTeardown(function(){o?r.paymentMethodNonceInput.value="":r.htmlForm.removeChild(r.paymentMethodNonceInput)}),this.model=new u,this.bus=new c({merchantUrl:n.location.href,channel:e.channel}),this.setEvents(),this.destructor.registerFunctionForTeardown(function(){r.bus.teardown()})}var o=t(87),r=t(73),s=t(195),a=t(77),c=t(155),u=t(198),l=t(197),h={message:"Unable to process payments at this time",type:"IMMEDIATE"};i.prototype.setEvents=function(){var t=this;this.onSubmitHandler=o(this.handleSubmit,this),this.onExternalNonceReceived=o(this.onExternalNonceReceived,this),this.clearExternalNonce=o(this.clearExternalNonce,this),r.addEventListener(this.htmlForm,"submit",this.onSubmitHandler),this.destructor.registerFunctionForTeardown(function(){r.removeEventListener(t.htmlForm,"submit",t.onSubmitHandler)}),this.bus.on(c.events.PAYMENT_METHOD_GENERATED,this.onExternalNonceReceived),this.bus.on(c.events.PAYMENT_METHOD_CANCELLED,this.clearExternalNonce)},i.prototype.handleSubmit=function(t){var e,n=this;return t.preventDefault?t.preventDefault():t.returnValue=!1,this.isCreditCardForm?(e=this.model.get("type"),e&&"CreditCard"!==e?(s.scrubAllAttributes(this.htmlForm),void this.onNonceReceived(null,this.model.attributes)):void this.apiClient.tokenizeCard(s.extractValues(this.htmlForm),function(t,e,i){t?n.onNonceReceived(h,null):(n.model.set({nonce:e,type:i.type,details:i.details}),n.onNonceReceived(null,n.model.attributes))})):void this.onNonceReceived(null,this.model.attributes)},i.prototype.writeNonceToDOM=function(){this.paymentMethodNonceInput.value=this.model.get("nonce")},i.prototype.onExternalNonceReceived=function(t){this.model.set(t),this.writeNonceToDOM()},i.prototype.clearExternalNonce=function(){this.model.reset()},i.prototype.onNonceReceived=function(t){var e=this.htmlForm;return t?void this.bus.emit(c.events.ERROR,h):(r.removeEventListener(e,"submit",this.onSubmitHandler),this.writeNonceToDOM(),void(e.submit&&("function"==typeof e.submit||e.submit.call)?e.submit():setTimeout(function(){e.querySelector('[type="submit"]').click()},1)))},i.prototype.teardown=function(){this.destructor.teardown()},e.exports=i}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{155:155,195:195,197:197,198:198,73:73,77:77,87:87}],197:[function(t,e,n){"use strict";e.exports=function(t){var e,n;return"object"==typeof t?t:(e="payment_method_nonce","string"==typeof t&&(e=t),n=document.createElement("input"),n.name=e,n.type="hidden",n)}},{}],198:[function(t,e,n){"use strict";function i(){this.reset()}i.prototype.get=function(t){return this.attributes[t]},i.prototype.set=function(t){this.attributes=t||{}},i.prototype.reset=function(){this.attributes={}},e.exports=i},{}],199:[function(t,e,n){"use strict";e.exports=function(t){var e,n,i=t.getElementsByTagName("*"),o={};for(e=0;e<i.length;e++)n=i[e].getAttribute("data-braintree-name"),o[n]=!0;if(!o.number)throw new Error('Unable to find an input with data-braintree-name="number" in your form. Please add one.');if(o.expiration_date){if(o.expiration_month||o.expiration_year)throw new Error('You have inputs with data-braintree-name="expiration_date" AND data-braintree-name="expiration_(year|month)". Please use either "expiration_date" or "expiration_year" and "expiration_month".')}else{if(!o.expiration_month&&!o.expiration_year)throw new Error('Unable to find an input with data-braintree-name="expiration_date" in your form. Please add one.');if(!o.expiration_month)throw new Error('Unable to find an input with data-braintree-name="expiration_month" in your form. Please add one.');if(!o.expiration_year)throw new Error('Unable to find an input with data-braintree-name="expiration_year" in your form. Please add one.')}}},{}],200:[function(t,e,n){"use strict";var i=t(202),o=t(204).events,r="2.18.0";e.exports={create:function(t){return new i(t)},events:o,VERSION:r}},{202:202,204:204}],201:[function(t,e,n){"use strict";var i=t(204);e.exports=function(t,e){return t+"/hosted-fields/"+i.VERSION+"/hosted-fields-frame.html#"+e}},{204:204}],202:[function(t,e,n){"use strict";function i(t,e){var n=document.createElement("div");return n.style.clear="both",e=e||document.body,e.appendChild(t),e.appendChild(n),{parent:e,children:[t,n]}}function o(t,e){return function(n){var i=t[n.fieldKey].containerElement,o=a(i);n.target={fieldKey:n.fieldKey,container:i},o.toggle(h.externalClasses.FOCUSED,n.isFocused).toggle(h.externalClasses.VALID,n.isValid),n.isStrictlyValidating?o.toggle(h.externalClasses.INVALID,!n.isValid):o.toggle(h.externalClasses.INVALID,!n.isPotentiallyValid),delete n.fieldKey,delete n.isStrictlyValidating,e&&e(n)}}function r(t){var e,n,r,p,d,f=this,m={},g=0;this.injectedNodes=[],this.destructor=new s,this.bus=new u({channel:t.channel,merchantUrl:location.href}),this.destructor.registerFunctionForTeardown(function(){f.bus.teardown()}),this.bus.emit(u.events.ASYNC_DEPENDENCY_INITIALIZING),this.bus.emit(u.events.SEND_ANALYTICS_EVENTS,"hosted-fields.initialized");for(p in h.whitelistedFields)if(h.whitelistedFields.hasOwnProperty(p)){if(e=t.merchantConfiguration.hostedFields[p],!e)continue;if(n=document.querySelector(e.selector),!n){d='Unable to find element with selector "'+e.selector+'" for hostedFields.'+p,this.bus.emit(u.events.ERROR,{message:d});continue}if(n.querySelector('iframe[name^="braintree-"]')){this.bus.emit(u.events.ERROR,{message:'Cannot place two elements in "'+e.selector+'"'});continue}r=c({type:p,name:"braintree-hosted-field-"+p,style:h.defaultIFrameStyle}),this.injectedNodes.push(i(r,n)),this.setupLabelFocus(p,n),m[p]={frameElement:r,containerElement:n},g++,setTimeout(function(e){return function(){e.src=l(t.gatewayConfiguration.assetsUrl,t.channel)}}(r),0)}this.bus.on(y.FRAME_READY,function(t){g--,t(0===g)}),this.bus.on(y.INPUT_EVENT,o(m,t.merchantConfiguration.hostedFields.onFieldEvent)),this.destructor.registerFunctionForTeardown(function(){var t,e,n;for(t=0;t<f.injectedNodes.length;t++){for(n=f.injectedNodes[t],e=0;e<n.children.length;e++)n.parent.removeChild(n.children[e]);a(n.parent).remove(h.externalClasses.FOCUSED,h.externalClasses.INVALID,h.externalClasses.VALID)}})}var s=t(77),a=t(74),c=t(82),u=t(155),l=t(201),h=t(204),p=t(154),d=t(73),f=t(205),m=t(203),y=h.events;r.prototype.setupLabelFocus=function(t,e){function n(){r.emit(y.TRIGGER_INPUT_FOCUS,t)}var i,o,r=this.bus;if(m()&&null!=e.id){for(i=p(document.querySelectorAll('label[for="'+e.id+'"]')),i=i.concat(f(e,"label")),o=0;o<i.length;o++)d.addEventListener(i[o],"click",n,!1);this.destructor.registerFunctionForTeardown(function(){for(o=0;o<i.length;o++)d.removeEventListener(i[o],"click",n,!1)})}},r.prototype.teardown=function(t){this.destructor.teardown(t)},e.exports=r},{154:154,155:155,201:201,203:203,204:204,205:205,73:73,74:74,77:77,82:82}],203:[function(t,e,n){"use strict";e.exports=function(){return!/(iPad|iPhone|iPod)/i.test(navigator.userAgent)}},{}],204:[function(t,e,n){"use strict";var i="2.18.0";e.exports={VERSION:i,events:{FRAME_READY:"hosted-fields:FRAME_READY",VALIDATE_STRICT:"hosted-fields:VALIDATE_STRICT",CONFIGURATION:"hosted-fields:CONFIGURATION",TOKENIZATION_REQUEST:"hosted-fields:TOKENIZATION_REQUEST",INPUT_EVENT:"hosted-fields:INPUT_EVENT",TRIGGER_INPUT_FOCUS:"hosted-fields:TRIGGER_INPUT_FOCUS"},externalEvents:{FOCUS:"focus",BLUR:"blur",FIELD_STATE_CHANGE:"fieldStateChange"},defaultMaxLengths:{number:19,postalCode:8,expirationDate:7,expirationMonth:2,expirationYear:4,cvv:3},externalClasses:{FOCUSED:"braintree-hosted-fields-focused",INVALID:"braintree-hosted-fields-invalid",VALID:"braintree-hosted-fields-valid"},defaultIFrameStyle:{border:"none",width:"100%",height:"100%","float":"left"},whitelistedStyles:["-moz-osx-font-smoothing","-moz-transition","-moz-tap-highlight-color","-webkit-font-smoothing","-webkit-transition","-webkit-tap-highlight-color","color","font","font-family","font-size","font-size-adjust","font-stretch","font-style","font-variant","font-variant-alternates","font-variant-caps","font-variant-east-asian","font-variant-ligatures","font-variant-numeric","font-weight","line-height","opacity","outline","text-shadow","transition"],whitelistedFields:{number:{name:"credit-card-number",label:"Credit Card Number"},cvv:{name:"cvv",label:"CVV"},expirationDate:{name:"expiration",label:"Expiration Date"},expirationMonth:{name:"expiration-month",label:"Expiration Month"},expirationYear:{name:"expiration-year",label:"Expiration Year"},postalCode:{name:"postal-code",label:"Postal Code"}}}},{}],205:[function(t,e,n){"use strict";function i(t,e){for(var n=t.parentNode,i=[];null!=n;)null!=n.tagName&&n.tagName.toLowerCase()===e&&i.push(n),n=n.parentNode;return i}e.exports=i},{}],206:[function(t,e,n){"use strict";e.exports=t(208)},{208:208}],207:[function(t,e,n){(function(n){"use strict";function i(t){this.configuration=t,this.destructor=new a,this.bus=new c({merchantUrl:n.location.href,channel:this.configuration.channel}),this.container=o.normalizeElement(this.configuration.merchantConfiguration.paypal.container||document.body),this.loggedInView=null,this.loggedOutView=null,this.appView=null,this.merchantPageView=null,this.paymentMethodNonceInputFieldView=null,this.overlayView=null,this.bridgeIframeView=null,_(this,["initAuthFlow","closeAuthFlow"])}var o=t(73),r=t(87),s=t(143),a=t(77),c=t(155),u=t(210),l=t(212),h=t(213),p=t(216),d=t(214),f=t(217),m=t(211),y=t(227),g=t(219),v=t(229),_=t(88);i.prototype.initialize=function(){var t=r(this._handleClickLogin,this);this._createViews(),this.bus.on(c.events.PAYMENT_METHOD_CANCELLED,r(this._handlePaymentMethodCancelled,this)),"dropin"!==this.configuration.integrationType&&this.bus.on(c.events.PAYMENT_METHOD_GENERATED,r(this._handlePaymentMethodGenerated,this)),o.addEventListener(document.body,"click",t),this.destructor.registerFunctionForTeardown(function(){o.removeEventListener(document.body,"click",t)})},i.prototype._createViews=function(){var t,e=[],n=this,i="dropin"===this.configuration.integrationType;y.isBridgeIframeRequired()&&(this.bridgeIframeView=new m({container:this.container,paypalAssetsUrl:this.configuration.gatewayConfiguration.paypal.assetsUrl,channel:this.configuration.channel}),e.push(this.bridgeIframeView)),this.appView=new u({insertFrameFunction:this.configuration.merchantConfiguration.paypal.insertFrameFunction,paypalAssetsUrl:this.configuration.gatewayConfiguration.paypal.assetsUrl,isHermes:v.isHermesConfiguration(this.configuration),isDropin:i,channel:this.configuration.channel}),e.push(this.appView),i||(this.merchantPageView=new d({channel:this.configuration.channel}),e.push(this.merchantPageView),y.isPopupSupported()&&y.isOverlaySupported()&&(this.overlayView=new p({paypalAssetsUrl:this.configuration.gatewayConfiguration.paypal.assetsUrl,onFocus:function(){n.bus.emit(g.events.FOCUS_APP)},onClose:function(){n.bus.emit(g.events.CLOSE_APP)},locale:this.configuration.merchantConfiguration.paypal.locale,channel:this.configuration.channel}),e.push(this.overlayView))),i||this.configuration.merchantConfiguration.paypal.headless||(this.paymentMethodNonceInputFieldView=new f({container:this.container,el:this.configuration.merchantConfiguration.paypal.paymentMethodNonceInputField,channel:this.configuration.channel}),e.push(this.paymentMethodNonceInputFieldView),this.loggedInView=new l({paypalAssetsUrl:this.configuration.gatewayConfiguration.paypal.assetsUrl,container:this.container,locale:this.configuration.merchantConfiguration.paypal.locale,channel:this.configuration.channel}),e.push(this.loggedInView),this.loggedOutView=new h({paypalAssetsUrl:this.configuration.gatewayConfiguration.paypal.assetsUrl,container:this.container,enablePayPalButton:v.isOnetimeHermesConfiguration(this.configuration),locale:this.configuration.merchantConfiguration.paypal.locale,channel:this.configuration.channel}),e.push(this.loggedOutView)),this.destructor.registerFunctionForTeardown(function(){for(t=0;t<e.length;t++)e[t].teardown()})},i.prototype._handleClickLogin=function(t){for(var e=t.target||t.srcElement;;){if(null==e)return;if(e===t.currentTarget)return;if(this._isButton(e))break;e=e.parentNode}v.preventDefault(t),this.initAuthFlow()},i.prototype.initAuthFlow=function(){this.appView.open()},i.prototype.closeAuthFlow=function(){this.appView.close()},i.prototype._isButton=function(t){var e="braintree-paypal-button"===t.id,n=v.isOnetimeHermesConfiguration(this.configuration)&&t.className.match(/paypal-button(?!-widget)/);return e||n},i.prototype._handlePaymentMethodGenerated=function(t){var e=this.configuration.merchantConfiguration.paypal.onSuccess;t.type===g.NONCE_TYPE&&s(e)&&e(t)},i.prototype._handlePaymentMethodCancelled=function(t){var e=this.configuration.merchantConfiguration.paypal.onCancelled;t.source===g.PAYPAL_INTEGRATION_NAME&&s(e)&&e()},i.prototype.teardown=function(){var t=this;this.destructor.teardown(function(){t.bus.teardown()})},e.exports=i}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{143:143,155:155,210:210,211:211,212:212,213:213,214:214,216:216,217:217,219:219,227:227,229:229,73:73,77:77,87:87,88:88}],208:[function(t,e,n){"use strict";function i(t){var e,n;if(n=t.merchantConfiguration.onUnsupported,"function"!=typeof n&&(n=function(t){try{console.log(t)}catch(e){}}),!t.gatewayConfiguration.paypalEnabled)return n(new Error("PayPal is not enabled")),null;if(!h.detectedPostMessage())return n(new Error("unsupported browser detected")),null;if(!t.merchantConfiguration.paypal.container&&!t.merchantConfiguration.paypal.headless)return n(new Error("Please supply a container for the PayPal button to be appended to")),null;if(!u(t))return n(new Error("unsupported protocol detected")),null;if(c(t))return n(new Error("Unvetted merchant client token does not include a payee email")),null;if(f.isHermesConfiguration(t)&&!s(t.merchantConfiguration.paypal.locale))return n(new Error("This PayPal integration does not support this country")),null;if(f.isOnetimeHermesConfiguration(t)){if(!r(t.merchantConfiguration.paypal.currency))return n(new Error("This PayPal integration does not support this currency")),null;if(!a(t.merchantConfiguration.paypal.amount))return n(new Error("Amount must be a number")),null}return e=new l(t),e.initialize(),e}function o(t,e){var n,i=e.length,o=!1;for(n=0;i>n;n++)t.toLowerCase()===e[n].toLowerCase()&&(o=!0);return o}function r(t){return o(t,p.HERMES_SUPPORTED_CURRENCIES)}function s(t){return o(d(t).split("_")[1],p.HERMES_SUPPORTED_COUNTRIES)}function a(t){return t=parseFloat(t),"number"==typeof t&&!isNaN(t)&&t>=0}function c(t){return t.gatewayConfiguration.paypal.unvettedMerchant&&(!f.isHermesConfiguration(t)||!t.gatewayConfiguration.paypal.payeeEmail)}function u(t){return t.gatewayConfiguration.paypal.allowHttp?!0:h.isPopupSupported()?!0:"isMerchantPageHttps"in t?t.isMerchantPageHttps:y.isBrowserHttps()}var l=t(207),h=t(227),p=t(219),d=t(221),f=t(229),m="2.18.0",y=t(73);e.exports={create:i,VERSION:m}},{207:207,219:219,221:221,227:227,229:229,73:73}],209:[function(t,e,n){e.exports={en_us:{cancel:"Cancel",overlay_text:"Don't see the secure PayPal browser? We'll help you re-launch the window to complete your purchase.",continue_link:"Continue"},en_uk:{cancel:"Cancel",overlay_text:"Don't see the secure PayPal browser? We'll help you re-launch the window to complete your purchase.",continue_link:"Continue"},en_au:{cancel:"Cancel",overlay_text:"Don't see the secure PayPal browser? We'll help you re-launch the window to complete your purchase.",continue_link:"Continue"},sv_se:{cancel:"Avbryt",overlay_text:"Ser du inte den säkra PayPal-webbl&auml;saren? Vi hj&auml;lper dig att starta om f&ouml;nstret f&ouml;r att slutf&ouml;ra k&ouml;pet.",continue_link:"Forts&auml;tt"},de_de:{cancel:"Abbrechen",overlay_text:"Sie sehen das sichere Browserfenster von PayPal nicht? Das Fenster wird neu ge&ouml;ffnet, damit Sie Ihren Einkauf abschlie&szlig;en k&ouml;nnen.",continue_link:"Weiter"},fr_fr:{cancel:"Annuler",overlay_text:"Vous ne voyez pas le navigateur s&eacute;curis&eacute; PayPal ? Nous allons vous aider &agrave; relancer la fen&ecirc;tre pour effectuer votre achat.",continue_link:"Continuer"},en_ca:{cancel:"Cancel",overlay_text:"Don't see the secure PayPal browser? We'll help you re-launch the window to complete your purchase.",continue_link:"Continue"},fr_ca:{cancel:"Annuler",overlay_text:"Vous ne voyez pas le navigateur s&eacute;curis&eacute; de PayPal ? Nous vous aiderons &agrave; relancer la fen&ecirc;tre afin d'effectuer votre achat.",continue_link:"Continuer"},es_es:{cancel:"Cancelar",overlay_text:"&iquest;No ves el s&iacute;mbolo de navegaci&oacute;n segura de PayPal? Te ayudaremos a abrir de nuevo la ventana para completar la compra.",continue_link:"Continuar"},es_xc:{cancel:"Cancelar",overlay_text:"&iquest;No ve el s&iacute;mbolo de navegaci&oacute;n segura de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra.",continue_link:"Continuar"},fr_xc:{cancel:"Annuler",overlay_text:"Le navigateur s&eacute;curis&eacute; de PayPal n'appara&icirc;t pas ? Nous allons vous aider &agrave; rouvrir la fen&ecirc;tre pour finaliser votre achat.",continue_link:"Continuer"},nl_nl:{cancel:"Annuleren",overlay_text:"Ziet u de beveiligde PayPal-browser niet? We helpen u het venster opnieuw te openen zodat u uw aankoop kunt voltooien.",continue_link:"Doorgaan"},pt_pt:{cancel:"Cancelar",overlay_text:"N&atilde;o est&aacute; a ver a indica&ccedil;&atilde;o de liga&ccedil;&atilde;o segura PayPal no browser? Vamos ent&atilde;o voltar a abrir a janela para concluir a sua compra.",continue_link:"Continuar"},ru_ru:{cancel:"Отмена",overlay_text:"Не отображается безопасная страница PayPal в браузере? Мы поможем вам повторно загрузить окно, чтобы завершить покупку.",continue_link:"Продолжить"},da_dk:{cancel:"Annuller",overlay_text:"Kan du ikke se PayPals sikre browser? Vi hj&aelig;lper dig med at &aring;bne vinduet igen, s&aring; du kan betale.",continue_link:"Forts&aelig;t"},it_it:{cancel:"Annulla",overlay_text:"Non vedi il browser sicuro di PayPal? Ti aiuteremo a riavviare la pagina per completare l'acquisto.",continue_link:"Continua"},no_no:{cancel:"Avbryt",overlay_text:"Ser du ikke den sikre PayPal-nettleseren? Vi hjelper deg med &aring; &aring;pne vinduet p&aring; nytt s&aring; du kan fullf&oslash;re kj&oslash;pet.",continue_link:"Fortsett"},pl_pl:{cancel:"Anuluj",overlay_text:"Nie widzisz bezpiecznej przeglądarki PayPal? Pomożemy Ci ponownie uruchomić to okno w celu dokonania zakupu.",continue_link:"Kontynuuj"},tr_tr:{cancel:"İptal",overlay_text:"G&uuml;venli PayPal tarayıcısını g&ouml;rm&uuml;yor musunuz? Alışverişinizi tamamlamak i&ccedil;in pencereyi yeniden başlatmanıza yardımcı olacağız.",continue_link:"Devam"},zh_xc:{cancel:"取消",overlay_text:"没有看到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",continue_link:"继续"},en_hk:{cancel:"Cancel",overlay_text:"Don't see the secure PayPal browser? We'll help you re-launch the window to complete your purchase.",continue_link:"Continue"},zh_hk:{cancel:"取消",overlay_text:"看不到安全的 PayPal 瀏覽器視窗？我們會助你重新啟動視窗，以完成購物。",continue_link:"繼續"},en_my:{cancel:"Cancel",overlay_text:"Don't see the secure PayPal browser? We'll help you re-launch the window to complete your purchase.",continue_link:"Continue"},en_nz:{cancel:"Cancel",overlay_text:"Don't see the secure PayPal browser? We'll help you re-launch the window to complete your purchase.",continue_link:"Continue"},en_sg:{cancel:"Cancel",overlay_text:"Don't see the secure PayPal browser? We'll help you re-launch the window to complete your purchase.",continue_link:"Continue"}}},{}],210:[function(t,e,n){(function(n){"use strict";function i(t){var e=this;this.options=t||{},this.destructor=new a,this.bus=new c({merchantUrl:n.location.href,channel:this.options.channel}),this.destructor.registerFunctionForTeardown(function(){e.bus.teardown()}),this._initialize()}var o=t(87),r=t(143),s=t(227),a=t(77),c=t(155),u=t(219),l=t(218),h=t(215);i.prototype._initialize=function(){var t=this;this.app=s.isPopupSupported()?new l({src:this._buildUrl(),isHermes:this.options.isHermes,channel:this.options.channel}):new h({src:this._buildUrl(),isDropin:this.options.isDropin,isHermes:this.options.isHermes,insertFrameFunction:this.options.insertFrameFunction,channel:this.options.channel}),this.destructor.registerFunctionForTeardown(function(){t.app.teardown()}),this.bus.on(u.events.CLOSE_APP,o(this.close,this)),this.bus.on(u.events.FOCUS_APP,o(this.focus,this)),this.bus.on(c.events.PAYMENT_METHOD_GENERATED,o(this._handlePaymentMethodGenerated,this)),this.bus.on(c.events.UI_POPUP_FORCE_CLOSE,o(this._handleForceClose,this))},i.prototype._buildUrl=function(){var t=this.options.paypalAssetsUrl;return t+="/pwpp/",t+=u.VERSION,t+="/html/braintree-frame.html",t+="#"+this.options.channel},i.prototype.open=function(){this.focus(),this.app.open(),this.poll()},i.prototype._handleForceClose=function(t){t.target===u.PAYPAL_INTEGRATION_NAME&&this.close()},i.prototype.close=function(){this.app.close()},i.prototype.focus=function(){r(this.app.focus)&&this.app.focus()},i.prototype.isClosed=function(){return this.app.isClosed()},i.prototype.stopPolling=function(){clearInterval(this.pollId)},i.prototype.poll=function(){var t=this;this.pollId=setInterval(function(){t.isClosed()&&t._handleClosed()},100)},i.prototype._handlePaymentMethodGenerated=function(t){t.type===u.NONCE_TYPE&&this.close()},i.prototype._handleClosed=function(){this.stopPolling(),this.close(),s.isPopupSupported()&&(this.app.el=null)},i.prototype.teardown=function(){this.destructor.teardown()},e.exports=i}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{143:143,155:155,215:215,218:218,219:219,227:227,77:77,87:87}],211:[function(t,e,n){"use strict";function i(t){this.options=t||{},this.el=r({src:this._buildUrl(),name:o.BRIDGE_FRAME_NAME,height:1,width:1,style:{position:"static",top:0,left:0,bottom:0,padding:0,margin:0,border:0,outline:"none",background:"transparent"}}),this.options.container.appendChild(this.el)}var o=t(219),r=t(82);i.prototype._buildUrl=function(){var t=this.options.paypalAssetsUrl;return t+="/pwpp/",t+=o.VERSION,t+="/html/bridge-frame.html",t+="#"+this.options.channel},i.prototype.teardown=function(){this.options.container.removeChild(this.el)},e.exports=i},{219:219,82:82}],212:[function(t,e,n){(function(n){"use strict";function i(t){var e;this.options=t||{},this.wrapper=this.options.container||document.body,this.destructor=new s,this.bus=new a({merchantUrl:n.location.href,channel:t.channel}),e=h(this.options.locale,p),this.translation=e.translation,this._initialize()}var o=t(73),r=t(87),s=t(77),a=t(155),c=t(229),u=t(228),l=t(219),h=t(222),p=t(209);i.prototype._initialize=function(){var t=this,e=r(this._handleClickLogout,this);this._createViewContainer(),this._createPayPalName(),this._createEmailNode(),this._createLogoutNode(),o.addEventListener(this.logoutNode,"click",e),this.destructor.registerFunctionForTeardown(function(){o.removeEventListener(t.logoutNode,"click",e)}),this.bus.on(a.events.PAYMENT_METHOD_GENERATED,r(this._handlePaymentMethodGenerated,this)),this.bus.on(a.events.PAYMENT_METHOD_CANCELLED,r(this._handlePaymentMethodCancelled,this))},i.prototype._createViewContainer=function(){var t=["display: none","max-width: 500px","overflow: hidden","padding: 16px","background-image: url("+this.options.paypalAssetsUrl+"/pwpp/"+l.VERSION+"/images/paypal-small.png)","background-image: url("+this.options.paypalAssetsUrl+"/pwpp/"+l.VERSION+"/images/paypal-small.svg), none","background-position: 20px 50%","background-repeat: no-repeat","background-size: 13px 15px","border-top: 1px solid #d1d4d6","border-bottom: 1px solid #d1d4d6"].join(";");this.container=document.createElement("div"),this.container.id="braintree-paypal-loggedin",this.container.style.cssText=t,this.wrapper.appendChild(this.container)},i.prototype._createPayPalName=function(){var t=["color: #283036","font-size: 13px","font-weight: 800",'font-family: "Helvetica Neue", Helvetica, Arial, sans-serif',"margin-left: 36px","-webkit-font-smoothing: antialiased","-moz-font-smoothing: antialiased","-ms-font-smoothing: antialiased","font-smoothing: antialiased"].join(";");return this.payPalName=document.createElement("span"),this.payPalName.id="bt-pp-name",this.payPalName.innerHTML="PayPal",this.payPalName.style.cssText=t,this.container.appendChild(this.payPalName)},i.prototype._createEmailNode=function(){var t=["color: #6e787f","font-size: 13px",'font-family: "Helvetica Neue", Helvetica, Arial, sans-serif',"margin-left: 5px","-webkit-font-smoothing: antialiased","-moz-font-smoothing: antialiased","-ms-font-smoothing: antialiased","font-smoothing: antialiased"].join(";");this.emailNode=document.createElement("span"),this.emailNode.id="bt-pp-email",this.emailNode.style.cssText=t,this.container.appendChild(this.emailNode)},i.prototype._createLogoutNode=function(){var t=["color: #3d95ce","font-size: 11px",'font-family: "Helvetica Neue", Helvetica, Arial, sans-serif',"line-height: 20px","margin: 0 0 0 25px","padding: 0","background-color: transparent","border: 0","cursor: pointer","text-decoration: underline","float: right","-webkit-font-smoothing: antialiased","-moz-font-smoothing: antialiased","-ms-font-smoothing: antialiased","font-smoothing: antialiased"].join(";");this.logoutNode=document.createElement("button"),this.logoutNode.id="bt-pp-cancel",this.logoutNode.innerHTML=this.translation.cancel,this.logoutNode.style.cssText=t,this.container.appendChild(this.logoutNode)},i.prototype.show=function(t){this.container.style.display="block",u.setTextContent(this.emailNode,t)},i.prototype.hide=function(){this.container.style.display="none"},i.prototype._handleClickLogout=function(t){c.preventDefault(t),this.bus.emit(a.events.PAYMENT_METHOD_CANCELLED,{source:l.PAYPAL_INTEGRATION_NAME})},i.prototype._handlePaymentMethodGenerated=function(t){var e;t.type===l.NONCE_TYPE&&(e=t&&t.details&&t.details.email?t.details.email:"",this.show(e))},i.prototype._handlePaymentMethodCancelled=function(t){t.source===l.PAYPAL_INTEGRATION_NAME&&this.hide()},i.prototype.teardown=function(){this.wrapper.removeChild(this.container),this.destructor.teardown(),this.bus.teardown()},e.exports=i}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{155:155,209:209,219:219,222:222,228:228,229:229,73:73,77:77,87:87}],213:[function(t,e,n){(function(n){"use strict";function i(t){this.options=t,this.wrapper=this.options.container||document.body,this.bus=new r({merchantUrl:n.location.href,channel:t.channel}),this._initialize()}var o=t(87),r=t(155),s=t(219),a=t(221);i.prototype._initialize=function(){this.createViewContainer(),this.options.enablePayPalButton?this.createCheckoutWithPayPalButton():this.createPayWithPayPalButton(),this.bus.on(r.events.PAYMENT_METHOD_GENERATED,o(this._handlePaymentMethodGenerated,this)),this.bus.on(r.events.PAYMENT_METHOD_CANCELLED,o(this._handlePaymentMethodCancelled,this))},i.prototype.createViewContainer=function(){this.container=document.createElement("div"),
this.container.id="braintree-paypal-loggedout",this.wrapper.appendChild(this.container),this.loginNode=this.container},i.prototype.createPayWithPayPalButton=function(){var t=document.createElement("a"),e=new Image,n=["max-width: 100%","display: block","width: 100%","height: 100%","outline: none","border: 0"].join(";"),i=["display: block","width: 115px","height: 44px","overflow: hidden"].join(";");t.id="braintree-paypal-button",t.href="#",t.style.cssText=i,e.src=this.options.paypalAssetsUrl+"/pwpp/"+s.VERSION+"/images/pay-with-paypal.png",e.setAttribute("alt","Pay with PayPal"),e.style.cssText=n,t.appendChild(e),this.container.appendChild(t)},i.prototype.createCheckoutWithPayPalButton=function(){var t,e=document.createElement("script"),n={"data-merchant":"merchant-id","data-button":"checkout","data-type":"button","data-color":"blue","data-lc":a(this.options.locale)};e.src="//www.paypalobjects.com/api/button.js",e.async=!0;for(t in n)n.hasOwnProperty(t)&&e.setAttribute(t,n[t]);this.container.appendChild(e)},i.prototype.show=function(){this.container.style.display="block"},i.prototype.hide=function(){this.container.style.display="none"},i.prototype._handlePaymentMethodGenerated=function(t){t.type===s.NONCE_TYPE&&this.hide()},i.prototype._handlePaymentMethodCancelled=function(t){t.source===s.PAYPAL_INTEGRATION_NAME&&this.show()},i.prototype.teardown=function(){this.wrapper.removeChild(this.container),this.bus.teardown()},e.exports=i}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{155:155,219:219,221:221,87:87}],214:[function(t,e,n){(function(n){"use strict";function i(t){this.options=t,this.bus=new s({merchantUrl:n.location.href,channel:t.channel}),this.bus.on(c.events.UI_MODAL_DID_OPEN,a(this.lockWindowSize,this)),this.bus.on(c.events.UI_MODAL_DID_CLOSE,a(this.unlockWindowSize,this))}function o(t){var e=window.getComputedStyle?getComputedStyle(t):t.currentStyle;return{overflow:e.overflow||"",height:t.style.height||""}}function r(){return{html:{node:document.documentElement,styles:o(document.documentElement)},body:{node:document.body,styles:o(document.body)}}}var s=t(155),a=t(87),c=t(219);i.prototype.lockWindowSize=function(){this.defaultStyles=r(),document.documentElement.style.height="100%",document.documentElement.style.overflow="hidden",document.body.style.height="100%",document.body.style.overflow="hidden"},i.prototype.unlockWindowSize=function(){this.defaultStyles&&(document.documentElement.style.height=this.defaultStyles.html.styles.height,document.documentElement.style.overflow=this.defaultStyles.html.styles.overflow,document.body.style.height=this.defaultStyles.body.styles.height,document.body.style.overflow=this.defaultStyles.body.styles.overflow,delete this.defaultStyles)},i.prototype._handleUIModalDidOpen=function(t){t.source===c.PAYPAL_INTEGRATION_NAME&&this.lockWindowSize()},i.prototype._handleUIModalDidClose=function(t){t.source===c.PAYPAL_INTEGRATION_NAME&&this.unlockWindowSize()},i.prototype.teardown=function(){this.unlockWindowSize(),this.bus.teardown()},e.exports=i}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{155:155,219:219,87:87}],215:[function(t,e,n){(function(n){"use strict";function i(t){this.options=t||{},this.container=document.body,this.bus=new c({merchantUrl:n.location.href,channel:t.channel}),this.options.isDropin?this._open=this._openHeadless:this._attachBusEvents(),this._initialize()}var o=t(87),r=t(143),s=t(227),a=t(219),c=t(155),u=t(82);i.prototype._attachBusEvents=function(){this.bus.on(a.events.OPEN_MODAL,o(this.open,this))},i.prototype._initialize=function(){var t=this.options.isHermes?a.HERMES_FRAME_NAME:a.FRAME_NAME;this.el=u({src:this.options.src,name:t,height:this.options.height||"100%",width:this.options.width||"100%",style:{position:s.isMobile()?"absolute":"fixed",top:0,left:0,bottom:0,padding:0,margin:0,border:0,outline:"none",zIndex:20001,background:"#FFFFFF"}})},i.prototype.isClosed=function(){return!this.container.contains(this.el)},i.prototype._openHeadless=function(){this.bus.emit(a.events.OPEN_MODAL)},i.prototype._open=function(){r(this.options.insertFrameFunction)?this.options.insertFrameFunction(this.el.src):this.container.appendChild(this.el),this.bus.emit(a.events.UI_MODAL_DID_OPEN,{source:a.PAYPAL_INTEGRATION_NAME})},i.prototype.open=function(){this.isClosed()&&this._open()},i.prototype.close=function(){this.isClosed()||(this.container.removeChild(this.el),this.bus.emit(a.events.UI_MODAL_DID_CLOSE,{source:a.PAYPAL_INTEGRATION_NAME}))},i.prototype.teardown=function(){this.close(),this.bus.teardown()},e.exports=i}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{143:143,155:155,219:219,227:227,82:82,87:87}],216:[function(t,e,n){(function(n){"use strict";function i(t){var e;this.options=t,this.spriteSrc=this.options.paypalAssetsUrl+"/pwpp/"+u.VERSION+"/images/pp_overlay_sprite.png",this.bus=new c({merchantUrl:n.location.href,channel:t.channel}),this.destructor=new a,e=l(this.options.locale,h),this.translation=e.translation,this._create(),this._setupEvents(),this.bus.on(c.events.UI_POPUP_DID_OPEN,r(this._handleUIPopupDidOpen,this)),this.bus.on(c.events.UI_POPUP_DID_CLOSE,r(this._handleUIPopupDidClose,this))}var o=t(73),r=t(87),s=t(143),a=t(77),c=t(155),u=t(219),l=t(222),h=t(209);i.prototype.open=function(){document.body.contains(this.el)||document.body.appendChild(this.el)},i.prototype.close=function(){document.body.contains(this.el)&&document.body.removeChild(this.el)},i.prototype._handleUIPopupDidClose=function(t){t.source===u.PAYPAL_INTEGRATION_NAME&&this.close()},i.prototype._handleUIPopupDidOpen=function(t){t.source===u.PAYPAL_INTEGRATION_NAME&&this.open()},i.prototype._create=function(){this.el=document.createElement("div"),this.el.className="bt-overlay",this._setStyles(this.el,["z-index: 20001","position: fixed","top: 0","left: 0","height: 100%","width: 100%","text-align: center","background: #000","background: rgba(0,0,0,0.7)",'-ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=52)"']),this.el.appendChild(this._createCloseIcon()),this.el.appendChild(this._createMessage())},i.prototype._createCloseIcon=function(){return this.closeIcon=document.createElement("div"),this.closeIcon.className="bt-close-overlay",this._setStyles(this.closeIcon,["position: absolute","top: 10px","right: 10px","cursor: pointer","background: url("+this.spriteSrc+") no-repeat 0 -67px","height: 14px","width: 14px"]),this.closeIcon},i.prototype._createMessage=function(){var t=document.createElement("div");return this._setStyles(t,["position: relative","top: 50%","max-width: 350px",'font-family: "HelveticaNeue", "HelveticaNeue-Light", "Helvetica Neue Light", helvetica, arial, sans-serif',"font-size: 14px","line-height: 20px","margin: -70px auto 0"]),t.appendChild(this._createLogo()),t.appendChild(this._createExplanation()),t.appendChild(this._createFocusLink()),t},i.prototype._createExplanation=function(){return this.explanation=document.createElement("div"),this._setStyles(this.explanation,["color: #FFF","margin-bottom: 20px"]),this.explanation.innerHTML=this.translation.overlay_text,this.explanation},i.prototype._createLogo=function(){var t=document.createElement("div");return this._setStyles(t,["background: url("+this.spriteSrc+") no-repeat 0 0","width: 94px","height: 25px","margin: 0 auto 26px auto"]),t},i.prototype._createFocusLink=function(){return this.focusLink=document.createElement("a"),this._setStyles(this.focusLink,["color: #009be1","cursor: pointer"]),this.focusLink.innerHTML=this.translation.continue_link,this.focusLink},i.prototype._setStyles=function(t,e){var n=e.join(";");t.style.cssText=n},i.prototype._setupEvents=function(){var t=this,e=r(this._handleClose,this),n=r(this._handleFocus,this);o.addEventListener(this.closeIcon,"click",e),o.addEventListener(this.focusLink,"click",n),this.destructor.registerFunctionForTeardown(function(){o.removeEventListener(t.closeIcon,"click",e),o.removeEventListener(t.focusLink,"click",n)})},i.prototype._handleClose=function(t){t.preventDefault(),this.close(),s(this.options.onClose)&&this.options.onClose()},i.prototype._handleFocus=function(t){t.preventDefault(),s(this.options.onFocus)&&this.options.onFocus()},i.prototype.teardown=function(){this.bus.teardown(),this.destructor.teardown(),this.close()},e.exports=i}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{143:143,155:155,209:209,219:219,222:222,73:73,77:77,87:87}],217:[function(t,e,n){(function(n){"use strict";function i(t){this.options=t||{},this.container=this.options.container||document.body,this.el=this.options.el,this.destructor=new a,this.bus=new c({merchantUrl:n.location.href,channel:t.channel}),this._initialize()}var o=t(73),r=t(87),s=t(143),a=t(77),c=t(155),u=t(219);i.prototype._initialize=function(){var t=this;s(this.el)||(null!=this.el?(this.el=o.normalizeElement(this.el),this.destructor.registerFunctionForTeardown(function(){t.clear()})):this.el=this.create()),this.bus.on(c.events.PAYMENT_METHOD_GENERATED,r(this._handlePaymentMethodGenerated,this)),this.bus.on(c.events.PAYMENT_METHOD_CANCELLED,r(this._handlePaymentMethodCancelled,this))},i.prototype.create=function(){var t=this,e=document.createElement("input");return e.name="payment_method_nonce",e.type="hidden",this.container.appendChild(e),this.destructor.registerFunctionForTeardown(function(){t.container.removeChild(e)}),e},i.prototype.value=function(t){s(this.el)?this.el(t):this.el.value=t},i.prototype.clear=function(){this.value("")},i.prototype._handlePaymentMethodCancelled=function(t){t.source===u.PAYPAL_INTEGRATION_NAME&&this.clear()},i.prototype._handlePaymentMethodGenerated=function(t){t.type===u.NONCE_TYPE&&this.value(t.nonce)},i.prototype.teardown=function(){this.destructor.teardown(),this.bus.teardown()},e.exports=i}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{143:143,155:155,219:219,73:73,77:77,87:87}],218:[function(t,e,n){(function(n){"use strict";function i(t){this.options=t,this.bus=new r({merchantUrl:n.location.href,channel:this.options.channel}),t.isHermes?(this.name=o.HERMES_POPUP_NAME,this.popupHeight=o.HERMES_POPUP_HEIGHT,this.popupWidth=o.HERMES_POPUP_WIDTH):(this.name=o.POPUP_NAME,this.popupHeight=o.POPUP_HEIGHT,this.popupWidth=o.POPUP_WIDTH)}var o=t(219),r=t(155),s=t(223);i.prototype._getPopupOptions=function(){return["height="+this.popupHeight,"width="+this.popupWidth,"top="+this._getTopPosition(),"left="+this._getLeftPosition(),o.POPUP_OPTIONS].join(",")},i.prototype._centerPosition=function(t,e,n){return(t-e)/2+n},i.prototype._getTopPosition=function(){var t=window.outerHeight||document.documentElement.clientHeight,e="undefined"==typeof window.screenY?window.screenTop:window.screenY;return this._centerPosition(t,this.popupHeight,e)},i.prototype._getLeftPosition=function(){var t=window.outerWidth||document.documentElement.clientWidth,e="undefined"==typeof window.screenX?window.screenLeft:window.screenX;return this._centerPosition(t,this.popupWidth,e)},i.prototype.isClosed=function(){return this.el?this.el.closed:void 0},i.prototype.open=function(){this.el||(this.el=window.open(this.options.src,this.name,this._getPopupOptions()),this.focus(),this.bus.emit(r.events.UI_POPUP_DID_OPEN,{source:o.PAYPAL_INTEGRATION_NAME}))},i.prototype.close=function(){this.el&&((s.isIE8()&&!this.isClosed()||!s.isIE8())&&this.el.close(),this.bus.emit(r.events.UI_POPUP_DID_CLOSE,{source:o.PAYPAL_INTEGRATION_NAME}))},i.prototype.focus=function(){this.el&&this.el.focus()},i.prototype.teardown=function(){this.close(),this.bus.teardown()},e.exports=i}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{155:155,219:219,223:223}],219:[function(t,e,n){"use strict";var i,o="2.18.0",r=["GET_CLIENT_TOKEN","GET_CLIENT_OPTIONS","OPEN_MODAL","CLOSE_APP","FOCUS_APP","UI_MODAL_DID_OPEN","UI_MODAL_DID_CLOSE"],s={LEGACY_ONETIME:"Legacy Onetime",HERMES_ONETIME:"Hermes Onetime",LEGACY_FUTURE_PAYMENTS:"Legacy Future Payments",HERMES_BILLING_AGREEMENTS:"Hermes Billing Agreements"};for(n.VERSION=o,n.POPUP_NAME="braintree_paypal_popup",n.HERMES_POPUP_NAME="PPFrameRedirect",n.FRAME_NAME="braintree-paypal-frame",n.HERMES_FRAME_NAME="PPFrameRedirect",n.POPUP_PATH="/pwpp/"+o+"/html/braintree-frame.html",n.POPUP_OPTIONS="resizable,scrollbars",n.POPUP_HEIGHT=470,n.POPUP_WIDTH=410,n.HERMES_POPUP_HEIGHT=535,n.HERMES_POPUP_WIDTH=450,n.BRIDGE_FRAME_NAME="bt-proxy-frame",n.HERMES_SUPPORTED_CURRENCIES=["USD","GBP","EUR","AUD","CAD","DKK","NOK","PLN","SEK","CHF","TRY","BRL"],n.HERMES_SUPPORTED_COUNTRIES=["US","GB","AU","CA","ES","FR","DE","IT","NL","NO","PL","CH","TR","DK","BE","AT"],n.NONCE_TYPE="PayPalAccount",n.PAYPAL_INTEGRATION_NAME="PayPal",n.ILLEGAL_XHR_ERROR="Illegal XHR request attempted",n.CONFIGURATION_TYPES=s,n.events={},i=0;i<r.length;i++)n.events[r[i]]="paypal:"+r[i]},{}],220:[function(t,e,n){"use strict";e.exports={us:"en_us",gb:"en_uk",uk:"en_uk",de:"de_de",fr:"fr_fr",it:"it_it",es:"es_es",ca:"en_ca",au:"en_au",at:"de_de",be:"en_us",ch:"de_de",dk:"da_dk",nl:"nl_nl",no:"no_no",pl:"pl_pl",se:"sv_se",tr:"tr_tr",bg:"en_us",cy:"en_us",hr:"en_us",is:"en_us",kh:"en_us",mt:"en_us",my:"en_us",ru:"ru_ru"}},{}],221:[function(t,e,n){"use strict";function i(t){return-1!==t.indexOf("_")&&5===t.length}function o(t){var e,n;for(e in s)s.hasOwnProperty(e)&&(e===t?n=s[e]:s[e]===t&&(n=s[e]));return n}function r(t){var e,n;return t=t?t.toLowerCase():"us",t=t.replace(/-/g,"_"),e=i(t)?t:o(t),e?(n=e.split("_"),[n[0],n[1].toUpperCase()].join("_")):"en_US"}var s=t(220);e.exports=r},{220:220}],222:[function(t,e,n){"use strict";function i(t){var e=t?t.toLowerCase().replace(/-/g,"_"):"us";return-1!==e.indexOf("_")&&(e=e.split("_")[1]),e=s[e]?e:"us","uk"===e&&(e="gb"),e}function o(t,e){return t=t.toLowerCase(),e[t]?e[t]:e.en_us}function r(t,e){var n=i(t),r=a(t),s=o(r,e);return{country:n,locale:r,translation:s}}var s=t(220),a=t(221);e.exports=r},{220:220,221:221}],223:[function(t,e,n){"use strict";function i(){return d.matchUserAgent("Android")&&!o()}function o(){return d.matchUserAgent("Chrome")||d.matchUserAgent("CriOS")}function r(){return d.matchUserAgent("Firefox")}function s(){return d.matchUserAgent("Trident")||d.matchUserAgent("MSIE")}function a(){return d.matchUserAgent(/MSIE 8\.0/)}function c(){return d.matchUserAgent("Opera")||d.matchUserAgent("OPR")}function u(){return c()&&"[object OperaMini]"===Object.prototype.toString.call(window.operamini)}function l(){return d.matchUserAgent("Safari")&&!o()&&!i()}function h(){return f.isIos()&&!o()&&!l()}function p(){var t=/Version\/[\w\.]+ Chrome\/[\w\.]+ Mobile/;return f.isAndroid()&&d.matchUserAgent(t)}var d=t(226),f=t(225);e.exports={isAndroid:i,isChrome:o,isFirefox:r,isIE:s,isIE8:a,isOpera:c,isOperaMini:u,isSafari:l,isIosWebView:h,isAndroidWebView:p}},{225:225,226:226}],224:[function(t,e,n){"use strict";function i(){return!o()&&(a.isAndroid()||a.isIpod()||a.isIphone()||s.matchUserAgent("IEMobile"))}function o(){return a.isIpad()||a.isAndroid()&&!s.matchUserAgent("Mobile")}function r(){return!i()&&!o()}var s=t(226),a=t(225);e.exports={isMobile:i,isTablet:o,isDesktop:r}},{225:225,226:226}],225:[function(t,e,n){"use strict";function i(){return c.matchUserAgent("Android")}function o(){return c.matchUserAgent("iPad")}function r(){return c.matchUserAgent("iPod")}function s(){return c.matchUserAgent("iPhone")&&!r()}function a(){return o()||r()||s()}var c=t(226);e.exports={isAndroid:i,isIpad:o,isIpod:r,isIphone:s,isIos:a}},{226:226}],226:[function(t,e,n){"use strict";function i(){return r}function o(t){var e=n.getNativeUserAgent(),i=e.match(t);return i?!0:!1}var r=window.navigator.userAgent;n.getNativeUserAgent=i,n.matchUserAgent=o},{}],227:[function(t,e,n){"use strict";function i(){return o()&&window.outerWidth<600}function o(){return m.test(f)}function r(){return Boolean(window.postMessage)}function s(){if(l.isOperaMini())return!1;if(h.isDesktop())return!0;if(h.isMobile()||h.isTablet()){if(l.isIE())return!1;if(p.isAndroid())return l.isAndroidWebView()?!1:!0;if(p.isIos())return l.isChrome()?!1:l.isSafari()&&d.matchUserAgent(/OS (?:8_1|8_0|8)(?!_\d)/i)?!1:l.isIosWebView()?!1:!0}return!1}function a(){if(l.isIE8())return!1;try{return window.self===window.top}catch(t){return!1}}function c(){return l.isIE()}function u(){var t=null,e="";try{new ActiveXObject("")}catch(n){e=n.name}try{t=Boolean(new ActiveXObject("htmlfile"))}catch(n){t=!1}return t="ReferenceError"!==e&&t===!1?!1:!0,!t}var l=t(223),h=t(224),p=t(225),d=t(226),f=window.navigator.userAgent,m=/[Mm]obi|tablet|iOS|Android|IEMobile|Windows\sPhone/;e.exports={isMobile:i,isMobileDevice:o,detectedPostMessage:r,isPopupSupported:s,isOverlaySupported:a,isBridgeIframeRequired:c,isMetroBrowser:u}},{223:223,224:224,225:225,226:226}],228:[function(t,e,n){"use strict";function i(t,e){var n="innerText";document&&document.body&&"textContent"in document.body&&(n="textContent"),t[n]=e}e.exports={setTextContent:i}},{}],229:[function(t,e,n){"use strict";function i(){var t,e,n="";for(t=0;32>t;t++)e=Math.floor(16*Math.random()),n+=e.toString(16);return n}function o(t){return/^(true|1)$/i.test(t)}function r(t){return t.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/\"/g,"&quot;").replace(/\'/g,"&apos;")}function s(t){var e,n,i,o,r,s,a,c,u=t.indexOf("?"),l={};if(u>=0&&(t=t.substr(u+1)),0===t.length)return null;for(e=t.split("&"),n=0,i=e.length;i>n;n++)o=e[n],r=o.indexOf("="),s=o.substr(0,r),c=o.substr(r+1),a=decodeURIComponent(c),a=a.replace(/</g,"&lt;").replace(/>/g,"&gt;"),"false"===a&&(a=!1),(null==a||"true"===a)&&(a=!0),l[s]=a;return l}function a(t){t.preventDefault?t.preventDefault():t.returnValue=!1}function c(t){var e;return e=Boolean(t.merchantConfiguration.paypal.amount)&&Boolean(t.merchantConfiguration.paypal.currency)?d.CONFIGURATION_TYPES.HERMES_ONETIME:d.CONFIGURATION_TYPES.LEGACY_ONETIME}function u(t){var e;return e=Boolean(t.gatewayConfiguration.paypal.billingAgreementsEnabled)?d.CONFIGURATION_TYPES.HERMES_BILLING_AGREEMENTS:d.CONFIGURATION_TYPES.LEGACY_FUTURE_PAYMENTS}function l(t){var e;return e=Boolean(t.merchantConfiguration.paypal.singleUse)?c(t):u(t)}function h(t){var e=l(t);return e===d.CONFIGURATION_TYPES.HERMES_ONETIME||e===d.CONFIGURATION_TYPES.HERMES_BILLING_AGREEMENTS}function p(t){var e=l(t);return e===d.CONFIGURATION_TYPES.HERMES_ONETIME}var d=t(219),f="function"==typeof String.prototype.trim?function(t){return t.trim()}:function(t){return t.replace(/^\s+|\s+$/,"")},m="function"==typeof window.btoa?function(t){return window.btoa(t)}:function(t){for(var e,n,i,o,r,s,a,c="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",u="",l=0;l<t.length;)e=t.charCodeAt(l++),n=t.charCodeAt(l++),i=t.charCodeAt(l++),o=e>>2,r=(3&e)<<4|n>>4,s=(15&n)<<2|i>>6,a=63&i,isNaN(n)?s=a=64:isNaN(i)&&(a=64),u=u+c.charAt(o)+c.charAt(r)+c.charAt(s)+c.charAt(a);return u};e.exports={trim:f,btoa:m,generateUid:i,castToBoolean:o,htmlEscape:r,parseUrlParams:s,preventDefault:a,isHermesConfiguration:h,isOnetimeHermesConfiguration:p,getConfigurationType:l}},{219:219}]},{},[172])(172)});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1).module('wowApp.common').service('InStoreProductService', __webpack_require__(870));

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MHSF_PRODUCTDETAIL_KEY = 'mhsfProductDetail';
var sessionStorageKey = 'forceFmsPopup';
var instoreDisclaimerStorageKey = 'instoreDisclaimer';

var InStoreProductService = function () {
    function InStoreProductService($state, Restangular, sessionStorageWrapper, detailProductService, shopperService, trolleyService, loginService, $location) {
        _classCallCheck(this, InStoreProductService);

        this.$location = $location;
        this.$state = $state;
        this.api = Restangular.all('products');
        this.sessionStorage = sessionStorageWrapper;
        this.detailProductService = detailProductService;
        this.shopperService = shopperService;
        this.trolleyService = trolleyService;
        this.loginService = loginService;
        this.showInstoreDisclaimer = false;
        this.disclaimerEnabled = false;
    }

    _createClass(InStoreProductService, [{
        key: 'retrieveAndRemoveMhsfDetail',
        value: function retrieveAndRemoveMhsfDetail() {
            return this.sessionStorage.getJsonAndRemove(MHSF_PRODUCTDETAIL_KEY);
        }
    }, {
        key: 'triggerMhsfProduct',
        value: function triggerMhsfProduct(instoreSalePrice, stockCode, storeCode, quantity, source, searchTerm) {
            var _this = this;

            var isInTrolley = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;

            // remove MHSF params from state to prevent user from being redirect to this page after login.
            if (this.$state.params.googleshop) {
                delete this.$state.params.googleshop;
                delete this.$state.params.store_code;
                delete this.$state.params.cmpid;
            }

            if (this.shopperService.IsGuest) {
                this.loginService.promptForLogin(this.loginService.LoginToAddMoreProductsMessage, null, null, null, function () {
                    _this.processMhsfProduct(instoreSalePrice, stockCode, storeCode, quantity, source, searchTerm, false, isInTrolley);
                });
            } else {
                this.$location.url(this.$location.path());
                this.$state.transitionTo(this.$state.current, this.$state.params, {
                    reload: true, inherit: false, notify: true
                });
                this.processMhsfProduct(instoreSalePrice, stockCode, storeCode, quantity, source, searchTerm, true, isInTrolley);
            }
        }
    }, {
        key: 'processMhsfProduct',
        value: function processMhsfProduct(instoreSalePrice, stockCode, storeCode, quantity, source, searchTerm, authenticated) {
            var _this2 = this;

            var isInTrolley = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;

            if (this.shopperService.shopper.FulfilmentStoreId === storeCode || authenticated) {
                if (isInTrolley === true) {
                    // if the product is already in trolley then display relevant disclaimer without performing any update
                    this.showDisclaimer(stockCode, instoreSalePrice);
                } else {
                    // same store - skip FMS and add product
                    this.addProductToCart(stockCode, instoreSalePrice, quantity, source, searchTerm).then(function (didAddToCart) {
                        if (!didAddToCart) {
                            _this2.enableDisclaimer();
                        }
                    });
                }

                return;
            }

            // different selected store and was a guest user. Store data in session to use after FMS is complete.
            this.sessionStorage.setJson(MHSF_PRODUCTDETAIL_KEY, {
                instoreSalePrice: instoreSalePrice, stockCode: stockCode, quantity: quantity, source: source, searchTerm: searchTerm
            });

            // trigger FMS.
            this.sessionStorage.set(sessionStorageKey, true);
        }
    }, {
        key: 'shouldShowFMS',
        value: function shouldShowFMS() {
            return this.sessionStorage.getAndRemove(sessionStorageKey, true);
        }
    }, {
        key: 'addSavedProductToCart',
        value: function addSavedProductToCart() {
            var _this3 = this;

            var mhsfDetail = this.retrieveAndRemoveMhsfDetail();
            if (mhsfDetail) {
                this.addProductToCart(mhsfDetail.stockCode, mhsfDetail.instoreSalePrice, mhsfDetail.quantity, mhsfDetail.source, mhsfDetail.searchTerm).then(function (didAddToCart) {
                    if (!didAddToCart) {
                        _this3.enableDisclaimer();
                    }
                });
            }
        }
    }, {
        key: 'addProductToCart',
        value: function addProductToCart(stockCode, instoreSalePrice, quantity, source, searchTerm) {
            var _this4 = this;

            return this.detailProductService.getProductDetail(stockCode).then(function (detail) {
                if (detail.Product.Price <= instoreSalePrice && detail.Product.IsPurchasable) {
                    _this4.trolleyService.addItemToTrolley(detail.Product, quantity, source, searchTerm);
                    return true;
                }

                return false;
            });
        }

        // puts disclaimer knowledge in storage for when this logic needs to persist the page refresh after login.

    }, {
        key: 'enableDisclaimer',
        value: function enableDisclaimer() {
            this.sessionStorage.set(instoreDisclaimerStorageKey, true);
            this.disclaimerEnabled = true;
        }

        // to be called before using disclaimerEnabled field incase it was reset by a page refresh (by logging in)

    }, {
        key: 'UpdateDisclaimer',
        value: function UpdateDisclaimer() {
            this.disclaimerEnabled = this.sessionStorage.getAndRemove(instoreDisclaimerStorageKey);
        }
    }, {
        key: 'showDisclaimer',
        value: function showDisclaimer(stockCode, instoreSalePrice) {
            var _this5 = this;

            this.detailProductService.getProductDetail(stockCode).then(function (detail) {
                if (detail.Product.Price > instoreSalePrice || !detail.Product.IsPurchasable) {
                    _this5.enableDisclaimer();
                }
            });
        }
    }]);

    return InStoreProductService;
}();

InStoreProductService.$inject = ['$state', 'Restangular', 'SessionStorageWrapper', 'DetailProductService', 'ShopperService', 'TrolleyService', 'LoginService', '$location'];

module.exports = InStoreProductService;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1).module('wowApp.common').service('SavedListsService', __webpack_require__(872));

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    find = _require.find,
    remove = _require.remove;

var SavedListsService = function () {
    function SavedListsService($rootScope, restangular, $q, $location, bootstrap, analyticsService) {
        _classCallCheck(this, SavedListsService);

        this.$rootScope = $rootScope;
        this.restangular = restangular;
        this.api = restangular.one('mylists');
        this.woolworthsRewardsApi = restangular.one('edr');
        this.$q = $q;
        this.$location = $location;
        this.analyticsService = analyticsService;

        // Promise used to cache saved lists
        this.savedListsPromise = null;

        // Used to share new created list details
        this.newListData = null;

        if (bootstrap.isBootstrapped(bootstrap.bootstrapped.SavedLists)) {
            // we do this instead of invalidating on login because sometimes the saved lists service hasn't been
            // instantiated before the login event, meaning we can't call invalidate and the incorrect bootstrapped data
            // will be loaded.
            var bootstrappedSavedLists = bootstrap.getBootstrappedData(bootstrap.bootstrapped.SavedLists);

            if (bootstrappedSavedLists.Response.length > 0) {
                this.savedListsPromise = this.$q.when(this.setSavedLists(bootstrappedSavedLists));
            }
        }
    }

    _createClass(SavedListsService, [{
        key: 'setSavedLists',
        value: function setSavedLists(data) {
            this.isServiceAvailable = data.IsServiceAvailable;
            this.savedLists = data.Response;
            return this.savedLists;
        }
    }, {
        key: 'invalidateCache',
        value: function invalidateCache() {
            // This will reset the saved lists promise to fetch from the API. This is needed when the
            // result is unpredictable / impractial to determine using the frontend only.
            // This call is slow so we should try to not invalidate the cache if we can, however,
            // Accuracy of data > Speed
            this.savedListsPromise = null;
            return this.getAllSavedLists();
        }
    }, {
        key: 'getIsServiceAvailable',
        value: function getIsServiceAvailable() {
            return this.isServiceAvailable;
        }
    }, {
        key: 'getDefaultList',
        value: function getDefaultList() {
            return this.$q.resolve(this.savedListsPromise).then(function (savedLists) {
                return savedLists[0];
            });
        }
    }, {
        key: 'getAllSavedLists',
        value: function getAllSavedLists() {
            var _this = this;

            if (!this.savedListsPromise) {
                // Cache has been invalidated, fetch from API
                this.savedListsPromise = this.api.get().then(function (data) {
                    return _this.setSavedLists(data);
                });
            }
            return this.savedListsPromise;
        }
    }, {
        key: 'getSmartList',
        value: function getSmartList(pageNumber, sortType, pageSize) {
            return this.api.one('smart').get({
                PageNumber: pageNumber,
                PageSize: pageSize,
                SortType: sortType,
                Location: this.$location.url(),
                Filters: []
            });
        }
    }, {
        key: 'getSavedList',
        value: function getSavedList(listId) {
            var _this2 = this;

            // If the cache is valid, just use the list already there
            if (this.savedListsPromise) {
                return this.getAllSavedLists().then(function (lists) {
                    return _this2.$q.when(find(lists, function (list) {
                        return list.ListId === listId;
                    }));
                });
            }
            // Else fetch only the list specified from the API
            return this.api.one(listId).get();
        }
    }, {
        key: 'setDefaultList',
        value: function setDefaultList(listId) {
            var _this3 = this;

            return this.api.one('setdefaultlist', listId).doPOST().then(function () {
                return _this3.invalidateCache();
            });
        }
    }, {
        key: 'saveNewList',
        value: function saveNewList(name) {
            var _this4 = this;

            return this.api.one('add').doPOST({ Name: name }).then(function (response) {
                if (!response.Success) {
                    throw response;
                }
                _this4.newListData = response;

                // We need to broadcast when this happens so the product save to list component updates the list
                _this4.$rootScope.$broadcast('savedLists:AddNewList');

                return _this4.invalidateCache();
            });
        }
    }, {
        key: 'renameList',
        value: function renameList(listId, newName) {
            var _this5 = this;

            return this.api.one('edit').doPOST({ Id: listId, Name: newName }).then(function () {
                var listToRename = find(_this5.savedLists, function (list) {
                    return list.ListId === listId;
                });
                listToRename.Name = newName;

                // We need to broadcast when this happens so the list counts update appropriately
                _this5.$rootScope.$broadcast('savedLists:RenameList');

                return _this5.$q.when(_this5.savedLists);
            }).catch(function () {
                return _this5.invalidateCache();
            });
        }
    }, {
        key: 'deleteList',
        value: function deleteList(listId) {
            var _this6 = this;

            var isDefault = this.savedLists[0].ListId === listId;
            return this.api.one('deleteList', listId).doPOST().then(function () {
                // If it is the default list, the order changes, so we need to fetch from the API
                if (isDefault) {
                    return _this6.invalidateCache();
                }

                // If it is not the default list, we do not need to refetch the whole list, making this call faster
                remove(_this6.savedLists, function (list) {
                    return list.ListId === listId;
                });
                return _this6.$q.when(_this6.savedLists);
            }).catch(function () {
                return _this6.invalidateCache();
            });
        }
    }, {
        key: 'getProductsForSelectedList',
        value: function getProductsForSelectedList(listId, pageNumber, sortType) {
            var pageSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;
            var filters = arguments[4];

            // In case something passes undefined
            if (pageSize === undefined) {
                pageSize = 10;
            }
            if (sortType === undefined) {
                sortType = 'Name';
            }
            return this.restangular.one('mylists', listId).post('products', {
                PageNumber: pageNumber,
                PageSize: pageSize,
                SortType: sortType,
                Location: this.$location.url(),
                Filters: filters ? filters.filters : []
            });
        }
    }, {
        key: 'getProductsForWoolworthsRewards',
        value: function getProductsForWoolworthsRewards(pageNumber, sortType) {
            var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;

            // In case something passes undefined as pageSize
            if (pageSize === undefined) {
                pageSize = 10;
            }
            return this.woolworthsRewardsApi.doGET('Products', { pageNumber: pageNumber, pageSize: pageSize, sortType: sortType });
        }
    }, {
        key: 'addListItem',
        value: function addListItem(listId, stockcode, quantity, source) {
            var _this7 = this;

            return this.restangular.one('mylists', listId).one('Items').doPOST({ StockCode: stockcode, Quantity: quantity, Source: source }).then(function () {
                _this7.analyticsService.pushEvent(_this7.analyticsService.events.SAVE_TO_LIST);

                // We cannot just increment as you may add an item that is already in the list in which
                // case will throw off the item count as there cannot be duplicates in a saved list
                // this.savedLists has no way of knowing what is in the list. We MUST invalidate the cache.
                _this7.$q.when(_this7.invalidateCache()).then(function () {
                    // We need to broadcast when this happens so the list counts update appropriately
                    _this7.$rootScope.$broadcast('savedLists:AddListItem', { listId: listId, stockCode: stockcode, quantity: quantity });
                });
            });
        }
    }, {
        key: 'deleteListItem',
        value: function deleteListItem(listId, stockcode) {
            var _this8 = this;

            return this.api.one('deleteitem').doPOST({ Id: listId, StockCode: stockcode }).then(function () {
                // Decrement the count from the list
                var listToDeleteItemFrom = find(_this8.savedLists, function (list) {
                    return list.ListId === listId;
                });
                listToDeleteItemFrom.ProductsCount--;

                // We need to broadcast when this happens so the list counts update appropriately
                _this8.$rootScope.$broadcast('savedLists:DeleteListItem', { listId: listId, stockCode: stockcode });

                return _this8.$q.when(_this8.savedLists);
            }).catch(function () {
                return _this8.invalidateCache();
            });
        }
    }]);

    return SavedListsService;
}();

SavedListsService.$inject = ['$rootScope', 'Restangular', '$q', '$location', 'BootstrapService', 'AnalyticsService'];

module.exports = SavedListsService;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(874),
    ShopPageStateService = _require.ShopPageStateService;

angular.module('wowApp.common').service('ShopPageStateService', ShopPageStateService);

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ShopPageStateService = function () {
    function ShopPageStateService($document) {
        _classCallCheck(this, ShopPageStateService);

        this.$document = $document;

        this.smallFormatMenuOpen = false;
        this.isCartOpen = false;
    }

    _createClass(ShopPageStateService, [{
        key: 'resetCenterPanelScroll',
        value: function resetCenterPanelScroll() {
            this.$document.scrollTop(0);
        }
    }, {
        key: 'toggleBodyScroll',
        value: function toggleBodyScroll(shouldBeScrollable) {
            this.$document.find('body').toggleClass('noscroll', !shouldBeScrollable);
        }
    }]);

    return ShopPageStateService;
}();

ShopPageStateService.$inject = ['$document'];

module.exports = { ShopPageStateService: ShopPageStateService };

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(876),
    smallFormatMenuComponentDefinition = _require.smallFormatMenuComponentDefinition;

var _require2 = __webpack_require__(878),
    smallFormatMenuPanelComponentDefinition = _require2.smallFormatMenuPanelComponentDefinition;

angular.module('wowApp.common').component('wowSmallMenu', smallFormatMenuComponentDefinition).component('wowSmallMenuPanel', smallFormatMenuPanelComponentDefinition);

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    cloneDeep = _require.cloneDeep,
    last = _require.last;

var SmallFormatMenuController = function () {
    function SmallFormatMenuController($scope, $element, $state, moveFocus, shopPageStateService, shopperService, inspirationService, recipeCategoriesService) {
        var _this = this;

        _classCallCheck(this, SmallFormatMenuController);

        this.$element = $element;
        this.moveFocus = moveFocus;
        this.shopPageStateService = shopPageStateService;
        this.shopperService = shopperService;
        this.inspirationService = inspirationService;
        this.recipeCategoriesService = recipeCategoriesService;

        $scope.$on('$stateChangeStart', function () {
            _this.closeMenu();
        });

        $scope.$on('$stateChangeSuccess', function () {
            if (!$state.includes(_this.menuItems.discover.menuState) && !$state.includes(_this.menuItems.recipes.menuState)) {
                _this.currentPanel = 'panel1';
            }
        });
    }

    _createClass(SmallFormatMenuController, [{
        key: '$onInit',
        value: function $onInit() {
            this.currentPanel = 'panel1';
            this.menuItems = {
                discover: {
                    name: 'Discover', urlFriendlyName: '', items: [], loading: true, menuState: 'shop.inspiration.**'
                },
                lists: {
                    name: 'My Lists', urlFriendlyName: '', items: [], loading: true
                },
                recipes: {
                    name: 'Recipes', urlFriendlyName: '', items: [], loading: true, menuState: 'shop.recipes.**'
                }
            };
        }
    }, {
        key: 'isMenuOpen',
        value: function isMenuOpen() {
            return this.shopPageStateService.smallFormatMenuOpen;
        }
    }, {
        key: 'isCurrentPanel',
        value: function isCurrentPanel(panel) {
            return this.currentPanel === panel;
        }
    }, {
        key: 'closeMenu',
        value: function closeMenu() {
            if (this.shopPageStateService.smallFormatMenuOpen) {
                this.shopPageStateService.smallFormatMenuOpen = false;
            }
        }
    }, {
        key: 'openPanel',
        value: function openPanel(panel) {
            var _this2 = this;

            this.currentPanel = panel;
            this.moveFocus('.smallMenu-' + panel + ' nav a:first-child').then(function () {
                return _this2.$element.find('#smallMenu').scrollTop(0).scrollLeft(0);
            });
        }
    }, {
        key: 'openInspirationMenu',
        value: function openInspirationMenu($event) {
            var _this3 = this;

            $event.preventDefault();

            this.openPanel('panel2');
            this.subMenus = { level1: this.menuItems.discover };

            this.inspirationService.getNavigationItems().then(function (items) {
                _this3.menuItems.discover.items = _this3.mapInspirationNavigation(items);
            }).finally(function () {
                _this3.menuItems.discover.loading = false;
            });
        }
    }, {
        key: 'openRecipesMenu',
        value: function openRecipesMenu($event) {
            var _this4 = this;

            $event.preventDefault();

            this.openPanel('panel2');
            this.subMenus = { level1: this.menuItems.recipes };

            this.recipeCategoriesService.getAll().then(function (items) {
                _this4.menuItems.recipes.items = _this4.mapRecipesNavigation(items);
                if (!_this4.shopperService.IsGuest) {
                    _this4.menuItems.recipes.items.unshift({ name: 'My Favourite Recipes', items: [], sref: 'shop.recipes.savedList' });
                }
            }).finally(function () {
                _this4.menuItems.recipes.loading = false;
            });
        }
    }, {
        key: 'mapInspirationNavigation',
        value: function mapInspirationNavigation(items) {
            var _this5 = this;

            var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            var parentsClone = cloneDeep(parents);

            var discoverState = void 0,
                stateParams = void 0;
            if (parents.length === 2) {
                discoverState = 'parent.child.grandchild';
                stateParams = { parent: parents[0].UrlPart, child: parents[1].UrlPart };
            } else if (parents.length === 1) {
                discoverState = 'parent.child';
                stateParams = { parent: parents[0].UrlPart };
            } else {
                discoverState = 'parent';
                stateParams = {};
            }

            var statePart = last(discoverState.split('.'));

            return items.map(function (i) {
                parentsClone[parents.length] = i;
                stateParams[statePart] = i.UrlPart;

                return {
                    name: i.Name,
                    items: _this5.mapInspirationNavigation(i.Items || [], parentsClone),
                    sref: 'shop.inspiration.' + discoverState + '(' + JSON.stringify(stateParams) + ')'
                };
            });
        }
    }, {
        key: 'mapRecipesNavigation',
        value: function mapRecipesNavigation(items, parent) {
            var _this6 = this;

            return items.map(function (i) {
                return {
                    name: i.Name,
                    items: _this6.mapRecipesNavigation(i.ChildCategories || [], i),
                    sref: 'shop.recipes.' + (parent ? 'category.subCategory' : 'category') + '(' + (parent ? '{ category: \'' + parent.UrlFriendlyName + '\', subCategory: \'' + i.UrlFriendlyName + '\' }' : '{ category: \'' + i.UrlFriendlyName + '\' }') + ')'
                };
            });
        }
    }, {
        key: 'selectSubmenu',
        value: function selectSubmenu(event, panelClass, submenu) {
            this.openPanel(panelClass);
            this.subMenus = submenu;
            event.preventDefault();
        }
    }, {
        key: 'onLevel2Select',
        value: function onLevel2Select($event, item) {
            if (!(item.items && item.items.length > 0)) return;

            this.selectSubmenu($event, 'panel3', { level1: this.subMenus.level1, level2: item });
        }
    }, {
        key: 'onLevel3Select',
        value: function onLevel3Select($event, item) {
            if (!(item.items && item.items.length > 0)) return;

            this.selectSubmenu($event, 'panel4', {
                level1: this.subMenus.level1,
                level2: this.subMenus.level2,
                level3: item
            });
        }
    }]);

    return SmallFormatMenuController;
}();

var smallFormatMenuComponentDefinition = {
    controller: ['$scope', '$element', '$state', 'MoveFocus', 'ShopPageStateService', 'ShopperService', 'InspirationService', 'RecipeCategoriesService', SmallFormatMenuController],
    template: __webpack_require__(877).trim()
};

module.exports = {
    SmallFormatMenuController: SmallFormatMenuController,
    smallFormatMenuComponentDefinition: smallFormatMenuComponentDefinition
};

/***/ }),
/* 877 */
/***/ (function(module, exports) {

module.exports = "<div class=\"smallMenu-mask\" ng-if=\"$ctrl.isMenuOpen()\" ng-click=\"$ctrl.closeMenu()\"></div>\r\n\r\n<div id=\"smallMenu\" class=\"smallMenu\" ng-class=\"{ 'u-displayNone': !$ctrl.isMenuOpen() }\" tabindex=\"-1\">\r\n    <div class=\"smallMenu-panels\" ng-class=\"'is-' + $ctrl.currentPanel\">\r\n        <div class=\"smallMenu-panel smallMenu-panel1\" ng-class=\"{ 'shrink': !$ctrl.isCurrentPanel('panel1') }\">\r\n            <div class=\"smallMenu-login\" ng-if=\"$ctrl.shopperService.IsGuest\">\r\n                <a ui-sref=\"shop.authentication.login\" ui-sref-opts=\"{ reload: true }\" class=\"smallMenu-loginLink\">\r\n                    Login <i class=\"iconww-ArrowRight\"></i>\r\n                </a>\r\n                <a ui-sref=\"shop.authentication.signup\" ui-sref-opts=\"{ reload: true }\" class=\"smallMenu-loginLink\">\r\n                    Sign up <i class=\"iconww-ArrowRight\"></i>\r\n                </a>\r\n            </div>\r\n            <div class=\"smallMenu-login\" ng-if=\"!$ctrl.shopperService.IsGuest && !($ctrl.settings.business.enableBusiness && $ctrl.shopperService.shopper.OrganisationId)\">\r\n                <a ui-sref=\"shop.myaccount.details\" ui-sref-opts=\"{ reload: true }\" class=\"smallMenu-loginWelcome\">\r\n                    {{ $ctrl.shopperService.shopper.FirstName | usernamelimiter }}\r\n                </a>\r\n            </div>\r\n            <div class=\"smallMenu-login\" ng-if=\"!$ctrl.shopperService.IsGuest && ($ctrl.settings.business.enableBusiness && $ctrl.shopperService.shopper.OrganisationId)\">\r\n                <a href=\"/business/dashboard\" target=\"_self\" class=\"smallMenu-loginWelcome\">\r\n                    {{ $ctrl.shopperService.shopper.FirstName | usernamelimiter }}\r\n                </a>\r\n            </div>\r\n\r\n            <wow-core-header-nav\r\n                class-modifier=\"coreHeaderNav--vertical\"\r\n                on-inspiration-selected=\"$ctrl.openInspirationMenu($event)\"\r\n                on-recipes-selected=\"$ctrl.openRecipesMenu($event)\">\r\n            </wow-core-header-nav>\r\n\r\n            <h2 class=\"smallMenu-services\">Explore our other services</h2>\r\n            <wow-corporate-header class-modifier=\"corporateHeader--vertical\"></wow-corporate-header>\r\n        </div>\r\n\r\n        <wow-small-menu-panel\r\n            class=\"smallMenu-panel smallMenu-panel2\"\r\n            ng-class=\"{ 'shrink': !$ctrl.isCurrentPanel('panel2') }\"\r\n            navigation-item=\"$ctrl.subMenus.level1\"\r\n            on-click-back=\"$ctrl.openPanel('panel1')\"\r\n            on-navigation-item-select=\"$ctrl.onLevel2Select($event, item)\">\r\n        </wow-small-menu-panel>\r\n\r\n        <wow-small-menu-panel\r\n            class=\"smallMenu-panel smallMenu-panel3\"\r\n            ng-class=\"{ 'shrink': !$ctrl.isCurrentPanel('panel3') }\"\r\n            navigation-item=\"$ctrl.subMenus.level2\"\r\n            on-click-back=\"$ctrl.openPanel('panel2')\"\r\n            on-navigation-item-select=\"$ctrl.onLevel3Select($event, item)\">\r\n        </wow-small-menu-panel>\r\n\r\n        <wow-small-menu-panel\r\n            class=\"smallMenu-panel smallMenu-panel4\"\r\n            ng-class=\"{ 'shrink': !$ctrl.isCurrentPanel('panel4') }\"\r\n            navigation-item=\"$ctrl.subMenus.level3\"\r\n            on-click-back=\"$ctrl.openPanel('panel3')\">\r\n        </wow-small-menu-panel>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SmallFormatMenuPanelController = function () {
    function SmallFormatMenuPanelController(analyticsService) {
        _classCallCheck(this, SmallFormatMenuPanelController);

        this.analyticsService = analyticsService;
    }

    _createClass(SmallFormatMenuPanelController, [{
        key: 'pushDataToAnalyticsService',
        value: function pushDataToAnalyticsService() {
            this.analyticsService.push({
                data: {
                    trackingType: 'link'
                },
                type: this.analyticsService.mapperTypes.customEvent.menuClick
            });
        }
    }]);

    return SmallFormatMenuPanelController;
}();

var smallFormatMenuPanelComponentDefinition = {
    bindings: {
        navigationItem: '<',
        onClickBack: '&',
        onNavigationItemSelect: '&?'
    },
    controller: ['AnalyticsService', SmallFormatMenuPanelController],
    template: __webpack_require__(879).trim()
};

module.exports = {
    SmallFormatMenuPanelController: SmallFormatMenuPanelController,
    smallFormatMenuPanelComponentDefinition: smallFormatMenuPanelComponentDefinition
};

/***/ }),
/* 879 */
/***/ (function(module, exports) {

module.exports = "<div class=\"smallFormatMenuPanel navigation navigation--mobileMenu\">\r\n    <h1 id=\"{{ $ctrl.navigationItem.name }}-title\" class=\"navigation-header\">\r\n        <button class=\"navigation-headerBack\" ng-click=\"$ctrl.onClickBack(); $ctrl.pushDataToAnalyticsService()\" aria-label=\"Up one level\">\r\n            <i class=\"iconww-ArrowLeft navigation-headerIcon\"></i>\r\n        </button>\r\n\r\n        {{ $ctrl.navigationItem.name }}\r\n    </h1>\r\n\r\n    <nav aria-labelledby=\"{{ $ctrl.navigationItem.name }}-title\" ng-switch=\"!!$ctrl.navigationItem.loading\">\r\n        <a class=\"navigation-link\"\r\n            ui-sref=\"{{ ::item.sref }}\"\r\n            ui-sref-active=\"is-active\"\r\n            ui-sref-opts=\"{ inherit: false }\"\r\n            ng-switch-when=\"false\"\r\n            ng-repeat=\"item in $ctrl.navigationItem.items track by item.sref\"\r\n            ng-click=\"$ctrl.onNavigationItemSelect({ $event: $event, item: item }); $ctrl.pushDataToAnalyticsService()\">\r\n\r\n            {{ ::item.name }} <i class=\"iconww-ArrowRight\"></i>\r\n        </a>\r\n\r\n        <wow-loading-spinner ng-switch-when=\"true\"></wow-loading-spinner>\r\n    </nav>\r\n</div>\r\n"

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1).module('wowApp.common').directive('wowSocialButtons', ['AnalyticsService', __webpack_require__(881)]);

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var UrlInfo = __webpack_require__(32);

module.exports = function (analyticsService) {
    function SocialButtonsController() {
        // ---------- for demo, don't forget to delete
        // this.url = 'https://www.woolworths.com.au/Shop/Recipes/christmas/jamie-olivers-christmas-recipes?name=jamie-s-baked-peach-apricot-pav-with-pistachios-honey&recipeId=4080';
        // this.media = 'https://www.woolworths.com.au/Content/wowRecipeImages/Large/1512-Jamie-BakedPeachApricotPavWithHoneyPistachios.jpg';
        // this.description = "Jamie's Baked Peach & Apricot Pav With Pistachios & Honey";
        // ---------- for demo, don't forget to delete
        var urlInfo = new UrlInfo(this.url);
        var mediaInfo = new UrlInfo(this.media);
        this.encodedUrl = encodeURIComponent(urlInfo.href());
        this.encodedMedia = encodeURIComponent(mediaInfo.href());
        this.encodedDescription = encodeURIComponent(this.description);

        this.facebookShareClick = function () {
            analyticsService.pushEvent(analyticsService.events.SOCIAL_SHARE.FACEBOOK);
        };
        this.twitterShareClick = function () {
            analyticsService.pushEvent(analyticsService.events.SOCIAL_SHARE.TWITTER);
        };
        this.googlePlusShareClick = function () {
            analyticsService.pushEvent(analyticsService.events.SOCIAL_SHARE.GOOGLEPLUS);
        };
        this.pinterestShareClick = function () {
            analyticsService.pushEvent(analyticsService.events.SOCIAL_SHARE.PINTEREST);
        };
    }

    return {
        restrict: 'E',
        scope: {
            url: '=',
            media: '=',
            description: '='
        },
        bindToController: true,
        controllerAs: 'ctrl',
        controller: [SocialButtonsController],
        template: __webpack_require__(882).trim()
    };
};

/***/ }),
/* 882 */
/***/ (function(module, exports) {

module.exports = "<div class=\"socialButtons\">\r\n    <a class=\"socialButtons-button socialButtons-facebook\"\r\n       ng-href=\"https://www.facebook.com/sharer/sharer.php?u={{::ctrl.encodedUrl}}&title={{::ctrl.encodedDescription}}\"\r\n       oly-open-window\r\n       ng-click=\"::ctrl.facebookShareClick()\">\r\n        <span class=\"sr-only\">Share {{::ctrl.description}} on Facebook</span>\r\n    </a>\r\n    <a class=\"socialButtons-button socialButtons-twitter\"\r\n       ng-href=\"https://twitter.com/intent/tweet?url={{::ctrl.encodedUrl}}&text={{::ctrl.encodedDescription}}\"\r\n       oly-open-window\r\n       ng-click=\"::ctrl.twitterShareClick()\">\r\n        <span class=\"sr-only\">Tweet {{::ctrl.description}}</span>\r\n    </a>\r\n    <a class=\"socialButtons-button socialButtons-gplus\"\r\n       ng-href=\"https://plus.google.com/share?url={{::ctrl.encodedUrl}}\"\r\n       oly-open-window\r\n       ng-click=\"::ctrl.googlePlusShareClick()\"\r\n       window-width=\"600\"\r\n       window-height=\"600\">\r\n        <span class=\"sr-only\">Share {{::ctrl.description}} on Google+</span>\r\n    </a>\r\n    <a class=\"socialButtons-button socialButtons-pinterest\"\r\n       ng-href=\"http://pinterest.com/pin/create/bookmarklet/?url={{::ctrl.encodedUrl}}&media={{::ctrl.encodedMedia}}&is_video=false&description={{::ctrl.encodedDescription}}\"\r\n       oly-open-window\r\n       ng-click=\"::ctrl.pinterestShareClick()\"\r\n       window-width=\"800\"\r\n       window-height=\"620\">\r\n        <span class=\"sr-only\">Pin {{::ctrl.description}}</span>\r\n    </a>\r\n</div>"

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(884),
    ToggleButtonComponentDefinition = _require.ToggleButtonComponentDefinition;

__webpack_require__(1).module('wowApp.common').component('wowToggleButton', ToggleButtonComponentDefinition);

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    camelCase = _require.camelCase,
    isFunction = _require.isFunction;

var ToggleButtonController = function () {
    function ToggleButtonController($element) {
        _classCallCheck(this, ToggleButtonController);

        this.$element = $element;
    }

    _createClass(ToggleButtonController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.inputId = this.getId();

            if (isFunction(this.onChange)) {
                this.change = function () {
                    return _this.onChange({ value: _this.value });
                };
            }

            // If there's no model, use JS onchange instead of ng-change
            if (this.model === undefined && this.change) {
                this.$element.on('change', 'input', this.change);
            }
        }
    }, {
        key: 'getId',
        value: function getId() {
            return this.inputId || 'toggleButton-' + camelCase(this.name + ' ' + this.label).replace(/\W/g, '');
        }
    }]);

    return ToggleButtonController;
}();

ToggleButtonController.$inject = ['$element'];

var ToggleButtonComponentDefinition = {
    controller: ToggleButtonController,
    template: __webpack_require__(885).trim(),
    bindings: {
        buttonClass: '@?',
        inputId: '@?',
        isSelected: '<?', // Will be ignored if model is defined
        label: '@',
        model: '=?',
        name: '@',
        onChange: '&?', // Will be called from either JS onchange or ng-change depending on model presence
        value: '<',
        eventRecorder: '@?',
        eventCategory: '@?',
        eventLabel: '@?',
        eventName: '@?'
    }
};

module.exports = {
    ToggleButtonController: ToggleButtonController,
    ToggleButtonComponentDefinition: ToggleButtonComponentDefinition
};

/***/ }),
/* 885 */
/***/ (function(module, exports) {

module.exports = "<div class=\"toggleButton {{ ::$ctrl.buttonClass }}\">\r\n    <input type=\"radio\"\r\n        ng-if=\"::$ctrl.model !== undefined\"\r\n        name=\"{{ ::$ctrl.name }}\"\r\n        id=\"{{ ::$ctrl.inputId }}\"\r\n        class=\"toggleButton-radio\"\r\n        ng-value=\"::$ctrl.value\"\r\n        ng-model=\"$ctrl.model\"\r\n        ng-change=\"::$ctrl.change()\"\r\n        wow-event-recorder=\"{{::$ctrl.eventRecorder}}\"\r\n        data-er-category=\"{{::$ctrl.eventCategory}}\"\r\n        data-er-label=\"{{::$ctrl.eventLabel}}\"\r\n        data-er-name=\"{{::$ctrl.eventName}}\"\r\n        data-er-value=\"{{::$ctrl.label}}\"\r\n    />\r\n    <input type=\"radio\"\r\n        ng-if=\"::$ctrl.model === undefined\"\r\n        name=\"{{ ::$ctrl.name }}\"\r\n        id=\"{{ ::$ctrl.inputId }}\"\r\n        class=\"toggleButton-radio\"\r\n        ng-value=\"::$ctrl.value\"\r\n        ng-checked=\"$ctrl.isSelected\"\r\n        wow-event-recorder=\"{{::$ctrl.eventRecorder}}\"\r\n        data-er-category=\"{{::$ctrl.eventCategory}}\"\r\n        data-er-label=\"{{::$ctrl.eventLabel}}\"\r\n        data-er-name=\"{{::$ctrl.eventName}}\"\r\n        data-er-value=\"{{::$ctrl.label}}\"\r\n    />\r\n    <label for=\"{{ ::$ctrl.inputId }}\" class=\"toggleButton-label\">{{ ::$ctrl.label }}</label>\r\n</div>\r\n"

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(887),
    ToggleButtonGroupComponentDefinition = _require.ToggleButtonGroupComponentDefinition;

__webpack_require__(1).module('wowApp.common').component('wowToggleButtonGroup', ToggleButtonGroupComponentDefinition);

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    ToggleButtonGroupComponentDefinition: {
        template: __webpack_require__(888).trim(),
        transclude: true,
        bindings: {
            groupClass: '@?'
        }
    }
};

/***/ }),
/* 888 */
/***/ (function(module, exports) {

module.exports = "<ng-transclude class=\"toggleButtonGroup {{ ::$ctrl.groupClass }}\"/>\r\n"

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.common');

wowApp.service('UnsubscribeEdmService', ['Restangular', __webpack_require__(890)]);

wowApp.directive('wowUnsubscribeEdm', ['UnsubscribeEdmService', 'Settings', '$state', '$timeout', __webpack_require__(891)]);

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function UnsubscribeEdmService(restangular) {
    this._api = restangular.one('shopper');
}

UnsubscribeEdmService.prototype.unsubscribeEDM = function (shopperid, token, checksum, documentid) {
    return this._api.one('unsubscribeEdm').get({
        shopperId: shopperid, token: token, checksum: checksum, documentId: documentid
    });
};

UnsubscribeEdmService.prototype.unsubscribeEDMConfirmation = function (unsubscribeData) {
    return this._api.one('UnsubscribeEDMConfirmation').doPOST(unsubscribeData);
};

module.exports = UnsubscribeEdmService;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (unsubscribeEdmService, settings, $state, $timeout) {
    return {
        restrict: 'E',
        scope: {},
        link: function link(scope) {
            scope.messages = {};

            function _init() {
                if (!$state.params.token) {
                    if (!$state.params.shopperID) {
                        $state.go('root');
                    } else if (!$state.params.checksum) {
                        $state.go('error.404', null, { location: 'replace' });
                    }
                }

                scope.settings = settings;

                unsubscribeEdmService.unsubscribeEDM($state.params.shopperID, $state.params.token, $state.params.checksum, $state.params.documentID).then(function (response) {
                    if (response.ShouldRedirectToHomePage) {
                        $state.go('root');
                    }

                    scope.unsubscribeData = response;

                    // Preset the checkboxes after content on page has loaded
                    $timeout(function () {
                        if (!scope.unsubscribeData.IsAlreadyUnsubscribed) {
                            scope.choice = 'Yes';
                        }
                    });
                });
            }

            scope.continue = function () {
                scope.unsubscribeData.Confirm = scope.choice;
                unsubscribeEdmService.unsubscribeEDMConfirmation(scope.unsubscribeData).then(function (response) {
                    if (response.ShouldRedirectToHomePage) {
                        $state.go('root');
                    }

                    scope.unsubscribeData = response;
                });
            };

            scope.toggleChoice = function (choice) {
                scope.choice = choice;
            };

            scope.showUnsubscribeConfirmation = function () {
                return scope.unsubscribeData && !scope.unsubscribeData.Successful && !scope.unsubscribeData.IsAlreadyUnsubscribed;
            };

            _init();
        },

        template: __webpack_require__(892).trim()
    };
};

/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports = "<div class=\"unsubEdm-container\">\r\n    <div class=\"unsubEdm-success\" ng-if=\"unsubscribeData.Successful\">\r\n        <h1 class=\"unsubEdm-heading\">\r\n            <i class=\"icon-dave-confirmation\"></i>\r\n            <span>{{ settings.unsubEdm.unsubSuccessHeading }}</span>\r\n        </h1>\r\n\r\n        <div class=\"unsubEdm-content\">\r\n            <p class=\"unsubEdm-instruction\">{{ settings.unsubEdm.instructions}}</p>\r\n            <p class=\"unsubEdm-preferences\"  ng-bind-html=\"settings.unsubEdm.loginLinkText\"></p>\r\n            <p class=\"unsubEdm-notes\" ng-bind-html=\"settings.unsubEdm.unsubNotes\"></p>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"unsubEdm-alreadyUnsubed\" ng-if=\"unsubscribeData.IsAlreadyUnsubscribed\">\r\n        <h1 class=\"unsubEdm-heading\">\r\n            <i class=\"icon-dave-confirmation\"></i>\r\n            <span>{{ settings.unsubEdm.alreadyUnsubedHeading }}</span>\r\n        </h1>\r\n        <div class=\"unsubEdm-content\">\r\n            <p class=\"unsubEdm-preferences alreadyUnsubed-preference\"  ng-bind-html=\"settings.unsubEdm.alreadyUnsubedSubHeading\"></p>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"unsubEdm-confirm\" ng-if=\"showUnsubscribeConfirmation()\">\r\n        <span ng-bind-html=\"messages.unsubscribeSuccess\"></span>\r\n        <h1 class=\"unsubEdm-heading confirm-heading\">\r\n            Are you sure you want to unsubscribe your email address {{ unsubscribeData.Email }}?\r\n        </h1>\r\n        <div class=\"unsubEdm-content\">\r\n            <p class=\"unsubEdm-instruction\">{{ settings.unsubEdm.confirmationInstruction }}</p>\r\n            <p class=\"unsubEdm-notes\" ng-bind-html=\"settings.unsubEdm.unsubNotes\"></p>\r\n            <form name=\"unsubscribeForm\" class=\"unsubscribeForm\" ng-submit=\"continue()\">\r\n                <div class=\"unsubEdm-choice\">\r\n                    <input class=\"wowRadio wowRadio--top\" type=\"radio\" name=\"unsubscribe\" ng-model=\"choice\" ng-change=\"toggleChoice('Yes')\" id=\"unsubscribeYes\" value=\"Yes\" />\r\n                    <label for=\"unsubscribeYes\">\r\n                        <wow-setting setting-group=\"unsubEdm\" setting-name=\"unsubYesMessage\"></wow-setting>\r\n                    </label>\r\n                </div>\r\n                <div class=\"unsubEdm-choice\">\r\n                    <input class=\"wowRadio wowRadio--top\" type=\"radio\" name=\"unsubscribe\" ng-model=\"choice\" ng-change=\"toggleChoice('No')\" id=\"unsubscribeNo\" value=\"No\"/>\r\n                    <label for=\"unsubscribeNo\">\r\n                        <wow-setting setting-group=\"unsubEdm\" setting-name=\"unsubNoMessage\"></wow-setting>\r\n                    </label>\r\n                </div>\r\n                <button class=\"button button--primary\">Save email preference</button>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var UserPreferenceService = __webpack_require__(894);

__webpack_require__(1).module('wowApp.common').service('UserPreferenceService', UserPreferenceService);

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    isEmpty = _require.isEmpty;

var UserPreferenceService = function () {
    function UserPreferenceService($rootScope, restangular, bootstrap, $q) {
        _classCallCheck(this, UserPreferenceService);

        this.$rootScope = $rootScope;
        this.restangular = restangular;
        this.api = restangular.one('UserPreferences');
        this.bootstrap = bootstrap;
        this.$q = $q;
        this.shopperPreferencesKey = bootstrap.bootstrapped.ShopperPreferences;
    }

    _createClass(UserPreferenceService, [{
        key: 'getUserPreference',
        value: function getUserPreference() {
            var _this = this;

            var shopperPreferences = this.bootstrap.getBootstrappedDataIfPresent(this.shopperPreferencesKey);

            if (!!shopperPreferences && !isEmpty(shopperPreferences)) {
                return this.$q.when(shopperPreferences);
            }

            return this.api.doGET().then(function (response) {
                _this.bootstrap.setData(_this.shopperPreferencesKey, response);
                return response;
            });
        }
    }, {
        key: 'getLoadedUserPreference',
        value: function getLoadedUserPreference() {
            return this.bootstrap.getBootstrappedDataIfPresent(this.shopperPreferencesKey);
        }
    }, {
        key: 'setListViewLayout',
        value: function setListViewLayout(value) {
            this.doPost('SetUserPreferenceListViewLayout', 'ListViewLayout', value);
        }
    }, {
        key: 'setListViewGroupBy',
        value: function setListViewGroupBy(value) {
            this.doPost('SetUserPreferenceListViewGroupBy', 'ListViewGroupBy', value);
        }
    }, {
        key: 'setPastShopPurchaseBy',
        value: function setPastShopPurchaseBy(value) {
            this.doPost('SetUserPreferencePastShopPurchaseBy', 'PastShopPurchaseBy', value);
        }
    }, {
        key: 'setFulfilmentSelectorStepStartShopping',
        value: function setFulfilmentSelectorStepStartShopping(value) {
            this.doPost('EnableFulfilmentSelectorStepStartShopping', 'FulfilmentSelectorStepStartShoppingEnabled', value);
        }
    }, {
        key: 'setDismissedRegionalNotificationPreference',
        value: function setDismissedRegionalNotificationPreference(value) {
            this.doPost('HasDismissedRegionalNotificationPreference', 'HasDismissedRegionalNotification', value);
        }
    }, {
        key: 'setOnboardingPreference',
        value: function setOnboardingPreference(value) {
            this.doPost('HasDoneOnboardingPreference', 'HasDoneOnboarding', value);
        }
    }, {
        key: 'setRewardsOnboardingPreference',
        value: function setRewardsOnboardingPreference(value) {
            this.doPost('HasDoneRewardsOnboardingPreference', 'HasDoneRewardsOnboarding', value);
        }
    }, {
        key: 'setLastViewFulfilmentMethodSelector',
        value: function setLastViewFulfilmentMethodSelector(value) {
            this.doPost('SetUserPreferenceLastViewFMS', 'HasSeenFulfilmentSelectorToday', value);
        }
    }, {
        key: 'setListViewVisited',
        value: function setListViewVisited(value) {
            this.doPost('SetUserPreferenceListViewVisited', 'ListViewVisited', value);
        }
    }, {
        key: 'setListViewGroupByVisited',
        value: function setListViewGroupByVisited(value) {
            this.doPost('SetUserPreferenceListViewGroupByVisited', 'ListViewGroupByVisited', value);
        }
    }, {
        key: 'setPastShopPurchaseByVisited',
        value: function setPastShopPurchaseByVisited(value) {
            this.doPost('SetUserPreferencePastShopPurchaseByVisited', 'PastShopPurchaseByVisited', value);
        }
    }, {
        key: 'SetDeliveryPlusCancelledNotificationDisabled',
        value: function SetDeliveryPlusCancelledNotificationDisabled(value) {
            this.doPost('SetDeliveryPlusCancelledNotificationDisabled', 'DeliveryPlusCancelledNotificationDisabled', value);
        }
    }, {
        key: 'setIsSecurityTabVisited',
        value: function setIsSecurityTabVisited(value) {
            this.doPost('SetUserPreferenceIsSecurityTabVisited', 'IsSecurityTabVisited', value);
        }
    }, {
        key: 'doPost',
        value: function doPost(endpoint, subKey, value) {
            var _this2 = this;

            this.api.one(endpoint).doPOST({ Value: value }).then(function () {
                return _this2.bootstrap.setData(_this2.shopperPreferencesKey, value, subKey);
            });
        }
    }]);

    return UserPreferenceService;
}();

UserPreferenceService.$inject = ['$rootScope', 'Restangular', 'BootstrapService', '$q'];

module.exports = UserPreferenceService;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var StorageWrapper = __webpack_require__(896);

__webpack_require__(1).module('oly.common').factory('LocalStorageWrapper', function () {
    return new StorageWrapper(localStorage);
}).factory('SessionStorageWrapper', function () {
    return new StorageWrapper(sessionStorage);
});

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StorageWrapper = function () {
    function StorageWrapper() {
        var storage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : localStorage;

        _classCallCheck(this, StorageWrapper);

        this.storage = storage;
    }

    _createClass(StorageWrapper, [{
        key: 'get',
        value: function get(key) {
            return this.storage.getItem(key);
        }
    }, {
        key: 'getAndRemove',
        value: function getAndRemove(key) {
            var value = this.get(key);
            if (value) {
                this.remove(key);
            }
            return value;
        }
    }, {
        key: 'getJsonAndRemove',
        value: function getJsonAndRemove(key) {
            var jsonValue = this.getAndRemove(key);

            if (!jsonValue) {
                return null;
            }

            try {
                return JSON.parse(jsonValue);
            } catch (error) {
                return null;
            }
        }
    }, {
        key: 'set',
        value: function set(key, value) {
            this.storage.setItem(key, value);
        }
    }, {
        key: 'setJson',
        value: function setJson(key, value) {
            try {
                var jsonValue = JSON.stringify(value);
                this.set(key, jsonValue);
            } catch (error) {
                //
            }
        }
    }, {
        key: 'remove',
        value: function remove(key) {
            this.storage.removeItem(key);
        }
    }, {
        key: 'clear',
        value: function clear() {
            this.storage.clear();
        }
    }]);

    return StorageWrapper;
}();

module.exports = StorageWrapper;

if (!('olyLocalStorage' in window)) {
    window.olyLocalStorage = new StorageWrapper();
}

/***/ }),
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DigitalPayPaymentInstrumentsService = function () {
    function DigitalPayPaymentInstrumentsService($q, Restangular) {
        _classCallCheck(this, DigitalPayPaymentInstrumentsService);

        this.$q = $q;
        this.api = Restangular.one('Checkout/DigitalPay');
    }

    _createClass(DigitalPayPaymentInstrumentsService, [{
        key: 'initializeCreditCardIframe',
        value: function initializeCreditCardIframe() {
            return this.api.one('InitializeCreditCardIframe').post();
        }
    }, {
        key: 'listDigitalPayInstruments',
        value: function listDigitalPayInstruments() {
            var isForPaymentAgreement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            return this.api.one('Instruments').get({ IsForPaymentAgreement: isForPaymentAgreement });
        }
    }, {
        key: 'deleteDigitalPayInstrument',
        value: function deleteDigitalPayInstrument(data) {
            return this.api.post('Instruments/Delete', data);
        }
    }, {
        key: 'getUnsavedGiftCardBalances',
        value: function getUnsavedGiftCardBalances(unsavedGiftCards) {
            return this.api.post('UnsavedGiftCard/Balance', unsavedGiftCards);
        }
    }, {
        key: 'tokenizeGiftCard',
        value: function tokenizeGiftCard(cardNumber, pinCode, save) {
            return this.api.post('GiftCard/Tokenize', { cardNumber: cardNumber, pinCode: pinCode, save: save });
        }
    }]);

    return DigitalPayPaymentInstrumentsService;
}();

module.exports = DigitalPayPaymentInstrumentsService;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    find = _require.find,
    remove = _require.remove;

/**
 * We should only have one iframe loaded (receiving events) at a time.
 * Use setIframeControl and releaseIframeControl to handle cases where there are more than one.
 */

var IframeEventHandler = function () {
    function IframeEventHandler($window) {
        var _this = this;

        _classCallCheck(this, IframeEventHandler);

        this.listenerObjects = [];
        this.$window = $window;
        this.isListenerActive = false;
        this.onMessageEvent = function (event) {
            _this.messageEventCallback(event);
        };
        this.activeIframeId = undefined;
    }

    /**
     * Sets an iframe to be active and restrict all events to this unique Id
     * @param {String} uniqueId Unique Id to identify the iframe
     */


    _createClass(IframeEventHandler, [{
        key: 'setIframeControl',
        value: function setIframeControl(uniqueId) {
            this.activeIframeId = uniqueId;
        }

        /**
         * Releases the control of the iframe events from the active iframe
         */

    }, {
        key: 'releaseIframeControl',
        value: function releaseIframeControl() {
            this.activeIframeId = null;
        }

        /**
         * Initialise message event listener.
         */

    }, {
        key: 'init',
        value: function init() {
            if (!this.isListenerActive) {
                this.$window.addEventListener('message', this.onMessageEvent);
                this.isListenerActive = true;
            }
        }

        /**
         * Remove message event listener.
         */

    }, {
        key: 'dispose',
        value: function dispose() {
            this.$window.removeEventListener('message', this.onMessageEvent);
            this.isListenerActive = false;
            this.listenerObjects = [];
        }

        /**
         * Callback which processes message event callback.
         * @param {Object} event
         */

    }, {
        key: 'messageEventCallback',
        value: function messageEventCallback(event) {
            var _this2 = this;

            // TODO:
            // When receiving a message, the event's origin should be validated.
            // However for testing this can be omitted.
            // if (event.origin != 'https://woolworths-domain') {
            //     return
            // }

            var response = JSON.parse(JSON.stringify(event.data, null, 2));
            var eventId = response.eventId;
            this.listenerObjects.filter(function (callbackObject) {
                return callbackObject.eventId === eventId;
            }).filter(function (callbackObject) {
                return !_this2.activeIframeId || callbackObject.uniqueId === _this2.activeIframeId;
            }).map(function (callbackObject) {
                return callbackObject.callback;
            }).forEach(function (callback) {
                return callback(response);
            });
        }

        /**
         * Register listener.
         * @param {String} eventId
         * @param {Function} listenerCallback
         * @param {String} uniqueId
         */

    }, {
        key: 'on',
        value: function on(eventId, listenerCallback) {
            var uniqueId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            if (!this.isListenerActive) this.init();

            // Ensure listener does not already exist for the given event.
            var listenerExists = find(this.listenerObjects, function (listenerObject) {
                return listenerObject.eventId === eventId && listenerObject.callback === listenerCallback;
            });

            if (!listenerExists) {
                this.listenerObjects.push({
                    eventId: eventId,
                    callback: listenerCallback,
                    uniqueId: uniqueId
                });
            }
        }

        /**
         * Unregister listener.
         * @param {String} eventId
         * @param {Function} listenerCallback
         */

    }, {
        key: 'off',
        value: function off(eventId, listenerCallback) {
            remove(this.listenerObjects, function (listenerObject) {
                return listenerObject.eventId === eventId && listenerObject.callback === listenerCallback;
            });

            if (this.listenerObjects.length === 0) {
                this.dispose();
            }
        }

        /**
         * Emits a message to the iframe.
         * @param {Element} iframeElement
         * @param {Object} message - must have eventId e.g. { eventId: 'pay-frame-submit' }
         */

    }, {
        key: 'emit',
        value: function emit(iframeElement, message) {
            // Send the message to the iframe's content window. The second argument specifies what the origin of the iframe URL is expected to be.
            // Currently for testing it is set to *, indicating no preference. In production this should be set to the production domain of the iframe.
            // For more information, see this page: https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage
            if (!iframeElement) {
                return;
            }
            // Be a little tolerant, try find the iframe element
            if (iframeElement[0]) {
                iframeElement = iframeElement[0];
            }
            if (iframeElement.contentWindow) {
                iframeElement.contentWindow.postMessage(message, '*');
            }
        }
    }]);

    return IframeEventHandler;
}();

module.exports = IframeEventHandler;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.wallet');

var _require = __webpack_require__(931),
    digitalPayButtonDirectiveDefinition = _require.digitalPayButtonDirectiveDefinition;

var _require2 = __webpack_require__(932),
    digitalPayListItemComponentDefinition = _require2.digitalPayListItemComponentDefinition;

var _require3 = __webpack_require__(934),
    digitalPayToggleButtonComponentDefinition = _require3.digitalPayToggleButtonComponentDefinition;

var _require4 = __webpack_require__(936),
    digitalPayConfirmationDialogComponentDefinition = _require4.digitalPayConfirmationDialogComponentDefinition;

var digitalPayTickStampComponentDefinition = __webpack_require__(938);

var DateHelperService = __webpack_require__(939);
var DigitalPayFormValidator = __webpack_require__(940);

wowApp.directive('wowDigitalPayButton', digitalPayButtonDirectiveDefinition);

wowApp.component('wowDigitalPayListItem', digitalPayListItemComponentDefinition);
wowApp.component('wowDigitalPayToggleButton', digitalPayToggleButtonComponentDefinition);
wowApp.component('wowDigitalPayConfirmationDialog', digitalPayConfirmationDialogComponentDefinition);
wowApp.component('wowDigitalPayTickStamp', digitalPayTickStampComponentDefinition);

wowApp.service('DateHelperService', [DateHelperService]);
wowApp.service('DigitalPayFormValidator', ['Settings', DigitalPayFormValidator]);

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This directive provides a way to execute common actions on digital pay buttons
 * in addition to the function of actual button being interacted with.
 * E.g. The user has encountered an error and continues on by clicking on a (any) button to
 * continue payment through other means. At this point we need to clear the error.
 */
var DigitalPayButtonController = function () {
    function DigitalPayButtonController($element, digitalPayPaymentErrorDisplayService) {
        _classCallCheck(this, DigitalPayButtonController);

        this.$element = $element;
        this.digitalPayPaymentErrorDisplayService = digitalPayPaymentErrorDisplayService;
    }

    _createClass(DigitalPayButtonController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$element.on('click', function () {
                _this.digitalPayPaymentErrorDisplayService.clearGlobalError();
            });
        }
    }]);

    return DigitalPayButtonController;
}();

DigitalPayButtonController.$inject = ['$element', 'DigitalPayPaymentErrorDisplayService'];

var digitalPayButtonDirectiveDefinition = function digitalPayButtonDirectiveDefinition() {
    return {
        restrict: 'A',
        scope: {},
        controller: DigitalPayButtonController
    };
};

module.exports = {
    DigitalPayButtonController: DigitalPayButtonController,
    digitalPayButtonDirectiveDefinition: digitalPayButtonDirectiveDefinition
};

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DigitalPayListItemController = function () {
    function DigitalPayListItemController($element, moveFocus) {
        _classCallCheck(this, DigitalPayListItemController);

        this.$element = $element;
        this.moveFocus = moveFocus;
    }

    _createClass(DigitalPayListItemController, [{
        key: 'onClickProxy',
        value: function onClickProxy() {
            var _this = this;

            /*
                div.digitalPayListItem provides a clickable target for mouse users.
                It is not keyboard accessible because it is an interactive element with child
                interactive elements (inputs for credit card CVV and gift card balance)
                which causes issues with screen readers. Don't allow the div to have focus.
                On click, shift focus to the hidden keyboard accessible button.
            */
            this.onClick();
            this.moveFocus(function () {
                return _this.$element.find('.digitalPayListItem-button');
            });
        }
    }]);

    return DigitalPayListItemController;
}();

DigitalPayListItemController.$inject = ['$element', 'MoveFocus'];

var digitalPayListItemComponentDefinition = {
    controller: DigitalPayListItemController,
    template: __webpack_require__(933).trim(),
    transclude: true,
    bindings: {
        icon: '@',
        isSelected: '<?',
        isDisabled: '<?', // Overrides selected
        isCondensed: '<?',
        isClickEnabled: '<?',
        isError: '<?', // Overrides selected and disabled
        labelledBy: '<?', // The ID of the element describing the instrument
        onClick: '&?',
        tickStampClass: '@' // Class Modifier for the tick stamp
    }
};

module.exports = {
    digitalPayListItemComponentDefinition: digitalPayListItemComponentDefinition
};

/***/ }),
/* 933 */
/***/ (function(module, exports) {

module.exports = "<input\r\n    type=\"button\"\r\n    aria-pressed=\"{{ !!$ctrl.isSelected }}\"\r\n    ng-click=\"$ctrl.onClick()\"\r\n    ng-disabled=\"!$ctrl.isClickEnabled || $ctrl.isDisabled || !$ctrl.onClick\"\r\n    class=\"sr-only digitalPayListItem-button\"\r\n    aria-labelledby=\"{{ $ctrl.labelledBy }}\"\r\n    wow-digital-pay-button\r\n/>\r\n<!-- Note that any click event that is transcluded into this component MUST cancel event propogation -->\r\n<div\r\n    class=\"digitalPayListItem\"\r\n    ng-class=\"{\r\n        'digitalPayListItem--selectable': $ctrl.isClickEnabled && !$ctrl.isDisabled,\r\n        'digitalPayListItem--selected': $ctrl.isSelected && !$ctrl.isError && !$ctrl.isDisabled,\r\n        'digitalPayListItem--error': $ctrl.isError && !$ctrl.isDisabled,\r\n        'digitalPayListItem--disabled': $ctrl.isDisabled}\"\r\n    ng-click=\"$ctrl.isClickEnabled && !$ctrl.isDisabled && !!$ctrl.onClick && $ctrl.onClickProxy()\"\r\n    wow-digital-pay-button\r\n    role=\"none\"\r\n    tabindex=\"-1\"\r\n    >\r\n    <div class=\"digitalPayListItem-container\">\r\n        <wow-digital-pay-tick-stamp ng-if=\"$ctrl.isSelected && !$ctrl.isError\" class=\"digitalPayListItem-stamp\" ng-class=\"$ctrl.tickStampClass\"></wow-digital-pay-tick-stamp>\r\n        <div class=\"digitalPayListItem-iconContainer\"\r\n            ng-class=\"{\r\n                'digitalPayListItem-iconContainer--selected': $ctrl.isSelected,\r\n                'digitalPayListItem-iconContainer--condensed': $ctrl.isCondensed,\r\n                'digitalPayListItem-iconContainer--error': $ctrl.isError,\r\n                'digitalPayListItem-iconContainer--disabled': $ctrl.isDisabled}\">\r\n            <img class=\"digitalPayListItem-icon\" ng-class=\"{'digitalPayListItem-icon--disabled': $ctrl.isDisabled}\" ng-src=\"{{$ctrl.icon}}\" oly-error-src />\r\n        </div>\r\n\r\n        <ng-transclude class=\"digitalPayListItem-contentContainer\"></ng-transclude>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var key = { enter: 13, space: 32 };

var DigitalPayToggleButtonController = function () {
    function DigitalPayToggleButtonController() {
        _classCallCheck(this, DigitalPayToggleButtonController);
    }

    _createClass(DigitalPayToggleButtonController, [{
        key: 'onKeyDown',
        value: function onKeyDown($event) {
            if ($event.keyCode === key.enter || $event.keyCode === key.space) {
                this.onClick();
            }
        }
    }]);

    return DigitalPayToggleButtonController;
}();

var digitalPayToggleButtonComponentDefinition = {
    controller: DigitalPayToggleButtonController,
    template: __webpack_require__(935).trim(),
    bindings: {
        icon: '@',
        iconClass: '@', // Class to apply for the icon (to resize if needed)
        instrumentName: '@',
        subText: '@?', // Replaces instrument name, but is styled to fit more text
        amount: '<?',
        linkText: '@?',
        isIconSvg: '<?',
        isSelectButton: '<', // If false, this is a toggleable button
        isSelected: '<?',
        isDisabled: '<?',
        isToggled: '<?',
        isLoading: '<?',
        isErrored: '<?',
        isNotBottom: '<?', // Not the bottom element (affects rounded corners)
        onClick: '&',
        shouldShowPayingAmount: '<'
    }
};

module.exports = {
    DigitalPayToggleButtonController: DigitalPayToggleButtonController,
    digitalPayToggleButtonComponentDefinition: digitalPayToggleButtonComponentDefinition
};

/***/ }),
/* 935 */
/***/ (function(module, exports) {

module.exports = "<!-- Workaround - IE does not support negative margins (tick stamp) and buttons together, hence a div that acts like a button is used -->\r\n<div\r\n    wow-digital-pay-button\r\n    class=\"digitalPayToggleButton digitalPayToggleButton-button\"\r\n    ng-class=\"{'isSelected': $ctrl.isSelected, 'isErrored': $ctrl.isErrored, 'isToggleOff': !$ctrl.isSelectButton, 'isNotBottom': $ctrl.isNotBottom }\"\r\n    role=\"button\"\r\n    tabindex=\"0\"\r\n    aria-pressed=\"{{$ctrl.isSelected || $ctrl.isToggled}}\"\r\n    ng-click=\"!$ctrl.isDisabled && $ctrl.onClick()\"\r\n    ng-keydown=\"!$ctrl.isDisabled && $ctrl.onKeyDown($event)\">\r\n    <!-- Stamp -->\r\n    <wow-digital-pay-tick-stamp ng-if=\"$ctrl.isSelected\"></wow-digital-pay-tick-stamp>\r\n\r\n    <!-- Icon -->\r\n    <div\r\n        class=\"digitalPayIcon-container\"\r\n        ng-class=\"{'isToggleOff': !$ctrl.isSelectButton, 'isSelected': $ctrl.isSelected && !$ctrl.isErrored}\"\r\n        ng-switch=\"!!$ctrl.isIconSvg\">\r\n        <img ng-switch-when=\"true\" class=\"digitalPayIcon-icon\" ng-class=\"$ctrl.iconClass\" ng-src=\"{{::$ctrl.icon}}\" alt=\"\" oly-error-src />\r\n        <i ng-switch-when=\"false\" class=\"digitalPayToggleButton-icon\" ng-class=\"::$ctrl.icon\"></i>\r\n    </div>\r\n\r\n    <!-- Label (Instrument Name or SubText) -->\r\n    <div class=\"digitalPayToggleButton-label\" ng-class=\"{'isToggleOff': !$ctrl.isSelectButton, 'isSelected': $ctrl.isSelected && !$ctrl.isErrored}\">\r\n        <span ng-if=\"$ctrl.instrumentName && !$ctrl.subText\">\r\n            <span class=\"sr-only\">Pay using </span>\r\n            {{::$ctrl.instrumentName}}\r\n        </span>\r\n        <span ng-if=\"$ctrl.subText\" class=\"digitalPayToggleButton-label--subText\">\r\n            <span class=\"sr-only\">Pay using {{::$ctrl.instrumentName}}</span>\r\n            {{$ctrl.subText}}\r\n        </span>\r\n    </div>\r\n\r\n    <!-- Spacer -->\r\n    <span class=\"u-flexSpacer\"></span>\r\n\r\n    <!-- Right side -->\r\n    <div class=\"digitalPayToggleButton-actions\">\r\n        <!-- Loading Spinner -->\r\n        <wow-loading-spinner ng-if=\"$ctrl.isLoading\" custom-spinner-class=\"digitalPayToggleButton-spinner\"></wow-loading-spinner>\r\n\r\n        <!-- Link Text -->\r\n        <a ng-if=\"!$ctrl.isLoading && $ctrl.linkText && !$ctrl.amount\" class=\"digitalPay-link\" aria-hidden=\"true\">{{::$ctrl.linkText}}</a>\r\n\r\n        <!-- Amount -->\r\n        <wow-staged-amount-display ng-if=\"$ctrl.shouldShowPayingAmount && !$ctrl.isLoading && $ctrl.amount !== undefined && $ctrl.isSelected\" paying-amount=\"$ctrl.amount\"></wow-staged-amount-display>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DigitalPayConfirmationDialogController = function () {
    function DigitalPayConfirmationDialogController($timeout, dialogRegistry) {
        _classCallCheck(this, DigitalPayConfirmationDialogController);

        this.$timeout = $timeout;
        this.dialogRegistry = dialogRegistry;
    }

    _createClass(DigitalPayConfirmationDialogController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$timeout(function () {
                _this.dialog = _this.dialogRegistry.getDialog(_this.dialogName);
            });
        }
    }]);

    return DigitalPayConfirmationDialogController;
}();

DigitalPayConfirmationDialogController.$inject = ['$timeout', 'DialogRegistry'];

var digitalPayConfirmationDialogComponentDefinition = {
    controller: DigitalPayConfirmationDialogController,
    template: __webpack_require__(937).trim(),
    transclude: true,
    bindings: {
        dialog: '=',
        dialogName: '<',
        isWarningIcon: '<?',
        message: '<'
    }
};

module.exports = {
    DigitalPayConfirmationDialogController: DigitalPayConfirmationDialogController,
    digitalPayConfirmationDialogComponentDefinition: digitalPayConfirmationDialogComponentDefinition
};

/***/ }),
/* 937 */
/***/ (function(module, exports) {

module.exports = "<dialog name=\"{{$ctrl.dialogName}}\" class=\"olyDialog olyDialog--confirmation digitalPayConfirmationDialog\">\r\n    <div class=\"digitalPayConfirmationDialog-container\">\r\n        <i class=\"digitalPayConfirmationDialog-icon iconww-Info\" ng-class=\"{'digitalPayConfirmationDialog-iconWarning': $ctrl.isWarningIcon}\">\r\n        </i>\r\n        <div class=\"digitalPayConfirmationDialog-message\">{{$ctrl.message}}</div>\r\n\r\n        <footer class=\"digitalPayConfirmationDialog-buttons\">\r\n            <ng-transclude class=\"dpFooter\"></ng-transclude>\r\n        </footer>\r\n    </div>\r\n</dialog>\r\n"

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var tickStampComponentDefinition = {
    template: '<div class="digitalPayTickStamp-wrapper"><i class="iconww-Tick digitalPayTickStamp"></i></div>'
};

module.exports = tickStampComponentDefinition;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DateHelperService = function () {
    function DateHelperService() {
        _classCallCheck(this, DateHelperService);
    }

    _createClass(DateHelperService, [{
        key: "getDateFromEpochInSeconds",
        value: function getDateFromEpochInSeconds(date) {
            return new Date(date).getTime() / 1000;
        }
    }]);

    return DateHelperService;
}();

module.exports = DateHelperService;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    first = _require.first,
    size = _require.size,
    values = _require.values,
    pickBy = _require.pickBy,
    isUndefined = _require.isUndefined;

var DigitalPayFormValidator = function () {
    function DigitalPayFormValidator(settings) {
        _classCallCheck(this, DigitalPayFormValidator);

        this.settings = settings;
    }

    _createClass(DigitalPayFormValidator, [{
        key: 'getAddNewCreditCardValidationError',
        value: function getAddNewCreditCardValidationError(response) {
            var selectedField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            var errors = {};
            errors.card = this.addCreditCardNumberValidationError(response, selectedField);
            errors.month = this.addCreditCardMonthValidationError(response, selectedField);
            errors.year = this.addCreditCardYearValidationError(response, selectedField);
            errors.cvv = this.addCreditCardCvvValidationError(response, selectedField);

            return this.condenseCreditCardValidationErrors(errors);
        }
    }, {
        key: 'getUpdateSavedCreditCardError',
        value: function getUpdateSavedCreditCardError(response) {
            var selectedField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            var errors = {};
            errors.month = this.addCreditCardMonthValidationError(response, selectedField);
            errors.year = this.addCreditCardYearValidationError(response, selectedField);
            errors.cvv = this.addCreditCardCvvValidationError(response, selectedField);

            return this.condenseCreditCardValidationErrors(errors);
        }
    }, {
        key: 'getGiftCardValidationError',
        value: function getGiftCardValidationError(response) {
            var selectedField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            var errors = {};

            errors.card = this.addGiftCardNumberValidationError(response, selectedField);
            errors.pin = this.addGiftCardPinValidationError(response, selectedField);

            return this.condenseGiftCardValidationErrors(errors);
        }
    }, {
        key: 'addCreditCardNumberValidationError',
        value: function addCreditCardNumberValidationError(response, selectedField) {
            if (selectedField !== this.settings.digitalPayCreditCardFields.cardNumber) {
                if (!this.isFieldValid(response.cardValid)) {
                    return this.settings.digitalPayError.creditCardInvalidCardNumberMessage;
                }

                if (this.isFieldValid(response.cardValid) && !this.isFieldValid(response.cardAccepted)) {
                    return this.settings.digitalPayError.creditCardNotSupportedMessage;
                }
            }
            return undefined;
        }
    }, {
        key: 'addCreditCardMonthValidationError',
        value: function addCreditCardMonthValidationError(response, selectedField) {
            if (selectedField !== this.settings.digitalPayCreditCardFields.month && !this.isFieldValid(response.expiryMonthValid)) {
                return this.settings.digitalPayError.creditCardInvalidMonthMessage;
            }
            return undefined;
        }
    }, {
        key: 'addCreditCardYearValidationError',
        value: function addCreditCardYearValidationError(response, selectedField) {
            if (selectedField !== this.settings.digitalPayCreditCardFields.year && !this.isFieldValid(response.expiryYearValid)) {
                return this.settings.digitalPayError.creditCardInvalidYearMessage;
            }
            return undefined;
        }
    }, {
        key: 'addCreditCardCvvValidationError',
        value: function addCreditCardCvvValidationError(response, selectedField) {
            if (selectedField !== this.settings.digitalPayCreditCardFields.cvv && !this.isFieldValid(response.cvvValid)) {
                return this.settings.digitalPayError.creditCardInvalidCvvMessage;
            }
            return undefined;
        }
    }, {
        key: 'addGiftCardNumberValidationError',
        value: function addGiftCardNumberValidationError(response, selectedField) {
            if (selectedField !== this.settings.digitalPayGiftCardFields.cardNumber && !this.isFieldValid(response.cardValid)) {
                return this.settings.digitalPayError.giftCardInvalidCardNumberMessage;
            }
            return undefined;
        }
    }, {
        key: 'addGiftCardPinValidationError',
        value: function addGiftCardPinValidationError(response, selectedField) {
            if (selectedField !== this.settings.digitalPayGiftCardFields.pin && !this.isFieldValid(response.pinValid)) {
                return this.settings.digitalPayError.giftCardInvalidPinMessage;
            }
            return undefined;
        }
    }, {
        key: 'condenseCreditCardValidationErrors',
        value: function condenseCreditCardValidationErrors(errors) {
            errors = pickBy(errors, function (property) {
                return !isUndefined(property);
            });

            if (size(errors) === 2 && errors.month && errors.year) {
                return this.settings.digitalPayError.creditCardInvalidExpiryDetailsMessage;
            } else if (size(errors) > 1) {
                return this.settings.digitalPayError.creditCardMultipleValidationErrorsMessage;
            }

            return first(values(errors));
        }
    }, {
        key: 'condenseGiftCardValidationErrors',
        value: function condenseGiftCardValidationErrors(errors) {
            errors = pickBy(errors, function (property) {
                return !isUndefined(property);
            });

            if (size(errors) > 1) {
                return this.settings.digitalPayError.giftCardIncorrectDetailsMessage;
            }
            return first(values(errors));
        }

        /**
         * Determines if the field is valid or not
         * For the purposes of showing validation errors, an empty field (null) is valid. Empty field checking is done elsewhere.
         * @param {object} field
         */

    }, {
        key: 'isFieldValid',
        value: function isFieldValid(field) {
            return field === null || field;
        }
    }]);

    return DigitalPayFormValidator;
}();

module.exports = DigitalPayFormValidator;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.wallet');

var _require = __webpack_require__(42),
    creditCardAddBaseComponentDefinition = _require.creditCardAddBaseComponentDefinition;

var _require2 = __webpack_require__(942),
    creditCardItemComponentDefinition = _require2.creditCardItemComponentDefinition;

var _require3 = __webpack_require__(944),
    creditCardItemEditComponentDefinition = _require3.creditCardItemEditComponentDefinition;

wowApp.component('wowCreditCardAddBase', creditCardAddBaseComponentDefinition);
wowApp.component('wowCreditCardItem', creditCardItemComponentDefinition);
wowApp.component('wowCreditCardItemEdit', creditCardItemEditComponentDefinition);

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    find = _require.find,
    values = _require.values;

var CreditCardItemController = function () {
    function CreditCardItemController(settings) {
        _classCallCheck(this, CreditCardItemController);

        this.settings = settings;
    }

    _createClass(CreditCardItemController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.editUpdateText = this.editUpdateText || 'Save';
            this.scheme = find(values(this.settings.digitalPayCreditCardNetworks), function (scheme) {
                return scheme === _this.card.Scheme;
            }) || this.settings.digitalPay.creditCardGenericIcon;

            this.creditCardDetailsId = 'creditCardDetails' + this.card.PaymentInstrumentId;
        }
    }, {
        key: 'setCardInEditMode',
        value: function setCardInEditMode() {
            if (this.onEdit) {
                this.onEdit({ card: this.card });
            }
        }
    }, {
        key: 'clearCardInEditMode',
        value: function clearCardInEditMode() {
            if (this.onEdit) {
                this.onEdit({ card: undefined });
            }
        }
    }, {
        key: 'notifyUpdateCardError',
        value: function notifyUpdateCardError(errorMessage) {
            this.updateCardError = errorMessage;
        }
    }]);

    return CreditCardItemController;
}();

CreditCardItemController.$inject = ['Settings'];

var creditCardItemComponentDefinition = {
    controller: CreditCardItemController,
    template: __webpack_require__(943).trim(),
    transclude: {
        middle: '?wowCreditCardItemMiddle',
        end: '?wowCreditCardItemEnd'
    },
    bindings: {
        card: '<',
        isPayment: '<',
        cardInEditMode: '<',
        editUpdateText: '@?',
        showValidationErrors: '<?',
        isManageMode: '<?',
        isSelected: '<',
        isSelectEnabled: '<',
        isShowDisabled: '<',
        isInline: '<',
        onIframeExpire: '&?',
        onRemove: '&?',
        onSelect: '&?',
        onUpdate: '&?',
        onEdit: '&?'
    }
};

module.exports = {
    CreditCardItemController: CreditCardItemController,
    creditCardItemComponentDefinition: creditCardItemComponentDefinition
};

/***/ }),
/* 943 */
/***/ (function(module, exports) {

module.exports = "<div class=\"u-flexColumn digitalPayItem\">\r\n    <wow-digital-pay-list-item\r\n        icon=\"/images/checkout/digitalPay/icon-{{::$ctrl.scheme}}.svg\"\r\n        is-selected=\"!$ctrl.isManageMode && $ctrl.isSelected\"\r\n        is-error=\"$ctrl.card.Expired\"\r\n        is-disabled=\"!$ctrl.card.Allowed\"\r\n        on-click=\"$ctrl.onSelect()\"\r\n        is-click-enabled=\"$ctrl.isSelectEnabled && !$ctrl.isManageMode && !!$ctrl.onSelect\"\r\n        labelled-by=\"$ctrl.creditCardDetailsId\">\r\n            <div class=\"digitalPayItem-container\" ng-class=\"{'inline': $ctrl.isInline}\">\r\n                <span class=\"digitalPayItem-spacer--left\"></span>\r\n                <!-- Left: Suffix, Expiry Date -->\r\n                <div\r\n                    id=\"{{ $ctrl.creditCardDetailsId }}\"\r\n                    class=\"digitalPayItem-section giftCardItem-cardDetailsContainer\"\r\n                    ng-switch=\"$ctrl.card.Expired\"\r\n                    ng-class=\"{'digitalPayItem--disabled': ($ctrl.card.Expired || !$ctrl.card.Allowed) && $ctrl.isShowDisabled, 'digitalPayItem-section--inline': $ctrl.isInline}\">\r\n                    <span class=\"digitalPayItem-mainText\" ng-class=\"{'inline': $ctrl.isInline}\">\r\n                        <span class=\"sr-only\">{{ ::$ctrl.card.Scheme }} card ending in</span>\r\n                        <span aria-hidden=\"true\">X-</span>{{::$ctrl.card.CardSuffix}}\r\n                    </span>\r\n                    <div class=\"digitalPayItem-subText\" ng-class=\"{'inline': $ctrl.isInline}\">\r\n                        <span ng-switch-when=\"false\">\r\n                            <span class=\"sr-only\">Expires</span>\r\n                            <span aria-hidden=\"true\">Exp</span>\r\n                            {{$ctrl.card.ExpiryMonth}}/{{$ctrl.card.ExpiryYear}}\r\n                        </span>\r\n                        <span ng-switch-when=\"true\" class=\"digitalPayItem-subText--expired\" ng-class=\"{'inline': $ctrl.isInline}\">EXPIRED</span>\r\n                    </div>\r\n                <span class=\"digitalPayItem-spacer--middle\"></span>\r\n                </div>\r\n                <!-- Middle: Typically used for inline CVV -->\r\n                <div ng-transclude=\"middle\"></div>\r\n                <span class=\"digitalPayItem-spacer--right\"></span>\r\n                <!-- Right: Edit/Remove action buttons, Amount Paying -->\r\n                <div class=\"digitalPayItem-section\">\r\n                    <div ng-if=\"$ctrl.card.Allowed && ($ctrl.card.Expired || $ctrl.isManageMode)\" class=\"creditCardItem-actionsContainer\">\r\n                        <button\r\n                            wow-digital-pay-button\r\n                            ng-if=\"!$ctrl.isPayment || ($ctrl.card.Expired && $ctrl.card.PaymentInstrumentId !== $ctrl.cardInEditMode.PaymentInstrumentId)\"\r\n                            class=\"dpLinkButton digitalPayItem-sectionActionText creditCardItem-actionsSpacer\"\r\n                            ng-class=\"{'inline': $ctrl.isInline}\"\r\n                            ng-click=\"$ctrl.setCardInEditMode(); $event.stopPropagation()\"\r\n                            type=\"button\">\r\n                            Edit\r\n                            <span class=\"sr-only\">{{::$ctrl.card.Scheme}} card ending in {{::$ctrl.card.CardSuffix}}</span>\r\n                        </button>\r\n                        <button\r\n                            wow-digital-pay-button\r\n                            class=\"dpLinkButton digitalPayItem-sectionActionText\"\r\n                            ng-click=\"$ctrl.onRemove(); $event.stopPropagation()\"\r\n                            type=\"button\">\r\n                            Remove\r\n                            <span class=\"sr-only\">{{::$ctrl.card.Scheme}} card ending in {{::$ctrl.card.CardSuffix}}</span>\r\n                        </button>\r\n                    </div>\r\n                    <div ng-transclude=\"end\"></div>\r\n                </div>\r\n            </div>\r\n    </wow-digital-pay-list-item>\r\n\r\n    <wow-digital-pay-error-display ng-if=\"!$ctrl.isInline\" error-message=\"$ctrl.updateCardError\" custom-error-class=\"creditCardItem-error\"></wow-digital-pay-error-display>\r\n    <wow-credit-card-item-edit\r\n        ng-if=\"$ctrl.isManageMode && $ctrl.card.PaymentInstrumentId === $ctrl.cardInEditMode.PaymentInstrumentId\"\r\n        card=\"$ctrl.card\"\r\n        update-text=\"{{$ctrl.editUpdateText}}\"\r\n        show-validation-errors=\"$ctrl.showValidationErrors\"\r\n        on-expire=\"$ctrl.onIframeExpire()\"\r\n        on-close=\"$ctrl.clearCardInEditMode()\"\r\n        on-update=\"$ctrl.onUpdate({paymentInstrumentId: paymentInstrumentId, stepUpToken: stepUpToken})\"\r\n        is-wallet=\"$ctrl.isInline\"\r\n        is-inline=\"$ctrl.isInline\"\r\n        on-update-card-error=\"$ctrl.notifyUpdateCardError(errorMessage)\">\r\n    </wow-credit-card-item-edit>\r\n</div>\r\n"

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    some = _require.some;

var NOT_SELECTED_FIELD = -1;
var CREDIT_CARD_FIELD_STRUCTURE_MONTH = 0;
var CREDIT_CARD_FIELD_STRUCTURE_YEAR = 1;
var CREDIT_CARD_FIELD_STRUCTURE_CVV = 2;

var CreditCardItemEditController = function () {
    function CreditCardItemEditController($sce, $timeout, $element, settings, digitalPayPaymentErrorDisplayService, iframeEventHandler, digitalPayFormValidator) {
        _classCallCheck(this, CreditCardItemEditController);

        this.$sce = $sce;
        this.$timeout = $timeout;
        this.$element = $element;
        this.settings = settings;
        this.digitalPayPaymentErrorDisplayService = digitalPayPaymentErrorDisplayService;
        this.iframeEventHandler = iframeEventHandler;
        this.digitalPayFormValidator = digitalPayFormValidator;
    }

    _createClass(CreditCardItemEditController, [{
        key: '$onInit',
        value: function $onInit() {
            this.creditCardEmptyField = NOT_SELECTED_FIELD;
            this.creditCardFieldStructureMonth = CREDIT_CARD_FIELD_STRUCTURE_MONTH;
            this.creditCardFieldStructureYear = CREDIT_CARD_FIELD_STRUCTURE_YEAR;
            this.creditCardFieldStructureCvv = CREDIT_CARD_FIELD_STRUCTURE_CVV;

            this.uniqueId = 'stepUp-' + this.card.PaymentInstrumentId;
            this.iframeUrl = undefined;
            this.iframeLoadTimeoutPromise = undefined;
            this.timeoutPeriodInMillseconds = this.settings.digitalPay.iframeTimeoutInMilliseconds;
            this.isLoading = true;
            this.isIframeLoadedSuccess = false;
            this.isUpdating = false;
            this.isValid = false;
            this.updateText = this.updateText || 'Update';
            this.errorMessage = this.settings.digitalPayError.creditCardEditCaptureFormLoadFailure;
            this.fieldStructure = [undefined, undefined, undefined]; // Setup initial field structure for each of the iframe fields
            this.currentSelectedField = this.creditCardEmptyField;
            this.setupIframe();
            this.setupListenerCallbacks();
            this.registerEventListeners();
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.digitalPayPaymentErrorDisplayService.clearGlobalError();
            this.disposeEventListeners();
            this.clearValidationState();
        }
    }, {
        key: 'updateCard',
        value: function updateCard() {
            if (!this.isValid) {
                return;
            }

            this.isUpdating = true;
            this.iframeEventHandler.emit(this.$element.find('#' + this.uniqueId)[0], { eventId: 'pay-frame-submit' });
        }
    }, {
        key: 'setupListenerCallbacks',
        value: function setupListenerCallbacks() {
            var _this = this;

            this.payFrameLoadedCallback = function () {
                _this.$timeout(function () {
                    // Cancel the timer and let the view know the iframe was successfully loaded
                    _this.$timeout.cancel(_this.iframeLoadTimeoutPromise);
                    if (_this.isLoading) {
                        _this.isLoading = false;
                        _this.isIframeLoadedSuccess = true;
                        // Reset error message to generic (in case it was set by the expired iframe)
                        _this.errorMessage = _this.settings.digitalPayError.creditCardEditCaptureFormLoadFailure;
                    }
                });
            };

            this.payFrameErrorCallback = function (response) {
                _this.$timeout(function () {
                    // Error does not return cardId (it may do in the future) so will stop all pending updates
                    _this.isUpdating = false;

                    if (response.code === _this.settings.digitalPayErrorCodes.creditCardCaptureFormExpired) {
                        _this.errorMessage = _this.settings.digitalPayError.creditCardEditCaptureFormLoadFailure;
                        _this.isIframeLoadedSuccess = false;
                    }
                    _this.digitalPayPaymentErrorDisplayService.pushGlobalError(_this.settings.digitalPayError.creditCardUpdateFailMessage);
                });
            };

            this.payFrameSuccessCallback = function (response) {
                _this.disposeEventListeners();
                if (_this.isWallet) {
                    _this.closeEditMode();
                }
                _this.onUpdate({ paymentInstrumentId: response.paymentInstrumentId, stepUpToken: response.stepUpToken });
                _this.$timeout(function () {
                    _this.digitalPayPaymentErrorDisplayService.clearGlobalError();
                });
            };

            this.payFrameValidCallback = function () {
                _this.$timeout(function () {
                    _this.isValid = true;
                });
                _this.clearValidationState();
                _this.fieldStructure = [true, true, true];
            };

            this.payFrameInvalidCallback = function () {
                _this.$timeout(function () {
                    _this.isValid = false;
                });
            };

            this.payFrameFocusGainCallback = function (response) {
                _this.currentSelectedField = _this.setCurrentSelectedField(response);
                if (!_this.focusLostObject) {
                    return;
                }

                var errorMessage = _this.digitalPayFormValidator.getUpdateSavedCreditCardError(_this.focusLostObject, response.field);
                _this.focusLostInvalidFieldsTimeoutPromise = _this.callUpdateCardError(errorMessage);

                // Stop the missing fields message from displaying if focus on form is gained
                _this.$timeout.cancel(_this.focusLostBlankFieldsTimeoutPromise);
                _this.focusLostBlankFieldsTimeoutPromise = undefined;
            };

            this.payFrameFocusLostCallback = function (response) {
                _this.currentSelectedField = _this.creditCardEmptyField;
                if (response.allFieldsEmpty) {
                    _this.clearValidationState();
                    return;
                }

                _this.focusLostObject = response;

                // Used for validation when this.showValidationErrors is enabled
                _this.fieldStructure = [_this.focusLostObject.expiryMonthValid, _this.focusLostObject.expiryYearValid, _this.focusLostObject.cvvValid];

                var errorMessage = _this.digitalPayFormValidator.getUpdateSavedCreditCardError(_this.focusLostObject);
                _this.focusLostInvalidFieldsTimeoutPromise = _this.callUpdateCardError(errorMessage);

                // If the user moves away from the form, we display a missing fields message instead.
                // This is cancelled if the user focuses on the form immediately after moving away (e.g. tab from one field to another)
                if (_this.hasBlankFields(_this.focusLostObject)) {
                    _this.focusLostBlankFieldsTimeoutPromise = _this.callUpdateCardError(_this.settings.digitalPayError.creditCardMultipleValidationErrorsMessage);
                }
            };
        }
    }, {
        key: 'registerEventListeners',
        value: function registerEventListeners() {
            this.iframeEventHandler.on('pay-frame-loaded', this.payFrameLoadedCallback);
            this.iframeEventHandler.on('pay-frame-error', this.payFrameErrorCallback);
            this.iframeEventHandler.on('pay-frame-success', this.payFrameSuccessCallback);
            this.iframeEventHandler.on('pay-frame-valid', this.payFrameValidCallback);
            this.iframeEventHandler.on('pay-frame-invalid', this.payFrameInvalidCallback);
            this.iframeEventHandler.on('pay-frame-focus-gain', this.payFrameFocusGainCallback);
            this.iframeEventHandler.on('pay-frame-focus-lost', this.payFrameFocusLostCallback);
        }
    }, {
        key: 'disposeEventListeners',
        value: function disposeEventListeners() {
            this.iframeEventHandler.off('pay-frame-loaded', this.payFrameLoadedCallback);
            this.iframeEventHandler.off('pay-frame-error', this.payFrameErrorCallback);
            this.iframeEventHandler.off('pay-frame-success', this.payFrameSuccessCallback);
            this.iframeEventHandler.off('pay-frame-valid', this.payFrameValidCallback);
            this.iframeEventHandler.off('pay-frame-invalid', this.payFrameInvalidCallback);
            this.iframeEventHandler.off('pay-frame-focus-gain', this.payFrameFocusGainCallback);
            this.iframeEventHandler.off('pay-frame-focus-lost', this.payFrameFocusLostCallback);
        }
    }, {
        key: 'setupIframe',
        value: function setupIframe() {
            var _this2 = this;

            this.isLoading = true;
            this.isIframeLoadedSuccess = false;
            this.iframeUrl = this.$sce.trustAsResourceUrl(!this.card.Expired ? this.card.UpdateURL : this.card.StepUp.Url);
            this.showIframe = true;

            // Setup a timer to wait for the iframe to load
            this.iframeLoadTimeoutPromise = this.$timeout(function () {
                _this2.isLoading = false;
            }, this.timeoutPeriodInMillseconds);
        }
    }, {
        key: 'refreshIframe',
        value: function refreshIframe() {
            this.isLoading = true;
            this.onExpire();
            // Rely on $onChanges to get back the new stepup url
        }
    }, {
        key: 'closeEditMode',
        value: function closeEditMode() {
            this.clearValidationState();
            this.onClose();
        }
    }, {
        key: 'hasBlankFields',
        value: function hasBlankFields(response) {
            return response.cardValid === null || response.expiryMonthValid === null || response.expiryYearValid === null || response.cvvValid === null;
        }
    }, {
        key: 'callUpdateCardError',
        value: function callUpdateCardError(errorMessage) {
            var _this3 = this;

            return this.$timeout(function () {
                _this3.onUpdateCardError({ errorMessage: errorMessage });
            }, this.settings.digitalPay.formFocusOutTimeoutMilliseconds);
        }
    }, {
        key: 'clearValidationState',
        value: function clearValidationState() {
            this.focusLostObject = undefined;
            this.fieldStructure = [undefined, undefined, undefined];
            this.callUpdateCardError('');
            this.resetErrorDisplayTimeouts();
        }
    }, {
        key: 'resetErrorDisplayTimeouts',
        value: function resetErrorDisplayTimeouts() {
            this.$timeout.cancel(this.focusLostBlankFieldsTimeoutPromise);
            this.$timeout.cancel(this.focusLostInvalidFieldsTimeoutPromise);
            this.focusLostBlankFieldsTimeoutPromise = undefined;
            this.focusLostInvalidFieldsTimeoutPromise = undefined;
        }
    }, {
        key: 'shouldShowValidation',
        value: function shouldShowValidation(fieldToCheck) {
            // Iframe response - True: Valid, False: Invalid, Null: Empty, Undefined: Hasn't been touched
            // Before submit, ignore empty fields
            return fieldToCheck === false;
        }
    }, {
        key: 'shouldShowValidationSection',
        value: function shouldShowValidationSection() {
            var _this4 = this;

            return some(this.fieldStructure, function (fieldValue, fieldIndex) {
                return fieldValue === false && _this4.currentSelectedField !== fieldIndex;
            });
        }
    }, {
        key: 'setCurrentSelectedField',
        value: function setCurrentSelectedField(response) {
            switch (response.field) {
                case 'month':
                    return this.creditCardFieldStructureMonth;
                case 'year':
                    return this.creditCardFieldStructureYear;
                case 'cvv':
                    return this.creditCardFieldStructureCvv;
                default:
                    return this.creditCardEmptyField;
            }
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.card && !changes.card.isFirstChange()) {
                this.setupIframe();
            }
        }
    }]);

    return CreditCardItemEditController;
}();

CreditCardItemEditController.$inject = ['$sce', '$timeout', '$element', 'Settings', 'DigitalPayPaymentErrorDisplayService', 'DigitalPayIframeEventHandler', 'DigitalPayFormValidator'];

var creditCardItemEditComponentDefinition = {
    controller: CreditCardItemEditController,
    template: __webpack_require__(945).trim(),
    bindings: {
        card: '<',
        updateText: '@?',
        showValidationErrors: '<?',
        onExpire: '&?',
        onClose: '&',
        onUpdate: '&?',
        isInline: '<?',
        isWallet: '<?',
        onUpdateCardError: '&'
    }
};

module.exports = {
    CreditCardItemEditController: CreditCardItemEditController,
    creditCardItemEditComponentDefinition: creditCardItemEditComponentDefinition
};

/***/ }),
/* 945 */
/***/ (function(module, exports) {

module.exports = "<ng-form name=\"$ctrl.creditCardEditForm\">\r\n    <wow-payment-methods-credit-card-validation\r\n        ng-if=\"$ctrl.shouldShowValidationSection() && $ctrl.showValidationErrors\"\r\n        fields=\"$ctrl.fieldStructure\"\r\n        custom-error-class=\"creditCardItemEdit-validation\">\r\n        <ul>\r\n            <li ng-if=\"$ctrl.shouldShowValidation($ctrl.fieldStructure[$ctrl.creditCardFieldStructureMonth]) && $ctrl.currentSelectedField !== $ctrl.creditCardFieldStructureMonth\">\r\n                {{$ctrl.settings.digitalPayError.creditCardInvalidMonthMessage}}\r\n            </li>\r\n            <li ng-if=\"$ctrl.shouldShowValidation($ctrl.fieldStructure[$ctrl.creditCardFieldStructureYear]) && $ctrl.currentSelectedField !== $ctrl.creditCardFieldStructureYear\">\r\n                {{$ctrl.settings.digitalPayError.creditCardInvalidYearMessage}}\r\n            </li>\r\n            <li ng-if=\"$ctrl.shouldShowValidation($ctrl.fieldStructure[$ctrl.creditCardFieldStructureCvv]) && $ctrl.currentSelectedField !== $ctrl.creditCardFieldStructureCvv\">\r\n                {{$ctrl.settings.digitalPayError.creditCardInvalidCvvMessage}}\r\n            </li>\r\n        </ul>\r\n    </wow-payment-methods-credit-card-validation>\r\n\r\n    <div class=\"creditCardItemEdit\">\r\n        <wow-loading-spinner ng-if=\"$ctrl.isLoading\" class=\"creditCardItemEdit-spinnerContainer\" custom-spinner-class=\"creditCardItemEdit-spinner\"></wow-loading-spinner>\r\n\r\n        <div class=\"creditCardItemEdit-container\" ng-class=\"{'inline': $ctrl.isInline}\">\r\n            <!-- ng-hide as we want to at least attempt to load the iframe to get the loaded event -->\r\n            <iframe\r\n                id=\"{{$ctrl.uniqueId}}\"\r\n                ng-if=\"$ctrl.showIframe\"\r\n                ng-hide=\"$ctrl.isLoading || !$ctrl.isIframeLoadedSuccess\"\r\n                class=\"creditCardItemEdit-iframe\"\r\n                ng-class=\"{'inline': $ctrl.isInline}\"\r\n                scrolling=\"no\"\r\n                ng-src=\"{{$ctrl.iframeUrl}}\">\r\n            </iframe>\r\n\r\n            <div class=\"creditCardItemEdit-buttonContainer\" ng-class=\"{'inline': $ctrl.isInline}\" ng-if=\"!$ctrl.isLoading && $ctrl.isIframeLoadedSuccess\">\r\n                <oly-button>\r\n                    <button\r\n                        wow-digital-pay-button\r\n                        class=\"button\"\r\n                        ng-click=\"$ctrl.closeEditMode()\"\r\n                        type=\"button\">\r\n                        <span class=\"u-flexCenterCross\"><i class=\"iconww-ArrowLeft dpFooter-iconLeftButton\"></i> Cancel</span>\r\n                    </button>\r\n                </oly-button>\r\n                <span class=\"creditCardItemEdit-buttonSpacer\"></span>\r\n                <oly-button loading=\"{state: $ctrl.isUpdating, message: 'Updating card, please wait'}\" button-class=\"u-fullWidth\">\r\n                    <button\r\n                        wow-digital-pay-button\r\n                        role=\"submit\"\r\n                        class=\"button button--primary u-fullWidth\"\r\n                        ng-click=\"$ctrl.updateCard()\"\r\n                        ng-disabled=\"!$ctrl.isValid\">\r\n                        <span ng-if=\"!$ctrl.completedUpdate\" class=\"creditCardItemEdit-buttonText\">{{$ctrl.updateText}} <i class=\"iconww-ArrowRight creditCardItemEdit-buttonArrowRight\"></i></span>\r\n                    </button>\r\n                </oly-button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div ng-if=\"!$ctrl.isLoading && !$ctrl.isIframeLoadedSuccess\" class=\"creditCardItemEdit-errorContainer\">\r\n        <wow-error-page\r\n            icon=\"iconww-Info\"\r\n            show-icon=\"true\"\r\n            message=\"{{$ctrl.errorMessage}}\"\r\n            page-class=\"creditCardItemEdit-errorPage\"\r\n            message-class=\"creditCardItemEdit-errorMessage\">\r\n        </wow-error-page>\r\n        <button class=\"dpLinkButton creditCardItemEdit-refreshButton\" ng-click=\"$ctrl.refreshIframe()\">Refresh</button>\r\n    </div>\r\n</ng-form>\r\n"

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.wallet');

var _require = __webpack_require__(947),
    digitalPayErrorDisplayComponentDefinition = _require.digitalPayErrorDisplayComponentDefinition;

var _require2 = __webpack_require__(949),
    digitalPayWarningDisplayComponentDefinition = _require2.digitalPayWarningDisplayComponentDefinition;

var digitalPayErrorStampDefinition = __webpack_require__(951);

var DigitalPayPaymentErrorDisplayService = __webpack_require__(952);
var DigitalPayErrorMessageGenerator = __webpack_require__(953);
var DigitalPayPaymentErrorStateService = __webpack_require__(547);

wowApp.component('wowDigitalPayErrorDisplay', digitalPayErrorDisplayComponentDefinition);
wowApp.component('wowDigitalPayWarningDisplay', digitalPayWarningDisplayComponentDefinition);
wowApp.component('wowDigitalPayErrorStamp', digitalPayErrorStampDefinition);

/* TODO: Need Tech Debt story to remove reliance on DigitalPayPaymentErrorStateService and DigitalPayPaymentErrorDisplayService */
wowApp.service('DigitalPayPaymentErrorStateService', [DigitalPayPaymentErrorStateService]);
wowApp.service('DigitalPayPaymentErrorDisplayService', ['$timeout', 'MoveFocus', 'Settings', 'DigitalPayPaymentErrorStateService', 'DigitalPayErrorMessageGenerator', DigitalPayPaymentErrorDisplayService]);
wowApp.service('DigitalPayErrorMessageGenerator', ['Settings', DigitalPayErrorMessageGenerator]);

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var digitalPayErrorDisplayComponentDefinition = {
    template: __webpack_require__(948).trim(),
    bindings: {
        errorMessage: '<',
        errorList: '<',
        isOnTop: '<',
        customErrorClass: '@?',
        hideErrorList: '<?',
        title: '<?'
    }
};

module.exports = {
    digitalPayErrorDisplayComponentDefinition: digitalPayErrorDisplayComponentDefinition
};

/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"$ctrl.errorMessage || ($ctrl.errorList && $ctrl.errorList.length)\" tabindex=\"-1\">\r\n    <div\r\n        class=\"alert alert--error u-noMargin digitalPayErrorDisplay\"\r\n        ng-class=\"{'digitalPayErrorDisplay--isTop': $ctrl.isOnTop, '{{$ctrl.customErrorClass}}': $ctrl.customErrorClass, 'digitalPayErrorDisplay--isNotTop': !$ctrl.isOnTop}\">\r\n        <wow-digital-pay-error-stamp></wow-digital-pay-error-stamp>\r\n        <div class=\"alert-content\">\r\n            <strong class=\"digitalPayErrorDisplay-title\" ng-if=\"$ctrl.title\">{{$ctrl.title}}</strong>\r\n            <div ng-if=\"$ctrl.errorMessage\" role=\"alert\">\r\n                <span class=\"digitalPayErrorDisplay-errorMessage\" ng-bind-html=\"$ctrl.errorMessage\"></span>\r\n                <span status=\"alert\" class=\"sr-only\" aria-live=\"polite\" aria-atomic=\"true\" ng-bind=\"$ctrl.errorMessage\"></span>\r\n            </div>\r\n            <div ng-if=\"$ctrl.errorList.length && !$ctrl.hideErrorList\" role=\"alert\">\r\n                <ul role=\"list\" class=\"u-noMargin\">\r\n                    <li role=\"listitem\" ng-repeat=\"error in $ctrl.errorList track by $index\">\r\n                        <span class=\"digitalPayErrorDisplay-errorMessage\" ng-bind-html=\"error\"></span>\r\n                    </li>\r\n                </ul>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var digitalPayWarningDisplayComponentDefinition = {
    template: __webpack_require__(950).trim(),
    bindings: {
        warningMessage: '<',
        isThinStyle: '<'
    }
};

module.exports = {
    digitalPayWarningDisplayComponentDefinition: digitalPayWarningDisplayComponentDefinition
};

/***/ }),
/* 950 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"$ctrl.warningMessage\" class=\"onesite-base\" tabindex=\"-1\">\r\n    <div class=\"alert alert--info u-noMargin digitalPayWarningDisplay\" ng-class=\"{'digitalPayWarningDisplay--thin': $ctrl.isThinStyle}\">\r\n        <span class=\"digitalPayWarningDisplay-icon\"/>\r\n        <span class=\"digitalPayWarningDisplay-message\">{{$ctrl.warningMessage}}</span>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var errorStampComponentDefinition = {
    template: '<div class="dpStampIcon dpStampIcon--error"></div>'
};

module.exports = errorStampComponentDefinition;

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DigitalPayPaymentErrorDisplayService = function () {
    function DigitalPayPaymentErrorDisplayService($timeout, moveFocus, settings, digitalPayPaymentErrorStateService, digitalPayErrorMessageGenerator) {
        _classCallCheck(this, DigitalPayPaymentErrorDisplayService);

        this.$timeout = $timeout;
        this.moveFocus = moveFocus;
        this.settings = settings;
        this.digitalPayPaymentErrorStateService = digitalPayPaymentErrorStateService;
        this.digitalPayErrorMessageGenerator = digitalPayErrorMessageGenerator;
        this.clearGlobalError();
    }

    _createClass(DigitalPayPaymentErrorDisplayService, [{
        key: 'pushGlobalError',
        value: function pushGlobalError() {
            var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

            var isSplitPayment = this.digitalPayErrorMessageGenerator.getPaymentErrorMode();
            if (!errorMessage) {
                errorMessage = isSplitPayment ? this.settings.digitalPayError.genericGlobalSplitPaymentMessage : this.settings.digitalPayError.genericGlobalPaymentMessage;
            }
            this.setGlobalBannerError(errorMessage);
        }

        /**
         * Push an error in response to a validation failure produced by wallet
         * @param {string} errorMessage
         */

    }, {
        key: 'pushToPaymentErrorBreakdown',
        value: function pushToPaymentErrorBreakdown(errorMessage) {
            this.paymentErrors.push(errorMessage);
        }
    }, {
        key: 'getGlobalErrorMessage',
        value: function getGlobalErrorMessage() {
            var showRawErrorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var isSplitPayment = this.digitalPayErrorMessageGenerator.getPaymentErrorMode();
            if (!showRawErrorMessage && this.paymentErrors && this.paymentErrors.length) {
                if (this.paymentErrors.length === 1 && !isSplitPayment) {
                    // When there is exactly one error in the list and we're not doing split payments, show that error by itself without a header error message
                    return '';
                }
                return this.settings.digitalPayError.multipleGlobalPaymentErrorMessage;
            }

            return this.globalErrorMessage;
        }
    }, {
        key: 'getPaymentErrors',
        value: function getPaymentErrors() {
            return this.paymentErrors;
        }
    }, {
        key: 'clearGlobalError',
        value: function clearGlobalError() {
            this.globalErrorMessage = undefined;
            this.paymentErrors = [];
            this.digitalPayPaymentErrorStateService.clearErrors();
        }
    }, {
        key: 'setGlobalBannerError',
        value: function setGlobalBannerError(errorMessage) {
            this.globalErrorMessage = errorMessage;
            this.moveFocus('.digitalPayErrorDisplay-errorMessage');
        }
    }]);

    return DigitalPayPaymentErrorDisplayService;
}();

module.exports = DigitalPayPaymentErrorDisplayService;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    reduce = _require.reduce,
    replace = _require.replace;

var DigitalPayErrorMessageGenerator = function () {
    function DigitalPayErrorMessageGenerator(settings) {
        _classCallCheck(this, DigitalPayErrorMessageGenerator);

        this.settings = settings;
    }

    _createClass(DigitalPayErrorMessageGenerator, [{
        key: 'getCreditCardDialogSubmitIframeError',
        value: function getCreditCardDialogSubmitIframeError(errorCode) {
            if (errorCode === this.settings.digitalPayErrorCodes.creditCardCaptureFormExpired) {
                return this.settings.digitalPayError.creditCardDialogCvvExpiredMessage;
            }

            return this.isSplitPayment ? this.settings.digitalPayError.genericGlobalSplitPaymentMessage : this.settings.digitalPayError.genericGlobalPaymentMessage;
        }
    }, {
        key: 'getGiftCardTokenizeError',
        value: function getGiftCardTokenizeError(errorCode) {
            var giftCardSuffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            switch (errorCode) {
                case this.settings.digitalPayErrorCodes.giftCardNotAcceptedByBanner:
                    return this.settings.digitalPayError.giftCardPaymentNotAcceptedByBannerErrorMessage;
                case this.settings.digitalPayErrorCodes.giftCardUnableToRetrieveDetails:
                    return this.settings.digitalPayError.giftCardIncorrectDetailsMessage;
                case this.settings.digitalPayErrorCodes.paymentInstrumentExpired:
                    return this.settings.digitalPayError.giftCardAddExpiredMessage;
                case this.settings.digitalPayErrorCodes.giftCardZeroBalance:
                    return this.settings.digitalPayError.giftCardAddInsufficientFundsMessage;
                default:
                    return this.isSplitPayment ? this.formatErrorMessage(this.settings.digitalPayError.giftCardGenericSplitPaymentErrorMessageTemplate, [giftCardSuffix]) : this.formatErrorMessage(this.settings.digitalPayError.giftCardGenericPaymentErrorMessageTemplate, [giftCardSuffix]);
            }
        }
    }, {
        key: 'getGiftCardPaymentError',
        value: function getGiftCardPaymentError(errorCode, giftCardSuffix) {
            var paymentResponseErrorMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

            switch (errorCode) {
                case this.settings.digitalPayErrorCodes.unknownPayment:
                    return this.isSplitPayment ? this.formatErrorMessage(this.settings.digitalPayError.giftCardGenericSplitPaymentErrorMessageTemplate, [giftCardSuffix]) : this.formatErrorMessage(this.settings.digitalPayError.giftCardGenericPaymentErrorMessageTemplate, [giftCardSuffix]);
                default:
                    return this.isSplitPayment ? this.formatErrorMessage(this.settings.digitalPayError.giftCardSpecificSplitPaymentErrorMessageTemplate, [giftCardSuffix, paymentResponseErrorMessage.toLowerCase()]) : this.formatErrorMessage(this.settings.digitalPayError.giftCardSpecificPaymentErrorMessageTemplate, [giftCardSuffix, paymentResponseErrorMessage.toLowerCase()]);
            }
        }
    }, {
        key: 'getPaypalLinkError',
        value: function getPaypalLinkError(errorCode) {
            switch (errorCode) {
                case this.settings.digitalPayErrorCodes.paypalAccountLockedOrClosed:
                    return this.settings.digitalPayError.paypalPaymentUnregisteredExternallyErrorMessage;
                default:
                    return this.settings.digitalPayError.paypalLinkFailureErrorMessage;
            }
        }
    }, {
        key: 'getPaypalUnlinkError',
        value: function getPaypalUnlinkError(errorCode) {
            switch (errorCode) {
                case this.settings.digitalPayErrorCodes.paypalAccountLockedOrClosed:
                    return this.settings.digitalPayError.paypalPaymentUnregisteredExternallyErrorMessage;
                default:
                    return this.settings.digitalPayError.paypalUnlinkFailureErrorMessage;
            }
        }
    }, {
        key: 'getPaypalPaymentError',
        value: function getPaypalPaymentError(errorCode) {
            switch (errorCode) {
                case this.settings.digitalPayErrorCodes.paypalAccountLockedOrClosed:
                    return this.settings.digitalPayError.paypalPaymentUnregisteredExternallyErrorMessage;
                case this.settings.digitalPayErrorCodes.insufficientFunds:
                    return this.settings.digitalPayError.paypalInsufficientFundsMessage;
                case this.settings.digitalPayErrorCodes.paymentInstrumentNotFound:
                    return this.isSplitPayment ? this.settings.digitalPayError.paymentInstrumentNotFoundSplitPaymentMessage : this.settings.digitalPayError.paymentInstrumentNotFoundMessage;
                default:
                    return this.isSplitPayment ? this.settings.digitalPayError.paypalSplitPaymentGenericErrorMessage : this.settings.digitalPayError.paypalPaymentGenericErrorMessage;
            }
        }
    }, {
        key: 'getNewCreditCardPaymentError',
        value: function getNewCreditCardPaymentError(isSavingCard) {
            if (this.isSplitPayment) {
                return isSavingCard ? this.settings.digitalPayError.creditCardSplitPaymentSaveNewCreditCardFailure : this.settings.digitalPayError.creditCardSplitPaymentNewCreditCardFailure;
            }

            return isSavingCard ? this.settings.digitalPayError.creditCardPaymentSaveNewCreditCardFailure : this.settings.digitalPayError.creditCardPaymentNewCreditCardFailure;
        }
    }, {
        key: 'getGenericPaymentError',
        value: function getGenericPaymentError(errorCode) {
            switch (errorCode) {
                case this.settings.digitalPayErrorCodes.paymentInstrumentNotFound:
                    return this.isSplitPayment ? this.settings.digitalPayError.paymentInstrumentNotFoundSplitPaymentMessage : this.settings.digitalPayError.paymentInstrumentNotFoundMessage;
                default:
                    return this.isSplitPayment ? this.settings.digitalPayError.genericGlobalSplitPaymentMessage : this.settings.digitalPayError.genericGlobalPaymentMessage;
            }
        }

        /**
         * Formats string template by replacing {\*} placeholders. Where * is the index number of the content to be replaced.
         * @param {string} template
         * @param {string[]} content
         */

    }, {
        key: 'formatErrorMessage',
        value: function formatErrorMessage(template) {
            for (var _len = arguments.length, content = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                content[_key - 1] = arguments[_key];
            }

            return reduce.apply(undefined, content.concat([function (result, value, index) {
                return replace(result, '{' + index + '}', value);
            }, template]));
        }
    }, {
        key: 'getPaymentErrorMode',
        value: function getPaymentErrorMode() {
            return this.isSplitPayment;
        }
    }, {
        key: 'setPaymentErrorMode',
        value: function setPaymentErrorMode(isSplitPayment) {
            this.isSplitPayment = isSplitPayment;
        }
    }]);

    return DigitalPayErrorMessageGenerator;
}();

module.exports = DigitalPayErrorMessageGenerator;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DigitalPayPaymentErrorStateException = function DigitalPayPaymentErrorStateException(message) {
    _classCallCheck(this, DigitalPayPaymentErrorStateException);

    this.message = message;
    this.name = 'DigitalPayPaymentErrorStateException';
};

module.exports = DigitalPayPaymentErrorStateException;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.wallet');

var giftCardAmountValidationDirective = __webpack_require__(956);
var giftCardBalanceValidationDirective = __webpack_require__(957);
var giftCardNumberValidationDirective = __webpack_require__(958);
var restrictPartialAlphaDirective = __webpack_require__(959);

var _require = __webpack_require__(43),
    giftCardAddBaseComponentDefinition = _require.giftCardAddBaseComponentDefinition;

var _require2 = __webpack_require__(960),
    giftCardItemComponentDefinition = _require2.giftCardItemComponentDefinition;

wowApp.directive('wowGiftCardAmountValidation', giftCardAmountValidationDirective);
wowApp.directive('wowGiftCardBalanceValidation', giftCardBalanceValidationDirective);
wowApp.directive('wowGiftCardNumberValidation', giftCardNumberValidationDirective);
wowApp.directive('restrictPartialAlpha', restrictPartialAlphaDirective);
wowApp.component('wowGiftCardAddBase', giftCardAddBaseComponentDefinition);
wowApp.component('wowGiftCardItem', giftCardItemComponentDefinition);

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 * Validates a Gift Card Amount.
 */

module.exports = function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, element, attrs, $ctrl) {
            $ctrl.$validators.giftCardAmount = function (modelValue, viewValue) {
                var maxAmount = scope.$eval(attrs.wowGiftCardAmountValidation);
                if ($ctrl.$isEmpty(modelValue) || !maxAmount && maxAmount !== 0) {
                    return true;
                }

                return viewValue <= maxAmount;
            };
        }
    };
};

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 * Validates a Gift Card Balance.
 */

module.exports = function () {
    return {
        restrict: 'A',
        scope: {
            wowGiftCardBalanceValidation: '@'
        },
        require: 'ngModel',
        link: function link(scope, element, attrs, $ctrl) {
            $ctrl.$validators.giftCardBalanceEmpty = function (modelValue) {
                var balanceApiAvailable = scope.$eval(attrs.wowGiftCardBalanceValidation);

                if ($ctrl.$isEmpty(modelValue) && !balanceApiAvailable) {
                    return true;
                }

                // Must be greater than 0
                return modelValue > 0;
            };
        }
    };
};

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 * Validates a Gift Card Number.
 */
var _require = __webpack_require__(0),
    some = _require.some,
    startsWith = _require.startsWith;

module.exports = function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, element, attrs, $ctrl) {
            var giftCardNumberValidation = JSON.parse(attrs.wowGiftCardNumberValidation);
            var allowedBins = giftCardNumberValidation.allowedBins;
            var cardDigitLength = giftCardNumberValidation.cardDigitLength;

            function isValidPartialPin(partialPin, binToTest) {
                var length = Math.min(partialPin.length, binToTest.length);
                for (var i = 0; i < length; i++) {
                    if (partialPin[i] !== binToTest[i]) {
                        return false;
                    }
                }
                return true;
            }

            $ctrl.$validators.giftCardNumberPartial = function (modelValue, viewValue) {
                if ($ctrl.$isEmpty(modelValue) || !allowedBins || !allowedBins.length) {
                    return true;
                }

                // For a gift card number to be valid it must start with a certain prefix
                // Validate only until the latest number entered
                return some(allowedBins, function (bin) {
                    return isValidPartialPin(viewValue, bin);
                });
            };

            $ctrl.$validators.giftCardNumber = function (modelValue, viewValue) {
                if ($ctrl.$isEmpty(modelValue) || !allowedBins || !allowedBins.length) {
                    return true;
                }

                // For a gift card number to be valid it must start with a certain prefix and also 19 digits long
                return some(allowedBins, function (bin) {
                    return startsWith(viewValue, bin) && viewValue.length === cardDigitLength;
                });
            };
        }
    };
};

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getKeyCode(evt) {
    var key = evt.key;
    var keyCode = evt.keyCode;
    if (key && !keyCode) {
        keyCode = key.charCodeAt(0);
    }
    return keyCode;
}

function isBackspace(keyCode) {
    return keyCode && keyCode === 8;
}

function isEnterKey(keyCode) {
    return keyCode && keyCode === 13;
}

function matchesPattern(regex, value) {
    return regex.test(value);
}

module.exports = function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            function isNumeric(keyCode) {
                return keyCode && keyCode >= 48 && keyCode <= 57 || keyCode === 46;
            }
            element.bind('keypress', function (event) {
                var keyCode = getKeyCode(event);
                if (!isBackspace(keyCode) && !isNumeric(keyCode) && !isEnterKey(keyCode)) {
                    event.preventDefault();
                }

                var previousValue = element.val().split('.')[1];
                var numberOfDecimalPlaces = scope.$eval(attrs.restrictPartialAlpha);
                if (previousValue && previousValue.length === numberOfDecimalPlaces) {
                    event.preventDefault();
                }
            });
            element.bind('keyup', function () {
                if (!matchesPattern(/^\d*[.]?\d{0,2}$/, element.val())) {
                    element.val('');
                }
            });
        }
    };
};

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    replace = _require.replace;

var GiftCardItemController = function () {
    function GiftCardItemController($filter, $timeout, settings, moveFocus) {
        _classCallCheck(this, GiftCardItemController);

        this.$filter = $filter;
        this.$timeout = $timeout;
        this.settings = settings;
        this.moveFocus = moveFocus;

        if (!this.onChangeGiftCardAmount) {
            this.onChangeGiftCardAmount = function () {};
        }
    }

    _createClass(GiftCardItemController, [{
        key: '$onInit',
        value: function $onInit() {
            var instrumentId = this.card.PaymentInstrumentId || this.card.NewStagedCardId;
            this.giftCardDetailsId = 'giftCardDetails' + instrumentId;
            this.giftCardAmountId = 'giftCardAmount' + instrumentId;
            this.giftCardSuffix = this.card.CardSuffix || this.getCardSuffixFromCardNumber(this.card.CardNumber);
        }
    }, {
        key: 'getCardSuffixFromCardNumber',
        value: function getCardSuffixFromCardNumber(cardNumber) {
            return cardNumber && cardNumber.length === this.settings.digitalPay.giftCardNumberLength ? cardNumber.slice(-4) : '';
        }
    }, {
        key: 'getExpiryYear',
        value: function getExpiryYear(expiryYear) {
            // Truncate 4 digit years to 2
            return expiryYear && expiryYear.length === 4 ? expiryYear.slice(-2) : expiryYear;
        }
    }, {
        key: 'getGiftCardAmount',
        value: function getGiftCardAmount(amount) {
            return amount ? parseFloat(amount) : 0.0;
        }
    }, {
        key: 'isProblemCard',
        value: function isProblemCard() {
            return !this.card.IsCondensed && (!this.card.Balance || this.card.Expired);
        }
    }, {
        key: 'isCardUnavailable',
        value: function isCardUnavailable() {
            return this.card.ErrorCode === this.settings.digitalPayErrorCodes.giftCardKnownBalanceCheckFailed || this.card.ErrorCode === this.settings.digitalPayErrorCodes.giftCardUnknownBalanceCheckFailed || this.card.ErrorCode === this.settings.digitalPayErrorCodes.giftCardBalanceApiUnavailable;
        }
    }, {
        key: 'toggleSelectCard',
        value: function toggleSelectCard() {
            var _this = this;

            this.errorMessage = '';
            if (this.onSelect && !this.manageMode) {
                this.onSelect(this.card);

                // Move the focus to the amount field
                this.$timeout(function () {
                    if (_this.card.Selected) {
                        _this.moveFocus('#' + _this.giftCardAmountId);
                    }
                });
            }
        }
    }, {
        key: 'onChangeAmount',
        value: function onChangeAmount() {
            var amount = this.getGiftCardAmount(this.card.Amount);

            this.errorMessage = amount > parseFloat(this.card.Balance) && !this.isCardUnavailable() ? replace(this.settings.digitalPayError.giftCardAmountAvailableExceedMessage, '{AMOUNTAVAILABLE}', this.$filter('currency')(this.card.Balance)) : '';

            this.onChangeGiftCardAmount({ amount: amount, card: this.card });
        }
    }]);

    return GiftCardItemController;
}();

GiftCardItemController.$inject = ['$filter', '$timeout', 'Settings', 'MoveFocus'];

var giftCardItemComponentDefinition = {
    controller: GiftCardItemController,
    template: __webpack_require__(961).trim(),
    transclude: true,
    bindings: {
        card: '<',
        allowedBins: '<',
        manageMode: '<',
        onSelect: '&?',
        onRemove: '&?',
        onChangeGiftCardAmount: '&',
        isInline: '<',
        showDisabled: '<'
    }
};

module.exports = {
    GiftCardItemController: GiftCardItemController,
    giftCardItemComponentDefinition: giftCardItemComponentDefinition
};

/***/ }),
/* 961 */
/***/ (function(module, exports) {

module.exports = "<ng-form name=\"$ctrl.giftCardItemForm\">\r\n    <wow-digital-pay-warning-display\r\n        ng-if=\"!$ctrl.manageMode && $ctrl.card.IsCondensed && !$ctrl.card.BalanceApiAvailable\"\r\n        warning-message=\"$ctrl.unableToRetrieveBalanceWarningMessage\">\r\n    </wow-digital-pay-warning-display>\r\n\r\n    <wow-digital-pay-error-display\r\n        ng-if=\"!$ctrl.manageMode && $ctrl.errorMessage\"\r\n        error-message=\"$ctrl.errorMessage\"\r\n        class=\"giftCardItem-error\">\r\n    </wow-digital-pay-error-display>\r\n\r\n    <wow-digital-pay-list-item\r\n        ng-if=\"$ctrl.card.PaymentInstrumentId || $ctrl.card.IsCondensed\"\r\n        icon=\"/images/checkout/digitalPay/icon-pay-giftcard.svg\"\r\n        is-selected=\"!$ctrl.manageMode && ($ctrl.card.Selected || $ctrl.card.IsCondensed)\"\r\n        is-condensed=\"$ctrl.card.IsCondensed\"\r\n        is-error=\"$ctrl.card.Expired\"\r\n        on-click=\"$ctrl.toggleSelectCard()\"\r\n        is-click-enabled=\"!$ctrl.isManageMode && !!$ctrl.onSelect\"\r\n        tick-stamp-class=\"{{$ctrl.card.IsCondensed ? 'giftCardItem-stampCondensed' : ''}}\"\r\n        labelled-by=\"$ctrl.giftCardDetailsId\"\r\n    >\r\n        <div class=\"digitalPayItem-container\" ng-class=\"{'inline': $ctrl.isInline}\">\r\n            <span class=\"digitalPayItem-spacer--left\"></span>\r\n\r\n            <div id=\"{{ $ctrl.giftCardDetailsId }}\" class=\"giftCardItem-cardDetailsAndBalance\">\r\n                <div class=\"giftCardItem-cardDetailsContainer\"\r\n                    ng-class=\"{'digitalPayItem--disabled': $ctrl.showDisabled && $ctrl.isProblemCard() && !$ctrl.isCardUnavailable(), 'digitalPayItem-section--inline': $ctrl.isInline}\">\r\n                    <!-- Saved || New Condensed Card -->\r\n                    <span\r\n                        class=\"digitalPayItem-mainText\"\r\n                        ng-class=\"{'inline': $ctrl.isInline}\">\r\n                        <span class=\"sr-only\">Gift card ending in</span>\r\n                        <span aria-hidden=\"true\">X-</span>{{ $ctrl.giftCardSuffix }}\r\n                    </span>\r\n                </div>\r\n                <span class=\"digitalPayItem-spacer--middle\"></span>\r\n                <div class=\"giftCardItem-balanceContainer\">\r\n                    <div class=\"digitalPayItem-section giftCardItem-balanceWrapper\"\r\n                        ng-if=\"($ctrl.card.PaymentInstrumentId || $ctrl.card.Balance) && !$ctrl.isCardUnavailable()\"\r\n                        ng-class=\"{'digitalPayItem--disabled': $ctrl.showDisabled && $ctrl.isProblemCard(), 'digitalPayItem-section--inline': $ctrl.isInline}\">\r\n                            <span\r\n                                class=\"digitalPayItem-mainText giftCardItem-balanceText\"\r\n                                ng-class=\"{'inline': $ctrl.isInline, 'zeroBalance': !$ctrl.card.Balance && $ctrl.isInline}\">\r\n                                <span class=\"sr-only\">with balance of</span>\r\n                                {{($ctrl.card.Balance || 0) | currency}}\r\n                            </span>\r\n                            <div\r\n                                class=\"digitalPayItem-subText giftCardItem-availableText\"\r\n                                ng-class=\"{'inline': $ctrl.isInline, 'zeroBalance': !$ctrl.card.Balance && $ctrl.isInline}\">\r\n                                available\r\n                            </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <span class=\"digitalPayItem-spacer--right\"></span>\r\n\r\n            <div\r\n                class=\"digitalPayInput digitalPayItem-sectionAction giftCardItem-amountContainer digitalPayInput-wowInputContainerOverride--noLeft\"\r\n                ng-if=\"!$ctrl.manageMode && ($ctrl.card.Selected || $ctrl.card.IsCondensed)\">\r\n                <wow-input-container class=\"digitalPayInput-wowInputContainerOverride\">\r\n                    <label for=\"{{$ctrl.giftCardAmountId}}\">Amount\r\n                        <span class=\"sr-only\">to pay using gift card ending in {{ $ctrl.giftCardSuffix }}</span>\r\n                    </label>\r\n                    <input\r\n                        id=\"{{$ctrl.giftCardAmountId}}\"\r\n                        name=\"giftCardAmount\"\r\n                        type=\"number\"\r\n                        min=\"0\"\r\n                        step=\"0.01\"\r\n                        ng-model=\"$ctrl.card.Amount\"\r\n                        ng-change=\"$ctrl.onChangeAmount()\"\r\n                        ng-model-options=\"{allowInvalid: true}\"\r\n                        wow-gift-card-amount-validation=\"{{$ctrl.card.Balance}}\"\r\n                        ng-click=\"$event.stopPropagation()\"\r\n                        ng-keydown=\"$event.stopPropagation()\"\r\n                        restrict-partial-alpha=\"2\"\r\n                        required />\r\n                </wow-input-container>\r\n            </div>\r\n            <div ng-if=\"($ctrl.isProblemCard() && !$ctrl.isCardUnavailable()) || $ctrl.manageMode\" class=\"digitalPayItem-section\">\r\n                <button\r\n                    wow-digital-pay-button\r\n                    class=\"dpLinkButton digitalPayItem-sectionActionText\"\r\n                    ng-click=\"$ctrl.onRemove(); $event.stopPropagation()\"\r\n                    type=\"button\">\r\n                    Remove\r\n                    <span class=\"sr-only\">\r\n                        gift card ending in\r\n                        {{ $ctrl.giftCardSuffix }}\r\n                        with balance of\r\n                        {{ ($ctrl.card.Balance || 0) | currency }}\r\n                    </span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </wow-digital-pay-list-item>\r\n\r\n    <!-- Condensed View Action Bar-->\r\n    <div class=\"giftCardItem-condensedActionBar\" ng-if=\"$ctrl.card.IsCondensed\">\r\n        <div>\r\n            <input\r\n                id=\"save-gift-card-checkbox-{{$ctrl.card.NewStagedCardId}}\"\r\n                name=\"saveGiftCardCheckbox\"\r\n                type=\"checkbox\"\r\n                ng-disabled=\"($ctrl.card.Balance && $ctrl.card.Balance === $ctrl.card.Amount) || $ctrl.card.Balance === 0\"\r\n                class=\"wowCheckbox giftCardAdd-save\"\r\n                ng-model=\"$ctrl.card.IsSavingCard\" />\r\n            <label for=\"save-gift-card-checkbox-{{$ctrl.card.NewStagedCardId}}\">Save card for later</label>\r\n        </div>\r\n\r\n        <button wow-digital-pay-button class=\"dpLinkButton\" ng-click=\"$ctrl.onRemove()\" type=\"button\">\r\n            Remove\r\n        </button>\r\n    </div>\r\n\r\n    <!-- New Card -->\r\n    <ng-transclude></ng-transclude>\r\n</ng-form>\r\n"

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.wallet');

var _require = __webpack_require__(29),
    paypalBaseComponentDefinition = _require.paypalBaseComponentDefinition;

wowApp.component('wowPaypalBase', paypalBaseComponentDefinition);

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DigitalPayPaymentErrorState = __webpack_require__(548);

var _require = __webpack_require__(0),
    filter = _require.filter,
    find = _require.find,
    first = _require.first,
    replace = _require.replace,
    map = _require.map,
    size = _require.size,
    sumBy = _require.sumBy;

var PLACING_ORDER_STATE_ID = 'PlacingOrder';
/**
 * DigitalPay Main Payment Component.
 * Note 1: Avoid adding payment type specific concerns in this component.
 *         i.e. This component does not need to know about specific payment instrument types (e.g. giftCard or Paypal)
 *         All payment type specific logic should be part of the instruments component.
 */

var PaymentDigitalPayController = function () {
    function PaymentDigitalPayController($element, $q, $state, settings, announcerService, digitalPayPaymentErrorDisplayService, paymentService, loadingIndicatorService, checkoutStepService, checkoutService, digitalPayIframeEventHandler, digitalPayPaymentDistributionService, digitalPayPrepaymentActionsService, digitalPayDisablePaymentStateService, digitalPayPaymentErrorStateService, digitalPayErrorMessageGenerator) {
        _classCallCheck(this, PaymentDigitalPayController);

        this.$element = $element;
        this.$q = $q;
        this.$state = $state;
        this.settings = settings;
        this.announcerService = announcerService;
        this.digitalPayPaymentErrorDisplayService = digitalPayPaymentErrorDisplayService;
        this.paymentService = paymentService;
        this.loadingIndicatorService = loadingIndicatorService;
        this.checkoutStepService = checkoutStepService;
        this.checkoutService = checkoutService;
        this.iframeEventHandler = digitalPayIframeEventHandler;
        this.paymentDistributionService = digitalPayPaymentDistributionService;
        this.prePaymentActionsService = digitalPayPrepaymentActionsService;
        this.disablePaymentStateService = digitalPayDisablePaymentStateService;
        this.digitalPayPaymentErrorStateService = digitalPayPaymentErrorStateService;
        this.digitalPayErrorMessageGenerator = digitalPayErrorMessageGenerator;
    }

    _createClass(PaymentDigitalPayController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.isCheckoutInitialised = false;
            this.isCvvDialogEnabled = false;
            this.isCreditCardSelected = false;
            this.iframeEventHandler.init();
            this.prePaymentActionsService.init();
            this.disablePaymentStateService.init();
            this.digitalPayPaymentErrorStateService.init();

            this.prePaymentActionDefinitions = {
                addAction: this.prePaymentActionsService.addAction.bind(this.prePaymentActionsService),
                removeAction: this.prePaymentActionsService.removeAction.bind(this.prePaymentActionsService)
            };

            this.paymentStateDefinitions = {
                addDisablePaymentState: this.disablePaymentStateService.addDisablePaymentState.bind(this.disablePaymentStateService),
                removeDisablePaymentState: this.disablePaymentStateService.removeDisablePaymentState.bind(this.disablePaymentStateService)
            };

            this.shouldShowPaypalPlaceOrderButton = false;

            this.initialiseBalanceToPay().then(function () {
                _this.isCheckoutInitialised = true;
            });
        }
    }, {
        key: 'initialiseBalanceToPay',
        value: function initialiseBalanceToPay() {
            var _this2 = this;

            var initBalanceStateKey = 'BalanceInitialisationStateKey';
            this.paymentStateDefinitions.addDisablePaymentState(initBalanceStateKey);
            return this.checkoutService.getCheckoutModel().then(function (data) {
                _this2.paymentDistributionService.init(data.Model.Order.BalanceToPay);
                _this2.paymentStateDefinitions.removeDisablePaymentState(initBalanceStateKey);
            });
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.digitalPayPaymentErrorDisplayService.clearGlobalError();
            this.iframeEventHandler.dispose();
            this.prePaymentActionsService.removeAllActions();
            this.digitalPayPaymentErrorStateService.clearErrors();
        }

        /**
         * Notifies when account password field should be enabled or disabled.
         * @param {boolean} value
         */

    }, {
        key: 'notifyOnAccountPasswordFieldLoaded',
        value: function notifyOnAccountPasswordFieldLoaded(value) {
            this.shouldShowOnAccountPasswordField = value;
        }

        /**
         * Notifies when child instrument components are in manage mode.
         * @param {*boolean} state
         */

    }, {
        key: 'notifyWhenChildIsInManageMode',
        value: function notifyWhenChildIsInManageMode(state) {
            // The field here is an additional field used for showing the account password textbox
            this.anyChildIsInManageMode = state;
        }
    }, {
        key: 'notifyWhenCreditCardSelectionChanged',
        value: function notifyWhenCreditCardSelectionChanged(value) {
            this.isCreditCardSelected = value;
        }
    }, {
        key: 'shouldShowCheckoutMessage',
        value: function shouldShowCheckoutMessage() {
            return this.isCreditCardSelected && this.settings.payments.enablePostPickPay && this.settings.payments.postPickPayOrderCheckoutMessage;
        }

        /**
         * Notifies when account password field should be reset
         */

    }, {
        key: 'notifyPasswordReset',
        value: function notifyPasswordReset() {
            this.resetPassword();
        }
    }, {
        key: 'shouldDisablePayment',
        value: function shouldDisablePayment() {
            return this.disablePaymentStateService.hasDisablePaymentStates() || this.hasNotFulfilledPaymentAmount() || this.hasExceededBasketAmount();
        }
    }, {
        key: 'getRemainingAmount',
        value: function getRemainingAmount() {
            return this.paymentDistributionService.getRemainingAmount();
        }
    }, {
        key: 'hasNotFulfilledPaymentAmount',
        value: function hasNotFulfilledPaymentAmount() {
            return this.getRemainingAmount() > 0 && !this.paymentDistributionService.hasSingleSelectType();
        }
    }, {
        key: 'hasExceededBasketAmount',
        value: function hasExceededBasketAmount() {
            return this.getRemainingAmount() < 0;
        }
    }, {
        key: 'hasOutstandingAmount',
        value: function hasOutstandingAmount() {
            return this.paymentDistributionService.hasPayments() && this.hasNotFulfilledPaymentAmount();
        }
    }, {
        key: 'setPasswordError',
        value: function setPasswordError(isError) {
            var target = this.$element.find('.onAccountPasswordInput')[0];
            if (!target) return;
            if (isError) {
                target.style.background = '#FFECEE';
                target.style.border = '1px solid #D0021B';
            } else {
                target.style.removeProperty('background');
                target.style.removeProperty('border');
            }
        }
    }, {
        key: 'clearPasswordError',
        value: function clearPasswordError() {
            this.setPasswordError(false);
            this.digitalPayPaymentErrorDisplayService.clearGlobalError();
        }
    }, {
        key: 'resetPassword',
        value: function resetPassword() {
            this.accountPassword = undefined;
        }

        /**
         * For clearing errors and resetting prepayment states
         */

    }, {
        key: 'resetPaymentStates',
        value: function resetPaymentStates() {
            this.digitalPayPaymentErrorDisplayService.clearGlobalError();
            this.setPasswordError(false);
            this.hasPrePaymentActionFailures = false;
            this.hasPrePaymentValidationFailure = false;
            this.shouldRemoveNewlyAddedInstruments = false;
            this.isOrderDeclined = false;
            this.digitalPayErrorMessageGenerator.setPaymentErrorMode(false);
        }
    }, {
        key: 'placeOrder',
        value: function placeOrder() {
            var _this3 = this;

            if (this.shouldDisablePayment()) {
                this.announcerService.announce(replace(this.settings.digitalPayScreenReaderMessages.placeOrderInvalidDisableMessage, '{0}', this.disablePaymentStateService.getReasonsWhyDisabled()));
                return;
            }

            this.paymentStateDefinitions.addDisablePaymentState(PLACING_ORDER_STATE_ID, this.settings.digitalPayScreenReaderMessages.placeOrderProcessingDisableMessage);
            this.resetPaymentStates();
            var prePaymentActions = this.prePaymentActionsService.getAllActions();

            var prePaymentPromises = [];
            prePaymentActions.forEach(function (action) {
                prePaymentPromises.push(action());
            });

            this._startPaymentSpinner();

            // Once all prepayment promises are resolved make the payment.
            this.$q.all(prePaymentPromises).then(function (resolvedPromises) {
                var payments = resolvedPromises.filter(function (resolvedPromise) {
                    return resolvedPromise && resolvedPromise.paymentInstrumentId;
                });

                _this3._startPaymentSpinner();
                var paymentsPayload = _this3.buildPaymentPayload(payments);

                var isSplitPayments = size(paymentsPayload.payments) > 1 || size(paymentsPayload.payments) === 1 && _this3.accountPassword && paymentsPayload.accountAmount;
                _this3.digitalPayErrorMessageGenerator.setPaymentErrorMode(isSplitPayments);

                _this3.submitDigitalPay(paymentsPayload);
            }).catch(function (error) {
                _this3.loadingIndicatorService.finishLoading();
                _this3.paymentStateDefinitions.removeDisablePaymentState(PLACING_ORDER_STATE_ID);
                _this3.hasPrePaymentActionFailures = true;
                if (error && error.errorMessage) {
                    _this3.digitalPayPaymentErrorDisplayService.pushGlobalError(error.errorMessage);
                }
            });
        }

        /**
         * Processes DigitalPay payments.
         * @param {Array} payments
         */

    }, {
        key: 'buildPaymentPayload',
        value: function buildPaymentPayload(payments) {
            var mergedPayments = {};
            payments.forEach(function (payment) {
                var existingPayment = mergedPayments[payment.paymentInstrumentId];
                if (existingPayment) {
                    mergedPayments[payment.paymentInstrumentId] = {
                        paymentInstrumentId: existingPayment.paymentInstrumentId,
                        amount: (existingPayment.amount || 0.0) + (payment.amount || 0.0),
                        stepUpToken: existingPayment.stepUpToken || payment.stepUpToken
                    };
                } else {
                    mergedPayments[payment.paymentInstrumentId] = {
                        paymentInstrumentId: payment.paymentInstrumentId,
                        amount: payment.amount,
                        stepUpToken: payment.stepUpToken
                    };
                }
            });

            var paymentsPayload = {
                payments: map(mergedPayments, function (value) {
                    return value;
                }).filter(function (payment) {
                    return payment.amount > 0.0;
                })
            };

            paymentsPayload.accountAmount = this.shouldShowOnAccountPasswordField ? this.paymentDistributionService.getOrderTotal() - sumBy(payments, function (payment) {
                return payment.amount;
            }) : 0.0;

            var paymentWithDeviceData = find(payments, function (p) {
                return p.deviceData != null;
            });
            paymentsPayload.deviceData = paymentWithDeviceData && paymentWithDeviceData.deviceData;

            return paymentsPayload;
        }

        /**
         * Submits DigitalPay payments.
         */

    }, {
        key: 'submitDigitalPay',
        value: function submitDigitalPay(paymentsPayload) {
            var _this4 = this;

            paymentsPayload.accountPassword = this.accountPassword;
            paymentsPayload.accountAmount = paymentsPayload.accountAmount;

            this.paymentService.submitDigitalPay(paymentsPayload).then(function (response) {
                return _this4._handlePaymentSuccess(response);
            }).then(function (response) {
                return _this4._handlePaymentInstrumentFailures(response, paymentsPayload);
            }).then(function (response) {
                return _this4._handleGenericPaymentFailure(response);
            }).then(function (response) {
                return _this4._handleOrderPlacementErrors(response);
            }).then(function (response) {
                if (!response.Result) {
                    _this4.loadingIndicatorService.finishLoading();
                }
                return response;
            }).catch(function (error) {
                _this4.loadingIndicatorService.finishLoading();
                _this4.digitalPayPaymentErrorDisplayService.pushGlobalError(error.ErrorMessage);
            }).finally(function () {
                _this4.paymentStateDefinitions.removeDisablePaymentState(PLACING_ORDER_STATE_ID);
            });
        }
    }, {
        key: 'showCvvConfirmationDialog',
        value: function showCvvConfirmationDialog(paymentsPayload, paymentInstrumentId) {
            var _this5 = this;

            // We need to specifically turn on this dialog otherwise it captures iframe events
            this.isCvvDialogEnabled = true;
            this.cvvConfirmationDialog.show().then(function (dialogResponse) {
                if (dialogResponse.success) {
                    _this5.digitalPayPaymentErrorDisplayService.clearGlobalError();
                    _this5._startPaymentSpinner();
                    var paymentToAddStepUpToken = find(paymentsPayload.payments, function (payment) {
                        return payment.paymentInstrumentId === paymentInstrumentId;
                    });
                    if (paymentToAddStepUpToken) {
                        paymentToAddStepUpToken.stepUpToken = dialogResponse.stepUpToken;
                    }
                    _this5.submitDigitalPay(paymentsPayload);
                } else {
                    _this5.digitalPayPaymentErrorDisplayService.pushGlobalError(dialogResponse.ErrorMessage);
                }
            }).finally(function () {
                _this5.isCvvDialogEnabled = false;
            });
        }
    }, {
        key: 'closedCvvConfirmationDialog',
        value: function closedCvvConfirmationDialog() {
            this.shouldRemoveNewlyAddedInstruments = true;
        }
    }, {
        key: 'backToReview',
        value: function backToReview() {
            this.checkoutStepService.resetStepTo('review');
        }

        /**
         * Handles case where payment request is successful.
         * @param {Object} response Payment Response
         */

    }, {
        key: '_handlePaymentSuccess',
        value: function _handlePaymentSuccess(response) {
            // Payment Successful.
            if (response.Result) {
                // Direct navigation is used instead of state transition in order to get the new state of a shopper's cart.
                window.location.href = '/shop/confirmation?orderId=' + response.PlacedOrderId;
            }

            return response;
        }

        /**
         * Handles case where payment request fails with failures with specific instruments.
         * @param {Object} response Payment Response
         * @param {Object} paymentsPayload Payment payloads request
         */

    }, {
        key: '_handlePaymentInstrumentFailures',
        value: function _handlePaymentInstrumentFailures(response, paymentsPayload) {
            // Handle payment specific errors.
            if (!response.Result && response.PaymentResponses && response.PaymentResponses.length) {
                var checkInstrumentError = function checkInstrumentError(value, type) {
                    return value.PaymentInstrumentType === type && value.ErrorCode;
                };
                var creditCardError = first(filter(response.PaymentResponses, function (value) {
                    return checkInstrumentError(value, 'CreditCard');
                }));
                if (creditCardError && creditCardError.StepUp && creditCardError.StepUp.Url) {
                    this.cvvUrl = creditCardError.StepUp.Url;
                    this.showCvvConfirmationDialog(paymentsPayload, creditCardError.PaymentInstrumentId);
                } else {
                    this.digitalPayPaymentErrorStateService.addErrors(response.PaymentResponses.filter(function (paymentResponse) {
                        return paymentResponse.ErrorCode;
                    }).map(function (paymentResponse) {
                        return new DigitalPayPaymentErrorState(paymentResponse.PaymentInstrumentId, paymentResponse);
                    }));
                    this.shouldRemoveNewlyAddedInstruments = true;
                }
            }

            return response;
        }

        /**
         * Handles case where payment request fails with a generic error.
         * @param {Object} response
         */

    }, {
        key: '_handleGenericPaymentFailure',
        value: function _handleGenericPaymentFailure(response) {
            // Handle generic Payment failures.
            if (!response.Result) {
                if (response.ErrorCode && response.ErrorCode !== 'InvalidPassword' && response.ErrorCode !== this.settings.digitalPayErrorCodes.creditCardStepUpTokenRequired) {
                    if (response.ErrorCode === this.settings.digitalPayErrorCodes.unknown) {
                        this.shouldRemoveNewlyAddedInstruments = true;
                    } else {
                        this.digitalPayPaymentErrorDisplayService.pushGlobalError();
                    }
                }
            }

            return response;
        }

        /**
         * Handles case where payment request fails with OrderPlacement errors.
         * @param {Object} response
         */

    }, {
        key: '_handleOrderPlacementErrors',
        value: function _handleOrderPlacementErrors(response) {
            var _this6 = this;

            // Handle Order Placement Errors.
            var orderPlacementError = first(response.OrderPlacementErrors);
            if (!response.Result && orderPlacementError) {
                var errorMessage = response.ErrorMessage ? response.ErrorMessage : response.OrderPlacementErrors[0].Message;

                if (orderPlacementError.Type === this.settings.digitalPayOrderPlacementErrorCodes.timeout) {
                    // Clear global error as the error context is already part of the dialog.
                    this.digitalPayPaymentErrorDisplayService.clearGlobalError();
                    this.timeoutErrorMessage = orderPlacementError.Message;
                    this.confirmationDialog.show();
                } else if (orderPlacementError.Type === this.settings.digitalPayOrderPlacementErrorCodes.deliveryWindow) {
                    // Clear global error as the error context is already part of the dialog.
                    this.digitalPayPaymentErrorDisplayService.clearGlobalError();
                    this.deliveryTimeoutConfirmationDialog.show().finally(function () {
                        return _this6.checkoutStepService.canReviewOrder(false);
                    });
                } else if (orderPlacementError.Type === this.settings.digitalPayOrderPlacementErrorCodes.invalidPassword) {
                    this.setPasswordError(true);
                    this.hasPrePaymentValidationFailure = true;
                    errorMessage = this.settings.digitalPayError.onAccountInvalidPasswordMessage;
                } else if (orderPlacementError.Type === this.settings.digitalPayOrderPlacementErrorCodes.declined) {
                    this.shouldRemoveNewlyAddedInstruments = true;
                    this.isOrderDeclined = true;
                    this.digitalPayPaymentErrorStateService.addErrors(response.PaymentResponses.filter(function (paymentResponse) {
                        return !paymentResponse.ErrorCode;
                    }).map(function (paymentResponse) {
                        return new DigitalPayPaymentErrorState(paymentResponse.PaymentInstrumentId, _this6.addDeclinedErrorDetails(paymentResponse));
                    }));
                }

                this.digitalPayPaymentErrorDisplayService.pushGlobalError(errorMessage);
            }

            return response;
        }
    }, {
        key: 'addDeclinedErrorDetails',
        value: function addDeclinedErrorDetails(paymentResponse) {
            paymentResponse.ErrorCode = this.settings.digitalPayOrderPlacementErrorCodes.declined;
            paymentResponse.ErrorMessage = '';

            return paymentResponse;
        }
    }, {
        key: '_startPaymentSpinner',
        value: function _startPaymentSpinner() {
            this.loadingIndicatorService.startLoading(true, 'Processing your payment', false);
        }
    }]);

    return PaymentDigitalPayController;
}();

PaymentDigitalPayController.$inject = ['$element', '$q', '$state', 'Settings', 'AnnouncerService', 'DigitalPayPaymentErrorDisplayService', 'PaymentService', 'LoadingIndicatorService', 'CheckoutStepService', 'CheckoutService', 'DigitalPayIframeEventHandler', 'DigitalPayPaymentDistributionService', 'DigitalPayPrepaymentActionsService', 'DigitalPayDisablePaymentStateService', 'DigitalPayPaymentErrorStateService', 'DigitalPayErrorMessageGenerator'];

var paymentDigitalPayComponentDefinition = {
    controller: PaymentDigitalPayController,
    template: __webpack_require__(964).trim()
};

module.exports = {
    PaymentDigitalPayController: PaymentDigitalPayController,
    paymentDigitalPayComponentDefinition: paymentDigitalPayComponentDefinition
};

/***/ }),
/* 964 */
/***/ (function(module, exports) {

module.exports = "<wow-digital-pay-error-display error-message=\"$ctrl.digitalPayPaymentErrorDisplayService.getGlobalErrorMessage($ctrl.isOrderDeclined)\"\r\n    error-list=\"$ctrl.digitalPayPaymentErrorDisplayService.getPaymentErrors()\"\r\n    hide-error-list=\"$ctrl.isOrderDeclined\"></wow-digital-pay-error-display>\r\n\r\n<div class=\"paymentDigitalPay-container\"\r\n    ng-class=\"{'paymentDigitalPay-container--extended': $ctrl.hasExceededBasketAmount() || $ctrl.hasOutstandingAmount(),\r\n        'paymentDigitalPay-container--extendedPassword': $ctrl.listLoaded && $ctrl.shouldShowOnAccountPasswordField}\">\r\n    <form name=\"$ctrl.paymentDigitalPay-checkoutFooterForm\" novalidate ng-submit=\"$ctrl.placeOrder()\">\r\n        <div class=\"paymentDigitalPay-methods\"\r\n            ng-class=\"{'is-extended' : $ctrl.shouldShowOnAccountPasswordField || $ctrl.shouldShowCheckoutMessage()}\">\r\n            <wow-digital-pay-instruments ng-if=\"$ctrl.isCheckoutInitialised\"\r\n                class=\"digitalPayInstrumentsContainer\"\r\n                account-password=\"$ctrl.accountPassword\"\r\n                has-pre-payment-action-failures=\"$ctrl.hasPrePaymentActionFailures\"\r\n                has-pre-payment-validation-failure=\"$ctrl.hasPrePaymentValidationFailure\"\r\n                is-for-payment-agreement=\"false\"\r\n                on-account-password-field-loaded=\"$ctrl.notifyOnAccountPasswordFieldLoaded(value)\"\r\n                on-child-is-in-manage-mode=\"$ctrl.notifyWhenChildIsInManageMode(state)\"\r\n                on-password-reset=\"$ctrl.notifyPasswordReset()\"\r\n                payment-error-states=\"$ctrl.digitalPayPaymentErrorStateService.getErrors()\"\r\n                payment-state-definitions=\"$ctrl.paymentStateDefinitions\"\r\n                pre-payment-action-definitions=\"$ctrl.prePaymentActionDefinitions\",\r\n                should-remove-newly-added-instruments=\"$ctrl.shouldRemoveNewlyAddedInstruments\"\r\n                should-show-paying-amount=\"true\"\r\n                should-show-paypal-place-order-button=\"$ctrl.shouldShowPaypalPlaceOrderButton\"\r\n                on-credit-card-selection-changed=\"$ctrl.notifyWhenCreditCardSelectionChanged(state)\"\r\n            >\r\n            </wow-digital-pay-instruments>\r\n        </div>\r\n        <footer class=\"checkoutFooter paymentDigitalPay-checkoutFooter\">\r\n            <div class=\"paymentDigitalPay-checkoutFooterHeader\" ng-show=\"$ctrl.hasExceededBasketAmount()\">\r\n                <b><i>Your supplied payments exceed the order value.</i></b>\r\n            </div>\r\n            <div class=\"paymentDigitalPay-checkoutFooterHeader\" ng-show=\"$ctrl.hasOutstandingAmount()\">\r\n                <b><i>There is currently a value of {{$ctrl.getRemainingAmount() | currency}} outstanding</i></b>\r\n            </div>\r\n            <div class=\"paymentDigitalPay-checkoutFooterHeader\" ng-show=\"$ctrl.shouldShowCheckoutMessage()\">\r\n                <b><i ng-bind-html=\"$ctrl.settings.payments.postPickPayOrderCheckoutMessage\"></i></b>\r\n            </div>\r\n            <div class=\"paymentDigitalPay-checkoutFooterPasswordContainerInput\"\r\n                ng-if=\"$ctrl.isCheckoutInitialised && $ctrl.shouldShowOnAccountPasswordField\"\r\n                ng-show=\"!$ctrl.anyChildIsInManageMode\">\r\n                <input type=\"password\"\r\n                    class=\"onAccountPasswordInput\"\r\n                    placeholder=\"Verify account password\"\r\n                    ng-change=\"$ctrl.clearPasswordError()\"\r\n                    ng-init=\"$ctrl.resetPassword()\"\r\n                    ng-model=\"$ctrl.accountPassword\"/>\r\n            </div>\r\n            <div class=\"dpFooter-container paymentDigitalPay-checkoutFooterBody\">\r\n                <button\r\n                    wow-digital-pay-button\r\n                    class=\"button\"\r\n                    type=\"button\"\r\n                    ng-click=\"$ctrl.backToReview()\">\r\n                        <i class=\"iconww-ArrowLeft dpFooter-iconLeftButton\"></i>Back\r\n                </button>\r\n\r\n                <!-- Common Place Order Button -->\r\n                <button\r\n                    wow-digital-pay-button\r\n                    class=\"button button--primary\"\r\n                    ng-class=\"{'is-disabled': $ctrl.shouldDisablePayment()}\"\r\n                    ng-if=\"!$ctrl.shouldShowPaypalPlaceOrderButton\"\r\n                    aria-disabled=\"{{ $ctrl.shouldDisablePayment() }}\"\r\n                    role=\"submit\">\r\n                        Place order<i class=\"iconww-ArrowRight dpFooter-iconRightButton\"></i>\r\n                </button>\r\n\r\n                <!-- Paypal Place Order Button -->\r\n                <button\r\n                    wow-digital-pay-button\r\n                    class=\"button paymentDigitalPay-paypalButton\"\r\n                    ng-class=\"{'is-disabled': $ctrl.shouldDisablePayment()}\"\r\n                    ng-if=\"$ctrl.shouldShowPaypalPlaceOrderButton\"\r\n                    aria-disabled=\"{{ $ctrl.shouldDisablePayment() }}\"\r\n                    role=\"submit\">\r\n                        <span>PAY WITH</span>\r\n                        <img class=\"paymentDigitalPay-paypalButtonIcon\" ng-src=\"images/checkout/digitalpay/icon-btn-paypal.svg\" alt=\"Paypal\" title=\"Pay with Paypal\"/>\r\n                        <i class=\"iconww-ArrowRight dpFooter-iconRightButton\"></i>\r\n                </button>\r\n            </div>\r\n        </footer>\r\n    </form>\r\n</div>\r\n\r\n<wow-credit-card-cvv-dialog\r\n    cvv-url=\"$ctrl.cvvUrl\"\r\n    dialog-name=\"'credit card confirm cvv dialog'\"\r\n    dialog=\"$ctrl.cvvConfirmationDialog\"\r\n    is-iframe-enabled=\"$ctrl.isCvvDialogEnabled\"\r\n    dialog-close-action=\"$ctrl.closedCvvConfirmationDialog()\">\r\n</wow-credit-card-cvv-dialog>\r\n<wow-digital-pay-confirmation-dialog\r\n    dialog-name=\"'Payment timeout dialog'\"\r\n    dialog=\"$ctrl.confirmationDialog\"\r\n    is-warning-icon=\"true\"\r\n    message=\"$ctrl.timeoutErrorMessage\">\r\n        <div class=\"dpFooter-container\">\r\n            <button class=\"button\" ng-click=\"$ctrl.confirmationDialog.close({ success: true })\">\r\n                <i class=\"iconww-ArrowLeft dpFooter-iconLeftButton\"></i>RETURN TO PAYMENT\r\n            </button>\r\n        </div>\r\n</wow-digital-pay-confirmation-dialog>\r\n<wow-digital-pay-confirmation-dialog\r\n    dialog-name=\"'payment delivery slot timeout dialog'\"\r\n    dialog=\"$ctrl.deliveryTimeoutConfirmationDialog\"\r\n    message=\"::$ctrl.settings.digitalPayError.deliveryWindowExpiryErrorMessage\">\r\n    <div class=\"dpFooter-container\">\r\n        <button class=\"button\" ng-click=\"$ctrl.deliveryTimeoutConfirmationDialog.close({ success: true })\">\r\n            <i class=\"iconww-ArrowLeft dpFooter-iconLeftButton\"></i>DELIVERY\r\n        </button>\r\n    </div>\r\n</wow-digital-pay-confirmation-dialog>\r\n"

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var singleSelectTypes = __webpack_require__(44);
var multiSelectTypes = __webpack_require__(966);

var _require = __webpack_require__(0),
    concat = _require.concat,
    curry = _require.curry,
    filter = _require.filter,
    find = _require.find,
    groupBy = _require.groupBy,
    keys = _require.keys,
    map = _require.map,
    max = _require.max,
    size = _require.size,
    some = _require.some;

/**
 * Handles Payment Specific Display Logic.
 *
 * Purpose of this component:
 * 1. Display Payment Instruments
 * 2. Maintain Payment Instrument display states.
 *
 * Note 1: This component should not concern itself about making payments.
 *
 */


var DigitalPayInstrumentsController = function () {
    function DigitalPayInstrumentsController($q, paymentDistributionService, shopperService, settings, digitalPayDisablePaymentStateService, dateHelperService, digitalPayPaymentErrorDisplayService, digitalPayErrorMessageGenerator, digitalPayPaymentInstrumentsService) {
        _classCallCheck(this, DigitalPayInstrumentsController);

        this.$q = $q;
        this.paymentDistributionService = paymentDistributionService;
        this.shopperService = shopperService;
        this.settings = settings;
        this.disablePaymentStateService = digitalPayDisablePaymentStateService;
        this.dateHelperService = dateHelperService;
        this.digitalPayPaymentErrorDisplayService = digitalPayPaymentErrorDisplayService;
        this.digitalPayErrorMessageGenerator = digitalPayErrorMessageGenerator;
        this.digitalPayPaymentInstrumentsService = digitalPayPaymentInstrumentsService;
    }

    _createClass(DigitalPayInstrumentsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Key used for identifying amount distributed to add gift card component.
            this.gcPaymentAddCardAmountKey = 'gcAddCardAmount';
            // Key used for identifying amount distributed to on account component.
            this.onAccountPaymentAmountKey = 'onAccountPaymentAmountKey';

            // Default pre-selected payment instrument value definitions
            this.singleSelectType = singleSelectTypes.NONE;
            this.shouldSelectGiftCard = false;

            // On Account
            this.isEligibleForOnAccount = this.shopperService.shopper.IsRegisteredForDirectDebit;

            // State of instruments
            this.isDigitalPayReady = false;
            this.hasListInstrumentsError = false;

            // Initializing error page
            this.serviceUnavailablePrimaryMessage = this.settings.digitalPay.paymentConnectivityPrimaryErrorMessage;
            this.serviceUnavailableSecondaryMessage = this.isEligibleForOnAccount ? this.settings.digitalPayMessages.accountPaymentWhenListUnavailableMessage : this.settings.digitalPay.paymentConnectivitySecondaryErrorMessage;

            // Keeps track of all the non single select type
            this.multipleSelectCards = {};

            this.loadInstruments().then(function () {
                _this.isImpersonated = _this.instruments.IsImpersonated;
                _this.showOnlyOnAccount = _this.instruments.Account.Enabled && !(_this.instruments.CreditCard.Enabled || _this.instruments.GiftCard.Enabled || _this.instruments.Paypal.Enabled);
                _this.preSelectPaymentInstruments();
            }).catch(function () {
                if (_this.isEligibleForOnAccount) {
                    _this.singleSelectType = singleSelectTypes.ACCOUNT;
                }
            }).finally(function () {
                _this.isDigitalPayReady = true;
            });

            this.notifyInstrumentTypeInManageMode(this.settings.digitalPayPaymentTypes.emptyType);
        }

        /**
         * Load payment instruments
         */

    }, {
        key: 'loadInstruments',
        value: function loadInstruments() {
            var _this2 = this;

            return this.digitalPayPaymentInstrumentsService.listDigitalPayInstruments(this.isForPaymentAgreement).then(function (response) {
                if (!response.Success) {
                    _this2.hasListInstrumentsError = true;
                    return _this2.$q.reject();
                }

                _this2.instruments = response;
                _this2.hasListInstrumentsError = false;
                return response;
            });
        }
    }, {
        key: 'preSelectPaymentInstruments',
        value: function preSelectPaymentInstruments() {
            // Pre-selection of instruments
            var paymentInstruments = this.normalizePaymentInstruments(this.instruments.CreditCard.Instruments, this.instruments.Paypal.Instruments, this.instruments.GiftCard.Instruments);
            var lastUsedPaymentInstruments = this.getLastUsedPaymentInstruments(paymentInstruments);
            var shouldSelectOnAccount = this.shouldSelectOnAccount(lastUsedPaymentInstruments, this.showOnlyOnAccount, this.instruments.Account.Attributes.AccountIsLastUsed, this.isEligibleForOnAccount);
            if (shouldSelectOnAccount) {
                this.singleSelectType = singleSelectTypes.ACCOUNT;
            } else {
                this.setSelectInstruments(lastUsedPaymentInstruments);
            }
        }

        /**
         * Normalizes a single payment instrument
         * @param {string} type
         * @param {Object} instrument
         */

    }, {
        key: 'normalizePaymentInstrument',
        value: function normalizePaymentInstrument(type, instrument) {
            return {
                Id: instrument.PaymentInstrumentId,
                LastUsed: instrument.LastUsed,
                Type: type
            };
        }

        /**
         * Returns a list of normalized payment instruments
         * We can add new payment instrument types here
         * @param {Object[]} creditCards
         * @param {Object[]} paypal
         * @param {Object[]} giftCards
         */

    }, {
        key: 'normalizePaymentInstruments',
        value: function normalizePaymentInstruments(creditCards, paypal, giftCards) {
            var creditCardInstruments = map(creditCards, curry(this.normalizePaymentInstrument)(singleSelectTypes.CREDITCARD));
            var paypalInstruments = map(paypal, curry(this.normalizePaymentInstrument)(singleSelectTypes.PAYPAL));
            var giftCardInstruments = map(giftCards, curry(this.normalizePaymentInstrument)(multiSelectTypes.GIFTCARD));
            return concat(creditCardInstruments, paypalInstruments, giftCardInstruments);
        }

        /**
         * Groups a list of normalized payment instruments by their last used
         * Returns the group which has the highest last used
         * @param {Object[]} instruments
         */

    }, {
        key: 'getLastUsedPaymentInstruments',
        value: function getLastUsedPaymentInstruments(instruments) {
            var _this3 = this;

            var instrumentGroups = groupBy(instruments, function (instrument) {
                return _this3.dateHelperService.getDateFromEpochInSeconds(instrument.LastUsed);
            });
            var instrumentGroupKeys = keys(instrumentGroups);
            var maxInstrumentGroupKey = max(instrumentGroupKeys);
            return instrumentGroups[maxInstrumentGroupKey];
        }

        /**
         * Determines if we should select on account or not
         * @param {Object[]} lastUsedPaymentInstruments
         * @param {boolean} showOnlyOnAccount
         * @param {boolean} accountIsLastUsed
         * @param {boolean} isEligibleForOnAccount
         */

    }, {
        key: 'shouldSelectOnAccount',
        value: function shouldSelectOnAccount(lastUsedPaymentInstruments, showOnlyOnAccount, accountIsLastUsed, isEligibleForOnAccount) {
            return showOnlyOnAccount || (!lastUsedPaymentInstruments || !lastUsedPaymentInstruments.length) && isEligibleForOnAccount || accountIsLastUsed && isEligibleForOnAccount;
        }

        /**
         * Single select type takes precedence over multi select types
         * When more multi select types are added, this method will need to change
         * @param {Object[]} lastUsedPaymentInstruments
         */

    }, {
        key: 'setSelectInstruments',
        value: function setSelectInstruments(lastUsedPaymentInstruments) {
            if (lastUsedPaymentInstruments && lastUsedPaymentInstruments.length) {
                var singleSelectType = find(lastUsedPaymentInstruments, function (instrument) {
                    return some(singleSelectTypes, function (type) {
                        return type === instrument.Type;
                    });
                });
                if (singleSelectType) {
                    this.singleSelectType = singleSelectType.Type;
                } else {
                    this.shouldSelectGiftCard = true;
                }
            }
        }
    }, {
        key: 'notifyPaypalSelected',
        value: function notifyPaypalSelected() {
            this.updateShowPaypalPlaceOrderButton();
        }
    }, {
        key: 'notifyPaypalUnselected',
        value: function notifyPaypalUnselected() {
            this.shouldShowPaypalPlaceOrderButton = false;
        }
    }, {
        key: 'notifyInstrumentTypeInManageMode',
        value: function notifyInstrumentTypeInManageMode(type) {
            this.instrumentTypeInManageMode = type;
            this.onChildIsInManageMode({ state: this.instrumentTypeInManageMode !== this.settings.digitalPayPaymentTypes.emptyType });
        }
    }, {
        key: 'notifyChangeMultiSelectCard',
        value: function notifyChangeMultiSelectCard(id, isSelected) {
            if (isSelected) {
                this.multipleSelectCards[id] = {};
            } else {
                delete this.multipleSelectCards[id];
            }

            this.updateShowPaypalPlaceOrderButton();
        }
    }, {
        key: 'notifyPayPalLinkFailed',
        value: function notifyPayPalLinkFailed(errorMessage) {
            this.digitalPayPaymentErrorDisplayService.pushGlobalError(errorMessage);
        }
    }, {
        key: 'notifyPayPalUnlinkFailed',
        value: function notifyPayPalUnlinkFailed(errorMessage) {
            this.digitalPayPaymentErrorDisplayService.pushGlobalError(errorMessage);
        }
    }, {
        key: 'shouldDisplayPaymentInstrumentList',
        value: function shouldDisplayPaymentInstrumentList(type) {
            return this.instrumentTypeInManageMode === this.settings.digitalPayPaymentTypes.emptyType || this.instrumentTypeInManageMode === type;
        }
    }, {
        key: 'setSingleSelectType',
        value: function setSingleSelectType(type) {
            this.singleSelectType = type;
            this.onCreditCardSelectionChanged({ state: type === singleSelectTypes.CREDITCARD });
        }
    }, {
        key: 'updateShowPaypalPlaceOrderButton',
        value: function updateShowPaypalPlaceOrderButton() {
            var paymentKeys = this.paymentDistributionService.getKeys();
            this.shouldShowPaypalPlaceOrderButton = paymentKeys.length === 1 && this.singleSelectType === singleSelectTypes.PAYPAL && !size(this.multipleSelectCards);
        }
    }, {
        key: 'reloadInstruments',
        value: function reloadInstruments() {
            var _this4 = this;

            this.hasListInstrumentsError = false;
            this.isDigitalPayReady = false;
            this.loadInstruments().finally(function () {
                _this4.isDigitalPayReady = true;
            });
        }
    }, {
        key: 'notifyLoadInstruments',
        value: function notifyLoadInstruments() {
            this.loadInstruments();
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            var _this5 = this;

            var currentPaymentErrorStates = changes.paymentErrorStates && changes.paymentErrorStates.currentValue || [];
            if (currentPaymentErrorStates.length) {
                // Filter unknown/notset instrument type error states.
                var unknownInstrumentErrorStates = filter(currentPaymentErrorStates, function (value) {
                    var state = value.state;
                    return state.ErrorCode && state.PaymentInstrumentType === _this5.settings.digitalPayPaymentTypes.unknownType;
                });

                if (some(unknownInstrumentErrorStates, function (errorState) {
                    return errorState.state.ErrorCode === _this5.settings.digitalPayErrorCodes.paymentInstrumentNotFound;
                })) {
                    var errorMessage = this.digitalPayErrorMessageGenerator.getGenericPaymentError(this.settings.digitalPayErrorCodes.paymentInstrumentNotFound);
                    this.digitalPayPaymentErrorDisplayService.pushGlobalError(errorMessage);
                    this.preSelectPaymentInstruments();
                }
            }
        }
    }]);

    return DigitalPayInstrumentsController;
}();

DigitalPayInstrumentsController.$inject = ['$q', 'DigitalPayPaymentDistributionService', 'ShopperService', 'Settings', 'DigitalPayDisablePaymentStateService', 'DateHelperService', 'DigitalPayPaymentErrorDisplayService', 'DigitalPayErrorMessageGenerator', 'DigitalPayPaymentInstrumentsService'];

var digitalPayInstrumentsComponentDefinition = {
    controller: DigitalPayInstrumentsController,
    template: __webpack_require__(967).trim(),
    bindings: {
        accountPassword: '<',
        hasPrePaymentActionFailures: '<',
        hasPrePaymentValidationFailure: '<',
        isForPaymentAgreement: '<',
        onAccountPasswordFieldLoaded: '&',
        onChildIsInManageMode: '&',
        onPasswordReset: '&',
        paymentErrorStates: '<',
        paymentStateDefinitions: '<',
        prePaymentActionDefinitions: '<',
        shouldRemoveNewlyAddedInstruments: '<',
        shouldShowPayingAmount: '<',
        shouldShowPaypalPlaceOrderButton: '=',
        onCreditCardSelectionChanged: '&'
    }
};

module.exports = {
    DigitalPayInstrumentsController: DigitalPayInstrumentsController,
    digitalPayInstrumentsComponentDefinition: digitalPayInstrumentsComponentDefinition
};

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    GIFTCARD: 'GiftCard'
};

/***/ }),
/* 967 */
/***/ (function(module, exports) {

module.exports = "<!-- Single Select Type -->\r\n<wow-digital-pay-account\r\n    ng-show=\"$ctrl.shouldDisplayPaymentInstrumentList($ctrl.settings.digitalPayPaymentTypes.onAccountType)\"\r\n    ng-if=\"$ctrl.instruments.Account.Enabled && $ctrl.isEligibleForOnAccount\"\r\n    class=\"digitalPayInstruments digitalPayInstruments-instrumentStyle\"\r\n    single-select-type=\"$ctrl.singleSelectType\"\r\n    set-single-select-type=\"$ctrl.setSingleSelectType(type)\"\r\n    on-account-payment-amount-key=\"$ctrl.onAccountPaymentAmountKey\"\r\n    is-show-only-on-account=\"$ctrl.showOnlyOnAccount\"\r\n    is-eligible-for-on-account=\"$ctrl.isEligibleForOnAccount\"\r\n    on-password-field-loaded=\"$ctrl.onAccountPasswordFieldLoaded({value:value})\"\r\n    account-password=\"$ctrl.accountPassword\"\r\n    has-list-instruments-error=\"$ctrl.hasListInstrumentsError\"\r\n    on-password-reset=\"$ctrl.onPasswordReset()\">\r\n</wow-digital-pay-account>\r\n\r\n<!-- Single Select Type -->\r\n<wow-credit-card\r\n    ng-show=\"!$ctrl.hasListInstrumentsError && $ctrl.shouldDisplayPaymentInstrumentList($ctrl.settings.digitalPayPaymentTypes.creditCardType)\"\r\n    ng-if=\"$ctrl.instruments.CreditCard.Enabled && $ctrl.isDigitalPayReady\"\r\n    class=\"digitalPayInstruments digitalPayInstruments-instrumentStyle\"\r\n    allowed-networks=\"$ctrl.instruments.CreditCard.Attributes.AllowedNetworks\"\r\n    credit-cards=\"$ctrl.instruments.CreditCard.Instruments\"\r\n    has-pre-payment-action-failures=\"$ctrl.hasPrePaymentActionFailures\"\r\n    is-impersonated=\"$ctrl.isImpersonated\"\r\n    is-saving-card=\"$ctrl.isForPaymentAgreement\"\r\n    on-instrument-type-in-manage-mode=\"$ctrl.notifyInstrumentTypeInManageMode(type)\"\r\n    payment-error-states=\"$ctrl.paymentErrorStates\"\r\n    payment-state-definitions=\"$ctrl.paymentStateDefinitions\"\r\n    pre-payment-action-definitions=\"$ctrl.prePaymentActionDefinitions\"\r\n    refresh-credit-cards=\"$ctrl.notifyLoadInstruments()\"\r\n    set-single-select-type=\"$ctrl.setSingleSelectType(type)\"\r\n    should-remove-newly-added-instruments=\"$ctrl.shouldRemoveNewlyAddedInstruments\"\r\n    should-show-paying-amount=\"$ctrl.shouldShowPayingAmount\"\r\n    should-show-save=\"!$ctrl.isImpersonated && !$ctrl.isForPaymentAgreement\"\r\n    single-select-type=\"$ctrl.singleSelectType\">\r\n</wow-credit-card>\r\n\r\n<!-- Single Select Type -->\r\n<wow-paypal-payment\r\n    ng-show=\"!$ctrl.hasListInstrumentsError && $ctrl.shouldDisplayPaymentInstrumentList($ctrl.settings.digitalPayPaymentTypes.paypalType)\"\r\n    ng-if=\"$ctrl.instruments.Paypal.Enabled && $ctrl.isDigitalPayReady\"\r\n    class=\"digitalPayInstruments digitalPayInstruments-instrumentStyle\"\r\n    pre-payment-action-definitions=\"$ctrl.prePaymentActionDefinitions\"\r\n    payment-state-definitions=\"$ctrl.paymentStateDefinitions\"\r\n    paypal=\"$ctrl.instruments.Paypal.Instruments[0]\"\r\n    token=\"$ctrl.instruments.Paypal.Attributes.ClientToken\"\r\n    single-select-type=\"$ctrl.singleSelectType\"\r\n    refresh-paypal=\"$ctrl.notifyLoadInstruments()\"\r\n    set-single-select-type=\"$ctrl.setSingleSelectType(type)\"\r\n    on-selected=\"$ctrl.notifyPaypalSelected()\"\r\n    on-unselected=\"$ctrl.notifyPaypalUnselected()\"\r\n    payment-error-states=\"$ctrl.paymentErrorStates\"\r\n    on-link-failed=\"$ctrl.notifyPayPalLinkFailed(errorMessage)\"\r\n    on-unlink-failed=\"$ctrl.notifyPayPalUnlinkFailed(errorMessage)\">\r\n</wow-paypal-payment>\r\n\r\n<!-- Multi Select Type -->\r\n<wow-gift-card\r\n    ng-show=\"!$ctrl.hasListInstrumentsError && $ctrl.shouldDisplayPaymentInstrumentList($ctrl.settings.digitalPayPaymentTypes.giftCardType)\"\r\n    ng-if=\"$ctrl.instruments.GiftCard.Enabled && $ctrl.isDigitalPayReady\"\r\n    class=\"digitalPayInstruments digitalPayInstruments-instrumentStyle\"\r\n    gift-cards=\"$ctrl.instruments.GiftCard.Instruments\"\r\n    allowed-bins=\"::$ctrl.instruments.GiftCard.Attributes.AllowedBins\"\r\n    payment-add-card-amount-key=\"$ctrl.gcPaymentAddCardAmountKey\"\r\n    payment-state-definitions=\"$ctrl.paymentStateDefinitions\"\r\n    pre-payment-action-definitions=\"$ctrl.prePaymentActionDefinitions\"\r\n    refresh-gift-cards=\"$ctrl.notifyLoadInstruments()\"\r\n    set-single-select-type=\"$ctrl.setSingleSelectType(type)\"\r\n    should-select-gift-card=\"$ctrl.shouldSelectGiftCard\"\r\n    single-select-type=\"$ctrl.singleSelectType\"\r\n    on-instrument-type-in-manage-mode=\"$ctrl.notifyInstrumentTypeInManageMode(type)\"\r\n    on-change-select-gift-card=\"$ctrl.notifyChangeMultiSelectCard(id, isSelected)\"\r\n    payment-error-states=\"$ctrl.paymentErrorStates\"\r\n    has-pre-payment-action-failures=\"$ctrl.hasPrePaymentActionFailures\"\r\n    has-pre-payment-validation-failure=\"$ctrl.hasPrePaymentValidationFailure\"\r\n    is-impersonated=\"$ctrl.isImpersonated\"\r\n    should-remove-newly-added-instruments=\"$ctrl.shouldRemoveNewlyAddedInstruments\">\r\n</wow-gift-card>\r\n\r\n<wow-loading-spinner\r\n    ng-if=\"!$ctrl.isDigitalPayReady && !$ctrl.showOnlyOnAccount\"\r\n    message=\"Loading Payment Instruments, please wait\"\r\n    is-message-sr-only=\"true\">\r\n</wow-loading-spinner>\r\n<span ng-if=\"$ctrl.isDigitalPayReady\" class=\"sr-only\" role=\"alert\">Payment Instruments Ready</span>\r\n\r\n<div ng-if=\"$ctrl.hasListInstrumentsError\" class=\"paymentDigitalPay-errorContainer digitalPayInstrumentsContainer-error\">\r\n    <wow-error-page\r\n        show-icon=\"true\"\r\n        icon=\"iconww-Info\"\r\n        message=\"{{$ctrl.serviceUnavailablePrimaryMessage}}\"\r\n        secondary-message=\"{{$ctrl.serviceUnavailableSecondaryMessage}}\"\r\n        page-class=\"paymentDigitalPay-errorPage\"\r\n        message-class=\"paymentDigitalPay-errorMessage\"\r\n        secondary-message-class=\"paymentDigitalPay-errorSecondaryMessage\">\r\n    </wow-error-page>\r\n    <button class=\"dpLinkButton\" ng-click=\"$ctrl.reloadInstruments()\">Reload page</button>\r\n</div>\r\n"

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stagedAmountDisplayComponentDefinition = {
    template: __webpack_require__(969).trim(),
    bindings: {
        payingAmount: '<',
        showDescription: '<'
    }
};

module.exports = {
    stagedAmountDisplayComponentDefinition: stagedAmountDisplayComponentDefinition
};

/***/ }),
/* 969 */
/***/ (function(module, exports) {

module.exports = "<div class=\"stagedAmountDisplay-container\">\r\n    <span class=\"stagedAmountDisplay-description\" ng-if=\"$ctrl.showDescription\">Payment to be deducted</span>\r\n    <div class=\"stagedAmountDisplay-innerContainer\">\r\n        <span class=\"stagedAmountDisplay-label\">PAYING</span>\r\n        <span class=\"stagedAmountDisplay-amount\">{{$ctrl.payingAmount | currency}}</span>\r\n    </div>\r\n</div>"

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.digitalpay');

var _require = __webpack_require__(971),
    digitalPayAccountComponentDefinition = _require.digitalPayAccountComponentDefinition;

wowApp.component('wowDigitalPayAccount', digitalPayAccountComponentDefinition);

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ACCOUNT_PASSWORD_DISABLE_STATE_KEY = 'onAccountPasswordDisableStateKey';

var singleSelectTypes = __webpack_require__(44);

var DigitalPayAccountController = function () {
    function DigitalPayAccountController(settings, digitalPayPaymentDistributionService, digitalPayPaymentErrorDisplayService, digitalPayDisablePaymentStateService) {
        _classCallCheck(this, DigitalPayAccountController);

        this.settings = settings;
        this.digitalPayPaymentDistributionService = digitalPayPaymentDistributionService;
        this.digitalPayPaymentErrorDisplayService = digitalPayPaymentErrorDisplayService;
        this.digitalPayDisablePaymentStateService = digitalPayDisablePaymentStateService;
    }

    _createClass(DigitalPayAccountController, [{
        key: 'getPayingAmount',
        value: function getPayingAmount() {
            return this.digitalPayPaymentDistributionService.getPayment(this.onAccountPaymentAmountKey);
        }
    }, {
        key: 'setPayingAmount',
        value: function setPayingAmount() {
            this.digitalPayPaymentDistributionService.addPaymentInFull(this.onAccountPaymentAmountKey);
        }
    }, {
        key: 'toggleSelected',
        value: function toggleSelected() {
            if (this.isSelected()) {
                this.unselect();
            } else {
                this.setSelected();
            }
        }
    }, {
        key: 'isSelected',
        value: function isSelected() {
            return this.singleSelectType === singleSelectTypes.ACCOUNT;
        }
    }, {
        key: 'setSelected',
        value: function setSelected() {
            this.setSingleSelectType({ type: singleSelectTypes.ACCOUNT });
            this.setPayingAmount();
            this.digitalPayPaymentErrorDisplayService.clearGlobalError();
        }
    }, {
        key: 'unselect',
        value: function unselect() {
            if (!this.isShowOnlyOnAccount && !this.hasListInstrumentsError) {
                this.setSingleSelectType({ type: singleSelectTypes.NONE });
                this.digitalPayPaymentDistributionService.removePayment(this.onAccountPaymentAmountKey);
            }
        }
    }, {
        key: 'callOnPasswordFieldLoaded',
        value: function callOnPasswordFieldLoaded(value) {
            this.onPasswordFieldLoaded({ value: value });
            this.setDisableState(value);
        }
    }, {
        key: 'setDisableState',
        value: function setDisableState(shouldDisable) {
            if (shouldDisable) {
                this.digitalPayDisablePaymentStateService.addDisablePaymentState(ACCOUNT_PASSWORD_DISABLE_STATE_KEY, this.settings.digitalPayScreenReaderMessages.accountPasswordDisableStateMessage);
            } else {
                this.digitalPayDisablePaymentStateService.removeDisablePaymentState(ACCOUNT_PASSWORD_DISABLE_STATE_KEY);
            }
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            // Handle if On Account gets selected
            if (changes.singleSelectType) {
                var onAccountSelected = changes.singleSelectType.currentValue === singleSelectTypes.ACCOUNT;
                if (onAccountSelected) {
                    this.setPayingAmount();
                } else if (changes.singleSelectType.previousValue === singleSelectTypes.ACCOUNT) {
                    this.onPasswordReset();
                }
                this.callOnPasswordFieldLoaded(onAccountSelected ? this.isShowOnlyOnAccount || this.isEligibleForOnAccount : false);
            }

            // Handle if the Password field changes
            if (this.isSelected() && changes.accountPassword) {
                var password = changes.accountPassword.currentValue;
                this.setDisableState(!password || !password.length);
            }
        }
    }]);

    return DigitalPayAccountController;
}();

DigitalPayAccountController.$inject = ['Settings', 'DigitalPayPaymentDistributionService', 'DigitalPayPaymentErrorDisplayService', 'DigitalPayDisablePaymentStateService'];

var digitalPayAccountComponentDefinition = {
    controller: DigitalPayAccountController,
    template: __webpack_require__(972).trim(),
    bindings: {
        singleSelectType: '<',
        setSingleSelectType: '&',
        onAccountPaymentAmountKey: '<',
        isShowOnlyOnAccount: '<',
        isEligibleForOnAccount: '<',
        onPasswordFieldLoaded: '&',
        accountPassword: '<',
        hasListInstrumentsError: '<',
        onPasswordReset: '&',
        shouldShowPayingAmount: '<'
    }
};

module.exports = {
    DigitalPayAccountController: DigitalPayAccountController,
    digitalPayAccountComponentDefinition: digitalPayAccountComponentDefinition
};

/***/ }),
/* 972 */
/***/ (function(module, exports) {

module.exports = "<div class\"digitalPay\">\r\n    <wow-digital-pay-toggle-button\r\n        instrument-name=\"Account\"\r\n        icon=\"iconww-PayOnAccount\"\r\n        on-click=\"$ctrl.toggleSelected()\"\r\n        is-selected=\"$ctrl.isSelected()\"\r\n        amount=\"$ctrl.getPayingAmount()\"\r\n        should-show-paying-amount=\"$ctrl.shouldShowPayingAmount\">\r\n    </wow-digital-pay-toggle-button>\r\n</div>\r\n\r\n<div ng-if=\"$ctrl.hasListInstrumentsError\" class=\"digitalPayAccount\"></div>\r\n"

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.digitalpay');

var _require = __webpack_require__(974),
    creditCardComponentDefinition = _require.creditCardComponentDefinition;

var _require2 = __webpack_require__(976),
    creditCardAddPaymentComponentDefinition = _require2.creditCardAddPaymentComponentDefinition;

var _require3 = __webpack_require__(978),
    creditCardItemInlineCvvComponentDefinition = _require3.creditCardItemInlineCvvComponentDefinition;

var _require4 = __webpack_require__(980),
    creditCardItemPaymentComponentDefinition = _require4.creditCardItemPaymentComponentDefinition;

var _require5 = __webpack_require__(982),
    creditCardCvvDialogComponentDefinition = _require5.creditCardCvvDialogComponentDefinition;

wowApp.component('wowCreditCard', creditCardComponentDefinition);
wowApp.component('wowCreditCardAddPayment', creditCardAddPaymentComponentDefinition);
wowApp.component('wowCreditCardItemInlineCvv', creditCardItemInlineCvvComponentDefinition);
wowApp.component('wowCreditCardItemPayment', creditCardItemPaymentComponentDefinition);
wowApp.component('wowCreditCardCvvDialog', creditCardCvvDialogComponentDefinition);

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CREDIT_CARD_MANAGE_MODE_ID = 'CreditCard:ManageMode';
var CREDIT_CARD_NEW_INSTRUMENT_ID = -1;

var _require = __webpack_require__(0),
    assign = _require.assign,
    each = _require.each,
    find = _require.find,
    filter = _require.filter,
    first = _require.first,
    remove = _require.remove;

var singleSelectTypes = __webpack_require__(44);

var CreditCardController = function () {
    function CreditCardController($q, settings, moveFocus, digitalPayPaymentInstrumentsService, digitalPayPaymentDistributionService, digitalPayPaymentErrorDisplayService, digitalPayErrorMessageGenerator) {
        _classCallCheck(this, CreditCardController);

        this.$q = $q;
        this.settings = settings;
        this.moveFocus = moveFocus;
        this.digitalPayPaymentInstrumentsService = digitalPayPaymentInstrumentsService;
        this.digitalPayPaymentDistributionService = digitalPayPaymentDistributionService;
        this.digitalPayPaymentErrorDisplayService = digitalPayPaymentErrorDisplayService;
        this.digitalPayErrorMessageGenerator = digitalPayErrorMessageGenerator;
    }

    _createClass(CreditCardController, [{
        key: '$onInit',
        value: function $onInit() {
            this.emptyCard = { PaymentInstrumentId: undefined };
            this.isAddNewCreditCard = false;
            this.isManageMode = false;
            this.selectedPaymentInstrumentId = undefined;
            this.creditCardStepUpTokens = [];
            this.deleteMessage = this.settings.digitalPayMessages.creditCardDeleteMessage;

            // Select the last paid credit card if the initial single select type (last transaction) was credit card (if it's not expired)
            if (this.singleSelectType === singleSelectTypes.CREDITCARD) {
                if (this.creditCards.length && !this.creditCards[0].Expired) {
                    this.selectCard(this.creditCards[0].PaymentInstrumentId);
                } else {
                    this.setSingleSelectType({ type: singleSelectTypes.NONE });
                }
            }
        }
    }, {
        key: 'showActions',
        value: function showActions() {
            return this.showAddCreditCard() || this.hasCreditCards();
        }
    }, {
        key: 'showAddCreditCard',
        value: function showAddCreditCard() {
            return !this.isManageMode && !this.isAddNewCreditCard && this.creditCards.length;
        }
    }, {
        key: 'hasCreditCards',
        value: function hasCreditCards() {
            return this.creditCards.length;
        }
    }, {
        key: 'hasValidCards',
        value: function hasValidCards() {
            return this.creditCards.length > this.getExpiredCount();
        }
    }, {
        key: 'toggleAddNewCreditCard',
        value: function toggleAddNewCreditCard() {
            this.unselectCard(false);
            this.selectCard(CREDIT_CARD_NEW_INSTRUMENT_ID);
            this.isAddNewCreditCard = !this.isAddNewCreditCard;
            if (!this.isAddNewCreditCard) {
                this.setSingleSelectType({ type: singleSelectTypes.NONE });
            }
        }
    }, {
        key: 'toggleManageMode',
        value: function toggleManageMode() {
            this.cardInEditMode = this.emptyCard;
            if (this.isManageMode) {
                // Re-enable payment when exiting Manage Mode
                this.paymentStateDefinitions.removeDisablePaymentState(CREDIT_CARD_MANAGE_MODE_ID);
                this.onInstrumentTypeInManageMode({ type: this.settings.digitalPayPaymentTypes.emptyType });
                this.isManageMode = false;
            } else {
                // Disable payment if in Manage Mode
                this.enterManageMode();
                if (this.isAddNewCreditCard) {
                    // Close the Add New Credit Panel if Manage Mode is turned on (fine to discard data in the panel)
                    this.toggleAddNewCreditCard();
                }
            }
        }
    }, {
        key: 'enterManageMode',
        value: function enterManageMode() {
            this.paymentStateDefinitions.addDisablePaymentState(CREDIT_CARD_MANAGE_MODE_ID, this.settings.digitalPayScreenReaderMessages.creditCardManageModeDisableMessage);
            this.onInstrumentTypeInManageMode({ type: this.settings.digitalPayPaymentTypes.creditCardType });
            this.isManageMode = true;
            this.isAddNewCreditCard = false;
            this.moveFocus('#digitalPayCreditCard');
        }
    }, {
        key: 'getExpiredCount',
        value: function getExpiredCount() {
            return filter(this.creditCards, function (card) {
                return card.Expired;
            }).length;
        }
    }, {
        key: 'getExpiredErrorMessage',
        value: function getExpiredErrorMessage() {
            return this.getExpiredCount() > 1 ? this.settings.digitalPayError.creditCardMultipleExpiredWarning : this.settings.digitalPayError.creditCardSingleExpiredWarning;
        }
    }, {
        key: 'toggleSelectCreditCard',
        value: function toggleSelectCreditCard(card) {
            if (this.isManageMode) {
                return;
            }

            if (card.PaymentInstrumentId === this.selectedPaymentInstrumentId) {
                // Toggle off
                this.unselectCard();
            } else {
                // Toggle on
                this.unselectCard(false);
                this.selectCard(card.PaymentInstrumentId);
            }
        }
    }, {
        key: 'removeCreditCard',
        value: function removeCreditCard(card) {
            var _this = this;

            // Confirmation Dialog is defined in the html
            this.confirmationDialog.show().then(function (dialogResponse) {
                if (!dialogResponse.success) {
                    return;
                }

                _this.digitalPayPaymentInstrumentsService.deleteDigitalPayInstrument({ paymentInstrumentId: card.PaymentInstrumentId }).then(function (response) {
                    if (response.Success) {
                        // Ensure that the card to be removed is not selected
                        if (card.PaymentInstrumentId === _this.selectedPaymentInstrumentId) {
                            _this.unselectCard();
                        }
                        remove(_this.creditCards, function (cardToDelete) {
                            return cardToDelete.PaymentInstrumentId === card.PaymentInstrumentId;
                        });
                        // When there are no non expired cards
                        if (!_this.hasCreditCards()) {
                            _this.toggleManageMode();
                        }
                        _this.refreshCreditCards();
                    } else if (response.ErrorCode === _this.settings.digitalPayErrorCodes.creditCardDeleteLinkedCardForbidden) {
                        _this.digitalPayPaymentErrorDisplayService.pushGlobalError(_this.settings.digitalPayError.creditCardDeleteLinkedCardForbiddenMessage);
                    } else {
                        _this.digitalPayPaymentErrorDisplayService.pushGlobalError(_this.settings.digitalPayError.creditCardDeleteErrorMessage);
                    }
                }).catch(function () {
                    _this.digitalPayPaymentErrorDisplayService.pushGlobalError(_this.settings.digitalPayError.creditCardDeleteErrorMessage);
                });
            });
        }
    }, {
        key: 'selectCard',
        value: function selectCard(paymentInstrumentId) {
            this.selectedPaymentInstrumentId = paymentInstrumentId;
            this.setSingleSelectType({ type: singleSelectTypes.CREDITCARD });

            // Deselect add new credit card if a different credit card gets selected
            if (paymentInstrumentId !== CREDIT_CARD_NEW_INSTRUMENT_ID) {
                this.isAddNewCreditCard = false;
            }
        }
    }, {
        key: 'unselectCard',
        value: function unselectCard() {
            var resetSingleSelectType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            if (!this.selectedPaymentInstrumentId) {
                return;
            }
            this.digitalPayPaymentDistributionService.removePayment(this.selectedPaymentInstrumentId);
            this.prePaymentActionDefinitions.removeAction(this.selectedPaymentInstrumentId);
            if (resetSingleSelectType) {
                // Suppress when switching to a different credit card for efficiency
                this.setSingleSelectType({ type: singleSelectTypes.NONE });
            }
            this.selectedPaymentInstrumentId = undefined;
        }
    }, {
        key: 'confirmDialog',
        value: function confirmDialog() {
            this.confirmationDialog.close({ success: true });
        }
    }, {
        key: 'notifyAddCardError',
        value: function notifyAddCardError(errorMessage) {
            this.addCardError = errorMessage;
        }
    }, {
        key: 'notifyUpdate',
        value: function notifyUpdate(paymentInstrumentId, stepUpToken) {
            this.creditCardStepUpTokens.push({ paymentInstrumentId: paymentInstrumentId, stepUpToken: stepUpToken });
            this.refreshCreditCards();
        }
    }, {
        key: 'notifyEditCard',
        value: function notifyEditCard(card) {
            if (!this.isManageMode) {
                this.enterManageMode();
            }
            this.cardInEditMode = card || this.emptyCard;
        }
    }, {
        key: 'notifyErroredCard',
        value: function notifyErroredCard(id) {
            this.onErroredCard(id);
        }
    }, {
        key: 'onErroredCard',
        value: function onErroredCard(id) {
            this.erroredSavedCardId = id;
            this.unselectCard();
        }
    }, {
        key: 'assignStepUpTokens',
        value: function assignStepUpTokens() {
            var _this2 = this;

            if (!this.creditCardStepUpTokens || !this.creditCardStepUpTokens.length) {
                return;
            }

            each(this.creditCardStepUpTokens, function (instrumentTokenPair) {
                var matchingCard = find(_this2.creditCards, function (card) {
                    return card.PaymentInstrumentId === instrumentTokenPair.paymentInstrumentId;
                });
                if (matchingCard) {
                    assign(matchingCard, { stepUpToken: instrumentTokenPair.stepUpToken });
                }
            });
            this.creditCardStepUpTokens = [];
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            var _this3 = this;

            if (changes.singleSelectType && changes.singleSelectType.previousValue === singleSelectTypes.CREDITCARD && changes.singleSelectType.currentValue !== singleSelectTypes.CREDITCARD) {
                // Another single select type payment method has been selected hence unselect all
                if (this.isAddNewCreditCard) {
                    this.isAddNewCreditCard = false;
                    return;
                }
                // Don't set single select type - the other payment method already does this
                this.unselectCard(false);
            }

            var currentPaymentErrorStates = changes.paymentErrorStates && changes.paymentErrorStates.currentValue || [];
            if (currentPaymentErrorStates.length) {
                // Filter all credit card errors.
                var creditCardErrorState = first(filter(currentPaymentErrorStates, function (value) {
                    var state = value.state;
                    return state.ErrorCode && state.PaymentInstrumentType === _this3.settings.digitalPayPaymentTypes.creditCardType;
                }));

                // Clear existing error states.
                this.erroredSavedCardId = undefined;
                if (creditCardErrorState) {
                    if (!this.isAddNewCreditCard && !creditCardErrorState.state.StepUp) {
                        var creditCard = find(this.creditCards, function (c) {
                            return c.PaymentInstrumentId === creditCardErrorState.state.PaymentInstrumentId;
                        });
                        if (creditCard && creditCardErrorState.state.ErrorCode === this.settings.digitalPayOrderPlacementErrorCodes.declined) {
                            this.onErroredCard(creditCardErrorState.state.PaymentInstrumentId);
                        } else if (creditCard) {
                            this.erroredSavedCardId = creditCard.PaymentInstrumentId;
                            var suffix = creditCard.CardSuffix;
                            var isSplitPayment = this.digitalPayErrorMessageGenerator.getPaymentErrorMode();
                            var messageTemplate = isSplitPayment ? this.settings.digitalPayError.creditCardSavedCardSplitPaymentFailure : this.settings.digitalPayError.creditCardSavedCardPaymentFailure;
                            var errorMessage = this.digitalPayErrorMessageGenerator.formatErrorMessage(messageTemplate, [suffix]);
                            this.digitalPayPaymentErrorDisplayService.pushToPaymentErrorBreakdown(errorMessage);
                            this.unselectCard();
                        }
                    }
                } else {
                    // clean up just for readability.
                    this.erroredSavedCardId = undefined;
                }
            } else if (changes.paymentErrorStates) {
                // Clear existing error states.
                this.erroredSavedCardId = undefined;
            }
            if (changes.creditCards) {
                this.assignStepUpTokens();
            }
        }
    }]);

    return CreditCardController;
}();

CreditCardController.$inject = ['$q', 'Settings', 'MoveFocus', 'DigitalPayPaymentInstrumentsService', 'DigitalPayPaymentDistributionService', 'DigitalPayPaymentErrorDisplayService', 'DigitalPayErrorMessageGenerator'];

var creditCardComponentDefinition = {
    controller: CreditCardController,
    template: __webpack_require__(975).trim(),
    bindings: {
        allowedNetworks: '<',
        creditCards: '<',
        hasPrePaymentActionFailures: '<',
        isImpersonated: '<',
        isSavingCard: '<',
        onInstrumentTypeInManageMode: '&',
        paymentErrorStates: '<',
        paymentStateDefinitions: '<',
        prePaymentActionDefinitions: '<',
        refreshCreditCards: '&?', // Used in the view
        setSingleSelectType: '&',
        shouldRemoveNewlyAddedInstruments: '<',
        shouldShowPayingAmount: '<',
        shouldShowSave: '<',
        singleSelectType: '<' // Watch using $onChanges
    }
};

module.exports = {
    CreditCardController: CreditCardController,
    creditCardComponentDefinition: creditCardComponentDefinition
};

/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports = "<div class=\"digitalPay\" ng-if=\"!$ctrl.loadingList\" tabindex=\"-1\" id=\"digitalPayCreditCard\">\r\n    <!-- Toggle Button -->\r\n    <wow-digital-pay-toggle-button\r\n        ng-if=\"!$ctrl.creditCards.length\"\r\n        instrument-name=\"Credit Card\"\r\n        icon=\"iconww-PayCreditCard\"\r\n        is-select-button=\"true\"\r\n        is-not-bottom=\"$ctrl.isAddNewCreditCard\"\r\n        on-click=\"$ctrl.toggleAddNewCreditCard()\"\r\n        should-show-paying-amount=\"$ctrl.shouldShowPayingAmount\">\r\n    </wow-digital-pay-toggle-button>\r\n\r\n    <!-- Expired Cards -->\r\n    <div ng-if=\"$ctrl.getExpiredCount()\" class=\"creditCard-errorSpacer\">\r\n        <wow-digital-pay-error-display error-message=\"$ctrl.getExpiredErrorMessage()\" is-on-top=\"true\"></wow-digital-pay-error-display>\r\n        <ul class=\"digitalPayContainer-list digitalPayContainer-list--error giftCard-errorList notTop\">\r\n            <li ng-repeat=\"expiredCard in $ctrl.creditCards | filter:{Expired: true}\">\r\n                <wow-credit-card-item-payment\r\n                    card=\"expiredCard\"\r\n                    card-in-edit-mode=\"$ctrl.cardInEditMode\"\r\n                    payment-state-definitions=\"$ctrl.paymentStateDefinitions\"\r\n                    pre-payment-action-definitions=\"$ctrl.prePaymentActionDefinitions\"\r\n                    payment-error-states=\"$ctrl.paymentErrorStates\"\r\n                    is-manage-mode=\"$ctrl.isManageMode\"\r\n                    on-iframe-expire=\"$ctrl.refreshCreditCards()\"\r\n                    on-remove=\"$ctrl.removeCreditCard(expiredCard)\"\r\n                    on-update=\"$ctrl.notifyUpdate(paymentInstrumentId, stepUpToken)\"\r\n                    on-edit=\"$ctrl.notifyEditCard(card)\">\r\n                </wow-credit-card-item-payment>\r\n            </li>\r\n        </ul>\r\n    </div>\r\n\r\n    <!-- All other cards -->\r\n    <ul class=\"digitalPayContainer-list digitalPayContainer-list--selectable digitalPayContainer-list--errorable notBottom\">\r\n        <li ng-repeat=\"card in $ctrl.creditCards | filter:{Expired: false}\" ng-class=\"{'selected': !$ctrl.isManageMode && card.PaymentInstrumentId === $ctrl.selectedPaymentInstrumentId, 'errored': $ctrl.erroredSavedCardId === card.PaymentInstrumentId}\">\r\n            <wow-credit-card-item-payment\r\n                card=\"card\"\r\n                payment-state-definitions=\"$ctrl.paymentStateDefinitions\"\r\n                pre-payment-action-definitions=\"$ctrl.prePaymentActionDefinitions\"\r\n                payment-error-states=\"$ctrl.paymentErrorStates\"\r\n                refresh-credit-cards=\"$ctrl.refreshCreditCards()\"\r\n                is-manage-mode=\"$ctrl.isManageMode\"\r\n                is-selected=\"card.PaymentInstrumentId === $ctrl.selectedPaymentInstrumentId\"\r\n                is-select-enabled=\"true\"\r\n                on-iframe-expire=\"$ctrl.refreshCreditCards()\"\r\n                on-remove=\"$ctrl.removeCreditCard(card)\"\r\n                on-select=\"$ctrl.toggleSelectCreditCard(card)\"\r\n                on-error=\"$ctrl.notifyErroredCard(id)\"\r\n                should-show-paying-amount=\"$ctrl.shouldShowPayingAmount\">\r\n            </wow-credit-card-item-payment>\r\n        </li>\r\n    </ul>\r\n\r\n    <!-- Add Credit Card -->\r\n    <div ng-if=\"$ctrl.isAddNewCreditCard && !$ctrl.isManageMode\">\r\n        <wow-digital-pay-error-display error-message=\"$ctrl.addCardError\"></wow-digital-pay-error-display>\r\n        <div\r\n            class=\"creditCard-addContainer\"\r\n            ng-class=\"{'notTop': !$ctrl.creditCards.length || $ctrl.hasValidCards(), 'notBottom': $ctrl.showActions()}\">\r\n            <wow-credit-card-add-payment\r\n                allowed-networks=\"$ctrl.allowedNetworks\"\r\n                payment-state-definitions=\"$ctrl.paymentStateDefinitions\"\r\n                pre-payment-action-definitions=\"$ctrl.prePaymentActionDefinitions\"\r\n                on-add-card-error=\"$ctrl.notifyAddCardError(errorMessage)\"\r\n                has-pre-payment-action-failures=\"$ctrl.hasPrePaymentActionFailures\"\r\n                is-impersonated=\"$ctrl.isImpersonated\"\r\n                is-saving-card=\"$ctrl.isSavingCard\"\r\n                should-remove-newly-added-instruments=\"$ctrl.shouldRemoveNewlyAddedInstruments\"\r\n                should-show-paying-amount=\"$ctrl.shouldShowPayingAmount\"\r\n                should-show-save=\"$ctrl.shouldShowSave\">\r\n            </wow-credit-card-add-payment>\r\n        </div>\r\n    </div>\r\n\r\n    <!-- Action Bar -->\r\n    <div\r\n        ng-if=\"$ctrl.showActions()\"\r\n        class=\"digitalPayActions-container\"\r\n        ng-class=\"{'notTop': $ctrl.creditCards.length === $ctrl.creditCards.getExpiredCount() || $ctrl.hasValidCards()}\">\r\n        <button\r\n            wow-digital-pay-button\r\n            class=\"dpLinkButton\"\r\n            ng-click=\"$ctrl.toggleAddNewCreditCard()\"\r\n            ng-if=\"$ctrl.showAddCreditCard()\"\r\n            type=\"button\">\r\n            Add credit card\r\n        </button>\r\n        <button\r\n            wow-digital-pay-button\r\n            class=\"dpLinkButton\"\r\n            ng-click=\"$ctrl.toggleManageMode()\"\r\n            ng-if=\"$ctrl.hasValidCards() && !$ctrl.isManageMode\"\r\n            type=\"button\">\r\n            Manage credit cards\r\n        </button>\r\n        <button\r\n            wow-digital-pay-button\r\n            class=\"dpLinkButton\"\r\n            ng-click=\"$ctrl.toggleManageMode()\"\r\n            ng-if=\"$ctrl.isManageMode\"\r\n            type=\"button\">\r\n            Done\r\n        </button>\r\n    </div>\r\n</div>\r\n\r\n<wow-digital-pay-confirmation-dialog\r\n    dialog-name=\"'delete card dialog'\"\r\n    dialog=\"$ctrl.confirmationDialog\"\r\n    message=\"::$ctrl.deleteMessage\">\r\n        <div class=\"dpFooter-container\">\r\n            <button oly-dialog-close class=\"button dpFooter-button\">\r\n                <i class=\"iconww-ArrowLeft dpFooter-iconLeftButton\"/>Cancel\r\n            </button>\r\n            <button class=\"button button--primary dpFooter-button--primary\" ng-click=\"$ctrl.confirmDialog()\">\r\n                Delete<i class=\"iconww-ArrowRight dpFooter-iconRightButton\"/>\r\n            </button>\r\n        </div>\r\n</wow-digital-pay-confirmation-dialog>\r\n"

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreditCardAddBaseController = __webpack_require__(42).CreditCardAddBaseController;

var CreditCardAddPaymentController = function (_CreditCardAddBaseCon) {
    _inherits(CreditCardAddPaymentController, _CreditCardAddBaseCon);

    function CreditCardAddPaymentController($element, $sce, $q, $timeout, settings, digitalPayPaymentInstrumentsService, digitalPayIframeEventHandler, digitalPayPaymentDistributionService, digitalPayPaymentErrorDisplayService, digitalPayErrorMessageGenerator, digitalPayFormValidator) {
        _classCallCheck(this, CreditCardAddPaymentController);

        var _this = _possibleConstructorReturn(this, (CreditCardAddPaymentController.__proto__ || Object.getPrototypeOf(CreditCardAddPaymentController)).call(this, $element, $sce, $timeout, settings, digitalPayPaymentInstrumentsService, digitalPayIframeEventHandler));

        _this.$q = $q;
        _this.$timeout = $timeout;
        _this.settings = settings;
        _this.paymentDistributionService = digitalPayPaymentDistributionService;
        _this.digitalPayPaymentErrorDisplayService = digitalPayPaymentErrorDisplayService;
        _this.digitalPayErrorMessageGenerator = digitalPayErrorMessageGenerator;
        _this.digitalPayFormValidator = digitalPayFormValidator;
        _this.AddCreditCardId = _this.paymentDistributionService.AddCreditCardId;
        return _this;
    }

    _createClass(CreditCardAddPaymentController, [{
        key: '$onInit',
        value: function $onInit() {
            _get(CreditCardAddPaymentController.prototype.__proto__ || Object.getPrototypeOf(CreditCardAddPaymentController.prototype), '$onInit', this).call(this);
            this.creditCardTypes = this.settings.digitalPayCreditCardNetworks;
            this.errorMessage = this.settings.digitalPayError.creditCardAddCaptureFormLoadFailure;
            this.resetPromise();
            // Execute the promise (get instrument id) before payment, disable place order button, set credit card to take rest of payment
            this.prePaymentActionDefinitions.addAction(this.AddCreditCardId, this.submitCreditCardIframe.bind(this));
            this.paymentStateDefinitions.addDisablePaymentState(this.AddCreditCardId, this.settings.digitalPayScreenReaderMessages.creditCardAddDisableMessage);
            this.paymentDistributionService.addPaymentInFull(this.AddCreditCardId);
            this.isImpersonated = false;
            this.isBlank = true;
            this.payFrameIsValid = false;
        }

        /**
         * Implies that user no longer wants to make a payment using a new credit card, remove all related hooks
         */

    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.prePaymentActionDefinitions.removeAction(this.AddCreditCardId);
            this.paymentStateDefinitions.removeDisablePaymentState(this.AddCreditCardId);
            this.paymentDistributionService.removePayment(this.AddCreditCardId);
            this.resetErrorDisplayTimeouts();
            // Clear the error message when add card is closed
            this.onAddCardError({});
            _get(CreditCardAddPaymentController.prototype.__proto__ || Object.getPrototypeOf(CreditCardAddPaymentController.prototype), '$onDestroy', this).call(this);
        }
    }, {
        key: 'getPayingAmount',
        value: function getPayingAmount() {
            var amount = this.paymentDistributionService.getPayment(this.AddCreditCardId);

            // Allow payment if the credit card add form is blank and it's $0 or if iframe is valid
            if (this.isBlank && amount === 0 || this.payFrameIsValid) {
                this.paymentStateDefinitions.removeDisablePaymentState(this.AddCreditCardId);
            } else {
                this.paymentStateDefinitions.addDisablePaymentState(this.AddCreditCardId, this.settings.digitalPayScreenReaderMessages.creditCardAddDisableMessage);
            }

            return amount;
        }
    }, {
        key: 'payFrameError',
        value: function payFrameError(response) {
            if (this.isBlank) {
                this.submitIframeDeferred.resolve();
            }

            _get(CreditCardAddPaymentController.prototype.__proto__ || Object.getPrototypeOf(CreditCardAddPaymentController.prototype), 'payFrameError', this).call(this, response);

            var globalError = '';
            var contextualError = '';
            // If form has expired, show ONLY a contextual error. Otherwise, show ONLY a global error.
            if (response.code === this.settings.digitalPayErrorCodes.creditCardCaptureFormExpired) {
                contextualError = this.settings.digitalPayError.creditCardAddCaptureFormExpiryFailure;
            } else {
                globalError = this.digitalPayErrorMessageGenerator.getNewCreditCardPaymentError(this.isSavingCard);
            }

            this.submitIframeDeferred.reject({ errorMessage: globalError });
            this.resetCardCapture();
            this.invokeAddCardError(contextualError);
        }
    }, {
        key: 'payFrameSuccess',
        value: function payFrameSuccess(response) {
            var _this2 = this;

            _get(CreditCardAddPaymentController.prototype.__proto__ || Object.getPrototypeOf(CreditCardAddPaymentController.prototype), 'payFrameSuccess', this).call(this, response);
            this.submitIframeDeferred.resolve({
                paymentInstrumentId: response.paymentInstrumentId,
                amount: this.getPayingAmount(),
                stepUpToken: response.stepUpToken
            });

            this.$timeout(function () {
                if (_this2.hasPrePaymentActionFailures) {
                    _this2.digitalPayPaymentInstrumentsService.deleteDigitalPayInstrument({ paymentInstrumentId: response.paymentInstrumentId });
                    _this2.resetCardCapture();
                }
            });

            this.newCardPaymentInstrumentId = response.paymentInstrumentId;
        }
    }, {
        key: 'payFrameValid',
        value: function payFrameValid() {
            var _this3 = this;

            _get(CreditCardAddPaymentController.prototype.__proto__ || Object.getPrototypeOf(CreditCardAddPaymentController.prototype), 'payFrameValid', this).call(this);
            this.payFrameIsValid = true;
            this.$timeout(function () {
                _this3.paymentStateDefinitions.removeDisablePaymentState(_this3.AddCreditCardId);
            });
            this.clearValidationState();
        }
    }, {
        key: 'payFrameInvalid',
        value: function payFrameInvalid() {
            var _this4 = this;

            _get(CreditCardAddPaymentController.prototype.__proto__ || Object.getPrototypeOf(CreditCardAddPaymentController.prototype), 'payFrameInvalid', this).call(this);
            this.payFrameIsValid = false;
            this.$timeout(function () {
                _this4.paymentStateDefinitions.addDisablePaymentState(_this4.AddCreditCardId, _this4.settings.digitalPayScreenReaderMessages.creditCardAddDisableMessage);
            });
        }
    }, {
        key: 'payFrameFocusGain',
        value: function payFrameFocusGain(response) {
            if (this.focusLostObject === undefined) {
                return;
            }
            this.digitalPayPaymentErrorDisplayService.clearGlobalError();

            var errorMessage = this.digitalPayFormValidator.getAddNewCreditCardValidationError(this.focusLostObject, response.field);
            this.focusLostInvalidFieldsTimeoutPromise = this.invokeAddCardError(errorMessage);

            // Stop the missing fields message from displaying if focus on form is gained
            this.$timeout.cancel(this.focusLostBlankFieldsTimeoutPromise);
            this.focusLostBlankFieldsTimeoutPromise = undefined;
        }
    }, {
        key: 'payFrameFocusLost',
        value: function payFrameFocusLost(response) {
            if (response.allFieldsEmpty) {
                this.isBlank = true;
                this.clearValidationState();
                return;
            }

            this.isBlank = false;
            this.focusLostObject = response;

            var errorMessage = this.digitalPayFormValidator.getAddNewCreditCardValidationError(this.focusLostObject);
            this.focusLostInvalidFieldsTimeoutPromise = this.invokeAddCardError(errorMessage);

            // If the user moves away from the form, we display a missing fields message instead.
            // This is cancelled if the user focuses on the form immediately after moving away (e.g. tab from one field to another)
            if (this.hasBlankFields(this.focusLostObject)) {
                this.focusLostBlankFieldsTimeoutPromise = this.invokeAddCardError(this.settings.digitalPayError.creditCardFieldsMissingErrorsMessage);
            }
        }

        /**
         * @override
         */

    }, {
        key: 'invokeAddCardError',
        value: function invokeAddCardError(errorMessage) {
            var _this5 = this;

            // Timeout exists here because we want to delay the error message appearing as a workaround for the UI design
            return this.$timeout(function () {
                _this5.onAddCardError({ errorMessage: errorMessage });
            }, this.settings.digitalPay.formFocusOutTimeoutMilliseconds);
        }
    }, {
        key: 'hasBlankFields',
        value: function hasBlankFields(response) {
            return response.cardValid === null || response.expiryMonthValid === null || response.expiryYearValid === null || response.cvvValid === null;
        }
    }, {
        key: 'clearValidationState',
        value: function clearValidationState() {
            this.focusLostObject = undefined;
            this.invokeAddCardError('');
        }
    }, {
        key: 'submitCreditCardIframe',
        value: function submitCreditCardIframe() {
            this.submitIframe(); // Call from base
            return this.submitIframeDeferred.promise;
        }
    }, {
        key: 'resetPromise',
        value: function resetPromise() {
            // Reset promise (for next time)
            this.submitIframeDeferred = this.$q.defer();
        }
    }, {
        key: 'resetCardCapture',
        value: function resetCardCapture() {
            // Reset promise (for next time)
            this.resetPromise();
            this.clearIframeContents();
            this.setupIframe();
        }
    }, {
        key: 'clearForm',
        value: function clearForm() {
            this.resetErrorDisplayTimeouts();
            this.clearIframeContents();
        }
    }, {
        key: 'clearIframeContents',
        value: function clearIframeContents() {
            _get(CreditCardAddPaymentController.prototype.__proto__ || Object.getPrototypeOf(CreditCardAddPaymentController.prototype), 'clearIframeContents', this).call(this);
            this.isBlank = true;
        }
    }, {
        key: 'resetErrorDisplayTimeouts',
        value: function resetErrorDisplayTimeouts() {
            this.$timeout.cancel(this.focusLostBlankFieldsTimeoutPromise);
            this.$timeout.cancel(this.focusLostInvalidFieldsTimeoutPromise);
            this.focusLostBlankFieldsTimeoutPromise = undefined;
            this.focusLostInvalidFieldsTimeoutPromise = undefined;
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.shouldRemoveNewlyAddedInstruments && changes.shouldRemoveNewlyAddedInstruments.currentValue) {
                if (this.isSavingCard) {
                    this.digitalPayPaymentInstrumentsService.deleteDigitalPayInstrument({ paymentInstrumentId: this.newCardPaymentInstrumentId });
                }

                if (changes.hasPrePaymentValidationFailure && changes.hasPrePaymentValidationFailure.currentValue) {
                    var errorMessage = this.digitalPayErrorMessageGenerator.getNewCreditCardPaymentError(this.isSavingCard);
                    this.digitalPayPaymentErrorDisplayService.pushToPaymentErrorBreakdown(errorMessage);
                }

                this.resetCardCapture();
            }
        }
    }]);

    return CreditCardAddPaymentController;
}(CreditCardAddBaseController);

CreditCardAddPaymentController.$inject = ['$element', '$sce', '$q', '$timeout', 'Settings', 'DigitalPayPaymentInstrumentsService', 'DigitalPayIframeEventHandler', 'DigitalPayPaymentDistributionService', 'DigitalPayPaymentErrorDisplayService', 'DigitalPayErrorMessageGenerator', 'DigitalPayFormValidator'];

var creditCardAddPaymentComponentDefinition = {
    controller: CreditCardAddPaymentController,
    template: __webpack_require__(977).trim(),
    bindings: {
        allowedNetworks: '<',
        hasPrePaymentActionFailures: '<',
        isImpersonated: '<',
        isSavingCard: '<',
        onAddCardError: '&',
        paymentStateDefinitions: '<',
        prePaymentActionDefinitions: '<',
        shouldRemoveNewlyAddedInstruments: '<',
        shouldShowPayingAmount: '<',
        shouldShowSave: '<'
    }
};

module.exports = {
    CreditCardAddPaymentController: CreditCardAddPaymentController,
    creditCardAddPaymentComponentDefinition: creditCardAddPaymentComponentDefinition
};

/***/ }),
/* 977 */
/***/ (function(module, exports) {

module.exports = "<ng-form name=\"$ctrl.creditCardAddPaymentForm\">\r\n    <wow-loading-spinner\r\n        ng-if=\"$ctrl.isLoading\"\r\n        message=\"Loading Credit Card Form, please wait\"\r\n        is-message-sr-only=\"true\">\r\n    </wow-loading-spinner>\r\n    <span ng-if=\"!$ctrl.isLoading\" class=\"sr-only\" role=\"alert\">Credit Card Form Ready</span>\r\n\r\n    <div ng-if=\"!$ctrl.isLoading && $ctrl.isIframeLoadedSuccess && $ctrl.shouldShowPayingAmount\">\r\n        <wow-staged-amount-display paying-amount=\"$ctrl.getPayingAmount()\" show-description=\"true\"></wow-staged-amount-display>\r\n    </div>\r\n\r\n    <!-- ng-hide as we want to at least attempt to load the iframe to get the loaded event -->\r\n    <iframe\r\n        id=\"{{::$ctrl.iframeId}}\"\r\n        ng-hide=\"$ctrl.isLoading || !$ctrl.isIframeLoadedSuccess\"\r\n        class=\"creditCardAdd-iframe\"\r\n        scrolling=\"no\"\r\n        ng-src=\"{{$ctrl.iframeUrl}}\">\r\n    </iframe>\r\n\r\n    <div ng-if=\"!$ctrl.isLoading && $ctrl.isIframeLoadedSuccess\">\r\n        <div class=\"creditCardAdd-actions\">\r\n            <input\r\n                ng-if=\"$ctrl.shouldShowSave\"\r\n                type=\"checkbox\"\r\n                id=\"save-card-checkbox\"\r\n                class=\"wowCheckbox digitalPay-checkbox\"\r\n                ng-model=\"$ctrl.isSavingCard\"/>\r\n            <label ng-if=\"$ctrl.shouldShowSave\" for=\"save-card-checkbox\">Save card for later</label>\r\n            <button class=\"dpLinkButton\" type=\"button\" ng-click=\"$ctrl.clearForm()\">Clear Form</button>\r\n        </div>\r\n\r\n        <div class=\"creditCardAdd-acceptedPaymentsContainer\">\r\n            <img\r\n                ng-if=\"$ctrl.isNetworkAllowed($ctrl.creditCardTypes.visa)\"\r\n                class=\"creditCardAdd-acceptedPaymentsIcon\"\r\n                src=\"/images/checkout/digitalpay/icon-method-visa.svg\"\r\n                alt=\"Visa\"\r\n                title=\"Visa\"/>\r\n            <img\r\n                ng-if=\"$ctrl.isNetworkAllowed($ctrl.creditCardTypes.mastercard)\"\r\n                class=\"creditCardAdd-acceptedPaymentsIcon\"\r\n                src=\"/images/checkout/digitalpay/icon-method-mastercard.svg\"\r\n                alt=\"MasterCard\"\r\n                title=\"MasterCard\"/>\r\n            <img\r\n                ng-if=\"$ctrl.isNetworkAllowed($ctrl.creditCardTypes.americanexpress)\"\r\n                class=\"creditCardAdd-acceptedPaymentsIcon\"\r\n                src=\"/images/checkout/digitalpay/icon-method-amex.svg\"\r\n                alt=\"American Express\"\r\n                title=\"American Express\"/>\r\n            <img\r\n                ng-if=\"$ctrl.isNetworkAllowed($ctrl.creditCardTypes.diners)\"\r\n                class=\"creditCardAdd-acceptedPaymentsIcon\"\r\n                src=\"/images/checkout/digitalpay/icon-method-diners.svg\"\r\n                alt=\"Diners Club International\"\r\n                title=\"Diners Club International\"/>\r\n        </div>\r\n    </div>\r\n\r\n    <div ng-if=\"!$ctrl.isLoading && !$ctrl.isIframeLoadedSuccess\" class=\"creditCardAdd-errorContainer\">\r\n        <wow-error-page\r\n            icon=\"iconww-Info\"\r\n            show-icon=\"true\"\r\n            message=\"{{$ctrl.errorMessage}}\"\r\n            page-class=\"creditCardAdd-errorPage\"\r\n            message-class=\"creditCardAdd-errorMessage\">\r\n        </wow-error-page>\r\n        <button class=\"dpLinkButton\" type=\"button\" ng-click=\"$ctrl.setupIframe()\">Reload form</button>\r\n    </div>\r\n</ng-form>\r\n"

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CREDIT_CARD_ITEM_CVV_ID = 'CreditCardValidateCvv';

var _require = __webpack_require__(0),
    find = _require.find,
    replace = _require.replace;

var CreditCardItemInlineCvvController = function () {
    function CreditCardItemInlineCvvController($element, $sce, $timeout, $q, settings, digitalPayPaymentErrorDisplayService, digitalPayErrorMessageGenerator, digitalPayIframeEventHandler) {
        _classCallCheck(this, CreditCardItemInlineCvvController);

        this.$element = $element;
        this.$sce = $sce;
        this.$timeout = $timeout;
        this.$q = $q;
        this.settings = settings;
        this.digitalPayPaymentErrorDisplayService = digitalPayPaymentErrorDisplayService;
        this.digitalPayErrorMessageGenerator = digitalPayErrorMessageGenerator;
        this.digitalPayIframeEventHandler = digitalPayIframeEventHandler;
    }

    _createClass(CreditCardItemInlineCvvController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.uniqueId = '' + CREDIT_CARD_ITEM_CVV_ID + this.card.PaymentInstrumentId;
            this.creditCardItemCvvDisableMessage = replace(this.settings.digitalPayScreenReaderMessages.creditCardCvvDisableMessage, '{0}', this.card.CardSuffix);
            this.timeoutPeriodInMillseconds = this.settings.digitalPay.inlineCvvIframeTimeoutInMilliseconds;
            this.isLoading = false;
            this.hasLoaded = false;
            this.hasIframeFailed = false;
            this.resolvedSuccessResponse = {};
            this.isValid = false;
            this.resetPromise();
            this.setupListenerCallbacks();
            this.registerEventListeners();
            this.setupIframe();

            // Execute the promise (validate the CVV) before payment, disable place order button
            this.prePaymentActionDefinitions.addAction(this.uniqueId, this.submitVerifyCvv.bind(this));
            this.paymentStateDefinitions.addDisablePaymentState(this.uniqueId, this.creditCardItemCvvDisableMessage);

            // Delay the loading spinner by the timeout period - so it only shows when it's not going to load in time
            this.$timeout(function () {
                if (!_this.hasLoaded) {
                    _this.isLoading = true;
                }
            }, this.settings.digitalPay.inlineCvvIframeSpinnerDelayInMilliseconds);
        }

        /**
         * Implies that the user no longer wants to make a payment using this particular credit card, remove all related hooks
         */

    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.prePaymentActionDefinitions.removeAction(this.uniqueId);
            this.paymentStateDefinitions.removeDisablePaymentState(this.uniqueId);
            this.disposeEventListeners();
            this.digitalPayIframeEventHandler.releaseIframeControl(this.uniqueId);
        }
    }, {
        key: 'setupListenerCallbacks',
        value: function setupListenerCallbacks() {
            var _this2 = this;

            this.payFrameLoadedCallback = function () {
                _this2.$timeout(function () {
                    _this2.hasLoaded = true;
                    _this2.isLoading = false;

                    // Cancel the timer and let the view know the iframe was successfully loaded
                    _this2.$timeout.cancel(_this2.iframeLoadTimeoutPromise);
                });
            };

            this.payFrameErrorCallback = function (response) {
                if (response.code === _this2.settings.digitalPayErrorCodes.creditCardIframeSucceededPreviously || response.code === _this2.settings.digitalPayErrorCodes.creditCardCaptureFormExpired || response.code === _this2.settings.digitalPayErrorCodes.creditCardIframeUnableToProcessRequest) {
                    _this2.paymentStateDefinitions.removeDisablePaymentState(_this2.uniqueId);
                    _this2.submitIframeDeferred.resolve(_this2.resolvedSuccessResponse);
                    _this2.refreshCreditCards();
                    _this2.resetPromise();
                    return;
                } else if (response.code === _this2.settings.digitalPayErrorCodes.paymentInstrumentNotFound || response.code === _this2.settings.digitalPayErrorCodes.creditCardCaptureFormAuthentication) {
                    _this2.refreshCreditCards();
                }

                // Any error responses from this point need to be treated as a payment error
                var suffix = _this2.card.CardSuffix;
                var isSplitPayment = _this2.digitalPayErrorMessageGenerator.getPaymentErrorMode();
                var messageTemplate = isSplitPayment ? _this2.settings.digitalPayError.creditCardSavedCardSplitPaymentFailure : _this2.settings.digitalPayError.creditCardSavedCardPaymentFailure;
                var errorMessage = _this2.digitalPayErrorMessageGenerator.formatErrorMessage(messageTemplate, [suffix]);

                _this2.digitalPayPaymentErrorDisplayService.pushToPaymentErrorBreakdown(errorMessage);
                _this2.submitIframeDeferred.reject({ id: _this2.uniqueId, errorMessage: errorMessage });
                _this2.onErroredCvv({ id: _this2.card.PaymentInstrumentId });
                _this2.resetPromise();
            };

            this.payFrameSuccessCallback = function (response) {
                _this2.resolvedSuccessResponse = {
                    paymentInstrumentId: response.paymentInstrumentId,
                    stepUpToken: response.stepUpToken
                };

                _this2.submitIframeDeferred.resolve(_this2.resolvedSuccessResponse);
                _this2.resetPromise();
            };

            this.payFrameValidCallback = function () {
                _this2.$timeout(function () {
                    _this2.isValid = true;
                    _this2.paymentStateDefinitions.removeDisablePaymentState(_this2.uniqueId);
                    if (_this2.onValidCvv) {
                        _this2.onValidCvv();
                    }
                });
            };

            this.payFrameInvalidCallback = function () {
                _this2.$timeout(function () {
                    _this2.isValid = false;
                    _this2.paymentStateDefinitions.addDisablePaymentState(_this2.uniqueId, _this2.creditCardItemCvvDisableMessage);
                });
            };

            this.payFrameFocusGainCallback = function () {
                _this2.$timeout(function () {
                    _this2.digitalPayPaymentErrorDisplayService.clearGlobalError();
                    if (_this2.onCvvFocus) {
                        _this2.onCvvFocus();
                    }
                });
            };

            this.payFrameFocusLostCallback = function (response) {
                _this2.$timeout(function () {
                    if (_this2.isValid || response.allFieldsEmpty) {
                        _this2.onValidCvv();
                    } else {
                        _this2.onInvalidCvv();
                    }
                });
            };
        }
    }, {
        key: 'registerEventListeners',
        value: function registerEventListeners() {
            this.digitalPayIframeEventHandler.on('pay-frame-loaded', this.payFrameLoadedCallback, this.uniqueId);
            this.digitalPayIframeEventHandler.on('pay-frame-error', this.payFrameErrorCallback, this.uniqueId);
            this.digitalPayIframeEventHandler.on('pay-frame-success', this.payFrameSuccessCallback, this.uniqueId);
            this.digitalPayIframeEventHandler.on('pay-frame-valid', this.payFrameValidCallback, this.uniqueId);
            this.digitalPayIframeEventHandler.on('pay-frame-invalid', this.payFrameInvalidCallback, this.uniqueId);
            this.digitalPayIframeEventHandler.on('pay-frame-focus-gain', this.payFrameFocusGainCallback, this.uniqueId);
            this.digitalPayIframeEventHandler.on('pay-frame-focus-lost', this.payFrameFocusLostCallback, this.uniqueId);
        }
    }, {
        key: 'disposeEventListeners',
        value: function disposeEventListeners() {
            this.digitalPayIframeEventHandler.off('pay-frame-loaded', this.payFrameLoadedCallback);
            this.digitalPayIframeEventHandler.off('pay-frame-error', this.payFrameErrorCallback);
            this.digitalPayIframeEventHandler.off('pay-frame-success', this.payFrameSuccessCallback);
            this.digitalPayIframeEventHandler.off('pay-frame-valid', this.payFrameValidCallback);
            this.digitalPayIframeEventHandler.off('pay-frame-invalid', this.payFrameInvalidCallback);
            this.digitalPayIframeEventHandler.off('pay-frame-focus-gain', this.payFrameFocusGainCallback);
            this.digitalPayIframeEventHandler.off('pay-frame-focus-lost', this.payFrameFocusLostCallback);
        }
    }, {
        key: 'resetPromise',
        value: function resetPromise() {
            // Reset promise (for next time)
            this.submitIframeDeferred = this.$q.defer();
        }
    }, {
        key: 'submitVerifyCvv',
        value: function submitVerifyCvv() {
            this.digitalPayIframeEventHandler.emit(this.$element.find('#' + this.uniqueId)[0], { eventId: 'pay-frame-submit' });
            this.digitalPayIframeEventHandler.setIframeControl(this.uniqueId);
            return this.submitIframeDeferred.promise;
        }
    }, {
        key: 'setupIframe',
        value: function setupIframe() {
            var _this3 = this;

            var suppressTimer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            this.iframeUrl = this.$sce.trustAsResourceUrl(this.card.StepUp.Url);

            // Setup a timer to wait for the iframe to load
            if (!suppressTimer) {
                this.iframeLoadTimeoutPromise = this.$timeout(function () {
                    _this3.hasIframeFailed = true;
                    _this3.setHasLoadFailure();
                }, this.timeoutPeriodInMillseconds);
            }
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            var _this4 = this;

            // Error handling
            if (changes.paymentErrorStates && changes.paymentErrorStates.currentValue && changes.paymentErrorStates.currentValue.length) {
                var creditCardError = find(changes.paymentErrorStates.currentValue, function (error) {
                    return error.state.PaymentInstrumentType === _this4.settings.digitalPayPaymentTypes.creditCardType && error.state.PaymentInstrumentId === _this4.card.PaymentInstrumentId;
                });

                // Step-up token update url
                if (creditCardError && creditCardError.state.ErrorCode === this.settings.digitalPayErrorCodes.creditCardStepUpTokenRequired) {
                    this.card.StepUp = creditCardError.state.StepUp;
                    // We must suppress the timeout timer as the iframe url comes from the cvv dialog (which disables all other iframe events)
                    // This has a possible edge case where this iframe fails to load
                    this.setupIframe(true);
                }
            }
        }
    }]);

    return CreditCardItemInlineCvvController;
}();

CreditCardItemInlineCvvController.$inject = ['$element', '$sce', '$timeout', '$q', 'Settings', 'DigitalPayPaymentErrorDisplayService', 'DigitalPayErrorMessageGenerator', 'DigitalPayIframeEventHandler'];

var creditCardItemInlineCvvComponentDefinition = {
    controller: CreditCardItemInlineCvvController,
    template: __webpack_require__(979).trim(),
    bindings: {
        card: '<',
        paymentErrorStates: '<',
        prePaymentActionDefinitions: '<',
        paymentStateDefinitions: '<',
        setHasLoadFailure: '&',
        refreshCreditCards: '&',
        onInvalidCvv: '&?',
        onValidCvv: '&?',
        onCvvFocus: '&?',
        onErroredCvv: '&'
    }
};

module.exports = {
    CreditCardItemInlineCvvController: CreditCardItemInlineCvvController,
    creditCardItemInlineCvvComponentDefinition: creditCardItemInlineCvvComponentDefinition
};

/***/ }),
/* 979 */
/***/ (function(module, exports) {

module.exports = "<div class=\"creditCardItemInlineCvv\">\r\n    <wow-loading-spinner ng-if=\"$ctrl.isLoading && !$ctrl.hasIframeFailed\" custom-spinner-class=\"creditCardItemInlineCvv-spinner\"></wow-loading-spinner>\r\n    <iframe\r\n        id=\"{{$ctrl.uniqueId}}\"\r\n        ng-show=\"$ctrl.hasLoaded\"\r\n        class=\"creditCardItemInlineCvv-iframe\"\r\n        ng-src=\"{{$ctrl.iframeUrl}}\"\r\n        title=\"CVV for card ending in {{ $ctrl.card.CardSuffix }}\">\r\n    </iframe>\r\n</div>\r\n"

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CreditCardItemPaymentController = function () {
    function CreditCardItemPaymentController($q, settings, digitalPayPaymentDistributionService) {
        _classCallCheck(this, CreditCardItemPaymentController);

        this.$q = $q;
        this.settings = settings;
        this.digitalPayPaymentDistributionService = digitalPayPaymentDistributionService;
        if (!this.onError) {
            this.onError = function () {};
        }
    }

    _createClass(CreditCardItemPaymentController, [{
        key: '$onInit',
        value: function $onInit() {
            this.hasLoadFailure = false;
            if (this.isSelected) {
                this.addPrePaymentAction();
                this.digitalPayPaymentDistributionService.addPaymentInFull(this.card.PaymentInstrumentId);
            }
        }
    }, {
        key: 'setHasLoadFailure',
        value: function setHasLoadFailure() {
            this.hasLoadFailure = true;
        }

        /**
         * Implies that the user no longer wants to make a payment using this particular credit card, remove all related hooks
         */

    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            if (!this.prePaymentActionDefinitions) {
                return;
            }
            this.prePaymentActionDefinitions.removeAction(this.card.PaymentInstrumentId);
        }
    }, {
        key: 'showCvvIframe',
        value: function showCvvIframe() {
            return !this.isManageMode && this.isSelected && this.card.RequiresCvv && !this.card.stepUpToken && !this.card.Expired && this.card.Allowed && !this.hasLoadFailure;
        }
    }, {
        key: 'getPayingAmount',
        value: function getPayingAmount() {
            var paymentInstrumentId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.card.PaymentInstrumentId;

            return this.digitalPayPaymentDistributionService.getPayment(paymentInstrumentId);
        }
    }, {
        key: 'selectCard',
        value: function selectCard() {
            this.addPrePaymentAction();
            this.digitalPayPaymentDistributionService.addPaymentInFull(this.card.PaymentInstrumentId);
            this.onSelect();
            this.removeCvvError();
        }
    }, {
        key: 'addPrePaymentAction',
        value: function addPrePaymentAction() {
            var _this = this;

            if (!this.prePaymentActionDefinitions) {
                return;
            }
            this.prePaymentActionDefinitions.addAction(this.card.PaymentInstrumentId, function () {
                return _this.$q.when({
                    paymentInstrumentId: _this.card.PaymentInstrumentId,
                    amount: _this.getPayingAmount(_this.card.PaymentInstrumentId),
                    stepUpToken: _this.card.stepUpToken
                });
            });
        }
    }, {
        key: 'setCvvError',
        value: function setCvvError() {
            this.cvvErrorMessage = this.settings.digitalPayError.creditCardInvalidCvvMessage;
        }
    }, {
        key: 'removeCvvError',
        value: function removeCvvError() {
            this.cvvErrorMessage = '';
            this.hasLoadFailure = false;
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.card && !changes.card.isFirstChange()) {
                // If a stepup token was added, add it in the prepayment action
                this.addPrePaymentAction();
            }
        }
    }]);

    return CreditCardItemPaymentController;
}();

CreditCardItemPaymentController.$inject = ['$q', 'Settings', 'DigitalPayPaymentDistributionService'];

var creditCardItemPaymentComponentDefinition = {
    controller: CreditCardItemPaymentController,
    template: __webpack_require__(981).trim(),
    bindings: {
        card: '<',
        cardInEditMode: '<',
        prePaymentActionDefinitions: '<',
        paymentStateDefinitions: '<',
        paymentErrorStates: '<',
        refreshCreditCards: '&',
        isManageMode: '<',
        isSelected: '<',
        isSelectEnabled: '<',
        onIframeExpire: '&',
        onRemove: '&?',
        onSelect: '&?',
        onUpdate: '&?',
        onEdit: '&?',
        onError: '&?',
        shouldShowPayingAmount: '<'
    }
};

module.exports = {
    CreditCardItemPaymentController: CreditCardItemPaymentController,
    creditCardItemPaymentComponentDefinition: creditCardItemPaymentComponentDefinition
};

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports = "<wow-digital-pay-error-display ng-if=\"$ctrl.showCvvIframe()\" ng-class=\"{'creditCardItemPayment-cvvError': $ctrl.cvvErrorMessage}\" error-message=\"$ctrl.cvvErrorMessage\"></wow-digital-pay-error-display>\r\n\r\n<wow-credit-card-item\r\n    card=\"$ctrl.card\"\r\n    is-payment=\"true\"\r\n    card-in-edit-mode=\"$ctrl.cardInEditMode\"\r\n    edit-update-text=\"Update\"\r\n    is-manage-mode=\"$ctrl.isManageMode\"\r\n    is-selected=\"$ctrl.isSelected\"\r\n    is-select-enabled=\"$ctrl.isSelectEnabled\"\r\n    is-show-disabled=\"true\"\r\n    on-iframe-expire=\"$ctrl.onIframeExpire()\"\r\n    on-edit=\"$ctrl.onEdit({card:card})\"\r\n    on-remove=\"$ctrl.onRemove(card)\"\r\n    on-select=\"$ctrl.selectCard(card)\"\r\n    on-update=\"$ctrl.onUpdate({paymentInstrumentId: paymentInstrumentId, stepUpToken: stepUpToken})\">\r\n    <!--- CVV iframe -->\r\n    <wow-credit-card-item-middle>\r\n        <div ng-if=\"$ctrl.showCvvIframe()\" class=\"digitalPayItem-section creditCardItemPayment-cvvContainer\">\r\n            <wow-credit-card-item-inline-cvv\r\n                class=\"creditCardItemPayment-cvv\"\r\n                card=\"$ctrl.card\"\r\n                payment-error-states=\"$ctrl.paymentErrorStates\"\r\n                pre-payment-action-definitions=\"$ctrl.prePaymentActionDefinitions\"\r\n                payment-state-definitions=\"$ctrl.paymentStateDefinitions\"\r\n                set-has-load-failure=\"$ctrl.setHasLoadFailure()\"\r\n                refresh-credit-cards=\"$ctrl.refreshCreditCards()\"\r\n                on-invalid-cvv=\"$ctrl.setCvvError()\"\r\n                on-valid-cvv=\"$ctrl.removeCvvError()\"\r\n                on-cvv-focus=\"$ctrl.removeCvvError()\"\r\n                on-errored-cvv=\"$ctrl.onError({id:id})\">\r\n            </wow-credit-card-item-inline-cvv>\r\n        </div>\r\n    </wow-credit-card-item-middle>\r\n    <!--- Amount -->\r\n    <wow-credit-card-item-end>\r\n        <div ng-if=\"$ctrl.isSelected && !$ctrl.isManageMode && $ctrl.shouldShowPayingAmount\" class=\"digitalPayItem-section\">\r\n            <wow-staged-amount-display paying-amount=\"$ctrl.getPayingAmount()\"></wow-staged-amount-display>\r\n        </div>\r\n    </wow-credit-card-item-end>\r\n</wow-credit-card-item>\r\n"

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CreditCardCvvDialogController = function () {
    function CreditCardCvvDialogController($document, $sce, $timeout, dialogRegistry, settings, digitalPayErrorMessageGenerator, digitalPayIframeEventHandler) {
        _classCallCheck(this, CreditCardCvvDialogController);

        this.$document = $document;
        this.$sce = $sce;
        this.$timeout = $timeout;
        this.dialogRegistry = dialogRegistry;
        this.settings = settings;
        this.digitalPayErrorMessageGenerator = digitalPayErrorMessageGenerator;
        this.digitalPayIframeEventHandler = digitalPayIframeEventHandler;
    }

    _createClass(CreditCardCvvDialogController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$timeout(function () {
                _this.dialog = _this.dialogRegistry.getDialog(_this.dialogName);
            });

            this.iframeId = this.dialogName.split(' ').join('');
            this.isValidateDisabled = true;
            this.isLoading = true;
            this.hasIframeFailed = false;
            this.iframeLoadTimeoutPromise = undefined;
            this.setupListenerCallbacks();
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.disposeEventListeners();
        }
    }, {
        key: 'setupListenerCallbacks',
        value: function setupListenerCallbacks() {
            var _this2 = this;

            this.payFrameLoadedCallback = function () {
                _this2.$timeout(function () {
                    _this2.isLoading = false;

                    // Cancel the timer and let the view know the iframe was successfully loaded
                    _this2.$timeout.cancel(_this2.iframeLoadTimeoutPromise);
                });
            };

            this.payFrameErrorCallback = function (response) {
                _this2.isUpdating = false;
                if (!_this2.dialog.isOpen()) {
                    return;
                }
                var errorMessage = _this2.digitalPayErrorMessageGenerator.getCreditCardDialogSubmitIframeError(response.code);
                if (response.code === _this2.settings.digitalPayErrorCodes.creditCardCaptureFormExpired) {
                    _this2.$timeout(function () {
                        _this2.cvvErrorMessage = errorMessage;
                    });
                } else {
                    _this2.dialog.close({ success: false, errorMessage: errorMessage });
                }
            };

            this.payFrameSuccessCallback = function (response) {
                _this2.isUpdating = false;
                if (!_this2.dialog.isOpen() || !response.paymentInstrumentId || response.code !== '00') {
                    return;
                }
                _this2.dialog.close({ success: true, stepUpToken: response.stepUpToken });
            };

            this.payFrameValidCallback = function () {
                _this2.$timeout(function () {
                    _this2.isValidateDisabled = false;
                    _this2.setInvalidCvvMessage();
                });
            };

            this.payFrameInvalidCallback = function () {
                _this2.$timeout(function () {
                    _this2.isValidateDisabled = true;
                });
            };

            this.payFrameFocusLostCallback = function () {
                _this2.$timeout(function () {
                    _this2.setInvalidCvvMessage();
                });
            };
        }
    }, {
        key: 'registerEventListeners',
        value: function registerEventListeners() {
            this.digitalPayIframeEventHandler.on('pay-frame-loaded', this.payFrameLoadedCallback, this.iframeId);
            this.digitalPayIframeEventHandler.on('pay-frame-error', this.payFrameErrorCallback, this.iframeId);
            this.digitalPayIframeEventHandler.on('pay-frame-success', this.payFrameSuccessCallback, this.iframeId);
            this.digitalPayIframeEventHandler.on('pay-frame-valid', this.payFrameValidCallback, this.iframeId);
            this.digitalPayIframeEventHandler.on('pay-frame-invalid', this.payFrameInvalidCallback, this.iframeId);
            this.digitalPayIframeEventHandler.on('pay-frame-focus-lost', this.payFrameFocusLostCallback, this.iframeId);
        }
    }, {
        key: 'disposeEventListeners',
        value: function disposeEventListeners() {
            this.digitalPayIframeEventHandler.off('pay-frame-loaded', this.payFrameLoadedCallback);
            this.digitalPayIframeEventHandler.off('pay-frame-error', this.payFrameErrorCallback);
            this.digitalPayIframeEventHandler.off('pay-frame-success', this.payFrameSuccessCallback);
            this.digitalPayIframeEventHandler.off('pay-frame-valid', this.payFrameValidCallback);
            this.digitalPayIframeEventHandler.off('pay-frame-invalid', this.payFrameInvalidCallback);
            this.digitalPayIframeEventHandler.off('pay-frame-focus-lost', this.payFrameFocusLostCallback);
        }
    }, {
        key: 'validateCvv',
        value: function validateCvv() {
            this.cvvErrorMessage = '';
            this.isUpdating = true;
            this.digitalPayIframeEventHandler.emit(this.$document.find('#' + this.iframeId)[0], { eventId: 'pay-frame-submit' });
        }
    }, {
        key: 'setupIframe',
        value: function setupIframe() {
            var _this3 = this;

            this.hasIframeFailed = false;
            this.iframeUrl = this.$sce.trustAsResourceUrl(this.cvvUrl);
            this.iframeLoadTimeoutPromise = this.$timeout(function () {
                _this3.hasIframeFailed = true;
            }, this.settings.digitalPay.iframeTimeoutInMilliseconds);
        }
    }, {
        key: 'setInvalidCvvMessage',
        value: function setInvalidCvvMessage() {
            this.cvvErrorMessage = this.isValidateDisabled ? this.settings.digitalPayError.creditCardInvalidCvvMessage : '';
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (!changes.isIframeEnabled) {
                return;
            }

            // Enable or disable event listeners depending on the value of isIframeEnabled
            if (changes.isIframeEnabled.currentValue) {
                this.setupIframe();
                this.registerEventListeners();
                this.digitalPayIframeEventHandler.setIframeControl(this.iframeId);
            } else {
                this.disposeEventListeners();
                this.digitalPayIframeEventHandler.releaseIframeControl(this.iframeId);
            }
        }
    }]);

    return CreditCardCvvDialogController;
}();

CreditCardCvvDialogController.$inject = ['$document', '$sce', '$timeout', 'DialogRegistry', 'Settings', 'DigitalPayErrorMessageGenerator', 'DigitalPayIframeEventHandler'];

var creditCardCvvDialogComponentDefinition = {
    controller: CreditCardCvvDialogController,
    template: __webpack_require__(983).trim(),
    bindings: {
        dialog: '=',
        dialogName: '<',
        cvvUrl: '<',
        isIframeEnabled: '<',
        dialogCloseAction: '&'
    }
};

module.exports = {
    CreditCardCvvDialogController: CreditCardCvvDialogController,
    creditCardCvvDialogComponentDefinition: creditCardCvvDialogComponentDefinition
};

/***/ }),
/* 983 */
/***/ (function(module, exports) {

module.exports = "<dialog name=\"{{$ctrl.dialogName}}\" class=\"olyDialog olyDialog--confirmation creditCardCvvDialog\">\r\n    <div ng-class=\"{'creditCardCvvDialog-errorMessageContainer': $ctrl.cvvErrorMessage}\">\r\n        <wow-digital-pay-error-display error-message=\"$ctrl.cvvErrorMessage\"></wow-digital-pay-error-display>\r\n    </div>\r\n\r\n    <div class=\"creditCardCvvDialog-container\">\r\n        <i class=\"iconww-Info creditCardCvvDialog-icon\"></i>\r\n        <wow-setting class=\"creditCardCvvDialog-message\" setting-group=\"DigitalPayMessages\" setting-name=\"CreditCardCvvMessage\"></wow-setting>\r\n        <div class=\"creditCardCvvDialog-cvvContainer\">\r\n            <span>\r\n                <b class=\"creditCardCvvDialog-label\">CSV/CVV</b>\r\n            </span>\r\n            <wow-loading-spinner ng-if=\"$ctrl.isLoading && !$ctrl.hasIframeFailed\" custom-spinner-class=\"creditCardCvvDialog-spinner\"></wow-loading-spinner>\r\n            <iframe id=\"{{$ctrl.iframeId}}\" class=\"creditCardCvvDialog-iframe\" scrolling=\"no\" ng-src=\"{{$ctrl.iframeUrl}}\" ng-if=\"$ctrl.isIframeEnabled\" ng-show=\"!$ctrl.isLoading && !$ctrl.hasIframeFailed\"></iframe>\r\n        </div>\r\n    </div>\r\n\r\n    <footer class=\"creditCardCvvDialog-footer\">\r\n        <button\r\n            oly-dialog-close class=\"button dpFooter-button\"\r\n            ng-click=\"$ctrl.dialogCloseAction()\">\r\n            <i class=\"iconww-ArrowLeft dpFooter-iconLeftButton\"/>Cancel\r\n        </button>\r\n\r\n        <oly-button loading=\"{state: $ctrl.isUpdating, message: 'Validating card, please wait'}\">\r\n            <button\r\n                class=\"button button--primary dpFooter-button--primary creditCardCvvDialog-validateButton\"\r\n                ng-disabled=\"$ctrl.isValidateDisabled\"\r\n                ng-click=\"!$ctrl.isUpdating && $ctrl.validateCvv()\">\r\n                <span ng-if=\"!$ctrl.isUpdating\" class=\"creditCardItemEdit-buttonText\">Validate <i class=\"iconww-ArrowRight dpFooter-iconRightButton\"></i></span>\r\n            </button>\r\n        </oly-button>\r\n    </footer>\r\n</dialog>\r\n"

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.digitalpay');

var _require = __webpack_require__(985),
    giftCardComponentDefinition = _require.giftCardComponentDefinition;

var _require2 = __webpack_require__(987),
    giftCardAddPaymentComponentDefinition = _require2.giftCardAddPaymentComponentDefinition;

wowApp.component('wowGiftCard', giftCardComponentDefinition);
wowApp.component('wowGiftCardAddPayment', giftCardAddPaymentComponentDefinition);

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    clone = _require.clone,
    concat = _require.concat,
    difference = _require.difference,
    each = _require.each,
    filter = _require.filter,
    last = _require.last,
    replace = _require.replace,
    remove = _require.remove,
    size = _require.size,
    some = _require.some,
    trim = _require.trim,
    find = _require.find,
    isUndefined = _require.isUndefined;

var PAYMENT_MANAGE_MODE_STATE_ID = 'gcDisableState';
var GC_CONDENSED_VIEW_STATE = 'gcDisableCondensedView:';
var GC_SELECT_CARD_AMOUNT_KEY = 'gcSelectCardAmount';
var GC_SELECT_CARD_WITH_NO_AMOUNT_SET_DISABLE_STATE = 'gcSelectCardWithNoAmountSet';

var GiftCardController = function () {
    function GiftCardController($q, $filter, moveFocus, digitalPayPaymentErrorDisplayService, digitalPayPaymentDistributionService, digitalPayPaymentInstrumentsService, settings, dateHelperService, digitalPayErrorMessageGenerator) {
        _classCallCheck(this, GiftCardController);

        this.$q = $q;
        this.$filter = $filter;
        this.moveFocus = moveFocus;
        this.digitalPayPaymentErrorDisplayService = digitalPayPaymentErrorDisplayService;
        this.digitalPayPaymentDistributionService = digitalPayPaymentDistributionService;
        this.digitalPayPaymentInstrumentsService = digitalPayPaymentInstrumentsService;
        this.settings = settings;
        this.dateHelperService = dateHelperService;
        this.digitalPayErrorMessageGenerator = digitalPayErrorMessageGenerator;
    }

    _createClass(GiftCardController, [{
        key: '$onInit',
        value: function $onInit() {
            this.giftCardsInErrorState = {};
            this.giftCardsEnabled = false;
            this.manageMode = false;
            this.newGiftCards = [];
            this.deleteMessage = this.settings.digitalPayMessages.giftCardDeleteMessage;
            this.gcWarningMessage = this.unavailableCards && this.unavailableCards.length ? this.settings.digitalPayError.giftCardBalanceApiWarningMessage : '';

            if (this.hasValidCards() && this.shouldSelectGiftCard) {
                this.selectGiftCard(this.validGiftCards[0]);
            }

            this.giftCardBalanceIsValid = true;
        }
    }, {
        key: 'initializeCards',
        value: function initializeCards() {
            var _this = this;

            this.unavailableCards = filter(this.giftCards, function (giftCard) {
                return _this.isCardUnavailable(giftCard);
            });
            var availableCards = difference(this.giftCards, this.unavailableCards);
            this.problemGiftCards = filter(availableCards, function (giftCard) {
                return _this.isProblemGiftCard(giftCard);
            });
            this.validGiftCards = concat(difference(availableCards, this.problemGiftCards), this.unavailableCards);
        }
    }, {
        key: 'getGiftCardError',
        value: function getGiftCardError() {
            var expiredCards = filter(this.problemGiftCards, function (giftCard) {
                return giftCard.Expired;
            });
            var zeroBalanceCards = filter(this.problemGiftCards, function (giftCard) {
                return !giftCard.Expired && giftCard.Balance === 0.0;
            });

            var expiredMsg = this.getIndividualErrorMessage(expiredCards, this.settings.digitalPayError.giftCardExpiredMessage, this.settings.digitalPayError.giftCardMultipleExpiredErrorMessage);

            var zeroBalanceMsg = this.getIndividualErrorMessage(zeroBalanceCards, this.settings.digitalPayError.giftCardInsufficientFundsMessage, this.settings.digitalPayError.giftCardMultipleInsufficientFundsErrorMessage);

            if (expiredMsg && zeroBalanceMsg) {
                return this.digitalPayErrorMessageGenerator.formatErrorMessage(this.settings.digitalPayError.giftCardMultipleErroredCardsMessage, [expiredMsg, zeroBalanceMsg]);
            }
            if (expiredMsg) {
                return expiredMsg;
            }
            if (zeroBalanceMsg) {
                return zeroBalanceMsg;
            }
            return '';
        }
    }, {
        key: 'getIndividualErrorMessage',
        value: function getIndividualErrorMessage(list, singularError, pluralisedError) {
            if (size(list) === 1) {
                return singularError;
            } else if (size(list) > 1) {
                return pluralisedError;
            }
            return '';
        }
    }, {
        key: 'toggleGiftCards',
        value: function toggleGiftCards() {
            var _this2 = this;

            this.giftCardsEnabled = !this.giftCardsEnabled;
            if (this.giftCardsEnabled) {
                // On toggle on, add a new card
                this.addNewGiftCard();
            } else {
                // On toggle off, destroy all new gift cards
                each(this.newGiftCards, function (giftCard) {
                    _this2.digitalPayPaymentDistributionService.removePayment(giftCard.NewStagedCardId);
                    _this2.prePaymentActionDefinitions.removeAction(giftCard.NewStagedCardId);
                    _this2.onChangeSelectGiftCard({ id: giftCard.PaymentInstrumentId || giftCard.NewStagedCardId, isSelected: false });
                });
                this.newGiftCards = [];
            }
        }
    }, {
        key: 'toggleManage',
        value: function toggleManage() {
            this.manageMode = !this.manageMode;
            this.onInstrumentTypeInManageMode({
                type: this.manageMode ? this.settings.digitalPayPaymentTypes.giftCardType : this.settings.digitalPayPaymentTypes.emptyType
            });
            this.setStateDefinitions(this.manageMode);

            if (this.manageMode) {
                var lastAddedGiftCard = last(this.newGiftCards);
                if (lastAddedGiftCard && !lastAddedGiftCard.IsCondensed) {
                    this.removeGiftCardFromUi(lastAddedGiftCard);
                }
                this.moveFocus('#digitalPayGiftCard');
            }
        }
    }, {
        key: 'addNewGiftCard',
        value: function addNewGiftCard() {
            var _this3 = this;

            // Set all existing new gift cards to condensed view
            each(this.newGiftCards, function (giftCard) {
                giftCard.IsCondensed = true;
                if (!giftCard.Amount) {
                    _this3.paymentStateDefinitions.addDisablePaymentState('' + GC_CONDENSED_VIEW_STATE + giftCard.NewStagedCardId, replace(_this3.settings.digitalPayScreenReaderMessages.giftCardAmountDisableMessage, '{0}', giftCard.CardSuffix));
                }
            });

            // Increment the last new gift card's id
            // Cannot use length as the user may have deleted an item which will result in duplicate ids
            var newId = this.hasNewCards() ? parseInt(trim(last(this.newGiftCards).NewStagedCardId, this.paymentAddCardAmountKey)) + 1 : 0;

            var newGiftCard = {
                NewStagedCardId: '' + this.paymentAddCardAmountKey + newId,
                CardNumber: undefined,
                PinCode: undefined,
                Balance: undefined,
                Amount: undefined,
                IsCondensed: false
            };
            this.newGiftCards.push(newGiftCard);
            this.refreshUsedCardNumbersList();
        }

        /**
         * Gets a new list of new gift card numbers
         */

    }, {
        key: 'refreshUsedCardNumbersList',
        value: function refreshUsedCardNumbersList() {
            this.usedCardNumbers = filter(this.newGiftCards, function (card) {
                return card.CardNumber;
            }).map(function (card) {
                return card.CardNumber;
            });
        }

        /**
         * Select a Saved GiftCard.
         * @param {object} giftCard
         */

    }, {
        key: 'selectGiftCard',
        value: function selectGiftCard(giftCard) {
            // Do not allow selecting when in manage mode, $0 balance, expired cards or newly created cards
            if ((this.manageMode || this.isProblemGiftCard(giftCard) || !giftCard.PaymentInstrumentId) && !this.isCardUnavailable(giftCard)) {
                return;
            }

            giftCard.Selected = !giftCard.Selected;

            var giftCardKey = this.getGiftCardKey(giftCard);
            var giftCardSelectDisableStateKey = this.getGiftCardSelectDisableStateKey(giftCard);

            if (!giftCard.Selected) {
                giftCard.Amount = undefined;
                this.digitalPayPaymentDistributionService.removePayment(giftCardKey);
                this.paymentStateDefinitions.removeDisablePaymentState(giftCardSelectDisableStateKey);
                this.prePaymentActionDefinitions.removeAction(giftCardKey);
            } else {
                this.paymentStateDefinitions.addDisablePaymentState(giftCardSelectDisableStateKey, replace(this.settings.digitalPayScreenReaderMessages.giftCardAmountDisableMessage, '{0}', giftCard.CardSuffix));
            }

            this.onChangeSelectGiftCard({ id: giftCard.PaymentInstrumentId || giftCard.NewStagedCardId, isSelected: giftCard.Selected });
        }
    }, {
        key: 'promptRemoveGiftCard',
        value: function promptRemoveGiftCard(giftCard) {
            var _this4 = this;

            this.confirmationDialog.show().then(function (dialogResponse) {
                if (!dialogResponse.success) return;

                if (giftCard.PaymentInstrumentId && isUndefined(giftCard.TokenizedWithSave)) {
                    _this4.removeGiftCard(giftCard);
                } else {
                    _this4.removeGiftCardFromUi(giftCard);
                }
            });
        }

        /**
         * Remove a saved GiftCard from container and the UI.
         * @param {object} giftCard
         * @returns {Promise} promise that returns true if successful
         */

    }, {
        key: 'removeGiftCard',
        value: function removeGiftCard(giftCard) {
            var _this5 = this;

            return this.digitalPayPaymentInstrumentsService.deleteDigitalPayInstrument({ paymentInstrumentId: giftCard.PaymentInstrumentId }).then(function (response) {
                if (response.Success) {
                    _this5.removeGiftCardFromUi(giftCard);
                    _this5.refreshGiftCards();
                } else {
                    _this5.digitalPayPaymentErrorDisplayService.pushGlobalError(_this5.settings.digitalPayError.giftCardDeleteErrorMessage);
                }
            });
        }

        /**
         * Remove a new or saved GiftCard from the UI. Does not remove the card instrument from the container.
         * @param {object} giftCard
         */

    }, {
        key: 'removeGiftCardFromUi',
        value: function removeGiftCardFromUi(giftCard) {
            var giftCardSelectDisableStateKey = this.getGiftCardSelectDisableStateKey(giftCard);
            var giftCardKey = giftCard.NewStagedCardId ? giftCard.NewStagedCardId : this.getGiftCardKey(giftCard);

            // Remove staged/condensed or newly added giftcard which has been tokenized
            this.digitalPayPaymentDistributionService.removePayment(giftCardKey);
            this.prePaymentActionDefinitions.removeAction(giftCardKey);
            if (giftCard.NewStagedCardId) {
                remove(this.newGiftCards, { NewStagedCardId: giftCard.NewStagedCardId });
                this.refreshUsedCardNumbersList();
            } else if (this.isProblemGiftCard(giftCard)) {
                remove(this.problemGiftCards, { PaymentInstrumentId: giftCard.PaymentInstrumentId });
                remove(this.giftCards, { PaymentInstrumentId: giftCard.PaymentInstrumentId });
            } else {
                remove(this.validGiftCards, { PaymentInstrumentId: giftCard.PaymentInstrumentId });
                remove(this.giftCards, { PaymentInstrumentId: giftCard.PaymentInstrumentId });
            }

            this.paymentStateDefinitions.removeDisablePaymentState(giftCardSelectDisableStateKey);
            this.onChangeSelectGiftCard({ id: giftCard.PaymentInstrumentId || giftCard.NewStagedCardId, isSelected: false });

            if (this.manageMode && !this.hasSavedCards()) {
                this.setStateDefinitions(false);
                this.onInstrumentTypeInManageMode({
                    type: this.settings.digitalPayPaymentTypes.emptyType
                });
                this.manageMode = false;
                if (this.hasNewCards()) {
                    this.giftCardsEnabled = !this.giftCardsEnabled;
                }
            }
        }
    }, {
        key: 'setStateDefinitions',
        value: function setStateDefinitions(isInManageMode) {
            if (isInManageMode) {
                this.paymentStateDefinitions.addDisablePaymentState(PAYMENT_MANAGE_MODE_STATE_ID, this.settings.digitalPayScreenReaderMessages.giftCardManageModeDisableMessage);
            } else {
                this.paymentStateDefinitions.removeDisablePaymentState(PAYMENT_MANAGE_MODE_STATE_ID);
            }
        }

        /**
         * Notifies when value in any saved GiftCard amount fields changes.
         * @param {number} amount
         * @param {object} card
         */

    }, {
        key: 'notifyChangeAmount',
        value: function notifyChangeAmount(amount, card) {
            var _this6 = this;

            var giftCardKey = this.getGiftCardKey(card);
            var giftCardSelectDisableStateKey = this.getGiftCardSelectDisableStateKey(card);

            if (!amount || amount <= 0) {
                this.digitalPayPaymentDistributionService.removePayment(giftCardKey);
                this.prePaymentActionDefinitions.removeAction(giftCardKey);
                if (card.PaymentInstrumentId) {
                    this.paymentStateDefinitions.addDisablePaymentState(giftCardSelectDisableStateKey, replace(this.settings.digitalPayScreenReaderMessages.giftCardAmountDisableMessage, '{0}', card.CardSuffix));
                }
                if (card.IsCondensed) {
                    this.paymentStateDefinitions.addDisablePaymentState('' + GC_CONDENSED_VIEW_STATE + card.NewStagedCardId, replace(this.settings.digitalPayScreenReaderMessages.giftCardAmountDisableMessage, '{0}', card.CardSuffix));
                }
            } else {
                this.digitalPayPaymentDistributionService.addPayment(giftCardKey, amount);
                this.paymentStateDefinitions.removeDisablePaymentState(giftCardSelectDisableStateKey);
                if (card.PaymentInstrumentId) {
                    this.prePaymentActionDefinitions.addAction(giftCardKey, function () {
                        return _this6.$q.when({
                            paymentInstrumentId: card.PaymentInstrumentId,
                            amount: amount
                        });
                    });
                } else {
                    this.prePaymentActionDefinitions.addAction(giftCardKey, this.tokenizeGiftCard.bind(this, card));
                }
                if (card.IsCondensed) {
                    this.paymentStateDefinitions.removeDisablePaymentState(GC_CONDENSED_VIEW_STATE + card.NewStagedCardId);
                }
            }
        }
    }, {
        key: 'notifyFormValidityChange',
        value: function notifyFormValidityChange(isValid) {
            this.giftCardBalanceIsValid = isValid;
        }
        /**
         * Tokenize new GiftCards.
         * @param {object} giftCard
         */

    }, {
        key: 'tokenizeGiftCard',
        value: function tokenizeGiftCard(giftCard) {
            var _this7 = this;

            return this.digitalPayPaymentInstrumentsService.tokenizeGiftCard(giftCard.CardNumber, giftCard.Pin, giftCard.IsSavingCard).then(function (response) {
                if (response.Success) {

                    // Hydrate NewGiftCard with newly available data.
                    // By reference the object in the newGiftCards list is also updated.
                    giftCard.PaymentInstrumentId = response.GiftCard.PaymentInstrumentId;
                    giftCard.CardSuffix = response.GiftCard.CardSuffix;
                    giftCard.TokenizedWithSave = giftCard.IsSavingCard;

                    if (_this7.hasPrePaymentActionFailures && some(_this7.newGiftCards, function (newGiftCard) {
                        return newGiftCard.CardNumber === giftCard.CardNumber;
                    })) {
                        _this7.removeGiftCard(giftCard);
                        _this7.addNewGiftCard();
                    }

                    if (last(_this7.newGiftCards) === giftCard) {
                        _this7.addNewGiftCard();
                    }

                    return {
                        paymentInstrumentId: response.GiftCard.PaymentInstrumentId,
                        amount: _this7.digitalPayPaymentDistributionService.getPayment(giftCard.NewStagedCardId)
                    };
                }

                // Payment error is returned here instead of tokenization error because tokenization happens at the time of payment, which has higher precedence
                var errorMessage = _this7.digitalPayErrorMessageGenerator.getGiftCardPaymentError(response.ErrorCode, giftCard.CardNumber.slice(-4), response.ErrorMessage);
                return _this7.$q.reject({ errorMessage: errorMessage });
            });
        }

        /**
         * Set true/false for the error state of a giftcard.
         * @param {string} paymentInstrumentId
         * @param {Object} state
         */

    }, {
        key: 'setSavedCardErrorState',
        value: function setSavedCardErrorState(paymentInstrumentId, state) {
            if (state) {
                this.giftCardsInErrorState[paymentInstrumentId] = state;
            } else {
                delete this.giftCardsInErrorState[paymentInstrumentId];
            }
        }
    }, {
        key: 'clearSavedCardErrorStates',
        value: function clearSavedCardErrorStates() {
            this.giftCardsInErrorState = {};
        }
    }, {
        key: 'clearNewlyAddedGiftCards',
        value: function clearNewlyAddedGiftCards() {
            var _this8 = this;

            var cardsToRemove = clone(this.newGiftCards);
            each(cardsToRemove, function (cardToRemove) {
                var isTokenized = function isTokenized(newGiftCard) {
                    return newGiftCard.PaymentInstrumentId;
                };
                if (cardToRemove.IsSavingCard && isTokenized(cardToRemove) && !_this8.isSavedCard(cardToRemove.PaymentInstrumentId)) {
                    _this8.removeGiftCard(cardToRemove);
                } else {
                    _this8.removeGiftCardFromUi(cardToRemove);
                }
            });

            // If a payment error occurred if the payment contained a new gift card, we want to show the user an empty add card form
            this.addNewGiftCard();
        }
    }, {
        key: 'isSavedCard',
        value: function isSavedCard(paymentInstrumentId) {
            return some(this.validGiftCards, function (card) {
                return card.PaymentInstrumentId === paymentInstrumentId;
            }) || some(this.problemGiftCards, function (card) {
                return card.PaymentInstrumentId === paymentInstrumentId;
            });
        }

        /**
         * Determine whether the saved giftcard with the given id is in error state.
         * @param {string} paymentInstrumentId
         */

    }, {
        key: 'isCardInErrorState',
        value: function isCardInErrorState(paymentInstrumentId) {
            return !isUndefined(this.giftCardsInErrorState[paymentInstrumentId]);
        }
    }, {
        key: 'getGiftCardKey',
        value: function getGiftCardKey(card) {
            return card.PaymentInstrumentId ? '' + GC_SELECT_CARD_AMOUNT_KEY + card.PaymentInstrumentId : card.NewStagedCardId;
        }
    }, {
        key: 'getGiftCardSelectDisableStateKey',
        value: function getGiftCardSelectDisableStateKey(card) {
            return '' + GC_SELECT_CARD_WITH_NO_AMOUNT_SET_DISABLE_STATE + (card.PaymentInstrumentId ? card.PaymentInstrumentId : card.NewStagedCardId);
        }
    }, {
        key: 'showAddNewGiftCard',
        value: function showAddNewGiftCard() {
            var newestGiftCard = last(this.newGiftCards);

            return (this.giftCards && this.hasSavedCards() || this.hasNewCards()) && !this.manageMode && this.digitalPayPaymentDistributionService.getRemainingAmount() > 0 && (!newestGiftCard || newestGiftCard.CardNumber && newestGiftCard.Pin && newestGiftCard.Amount && !newestGiftCard.ErrorCode) && this.giftCardBalanceIsValid;
        }
    }, {
        key: 'showSavedGiftCards',
        value: function showSavedGiftCards() {
            return this.hasValidCards();
        }
    }, {
        key: 'showNewGiftCards',
        value: function showNewGiftCards() {
            return this.hasNewCards() || this.giftCardsEnabled && this.hasSavedCards();
        }
    }, {
        key: 'showActions',
        value: function showActions() {
            return this.showAddNewGiftCard() || this.hasValidCards() && !this.manageMode || this.manageMode;
        }
    }, {
        key: 'hasValidCards',
        value: function hasValidCards() {
            return this.validGiftCards && this.validGiftCards.length;
        }
    }, {
        key: 'hasSavedCards',
        value: function hasSavedCards() {
            return this.giftCards && this.giftCards.length;
        }
    }, {
        key: 'hasNewCards',
        value: function hasNewCards() {
            return this.newGiftCards && this.newGiftCards.length;
        }
    }, {
        key: 'isCardUnavailable',
        value: function isCardUnavailable(giftCard) {
            return giftCard.ErrorCode === this.settings.digitalPayErrorCodes.giftCardKnownBalanceCheckFailed || giftCard.ErrorCode === this.settings.digitalPayErrorCodes.giftCardUnknownBalanceCheckFailed || giftCard.ErrorCode === this.settings.digitalPayErrorCodes.giftCardBalanceApiUnavailable;
        }
    }, {
        key: 'isProblemGiftCard',
        value: function isProblemGiftCard(giftCard) {
            return giftCard.Expired || giftCard.Balance === 0.0;
        }
    }, {
        key: 'checkIfDatesAreEqual',
        value: function checkIfDatesAreEqual(date1, date2) {
            return this.dateHelperService.getDateFromEpochInSeconds(date1) === this.dateHelperService.getDateFromEpochInSeconds(date2);
        }
    }, {
        key: 'handleSavedCardPaymentFailure',
        value: function handleSavedCardPaymentFailure(savedGiftCard, gcErrorState) {
            // Deselect selected GiftCard
            this.selectGiftCard(savedGiftCard);
            this.setSavedCardErrorState(savedGiftCard.PaymentInstrumentId, gcErrorState);
            if (gcErrorState.state.ErrorMessage) {
                this.handleGiftCardPaymentFailure(savedGiftCard, gcErrorState);
            }
        }
    }, {
        key: 'handleGiftCardPaymentFailure',
        value: function handleGiftCardPaymentFailure(giftCard, gcErrorState) {
            var errorMessage = this.digitalPayErrorMessageGenerator.getGiftCardPaymentError(gcErrorState.state.ErrorCode, giftCard.CardSuffix, gcErrorState.state.ErrorMessage);
            this.digitalPayPaymentErrorDisplayService.pushToPaymentErrorBreakdown(errorMessage);
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            var _this9 = this;

            // Core logic for changes in the gift cards list, we will refresh the error that is initialized
            if (changes.giftCards && changes.giftCards.currentValue) {
                this.initializeCards();
                this.giftCardError = this.getGiftCardError();
            }

            var currentPaymentErrorStates = changes.paymentErrorStates && changes.paymentErrorStates.currentValue || [];
            if (currentPaymentErrorStates.length) {
                // Filter all giftcard errors.
                var giftCardErrorStates = filter(currentPaymentErrorStates, function (value) {
                    var state = value.state;
                    return state.ErrorCode && state.PaymentInstrumentType === _this9.settings.digitalPayPaymentTypes.giftCardType;
                });

                // Clear existing error states.
                this.clearSavedCardErrorStates();

                // Handle all giftcard payment errors.
                each(giftCardErrorStates, function (gcErrorState) {
                    var paymentInstrumentId = gcErrorState.state.PaymentInstrumentId;

                    // Find selected Giftcard matching the payment error.
                    var savedGiftCard = find(_this9.validGiftCards, function (c) {
                        return c.PaymentInstrumentId === paymentInstrumentId && c.Selected;
                    });
                    var newlyAddedGiftCard = find(_this9.newGiftCards, function (c) {
                        return c.PaymentInstrumentId === paymentInstrumentId;
                    });

                    if (savedGiftCard) {
                        _this9.handleSavedCardPaymentFailure(savedGiftCard, gcErrorState);
                    } else if (newlyAddedGiftCard && gcErrorState.state.ErrorMessage) {
                        _this9.handleGiftCardPaymentFailure(newlyAddedGiftCard, gcErrorState);
                    }
                });

                if (this.hasNewCards()) {
                    this.clearNewlyAddedGiftCards();
                }
            } else if (changes.paymentErrorStates) {
                // Clear existing error states.
                this.clearSavedCardErrorStates();
            }

            if (this.hasNewCards() && (changes.hasPrePaymentActionFailures && changes.hasPrePaymentActionFailures.currentValue || changes.hasPrePaymentValidationFailure && changes.hasPrePaymentValidationFailure.currentValue || changes.shouldRemoveNewlyAddedInstruments && changes.shouldRemoveNewlyAddedInstruments.currentValue)) {
                this.clearNewlyAddedGiftCards();
            }
        }
    }]);

    return GiftCardController;
}();

GiftCardController.$inject = ['$q', '$filter', 'MoveFocus', 'DigitalPayPaymentErrorDisplayService', 'DigitalPayPaymentDistributionService', 'DigitalPayPaymentInstrumentsService', 'Settings', 'DateHelperService', 'DigitalPayErrorMessageGenerator'];

var giftCardComponentDefinition = {
    controller: GiftCardController,
    template: __webpack_require__(986).trim(),
    bindings: {
        giftCards: '<',
        allowedBins: '<',
        paymentAddCardAmountKey: '<',
        paymentStateDefinitions: '<',
        prePaymentActionDefinitions: '<',
        refreshGiftCards: '&',
        setSingleSelectType: '&',
        shouldSelectGiftCard: '<',
        singleSelectType: '<',
        onInstrumentTypeInManageMode: '&',
        onChangeSelectGiftCard: '&',
        paymentErrorStates: '<',
        hasPrePaymentActionFailures: '<',
        hasPrePaymentValidationFailure: '<',
        isImpersonated: '<',
        shouldRemoveNewlyAddedInstruments: '<',
        shouldShowPayingAmount: '<'
    }
};

module.exports = {
    GiftCardController: GiftCardController,
    giftCardComponentDefinition: giftCardComponentDefinition
};

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"!$ctrl.loadingList\" class=\"digitalPay\" tabindex=\"-1\" id=\"digitalPayGiftCard\">\r\n    <!-- List of Problem Gift Cards -->\r\n    <div ng-if=\"$ctrl.problemGiftCards.length\" class=\"giftCard-errorSpacer\">\r\n        <wow-digital-pay-error-display error-message=\"$ctrl.giftCardError\" is-on-top=\"true\"></wow-digital-pay-error-display>\r\n        <ul class=\"digitalPayContainer-list digitalPayContainer-list--error giftCard-errorList notTop\">\r\n            <li ng-repeat=\"giftCard in $ctrl.problemGiftCards\">\r\n                <wow-gift-card-item\r\n                    card=\"giftCard\"\r\n                    manage-mode=\"$ctrl.manageMode\"\r\n                    on-remove=\"$ctrl.promptRemoveGiftCard(giftCard)\"\r\n                    show-disabled=\"true\">\r\n                </wow-gift-card-item>\r\n            </li>\r\n        </ul>\r\n    </div>\r\n\r\n    <div class=\"digitalPayContainer u-flexColumn\">\r\n        <!-- Toggle Button (only show if there are no saved gift cards) -->\r\n        <wow-digital-pay-toggle-button\r\n            ng-if=\"!$ctrl.hasSavedCards()\"\r\n            instrument-name=\"Gift Card\"\r\n            icon=\"images/checkout/digitalpay/icon-pay-giftcard.svg\"\r\n            is-icon-svg=\"true\"\r\n            on-click=\"$ctrl.toggleGiftCards()\"\r\n            is-select-button=\"true\"\r\n            is-not-bottom=\"$ctrl.showSavedGiftCards() || $ctrl.showNewGiftCards()\"\r\n            should-show-paying-amount=\"$ctrl.shouldShowPayingAmount\">\r\n        </wow-digital-pay-toggle-button>\r\n\r\n        <wow-digital-pay-warning-display ng-if=\"$ctrl.hasSavedCards()\" warning-message=\"$ctrl.gcWarningMessage\" is-thin-style=\"true\"></wow-digital-pay-warning-display>\r\n\r\n        <!-- List of Saved Gift Cards (excluding problem gift cards) -->\r\n        <ul ng-if=\"$ctrl.showSavedGiftCards()\"\r\n            class=\"digitalPayContainer-list digitalPayContainer-list--selectable digitalPayContainer-list--errorable\"\r\n            ng-class=\"$ctrl.unavailableCards && $ctrl.unavailableCards.length ? 'notTop' : 'notBottom'\">\r\n            <li ng-repeat=\"giftCard in $ctrl.validGiftCards\" ng-class=\"{'selected': !$ctrl.manageMode && giftCard.Selected, 'errored': $ctrl.isCardInErrorState(giftCard.PaymentInstrumentId)}\">\r\n                <wow-gift-card-item\r\n                    card=\"giftCard\"\r\n                    manage-mode=\"$ctrl.manageMode\"\r\n                    on-remove=\"$ctrl.promptRemoveGiftCard(giftCard)\"\r\n                    on-select=\"$ctrl.selectGiftCard(giftCard)\"\r\n                    on-change-gift-card-amount=\"$ctrl.notifyChangeAmount(amount, card)\"\r\n                    show-disabled=\"true\">\r\n                </wow-gift-card-item>\r\n            </li>\r\n        </ul>\r\n\r\n        <!-- List of New Gift Cards -->\r\n        <ul ng-if=\"$ctrl.showNewGiftCards()\" class=\"digitalPayContainer-list digitalPayContainer-list--selectable notTop\" ng-class=\"{'notBottom': $ctrl.showActions()}\">\r\n            <li ng-repeat=\"giftCard in $ctrl.newGiftCards\" ng-class=\"{'selected': giftCard.IsCondensed}\">\r\n                <wow-gift-card-item\r\n                    card=\"giftCard\"\r\n                    on-remove=\"$ctrl.promptRemoveGiftCard(giftCard)\"\r\n                    on-change-gift-card-amount=\"$ctrl.notifyChangeAmount(amount, card)\"\r\n                    show-disabled=\"true\">\r\n                    <wow-gift-card-add-payment\r\n                        ng-if=\"!giftCard.PaymentInstrumentId && !giftCard.IsCondensed\"\r\n                        card=\"giftCard\"\r\n                        allowed-bins=\"$ctrl.allowedBins\"\r\n                        payment-state-definitions=\"$ctrl.paymentStateDefinitions\"\r\n                        on-change-gift-card-amount=\"$ctrl.notifyChangeAmount(amount, card)\"\r\n                        on-change-select-gift-card=\"$ctrl.onChangeSelectGiftCard({id: id, isSelected: isSelected})\"\r\n                        is-impersonated=\"$ctrl.isImpersonated\"\r\n                        used-card-numbers=\"$ctrl.usedCardNumbers\"\r\n                        on-form-validity-change=\"$ctrl.notifyFormValidityChange(isValid)\">\r\n                    </wow-gift-card-add-payment>\r\n                </wow-gift-card-item>\r\n            </li>\r\n        </ul>\r\n\r\n        <!-- Actions -->\r\n        <div\r\n            ng-if=\"$ctrl.showActions()\"\r\n            class=\"digitalPayActions-container\"\r\n            ng-class=\"{'notTop': $ctrl.hasValidCards()}\">\r\n            <button\r\n                wow-digital-pay-button\r\n                class=\"dpLinkButton\"\r\n                ng-if=\"$ctrl.showAddNewGiftCard()\"\r\n                ng-click=\"$ctrl.addNewGiftCard()\"\r\n                type=\"button\">\r\n                Add gift card\r\n            </button>\r\n            <button\r\n                wow-digital-pay-button\r\n                class=\"dpLinkButton\"\r\n                ng-if=\"$ctrl.hasValidCards() && !$ctrl.manageMode\"\r\n                ng-click=\"$ctrl.toggleManage()\"\r\n                type=\"button\">\r\n                Manage gift cards\r\n            </button>\r\n            <button\r\n                wow-digital-pay-button\r\n                class=\"dpLinkButton\"\r\n                ng-if=\"$ctrl.manageMode\"\r\n                ng-click=\"$ctrl.toggleManage()\"\r\n                type=\"button\">\r\n                Done\r\n            </button>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<wow-digital-pay-confirmation-dialog\r\n    dialog-name=\"'delete gift card dialog'\"\r\n    dialog=\"$ctrl.confirmationDialog\"\r\n    message=\"::$ctrl.deleteMessage\">\r\n        <div class=\"dpFooter-container\">\r\n            <button oly-dialog-close class=\"button dpFooter-button\">\r\n                <i class=\"iconww-ArrowLeft dpFooter-iconLeftButton\"/>Cancel\r\n            </button>\r\n            <button class=\"button button--primary dpFooter-button--primary\" ng-click=\"$ctrl.confirmationDialog.close({ success: true })\">\r\n                Delete<i class=\"iconww-ArrowRight dpFooter-iconRightButton\"/>\r\n            </button>\r\n        </div>\r\n</wow-digital-pay-confirmation-dialog>\r\n"

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GiftCardAddBaseController = __webpack_require__(43).GiftCardAddBaseController;

var ADD_GIFT_CARD_ID = 'GiftCard:AddGiftCard:SplitPayment';
var ADD_GIFT_CARD_BALANCE_ID = 'GiftCard:AddGiftCard:BalanceLoading';

var _require = __webpack_require__(0),
    replace = _require.replace,
    some = _require.some;

var GiftCardAddPaymentController = function (_GiftCardAddBaseContr) {
    _inherits(GiftCardAddPaymentController, _GiftCardAddBaseContr);

    function GiftCardAddPaymentController($filter, $timeout, settings, announcerService, digitalPayPaymentInstrumentsService, digitalPayFormValidator, digitalPayPaymentErrorDisplayService) {
        _classCallCheck(this, GiftCardAddPaymentController);

        var _this = _possibleConstructorReturn(this, (GiftCardAddPaymentController.__proto__ || Object.getPrototypeOf(GiftCardAddPaymentController)).call(this, $timeout, settings, digitalPayPaymentInstrumentsService, digitalPayFormValidator));

        _this.$filter = $filter;
        _this.settings = settings;
        _this.announcerService = announcerService;
        _this.digitalPayPaymentInstrumentsService = digitalPayPaymentInstrumentsService;
        _this.digitalPayFormValidator = digitalPayFormValidator;
        _this.digitalPayPaymentErrorDisplayService = digitalPayPaymentErrorDisplayService;
        return _this;
    }

    _createClass(GiftCardAddPaymentController, [{
        key: '$onInit',
        value: function $onInit() {
            _get(GiftCardAddPaymentController.prototype.__proto__ || Object.getPrototypeOf(GiftCardAddPaymentController.prototype), '$onInit', this).call(this);

            this.isLoadingBalance = false;
            this.giftCardNumberFocus = false;
            this.isImpersonated = false;

            this.onFormValidityChange({ isValid: this.hasValidGiftCardBalance || !this.card.BalanceApiAvailable });
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.onFormValidityChange({ isValid: true });
            this.paymentStateDefinitions.removeDisablePaymentState(ADD_GIFT_CARD_ID);
            this.paymentStateDefinitions.removeDisablePaymentState(ADD_GIFT_CARD_BALANCE_ID);
        }
    }, {
        key: 'onBlurEvents',
        value: function onBlurEvents(event) {
            if (this.checkCardNumberAlreadyExists(this.card.CardNumber)) {
                this.setDuplicateCardError(true);
            } else {
                this.giftCardCaptureFocusLost(event);
            }
        }
    }, {
        key: 'onFocusGiftCardNumber',
        value: function onFocusGiftCardNumber(event) {
            if (this.checkCardNumberAlreadyExists(this.card.CardNumber)) {
                this.setDuplicateCardError(false);
            } else {
                this.giftCardCaptureFocusGain(event);
            }
        }
    }, {
        key: 'onFocusPin',
        value: function onFocusPin(event) {
            if (this.checkCardNumberAlreadyExists(this.card.CardNumber)) {
                this.setDuplicateCardError(true);
            } else {
                this.giftCardCaptureFocusGain(event);
            }
        }
    }, {
        key: 'onChangeGiftCardNumber',
        value: function onChangeGiftCardNumber() {
            var _this2 = this;

            this.digitalPayPaymentErrorDisplayService.clearGlobalError();
            // Timeout added to stop the red flash in the gift card number input field when retrieving gift card balance
            this.$timeout(function () {
                _this2.getBalance();
            });
        }
    }, {
        key: 'onChangePin',
        value: function onChangePin() {
            var _this3 = this;

            this.digitalPayPaymentErrorDisplayService.clearGlobalError();
            // Timeout added to stop the red flash in the gift card pin input field when retrieving gift card balance
            this.$timeout(function () {
                _this3.getBalance();
            });
        }
    }, {
        key: 'onChangeCardAmount',
        value: function onChangeCardAmount() {
            this.digitalPayPaymentErrorDisplayService.clearGlobalError();

            if (this.shouldDisableCheckBox()) {
                this.card.IsSavingCard = false;
            }

            var hasValidBalance = this.hasValidBalance();
            if (!hasValidBalance) {
                return;
            } else if (this.card.Amount && !hasValidBalance) {
                this.giftCardCaptureFocusLost({ target: { name: this.settings.digitalPayGiftCardFields.amount } });
                return;
            } else if (!this.card.Amount && (!this.focusLostObject || this.focusLostObject.allFieldsEmpty)) {
                this.errorMessage = '';
                return;
            }

            var amount = this.getGiftCardAmount(this.card.Amount);

            this.errorMessage = amount > parseFloat(this.card.Balance) && !this.isCardUnavailable(this.card) ? replace(this.settings.digitalPayError.giftCardAmountAvailableExceedMessage, '{AMOUNTAVAILABLE}', this.$filter('currency')(this.card.Balance)) : '';

            this.onChangeGiftCardAmount({ amount: amount, card: this.card });

            if (this.card.Amount) {
                this.paymentStateDefinitions.removeDisablePaymentState(ADD_GIFT_CARD_ID);
            } else {
                this.paymentStateDefinitions.addDisablePaymentState(ADD_GIFT_CARD_ID, this.settings.digitalPayScreenReaderMessages.giftCardAddDisableMessage);
            }

            this.onFormValidityChange({ isValid: this.amountIsValid() && (this.hasValidGiftCardBalance || !this.card.BalanceApiAvailable) });
        }
    }, {
        key: 'onFocusCardAmount',
        value: function onFocusCardAmount() {
            this.onChangeCardAmount();
        }
    }, {
        key: 'setDuplicateCardError',
        value: function setDuplicateCardError(isDuplicate) {
            this.errorMessage = isDuplicate ? this.settings.digitalPayError.giftCardAddDuplicateCardMessage : '';
            this.giftCardAddForm.giftCardNumber.$setValidity('duplicate', !isDuplicate);
        }
    }, {
        key: 'shouldHideSave',
        value: function shouldHideSave() {
            return this.isImpersonated;
        }
    }, {
        key: 'checkCardNumberAlreadyExists',
        value: function checkCardNumberAlreadyExists(cardNumber) {
            return some(this.usedCardNumbers, function (usedCardNumber) {
                return usedCardNumber === cardNumber;
            });
        }
    }, {
        key: 'getGiftCardAmount',
        value: function getGiftCardAmount(amount) {
            return amount ? parseFloat(amount) : 0.0;
        }
    }, {
        key: 'isCardUnavailable',
        value: function isCardUnavailable(giftCard) {
            return giftCard.ErrorCode === this.settings.digitalPayErrorCodes.giftCardKnownBalanceCheckFailed || giftCard.ErrorCode === this.settings.digitalPayErrorCodes.giftCardUnknownBalanceCheckFailed || giftCard.ErrorCode === this.settings.digitalPayErrorCodes.giftCardBalanceApiUnavailable;
        }
    }, {
        key: 'onKeyGiftCardStateEvents',
        value: function onKeyGiftCardStateEvents() {
            if (this.isValueUndefinedOrEmpty(this.giftCardAddForm.giftCardNumber.$viewValue) || this.isValueUndefinedOrEmpty(this.giftCardAddForm.giftCardPin.$viewValue)) {
                this.paymentStateDefinitions.addDisablePaymentState(ADD_GIFT_CARD_ID, this.settings.digitalPayScreenReaderMessages.giftCardAddDisableMessage);
                this.onChangeSelectGiftCard({ id: this.card.PaymentInstrumentId || this.card.NewStagedCardId, isSelected: true });
            } else {
                this.paymentStateDefinitions.removeDisablePaymentState(ADD_GIFT_CARD_ID);
                this.onChangeSelectGiftCard({ id: this.card.PaymentInstrumentId || this.card.NewStagedCardId, isSelected: false });
            }
        }
    }, {
        key: 'isValueUndefinedOrEmpty',
        value: function isValueUndefinedOrEmpty(value) {
            return value && value.length;
        }
    }, {
        key: 'clearCardCaptureContents',
        value: function clearCardCaptureContents() {
            this.invalidateBalance();
            this.card.CardNumber = '';
            this.card.Pin = '';
            this.card.IsSavingCard = false;
            this.cardNumberError = false;
            this.resetFormValidation();
            this.clearValidationState();
            this.setCardValidity(true);
            this.setDuplicateCardError(false);
            this.stopLoadingBalance();
        }
    }, {
        key: 'resetFormValidation',
        value: function resetFormValidation() {
            this.giftCardAddForm.$setPristine();
            this.giftCardAddForm.$setUntouched();
        }
    }, {
        key: 'isFormInvalid',
        value: function isFormInvalid() {
            return this.card.BalanceApiAvailable && this.giftCardAddForm.$invalid || this.giftCardAddForm.giftCardNumber.$invalid || this.giftCardAddForm.giftCardPin.$invalid || this.giftCardAddForm.giftCardAddAmount.$invalid;
        }
    }, {
        key: 'amountIsValid',
        value: function amountIsValid() {
            return this.card.Amount && this.card.Amount > 0 && this.card.Amount <= this.card.Balance;
        }
    }, {
        key: 'shouldDisableCheckBox',
        value: function shouldDisableCheckBox() {
            return this.isFormInvalid() || !this.card.Balance || !this.amountIsValid() || this.isBalanceSameAsAvailableAmount();
        }

        /**
         * @override
         */

    }, {
        key: 'getBalance',
        value: function getBalance() {
            if (!this.checkCardNumberAlreadyExists(this.card.CardNumber)) {
                _get(GiftCardAddPaymentController.prototype.__proto__ || Object.getPrototypeOf(GiftCardAddPaymentController.prototype), 'getBalance', this).call(this);
            }
        }

        /**
         * @override
         */

    }, {
        key: 'invalidateBalance',
        value: function invalidateBalance() {
            _get(GiftCardAddPaymentController.prototype.__proto__ || Object.getPrototypeOf(GiftCardAddPaymentController.prototype), 'invalidateBalance', this).call(this);
            this.card.IsSavingCard = false;
            this.onChangeGiftCardAmount({ amount: this.card.Amount, card: this.card });
        }

        /**
         * @override
         */

    }, {
        key: 'clearValidationState',
        value: function clearValidationState() {
            _get(GiftCardAddPaymentController.prototype.__proto__ || Object.getPrototypeOf(GiftCardAddPaymentController.prototype), 'clearValidationState', this).call(this);
            this.paymentStateDefinitions.removeDisablePaymentState(ADD_GIFT_CARD_ID);
            this.onChangeSelectGiftCard({ id: this.card.PaymentInstrumentId || this.card.NewStagedCardId, isSelected: false });
        }

        /**
         * @override
         */

    }, {
        key: 'onGetValidBalance',
        value: function onGetValidBalance() {
            _get(GiftCardAddPaymentController.prototype.__proto__ || Object.getPrototypeOf(GiftCardAddPaymentController.prototype), 'onGetValidBalance', this).call(this);
            this.announcerService.announce('This gift card has $' + this.card.Balance + ' available');
        }

        /**
         * @override
         */

    }, {
        key: 'startLoadingBalance',
        value: function startLoadingBalance() {
            this.isLoadingBalance = true;
            this.paymentStateDefinitions.addDisablePaymentState(ADD_GIFT_CARD_BALANCE_ID);
        }

        /**
         * @override
         */

    }, {
        key: 'stopLoadingBalance',
        value: function stopLoadingBalance() {
            this.isLoadingBalance = false;
            this.paymentStateDefinitions.removeDisablePaymentState(ADD_GIFT_CARD_BALANCE_ID);
        }
    }]);

    return GiftCardAddPaymentController;
}(GiftCardAddBaseController);

GiftCardAddPaymentController.$inject = ['$filter', '$timeout', 'Settings', 'AnnouncerService', 'DigitalPayPaymentInstrumentsService', 'DigitalPayFormValidator', 'DigitalPayPaymentErrorDisplayService'];

var giftCardAddPaymentComponentDefinition = {
    controller: GiftCardAddPaymentController,
    template: __webpack_require__(988).trim(),
    bindings: {
        card: '<',
        allowedBins: '<',
        paymentStateDefinitions: '<',
        onChangeGiftCardAmount: '&',
        onChangeSelectGiftCard: '&',
        isImpersonated: '<',
        usedCardNumbers: '<',
        onFormValidityChange: '&'
    }
};

module.exports = {
    GiftCardAddPaymentController: GiftCardAddPaymentController,
    giftCardAddPaymentComponentDefinition: giftCardAddPaymentComponentDefinition
};

/***/ }),
/* 988 */
/***/ (function(module, exports) {

module.exports = "<ng-form name=\"$ctrl.giftCardAddForm\">\r\n    <wow-digital-pay-warning-display\r\n        ng-if=\"!$ctrl.card.BalanceApiAvailable\"\r\n        warning-message=\"$ctrl.unableToRetrieveBalanceWarningMessage\">\r\n    </wow-digital-pay-warning-display>\r\n\r\n    <wow-digital-pay-error-display\r\n        ng-if=\"$ctrl.errorMessage\"\r\n        error-message=\"$ctrl.errorMessage\">\r\n    </wow-digital-pay-error-display>\r\n\r\n    <wow-digital-pay-error-display\r\n        ng-if=\"$ctrl.hasTooManyRequests\"\r\n        error-message=\"$ctrl.hasTooManyRequestsMessage\">\r\n    </wow-digital-pay-error-display>\r\n\r\n    <div class=\"digitalPayAdd-container\">\r\n        <div class=\"digitalPayInput giftCardAddPayment-card\">\r\n            <div\r\n                class=\"digitalPayInput-icon\"\r\n                ng-class=\"{'digitalPayInput-icon--invalid':\r\n                            $ctrl.giftCardAddForm.giftCardNumber.$error.giftCardNumberPartial ||\r\n                            ($ctrl.giftCardAddForm.giftCardNumber.$error.giftCardNumber && !$ctrl.giftCardNumberFocus) ||\r\n                            $ctrl.giftCardAddForm.giftCardNumber.$error.card ||\r\n                            $ctrl.giftCardAddForm.giftCardNumber.$error.duplicate}\">\r\n                <i class=\"iconww-Card giftCardAddPayment-cardIcon\"></i>\r\n            </div>\r\n\r\n        <wow-input-container class=\"digitalPayInput-wowInputContainerOverride\">\r\n            <label>Card number</label>\r\n            <input\r\n                name=\"giftCardNumber\"\r\n                type=\"tel\"\r\n                aria-label=\"Gift Card Number\"\r\n                ng-model=\"$ctrl.card.CardNumber\"\r\n                ng-blur=\"$ctrl.giftCardNumberFocus = false; $ctrl.onBlurEvents($event)\"\r\n                ng-change=\"$ctrl.onChangeGiftCardNumber()\"\r\n                ng-focus=\"$ctrl.giftCardNumberFocus = true; $ctrl.onFocusGiftCardNumber($event)\"\r\n                ng-keyup=\"$ctrl.onKeyGiftCardStateEvents()\"\r\n                oly-max-length=\"{{$ctrl.validGiftCardNumberLength}}\"\r\n                ng-minlength=\"{{$ctrl.validGiftCardNumberLength}}\"\r\n                ng-maxlength=\"{{$ctrl.validGiftCardNumberLength}}\"\r\n                ng-model-options=\"{updateOn : 'keyup blur'}\"\r\n                ng-disabled=\"$ctrl.isLoadingBalance\"\r\n                restrict-alpha\r\n                wow-gift-card-number-validation=\"{{$ctrl.giftCardNumberValidation}}\"\r\n                required />\r\n        </wow-input-container>\r\n    </div>\r\n\r\n    <div class=\"u-flex\">\r\n        <div class=\"digitalPayInput giftCardAddPayment-pin\">\r\n            <wow-input-container class=\"digitalPayInput-wowInputContainerOverride\">\r\n                <label>PIN</label>\r\n                <input\r\n                    id=\"giftCardPin\"\r\n                    name=\"giftCardPin\"\r\n                    type=\"tel\"\r\n                    ng-model=\"$ctrl.card.Pin\"\r\n                    ng-blur=\"$ctrl.onBlurEvents($event)\"\r\n                    ng-change=\"$ctrl.onChangePin()\"\r\n                    ng-focus=\"$ctrl.onFocusPin($event)\"\r\n                    ng-keyup=\"$ctrl.onKeyGiftCardStateEvents()\"\r\n                    oly-max-length=\"{{$ctrl.validGiftCardPinNumberLength}}\"\r\n                    ng-minlength=\"{{$ctrl.validGiftCardPinNumberLength}}\"\r\n                    ng-maxlength=\"{{$ctrl.validGiftCardPinNumberLength}}\"\r\n                    ng-model-options=\"{updateOn : 'keyup blur'}\"\r\n                    ng-disabled=\"$ctrl.isLoadingBalance\"\r\n                    autocomplete=\"off\"\r\n                    restrict-alpha\r\n                    required />\r\n            </wow-input-container>\r\n        </div>\r\n\r\n        <!-- Hidden field for validation purposes -->\r\n        <input\r\n            name=\"giftCardBalance\"\r\n            type=\"number\"\r\n            aria-label=\"Gift Card Balance\"\r\n            class=\"giftCardAddPayment-balanceAvailableHidden\"\r\n            ng-model=\"$ctrl.card.Balance\"\r\n            wow-gift-card-balance-validation={{$ctrl.card.BalanceApiAvailable}}\r\n            tabindex=\"-1\"\r\n            readonly>\r\n        </input>\r\n\r\n        <div class=\"digitalPayInput\" ng-class=\"{'giftCardAddPayment-balanceInput': $ctrl.card.Amount === 0}\">\r\n            <div\r\n                class=\"digitalPayInput-icon giftCardAddPayment-balanceAvailable\"\r\n                ng-class=\"{'digitalPayInput-error': $ctrl.giftCardAddForm.giftCardAvailableAmount.$error.giftCardAmountAvailableEmpty || $ctrl.giftCardAddForm.giftCardAmount.$error.giftCardAmount}\">\r\n                <div class=\"giftCardAddPayment-balanceAvailableLoadingContainer\" ng-if=\"$ctrl.isLoadingBalance\">\r\n                    <wow-loading-spinner custom-spinner-class=\"giftCardAddPayment-balanceAvailableLoading\"></wow-loading-spinner>\r\n                    <span class=\"sr-only\" role=\"alert\">Loading Balance, please wait</span>\r\n                </div>\r\n                <div ng-if=\"!$ctrl.isLoadingBalance\">{{$ctrl.card.Balance || $ctrl.card.Balance === 0 ? ($ctrl.card.Balance | currency) : '$'}}</div>\r\n                <div ng-if=\"$ctrl.isGiftCardBalanceAmountExist()\" class=\"giftCardAddPayment-balanceAvailableSubtext\">AVAILABLE</div>\r\n            </div>\r\n            <div class=\"giftCardAddPayment-amountContainer\" ng-class=\"{'giftCardAddPayment-amountAvailableError': $ctrl.giftCardAddForm.giftCardAvailableAmount.$error.giftCardAmountAvailableEmpty}\">\r\n                <wow-input-container class=\"digitalPayInput-wowInputContainerOverride\">\r\n                    <label>Amount</label>\r\n                    <input\r\n                        id=\"giftCardAddAmount\"\r\n                        name=\"giftCardAddAmount\"\r\n                        type=\"number\"\r\n                        aria-label=\"Amount\"\r\n                        min=\"0\"\r\n                        step=\"0.01\"\r\n                        ng-model=\"$ctrl.card.Amount\"\r\n                        ng-change=\"$ctrl.onChangeCardAmount()\"\r\n                        ng-disabled=\"!$ctrl.card.Balance && $ctrl.card.BalanceApiAvailable\"\r\n                        ng-focus=\"$ctrl.onFocusCardAmount()\"\r\n                        ng-model-options=\"{allowInvalid: true}\"\r\n                        wow-gift-card-amount-validation=\"{{$ctrl.card.Balance}}\"\r\n                        autocomplete=\"off\"\r\n                        restrict-partial-alpha=\"2\"\r\n                        required />\r\n                </wow-input-container>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"digitalPayInput giftCardAddPayment-actions\">\r\n        <div>\r\n            <input\r\n                ng-hide=\"$ctrl.shouldHideSave()\"\r\n                id=\"save-gift-card-checkbox-{{$ctrl.card.NewStagedCardId}}\"\r\n                name=\"saveGiftCardCheckbox\"\r\n                type=\"checkbox\"\r\n                ng-disabled=\"$ctrl.shouldDisableCheckBox()\"\r\n                class=\"wowCheckbox digitalPay-checkbox\"\r\n                ng-model=\"$ctrl.card.IsSavingCard\"\r\n                ng-checked=\"!$ctrl.shouldDisableCheckBox() && $ctrl.card.IsSavingCard\" />\r\n            <label\r\n                ng-hide=\"$ctrl.shouldHideSave()\"\r\n                for=\"save-gift-card-checkbox-{{$ctrl.card.NewStagedCardId}}\">Save card for later</label>\r\n        </div>\r\n        <button class=\"dpLinkButton\" type=\"button\" ng-click=\"$ctrl.clearCardCaptureContents()\">Clear Form</button>\r\n        <div ng-if=\"!$ctrl.shouldHideSave()\"></div>\r\n    </div>\r\n</ng-form>\r\n"

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.digitalpay');

var _require = __webpack_require__(990),
    paypalPaymentComponentDefinition = _require.paypalPaymentComponentDefinition;

wowApp.component('wowPaypalPayment', paypalPaymentComponentDefinition);

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaypalBaseController = __webpack_require__(29).PaypalBaseController;

var _require = __webpack_require__(0),
    first = _require.first,
    filter = _require.filter;

var singleSelectTypes = __webpack_require__(44);

var paypalPrepaymentActionId = 'Paypal:ResolvePaymentAction';
// Key used for identifying amount distributed to paypal component.
var paypalPaymentAmountKey = 'paypalSelectAmount';

var PaypalPaymentController = function (_PaypalBaseController) {
    _inherits(PaypalPaymentController, _PaypalBaseController);

    function PaypalPaymentController($q, settings, paymentDistributionService, paypalService, digitalPayPaymentInstrumentsService, digitalPayPaymentErrorDisplayService, digitalPayPaymentErrorStateService, digitalPayErrorMessageGenerator) {
        _classCallCheck(this, PaypalPaymentController);

        var _this = _possibleConstructorReturn(this, (PaypalPaymentController.__proto__ || Object.getPrototypeOf(PaypalPaymentController)).call(this, settings, paypalService, digitalPayPaymentInstrumentsService));

        _this.$q = $q;
        _this.settings = settings;
        _this.paymentDistributionService = paymentDistributionService;
        _this.paypalService = paypalService;
        _this.digitalPayPaymentInstrumentsService = digitalPayPaymentInstrumentsService;
        _this.digitalPayPaymentErrorDisplayService = digitalPayPaymentErrorDisplayService;
        _this.digitalPayPaymentErrorStateService = digitalPayPaymentErrorStateService;
        _this.digitalPayErrorMessageGenerator = digitalPayErrorMessageGenerator;
        return _this;
    }

    _createClass(PaypalPaymentController, [{
        key: '$onInit',
        value: function $onInit() {
            _get(PaypalPaymentController.prototype.__proto__ || Object.getPrototypeOf(PaypalPaymentController.prototype), '$onInit', this).call(this);
            this.setupPaypal();
        }

        /**
         * @Override
         */

    }, {
        key: 'onLinkFailed',
        value: function onLinkFailed(errorCode, errorMessage) {
            _get(PaypalPaymentController.prototype.__proto__ || Object.getPrototypeOf(PaypalPaymentController.prototype), 'onLinkFailed', this).call(this, errorCode, errorMessage);
            this.notifyLinkFailure({ errorMessage: this.digitalPayErrorMessageGenerator.getPaypalLinkError(errorCode) });
        }

        /**
         * Notifies when PayPal is successfully unlinked.
         * @Override
         */

    }, {
        key: 'onUnlink',
        value: function onUnlink() {
            _get(PaypalPaymentController.prototype.__proto__ || Object.getPrototypeOf(PaypalPaymentController.prototype), 'onUnlink', this).call(this);
            this.unselectPaypal();
            this.digitalPayPaymentErrorDisplayService.clearGlobalError();
            this.digitalPayPaymentErrorStateService.clearErrors();
        }

        /**
         * @Override
         */

    }, {
        key: 'onUnlinkFailed',
        value: function onUnlinkFailed() {
            var errorCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            _get(PaypalPaymentController.prototype.__proto__ || Object.getPrototypeOf(PaypalPaymentController.prototype), 'onUnlinkFailed', this).call(this, errorCode, errorMessage);

            if (errorCode === this.settings.digitalPayErrorCodes.paypalAccountLockedOrClosed) {
                // Unlink since PayPal account is no longer part of the wallet.
                this.paypal = undefined;
                this.unselectPaypal();
            }

            this.notifyUnlinkFailure({ errorMessage: this.digitalPayErrorMessageGenerator.getPaypalUnlinkError(errorCode) });
            if (this.refreshPaypal) {
                this.refreshPaypal();
            }
        }

        /**
         * @Override
         */

    }, {
        key: 'toggleSelected',
        value: function toggleSelected() {
            _get(PaypalPaymentController.prototype.__proto__ || Object.getPrototypeOf(PaypalPaymentController.prototype), 'toggleSelected', this).call(this);

            if (this.singleSelectType === singleSelectTypes.PAYPAL) {
                this.unselectPaypal();
            } else {
                this.selectPaypal();
            }
        }

        /**
         * @Override
         */

    }, {
        key: 'getAmount',
        value: function getAmount() {
            // Overrides base class
            return this.paymentDistributionService.getPayment(paypalPaymentAmountKey);
        }
    }, {
        key: 'setPayingAmount',
        value: function setPayingAmount() {
            this.paymentDistributionService.addPaymentInFull(paypalPaymentAmountKey);
        }
    }, {
        key: 'removePayingAmount',
        value: function removePayingAmount() {
            this.paymentDistributionService.removePayment(paypalPaymentAmountKey);
        }
    }, {
        key: 'addPrepaymentAction',
        value: function addPrepaymentAction() {
            var _this2 = this;

            this.paypalInstrumentId = this.paypal.PaymentInstrumentId;
            this.prePaymentActionDefinitions.addAction(paypalPrepaymentActionId, function () {
                return _this2.$q.when({
                    paymentInstrumentId: _this2.paypalInstrumentId,
                    amount: _this2.getAmount(),
                    deviceData: JSON.parse(_this2.paypalService.getDeviceData())
                });
            });
        }
    }, {
        key: 'removePrepaymentAction',
        value: function removePrepaymentAction() {
            this.prePaymentActionDefinitions.removeAction(paypalPrepaymentActionId);
        }
    }, {
        key: 'confirmDialog',
        value: function confirmDialog() {
            this.confirmationDialog.close({ success: true });
        }
    }, {
        key: 'selectPaypal',
        value: function selectPaypal() {
            if (!this.paypalSelected) {
                this.setSingleSelectType({ type: singleSelectTypes.PAYPAL });
            }
        }
    }, {
        key: 'unselectPaypal',
        value: function unselectPaypal() {
            if (this.paypalSelected) {
                this.setSingleSelectType({ type: singleSelectTypes.NONE });
            }
        }

        /**
         * @Override
         */

    }, {
        key: 'unlinkPaypal',
        value: function unlinkPaypal() {
            var _this3 = this;

            this.confirmationDialog.show().then(function (dialogResponse) {
                if (!dialogResponse.success) {
                    return;
                }
                _get(PaypalPaymentController.prototype.__proto__ || Object.getPrototypeOf(PaypalPaymentController.prototype), 'unlinkPaypal', _this3).call(_this3, _this3.paypal.PaymentInstrumentId);
            });
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            var _this4 = this;

            if (changes.paypal) {
                this.paypal = changes.paypal.currentValue;
                if (!this.paypal) this.unselectPaypal();
            }

            // Select unselect payment.
            if (changes.singleSelectType) {
                this.paypalSelected = changes.singleSelectType.currentValue === singleSelectTypes.PAYPAL;
                if (this.paypalSelected) {
                    this.hasPaymentError = false;
                    this.setPayingAmount();
                    this.addPrepaymentAction();
                    this.onSelected();
                } else {
                    this.removePrepaymentAction();
                    this.removePayingAmount();
                    this.onUnselected();
                }
            }

            var currentPaymentErrorStates = changes.paymentErrorStates && changes.paymentErrorStates.currentValue || [];
            if (currentPaymentErrorStates.length) {
                var paypalErrorState = first(filter(currentPaymentErrorStates, function (value) {
                    var state = value.state;
                    return state.ErrorCode && (state.PaymentInstrumentType === _this4.settings.digitalPayPaymentTypes.paypalType || state.PaymentInstrumentId === _this4.paypalInstrumentId);
                }));

                if (paypalErrorState) {
                    var errorMessage = this.digitalPayErrorMessageGenerator.getPaypalPaymentError(paypalErrorState.state.ErrorCode);

                    if (paypalErrorState.state.ErrorCode === this.settings.digitalPayErrorCodes.paypalAccountLockedOrClosed || paypalErrorState.state.ErrorCode === this.settings.digitalPayErrorCodes.paymentInstrumentNotFound) {
                        // Refresh link since PayPal account is no longer part of the wallet.
                        this.paypal = undefined;
                    } else {
                        this.hasPaymentError = true;
                    }

                    this.unselectPaypal();
                    this.digitalPayPaymentErrorDisplayService.pushToPaymentErrorBreakdown(errorMessage);
                } else {
                    // PayPal no longer has an error state.
                    this.hasPaymentError = false;
                }
            } else if (changes.paymentErrorStates) {
                // There are no longer any payment error states.
                this.hasPaymentError = false;
            }
        }
    }]);

    return PaypalPaymentController;
}(PaypalBaseController);

PaypalPaymentController.$inject = ['$q', 'Settings', 'DigitalPayPaymentDistributionService', 'PaypalService', 'DigitalPayPaymentInstrumentsService', 'DigitalPayPaymentErrorDisplayService', 'DigitalPayPaymentErrorStateService', 'DigitalPayErrorMessageGenerator'];

var paypalPaymentComponentDefinition = {
    controller: PaypalPaymentController,
    template: __webpack_require__(991).trim(),
    bindings: {
        prePaymentActionDefinitions: '<',
        singleSelectType: '<',
        paypal: '<?',
        token: '<',
        setSingleSelectType: '&',
        onSelected: '&',
        onUnselected: '&',
        paymentErrorStates: '<',
        refreshPaypal: '&?',
        notifyLinkFailure: '&onLinkFailed',
        notifyUnlinkFailure: '&onUnlinkFailed',
        shouldShowPayingAmount: '<'
    }
};

module.exports = {
    PaypalPaymentController: PaypalPaymentController,
    paypalPaymentComponentDefinition: paypalPaymentComponentDefinition
};

/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports = "<div class=\"digitalPay digitalPayPaypalBase\">\r\n    <wow-digital-pay-toggle-button\r\n        instrument-name=\"PayPal\"\r\n        icon=\"images/checkout/digitalpay/icon-pay-paypal.svg\"\r\n        is-icon-svg=\"true\"\r\n        on-click=\"$ctrl.togglePayPal()\"\r\n        is-selected=\"$ctrl.paypalSelected\"\r\n        link-text=\"{{$ctrl.paypal ? '' : 'Link PayPal account'}}\"\r\n        sub-text=\"{{$ctrl.paypal ? $ctrl.paypal.PayPalId : ''}}\"\r\n        is-select-button=\"!$ctrl.paypal\"\r\n        is-loading=\"!$ctrl.isPaypalReady\"\r\n        is-errored=\"$ctrl.hasPaymentError\"\r\n        amount=\"$ctrl.getAmount()\"\r\n        is-not-bottom=\"$ctrl.paypal\"\r\n        should-show-paying-amount=\"$ctrl.shouldShowPayingAmount\">\r\n    </wow-digital-pay-toggle-button>\r\n\r\n    <div\r\n        ng-if=\"$ctrl.paypal\"\r\n        class=\"digitalPayActions-container notTop\"\r\n        ng-class=\"{'selected': $ctrl.paypalSelected, 'errored': $ctrl.hasPaymentError}\">\r\n        <button\r\n            wow-digital-pay-button\r\n            class=\"dpLinkButton\"\r\n            ng-click=\"$ctrl.unlinkPaypal()\"\r\n            type=\"button\">\r\n            Unlink <span class=\"sr-only\">PayPal</span> Account\r\n        </button>\r\n    </div>\r\n</div>\r\n\r\n<wow-digital-pay-confirmation-dialog\r\n    dialog-name=\"'unlink paypal dialog'\"\r\n    dialog=\"$ctrl.confirmationDialog\"\r\n    message=\"::$ctrl.unlinkMessage\">\r\n    <div class=\"dpFooter-container\">\r\n        <button oly-dialog-close class=\"button dpFooter-button\">\r\n            <i class=\"iconww-ArrowLeft dpFooter-iconLeftButton\"></i>Cancel\r\n        </button>\r\n        <button class=\"button button--primary dpFooter-button--primary\" ng-click=\"$ctrl.confirmDialog()\">\r\n            Unlink<i class=\"iconww-ArrowRight dpFooter-iconRightButton\"></i>\r\n        </button>\r\n    </div>\r\n</wow-digital-pay-confirmation-dialog>\r\n"

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.digitalpay');

var DigitalPayPaymentDistributionService = __webpack_require__(993);
var DigitalPayPrepaymentActionsService = __webpack_require__(994);
var DigitalPayDisablePaymentStateService = __webpack_require__(995);
var DigitalPayPaymentErrorStateService = __webpack_require__(547);

wowApp.service('DigitalPayPaymentDistributionService', DigitalPayPaymentDistributionService);
wowApp.service('DigitalPayPrepaymentActionsService', DigitalPayPrepaymentActionsService);
wowApp.service('DigitalPayDisablePaymentStateService', DigitalPayDisablePaymentStateService);
wowApp.service('DigitalPayPaymentErrorStateService', DigitalPayPaymentErrorStateService);

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    isUndefined = _require.isUndefined,
    keysIn = _require.keysIn,
    size = _require.size;

var ADD_CREDIT_CARD_ID = 'CreditCard:AddCreditCard';

var DigitalPayPaymentDistributionService = function () {
    function DigitalPayPaymentDistributionService() {
        _classCallCheck(this, DigitalPayPaymentDistributionService);

        this._orderTotal = 0;
        this._remainingAmount = 0;
        this._paymentDistributions = {};
        this._singleSelectKey = undefined;
        this.AddCreditCardId = ADD_CREDIT_CARD_ID;
    }

    /**
     * Initialise Distribution Service with the given remaining order total.
     * @param {Double} totalOrderAmountStillToPay
     */


    _createClass(DigitalPayPaymentDistributionService, [{
        key: 'init',
        value: function init(totalOrderAmountStillToPay) {
            // Set remaining amount to pay for the order.
            this._orderTotal = this.convertValueToTwoDecimalPlaces(totalOrderAmountStillToPay);

            // Static remaining amount
            this._remainingAmount = this.convertValueToTwoDecimalPlaces(totalOrderAmountStillToPay);

            // Reset distributions
            this._paymentDistributions = {};

            // SingleSelectKey represents the key associated with a payment which always takes the remaining amount to pay.
            this._singleSelectKey = undefined;
        }
    }, {
        key: 'getOrderTotal',
        value: function getOrderTotal() {
            return this._orderTotal;
        }

        /**
         * Get remaining amount still due for the current order. Excludes single select type amounts
         */

    }, {
        key: 'getRemainingAmount',
        value: function getRemainingAmount() {
            return this._remainingAmount;
        }
    }, {
        key: 'convertValueToTwoDecimalPlaces',
        value: function convertValueToTwoDecimalPlaces(value) {
            var numberValue = parseFloat(value);
            return numberValue ? Math.round(value * 100) / 100 : 0.00;
        }

        /**
         * Get all keys currently distributed the total amount.
         */

    }, {
        key: 'getKeys',
        value: function getKeys() {
            if (!this._paymentDistributions) return [];
            return keysIn(this._paymentDistributions);
        }
    }, {
        key: 'getSingleSelectKey',
        value: function getSingleSelectKey() {
            return this._singleSelectKey;
        }
    }, {
        key: 'isPayingWithNewCard',
        value: function isPayingWithNewCard() {
            return this._singleSelectKey === this.AddCreditCardId;
        }

        /**
         * Get payment distribution associated with the given key.
         * @param {String} key
         */

    }, {
        key: 'getPayment',
        value: function getPayment(key) {
            return this._paymentDistributions[key] || 0.00;
        }

        /**
         * Add key/value pair representing the distributed amount associated with the given key.
         * @param {string} key
         * @param {boolean} amount
         */

    }, {
        key: 'addPayment',
        value: function addPayment(key, amount) {
            if (!key || key === '') return;

            if (key in this._paymentDistributions) {
                this._remainingAmount += this._paymentDistributions[key];
            }

            // TODO: we may allow the user to set a 0 remaining amount amount because addPaymentInFull allows this as well just to keep things consistent
            this._paymentDistributions[key] = this.convertValueToTwoDecimalPlaces(amount);

            this._remainingAmount = this.convertValueToTwoDecimalPlaces(this._remainingAmount - this._paymentDistributions[key]);

            this._updateSingleSelectStagedAmount();
        }

        /**
         * Add staged payment distribution in full for the remaining amount.
         * Note: Payment distribution for this key updates when remaining amount changes.
         * @param {string} key
         */

    }, {
        key: 'addPaymentInFull',
        value: function addPaymentInFull(key) {
            // Remove existing single select distribution amount.
            delete this._paymentDistributions[this._singleSelectKey];

            // Store single select key.
            if (key) this._singleSelectKey = key;

            // Set remaining amount.
            this._paymentDistributions[key] = this._remainingAmount < 0.00 ? 0.00 : this._remainingAmount;
        }

        /**
         * Remove a payment amount association when given the key.
         * @param {string} key
         */

    }, {
        key: 'removePayment',
        value: function removePayment(key) {
            if (!key || key === '') return;
            if (key === this._singleSelectKey) {
                this._singleSelectKey = undefined;
            } else if (key in this._paymentDistributions) {
                // Ignore single select types
                this._remainingAmount = this.convertValueToTwoDecimalPlaces(this._remainingAmount + this._paymentDistributions[key]);
            }
            delete this._paymentDistributions[key];

            this._updateSingleSelectStagedAmount();
        }

        /**
         * Determines whether the distribution service has at least one payment.
         */

    }, {
        key: 'hasPayments',
        value: function hasPayments() {
            return size(this._paymentDistributions) > 0;
        }

        /**
         * Determines whether the distribution service has a single select type.
         */

    }, {
        key: 'hasSingleSelectType',
        value: function hasSingleSelectType() {
            return !isUndefined(this._singleSelectKey);
        }

        /**
         * Updates the remaining amount associated with a single select key.
         */

    }, {
        key: '_updateSingleSelectStagedAmount',
        value: function _updateSingleSelectStagedAmount() {
            if (this._singleSelectKey) {
                // Remove currently distributed amount associated with single select key.
                delete this._paymentDistributions[this._singleSelectKey];
                // Re-add with updated remaining total.
                this.addPaymentInFull(this._singleSelectKey);
            }
        }
    }]);

    return DigitalPayPaymentDistributionService;
}();

module.exports = DigitalPayPaymentDistributionService;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    forEach = _require.forEach,
    isFunction = _require.isFunction;

var DigitalPayPrepaymentActionsService = function () {
    function DigitalPayPrepaymentActionsService() {
        _classCallCheck(this, DigitalPayPrepaymentActionsService);

        this._prePaymentActions = {};
    }

    _createClass(DigitalPayPrepaymentActionsService, [{
        key: 'init',
        value: function init() {
            this._prePaymentActions = {};
        }

        /**
         * Add an invokable action associated with the given key.
         * Actions should all return promises to support delayed resolution of actions. |
         * When promise is resolved should return object with at least one of the the following formats: |
         * { paymentInstrumentId: 123, amount: 12 }, { paymentInstrumentId: 123, stepUpToken: abc } |
         * When promise is rejected should return object with at least the following format { id: actionKey, errorMessage: 'SomeError' }
         * @param {String} key
         * @param {Function} action
         */

    }, {
        key: 'addAction',
        value: function addAction(key, action) {
            if (!key || !action || !isFunction(action)) return;
            this._prePaymentActions[key] = action;
        }

        /**
         * Get action associated with the given key.
         * @param {String} key
         */

    }, {
        key: 'getAction',
        value: function getAction(key) {
            return this._prePaymentActions[key];
        }

        /**
         * Get all persisted actions.
         */

    }, {
        key: 'getAllActions',
        value: function getAllActions() {
            var actions = [];
            forEach(this._prePaymentActions, function (action) {
                actions.push(action);
            });
            return actions;
        }

        /**
         * Remove action associated with the given key.
         * @param {String} key
         */

    }, {
        key: 'removeAction',
        value: function removeAction(key) {
            delete this._prePaymentActions[key];
        }

        /**
         * Remove all presisted actions.
         */

    }, {
        key: 'removeAllActions',
        value: function removeAllActions() {
            this._prePaymentActions = {};
        }
    }]);

    return DigitalPayPrepaymentActionsService;
}();

module.exports = DigitalPayPrepaymentActionsService;

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    find = _require.find,
    isEmpty = _require.isEmpty,
    map = _require.map,
    remove = _require.remove;

var DigitalPayDisablePaymentStateService = function () {
    function DigitalPayDisablePaymentStateService() {
        _classCallCheck(this, DigitalPayDisablePaymentStateService);

        this.disablePaymentStates = [];
    }

    /**
     * Initialise disable payment state service with clean state.
     */


    _createClass(DigitalPayDisablePaymentStateService, [{
        key: 'init',
        value: function init() {
            // Reset disable payment states.
            this.disablePaymentStates = [];
        }

        /**
         * Adds a new disable payment state which implies payment is not ready to be made yet.
         * @param {String} state (must be unique)
         * @param {String} reason Reason for screen readers
         */

    }, {
        key: 'addDisablePaymentState',
        value: function addDisablePaymentState(state) {
            var reason = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            if (find(this.disablePaymentStates, function (disableState) {
                return disableState.state === state;
            })) {
                return;
            }
            this.disablePaymentStates.push({ state: state, reason: reason });
        }

        /**
         * Lists why payment has been disabled.
         */

    }, {
        key: 'getReasonsWhyDisabled',
        value: function getReasonsWhyDisabled() {
            return map(this.disablePaymentStates, function (disableState) {
                return disableState.reason;
            }).toString();
        }

        /**
         * Returns true there are disable payment states; otherwise false.
         */

    }, {
        key: 'hasDisablePaymentStates',
        value: function hasDisablePaymentStates() {
            return !isEmpty(this.disablePaymentStates);
        }

        /**
         * Removes the given disable payment state.
         * @param {String} state
         */

    }, {
        key: 'removeDisablePaymentState',
        value: function removeDisablePaymentState(state) {
            remove(this.disablePaymentStates, function (disableState) {
                return disableState.state === state;
            });
        }
    }]);

    return DigitalPayDisablePaymentStateService;
}();

module.exports = DigitalPayDisablePaymentStateService;

/***/ })
]);


// WEBPACK FOOTER //
// common.b1ac8b722a5d3e6bd516.bundle.js